//Bff Hosting Type: Local
//Bff Name: Booker.Planner.BFF.ApiServer
//----------------------
//Custom base class for adding custom request headers
import { BookerPlannerBffClientBase } from './booker-planner-bff-api-client-base';

//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, from as _observableFrom, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import { DateTime, Duration } from "luxon";

export namespace RaxBFF {
export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IClient {
    utils_GetAddressLookup(query: GetAddressLookupQuery): Observable<AddressLookupResult>;
    translation_GetLocationTranslationCoverage(): Observable<GetLocationTranslationCoverageQueryResult>;
    translation_ApplyTranslations(command: ApplyTranslationsCommand): Observable<ApplyTranslationsCommandResult>;
    textMessaging_SyncWhatsAppTemplates(): Observable<WhatsAppConnection>;
    textMessaging_SetWhatsAppTestPhoneNumber(command: SetWhatsAppTestPhoneNumberCommand): Observable<WhatsAppConnection>;
    textMessaging_SendTestTextMessage(command: SendTestTextMessageCommand): Observable<OutboundTextMessage>;
    textMessaging_RetryWhatsAppSignup(command: RetryWhatsAppSignupCommand): Observable<WhatsAppConnection>;
    textMessaging_GetWhatsAppSignupConfig(): Observable<GetWhatsAppSignupConfigQueryResult>;
    textMessaging_GetWhatsAppConnection(): Observable<WhatsAppConnection>;
    textMessaging_GetRecentOutboundTextMessages(query: GetRecentOutboundTextMessagesQuery): Observable<GetRecentOutboundTextMessagesQueryResult>;
    textMessaging_DisconnectWhatsApp(): Observable<WhatsAppConnection>;
    textMessaging_CompleteWhatsAppSignup(command: CompleteWhatsAppSignupCommand): Observable<WhatsAppConnection>;
    tenant_GetTenantEditDialogView(query: GetTenantEditDialogViewQuery): Observable<GetTenantEditDialogViewQueryResult>;
    tenant_CheckTenantIdCode(query: CheckTenantIdCodeQuery): Observable<CheckTenantIdCodeQueryResult>;
    tenantUsers_UpdateTenantUser(command: UpdateTenantUserCommand): Observable<UpdateTenantUserCommandResult>;
    tenantUsers_RemoveTenantUser(command: RemoveTenantUserCommand): Observable<RemoveTenantUserCommandResult>;
    tenantUsers_GetTenantUsers(): Observable<GetTenantUsersQueryResult>;
    tenantUsers_GetTenantUserEditItem(query: GetTenantUserEditItemQuery): Observable<GetTenantUserEditItemQueryResult>;
    tenantUsers_GetTenantUserAliasAddDialog(): Observable<GetTenantUserAliasAddDialogQueryResult>;
    tenantUsers_GetTenantUserAddDialog(): Observable<GetTenantUserAddDialogQueryResult>;
    tenantUsers_AddTenantUsers(command: AddTenantUsersCommand): Observable<AddTenantUsersCommandResult>;
    selfService_UpdateSelfServiceSettings(command: UpdateSelfServiceSettingsCommand): Observable<void>;
    selfService_UpdateSelfServiceRuleSettings(command: UpdateSelfServiceRuleSettingsCommand): Observable<void>;
    selfService_UpdateProgramSelfServiceOverrides(command: UpdateProgramSelfServiceOverridesCommand): Observable<void>;
    selfService_MigrateLocationSelfServiceRules(command: MigrateLocationSelfServiceRulesCommand): Observable<void>;
    selfService_GetSelfServiceSettings(query: GetSelfServiceSettingsQuery): Observable<GetSelfServiceSettingsQueryResult>;
    selfService_GetSelfServiceRuleSettings(query: GetSelfServiceRuleSettingsQuery): Observable<GetSelfServiceRuleSettingsQueryResult>;
    selfService_GetSelfServiceProgramDeviations(query: GetSelfServiceProgramDeviationsQuery): Observable<GetSelfServiceProgramDeviationsQueryResult>;
    selfService_GetSelfServiceOverrideSummary(query: GetSelfServiceOverrideSummaryQuery): Observable<GetSelfServiceOverrideSummaryQueryResult>;
    selfService_GetProgramSelfServiceOverrides(query: GetProgramSelfServiceOverridesQuery): Observable<GetProgramSelfServiceOverridesQueryResult>;
    security_UpdateSecurityGroup(command: UpdateSecurityGroupCommand): Observable<UpdateSecurityGroupCommandResult>;
    security_RemoveSecurityGroupMember(command: RemoveSecurityGroupMemberCommand): Observable<RemoveSecurityGroupMemberCommandResult>;
    security_GetSecurityUserListView(query: GetSecurityUserListViewQuery): Observable<GetSecurityUserListViewResult>;
    security_GetSecurityUserEditItemView(query: GetSecurityUserEditItemViewQuery): Observable<GetSecurityUserEditItemViewResult>;
    security_GetSecurityNavigation(query: GetSecurityNavigationQuery): Observable<GetSecurityNavigationResult>;
    security_GetSecurityGroupMembersAddDialogView(query: GetSecurityGroupMembersAddDialogViewQuery): Observable<GetSecurityGroupMembersAddDialogViewResult>;
    security_GetSecurityGroupListView(query: GetSecurityGroupListViewQuery): Observable<GetSecurityGroupListViewResult>;
    security_GetSecurityGroupEditItemView(query: GetSecurityGroupEditItemViewQuery): Observable<GetSecurityGroupEditItemViewResult>;
    security_GetSecurityGroupEditItemRolesView(query: GetSecurityGroupEditItemRolesViewQuery): Observable<GetSecurityGroupEditItemRolesViewResult>;
    security_GetSecurityGroupAddDialogView(query: GetSecurityGroupAddDialogViewQuery): Observable<GetSecurityGroupAddDialogViewResult>;
    security_DeleteSecurityGroup(command: DeleteSecurityGroupCommand): Observable<DeleteSecurityGroupCommandResult>;
    security_CreateSecurityGroup(command: CreateSecurityGroupCommand): Observable<CreateSecurityGroupCommandResult>;
    security_AddSecurityGroupMembers(command: AddSecurityGroupMembersCommand): Observable<AddSecurityGroupMembersCommandResult>;
    reporting_GetUpsell(query: GetUpsellQuery): Observable<GetUpsellQueryResult>;
    /**
     * @return The generated file.
     */
    reporting_ExportUpsellExcel(query: GetUpsellQuery): Observable<FileResponse>;
    reporting_GetResourceUtilization(query: GetResourceUtilizationQuery): Observable<GetResourceUtilizationQueryResult>;
    reporting_GetProgramRevenue(query: GetProgramRevenueQuery): Observable<GetProgramRevenueQueryResult>;
    /**
     * @return The generated file.
     */
    reporting_ExportProgramRevenueExcel(query: GetProgramRevenueQuery): Observable<FileResponse>;
    reporting_GetProductSales(query: GetProductSalesQuery): Observable<GetProductSalesQueryResult>;
    /**
     * @return The generated file.
     */
    reporting_ExportProductSalesExcel(query: GetProductSalesQuery): Observable<FileResponse>;
    reporting_GetOnlinePayments(query: GetOnlinePaymentsQuery): Observable<GetOnlinePaymentsQueryResult>;
    /**
     * @return The generated file.
     */
    reporting_ExportOnlinePaymentsExcel(query: GetOnlinePaymentsQuery): Observable<FileResponse>;
    reporting_GetLostRevenue(query: GetLostRevenueQuery): Observable<GetLostRevenueQueryResult>;
    /**
     * @return The generated file.
     */
    reporting_ExportLostRevenueExcel(query: GetLostRevenueQuery): Observable<FileResponse>;
    reporting_GetLocationOverviewNewBookings(query: GetLocationOverviewBookingsQuery): Observable<GetLocationOverviewBookingsQueryResult>;
    reporting_GetLocationOverviewMolliePriceLineItems(query: GetLocationOverviewMolliePriceLineItemsQuery): Observable<MolliePriceLineItemsQueryResult>;
    reporting_GetLocationOverviewMolliePayments(query: GetLocationOverviewMolliePaymentsQuery): Observable<MolliePaymentsQueryResult>;
    reporting_GetLocationOverviewMollieFuturePrePaidAmount(query: GetLocationOverviewMollieFuturePrePaidAmountQuery): Observable<MollieFuturePrePaidAmountQueryResult>;
    reporting_GetLocationOverviewMollieCancelledBookingPayments(query: GetLocationOverviewMollieCancelledBookingPaymentsQuery): Observable<MollieCancelledBookingPaymentsQueryResult>;
    reporting_GetLocationOverviewDayPlanning(query: GetLocationOverviewDayPlanningQuery): Observable<GetLocationOverviewDayPlanningView>;
    reporting_GetLocationOverviewCustomBookings(query: GetLocationOverviewCustomBookingsQuery): Observable<GetLocationOverviewCustomBookingsQueryResult>;
    reporting_GetLocationOverviewCustomBookingListView(query: GetLocationOverviewCustomBookingListViewQuery): Observable<LocationOverviewCustomBookingListView>;
    reporting_GetLocationOverviewCancelledBookings(query: GetLocationOverviewBookingsQuery): Observable<GetLocationOverviewBookingsQueryResult>;
    reporting_GetLocationOverviewBookings(query: GetLocationOverviewBookingsQuery): Observable<GetLocationOverviewBookingsQueryResult>;
    /**
     * @return The generated file.
     */
    reporting_ExportLocationOverviewDayPlanningExcel(query: GetLocationOverviewDayPlanningQuery): Observable<FileResponse>;
    reporting_GetDailyBusyness(query: GetDailyBusynessQuery): Observable<GetDailyBusynessQueryResult>;
    /**
     * @return The generated file.
     */
    reporting_ExportDailyBusynessExcel(query: GetDailyBusynessQuery): Observable<FileResponse>;
    reporting_GetCustomerLifetimeValue(query: GetCustomerLifetimeValueQuery): Observable<GetCustomerLifetimeValueQueryResult>;
    /**
     * @return The generated file.
     */
    reporting_ExportCustomerLifetimeValueExcel(query: GetCustomerLifetimeValueQuery): Observable<FileResponse>;
    reporting_GetCapacityOverview(query: GetCapacityOverviewQuery): Observable<GetCapacityOverviewQueryResult>;
    /**
     * @return The generated file.
     */
    reporting_ExportCapacityOverviewExcel(query: GetCapacityOverviewQuery): Observable<FileResponse>;
    reporting_GetCancelledBookings(query: GetCancelledBookingsQuery): Observable<GetCancelledBookingsQueryResult>;
    /**
     * @return The generated file.
     */
    reporting_ExportCancelledBookingsExcel(query: GetCancelledBookingsQuery): Observable<FileResponse>;
    reporting_GetBookingContact(query: GetBookingContactQuery): Observable<GetBookingContactQueryResult>;
    /**
     * @return The generated file.
     */
    reporting_ExportBookingContactExcel(query: GetBookingContactQuery): Observable<FileResponse>;
    reporting_GetActivityRevenue(query: GetActivityRevenueQuery): Observable<GetActivityRevenueQueryResult>;
    /**
     * @return The generated file.
     */
    reporting_ExportActivityRevenueExcel(query: GetActivityRevenueQuery): Observable<FileResponse>;
    rateCard_RequestNewPriceLevel(query: RequestNewRateCardPriceLevelQuery): Observable<RateCardPriceLevelDto>;
    rateCard_GetRateCardPriceRuleDefAddDialogView(query: GetRateCardPriceRuleDefAddDialogViewQuery): Observable<GetRateCardPriceRuleDefAddDialogViewResult>;
    rateCard_GetRateCardPriceLevelEditDialogView(query: GetRateCardPriceLevelEditDialogViewQuery): Observable<GetRateCardPriceLevelEditDialogViewResult>;
    rateCard_GetEditView(query: GetRateCardEditViewQuery): Observable<RateCardEditViewResult>;
    rateCard_GetEditViewForRateCard(query: GetRateCardEditViewForRateCardQuery): Observable<RateCardEditViewResult>;
    rateCard_GetEditDialogView(query: GetRateCardEditDialogViewQuery): Observable<GetRateCardEditDialogViewResult>;
    rateCards_GetPricingOverview(query: GetPricingOverviewQuery): Observable<GetPricingOverviewQueryResult>;
    rateCards_GetPricingOverviewData(query: GetPricingOverviewDataQuery): Observable<GetPricingOverviewDataQueryResult>;
    rateCard_CalculateStartPriceConfig(command: CalculateRateCardStartingPriceCommand): Observable<RateCardStartingPriceConfigDto>;
    rateCardPeriodConfig_GetEditItemView(query: GetRateCardPeriodConfigEditItemViewQuery): Observable<GetRateCardPeriodConfigEditItemViewQueryResult>;
    questionnaires_RemoveSelectOption(command: RemoveSelectOptionCommand): Observable<void>;
    questionnaires_RemoveOptionCountOption(command: RemoveOptionCountOptionCommand): Observable<void>;
    questionnaires_GetQuestion(query: GetQuestionQuery): Observable<GetQuestionQueryResult>;
    questionnaires_GetLocationQuestions(): Observable<GetLocationQuestionsQueryResult>;
    questionnaires_DeleteQuestion(command: DeleteQuestionCommand): Observable<void>;
    questionnaires_CreateTextQuestion(command: CreateTextQuestionCommand): Observable<CreateTextQuestionCommandResponse>;
    questionnaires_CreateSelectQuestion(command: CreateSelectQuestionCommand): Observable<CreateSelectQuestionCommandResponse>;
    questionnaires_CreateOptionCountQuestion(command: CreateOptionCountQuestionCommand): Observable<CreateOptionCountQuestionCommandResponse>;
    questionnaires_CreateCheckQuestion(command: CreateCheckQuestionCommand): Observable<CreateCheckQuestionCommandResponse>;
    questionnaires_ChangeTextAnswerLengthBounds(command: ChangeTextAnswerLengthBoundsCommand): Observable<void>;
    questionnaires_ChangeSelectOptionText(command: ChangeSelectOptionTextCommand): Observable<void>;
    questionnaires_ChangeSelectDisplay(command: ChangeSelectDisplayCommand): Observable<void>;
    questionnaires_ChangeQuestionSettings(command: ChangeQuestionSettingsCommand): Observable<void>;
    questionnaires_ChangeQuestionPrompt(command: ChangeQuestionPromptCommand): Observable<void>;
    questionnaires_ChangeOptionCountParticipantLimit(command: ChangeOptionCountParticipantLimitCommand): Observable<void>;
    questionnaires_ChangeOptionCountOptionText(command: ChangeOptionCountOptionTextCommand): Observable<void>;
    questionnaires_ChangeCheckAnswer(command: ChangeCheckAnswerCommand): Observable<void>;
    questionnaires_AddSelectOption(command: AddSelectOptionCommand): Observable<AddSelectOptionCommandResponse>;
    questionnaires_AddOptionCountOption(command: AddOptionCountOptionCommand): Observable<AddOptionCountOptionCommandResponse>;
    questionnaires_ReorderActivityQuestions(command: ReorderActivityQuestionsCommand): Observable<void>;
    questionnaires_RemoveActivityQuestion(command: RemoveActivityQuestionCommand): Observable<void>;
    questionnaires_GetActivityQuestions(query: GetActivityQuestionsQuery): Observable<GetActivityQuestionsQueryResult>;
    questionnaires_AddActivityQuestion(command: AddActivityQuestionCommand): Observable<void>;
    promotions_SetPromotionName(command: SetPromotionNameCommand): Observable<void>;
    promotions_SetPromotionEffect(command: SetPromotionEffectCommand): Observable<void>;
    promotions_ListPromotions(): Observable<ListPromotionsQueryResult>;
    promotions_GetPromotionsByIds(query: GetPromotionsByIdsQuery): Observable<GetPromotionsByIdsQueryResult>;
    promotions_CreateDraftPromotion(command: CreateDraftPromotionCommand): Observable<CreateDraftPromotionCommandResponse>;
    program_GetProgramStartDateTimesForArrivalDate(query: GetProgramStartDateTimesForArrivalDateQuery): Observable<GetProgramStartDateTimesForArrivalDateQueryResult>;
    programs_GetProgramListView(query: GetProgramListViewQuery): Observable<GetProgramListViewQueryResult>;
    programs_GetProgramEditItemLinkView(query: GetProgramEditItemLinkViewQuery): Observable<GetProgramEditItemLinkViewQueryResult>;
    programs_GetProgramBookingPartyConfig(query: GetProgramBookingPartyConfigQuery): Observable<GetProgramBookingPartyConfigQueryResult>;
    program_GetProgramArrivalDateAvailabilityForMonth(query: GetProgramArrivalDateAvailabilityForMonthQuery): Observable<GetProgramArrivalDateAvailabilityForMonthQueryResult>;
    programSteps_GetProgramStepListView(query: GetProgramStepListViewQuery): Observable<GetProgramStepListViewQueryResult>;
    programSteps_GetProgramStepEditItemLinkView(query: GetProgramStepEditItemLinkViewQuery): Observable<GetProgramStepEditItemLinkViewQueryResult>;
    product_GetProductAddDialogView(query: GetProductAddDialogViewQuery): Observable<GetProductAddDialogViewQueryResult>;
    product_GetProductEditItemView(query: GetProductEditItemViewQuery): Observable<GetProductEditItemViewQueryResult>;
    product_GetProductListView(query: GetProductListViewQuery): Observable<GetProductListViewQueryResult>;
    pricing_SetRateCardAmounts(command: SetRateCardAmountsCommand): Observable<void>;
    pricing_ScheduleLevelTransition(command: ScheduleLevelTransitionCommand): Observable<void>;
    pricing_RemoveLevelTransition(command: RemoveLevelTransitionCommand): Observable<void>;
    pricing_MoveLevelTransition(command: MoveLevelTransitionCommand): Observable<void>;
    pricing_GetActivityRateCardsView(query: GetActivityRateCardsViewQuery): Observable<GetActivityRateCardsViewQueryResult>;
    pricing_CreateActivityRateCardSet(command: CreateActivityRateCardSetCommand): Observable<CreateActivityRateCardSetCommandResponse>;
    pricing_CopyDaySchedule(command: CopyDayScheduleCommand): Observable<void>;
    pricing_ChangeLevelTransitionTarget(command: ChangeLevelTransitionTargetCommand): Observable<void>;
    pricing_ChangeDayStartLevel(command: ChangeDayStartLevelCommand): Observable<void>;
    pricing_RestorePriceComponent(command: RestorePriceComponentCommand): Observable<void>;
    pricing_RemovePriceComponent(command: RemovePriceComponentCommand): Observable<void>;
    pricing_RedefinePerResourceComponent(command: RedefinePerResourceComponentCommand): Observable<void>;
    pricing_RedefinePerParticipantComponent(command: RedefinePerParticipantComponentCommand): Observable<void>;
    pricing_RedefinePerBookingComponent(command: RedefinePerBookingComponentCommand): Observable<void>;
    pricing_PublishPriceStructureDraft(command: PublishPriceStructureDraftCommand): Observable<void>;
    pricing_GetPriceStructureDraftPreparationView(query: GetPriceStructureDraftPreparationViewQuery): Observable<GetPriceStructureDraftPreparationViewQueryResult>;
    pricing_GetActivityPriceStructureView(query: GetActivityPriceStructureViewQuery): Observable<GetActivityPriceStructureViewQueryResult>;
    pricing_DiscardPriceStructureDraft(command: DiscardPriceStructureDraftCommand): Observable<void>;
    pricing_CreatePriceStructureDraft(command: CreatePriceStructureDraftCommand): Observable<void>;
    pricing_CreateActivityPriceStructure(command: CreateActivityPriceStructureCommand): Observable<void>;
    pricing_AddPerResourceComponent(command: AddPerResourceComponentCommand): Observable<AddPerResourceComponentCommandResponse>;
    pricing_AddPerParticipantComponent(command: AddPerParticipantComponentCommand): Observable<AddPerParticipantComponentCommandResponse>;
    pricing_AddPerBookingComponent(command: AddPerBookingComponentCommand): Observable<AddPerBookingComponentCommandResponse>;
    pricing_SetPriceLevelName(command: SetPriceLevelNameCommand): Observable<void>;
    pricing_ReorderPriceLevels(command: ReorderPriceLevelsCommand): Observable<void>;
    pricing_ReactivatePriceLevel(command: ReactivatePriceLevelCommand): Observable<void>;
    pricing_GetPriceLevelUsage(query: GetPriceLevelUsageQuery): Observable<GetPriceLevelUsageQueryResult>;
    pricing_GetLocationPriceLevelsConfig(query: GetLocationPriceLevelsConfigQuery): Observable<GetLocationPriceLevelsConfigQueryResult>;
    pricing_GetCanDeactivatePriceLevelView(query: GetCanDeactivatePriceLevelViewQuery): Observable<GetCanDeactivatePriceLevelViewQueryResult>;
    pricing_DefinePriceLevel(command: DefinePriceLevelCommand): Observable<DefinePriceLevelCommandResponse>;
    pricing_DeactivatePriceLevel(command: DeactivatePriceLevelCommand): Observable<void>;
    pricing_CreateLocationPriceLevels(command: CreateLocationPriceLevelsCommand): Observable<void>;
    pricing_ChangePriceLevelColor(command: ChangePriceLevelColorCommand): Observable<void>;
    pricing_SetPriceComponentName(command: SetPriceComponentNameCommand): Observable<void>;
    pricing_RetirePriceComponent(command: RetirePriceComponentCommand): Observable<void>;
    pricing_GetLocationPriceComponentsView(query: GetLocationPriceComponentsViewQuery): Observable<GetLocationPriceComponentsViewQueryResult>;
    pricing_CreatePriceComponent(command: CreatePriceComponentCommand): Observable<CreatePriceComponentCommandResponse>;
    pricing_SetLocationDepositRule(command: SetLocationDepositRuleCommand): Observable<void>;
    pricing_SetLocationDepositDueWindow(command: SetLocationDepositDueWindowCommand): Observable<void>;
    pricing_SetLocationDepositChannelApplicability(command: SetLocationDepositChannelApplicabilityCommand): Observable<void>;
    pricing_SetActivityDepositOverride(command: SetActivityDepositOverrideCommand): Observable<SetActivityDepositOverrideCommandResponse>;
    pricing_RemoveActivityDepositOverride(command: RemoveActivityDepositOverrideCommand): Observable<void>;
    pricing_GetLocationDepositPolicyView(query: GetLocationDepositPolicyViewQuery): Observable<GetLocationDepositPolicyViewQueryResult>;
    pricing_GetActivityDepositPolicyView(query: GetActivityDepositPolicyViewQuery): Observable<GetActivityDepositPolicyViewQueryResult>;
    pricing_CreateLocationDepositPolicy(command: CreateLocationDepositPolicyCommand): Observable<CreateLocationDepositPolicyCommandResponse>;
    pos_SetPosTableSelection(request: SetPosTableSelectionRequestDto): Observable<void>;
    pos_GetPosTableSelectionSettings(): Observable<PosTableSelectionSettingsView>;
    posArticleConfig_GetPosArticlePickerView(query: GetPosArticlePickerViewQuery): Observable<GetPosArticlePickerViewQueryResult>;
    posArticleConfig_GetPosArticleConfigListPageView(query: GetPosArticleConfigListPageViewQuery): Observable<GetPosArticleConfigListPageViewQueryResult>;
    posArticleConfig_GetPosArticleConfigEditItemPageView(query: GetPosArticleConfigEditItemPageViewQuery): Observable<GetPosArticleConfigEditItemPageViewQueryResult>;
    posArticleConfig_GetPosArticleConfigArticleDetailsDialogView(query: GetPosArticleConfigArticleDetailsDialogViewQuery): Observable<GetPosArticleConfigArticleDetailsDialogViewQueryResult>;
    pos_StartPosArticleBookingSync(command: StartPosArticleBookingSyncCommand): Observable<StartPosArticleBookingSyncCommandResult>;
    pos_PreviewPosArticleBookingSync(query: PreviewPosArticleBookingSyncQuery): Observable<PreviewPosArticleBookingSyncQueryResult>;
    pos_GetLatestPosArticleBookingSyncRun(query: GetLatestPosArticleBookingSyncRunQuery): Observable<GetLatestPosArticleBookingSyncRunQueryResult>;
    posBooking_GetTableAreas(): Observable<GetTableAreasQueryResult>;
    posBooking_GetPosBookingEntryDialogView(query: GetPosBookingEntryDialogViewQuery): Observable<GetPosBookingEntryDialogViewQueryResult>;
    posBooking_GetFreeTables(query: GetFreeTablesQuery): Observable<GetFreeTablesQueryResult>;
    posBooking_EnterManually(request: PosBookingEnterManuallyRequestDto): Observable<ResultId>;
    posBooking_EnterAutomatically(request: PosBookingEnterAutomaticallyRequestDto): Observable<PosBookingEnterAutomaticallyResult>;
    posBooking_Clear(request: PosBookingClearRequestDto): Observable<ResultId>;
    platformEnvironmentOverrides_SetLocationEnvironmentOverrides(command: SetLocationEnvironmentOverridesCommand): Observable<void>;
    platformEnvironmentOverrides_GetLocationEnvironmentOverrides(query: GetLocationEnvironmentOverridesQuery): Observable<GetLocationEnvironmentOverridesQueryResult>;
    platform_GetPlatformDomains(query: GetPlatformDomainsQuery): Observable<GetPlatformDomainsQueryResult>;
    platform_GetPlatformConfigListPageView(query: GetPlatformConfigListPageViewQuery): Observable<GetPlatformConfigListPageViewQueryResult>;
    platformLogging_GetListView(query: GetListViewQuery): Observable<GetListViewQueryResult>;
    platformLogging_GetListDataView(query: GetListDataViewQuery): Observable<GetListDataViewQueryResult>;
    platformLogging_GetGroupListView(query: GetGroupListViewQuery): Observable<GetGroupListViewQueryResult>;
    platformLogging_GetGroupListDataView(query: GetGroupListDataViewQuery): Observable<GetGroupListDataViewQueryResult>;
    platformLogging_GetEditItemView(query: GetEditItemViewQuery): Observable<GetEditItemViewQueryResult>;
    payments_GetStuckRefunds(): Observable<GetStuckRefundsQueryResult>;
    payments_GetRefundReport(query: GetRefundReportQuery): Observable<GetRefundReportQueryResult>;
    payments_GetPaymentVolume(query: GetPaymentVolumeQuery): Observable<GetPaymentVolumeQueryResult>;
    payments_GetPaymentTransactions(query: GetPaymentTransactionsQuery): Observable<GetPaymentTransactionsQueryResult>;
    /**
     * @return The generated file.
     */
    payments_ExportRefundsExcel(query: GetRefundReportQuery): Observable<FileResponse>;
    /**
     * @return The generated file.
     */
    payments_ExportPaymentVolumeExcel(query: GetPaymentVolumeQuery): Observable<FileResponse>;
    /**
     * @return The generated file.
     */
    payments_ExportPaymentTransactionsExcel(query: GetPaymentTransactionsQuery): Observable<FileResponse>;
    payments_SetPlatformProviderFeeSchedule(command: SetPlatformProviderFeeScheduleCommand): Observable<ProviderFeeScheduleResponse>;
    payments_SetLocationProviderFeeSchedule(command: SetLocationProviderFeeScheduleCommand): Observable<ProviderFeeScheduleResponse>;
    payments_GetPlatformProviderFeeSchedule(query: GetPlatformProviderFeeScheduleQuery): Observable<ProviderFeeScheduleResponse>;
    payments_GetLocationProviderFeeSchedule(query: GetLocationProviderFeeScheduleQuery): Observable<ProviderFeeScheduleResponse>;
    payments_SelectProviderConnectionProfile(command: SelectProviderConnectionProfileCommand): Observable<ProviderConnectionDto>;
    payments_RenameProviderConnection(command: RenameProviderConnectionCommand): Observable<ProviderConnectionDto>;
    payments_RefreshProviderConnectionStatus(command: RefreshProviderConnectionStatusCommand): Observable<ListProviderConnectionsResponse>;
    payments_ListProviderConnections(): Observable<ListProviderConnectionsResponse>;
    payments_ListProviderConnectionProfiles(query: ListProviderConnectionProfilesQuery): Observable<ListProviderConnectionProfilesResponse>;
    payments_DisconnectProviderConnection(command: DisconnectProviderConnectionCommand): Observable<ProviderConnectionDto>;
    payments_ConnectProviderWithApiKey(command: ConnectProviderWithApiKeyCommand): Observable<ProviderConnectionDto>;
    payments_CompleteProviderOAuth(command: CompleteProviderOAuthCommand): Observable<CompleteProviderOAuthResponse>;
    payments_BeginProviderPlatformOnboarding(command: BeginProviderPlatformOnboardingCommand): Observable<BeginProviderPlatformOnboardingResponse>;
    payments_BeginProviderConnection(command: BeginProviderConnectionCommand): Observable<BeginProviderConnectionResponse>;
    payments_AssignProviderConnectionToPaymentSettings(command: AssignProviderConnectionToPaymentSettingsCommand): Observable<AssignProviderConnectionToPaymentSettingsResponse>;
    participantSegmentation_SplitAgeGroup(command: SplitAgeGroupCommand): Observable<SplitAgeGroupCommandResponse>;
    participantSegmentation_SetAgeGroupText(command: SetAgeGroupTextCommand): Observable<void>;
    participantSegmentation_MergeAgeGroups(command: MergeAgeGroupsCommand): Observable<void>;
    participantSegmentation_GetLocationAgeGroupsConfig(): Observable<GetLocationAgeGroupsConfigQueryResult>;
    participantSegmentation_CreateLocationAgeGroups(command: CreateLocationAgeGroupsCommand): Observable<void>;
    participantSegmentation_ChangeAgeGroupSortOrder(command: ChangeAgeGroupSortOrderCommand): Observable<void>;
    participantSegmentation_AdjustAgeGroupBoundary(command: AdjustAgeGroupBoundaryCommand): Observable<void>;
    operations_SyncPeriods(): Observable<void>;
    operations_SetPeriodAdjustedOpeningHours(command: SetPeriodAdjustedOpeningHoursCommand): Observable<void>;
    operations_ResolveLocationOpeningHoursForDate(query: ResolveLocationOpeningHoursForDateQuery): Observable<ResolveLocationOpeningHoursForDateQueryResult>;
    operations_ResetAdjustedDayOfWeekToRegular(command: ResetAdjustedDayOfWeekToRegularCommand): Observable<void>;
    operations_ReplaceSpecialOpeningHoursIntervals(command: ReplaceSpecialOpeningHoursIntervalsCommand): Observable<void>;
    operations_ReplaceRegularDayOfWeekIntervals(command: ReplaceRegularDayOfWeekIntervalsCommand): Observable<void>;
    operations_ReplaceAdjustedDayOfWeekIntervals(command: ReplaceAdjustedDayOfWeekIntervalsCommand): Observable<void>;
    operations_RenameSpecialOpeningHours(command: RenameSpecialOpeningHoursCommand): Observable<void>;
    operations_RenameAdjustedOpeningHours(command: RenameAdjustedOpeningHoursCommand): Observable<void>;
    operations_RemoveSpecialOpeningHours(command: RemoveSpecialOpeningHoursCommand): Observable<void>;
    operations_RemoveRegularOpeningHoursVersion(command: RemoveRegularOpeningHoursVersionCommand): Observable<void>;
    operations_RemoveAdjustedOpeningHours(command: RemoveAdjustedOpeningHoursCommand): Observable<void>;
    operations_ImportLocationOpeningHoursFromLegacy(): Observable<ImportLocationOpeningHoursFromLegacyResponse>;
    operations_GetLocationOpeningHoursConfig(): Observable<GetLocationOpeningHoursConfigQueryResult>;
    operations_GetLocationOpeningHoursCalendar(): Observable<GetLocationOpeningHoursCalendarQueryResult>;
    operations_CreateLocationOpeningHours(): Observable<void>;
    operations_CopyRegularDayOfWeek(command: CopyRegularDayOfWeekCommand): Observable<void>;
    operations_CopyAdjustedDayOfWeek(command: CopyAdjustedDayOfWeekCommand): Observable<void>;
    operations_ClearPeriodAdjustedOpeningHours(command: ClearPeriodAdjustedOpeningHoursCommand): Observable<void>;
    operations_AddSpecialOpeningHours(command: AddSpecialOpeningHoursCommand): Observable<AddSpecialOpeningHoursCommandResponse>;
    operations_AddRegularOpeningHoursVersion(command: AddRegularOpeningHoursVersionCommand): Observable<void>;
    operations_AddAdjustedOpeningHours(command: AddAdjustedOpeningHoursCommand): Observable<AddAdjustedOpeningHoursCommandResponse>;
    operations_SyncOfferingSchedulePeriods(): Observable<void>;
    operations_SyncOfferingScheduleAreas(): Observable<void>;
    operations_SetSpecialAreaDay(command: SetSpecialAreaDayCommand): Observable<void>;
    operations_SetRegularAreaDay(command: SetRegularAreaDayCommand): Observable<void>;
    operations_SetRegularAreaDays(command: SetRegularAreaDaysCommand): Observable<void>;
    operations_SetPeriodAdjustedSchedule(command: SetPeriodAdjustedScheduleCommand): Observable<void>;
    operations_SetAdjustedAreaDay(command: SetAdjustedAreaDayCommand): Observable<void>;
    operations_ResolveLocationOfferingScheduleForDate(query: ResolveLocationOfferingScheduleForDateQuery): Observable<ResolveLocationOfferingScheduleForDateQueryResult>;
    operations_RenameSpecialOfferingSchedule(command: RenameSpecialOfferingScheduleCommand): Observable<void>;
    operations_RenameAdjustedOfferingSchedule(command: RenameAdjustedOfferingScheduleCommand): Observable<void>;
    operations_RemoveSpecialOfferingSchedule(command: RemoveSpecialOfferingScheduleCommand): Observable<void>;
    operations_RemoveSpecialAreaSchedule(command: RemoveSpecialAreaScheduleCommand): Observable<void>;
    operations_RemoveRegularOfferingScheduleVersion(command: RemoveRegularOfferingScheduleVersionCommand): Observable<void>;
    operations_RemoveRegularAreaSchedule(command: RemoveRegularAreaScheduleCommand): Observable<void>;
    operations_RemoveAdjustedOfferingSchedule(command: RemoveAdjustedOfferingScheduleCommand): Observable<void>;
    operations_RemoveAdjustedAreaSchedule(command: RemoveAdjustedAreaScheduleCommand): Observable<void>;
    operations_GetLocationOfferingScheduleConfig(): Observable<GetLocationOfferingScheduleConfigQueryResult>;
    operations_CreateLocationOfferingSchedule(): Observable<void>;
    operations_ClearPeriodAdjustedSchedule(command: ClearPeriodAdjustedScheduleCommand): Observable<void>;
    operations_ClearAdjustedAreaDay(command: ClearAdjustedAreaDayCommand): Observable<void>;
    operations_AddSpecialOfferingSchedule(command: AddSpecialOfferingScheduleCommand): Observable<AddSpecialOfferingScheduleCommandResponse>;
    operations_AddRegularOfferingScheduleVersion(command: AddRegularOfferingScheduleVersionCommand): Observable<void>;
    operations_AddAdjustedOfferingSchedule(command: AddAdjustedOfferingScheduleCommand): Observable<AddAdjustedOfferingScheduleCommandResponse>;
    operations_SetActivityOfferingPresetStartPolicy(command: SetActivityOfferingPresetStartPolicyCommand): Observable<void>;
    operations_SetActivityOfferingPresetDurationPolicy(command: SetActivityOfferingPresetDurationPolicyCommand): Observable<void>;
    operations_RenameActivityOfferingPreset(command: RenameActivityOfferingPresetCommand): Observable<void>;
    operations_RemoveActivityOfferingPreset(command: RemoveActivityOfferingPresetCommand): Observable<void>;
    operations_GetActivityOfferingPresets(query: GetActivityOfferingPresetsQuery): Observable<GetActivityOfferingPresetsQueryResult>;
    operations_AddActivityOfferingPreset(command: AddActivityOfferingPresetCommand): Observable<AddActivityOfferingPresetCommandResponse>;
    operations_GetActivityOfferingDurationsInUse(query: GetActivityOfferingDurationsInUseQuery): Observable<GetActivityOfferingDurationsInUseQueryResult>;
    operations_ResolveLocationCalendarForDate(query: ResolveLocationCalendarForDateQuery): Observable<ResolveLocationCalendarForDateQueryResult>;
    operations_RescheduleCalendarPeriod(command: RescheduleCalendarPeriodCommand): Observable<void>;
    operations_RenameCalendarPeriod(command: RenameCalendarPeriodCommand): Observable<void>;
    operations_RemoveCalendarPeriod(command: RemoveCalendarPeriodCommand): Observable<void>;
    operations_PruneExpiredAnnualCalendars(): Observable<void>;
    operations_ImportLocationCalendarFromLegacy(command: ImportLocationCalendarFromLegacyCommand): Observable<ImportLocationCalendarFromLegacyResponse>;
    operations_GetLocationCalendarConfig(): Observable<GetLocationCalendarConfigQueryResult>;
    operations_CreateLocationCalendar(command: CreateLocationCalendarCommand): Observable<void>;
    operations_ChangeAnnualCalendarStartMonth(command: ChangeAnnualCalendarStartMonthCommand): Observable<void>;
    operations_CanChangeAnnualCalendarStartMonth(query: CanChangeAnnualCalendarStartMonthQuery): Observable<CanChangeAnnualCalendarStartMonthQueryResult>;
    operations_AddNextAnnualCalendar(): Observable<void>;
    operations_AddCalendarPeriod(command: AddCalendarPeriodCommand): Observable<AddCalendarPeriodCommandResponse>;
    operations_SetActivityResourcePool(command: SetActivityResourcePoolCommand): Observable<void>;
    operations_SetActivityResourcePoolPolicy(command: SetActivityResourcePoolPolicyCommand): Observable<void>;
    operations_GetActivityResourcePool(query: GetActivityResourcePoolQuery): Observable<GetActivityResourcePoolQueryResult>;
    operations_GetActivityAreaPlacements(): Observable<GetActivityAreaPlacementsQueryResult>;
    offers_ProgramGroup_GetProgramGroupListPageView(query: GetProgramGroupListPageViewQuery): Observable<GetProgramGroupListPageViewQueryResult>;
    offers_ProgramGroup_GetProgramGroupEditItemView(query: GetProgramGroupEditItemViewQuery): Observable<GetProgramGroupEditItemViewQueryResult>;
    offers_ProgramGroup_GetProgramGroupEditItemProgramsView(query: GetProgramGroupEditItemProgramsViewQuery): Observable<GetProgramGroupEditItemProgramsViewQueryResult>;
    offers_ProgramGroup_GetProgramGroupAddDialogView(query: GetProgramGroupAddDialogViewQuery): Observable<GetProgramGroupAddDialogViewQueryResult>;
    notes_GetNotesDataView(query: GetNotesDataViewQuery): Observable<GetNotesDataViewQueryResult>;
    notes_GetNoteListView(query: GetNoteListViewQuery): Observable<GetNoteListViewQueryResult>;
    notes_GetNoteListTodayView(query: GetNoteListTodayViewQuery): Observable<GetNoteListTodayViewQueryResult>;
    notes_GetNoteListCalendarView(query: GetNoteListCalendarViewQuery): Observable<GetNoteListCalendarViewQueryResult>;
    notes_GetNoteListCalendarDataView(query: GetNoteListCalendarDataViewQuery): Observable<GetNoteListCalendarDataViewQueryResult>;
    notes_GetNoteItem(query: GetNoteItemQuery): Observable<GetNoteItemQueryResult>;
    notes_GetNoteDetailsDialogView(query: GetNoteDetailsDialogViewQuery): Observable<GetNoteDetailsDialogViewQueryResult>;
    monitoring_RunPosStatusCheck(command: RunPosStatusCheckCommand): Observable<RunPosStatusCheckCommandResponse>;
    monitoring_GetPosStatusListPageView(query: GetPosStatusListPageViewQuery): Observable<GetPosStatusListPageViewQueryResult>;
    locationMarketing_GetLocationSocialSettingsPageView(query: GetLocationSocialSettingsPageViewQuery): Observable<GetLocationSocialSettingsPageViewQueryResult>;
    locations_IsLocationIdCodeInUse(query: IsLocationIdCodeInUseQuery): Observable<IsLocationIdCodeInUseQueryResult>;
    locations_GetLocationsOpenDatesForMonth(query: GetLocationOpenDatesForMonthQuery): Observable<GetLocationOpenDatesForMonthQueryResult>;
    locationSnapshots_ResolveLocationSnapshotBooking(query: ResolveLocationSnapshotBookingQuery): Observable<ResolveLocationSnapshotBookingQueryResult>;
    locationSnapshots_RequestLocationSnapshot(command: RequestLocationSnapshotCommand): Observable<RequestLocationSnapshotCommandResult>;
    locationSnapshots_GetLocationSnapshotSourceTenants(): Observable<GetLocationSnapshotSourceTenantsQueryResult>;
    locationSnapshots_GetLocationSnapshotSourceLocations(query: GetLocationSnapshotSourceLocationsQuery): Observable<GetLocationSnapshotSourceLocationsQueryResult>;
    locationSnapshots_GetLocationSnapshotRuns(): Observable<GetLocationSnapshotRunsQueryResult>;
    locationSnapshots_DeleteLocationSnapshot(command: DeleteLocationSnapshotCommand): Observable<void>;
    locationSettings_UpdateLocationBookingSettings(command: UpdateLocationBookingSettingsCommand): Observable<void>;
    locationSettings_GetLocationUnitListPageView(query: GetLocationUnitListPageViewQuery): Observable<GetLocationUnitListPageViewQueryResult>;
    locationSettings_GetLocationUnitFormDialogView(query: GetLocationUnitFormDialogViewQuery): Observable<GetLocationUnitFormDialogViewQueryResult>;
    locationSettings_GetLocationSurveyQuestionListPageView(query: GetLocationSurveyQuestionListPageViewQuery): Observable<GetLocationSurveyQuestionListPageViewQueryResult>;
    locationSettings_GetLocationSurveyQuestionItemTabsPageView(query: GetLocationSurveyQuestionItemTabsPageViewQuery): Observable<GetLocationSurveyQuestionItemTabsPageViewQueryResult>;
    locationSettings_GetLocationSurveyQuestionItemGeneralPageView(query: GetLocationSurveyQuestionItemGeneralPageViewQuery): Observable<GetLocationSurveyQuestionItemGeneralPageViewQueryResult>;
    locationSettings_GetLocationSurveyQuestionFormDialogView(query: GetLocationSurveyQuestionFormDialogViewQuery): Observable<GetLocationSurveyQuestionFormDialogViewQueryResult>;
    locationSettings_GetLocationScheduleBoardListView(query: GetLocationScheduleBoardListViewQuery): Observable<GetLocationScheduleBoardListViewQueryResult>;
    locationSettings_GetLocationScheduleBoardEditItemView(query: GetLocationScheduleBoardEditItemViewQuery): Observable<GetLocationScheduleBoardEditItemViewQueryResult>;
    locationSettings_GetLocationScheduleBoardEditItemResourcesView(query: GetLocationScheduleBoardEditItemResourcesViewQuery): Observable<GetLocationScheduleBoardEditItemResourcesViewQueryResult>;
    locationSettings_GetLocationResourceConfigResourceTypesPageView(query: GetLocationResourceConfigResourceTypesPageViewQuery): Observable<GetLocationResourceConfigResourceTypesPageViewQueryResult>;
    locationSettings_GetLocationResourceConfigResourceTypeFormDialogView(query: GetLocationResourceConfigResourceTypeFormDialogViewQuery): Observable<GetLocationResourceConfigResourceTypeFormDialogViewQueryResult>;
    locationSettings_GetLocationResourceConfigResourcesPageView(query: GetLocationResourceConfigResourcesPageViewQuery): Observable<GetLocationResourceConfigResourcesPageViewQueryResult>;
    locationSettings_GetLocationResourceConfigResourceFormDialogView(query: GetLocationResourceConfigResourceFormDialogViewQuery): Observable<GetLocationResourceConfigResourceFormDialogViewQueryResult>;
    locationSettings_GetLocationResourceConfigResourceCategoryPageView(query: GetLocationResourceConfigResourceCategoryPageViewQuery): Observable<GetLocationResourceConfigResourceCategoryPageViewQueryResult>;
    locationSettings_GetLocationResourceConfigResourceCategoryEditDialogView(query: GetLocationResourceConfigResourceCategoryEditDialogViewQuery): Observable<GetLocationResourceConfigResourceCategoryEditDialogViewQueryResult>;
    locationSettings_GetLocationResourceConfigResourceCategoryAddDialogView(query: GetLocationResourceConfigResourceCategoryAddDialogViewQuery): Observable<GetLocationResourceConfigResourceCategoryAddDialogViewQueryResult>;
    locationSettings_GetLocationResourceConfigAreaSectionFormDialogView(query: GetLocationResourceConfigAreaSectionFormDialogViewQuery): Observable<GetLocationResourceConfigAreaSectionFormDialogViewQueryResult>;
    locationSettings_GetLocationResourceConfigAreaFormDialogView(query: GetLocationResourceConfigAreaFormDialogViewQuery): Observable<GetLocationResourceConfigAreaFormDialogViewQueryResult>;
    locationSettings_GetLocationPeriodEditDialogView(query: GetLocationPeriodEditDialogViewQuery): Observable<GetLocationPeriodEditDialogViewQueryResult>;
    locationSettings_GetLocationPeriodConfigOpeningHoursView(query: GetLocationPeriodConfigOpeningHoursViewQuery): Observable<GetLocationPeriodConfigOpeningHoursViewQueryResult>;
    locationSettings_GetLocationPeriodConfigEditItemView(query: GetLocationPeriodConfigEditItemViewQuery): Observable<GetLocationPeriodConfigEditItemViewQueryResult>;
    locationSettings_GetLocationPaymentListPageView(query: GetLocationPaymentListPageViewQuery): Observable<GetLocationPaymentListPageViewQueryResult>;
    locationSettings_GetLocationPaymentFormDialogView(query: GetLocationPaymentFormDialogViewQuery): Observable<GetLocationPaymentFormDialogViewQueryResult>;
    locationSettings_GetLocationNewPaymentFormDialogView(query: GetLocationNewPaymentFormDialogViewQuery): Observable<GetLocationNewPaymentFormDialogViewQueryResult>;
    locationSettings_GetLocationBookingPaymentSettingsEditItemView(query: GetLocationBookingPaymentSettingsEditItemViewQuery): Observable<GetLocationBookingPaymentSettingsEditItemViewQueryResult>;
    locationSettings_GetLocationOverviewListPageView(query: GetLocationOverviewListPageViewQuery): Observable<GetLocationOverviewListPageViewQueryResult>;
    locationSettings_GetLocationOverviewItemTabsPageView(query: GetLocationOverviewItemTabsPageViewQuery): Observable<GetLocationOverviewItemTabsPageViewQueryResult>;
    locationSettings_GetLocationOverviewFormDialogView(query: GetLocationOverviewFormDialogViewQuery): Observable<GetLocationOverviewFormDialogViewQueryResult>;
    locationSettings_GetLocationNoteListListPageView(query: GetLocationNoteListListPageViewQuery): Observable<GetLocationNoteListListPageViewQueryResult>;
    locationSettings_GetLocationNoteListItemTabsPageView(query: GetLocationNoteListItemTabsPageViewQuery): Observable<GetLocationNoteListItemTabsPageViewQueryResult>;
    locationSettings_GetLocationNoteListFormDialogView(query: GetLocationNoteListFormDialogViewQuery): Observable<GetLocationNoteListFormDialogViewQueryResult>;
    locationSettings_GetLocationGeneralSettings(query: GetLocationGeneralSettingsQuery): Observable<GetLocationGeneralSettingsQueryResult>;
    locationSettings_GetLocationBookingSettings(query: GetLocationBookingSettingsQuery): Observable<GetLocationBookingSettingsQueryResult>;
    locationSettings_UpdateLocationBrandColorScheme(command: UpdateLocationBrandColorSchemeCommand): Observable<void>;
    locationSettings_GetLocationBrandSettings(query: GetLocationBrandSettingsQuery): Observable<GetLocationBrandSettingsQueryResult>;
    locationSettings_GetLocationAgeGroupListPageView(query: GetLocationAgeGroupListPageViewQuery): Observable<GetLocationAgeGroupListPageViewQueryResult>;
    locationSettings_GetLocationAgeGroupFormDialogView(query: GetLocationAgeGroupFormDialogViewQuery): Observable<GetLocationAgeGroupFormDialogViewQueryResult>;
    locationFeatureFlags_SetLocationFeatureFlags(command: SetLocationFeatureFlagsCommand): Observable<void>;
    locationFeatureFlags_GetLocationFeatureFlagsFormView(query: GetLocationFeatureFlagsFormViewQuery): Observable<GetLocationFeatureFlagsFormViewQueryResult>;
    locationDashboard_GetProgramResultListWidgetData(query: GetProgramResultListWidgetDataQuery): Observable<GetProgramResultListWidgetDataQueryResult>;
    locationDashboard_GetPeriodSummaryWidgetData(query: GetPeriodSummaryWidgetDataQuery): Observable<GetPeriodSummaryWidgetDataQueryResult>;
    locationDashboard_GetDayView(query: GetDayViewQuery): Observable<GetDayViewQueryResult>;
    locationDashboard_GetBookingCreatedOnWidgetData(query: GetBookingCreatedOnWidgetDataQuery): Observable<GetBookingCreatedOnWidgetDataQueryResult>;
    locationDashboard_GetBookingCountOriginWidgetData(query: GetBookingCountOriginWidgetDataQuery): Observable<GetBookingCountOriginWidgetDataQueryResult>;
    locationDashboard_GetBookingAmountOriginWidgetData(query: GetBookingAmountOriginWidgetDataQuery): Observable<GetBookingAmountOriginWidgetDataQueryResult>;
    locationCore_RefreshCachedCoreLocationData(command: RefreshCachedCoreLocationDataCommand): Observable<void>;
    locationCore_GetLocationRelatedObjectNameData(query: GetLocationRelatedObjectNameDataQuery): Observable<LocationRelatedObjectNameData>;
    locationCore_GetLocationCoreData(query: GetLocationCoreDataQuery): Observable<LocationCoreData>;
    league_GetLeagueListPageView(query: GetLeagueListPageViewQuery): Observable<GetLeagueListPageViewQueryResult>;
    i18n_GetPlatformLocales(query: GetPlatformLocalesQuery): Observable<GetPlatformLocalesQueryResult>;
    i18n_DeactivatePlatformLocale(command: DeactivatePlatformLocaleCommand): Observable<void>;
    i18n_AddPlatformLocale(command: AddPlatformLocaleCommand): Observable<void>;
    i18n_ActivatePlatformLocale(command: ActivatePlatformLocaleCommand): Observable<void>;
    i18n_SetLocationLocaleFallbackLocale(command: SetLocationLocaleFallbackLocaleCommand): Observable<void>;
    i18n_SetLocationDefaultLocale(command: SetLocationDefaultLocaleCommand): Observable<void>;
    i18n_RemoveLocationLocale(command: RemoveLocationLocaleCommand): Observable<void>;
    i18n_MakeLocationLocaleOptional(command: MakeLocationLocaleOptionalCommand): Observable<void>;
    i18n_MakeLocationLocaleMandatory(command: MakeLocationLocaleMandatoryCommand): Observable<void>;
    i18n_GetLocationLocales(query: GetLocationLocalesQuery): Observable<GetLocationLocalesQueryResult>;
    i18n_GetAvailableLocalesForLocation(query: GetAvailableLocalesForLocationQuery): Observable<GetAvailableLocalesForLocationQueryResult>;
    i18n_GetAvailableFallbackLocalesForLocationLocale(query: GetAvailableFallbackLocalesForLocationLocaleQuery): Observable<GetAvailableFallbackLocalesForLocationLocaleQueryResult>;
    i18n_ClearLocationLocaleFallbackLocale(command: ClearLocationLocaleFallbackLocaleCommand): Observable<void>;
    i18n_AddLocationLocale(command: AddLocationLocaleCommand): Observable<void>;
    facility_SetResourceTypeText(command: SetResourceTypeTextCommand): Observable<void>;
    facility_SetResourceTypeOrder(command: SetResourceTypeOrderCommand): Observable<void>;
    facility_RenameResourceType(command: RenameResourceTypeCommand): Observable<void>;
    facility_RenameResourceTypePreset(command: RenameResourceTypePresetCommand): Observable<void>;
    facility_RemoveResourceTypePreset(command: RemoveResourceTypePresetCommand): Observable<void>;
    facility_GetResourceTypesConfig(query: GetResourceTypesConfigQuery): Observable<GetResourceTypesConfigQueryResult>;
    facility_GetResourceTypeConfig(query: GetResourceTypeConfigQuery): Observable<GetResourceTypeConfigQueryResult>;
    facility_DeleteResourceType(command: DeleteResourceTypeCommand): Observable<void>;
    facility_CreateResourceType(command: CreateResourceTypeCommand): Observable<CreateResourceTypeCommandResponse>;
    facility_CreateResourceTypeCatalog(command: CreateResourceTypeCatalogCommand): Observable<CreateResourceTypeCatalogCommandResponse>;
    facility_ChangeResourceTypePresetDisplayDefaults(command: ChangeResourceTypePresetDisplayDefaultsCommand): Observable<void>;
    facility_ChangeResourceTypePresetDefaultPersonCapacity(command: ChangeResourceTypePresetDefaultPersonCapacityCommand): Observable<void>;
    facility_AddResourceTypePreset(command: AddResourceTypePresetCommand): Observable<AddResourceTypePresetCommandResponse>;
    facility_SetLocationLayoutResourceDisplay(command: SetLocationLayoutResourceDisplayCommand): Observable<void>;
    facility_ReorderLocationLayoutSection(command: ReorderLocationLayoutSectionCommand): Observable<void>;
    facility_ReorderLocationLayoutResource(command: ReorderLocationLayoutResourceCommand): Observable<void>;
    facility_ReorderLocationLayoutArea(command: ReorderLocationLayoutAreaCommand): Observable<void>;
    facility_RenameLocationLayoutSection(command: RenameLocationLayoutSectionCommand): Observable<void>;
    facility_RenameLocationLayoutResource(command: RenameLocationLayoutResourceCommand): Observable<void>;
    facility_RenameLocationLayoutArea(command: RenameLocationLayoutAreaCommand): Observable<void>;
    facility_RemoveLocationLayoutSection(command: RemoveLocationLayoutSectionCommand): Observable<void>;
    facility_RemoveLocationLayoutResource(command: RemoveLocationLayoutResourceCommand): Observable<void>;
    facility_RemoveLocationLayoutArea(command: RemoveLocationLayoutAreaCommand): Observable<void>;
    facility_MoveLocationLayoutSection(command: MoveLocationLayoutSectionCommand): Observable<void>;
    facility_MoveLocationLayoutResource(command: MoveLocationLayoutResourceCommand): Observable<void>;
    facility_GetLocationLayoutConfig(query: GetLocationLayoutConfigQuery): Observable<GetLocationLayoutConfigQueryResult>;
    facility_FormLocationLayoutPairGroup(command: FormLocationLayoutPairGroupCommand): Observable<FormLocationLayoutPairGroupCommandResponse>;
    facility_DissolveLocationLayoutPairGroup(command: DissolveLocationLayoutPairGroupCommand): Observable<void>;
    facility_DeleteLocationLayout(command: DeleteLocationLayoutCommand): Observable<void>;
    facility_CreateLocationLayout(command: CreateLocationLayoutCommand): Observable<CreateLocationLayoutCommandResponse>;
    facility_ChangeLocationLayoutResourcePersonCapacity(command: ChangeLocationLayoutResourcePersonCapacityCommand): Observable<void>;
    facility_AddLocationLayoutSection(command: AddLocationLayoutSectionCommand): Observable<AddLocationLayoutSectionCommandResponse>;
    facility_AddLocationLayoutResource(command: AddLocationLayoutResourceCommand): Observable<AddLocationLayoutResourceCommandResponse>;
    facility_AddLocationLayoutResources(command: AddLocationLayoutResourcesCommand): Observable<AddLocationLayoutResourcesCommandResponse>;
    facility_AddLocationLayoutArea(command: AddLocationLayoutAreaCommand): Observable<AddLocationLayoutAreaCommandResponse>;
    externalAccess_SetNameForApiKey(command: SetNameForApiKeyCommand): Observable<SetNameForApiKeyCommandResponse>;
    externalAccess_RevokeApiKey(command: RevokeApiKeyCommand): Observable<RevokeApiKeyCommandResponse>;
    externalAccess_GetApiKeysForLocation(): Observable<GetApiKeysForLocationQueryResult>;
    externalAccess_CreateApiKey(command: CreateApiKeyCommand): Observable<CreateApiKeyCommandResponse>;
    emailTemplate_GetEmailTemplateListView(query: GetEmailTemplateListViewQuery): Observable<GetEmailTemplateListViewQueryResult>;
    emailTemplate_GetEmailTemplateEditItemView(query: GetEmailTemplateEditItemViewQuery): Observable<GetEmailTemplateEditItemViewQueryResult>;
    emailMessaging_SendCmsSiteCheckOutLink(command: SendCmsSiteCheckOutLinkCommand): Observable<void>;
    emailMessaging_GetEmailSettingsEditItemView(query: GetEmailSettingsEditItemViewQuery): Observable<EmailSettingsEditItemView>;
    emailMessaging_GetEmailSettingsEditItemLocationView(query: GetEmailSettingsEditItemLocationViewQuery): Observable<EmailSettingsEditItemLocationView>;
    emailMessaging_GetEmailSettingsEditItemEventsView(query: GetEmailSettingsEditItemEventsViewQuery): Observable<EmailSettingsEditItemEventsView>;
    customers_GetCustomerListPageView(query: GetCustomerListPageViewQuery): Observable<GetCustomerListPageViewQueryResult>;
    customers_GetCustomerEditItemPageView(query: GetCustomerEditItemPageViewQuery): Observable<GetCustomerEditItemPageViewQueryResult>;
    customers_SearchCustomers(query: SearchCustomersQuery): Observable<SearchCustomersQueryResult>;
    customers_GetCustomerInfo(query: GetCustomerInfoQuery): Observable<GetCustomerInfoQueryResult>;
    customers_IsCustomerAccountAuthenticationPhoneNumberInUse(query: IsCustomerAccountAuthenticationPhoneNumberInUseQuery): Observable<IsCustomerAccountAuthenticationPhoneNumberInUseQueryResult>;
    customers_IsCustomerAccountAuthenticationEmailAddressInUse(query: IsCustomerAccountAuthenticationEmailAddressInUseQuery): Observable<IsCustomerAccountAuthenticationEmailAddressInUseQueryResult>;
    customers_GetCustomerAccountInfoById(query: GetCustomerAccountInfoByIdQuery): Observable<GetCustomerAccountInfoByIdQueryResult>;
    customers_GetCustomerAccountInfoByAuthenticationPhoneNumber(query: GetCustomerAccountInfoByAuthenticationPhoneNumberQuery): Observable<GetCustomerAccountInfoByAuthenticationPhoneNumberQueryResult>;
    customers_GetCustomerAccountInfoByAuthenticationEmailAddress(query: GetCustomerAccountInfoByAuthenticationEmailAddressQuery): Observable<GetCustomerAccountInfoByAuthenticationEmailAddressQueryResult>;
    customers_CreateCustomerAccount(command: CreateCustomerAccountCommand): Observable<CreateCustomerAccountCommandResponse>;
    customerMessaging_SetLocationMessagingSettings(command: SetLocationMessagingSettingsCommand): Observable<void>;
    customerMessaging_SetEmailContentSections(command: SetEmailContentSectionsCommand): Observable<void>;
    customerMessaging_SetCurrentEmailTheme(command: SetCurrentEmailThemeCommand): Observable<void>;
    customerMessaging_SendTestEmail(command: SendTestEmailCommand): Observable<OutboundEmail>;
    customerMessaging_ResetEmailContentSection(command: ResetEmailContentSectionCommand): Observable<void>;
    customerMessaging_ResendOutboundEmail(command: ResendOutboundEmailCommand): Observable<OutboundEmail>;
    customerMessaging_PreviewEmail(command: PreviewEmailCommand): Observable<RenderedEmail>;
    customerMessaging_PreviewEmailForSubject(command: PreviewEmailForSubjectCommand): Observable<PreviewEmailForSubjectQueryResult>;
    customerMessaging_PreviewEmailDraft(command: PreviewEmailDraftCommand): Observable<RenderedEmail>;
    customerMessaging_GetRecentOutboundEmails(query: GetRecentOutboundEmailsQuery): Observable<GetRecentOutboundEmailsQueryResult>;
    customerMessaging_GetOutboundEmailsBySubjectRef(query: GetOutboundEmailsBySubjectRefQuery): Observable<GetOutboundEmailsBySubjectRefQueryResult>;
    customerMessaging_GetMessageKinds(): Observable<GetMessageKindsQueryResult>;
    customerMessaging_GetLocationMessagingSettings(): Observable<GetLocationMessagingSettingsQueryResult>;
    customerMessaging_GetEmailContent(query: GetEmailContentQuery): Observable<GetEmailContentQueryResult>;
    customerMessaging_GetCurrentEmailTheme(): Observable<GetCurrentEmailThemeQueryResult>;
    customDomains_TestEmailProviderConnection(): Observable<TestEmailProviderConnectionQueryResult>;
    customDomains_GetEmailProviderConfiguration(): Observable<GetEmailProviderConfigurationQueryResult>;
    customDomains_UnassignCustomDomainHostnameFromLocation(command: UnassignCustomDomainHostnameFromLocationCommand): Observable<void>;
    customDomains_RetryCustomDomainProvisioning(command: RetryCustomDomainProvisioningCommand): Observable<void>;
    customDomains_RequestCustomDomain(command: RequestCustomDomainCommand): Observable<RequestCustomDomainCommandResponse>;
    customDomains_RemoveCustomDomainHostname(command: RemoveCustomDomainHostnameCommand): Observable<void>;
    customDomains_RemoveCustomDomainCapability(command: RemoveCustomDomainCapabilityCommand): Observable<void>;
    customDomains_GetTenantHostAllowance(): Observable<GetTenantHostAllowanceQueryResult>;
    customDomains_GetCustomDomains(): Observable<GetCustomDomainsQueryResult>;
    customDomains_EvaluateCustomDomainHostname(query: EvaluateCustomDomainHostnameQuery): Observable<EvaluateCustomDomainHostnameQueryResult>;
    customDomains_CheckCustomDomainCapabilityNow(command: CheckCustomDomainCapabilityNowCommand): Observable<CheckCustomDomainCapabilityNowQueryResult>;
    customDomains_AssignCustomDomainHostnameToLocation(command: AssignCustomDomainHostnameToLocationCommand): Observable<void>;
    customDomains_ActivateCustomDomainCapability(command: ActivateCustomDomainCapabilityCommand): Observable<ActivateCustomDomainCapabilityCommandResponse>;
    customDomains_TestDnsProviderConnection(): Observable<TestDnsProviderConnectionQueryResult>;
    customDomains_SetDnsProviderOverride(command: SetDnsProviderOverrideCommand): Observable<void>;
    customDomains_GetDnsProviderConfiguration(): Observable<GetDnsProviderConfigurationQueryResult>;
    couponCampaign_GetCouponCampaignListView(query: GetCouponCampaignListViewQuery): Observable<GetCouponCampaignListViewQueryResult>;
    couponCampaign_GetCouponCampaignEditItemView(query: GetCouponCampaignEditItemViewQuery): Observable<GetCouponCampaignEditItemViewQueryResult>;
    couponCampaign_GetCouponCampaignEditItemCodesView(query: GetCouponCampaignEditItemCodesViewQuery): Observable<GetCouponCampaignEditItemCodesViewQueryResult>;
    couponCampaign_GetCouponCampaignAddDialogView(query: GetCouponCampaignAddDialogViewQuery): Observable<GetCouponCampaignAddDialogViewQueryResult>;
    cmsTemplate_GetListView(query: GetListViewQuery2): Observable<CmsTemplateListView>;
    cmsTemplate_GetEditItemView(query: GetEditItemViewQuery2): Observable<CmsTemplateEditItemView>;
    cmsTemplate_GetAddPartdDialogView(query: GetAddPartdDialogViewQuery): Observable<CmsTemplateAddPartDialogView>;
    cmsTemplate_GetAddDialogView(query: GetAddDialogViewQuery): Observable<CmsTemplateAddDialogView>;
    cms_TemplatePart_GetCmsTemplatePartListView(query: GetCmsTemplatePartListViewQuery): Observable<GetCmsTemplatePartListViewQueryResult>;
    cms_TemplatePart_GetCmsTemplatePartEditItemView(query: GetCmsTemplatePartEditItemViewQuery): Observable<GetCmsTemplatePartEditItemViewQueryResult>;
    cms_TemplatePart_GetCmsTemplatePartAddDialogView(query: GetCmsTemplatePartAddDialogViewQuery): Observable<GetCmsTemplatePartAddDialogViewQueryResult>;
    cms_SiteTheme_GetCmsSiteThemeListView(query: GetCmsSiteThemeListViewQuery): Observable<GetCmsSiteThemeListViewQueryResult>;
    cms_SiteTheme_GetCmsSiteThemeEditItemView(query: GetCmsSiteThemeEditItemViewQuery): Observable<GetCmsSiteThemeEditItemViewQueryResult>;
    cms_Sites_UpdateCmsSiteDomain(command: UpdateCmsSiteDomainCommand): Observable<void>;
    cms_Sites_SetCmsSiteLogo(command: SetCmsSiteLogoCommand): Observable<void>;
    cms_Sites_SetCmsSiteFavicon(command: SetCmsSiteFaviconCommand): Observable<void>;
    cms_Sites_SetCmsSiteDomainPrefix(command: SetCmsSiteDomainPrefixCommand): Observable<SetCmsSiteDomainPrefixCommandResponse>;
    cms_Sites_SetCmsSiteDefaultLocale(command: SetCmsSiteDefaultLocaleCommand): Observable<void>;
    cms_Sites_RemoveCmsSiteDomain(command: RemoveCmsSiteDomainCommand): Observable<void>;
    cms_GetSeoPagesForHostname(query: GetSeoPagesForHostnameQuery): Observable<GetSeoPagesForHostnameQueryResult>;
    cms_Sites_GetCmsSiteListPageView(query: GetCmsSiteListPageViewQuery): Observable<GetCmsSiteListPageViewQueryResult>;
    cms_Sites_GetCmsSiteEditItemView(query: GetCmsSiteEditItemViewQuery): Observable<GetCmsSiteEditItemViewQueryResult>;
    cms_Sites_GetCmsSiteEditItemSelfServiceView(query: GetCmsSiteEditItemSelfServiceViewQuery): Observable<GetCmsSiteEditItemSelfServiceViewQueryResult>;
    cms_Sites_GetCmsSiteEditItemDomainView(query: GetCmsSiteEditItemDomainViewQuery): Observable<GetCmsSiteEditItemDomainViewQueryResult>;
    cms_Sites_GetCmsSiteEditItemAnalyticsView(query: GetCmsSiteEditItemAnalyticsViewQuery): Observable<GetCmsSiteEditItemAnalyticsViewQueryResult>;
    cms_Sites_GetCmsSiteDomainPrefixAvailability(query: GetCmsSiteDomainPrefixAvailabilityQuery): Observable<GetCmsSiteDomainPrefixAvailabilityQueryResult>;
    cms_Sites_ClearCmsSiteLogo(command: ClearCmsSiteLogoCommand): Observable<void>;
    cms_Sites_ClearCmsSiteFavicon(command: ClearCmsSiteFaviconCommand): Observable<void>;
    cms_Sites_AddCmsSiteDomain(command: AddCmsSiteDomainCommand): Observable<AddCmsSiteDomainCommandResponse>;
    cms_SiteCheckOuts_GetCmsSiteCheckOutListPageView(query: GetCmsSiteCheckOutListPageViewQuery): Observable<GetCmsSiteCheckOutListPageViewQueryResult>;
    cms_SiteCheckOuts_GetCmsSiteCheckOutEditItemView(query: GetCmsSiteCheckOutEditItemViewQuery): Observable<GetCmsSiteCheckOutEditItemViewQueryResult>;
    cms_ContentTypes_GetContentTypePartAddDialogView(query: GetContentTypePartAddDialogViewQuery): Observable<GetContentTypePartAddDialogViewQueryResult>;
    cms_ContentTypes_GetContentTypeListPageView(query: GetContentTypeListPageViewQuery): Observable<GetContentTypeListPageViewQueryResult>;
    cms_ContentTypes_GetContentTypeEditItemView(query: GetContentTypeEditItemViewQuery): Observable<GetContentTypeEditItemViewQueryResult>;
    cms_ContentPart_GetCmsContentPartListView(query: GetCmsContentPartListViewQuery): Observable<GetCmsContentPartListViewQueryResult>;
    cms_ContentPart_GetCmsContentPartFieldAddDialogView(query: GetCmsContentPartFieldAddDialogViewQuery): Observable<GetCmsContentPartFieldAddDialogViewQueryResult>;
    cms_ContentPart_GetCmsContentPartEditItemView(query: GetCmsContentPartEditItemViewQuery): Observable<GetCmsContentPartEditItemViewQueryResult>;
    cms_ContentItem_GetCmsContentItemVersionEditItemView(query: GetCmsContentItemVersionEditItemViewQuery): Observable<CmsContentItemVersionEditItemViewResult>;
    cms_ContentItem_GetCmsContentItemLinkPickerView(query: GetCmsContentItemLinkPickerViewQuery): Observable<GetCmsContentItemLinkPickerViewQueryResult>;
    cms_ContentItem_GetCmsContentItemEditItemView(query: GetCmsContentItemEditItemViewQuery): Observable<CmsContentItemEditItemViewResult>;
    cms_ContentItem_GetCmsContentItemAddDialogView(query: GetCmsContentItemAddDialogViewQuery): Observable<GetCmsContentItemAddDialogViewQueryResult>;
    cmsV2Settings_TakePublicWebsiteOffline(command: TakePublicWebsiteOfflineCommand): Observable<void>;
    cmsV2Settings_SetWebsiteName(command: SetWebsiteNameCommand): Observable<void>;
    cmsV2Settings_MakeOfflineWebsiteAvailableToPublic(command: MakeOfflineWebsiteAvailableToPublicCommand): Observable<void>;
    cmsV2Settings_GetWebsites(query: GetWebsitesQuery): Observable<GetWebsitesQueryResult>;
    cmsV2Settings_CreateWebsite(command: CreateWebsiteCommand): Observable<CreateWebsiteCommandResponse>;
    cmsV2Settings_SetWebsiteDomainLocaleAsPrimary(command: SetWebsiteDomainLocaleAsPrimaryCommand): Observable<void>;
    cmsV2Settings_RemoveWebsiteDomainSecondaryLocale(command: RemoveWebsiteDomainSecondaryLocaleCommand): Observable<void>;
    cmsV2Settings_GetWebsitesWithDomainsLocales(query: GetWebsitesWithDomainsLocalesQuery): Observable<GetWebsitesWithDomainsLocalesQueryResult>;
    cmsV2Settings_AddWebsiteDomainSecondaryLocale(command: AddWebsiteDomainSecondaryLocaleCommand): Observable<void>;
    cmsV2Settings_RemoveWebsiteDomain(command: RemoveWebsiteDomainCommand): Observable<void>;
    cmsV2Settings_GetWebsitesWithDomains(query: GetWebsitesWithDomainsQuery): Observable<GetWebsitesWithDomainsQueryResult>;
    cmsV2Settings_AddWebsiteDomain(command: AddWebsiteDomainCommand): Observable<void>;
    cmsV2Preview_GetWebsiteThemeStylesheetForWebsitePagePreview(query: GetWebsiteThemeStylesheetForWebsitePagePreviewQuery): Observable<GetWebsiteThemeStylesheetForWebsitePagePreviewQueryResult>;
    cmsV2Preview_GetWebsiteThemeStylesheetForComponentPreview(query: GetWebsiteThemeStylesheetForComponentPreviewQuery): Observable<GetWebsiteThemeStylesheetForComponentPreviewQueryResult>;
    cmsV2Preview_GetPageContentHtmlForWebsitePagePreview(query: GetPageContentHtmlForWebsitePagePreviewQuery): Observable<GetPageContentHtmlForWebsitePagePreviewQueryResult>;
    cmsV2Preview_GetPageContentCellHtmlForWebsitePagePreview(query: GetPageContentCellHtmlForWebsitePagePreviewQuery): Observable<GetPageContentCellHtmlForWebsitePagePreviewQueryResult>;
    cmsV2Preview_GetPageContentCellHtmlForComponentPreview(query: GetPageContentCellHtmlForComponentPreviewQuery): Observable<GetPageContentCellHtmlForComponentPreviewQueryResult>;
    cmsV2Preview_GetComponentStylesheetForComponentPreview(query: GetComponentStylesheetForComponentPreviewQuery): Observable<GetComponentStylesheetForComponentPreviewQueryResult>;
    cmsV2FieldTypes_(query: GetFieldTypeDtosQuery): Observable<GetFieldTypeDtosQueryResult>;
    cmsV2Design_SetWebsiteThemeStyleSheet(command: SetWebsiteThemeStylesheetTemplateCommand): Observable<void>;
    cmsV2Design_SetWebsiteThemeName(command: SetWebsiteThemeNameCommand): Observable<void>;
    cmsV2Design_GetWebsiteTheme(query: GetWebsiteThemeQuery): Observable<GetWebsiteThemeQueryResult>;
    cmsV2Design_GetWebsitesWithThemes(query: GetWebsitesWithThemesQuery): Observable<GetWebsitesWithThemesQueryResult>;
    cmsV2Design_CreateWebsiteTheme(command: CreateWebsiteThemeCommand): Observable<CreateWebsiteThemeCommandResponse>;
    cmsV2Design_UpdatePublishedPageTemplateContent(command: UpdatePublishedPageTemplateContentCommand): Observable<void>;
    cmsV2Design_SetPageTemplatePrimaryLanguage(command: SetPageTemplatePrimaryLanguageCommand): Observable<void>;
    cmsV2Design_SetPageTemplateName(command: SetPageTemplateNameCommand): Observable<void>;
    cmsV2Design_RetractPublishedPageTemplate(command: RetractPublishedPageTemplateCommand): Observable<void>;
    cmsV2Design_RemovePageTemplateSecondaryLanguage(command: RemovePageTemplateSecondaryLanguageCommand): Observable<void>;
    cmsV2Design_PublishDraftPageTemplate(command: PublishDraftPageTemplateCommand): Observable<void>;
    cmsV2Design_GetPageTemplates(query: GetPageTemplatesQuery): Observable<GetPageTemplatesQueryResult>;
    cmsV2Design_GetPageTemplatesForNewWebsitePage(query: GetPageTemplatesForNewWebsitePageQuery): Observable<GetPageTemplatesForNewWebsitePageQueryResult>;
    cmsV2Design_GetPageTemplateName(query: GetPageTemplateNameQuery): Observable<GetPageTemplateNameQueryResult>;
    cmsV2Design_GetPageTemplateLocalesNotInUse(query: GetPageTemplateLocalesNotInUseQuery): Observable<GetPageTemplateLocalesNotInUseQueryResult>;
    cmsV2Design_GetPageTemplateEditorView(query: GetPageTemplateEditorViewQuery): Observable<PageTemplateEditorView>;
    cmsV2Design_GetPageTemplateContentVersionHistory(query: GetPageTemplateContentVersionHistoryQuery): Observable<GetPageTemplateContentVersionHistoryQueryResult>;
    cmsV2Design_GetLatestPageTemplateContentVersion(query: GetLatestPageTemplateContentVersionQuery): Observable<GetLatestPageTemplateContentVersionQueryResult>;
    cmsV2Design_CreatePageTemplate(command: CreatePageTemplateCommand): Observable<CreatePageTemplateCommandResponse>;
    cmsV2Design_CreatePageTemplateContentVersion(command: CreatePageTemplateContentVersionCommand): Observable<CreatePageTemplateContentVersionCommandResponse>;
    cmsV2Design_AddPageTemplateSecondaryLanguage(command: AddPageTemplateSecondaryLanguageCommand): Observable<AddPageTemplateSecondaryLanguageCommandResponse>;
    cmsV2Design_UpdatePublishedPageContentComponentSourceCode(command: UpdatePublishedPageContentComponentSourceCodeCommand): Observable<void>;
    cmsV2Design_SetPageContentComponentName(command: SetPageContentComponentNameCommand): Observable<void>;
    cmsV2Design_PublishDraftPageContentComponent(command: PublishDraftPageContentComponentCommand): Observable<void>;
    cmsV2Design_GetStandardPageContentComponentsForPageContent(query: GetStandardPageContentComponentsForPageContentQuery): Observable<GetStandardPageContentComponentsForPageContentQueryResult>;
    cmsV2Design_GetPageContentComponents(query: GetPageContentComponentsQuery): Observable<GetPageContentComponentsQueryResult>;
    cmsV2Design_GetPageContentComponentsForPageContent(query: GetPageContentComponentsForPageContentQuery): Observable<GetPageContentComponentsForPageContentQueryResult>;
    cmsV2Design_GetPageContentComponentEditorView(query: GetPageContentComponentEditorViewQuery): Observable<PageContentComponentEditorView>;
    cmsV2Design_GetLatestPageContentComponentSourceCodeVersion(query: GetLatestPageContentComponentSourceCodeVersionQuery): Observable<GetLatestPageContentComponentSourceCodeVersionQueryResult>;
    cmsV2Design_CreatePageContentComponent(command: CreatePageContentComponentCommand): Observable<CreatePageContentComponentCommandResponse>;
    cmsV2Design_CreatePageContentComponentSourceCodeVersion(command: CreatePageContentComponentSourceCodeVersionCommand): Observable<CreatePageContentComponentSourceCodeVersionCommandResponse>;
    cmsV2Content_SetWebsitePageTitle(command: SetWebsitePageTitleCommand): Observable<void>;
    cmsV2Content_SetWebsitePageContentSlug(command: SetWebsitePageContentSlugCommand): Observable<void>;
    cmsV2Content_RetractPublishedWebsitePage(command: RetractPublishedWebsitePageCommand): Observable<void>;
    cmsV2Content_PublishDraftWebsitePage(command: PublishDraftWebsitePageCommand): Observable<void>;
    cmsV2Content_IsWebsitePageContentSlugUnique(query: IsWebsitePageContentSlugUniqueQuery): Observable<IsWebsitePageContentSlugUniqueQueryResult>;
    cmsV2Content_GetWebsitePage(query: GetWebsitePageQuery): Observable<GetWebsitePageQueryResult>;
    cmsV2Content_GetWebsitePages(query: GetWebsitePagesQuery): Observable<GetWebsitePagesQueryResult>;
    cmsV2Content_GetWebsitePageEditorView(query: GetWebsitePageEditorViewQuery): Observable<WebsitePageEditorView>;
    cmsV2Content_GetWebsitePageContentVersionHistory(query: GetWebsitePageContentVersionHistoryQuery): Observable<GetWebsitePageContentVersionHistoryQueryResult>;
    cmsV2Content_GetLatestWebsitePageContentVersion(query: GetLatestWebsitePageContentVersionQuery): Observable<GetLatestWebsitePageContentVersionQueryResult>;
    cmsV2Content_CreateWebsitePage(command: CreateWebsitePageCommand): Observable<CreateWebsitePageCommandResponse>;
    cmsV2Content_CreateWebsitePageContentVersion(command: CreateWebsitePageContentVersionCommand): Observable<CreateWebsitePageContentVersionCommandResponse>;
    catalogs_SetProgramVariantStepWeekConfig(command: SetProgramVariantStepWeekConfigCommand): Observable<void>;
    catalogs_SetProgramVariantStepDayConfig(command: SetProgramVariantStepDayConfigCommand): Observable<void>;
    catalogs_SetProgramVariantStepDayConfigs(command: SetProgramVariantStepDayConfigsCommand): Observable<void>;
    catalogs_SetProgramStepHasDynamicDuration(command: SetProgramStepHasDynamicDurationCommand): Observable<void>;
    catalogs_SetProgramStepCanChangePosition(command: SetProgramStepCanChangePositionCommand): Observable<void>;
    catalogs_SetProgramPeriodOfferingVariant(command: SetProgramPeriodOfferingVariantCommand): Observable<void>;
    catalogs_SetProgramOfferingVariantName(command: SetProgramOfferingVariantNameCommand): Observable<void>;
    catalogs_SetDefaultProgramOfferingVariant(command: SetDefaultProgramOfferingVariantCommand): Observable<void>;
    catalogs_ReorderProgramSteps(command: ReorderProgramStepsCommand): Observable<void>;
    catalogs_RemoveProgramStep(command: RemoveProgramStepCommand): Observable<void>;
    catalogs_RemoveProgramOfferingVariant(command: RemoveProgramOfferingVariantCommand): Observable<void>;
    catalogs_MigrateLocationProgramsToOfferingVariants(command: MigrateLocationProgramsToOfferingVariantsCommand): Observable<void>;
    catalogs_GetProgramById(query: GetProgramByIdQuery): Observable<GetProgramByIdQueryResult>;
    catalogs_GetActivePrograms(): Observable<GetActiveProgramsQueryResult>;
    catalogs_CopyProgramVariantStepDayConfigToOtherDays(command: CopyProgramVariantStepDayConfigToOtherDaysCommand): Observable<void>;
    catalogs_AddProgramStep(command: AddProgramStepCommand): Observable<AddProgramStepCommandResponse>;
    catalogs_AddProgramOfferingVariant(command: AddProgramOfferingVariantCommand): Observable<AddProgramOfferingVariantCommandResponse>;
    catalogs_CreateArticle(command: CreateArticleCommand): Observable<CreateArticleCommandResponse>;
    catalogs_SetActivitySuitableAgeGroups(command: SetActivitySuitableAgeGroupsCommand): Observable<void>;
    catalogs_SetActivityName(command: SetActivityNameCommand): Observable<void>;
    catalogs_SetActivityDescription(command: SetActivityDescriptionCommand): Observable<void>;
    catalogs_SetActivityCompatibleResourceTypes(command: SetActivityCompatibleResourceTypesCommand): Observable<void>;
    catalogs_SetActivityCapacityBasis(command: SetActivityCapacityBasisCommand): Observable<void>;
    catalogs_RemoveActivityDuration(command: RemoveActivityDurationCommand): Observable<void>;
    catalogs_GetActivities(query: GetActivitiesQuery): Observable<GetActivitiesQueryResult>;
    catalogs_GetActiveActivities(): Observable<GetActiveActivitiesQueryResult>;
    catalogs_CreateActivity(command: CreateActivityCommand): Observable<CreateActivityCommandResponse>;
    catalogs_AddActivityDuration(command: AddActivityDurationCommand): Observable<void>;
    bookings_GetPendingConfirmationEmailBookingsListPageView(query: GetPendingConfirmationEmailBookingsListPageViewQuery): Observable<GetPendingConfirmationEmailBookingsListPageViewQueryResult>;
    bookings_GetPendingApprovalBookingsListPageView(query: GetPendingApprovalBookingsListPageViewQuery): Observable<GetPendingApprovalBookingsListPageViewQueryResult>;
    bookingsV2Payments_RegisterBookingPaymentReceived(command: RegisterBookingPaymentReceivedCommand): Observable<RegisterBookingPaymentReceivedCommandResult>;
    bookingsV2Payments_GetBookingPaymentPanelView(query: GetBookingPaymentPanelViewQuery): Observable<GetBookingPaymentPanelViewQueryResult>;
    bookingsV2Payments_CreateBookingPaymentLink(command: CreateBookingPaymentLinkCommand): Observable<CreateBookingPaymentLinkCommandResult>;
    bookingsV2Catalogs_GetCatalogAvailabilityForDate(query: GetCatalogAvailabilityForDateQuery): Observable<GetCatalogAvailabilityForDateQueryResult>;
    bookingsV2Bookings_SubmitDraftBooking(command: SubmitDraftBookingCommand): Observable<SubmitDraftBookingCommandResponse>;
    bookingsV2Bookings_SetBookingReference(command: SetBookingReferenceCommand): Observable<SetBookingReferenceCommandResponse>;
    bookingsV2Bookings_SetBookingQuestionAnswers(command: SetBookingQuestionAnswersCommand): Observable<SetBookingQuestionAnswersCommandResponse>;
    bookingsV2Bookings_SetBookingIndividualCustomer(command: SetBookingIndividualCustomerCommand): Observable<SetBookingIndividualCustomerCommandResponse>;
    bookingsV2Bookings_SetBookingCustomerForCustomerAccount(command: SetBookingCustomerForCustomerAccountCommand): Observable<SetBookingCustomerForCustomerAccountCommandResponse>;
    bookingsV2Bookings_SetBookingCompanyCustomer(command: SetBookingCompanyCustomerCommand): Observable<SetBookingCompanyCustomerCommandResponse>;
    bookingsV2Bookings_SetBookingCommunicationLocale(command: SetBookingCommunicationLocaleCommand): Observable<SetBookingCommunicationLocaleCommandResponse>;
    bookingsV2Bookings_SetBookingArticleExtras(command: SetBookingArticleExtrasCommand): Observable<SetBookingArticleExtrasCommandResponse>;
    bookingsV2Bookings_SetAsideDraftBooking(command: SetAsideDraftBookingCommand): Observable<SetAsideDraftBookingCommandResponse>;
    bookingsV2Bookings_ReverseBookingPromotionCodeRedemption(command: ReverseBookingPromotionCodeRedemptionCommand): Observable<ReverseBookingPromotionCodeRedemptionCommandResponse>;
    bookingsV2Bookings_ResumeDraftBooking(command: ResumeDraftBookingCommand): Observable<ResumeDraftBookingCommandResponse>;
    bookingsV2Bookings_RemoveBookingActivity(command: RemoveBookingActivityCommand): Observable<RemoveBookingActivityCommandResponse>;
    bookingsV2Bookings_RedeemBookingPromotionCode(command: RedeemBookingPromotionCodeCommand): Observable<RedeemBookingPromotionCodeCommandResponse>;
    bookingsV2Bookings_ListSubmittedBookingsForDate(query: ListSubmittedBookingsForDateQuery): Observable<ListSubmittedBookingsForDateQueryResult>;
    bookingsV2_ListRecentConfirmedBookings(query: ListRecentConfirmedBookingsQuery): Observable<ListRecentConfirmedBookingsQueryResult>;
    bookingsV2Bookings_ListDraftBookings(query: ListDraftBookingsQuery): Observable<ListDraftBookingsQueryResult>;
    bookingsV2Bookings_GetBookingForBookingSession(query: GetBookingForBookingSessionQuery): Observable<GetBookingForBookingSessionQueryResult>;
    bookingsV2Bookings_DiscardDraftBooking(command: DiscardDraftBookingCommand): Observable<DiscardDraftBookingCommandResponse>;
    bookingsV2Bookings_ConfirmDraftBooking(command: ConfirmDraftBookingCommand): Observable<ConfirmDraftBookingCommandResponse>;
    bookingsV2Bookings_ClearBookingCustomer(command: ClearBookingCustomerCommand): Observable<ClearBookingCustomerCommandResponse>;
    bookingsV2Bookings_CancelBooking(command: CancelBookingCommand): Observable<CancelBookingCommandResponse>;
    bookingsV2Bookings_AddBookingActivityFromOption(command: AddBookingActivityFromOptionCommand): Observable<AddBookingActivityFromOptionCommandResponse>;
    bookingsV2Bookings_AbortDraftBooking(command: AbortDraftBookingCommand): Observable<AbortDraftBookingCommandResponse>;
    bookingsV2Sessions_StartDraftBookingSession(command: StartDraftBookingSessionCommand): Observable<StartDraftBookingSessionCommandResponse>;
    bookingsV2Sessions_ExtendBookingSession(command: ExtendBookingSessionCommand): Observable<ExtendBookingSessionCommandResponse>;
    bookingsDev_CreateSampleBooking(command: CreateSampleBookingCommand): Observable<CreateSampleBookingResult>;
    bookingRefundProposals_GetPrepareBookingRefundProposalsPageView(query: GetPrepareBookingRefundProposalsPageViewQuery): Observable<GetPrepareBookingRefundProposalsPageViewQueryResult>;
    bookingRefundProposals_GetBookingRefundProposalPendingApprovalListPageView(query: GetBookingRefundProposalPendingApprovalListPageViewQuery): Observable<GetBookingRefundProposalPendingApprovalListPageViewQueryResult>;
    bookingRefundProposals_GetBookingRefundProposalInProgressListPageView(query: GetBookingRefundProposalInProgressListPageViewQuery): Observable<GetBookingRefundProposalInProgressListPageViewQueryResult>;
    bookingRefundProposals_GetBookingRefundProposalHistoryListPageDataView(query: GetBookingRefundProposalHistoryListPageDataViewQuery): Observable<GetBookingRefundProposalHistoryListPageDataViewQueryResult>;
    bookingNotifications_SetBookingReminderLeadDays(command: SetBookingReminderLeadDaysCommand): Observable<void>;
    bookingNotifications_SetBookingNotificationKindEnabled(command: SetBookingNotificationKindEnabledCommand): Observable<void>;
    bookingNotifications_GetBookingNotificationRules(query: GetBookingNotificationRulesQuery): Observable<GetBookingNotificationRulesQueryResult>;
    bookingItem_GetPaymentDetailsDialogView(query: GetPaymentDetailsDialogViewQuery): Observable<GetPaymentDetailsDialogViewQueryResult>;
    bookingDev_GetSelfServiceOptions(query: BookingDevQuery): Observable<GetSelfServiceOptionsQueryResult>;
    bookingDev_GetResourceBookings(query: BookingDevQuery): Observable<__GetBookingResourceBookingsQueryResult>;
    bookingDev_GetRefunds(query: BookingDevQuery): Observable<GetRefundsQueryResult>;
    bookingDev_GetPayments(query: BookingDevQuery): Observable<GetPaymentsQueryResult>;
    bookingDev_GetPaymentLinkOptions(query: BookingDevQuery): Observable<GetPaymentLinkOptionsQueryResult>;
    bookingDev_GetBooking(query: BookingDevQuery): Observable<__BookingData>;
    bookingDev_GetBookingRefundProposals(query: BookingDevQuery): Observable<__GetBookingRefundProposalsForBookingQueryResult>;
    bookingDev_GetBookingLedger(query: BookingDevQuery): Observable<__BookingLedgerData>;
    bookability_ResolveActivityBookingOptionsForDate(query: ResolveActivityBookingOptionsForDateQuery): Observable<ResolveActivityBookingOptionsForDateQueryResult>;
    bookability_GetOfferedActivityIdsForDate(query: GetOfferedActivityIdsForDateQuery): Observable<GetOfferedActivityIdsForDateQueryResult>;
    bookability_GetBookableArticleExtrasForSession(query: GetBookableArticleExtrasForSessionQuery): Observable<GetBookableArticleExtrasForSessionQueryResult>;
    bookability_GetActivityBookingOptionDetails(query: GetActivityBookingOptionDetailsQuery): Observable<GetActivityBookingOptionDetailsQueryResult>;
    assortments_GetAssortmentActivities(query: GetAssortmentActivitiesQuery): Observable<GetAssortmentActivitiesQueryResult>;
    admins_LookupBookingInfo(query: LookupBookingInfoQuery): Observable<LookupBookingInfoQueryResult>;
    marketing_SetMarketingLocationConfig(command: SetMarketingLocationConfigCommand): Observable<ResultV2Dto>;
    marketing_GetMarketingLocationConfigFormData(query: GetMarketingLocationConfigFormDataQuery): Observable<ResultV2DtoOfGetMarketingLocationConfigFormDataQueryResult>;
    marketing_GetMarketingLocationIntegrations(query: GetMarketingLocationIntegrationsQuery): Observable<ResultV2DtoOfGetMarketingLocationIntegrationsQueryResult>;
    marketing_GetAvailableMarketingIntegrationsForLocation(query: GetAvailableMarketingIntegrationsForLocationQuery): Observable<ResultV2DtoOfGetAvailableMarketingIntegrationsForLocationQueryResult>;
    marketing_AddMarketingLocationIntegration(command: AddMarketingLocationIntegrationCommand): Observable<ResultV2Dto>;
    shell_GetShellView(query: GetShellViewQuery): Observable<ShellView>;
    shell_GetShellViewLocation(query: GetShellViewLocationQuery): Observable<ShellViewLocation>;
    scheduleBoard_GetBookingStartStopOverviewDialogView(query: GetBookingStartStopOverviewDialogViewQuery): Observable<BookingStartStopOverviewDialogView>;
    scheduleBoard_GetGridBlockItems(query: GetGridBlockItemsQuery): Observable<GetGridBlockItemsResult>;
    scheduleBoard_GetGridDataView(query: GetGridDataViewQuery): Observable<ScheduleBoardGridDataView>;
    scheduleBoard_GetGridsterItemsForBookingId(query: GetGridsterItemsForBookingIdQuery): Observable<GetGridsterItemsForBookingIdResult>;
    scheduleBoard_GetGridView(query: GetGridViewQuery): Observable<ScheduleBoardGridView>;
    scheduleBoard_GetScheduleBoardBlockGridEditDialogView(command: ScheduleBoardBlockGridsterItem): Observable<ScheduleBoardBlockGridEditDialogView>;
    scheduleBoard_SetGridBlockItems(command: ScheduleBoardBlockGridRequest): Observable<Result>;
    scheduleBoard_SetGridItemsResourceBookings(command: ScheduleBoardGridItemResourceBookingChangeRequest): Observable<Result>;
    cmsPage_GetAddDialogView(query: GetCmsPageAddDialogViewQuery): Observable<CmsPageAddDialogView>;
    cmsPage_GetEditItemContentView(query: GetCmsPageEditItemContentViewQuery): Observable<CmsPageEditItemContentView>;
    cmsPage_GetEditItemView(query: GetCmsPageEditItemViewQuery): Observable<CmsPageEditItemView>;
    cmsPage_GetListView(query: GetCmsPageListViewQuery): Observable<CmsPageListView>;
    cmsPage_GetPickerDialogView(query: GetCmsPagePickerDialogViewQuery): Observable<CmsPagePickerDialogView>;
    webClientSchema_GetCustomSchemaDefinitions(): Observable<CustomSchemaDefinition>;
    webClientSchema_WebComponents(): Observable<WebComponentsRegister>;
    cacheAdmin_Set(cacheKey: string | null, value: string | null): Observable<ResultV2DtoOfString>;
    cacheAdmin_SetWithTags(cacheKey: string | null, value: string | null, tags: string[] | null): Observable<ResultV2DtoOfString>;
    cacheAdmin_Get(cacheKey: string | null): Observable<ResultV2DtoOfString>;
    cacheAdmin_InvalidateKeysByTag(tags: string[] | null): Observable<ResultV2Dto>;
    cacheAdmin_FlushDatabase(password?: string | null | undefined): Observable<ResultV2Dto>;
    testCQRS_PortalAppTest(helloWorldText: string): Observable<ResultV2DtoOfPortalAppTestQueryResult>;
    testCQRS_BackendTest(helloWorldText: string): Observable<ResultV2DtoOfBackendTestQueryResult>;
    resourceConfigResourceCategories_GetResourceCategories(query: GetResourceCategoriesQuery): Observable<ResultV2DtoOfGetResourceCategoriesQueryResult>;
    resourceConfigResourceCategories_GetResourceCategoryFormData(query: GetResourceCategoryFormDataQuery): Observable<ResultV2DtoOfGetResourceCategoryFormDataQueryResult>;
    resourceConfigResourceCategories_GetNewResourceCategoryFormData(query: GetNewResourceCategoryFormDataQuery): Observable<ResultV2DtoOfGetResourceCategoryFormDataQueryResult>;
    resourceConfigResourceCategories_AddResourceCategory(command: AddResourceCategoryCommand): Observable<ResultV2Dto>;
    resourceConfigResourceCategories_UpdateResourceCategory(command: UpdateResourceCategoryCommand): Observable<ResultV2Dto>;
    resourceConfigResourceCategories_RemoveResourceCategory(command: RemoveResourceCategoryCommand): Observable<ResultV2Dto>;
    resourceConfigResourceTypes_GetResourceTypes(query: GetResourceTypesQuery): Observable<ResultV2DtoOfGetResourceTypesQueryResult>;
    resourceConfigResourceTypes_GetResourceTypeFormData(query: GetResourceTypeFormDataQuery): Observable<ResultV2DtoOfGetResourceTypeFormDataQueryResult>;
    resourceConfigResourceTypes_GetNewResourceTypeFormData(query: GetNewResourceTypeFormDataQuery): Observable<ResultV2DtoOfGetResourceTypeFormDataQueryResult>;
    resourceConfigResourceTypes_AddResourceType(command: AddResourceTypeCommand): Observable<ResultV2Dto>;
    resourceConfigResourceTypes_UpdateResourceType(command: UpdateResourceTypeCommand): Observable<ResultV2Dto>;
    resourceConfigResourceTypes_RemoveResourceType(command: RemoveResourceTypeCommand): Observable<ResultV2Dto>;
    periodConfiguration_GetPeriodConfigurationWithPeriodInserted(query: GetPeriodConfigurationWithPeriodInsertedQuery): Observable<ResultV2DtoOfGetPeriodConfigurationWithPeriodInsertedQueryResult>;
    periodConfiguration_GetPeriodConfigurationWithPeriodModified(query: GetPeriodConfigurationWithPeriodModifiedQuery): Observable<ResultV2DtoOfGetPeriodConfigurationWithPeriodModifiedQueryResult>;
    periodConfiguration_GetPeriodConfigurationWithPeriodRemovedAndGapFilled(query: GetPeriodConfigurationWithPeriodRemovedAndGapFilledQuery): Observable<ResultV2DtoOfGetPeriodConfigurationWithPeriodRemovedAndGapFilledQueryResult>;
    paymentSettings_CreateNewPaymentSettings(command: CreateNewPaymentSettingsCommand): Observable<ResultV2DtoOfCreateNewPaymentSettingsCommandResponse>;
    paymentSettings_PatchPaymentSettings(command: PatchPaymentSettingsCommand): Observable<ResultV2DtoOfPatchPaymentSettingsCommandResponse>;
    paymentServiceProviders_CreateManualPaymentForBooking(command: CreateManualPaymentForBookingCommand): Observable<ResultV2DtoOfCreateManualPaymentForBookingCommandResponse>;
    paymentServiceProviders_CreateManualRefundForBooking(command: CreateManualRefundForBookingCommand): Observable<ResultV2DtoOfCreateManualRefundForBookingCommandResponse>;
    program_GetStartDateTimesFilterData(programId: string, year: number, month: number): Observable<ResultV2DtoOfGetProgramStartDateTimesFilterDataQueryResult>;
    file_GetFileUri(fileId: string): Observable<ResultV2DtoOfGetFileUriQueryResult>;
    file_SetFileUploadStatus(command: SetFileUploadStatusCommand): Observable<ResultV2Dto>;
    file_CreateNewFileForUpload(command: CreateNewFileForUploadCommand): Observable<ResultV2DtoOfCreateNewFileForUploadCommandResponse>;
    cmsCaching_ClearCachedCmsPagesDataForLocation(command: ClearCachedCmsPagesDataForLocationCommand): Observable<ResultV2Dto>;
    cmsCaching_ClearCachedCmsSiteData(command: ClearCachedCmsSiteDataCommand): Observable<ResultV2Dto>;
    bookingItem_Patch(bookingId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    bookingItem_PatchCustomer(bookingId: string | null, customerId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    bookingItem_ChangeStatus(bookingId: string | null, bookingStatus: BookingStatus): Observable<ResultId>;
    bookingItem_GetLookupDialogView(): Observable<ResultDataOfBookingLookupDialogView>;
    bookingItem_RequestBookingLookup(searchQ: string | null): Observable<ResultDataOfListOfBookingLookupResultItem>;
    bookingItem_RequestCustomerLookup(searchQ: string | null): Observable<ResultDataOfListOfBookingCustomerDetails>;
    bookingItem_GetDetailsDialogView(bookingId: string | null): Observable<ResultDataOfBookingDetailsDialogView>;
    bookingItem_GetBookingCustomerEditDialogView(bookingId: string | null): Observable<ResultDataOfBookingCustomerEditDialogView>;
    bookingItem_RequestPaymentLink(paymentLinkRequest: BookingPaymentLinkRequest): Observable<ResultDataOfBookingPaymentLinkResponse>;
    bookingProcess_Cancel(cancelBookingPortalRequest: CancelBookingPortalRequest): Observable<ResultId>;
    bookingProcess_CreateBooking(createBookingPortalRequest: CreateBookingPortalRequest): Observable<ResultId>;
    bookingProcess_UpdateBooking(updateBookingPortalRequest: UpdateBookingPortalRequest): Observable<ResultId>;
    bookingProcess_ValidateCouponCode(couponCode: string | null, bookingInfo: CouponCodeBookingPortalInfo): Observable<ResultDataOfCouponValidationPortalResponse>;
    bookingProcessDialog_GetDebugSettingsFormDialogView(debugSettings?: BookingRequestDialogDebugSettings | undefined): Observable<ResultDataOfRaxFormDialogView>;
    bookingProcessDialog_GetRequestDialogView(options: BookingRequestDialogOptions): Observable<ResultDataOfBookingRequestDialogView>;
    bookingProcessDialog_GetProgramStepPickerDialogView(fromDate: DateTime, programId: string | null): Observable<ResultDataOfProgramBookingProgramStepPickerDialogView>;
    bookingProcessDialog_GetRequestChangeDialogView(bookingId: string | null): Observable<ResultDataOfBookingRequestChangeDialogView>;
    bookingProcessDialog_GetRequestMoveDialogView(bookingId: string | null, moveRequest: ProgramStepMoveRequest): Observable<ResultDataOfBookingRequestChangeDialogView>;
    bookingProcessDialog_GetProgramAvailabilityInfo(programId: string | null): Observable<ResultDataOfProgramAvailabilityInfo>;
    bookingProcessDialog_GetProgramBookingOptions(fromDate: DateTime, programId: string | null): Observable<ResultDataOfProgramBookingOptions>;
    bookingProcessDialog_GetProgramBookingAvailabilityView(programAvailabilityRequest: ProgramAvailabilityRequest): Observable<ResultDataOfProgramBookingAvailabilityView>;
    bookingProposal_Patch(bookingProposalId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    bookingProposal_PatchObjects(objects: PatchObject[]): Observable<Result>;
    bookingProposal_Delete(bookingProposalId: string | null): Observable<ResultId>;
    bookingProposal_GetListView(): Observable<ResultDataOfBookingProposalListView>;
    bookingProposal_GetListItem(bookingProposalId: string | null): Observable<ResultDataOfBookingProposalListItem>;
    bookingProposal_GetEditItemView(bookingProposalId: string | null): Observable<ResultDataOfBookingProposalEditItemView>;
    bookingProposal_GetEditItem(bookingProposalId: string | null): Observable<ResultDataOfBookingProposalEditItem>;
    bookingProposal_ChangeStatus(statusChangeRequest: BookingProposalStatusChangeRequest): Observable<ResultId>;
    clients_DownloadAngularClient(): Observable<FileResponse>;
    cmsContentItem_Post(cmsContentItemPost: CmsContentItemPostRequest): Observable<ResultId>;
    cmsContentItem_Patch(cmsContentItemId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    cmsContentItem_Delete(cmsContentItemId: string | null): Observable<ResultId>;
    cmsContentItem_PatchVersion(cmsContentItemVersionId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    cmsContentPart_Post(cmsContentPart: CmsContentPartPostRequest): Observable<ResultId>;
    cmsContentPart_Patch(cmsContentPartId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    cmsContentPart_Delete(cmsContentPartId: string | null): Observable<ResultId>;
    cmsContentPart_GetAddDialogView(): Observable<ResultDataOfCmsContentPartAddDialogView>;
    cmsContentType_Post(cmsContentType: CmsContentTypePostRequest): Observable<ResultId>;
    cmsContentType_Patch(cmsContentTypeId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    cmsContentType_Delete(cmsContentTypeId: string | null): Observable<ResultId>;
    cmsContentType_GetAddDialogView(): Observable<ResultDataOfCmsContentTypeAddDialogView>;
    cms_GetFieldEditDialogView(cmsField?: CmsField | undefined): Observable<ResultDataOfCmsFieldEditDialogView>;
    cmsPage_Post(cmsPage: CmsPagePostRequest): Observable<ResultId>;
    cmsPage_Patch(cmsPageId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    cmsPage_Delete(cmsPageId: string | null): Observable<ResultId>;
    cmsPage_PatchVersion(cmsPageVersionId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    cmsSiteCheckOut_Post(cmsSiteCheckOut: CmsSiteCheckOutPostRequest): Observable<ResultId>;
    cmsSiteCheckOut_Patch(cmsSiteCheckOutId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    cmsSiteCheckOut_Delete(cmsSiteCheckOutId: string | null): Observable<ResultId>;
    cmsSiteCheckOut_GetAddDialogView(): Observable<ResultDataOfCmsSiteCheckOutAddDialogView>;
    cmsSite_Post(cmsSite: CmsSitePostRequest): Observable<ResultId>;
    cmsSite_Patch(cmsSiteId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    cmsSite_Delete(cmsSiteId: string | null): Observable<ResultId>;
    cmsSite_GetAddDialogView(): Observable<ResultDataOfCmsSiteAddDialogView>;
    cmsSite_GetTheme(): Observable<ResultDataOfString>;
    cmsSite_SetTheme(cmsThemeData: string): Observable<Result>;
    cmsSiteTheme_Post(cmsSiteTheme: CmsSiteThemePostRequest): Observable<ResultId>;
    cmsSiteTheme_Patch(cmsSiteThemeId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    cmsSiteTheme_Delete(cmsSiteThemeId: string | null): Observable<ResultId>;
    cmsSiteTheme_GetAddDialogView(): Observable<ResultDataOfCmsSiteThemeAddDialogView>;
    cmsSiteTheme_GetAddScriptTagSourceDialogView(): Observable<ResultDataOfCmsStyleScriptTagSourceAddDialogView>;
    cmsSiteTheme_GetAddFontDialogView(): Observable<ResultDataOfCmsStyleFontAddDialogView>;
    cmsSiteTheme_GetAddVariableDialogView(): Observable<ResultDataOfCmsStyleVariableAddDialogView>;
    cmsTemplate_Post(cmsTemplate: CmsTemplatePostRequest): Observable<ResultId>;
    cmsTemplate_Patch(cmsTemplateId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    cmsTemplate_Delete(cmsTemplateId: string | null): Observable<ResultId>;
    cmsTemplatePart_Post(cmsTemplatePart: CmsTemplatePartPostRequest): Observable<ResultId>;
    cmsTemplatePart_Patch(cmsTemplatePartId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    cmsTemplatePart_Delete(cmsTemplatePartId: string | null): Observable<ResultId>;
    couponCampaign_Post(couponCampaign: CouponCampaignPostRequest): Observable<ResultId>;
    couponCampaign_Patch(couponCampaignId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    couponCampaign_Delete(couponCampaignId: string | null): Observable<ResultId>;
    customer_Patch(customerId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    customer_PatchObjects(objects: PatchObject[]): Observable<Result>;
    customer_Delete(customerId: string | null): Observable<ResultId>;
    dev_GetDemoFormView(objectId: string | null): Observable<ResultDataOfRaxFormPageView>;
    dev_GetDemoFormDialogView(): Observable<ResultDataOfRaxFormDialogView>;
    dev_Patch(demoModelId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    dev_TimeSpanTest(helloWorldTimeSpan: Duration): Observable<boolean>;
    dev_TimeSpanTestBody(helloWorldTimeSpan: Duration, worldTimeModel: HelloWorldTimeModel): Observable<HelloWorldTimeModel>;
    emailSettings_PostForBookingSiteId(bookingSiteId: string | null): Observable<ResultId>;
    emailSettings_Patch(messageSettingsId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    emailTemplate_Post(emailTemplatePost: EmailTemplatePostRequest): Observable<ResultId>;
    emailTemplate_Patch(emailTemplateId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    emailTemplate_GetAddDialogView(): Observable<ResultDataOfEmailTemplateAddDialogView>;
    error_GetGET(): Observable<Result>;
    error_GetPATCH(): Observable<Result>;
    error_GetPOST(): Observable<Result>;
    error_GetPUT(): Observable<Result>;
    error_GetDELETE(): Observable<Result>;
    error_GetHEAD(): Observable<Result>;
    error_GetOPTIONS(): Observable<Result>;
    error_GetV2GET(status400: boolean): Observable<ResultV2DtoOfString>;
    error_GetV2PATCH(status400: boolean): Observable<ResultV2DtoOfString>;
    error_GetV2POST(status400: boolean): Observable<ResultV2DtoOfString>;
    error_GetV2PUT(status400: boolean): Observable<ResultV2DtoOfString>;
    error_GetV2DELETE(status400: boolean): Observable<ResultV2DtoOfString>;
    error_GetV2HEAD(status400: boolean): Observable<ResultV2DtoOfString>;
    error_GetV2OPTIONS(status400: boolean): Observable<ResultV2DtoOfString>;
    error_GetDetailsGET(): Observable<Result>;
    error_GetDetailsPATCH(): Observable<Result>;
    error_GetDetailsPOST(): Observable<Result>;
    error_GetDetailsPUT(): Observable<Result>;
    error_GetDetailsDELETE(): Observable<Result>;
    error_GetDetailsHEAD(): Observable<Result>;
    error_GetDetailsOPTIONS(): Observable<Result>;
    error_LogError(errorMessage: string): Observable<Result>;
    error_TriggerGraphError(): Observable<Result>;
    error_GetExceptionData(): Observable<ExceptionData>;
    feedback_Post(feedback: PortalFeedback): Observable<Result>;
    league_Post(league: LeaguePostRequest): Observable<ResultId>;
    league_Patch(leagueId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    league_PatchObjects(objects: PatchObject[]): Observable<Result>;
    league_Delete(leagueId: string | null): Observable<ResultId>;
    league_GetAddDialogView(): Observable<ResultDataOfLeagueAddDialogView>;
    league_GetSeasonAddDialogView(leagueId: string | null, sourceSeasonId?: string | null | undefined): Observable<ResultDataOfLeagueSeasonAddDialogView>;
    league_GetEditItemView(leagueId: string | null): Observable<ResultDataOfLeagueEditItemView>;
    league_GetEditItemSeasonView(leagueId: string | null, seasonId: string | null): Observable<ResultDataOfLeagueEditItemSeasonView>;
    league_TeamUpdatesRequest(leagueTeamUpdatesRequest: LeagueTeamUpdatesRequest): Observable<Result>;
    leagueMatchDateProcess_CreateMatchDates(createMatchDatesRequest: CreateMatchDatesRequest): Observable<Result>;
    leagueMatchDateProcess_UpdateMatchDateBookingsTeamOrder(orderUpdateRequest: MatchDateBookingsTeamOrderUpdateRequest): Observable<ResultId>;
    leagueMatchDateProcessDialog_GetRequestDialogView(options: MatchDatesRequestDialogOptions): Observable<ResultDataOfMatchDatesRequestDialogView>;
    leagueMatchDateProcessDialog_GetMatchDateBookingOptions(startTime: Duration, programId: string | null, leagueId: string | null, seasonId: string | null): Observable<ResultDataOfMatchDateBookingOptions>;
    leagueMatchDateProcessDialog_GetMatchDatesAvailabilityView(matchDatesAvailabilityRequest: MatchDatesAvailabilityRequest): Observable<ResultDataOfMatchDatesAvailabilityView>;
    locationBookingApproval_SetBookingApproval(bookingApprovalChangeRequest: LocationBookingApprovalChangeRequest): Observable<Result>;
    locationBookingConfirmationEmail_SetBookingConfirmationEmail(bookingConfirmationEmailChangeItem: LocationBookingConfirmationEmailChangeItem): Observable<ResultId>;
    locationBookingRefundProposal_GetCreateBookingRefundProposalDialogView(bookingId: string | null): Observable<ResultDataOfCreateBookingRefundProposalDialogView>;
    locationBookingRefundProposal_ProcessBookingRefundProposalApprovalDecisionBatch(processRefundApprovalRequest: BookingRefundProposalApprovalDecisionBatchRequest): Observable<Result>;
    locationBookingRefundProposal_GetBookingRefundProposalHistoryListPageView(): Observable<ResultDataOfBookingRefundProposalHistoryListPageView>;
    locationBookingRefundProposal_CreateBookingRefundProposalBatch(createBookingRefundProposalBatchRequest: CreateBookingRefundProposalBatchRequest): Observable<Result>;
    locationBookingRefundProposal_CreateBookingRefundProposal(createBookingRefundProposal: CreateBookingRefundProposalRequest): Observable<Result>;
    location_Post(location: LocationEditItem): Observable<ResultId>;
    location_Patch(locationId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    location_Delete(locationId: string | null): Observable<ResultId>;
    location_GetEditDialogView(locationId?: string | null | undefined): Observable<ResultDataOfLocationEditDialogView>;
    locationMarketingSocial_Patch(locationSettingsId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    locationSettingsAgeGroup_Post(ageGroup: LocationSettingsAgeGroupFormData): Observable<ResultId>;
    locationSettingsAgeGroup_Patch(ageGroupId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    locationSettingsAgeGroup_PatchObjects(objects: PatchObject[]): Observable<Result>;
    locationSettingsAgeGroup_Delete(ageGroupId: string | null): Observable<ResultId>;
    locationSettingsLocation_Patch(locationSettingsId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    locationSettingsLocation_GetTabsPageView(): Observable<ResultDataOfRaxTabsPageView>;
    locationSettingsMarketing_Patch(posSettingsId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    locationSettingsMarketing_GetMarketingView(): Observable<ResultDataOfLocationSettingsMarketingView>;
    locationSettingsMarketing_GetEmailMarketingView(): Observable<ResultDataOfLocationSettingsMarketingEmailMarketingView>;
    locationSettingsNoteList_Post(noteListFormData: LocationSettingsNoteListFormData): Observable<ResultId>;
    locationSettingsNoteList_Patch(noteListId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    locationSettingsNoteList_PatchObjects(objects: PatchObject[]): Observable<Result>;
    locationSettingsNoteList_Delete(noteListId: string | null): Observable<ResultId>;
    locationSettingsOverview_Post(overviewFormData: LocationSettingsOverviewFormData): Observable<ResultId>;
    locationSettingsOverview_Patch(overviewId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    locationSettingsOverview_PatchObjects(objects: PatchObject[]): Observable<Result>;
    locationSettingsOverview_Delete(overviewId: string | null): Observable<ResultId>;
    locationSettingsPayment_GetTabsPageView(): Observable<ResultDataOfRaxTabsPageView>;
    locationSettingsPayment_Patch(locationPaymentSettingsId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    locationSettingsPeriodConfig_Patch(periodConfigId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    locationSettingsPeriodConfig_PatchOpeningHourConfig(openingHourConfigId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    locationSettingsPos_Patch(posSettingsId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    locationSettingsPos_GetEditItemView(): Observable<ResultDataOfLocationSettingsPosEditItemView>;
    locationSettingsPos_GetPosSystemConfigPickerDialogView(): Observable<ResultDataOfPosSystemConfigPickerDialogView>;
    locationSettingsPos_GetDefaultSystemConfig(posSystemId: string | null, posSystemVersionId: string | null): Observable<ResultDataOfPosSystemConfig>;
    locationSettingsPos_ValidatePosSystemConfig(validationRequest: PosSystemConfigValidationRequestDto): Observable<Result>;
    locationSettingsResourceConfig_Patch(resourceConfigId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    locationSettingsResourceConfig_GetTabsPageView(): Observable<ResultDataOfRaxTabsPageView>;
    locationSettingsScheduleBoard_Post(scheduleBoard: LocationSettingsScheduleBoardPostRequest): Observable<ResultId>;
    locationSettingsScheduleBoard_Patch(scheduleBoardId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    locationSettingsScheduleBoard_PatchObjects(objects: PatchObject[]): Observable<Result>;
    locationSettingsScheduleBoard_Delete(scheduleBoardId: string | null): Observable<ResultId>;
    locationSettingsScheduleBoard_GetItemTabsPageView(scheduleBoardId: string | null): Observable<ResultDataOfRaxTabsPageView>;
    locationSettingsScheduleBoard_GetAddDialogView(): Observable<ResultDataOfLocationSettingsScheduleBoardAddDialogView>;
    locationSettingsScheduleBoard_GetViewModeOptionEditDialogView(viewModeOption?: ScheduleBoardGridViewModeOptions | undefined): Observable<ResultDataOfLocationSettingsScheduleBoardGridViewModeOptionEditDialogView>;
    locationSettingsSurveyQuestion_Post(surveyQuestionFormData: SurveyQuestionFormData): Observable<ResultId>;
    locationSettingsSurveyQuestion_Patch(surveyQuestionId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    locationSettingsSurveyQuestion_Delete(surveyQuestionId: string | null): Observable<ResultId>;
    locationSettingsUnit_Post(unit: LocationSettingsUnitFormData): Observable<ResultId>;
    locationSettingsUnit_Patch(unitId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    locationSettingsUnit_Delete(unitId: string | null): Observable<ResultId>;
    note_Post(note: NotePostRequest): Observable<ResultId>;
    note_Patch(noteId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    note_Delete(noteId: string | null): Observable<ResultId>;
    note_GetNoteTaskAddDialogView(dialogOptions: NoteTaskAddDialogOptions): Observable<ResultDataOfNoteAddDialogView>;
    note_GetNoteAddDialogView(dialogOptions: NoteAddDialogOptions): Observable<ResultDataOfNoteAddDialogView>;
    platformConfig_Post(platformConfig: PlatformConfigPostRequest): Observable<ResultId>;
    platformConfig_Patch(platformConfigId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    platformConfig_PatchObjects(objects: PatchObject[]): Observable<Result>;
    platformConfig_Delete(platformConfigId: string | null): Observable<ResultId>;
    platformConfig_SetActive(platformConfigId: string | null): Observable<ResultId>;
    platformConfig_GetAddDialogView(sourcePlatformConfigId?: string | null | undefined, sourcePlatformName?: string | null | undefined): Observable<ResultDataOfPlatformConfigAddDialogView>;
    platformConfig_GetEditItemView(platformConfigId: string | null): Observable<ResultDataOfPlatformConfigEditItemView>;
    platformConfig_GetEditItemPlannerView(platformConfigId: string | null): Observable<ResultDataOfPlatformConfigEditItemPlannerView>;
    platformConfig_GetPlannerMenuItemEditDialogView(menuItem?: MainPlannerNavMenuItem | undefined, isMainMenuItem?: boolean | undefined): Observable<ResultDataOfPlatformPlannerMenuItemEditDialogView>;
    platformConfig_GetEditItemFeatureFlagView(platformConfigId: string | null): Observable<ResultDataOfPlatformConfigEditItemFeatureFlagView>;
    platformConfig_GetEditItemSecurityView(platformConfigId: string | null): Observable<ResultDataOfPlatformConfigEditItemSecurityView>;
    platformConfig_GetSecurityTopicEditDialogView(topic?: PlatformSecurityTopic | undefined): Observable<ResultDataOfPlatformSecurityTopicEditDialogView>;
    platformConfig_GetSecurityActionEditDialogView(action?: PlatformSecurityAction | undefined, parentKey?: string | null | undefined): Observable<ResultDataOfPlatformSecurityActionEditDialogView>;
    platformConfig_GetSecurityRoleEditDialogView(role?: PlatformSecurityRole | undefined): Observable<ResultDataOfPlatformSecurityRoleEditDialogView>;
    platformConfig_GetSecurityGroupEditDialogView(group?: PlatformSecurityGroup | undefined): Observable<ResultDataOfPlatformSecurityGroupEditDialogView>;
    platformDebug_GetLocationInfo(locationId: string | null): Observable<ResultDataOfLocationInfo>;
    platformDebug_GetTenantInfo(tenantId: string | null): Observable<ResultDataOfTenantInfo>;
    posArticleConfig_Sync(): Observable<ResultId>;
    posArticleConfig_Patch(posArticleConfigId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    posArticleConfig_Delete(posArticleConfigId: string | null): Observable<ResultId>;
    posArticleConfig_SetActive(posArticleConfigId: string | null): Observable<ResultId>;
    product_Post(product: ProductPostRequest): Observable<ResultId>;
    product_Patch(productId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    product_PatchObjects(objects: PatchObject[]): Observable<Result>;
    product_Delete(productId: string | null): Observable<ResultId>;
    program_Post(program: ProgramPostRequest): Observable<ResultId>;
    program_Patch(programId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    program_PatchObjects(objects: PatchObject[]): Observable<Result>;
    program_Delete(programId: string | null): Observable<ResultId>;
    program_GetAddDialogView(): Observable<ResultDataOfProgramAddDialogView>;
    program_GetEditItemView(programId: string | null): Observable<ResultDataOfProgramEditItemView>;
    program_GetEditItemProgramStepsView(programId: string | null): Observable<ResultDataOfProgramEditItemProgramStepsView>;
    programGroup_Post(programGroup: ProgramGroupPostRequest): Observable<ResultId>;
    programGroup_Patch(programGroupId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    programGroup_PatchObjects(objects: PatchObject[]): Observable<Result>;
    programGroup_Delete(programGroupId: string | null): Observable<ResultId>;
    programStep_Post(programStep: ProgramStepPostRequest): Observable<ResultId>;
    programStep_Patch(programStepId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    programStep_PatchObjects(objects: PatchObject[]): Observable<Result>;
    programStep_Delete(programStepId: string | null): Observable<ResultId>;
    programStep_GetAddDialogView(): Observable<ResultDataOfProgramStepAddDialogView>;
    programStep_GetEditItemView(programStepId: string | null): Observable<ResultDataOfProgramStepEditItemView>;
    programStep_GetEditItemSurveyView(programStepId: string | null): Observable<ResultDataOfProgramStepEditItemSurveyView>;
    programStep_GetEditItemResourceView(programStepId: string | null): Observable<ResultDataOfProgramStepEditItemResourceView>;
    rateCard_Post(relatedObjectType: string | null, relatedObjectId: string | null, rateCard: RateCardEditDialogItem): Observable<ResultId>;
    rateCard_Patch(rateCardId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    rateCard_Delete(rateCardId: string | null): Observable<ResultId>;
    rateCard_Duplicate(sourceRateCardId: string | null, newRateCardName: string | null): Observable<ResultId>;
    rateCard_SetActive(rateCardId: string | null): Observable<ResultId>;
    rateCardPeriodConfig_Post(relatedObjectType: string | null, relatedObjectId: string | null): Observable<ResultId>;
    rateCardPeriodConfig_Patch(rateCardPeriodConfigId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    rateCardPeriodConfig_Delete(rateCardPeriodConfigId: string | null): Observable<ResultId>;
    tenant_Post(tenant: TenantEditItem): Observable<ResultId>;
    tenant_Patch(tenantId: string | null, operations: PatchOperation[]): Observable<ResultId>;
    tenant_Delete(tenantId: string | null): Observable<ResultId>;
    utils_GetGuid(): Observable<string>;
}

@Injectable()
export class Client extends BookerPlannerBffClientBase implements IClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        super();
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    utils_GetAddressLookup(query: GetAddressLookupQuery): Observable<AddressLookupResult> {
        let url_ = this.baseUrl + "/Utils/GetAddressLookup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUtils_GetAddressLookup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUtils_GetAddressLookup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddressLookupResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddressLookupResult>;
        }));
    }

    protected processUtils_GetAddressLookup(response: HttpResponseBase): Observable<AddressLookupResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddressLookupResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddressLookupResult>(null as any);
    }

    translation_GetLocationTranslationCoverage(): Observable<GetLocationTranslationCoverageQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Translation/GetLocationTranslationCoverage";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processTranslation_GetLocationTranslationCoverage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTranslation_GetLocationTranslationCoverage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationTranslationCoverageQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationTranslationCoverageQueryResult>;
        }));
    }

    protected processTranslation_GetLocationTranslationCoverage(response: HttpResponseBase): Observable<GetLocationTranslationCoverageQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationTranslationCoverageQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationTranslationCoverageQueryResult>(null as any);
    }

    translation_ApplyTranslations(command: ApplyTranslationsCommand): Observable<ApplyTranslationsCommandResult> {
        let url_ = this.baseUrl + "/api/cqrs/Translation/ApplyTranslations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processTranslation_ApplyTranslations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTranslation_ApplyTranslations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplyTranslationsCommandResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplyTranslationsCommandResult>;
        }));
    }

    protected processTranslation_ApplyTranslations(response: HttpResponseBase): Observable<ApplyTranslationsCommandResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApplyTranslationsCommandResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApplyTranslationsCommandResult>(null as any);
    }

    textMessaging_SyncWhatsAppTemplates(): Observable<WhatsAppConnection> {
        let url_ = this.baseUrl + "/api/cqrs/TextMessaging/SyncWhatsAppTemplates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processTextMessaging_SyncWhatsAppTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTextMessaging_SyncWhatsAppTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WhatsAppConnection>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WhatsAppConnection>;
        }));
    }

    protected processTextMessaging_SyncWhatsAppTemplates(response: HttpResponseBase): Observable<WhatsAppConnection> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WhatsAppConnection;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WhatsAppConnection>(null as any);
    }

    textMessaging_SetWhatsAppTestPhoneNumber(command: SetWhatsAppTestPhoneNumberCommand): Observable<WhatsAppConnection> {
        let url_ = this.baseUrl + "/api/cqrs/TextMessaging/SetWhatsAppTestPhoneNumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processTextMessaging_SetWhatsAppTestPhoneNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTextMessaging_SetWhatsAppTestPhoneNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WhatsAppConnection>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WhatsAppConnection>;
        }));
    }

    protected processTextMessaging_SetWhatsAppTestPhoneNumber(response: HttpResponseBase): Observable<WhatsAppConnection> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WhatsAppConnection;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WhatsAppConnection>(null as any);
    }

    textMessaging_SendTestTextMessage(command: SendTestTextMessageCommand): Observable<OutboundTextMessage> {
        let url_ = this.baseUrl + "/api/cqrs/TextMessaging/SendTestTextMessage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processTextMessaging_SendTestTextMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTextMessaging_SendTestTextMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutboundTextMessage>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutboundTextMessage>;
        }));
    }

    protected processTextMessaging_SendTestTextMessage(response: HttpResponseBase): Observable<OutboundTextMessage> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OutboundTextMessage;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OutboundTextMessage>(null as any);
    }

    textMessaging_RetryWhatsAppSignup(command: RetryWhatsAppSignupCommand): Observable<WhatsAppConnection> {
        let url_ = this.baseUrl + "/api/cqrs/TextMessaging/RetryWhatsAppSignup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processTextMessaging_RetryWhatsAppSignup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTextMessaging_RetryWhatsAppSignup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WhatsAppConnection>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WhatsAppConnection>;
        }));
    }

    protected processTextMessaging_RetryWhatsAppSignup(response: HttpResponseBase): Observable<WhatsAppConnection> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WhatsAppConnection;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WhatsAppConnection>(null as any);
    }

    textMessaging_GetWhatsAppSignupConfig(): Observable<GetWhatsAppSignupConfigQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/TextMessaging/GetWhatsAppSignupConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processTextMessaging_GetWhatsAppSignupConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTextMessaging_GetWhatsAppSignupConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetWhatsAppSignupConfigQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetWhatsAppSignupConfigQueryResult>;
        }));
    }

    protected processTextMessaging_GetWhatsAppSignupConfig(response: HttpResponseBase): Observable<GetWhatsAppSignupConfigQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetWhatsAppSignupConfigQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetWhatsAppSignupConfigQueryResult>(null as any);
    }

    textMessaging_GetWhatsAppConnection(): Observable<WhatsAppConnection> {
        let url_ = this.baseUrl + "/api/cqrs/TextMessaging/GetWhatsAppConnection";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processTextMessaging_GetWhatsAppConnection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTextMessaging_GetWhatsAppConnection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WhatsAppConnection>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WhatsAppConnection>;
        }));
    }

    protected processTextMessaging_GetWhatsAppConnection(response: HttpResponseBase): Observable<WhatsAppConnection> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WhatsAppConnection;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WhatsAppConnection>(null as any);
    }

    textMessaging_GetRecentOutboundTextMessages(query: GetRecentOutboundTextMessagesQuery): Observable<GetRecentOutboundTextMessagesQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/TextMessaging/GetRecentOutboundTextMessages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processTextMessaging_GetRecentOutboundTextMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTextMessaging_GetRecentOutboundTextMessages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRecentOutboundTextMessagesQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRecentOutboundTextMessagesQueryResult>;
        }));
    }

    protected processTextMessaging_GetRecentOutboundTextMessages(response: HttpResponseBase): Observable<GetRecentOutboundTextMessagesQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetRecentOutboundTextMessagesQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRecentOutboundTextMessagesQueryResult>(null as any);
    }

    textMessaging_DisconnectWhatsApp(): Observable<WhatsAppConnection> {
        let url_ = this.baseUrl + "/api/cqrs/TextMessaging/DisconnectWhatsApp";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processTextMessaging_DisconnectWhatsApp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTextMessaging_DisconnectWhatsApp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WhatsAppConnection>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WhatsAppConnection>;
        }));
    }

    protected processTextMessaging_DisconnectWhatsApp(response: HttpResponseBase): Observable<WhatsAppConnection> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WhatsAppConnection;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WhatsAppConnection>(null as any);
    }

    textMessaging_CompleteWhatsAppSignup(command: CompleteWhatsAppSignupCommand): Observable<WhatsAppConnection> {
        let url_ = this.baseUrl + "/api/cqrs/TextMessaging/CompleteWhatsAppSignup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processTextMessaging_CompleteWhatsAppSignup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTextMessaging_CompleteWhatsAppSignup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WhatsAppConnection>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WhatsAppConnection>;
        }));
    }

    protected processTextMessaging_CompleteWhatsAppSignup(response: HttpResponseBase): Observable<WhatsAppConnection> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WhatsAppConnection;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WhatsAppConnection>(null as any);
    }

    tenant_GetTenantEditDialogView(query: GetTenantEditDialogViewQuery): Observable<GetTenantEditDialogViewQueryResult> {
        let url_ = this.baseUrl + "/Tenant/GetTenantEditDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processTenant_GetTenantEditDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTenant_GetTenantEditDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTenantEditDialogViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTenantEditDialogViewQueryResult>;
        }));
    }

    protected processTenant_GetTenantEditDialogView(response: HttpResponseBase): Observable<GetTenantEditDialogViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetTenantEditDialogViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTenantEditDialogViewQueryResult>(null as any);
    }

    tenant_CheckTenantIdCode(query: CheckTenantIdCodeQuery): Observable<CheckTenantIdCodeQueryResult> {
        let url_ = this.baseUrl + "/Tenant/CheckTenantIdCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processTenant_CheckTenantIdCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTenant_CheckTenantIdCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckTenantIdCodeQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckTenantIdCodeQueryResult>;
        }));
    }

    protected processTenant_CheckTenantIdCode(response: HttpResponseBase): Observable<CheckTenantIdCodeQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CheckTenantIdCodeQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CheckTenantIdCodeQueryResult>(null as any);
    }

    tenantUsers_UpdateTenantUser(command: UpdateTenantUserCommand): Observable<UpdateTenantUserCommandResult> {
        let url_ = this.baseUrl + "/api/cqrs/TenantUsers/UpdateTenantUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processTenantUsers_UpdateTenantUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTenantUsers_UpdateTenantUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateTenantUserCommandResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateTenantUserCommandResult>;
        }));
    }

    protected processTenantUsers_UpdateTenantUser(response: HttpResponseBase): Observable<UpdateTenantUserCommandResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdateTenantUserCommandResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateTenantUserCommandResult>(null as any);
    }

    tenantUsers_RemoveTenantUser(command: RemoveTenantUserCommand): Observable<RemoveTenantUserCommandResult> {
        let url_ = this.baseUrl + "/api/cqrs/TenantUsers/RemoveTenantUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processTenantUsers_RemoveTenantUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTenantUsers_RemoveTenantUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RemoveTenantUserCommandResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RemoveTenantUserCommandResult>;
        }));
    }

    protected processTenantUsers_RemoveTenantUser(response: HttpResponseBase): Observable<RemoveTenantUserCommandResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RemoveTenantUserCommandResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RemoveTenantUserCommandResult>(null as any);
    }

    tenantUsers_GetTenantUsers(): Observable<GetTenantUsersQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/TenantUsers/GetTenantUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processTenantUsers_GetTenantUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTenantUsers_GetTenantUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTenantUsersQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTenantUsersQueryResult>;
        }));
    }

    protected processTenantUsers_GetTenantUsers(response: HttpResponseBase): Observable<GetTenantUsersQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetTenantUsersQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTenantUsersQueryResult>(null as any);
    }

    tenantUsers_GetTenantUserEditItem(query: GetTenantUserEditItemQuery): Observable<GetTenantUserEditItemQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/TenantUsers/GetTenantUserEditItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processTenantUsers_GetTenantUserEditItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTenantUsers_GetTenantUserEditItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTenantUserEditItemQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTenantUserEditItemQueryResult>;
        }));
    }

    protected processTenantUsers_GetTenantUserEditItem(response: HttpResponseBase): Observable<GetTenantUserEditItemQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetTenantUserEditItemQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTenantUserEditItemQueryResult>(null as any);
    }

    tenantUsers_GetTenantUserAliasAddDialog(): Observable<GetTenantUserAliasAddDialogQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/TenantUsers/GetTenantUserAliasAddDialog";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processTenantUsers_GetTenantUserAliasAddDialog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTenantUsers_GetTenantUserAliasAddDialog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTenantUserAliasAddDialogQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTenantUserAliasAddDialogQueryResult>;
        }));
    }

    protected processTenantUsers_GetTenantUserAliasAddDialog(response: HttpResponseBase): Observable<GetTenantUserAliasAddDialogQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetTenantUserAliasAddDialogQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTenantUserAliasAddDialogQueryResult>(null as any);
    }

    tenantUsers_GetTenantUserAddDialog(): Observable<GetTenantUserAddDialogQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/TenantUsers/GetTenantUserAddDialog";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processTenantUsers_GetTenantUserAddDialog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTenantUsers_GetTenantUserAddDialog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTenantUserAddDialogQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTenantUserAddDialogQueryResult>;
        }));
    }

    protected processTenantUsers_GetTenantUserAddDialog(response: HttpResponseBase): Observable<GetTenantUserAddDialogQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetTenantUserAddDialogQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTenantUserAddDialogQueryResult>(null as any);
    }

    tenantUsers_AddTenantUsers(command: AddTenantUsersCommand): Observable<AddTenantUsersCommandResult> {
        let url_ = this.baseUrl + "/api/cqrs/TenantUsers/AddTenantUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processTenantUsers_AddTenantUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTenantUsers_AddTenantUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddTenantUsersCommandResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddTenantUsersCommandResult>;
        }));
    }

    protected processTenantUsers_AddTenantUsers(response: HttpResponseBase): Observable<AddTenantUsersCommandResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddTenantUsersCommandResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddTenantUsersCommandResult>(null as any);
    }

    selfService_UpdateSelfServiceSettings(command: UpdateSelfServiceSettingsCommand): Observable<void> {
        let url_ = this.baseUrl + "/SelfService/UpdateSelfServiceSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSelfService_UpdateSelfServiceSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelfService_UpdateSelfServiceSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSelfService_UpdateSelfServiceSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    selfService_UpdateSelfServiceRuleSettings(command: UpdateSelfServiceRuleSettingsCommand): Observable<void> {
        let url_ = this.baseUrl + "/SelfService/UpdateSelfServiceRuleSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSelfService_UpdateSelfServiceRuleSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelfService_UpdateSelfServiceRuleSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSelfService_UpdateSelfServiceRuleSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    selfService_UpdateProgramSelfServiceOverrides(command: UpdateProgramSelfServiceOverridesCommand): Observable<void> {
        let url_ = this.baseUrl + "/SelfService/UpdateProgramSelfServiceOverrides";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSelfService_UpdateProgramSelfServiceOverrides(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelfService_UpdateProgramSelfServiceOverrides(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSelfService_UpdateProgramSelfServiceOverrides(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    selfService_MigrateLocationSelfServiceRules(command: MigrateLocationSelfServiceRulesCommand): Observable<void> {
        let url_ = this.baseUrl + "/SelfService/MigrateLocationSelfServiceRules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSelfService_MigrateLocationSelfServiceRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelfService_MigrateLocationSelfServiceRules(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSelfService_MigrateLocationSelfServiceRules(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    selfService_GetSelfServiceSettings(query: GetSelfServiceSettingsQuery): Observable<GetSelfServiceSettingsQueryResult> {
        let url_ = this.baseUrl + "/SelfService/GetSelfServiceSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSelfService_GetSelfServiceSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelfService_GetSelfServiceSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSelfServiceSettingsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSelfServiceSettingsQueryResult>;
        }));
    }

    protected processSelfService_GetSelfServiceSettings(response: HttpResponseBase): Observable<GetSelfServiceSettingsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetSelfServiceSettingsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSelfServiceSettingsQueryResult>(null as any);
    }

    selfService_GetSelfServiceRuleSettings(query: GetSelfServiceRuleSettingsQuery): Observable<GetSelfServiceRuleSettingsQueryResult> {
        let url_ = this.baseUrl + "/SelfService/GetSelfServiceRuleSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSelfService_GetSelfServiceRuleSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelfService_GetSelfServiceRuleSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSelfServiceRuleSettingsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSelfServiceRuleSettingsQueryResult>;
        }));
    }

    protected processSelfService_GetSelfServiceRuleSettings(response: HttpResponseBase): Observable<GetSelfServiceRuleSettingsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetSelfServiceRuleSettingsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSelfServiceRuleSettingsQueryResult>(null as any);
    }

    selfService_GetSelfServiceProgramDeviations(query: GetSelfServiceProgramDeviationsQuery): Observable<GetSelfServiceProgramDeviationsQueryResult> {
        let url_ = this.baseUrl + "/SelfService/GetSelfServiceProgramDeviations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSelfService_GetSelfServiceProgramDeviations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelfService_GetSelfServiceProgramDeviations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSelfServiceProgramDeviationsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSelfServiceProgramDeviationsQueryResult>;
        }));
    }

    protected processSelfService_GetSelfServiceProgramDeviations(response: HttpResponseBase): Observable<GetSelfServiceProgramDeviationsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetSelfServiceProgramDeviationsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSelfServiceProgramDeviationsQueryResult>(null as any);
    }

    selfService_GetSelfServiceOverrideSummary(query: GetSelfServiceOverrideSummaryQuery): Observable<GetSelfServiceOverrideSummaryQueryResult> {
        let url_ = this.baseUrl + "/SelfService/GetSelfServiceOverrideSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSelfService_GetSelfServiceOverrideSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelfService_GetSelfServiceOverrideSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSelfServiceOverrideSummaryQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSelfServiceOverrideSummaryQueryResult>;
        }));
    }

    protected processSelfService_GetSelfServiceOverrideSummary(response: HttpResponseBase): Observable<GetSelfServiceOverrideSummaryQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetSelfServiceOverrideSummaryQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSelfServiceOverrideSummaryQueryResult>(null as any);
    }

    selfService_GetProgramSelfServiceOverrides(query: GetProgramSelfServiceOverridesQuery): Observable<GetProgramSelfServiceOverridesQueryResult> {
        let url_ = this.baseUrl + "/SelfService/GetProgramSelfServiceOverrides";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSelfService_GetProgramSelfServiceOverrides(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSelfService_GetProgramSelfServiceOverrides(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProgramSelfServiceOverridesQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProgramSelfServiceOverridesQueryResult>;
        }));
    }

    protected processSelfService_GetProgramSelfServiceOverrides(response: HttpResponseBase): Observable<GetProgramSelfServiceOverridesQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProgramSelfServiceOverridesQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProgramSelfServiceOverridesQueryResult>(null as any);
    }

    security_UpdateSecurityGroup(command: UpdateSecurityGroupCommand): Observable<UpdateSecurityGroupCommandResult> {
        let url_ = this.baseUrl + "/api/cqrs/Security/UpdateSecurityGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSecurity_UpdateSecurityGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSecurity_UpdateSecurityGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateSecurityGroupCommandResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateSecurityGroupCommandResult>;
        }));
    }

    protected processSecurity_UpdateSecurityGroup(response: HttpResponseBase): Observable<UpdateSecurityGroupCommandResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdateSecurityGroupCommandResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateSecurityGroupCommandResult>(null as any);
    }

    security_RemoveSecurityGroupMember(command: RemoveSecurityGroupMemberCommand): Observable<RemoveSecurityGroupMemberCommandResult> {
        let url_ = this.baseUrl + "/api/cqrs/Security/RemoveSecurityGroupMember";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSecurity_RemoveSecurityGroupMember(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSecurity_RemoveSecurityGroupMember(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RemoveSecurityGroupMemberCommandResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RemoveSecurityGroupMemberCommandResult>;
        }));
    }

    protected processSecurity_RemoveSecurityGroupMember(response: HttpResponseBase): Observable<RemoveSecurityGroupMemberCommandResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RemoveSecurityGroupMemberCommandResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RemoveSecurityGroupMemberCommandResult>(null as any);
    }

    security_GetSecurityUserListView(query: GetSecurityUserListViewQuery): Observable<GetSecurityUserListViewResult> {
        let url_ = this.baseUrl + "/api/cqrs/Security/GetSecurityUserListView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSecurity_GetSecurityUserListView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSecurity_GetSecurityUserListView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSecurityUserListViewResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSecurityUserListViewResult>;
        }));
    }

    protected processSecurity_GetSecurityUserListView(response: HttpResponseBase): Observable<GetSecurityUserListViewResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetSecurityUserListViewResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSecurityUserListViewResult>(null as any);
    }

    security_GetSecurityUserEditItemView(query: GetSecurityUserEditItemViewQuery): Observable<GetSecurityUserEditItemViewResult> {
        let url_ = this.baseUrl + "/api/cqrs/Security/GetSecurityUserEditItemView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSecurity_GetSecurityUserEditItemView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSecurity_GetSecurityUserEditItemView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSecurityUserEditItemViewResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSecurityUserEditItemViewResult>;
        }));
    }

    protected processSecurity_GetSecurityUserEditItemView(response: HttpResponseBase): Observable<GetSecurityUserEditItemViewResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetSecurityUserEditItemViewResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSecurityUserEditItemViewResult>(null as any);
    }

    security_GetSecurityNavigation(query: GetSecurityNavigationQuery): Observable<GetSecurityNavigationResult> {
        let url_ = this.baseUrl + "/api/cqrs/Security/GetSecurityNavigation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSecurity_GetSecurityNavigation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSecurity_GetSecurityNavigation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSecurityNavigationResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSecurityNavigationResult>;
        }));
    }

    protected processSecurity_GetSecurityNavigation(response: HttpResponseBase): Observable<GetSecurityNavigationResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetSecurityNavigationResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSecurityNavigationResult>(null as any);
    }

    security_GetSecurityGroupMembersAddDialogView(query: GetSecurityGroupMembersAddDialogViewQuery): Observable<GetSecurityGroupMembersAddDialogViewResult> {
        let url_ = this.baseUrl + "/api/cqrs/Security/GetSecurityGroupMembersAddDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSecurity_GetSecurityGroupMembersAddDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSecurity_GetSecurityGroupMembersAddDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSecurityGroupMembersAddDialogViewResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSecurityGroupMembersAddDialogViewResult>;
        }));
    }

    protected processSecurity_GetSecurityGroupMembersAddDialogView(response: HttpResponseBase): Observable<GetSecurityGroupMembersAddDialogViewResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetSecurityGroupMembersAddDialogViewResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSecurityGroupMembersAddDialogViewResult>(null as any);
    }

    security_GetSecurityGroupListView(query: GetSecurityGroupListViewQuery): Observable<GetSecurityGroupListViewResult> {
        let url_ = this.baseUrl + "/api/cqrs/Security/GetSecurityGroupListView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSecurity_GetSecurityGroupListView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSecurity_GetSecurityGroupListView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSecurityGroupListViewResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSecurityGroupListViewResult>;
        }));
    }

    protected processSecurity_GetSecurityGroupListView(response: HttpResponseBase): Observable<GetSecurityGroupListViewResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetSecurityGroupListViewResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSecurityGroupListViewResult>(null as any);
    }

    security_GetSecurityGroupEditItemView(query: GetSecurityGroupEditItemViewQuery): Observable<GetSecurityGroupEditItemViewResult> {
        let url_ = this.baseUrl + "/api/cqrs/Security/GetSecurityGroupEditItemView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSecurity_GetSecurityGroupEditItemView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSecurity_GetSecurityGroupEditItemView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSecurityGroupEditItemViewResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSecurityGroupEditItemViewResult>;
        }));
    }

    protected processSecurity_GetSecurityGroupEditItemView(response: HttpResponseBase): Observable<GetSecurityGroupEditItemViewResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetSecurityGroupEditItemViewResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSecurityGroupEditItemViewResult>(null as any);
    }

    security_GetSecurityGroupEditItemRolesView(query: GetSecurityGroupEditItemRolesViewQuery): Observable<GetSecurityGroupEditItemRolesViewResult> {
        let url_ = this.baseUrl + "/api/cqrs/Security/GetSecurityGroupEditItemRolesView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSecurity_GetSecurityGroupEditItemRolesView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSecurity_GetSecurityGroupEditItemRolesView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSecurityGroupEditItemRolesViewResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSecurityGroupEditItemRolesViewResult>;
        }));
    }

    protected processSecurity_GetSecurityGroupEditItemRolesView(response: HttpResponseBase): Observable<GetSecurityGroupEditItemRolesViewResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetSecurityGroupEditItemRolesViewResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSecurityGroupEditItemRolesViewResult>(null as any);
    }

    security_GetSecurityGroupAddDialogView(query: GetSecurityGroupAddDialogViewQuery): Observable<GetSecurityGroupAddDialogViewResult> {
        let url_ = this.baseUrl + "/api/cqrs/Security/GetSecurityGroupAddDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSecurity_GetSecurityGroupAddDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSecurity_GetSecurityGroupAddDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSecurityGroupAddDialogViewResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSecurityGroupAddDialogViewResult>;
        }));
    }

    protected processSecurity_GetSecurityGroupAddDialogView(response: HttpResponseBase): Observable<GetSecurityGroupAddDialogViewResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetSecurityGroupAddDialogViewResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSecurityGroupAddDialogViewResult>(null as any);
    }

    security_DeleteSecurityGroup(command: DeleteSecurityGroupCommand): Observable<DeleteSecurityGroupCommandResult> {
        let url_ = this.baseUrl + "/api/cqrs/Security/DeleteSecurityGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSecurity_DeleteSecurityGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSecurity_DeleteSecurityGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteSecurityGroupCommandResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteSecurityGroupCommandResult>;
        }));
    }

    protected processSecurity_DeleteSecurityGroup(response: HttpResponseBase): Observable<DeleteSecurityGroupCommandResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeleteSecurityGroupCommandResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteSecurityGroupCommandResult>(null as any);
    }

    security_CreateSecurityGroup(command: CreateSecurityGroupCommand): Observable<CreateSecurityGroupCommandResult> {
        let url_ = this.baseUrl + "/api/cqrs/Security/CreateSecurityGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSecurity_CreateSecurityGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSecurity_CreateSecurityGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateSecurityGroupCommandResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateSecurityGroupCommandResult>;
        }));
    }

    protected processSecurity_CreateSecurityGroup(response: HttpResponseBase): Observable<CreateSecurityGroupCommandResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateSecurityGroupCommandResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateSecurityGroupCommandResult>(null as any);
    }

    security_AddSecurityGroupMembers(command: AddSecurityGroupMembersCommand): Observable<AddSecurityGroupMembersCommandResult> {
        let url_ = this.baseUrl + "/api/cqrs/Security/AddSecurityGroupMembers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processSecurity_AddSecurityGroupMembers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSecurity_AddSecurityGroupMembers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddSecurityGroupMembersCommandResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddSecurityGroupMembersCommandResult>;
        }));
    }

    protected processSecurity_AddSecurityGroupMembers(response: HttpResponseBase): Observable<AddSecurityGroupMembersCommandResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddSecurityGroupMembersCommandResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddSecurityGroupMembersCommandResult>(null as any);
    }

    reporting_GetUpsell(query: GetUpsellQuery): Observable<GetUpsellQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Reporting/Upsell/GetUpsell";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processReporting_GetUpsell(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReporting_GetUpsell(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUpsellQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUpsellQueryResult>;
        }));
    }

    protected processReporting_GetUpsell(response: HttpResponseBase): Observable<GetUpsellQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetUpsellQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUpsellQueryResult>(null as any);
    }

    /**
     * @return The generated file.
     */
    reporting_ExportUpsellExcel(query: GetUpsellQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Reporting/Upsell/ExportUpsellExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processReporting_ExportUpsellExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReporting_ExportUpsellExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processReporting_ExportUpsellExcel(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    reporting_GetResourceUtilization(query: GetResourceUtilizationQuery): Observable<GetResourceUtilizationQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Reporting/ResourceUtilization/GetResourceUtilization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processReporting_GetResourceUtilization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReporting_GetResourceUtilization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetResourceUtilizationQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetResourceUtilizationQueryResult>;
        }));
    }

    protected processReporting_GetResourceUtilization(response: HttpResponseBase): Observable<GetResourceUtilizationQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetResourceUtilizationQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetResourceUtilizationQueryResult>(null as any);
    }

    reporting_GetProgramRevenue(query: GetProgramRevenueQuery): Observable<GetProgramRevenueQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Reporting/ProgramRevenue/GetProgramRevenue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processReporting_GetProgramRevenue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReporting_GetProgramRevenue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProgramRevenueQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProgramRevenueQueryResult>;
        }));
    }

    protected processReporting_GetProgramRevenue(response: HttpResponseBase): Observable<GetProgramRevenueQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProgramRevenueQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProgramRevenueQueryResult>(null as any);
    }

    /**
     * @return The generated file.
     */
    reporting_ExportProgramRevenueExcel(query: GetProgramRevenueQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Reporting/ProgramRevenue/ExportProgramRevenueExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processReporting_ExportProgramRevenueExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReporting_ExportProgramRevenueExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processReporting_ExportProgramRevenueExcel(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    reporting_GetProductSales(query: GetProductSalesQuery): Observable<GetProductSalesQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Reporting/ProductSales/GetProductSales";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processReporting_GetProductSales(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReporting_GetProductSales(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProductSalesQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProductSalesQueryResult>;
        }));
    }

    protected processReporting_GetProductSales(response: HttpResponseBase): Observable<GetProductSalesQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProductSalesQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProductSalesQueryResult>(null as any);
    }

    /**
     * @return The generated file.
     */
    reporting_ExportProductSalesExcel(query: GetProductSalesQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Reporting/ProductSales/ExportProductSalesExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processReporting_ExportProductSalesExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReporting_ExportProductSalesExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processReporting_ExportProductSalesExcel(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    reporting_GetOnlinePayments(query: GetOnlinePaymentsQuery): Observable<GetOnlinePaymentsQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Reporting/OnlinePayments/GetOnlinePayments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processReporting_GetOnlinePayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReporting_GetOnlinePayments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOnlinePaymentsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOnlinePaymentsQueryResult>;
        }));
    }

    protected processReporting_GetOnlinePayments(response: HttpResponseBase): Observable<GetOnlinePaymentsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetOnlinePaymentsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOnlinePaymentsQueryResult>(null as any);
    }

    /**
     * @return The generated file.
     */
    reporting_ExportOnlinePaymentsExcel(query: GetOnlinePaymentsQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Reporting/OnlinePayments/ExportOnlinePaymentsExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processReporting_ExportOnlinePaymentsExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReporting_ExportOnlinePaymentsExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processReporting_ExportOnlinePaymentsExcel(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    reporting_GetLostRevenue(query: GetLostRevenueQuery): Observable<GetLostRevenueQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Reporting/LostRevenue/GetLostRevenue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processReporting_GetLostRevenue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReporting_GetLostRevenue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLostRevenueQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLostRevenueQueryResult>;
        }));
    }

    protected processReporting_GetLostRevenue(response: HttpResponseBase): Observable<GetLostRevenueQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLostRevenueQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLostRevenueQueryResult>(null as any);
    }

    /**
     * @return The generated file.
     */
    reporting_ExportLostRevenueExcel(query: GetLostRevenueQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Reporting/LostRevenue/ExportLostRevenueExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processReporting_ExportLostRevenueExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReporting_ExportLostRevenueExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processReporting_ExportLostRevenueExcel(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    reporting_GetLocationOverviewNewBookings(query: GetLocationOverviewBookingsQuery): Observable<GetLocationOverviewBookingsQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Reporting/LocationOverviews/GetLocationOverviewNewBookings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processReporting_GetLocationOverviewNewBookings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReporting_GetLocationOverviewNewBookings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationOverviewBookingsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationOverviewBookingsQueryResult>;
        }));
    }

    protected processReporting_GetLocationOverviewNewBookings(response: HttpResponseBase): Observable<GetLocationOverviewBookingsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationOverviewBookingsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationOverviewBookingsQueryResult>(null as any);
    }

    reporting_GetLocationOverviewMolliePriceLineItems(query: GetLocationOverviewMolliePriceLineItemsQuery): Observable<MolliePriceLineItemsQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Reporting/LocationOverviews/GetLocationOverviewMolliePriceLineItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processReporting_GetLocationOverviewMolliePriceLineItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReporting_GetLocationOverviewMolliePriceLineItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MolliePriceLineItemsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MolliePriceLineItemsQueryResult>;
        }));
    }

    protected processReporting_GetLocationOverviewMolliePriceLineItems(response: HttpResponseBase): Observable<MolliePriceLineItemsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MolliePriceLineItemsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MolliePriceLineItemsQueryResult>(null as any);
    }

    reporting_GetLocationOverviewMolliePayments(query: GetLocationOverviewMolliePaymentsQuery): Observable<MolliePaymentsQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Reporting/LocationOverviews/GetLocationOverviewMolliePayments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processReporting_GetLocationOverviewMolliePayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReporting_GetLocationOverviewMolliePayments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MolliePaymentsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MolliePaymentsQueryResult>;
        }));
    }

    protected processReporting_GetLocationOverviewMolliePayments(response: HttpResponseBase): Observable<MolliePaymentsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MolliePaymentsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MolliePaymentsQueryResult>(null as any);
    }

    reporting_GetLocationOverviewMollieFuturePrePaidAmount(query: GetLocationOverviewMollieFuturePrePaidAmountQuery): Observable<MollieFuturePrePaidAmountQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Reporting/LocationOverviews/GetLocationOverviewMollieFuturePrePaidAmount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processReporting_GetLocationOverviewMollieFuturePrePaidAmount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReporting_GetLocationOverviewMollieFuturePrePaidAmount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MollieFuturePrePaidAmountQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MollieFuturePrePaidAmountQueryResult>;
        }));
    }

    protected processReporting_GetLocationOverviewMollieFuturePrePaidAmount(response: HttpResponseBase): Observable<MollieFuturePrePaidAmountQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MollieFuturePrePaidAmountQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MollieFuturePrePaidAmountQueryResult>(null as any);
    }

    reporting_GetLocationOverviewMollieCancelledBookingPayments(query: GetLocationOverviewMollieCancelledBookingPaymentsQuery): Observable<MollieCancelledBookingPaymentsQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Reporting/LocationOverviews/GetLocationOverviewMollieCancelledBookingPayments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processReporting_GetLocationOverviewMollieCancelledBookingPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReporting_GetLocationOverviewMollieCancelledBookingPayments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MollieCancelledBookingPaymentsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MollieCancelledBookingPaymentsQueryResult>;
        }));
    }

    protected processReporting_GetLocationOverviewMollieCancelledBookingPayments(response: HttpResponseBase): Observable<MollieCancelledBookingPaymentsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MollieCancelledBookingPaymentsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MollieCancelledBookingPaymentsQueryResult>(null as any);
    }

    reporting_GetLocationOverviewDayPlanning(query: GetLocationOverviewDayPlanningQuery): Observable<GetLocationOverviewDayPlanningView> {
        let url_ = this.baseUrl + "/api/cqrs/Reporting/LocationOverviews/GetLocationOverviewDayPlanning";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processReporting_GetLocationOverviewDayPlanning(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReporting_GetLocationOverviewDayPlanning(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationOverviewDayPlanningView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationOverviewDayPlanningView>;
        }));
    }

    protected processReporting_GetLocationOverviewDayPlanning(response: HttpResponseBase): Observable<GetLocationOverviewDayPlanningView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationOverviewDayPlanningView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationOverviewDayPlanningView>(null as any);
    }

    reporting_GetLocationOverviewCustomBookings(query: GetLocationOverviewCustomBookingsQuery): Observable<GetLocationOverviewCustomBookingsQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Reporting/LocationOverviews/GetLocationOverviewCustomBookings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processReporting_GetLocationOverviewCustomBookings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReporting_GetLocationOverviewCustomBookings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationOverviewCustomBookingsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationOverviewCustomBookingsQueryResult>;
        }));
    }

    protected processReporting_GetLocationOverviewCustomBookings(response: HttpResponseBase): Observable<GetLocationOverviewCustomBookingsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationOverviewCustomBookingsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationOverviewCustomBookingsQueryResult>(null as any);
    }

    reporting_GetLocationOverviewCustomBookingListView(query: GetLocationOverviewCustomBookingListViewQuery): Observable<LocationOverviewCustomBookingListView> {
        let url_ = this.baseUrl + "/api/cqrs/Reporting/LocationOverviews/GetLocationOverviewCustomBookingListView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processReporting_GetLocationOverviewCustomBookingListView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReporting_GetLocationOverviewCustomBookingListView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationOverviewCustomBookingListView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationOverviewCustomBookingListView>;
        }));
    }

    protected processReporting_GetLocationOverviewCustomBookingListView(response: HttpResponseBase): Observable<LocationOverviewCustomBookingListView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LocationOverviewCustomBookingListView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocationOverviewCustomBookingListView>(null as any);
    }

    reporting_GetLocationOverviewCancelledBookings(query: GetLocationOverviewBookingsQuery): Observable<GetLocationOverviewBookingsQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Reporting/LocationOverviews/GetLocationOverviewCancelledBookings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processReporting_GetLocationOverviewCancelledBookings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReporting_GetLocationOverviewCancelledBookings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationOverviewBookingsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationOverviewBookingsQueryResult>;
        }));
    }

    protected processReporting_GetLocationOverviewCancelledBookings(response: HttpResponseBase): Observable<GetLocationOverviewBookingsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationOverviewBookingsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationOverviewBookingsQueryResult>(null as any);
    }

    reporting_GetLocationOverviewBookings(query: GetLocationOverviewBookingsQuery): Observable<GetLocationOverviewBookingsQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Reporting/LocationOverviews/GetLocationOverviewBookings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processReporting_GetLocationOverviewBookings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReporting_GetLocationOverviewBookings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationOverviewBookingsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationOverviewBookingsQueryResult>;
        }));
    }

    protected processReporting_GetLocationOverviewBookings(response: HttpResponseBase): Observable<GetLocationOverviewBookingsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationOverviewBookingsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationOverviewBookingsQueryResult>(null as any);
    }

    /**
     * @return The generated file.
     */
    reporting_ExportLocationOverviewDayPlanningExcel(query: GetLocationOverviewDayPlanningQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Reporting/LocationOverviews/ExportLocationOverviewDayPlanningExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processReporting_ExportLocationOverviewDayPlanningExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReporting_ExportLocationOverviewDayPlanningExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processReporting_ExportLocationOverviewDayPlanningExcel(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    reporting_GetDailyBusyness(query: GetDailyBusynessQuery): Observable<GetDailyBusynessQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Reporting/DailyBusyness/GetDailyBusyness";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processReporting_GetDailyBusyness(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReporting_GetDailyBusyness(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDailyBusynessQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDailyBusynessQueryResult>;
        }));
    }

    protected processReporting_GetDailyBusyness(response: HttpResponseBase): Observable<GetDailyBusynessQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetDailyBusynessQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDailyBusynessQueryResult>(null as any);
    }

    /**
     * @return The generated file.
     */
    reporting_ExportDailyBusynessExcel(query: GetDailyBusynessQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Reporting/DailyBusyness/ExportDailyBusynessExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processReporting_ExportDailyBusynessExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReporting_ExportDailyBusynessExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processReporting_ExportDailyBusynessExcel(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    reporting_GetCustomerLifetimeValue(query: GetCustomerLifetimeValueQuery): Observable<GetCustomerLifetimeValueQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Reporting/CustomerLifetimeValue/GetCustomerLifetimeValue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processReporting_GetCustomerLifetimeValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReporting_GetCustomerLifetimeValue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCustomerLifetimeValueQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCustomerLifetimeValueQueryResult>;
        }));
    }

    protected processReporting_GetCustomerLifetimeValue(response: HttpResponseBase): Observable<GetCustomerLifetimeValueQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCustomerLifetimeValueQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCustomerLifetimeValueQueryResult>(null as any);
    }

    /**
     * @return The generated file.
     */
    reporting_ExportCustomerLifetimeValueExcel(query: GetCustomerLifetimeValueQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Reporting/CustomerLifetimeValue/ExportCustomerLifetimeValueExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processReporting_ExportCustomerLifetimeValueExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReporting_ExportCustomerLifetimeValueExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processReporting_ExportCustomerLifetimeValueExcel(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    reporting_GetCapacityOverview(query: GetCapacityOverviewQuery): Observable<GetCapacityOverviewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Reporting/CapacityOverview/GetCapacityOverview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processReporting_GetCapacityOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReporting_GetCapacityOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCapacityOverviewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCapacityOverviewQueryResult>;
        }));
    }

    protected processReporting_GetCapacityOverview(response: HttpResponseBase): Observable<GetCapacityOverviewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCapacityOverviewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCapacityOverviewQueryResult>(null as any);
    }

    /**
     * @return The generated file.
     */
    reporting_ExportCapacityOverviewExcel(query: GetCapacityOverviewQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Reporting/CapacityOverview/ExportCapacityOverviewExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processReporting_ExportCapacityOverviewExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReporting_ExportCapacityOverviewExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processReporting_ExportCapacityOverviewExcel(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    reporting_GetCancelledBookings(query: GetCancelledBookingsQuery): Observable<GetCancelledBookingsQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Reporting/CancelledBookings/GetCancelledBookings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processReporting_GetCancelledBookings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReporting_GetCancelledBookings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCancelledBookingsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCancelledBookingsQueryResult>;
        }));
    }

    protected processReporting_GetCancelledBookings(response: HttpResponseBase): Observable<GetCancelledBookingsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCancelledBookingsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCancelledBookingsQueryResult>(null as any);
    }

    /**
     * @return The generated file.
     */
    reporting_ExportCancelledBookingsExcel(query: GetCancelledBookingsQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Reporting/CancelledBookings/ExportCancelledBookingsExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processReporting_ExportCancelledBookingsExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReporting_ExportCancelledBookingsExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processReporting_ExportCancelledBookingsExcel(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    reporting_GetBookingContact(query: GetBookingContactQuery): Observable<GetBookingContactQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Reporting/BookingContact/GetBookingContact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processReporting_GetBookingContact(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReporting_GetBookingContact(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBookingContactQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBookingContactQueryResult>;
        }));
    }

    protected processReporting_GetBookingContact(response: HttpResponseBase): Observable<GetBookingContactQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetBookingContactQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBookingContactQueryResult>(null as any);
    }

    /**
     * @return The generated file.
     */
    reporting_ExportBookingContactExcel(query: GetBookingContactQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Reporting/BookingContact/ExportBookingContactExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processReporting_ExportBookingContactExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReporting_ExportBookingContactExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processReporting_ExportBookingContactExcel(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    reporting_GetActivityRevenue(query: GetActivityRevenueQuery): Observable<GetActivityRevenueQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Reporting/ActivityRevenue/GetActivityRevenue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processReporting_GetActivityRevenue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReporting_GetActivityRevenue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetActivityRevenueQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetActivityRevenueQueryResult>;
        }));
    }

    protected processReporting_GetActivityRevenue(response: HttpResponseBase): Observable<GetActivityRevenueQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetActivityRevenueQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetActivityRevenueQueryResult>(null as any);
    }

    /**
     * @return The generated file.
     */
    reporting_ExportActivityRevenueExcel(query: GetActivityRevenueQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Reporting/ActivityRevenue/ExportActivityRevenueExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processReporting_ExportActivityRevenueExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReporting_ExportActivityRevenueExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processReporting_ExportActivityRevenueExcel(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    rateCard_RequestNewPriceLevel(query: RequestNewRateCardPriceLevelQuery): Observable<RateCardPriceLevelDto> {
        let url_ = this.baseUrl + "/api/cqrs/RateCard/RequestNewPriceLevel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRateCard_RequestNewPriceLevel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRateCard_RequestNewPriceLevel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RateCardPriceLevelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RateCardPriceLevelDto>;
        }));
    }

    protected processRateCard_RequestNewPriceLevel(response: HttpResponseBase): Observable<RateCardPriceLevelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RateCardPriceLevelDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RateCardPriceLevelDto>(null as any);
    }

    rateCard_GetRateCardPriceRuleDefAddDialogView(query: GetRateCardPriceRuleDefAddDialogViewQuery): Observable<GetRateCardPriceRuleDefAddDialogViewResult> {
        let url_ = this.baseUrl + "/api/cqrs/RateCard/GetRateCardPriceRuleDefAddDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRateCard_GetRateCardPriceRuleDefAddDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRateCard_GetRateCardPriceRuleDefAddDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRateCardPriceRuleDefAddDialogViewResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRateCardPriceRuleDefAddDialogViewResult>;
        }));
    }

    protected processRateCard_GetRateCardPriceRuleDefAddDialogView(response: HttpResponseBase): Observable<GetRateCardPriceRuleDefAddDialogViewResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetRateCardPriceRuleDefAddDialogViewResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRateCardPriceRuleDefAddDialogViewResult>(null as any);
    }

    rateCard_GetRateCardPriceLevelEditDialogView(query: GetRateCardPriceLevelEditDialogViewQuery): Observable<GetRateCardPriceLevelEditDialogViewResult> {
        let url_ = this.baseUrl + "/api/cqrs/RateCard/GetRateCardPriceLevelEditDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRateCard_GetRateCardPriceLevelEditDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRateCard_GetRateCardPriceLevelEditDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRateCardPriceLevelEditDialogViewResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRateCardPriceLevelEditDialogViewResult>;
        }));
    }

    protected processRateCard_GetRateCardPriceLevelEditDialogView(response: HttpResponseBase): Observable<GetRateCardPriceLevelEditDialogViewResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetRateCardPriceLevelEditDialogViewResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRateCardPriceLevelEditDialogViewResult>(null as any);
    }

    rateCard_GetEditView(query: GetRateCardEditViewQuery): Observable<RateCardEditViewResult> {
        let url_ = this.baseUrl + "/api/cqrs/RateCard/GetEditView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRateCard_GetEditView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRateCard_GetEditView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RateCardEditViewResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RateCardEditViewResult>;
        }));
    }

    protected processRateCard_GetEditView(response: HttpResponseBase): Observable<RateCardEditViewResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RateCardEditViewResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RateCardEditViewResult>(null as any);
    }

    rateCard_GetEditViewForRateCard(query: GetRateCardEditViewForRateCardQuery): Observable<RateCardEditViewResult> {
        let url_ = this.baseUrl + "/api/cqrs/RateCard/GetEditViewForRateCard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRateCard_GetEditViewForRateCard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRateCard_GetEditViewForRateCard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RateCardEditViewResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RateCardEditViewResult>;
        }));
    }

    protected processRateCard_GetEditViewForRateCard(response: HttpResponseBase): Observable<RateCardEditViewResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RateCardEditViewResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RateCardEditViewResult>(null as any);
    }

    rateCard_GetEditDialogView(query: GetRateCardEditDialogViewQuery): Observable<GetRateCardEditDialogViewResult> {
        let url_ = this.baseUrl + "/api/cqrs/RateCard/GetEditDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRateCard_GetEditDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRateCard_GetEditDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRateCardEditDialogViewResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRateCardEditDialogViewResult>;
        }));
    }

    protected processRateCard_GetEditDialogView(response: HttpResponseBase): Observable<GetRateCardEditDialogViewResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetRateCardEditDialogViewResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRateCardEditDialogViewResult>(null as any);
    }

    rateCards_GetPricingOverview(query: GetPricingOverviewQuery): Observable<GetPricingOverviewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/RateCards/GetPricingOverview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRateCards_GetPricingOverview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRateCards_GetPricingOverview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPricingOverviewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPricingOverviewQueryResult>;
        }));
    }

    protected processRateCards_GetPricingOverview(response: HttpResponseBase): Observable<GetPricingOverviewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPricingOverviewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPricingOverviewQueryResult>(null as any);
    }

    rateCards_GetPricingOverviewData(query: GetPricingOverviewDataQuery): Observable<GetPricingOverviewDataQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/RateCards/GetPricingOverviewData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRateCards_GetPricingOverviewData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRateCards_GetPricingOverviewData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPricingOverviewDataQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPricingOverviewDataQueryResult>;
        }));
    }

    protected processRateCards_GetPricingOverviewData(response: HttpResponseBase): Observable<GetPricingOverviewDataQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPricingOverviewDataQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPricingOverviewDataQueryResult>(null as any);
    }

    rateCard_CalculateStartPriceConfig(command: CalculateRateCardStartingPriceCommand): Observable<RateCardStartingPriceConfigDto> {
        let url_ = this.baseUrl + "/api/cqrs/RateCard/CalculateStartPriceConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRateCard_CalculateStartPriceConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRateCard_CalculateStartPriceConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RateCardStartingPriceConfigDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RateCardStartingPriceConfigDto>;
        }));
    }

    protected processRateCard_CalculateStartPriceConfig(response: HttpResponseBase): Observable<RateCardStartingPriceConfigDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RateCardStartingPriceConfigDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RateCardStartingPriceConfigDto>(null as any);
    }

    rateCardPeriodConfig_GetEditItemView(query: GetRateCardPeriodConfigEditItemViewQuery): Observable<GetRateCardPeriodConfigEditItemViewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/RateCardPeriodConfig/GetEditItemView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRateCardPeriodConfig_GetEditItemView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRateCardPeriodConfig_GetEditItemView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRateCardPeriodConfigEditItemViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRateCardPeriodConfigEditItemViewQueryResult>;
        }));
    }

    protected processRateCardPeriodConfig_GetEditItemView(response: HttpResponseBase): Observable<GetRateCardPeriodConfigEditItemViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetRateCardPeriodConfigEditItemViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRateCardPeriodConfigEditItemViewQueryResult>(null as any);
    }

    questionnaires_RemoveSelectOption(command: RemoveSelectOptionCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Questionnaires/RemoveSelectOption";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processQuestionnaires_RemoveSelectOption(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionnaires_RemoveSelectOption(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processQuestionnaires_RemoveSelectOption(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    questionnaires_RemoveOptionCountOption(command: RemoveOptionCountOptionCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Questionnaires/RemoveOptionCountOption";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processQuestionnaires_RemoveOptionCountOption(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionnaires_RemoveOptionCountOption(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processQuestionnaires_RemoveOptionCountOption(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    questionnaires_GetQuestion(query: GetQuestionQuery): Observable<GetQuestionQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Questionnaires/GetQuestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processQuestionnaires_GetQuestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionnaires_GetQuestion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetQuestionQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetQuestionQueryResult>;
        }));
    }

    protected processQuestionnaires_GetQuestion(response: HttpResponseBase): Observable<GetQuestionQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetQuestionQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetQuestionQueryResult>(null as any);
    }

    questionnaires_GetLocationQuestions(): Observable<GetLocationQuestionsQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Questionnaires/GetLocationQuestions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processQuestionnaires_GetLocationQuestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionnaires_GetLocationQuestions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationQuestionsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationQuestionsQueryResult>;
        }));
    }

    protected processQuestionnaires_GetLocationQuestions(response: HttpResponseBase): Observable<GetLocationQuestionsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationQuestionsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationQuestionsQueryResult>(null as any);
    }

    questionnaires_DeleteQuestion(command: DeleteQuestionCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Questionnaires/DeleteQuestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processQuestionnaires_DeleteQuestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionnaires_DeleteQuestion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processQuestionnaires_DeleteQuestion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeleteQuestionCommandRefusal;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    questionnaires_CreateTextQuestion(command: CreateTextQuestionCommand): Observable<CreateTextQuestionCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Questionnaires/CreateTextQuestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processQuestionnaires_CreateTextQuestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionnaires_CreateTextQuestion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateTextQuestionCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateTextQuestionCommandResponse>;
        }));
    }

    protected processQuestionnaires_CreateTextQuestion(response: HttpResponseBase): Observable<CreateTextQuestionCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateTextQuestionCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateTextQuestionCommandResponse>(null as any);
    }

    questionnaires_CreateSelectQuestion(command: CreateSelectQuestionCommand): Observable<CreateSelectQuestionCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Questionnaires/CreateSelectQuestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processQuestionnaires_CreateSelectQuestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionnaires_CreateSelectQuestion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateSelectQuestionCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateSelectQuestionCommandResponse>;
        }));
    }

    protected processQuestionnaires_CreateSelectQuestion(response: HttpResponseBase): Observable<CreateSelectQuestionCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateSelectQuestionCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateSelectQuestionCommandResponse>(null as any);
    }

    questionnaires_CreateOptionCountQuestion(command: CreateOptionCountQuestionCommand): Observable<CreateOptionCountQuestionCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Questionnaires/CreateOptionCountQuestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processQuestionnaires_CreateOptionCountQuestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionnaires_CreateOptionCountQuestion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateOptionCountQuestionCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateOptionCountQuestionCommandResponse>;
        }));
    }

    protected processQuestionnaires_CreateOptionCountQuestion(response: HttpResponseBase): Observable<CreateOptionCountQuestionCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateOptionCountQuestionCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateOptionCountQuestionCommandResponse>(null as any);
    }

    questionnaires_CreateCheckQuestion(command: CreateCheckQuestionCommand): Observable<CreateCheckQuestionCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Questionnaires/CreateCheckQuestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processQuestionnaires_CreateCheckQuestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionnaires_CreateCheckQuestion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateCheckQuestionCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateCheckQuestionCommandResponse>;
        }));
    }

    protected processQuestionnaires_CreateCheckQuestion(response: HttpResponseBase): Observable<CreateCheckQuestionCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateCheckQuestionCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateCheckQuestionCommandResponse>(null as any);
    }

    questionnaires_ChangeTextAnswerLengthBounds(command: ChangeTextAnswerLengthBoundsCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Questionnaires/ChangeTextAnswerLengthBounds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processQuestionnaires_ChangeTextAnswerLengthBounds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionnaires_ChangeTextAnswerLengthBounds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processQuestionnaires_ChangeTextAnswerLengthBounds(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    questionnaires_ChangeSelectOptionText(command: ChangeSelectOptionTextCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Questionnaires/ChangeSelectOptionText";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processQuestionnaires_ChangeSelectOptionText(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionnaires_ChangeSelectOptionText(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processQuestionnaires_ChangeSelectOptionText(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    questionnaires_ChangeSelectDisplay(command: ChangeSelectDisplayCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Questionnaires/ChangeSelectDisplay";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processQuestionnaires_ChangeSelectDisplay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionnaires_ChangeSelectDisplay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processQuestionnaires_ChangeSelectDisplay(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    questionnaires_ChangeQuestionSettings(command: ChangeQuestionSettingsCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Questionnaires/ChangeQuestionSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processQuestionnaires_ChangeQuestionSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionnaires_ChangeQuestionSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processQuestionnaires_ChangeQuestionSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    questionnaires_ChangeQuestionPrompt(command: ChangeQuestionPromptCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Questionnaires/ChangeQuestionPrompt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processQuestionnaires_ChangeQuestionPrompt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionnaires_ChangeQuestionPrompt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processQuestionnaires_ChangeQuestionPrompt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    questionnaires_ChangeOptionCountParticipantLimit(command: ChangeOptionCountParticipantLimitCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Questionnaires/ChangeOptionCountParticipantLimit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processQuestionnaires_ChangeOptionCountParticipantLimit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionnaires_ChangeOptionCountParticipantLimit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processQuestionnaires_ChangeOptionCountParticipantLimit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    questionnaires_ChangeOptionCountOptionText(command: ChangeOptionCountOptionTextCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Questionnaires/ChangeOptionCountOptionText";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processQuestionnaires_ChangeOptionCountOptionText(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionnaires_ChangeOptionCountOptionText(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processQuestionnaires_ChangeOptionCountOptionText(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    questionnaires_ChangeCheckAnswer(command: ChangeCheckAnswerCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Questionnaires/ChangeCheckAnswer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processQuestionnaires_ChangeCheckAnswer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionnaires_ChangeCheckAnswer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processQuestionnaires_ChangeCheckAnswer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    questionnaires_AddSelectOption(command: AddSelectOptionCommand): Observable<AddSelectOptionCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Questionnaires/AddSelectOption";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processQuestionnaires_AddSelectOption(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionnaires_AddSelectOption(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddSelectOptionCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddSelectOptionCommandResponse>;
        }));
    }

    protected processQuestionnaires_AddSelectOption(response: HttpResponseBase): Observable<AddSelectOptionCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddSelectOptionCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddSelectOptionCommandResponse>(null as any);
    }

    questionnaires_AddOptionCountOption(command: AddOptionCountOptionCommand): Observable<AddOptionCountOptionCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Questionnaires/AddOptionCountOption";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processQuestionnaires_AddOptionCountOption(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionnaires_AddOptionCountOption(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddOptionCountOptionCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddOptionCountOptionCommandResponse>;
        }));
    }

    protected processQuestionnaires_AddOptionCountOption(response: HttpResponseBase): Observable<AddOptionCountOptionCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddOptionCountOptionCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddOptionCountOptionCommandResponse>(null as any);
    }

    questionnaires_ReorderActivityQuestions(command: ReorderActivityQuestionsCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Questionnaires/ReorderActivityQuestions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processQuestionnaires_ReorderActivityQuestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionnaires_ReorderActivityQuestions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processQuestionnaires_ReorderActivityQuestions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    questionnaires_RemoveActivityQuestion(command: RemoveActivityQuestionCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Questionnaires/RemoveActivityQuestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processQuestionnaires_RemoveActivityQuestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionnaires_RemoveActivityQuestion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processQuestionnaires_RemoveActivityQuestion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    questionnaires_GetActivityQuestions(query: GetActivityQuestionsQuery): Observable<GetActivityQuestionsQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Questionnaires/GetActivityQuestions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processQuestionnaires_GetActivityQuestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionnaires_GetActivityQuestions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetActivityQuestionsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetActivityQuestionsQueryResult>;
        }));
    }

    protected processQuestionnaires_GetActivityQuestions(response: HttpResponseBase): Observable<GetActivityQuestionsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetActivityQuestionsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetActivityQuestionsQueryResult>(null as any);
    }

    questionnaires_AddActivityQuestion(command: AddActivityQuestionCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Questionnaires/AddActivityQuestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processQuestionnaires_AddActivityQuestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionnaires_AddActivityQuestion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processQuestionnaires_AddActivityQuestion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    promotions_SetPromotionName(command: SetPromotionNameCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Promotions/SetPromotionName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPromotions_SetPromotionName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPromotions_SetPromotionName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPromotions_SetPromotionName(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    promotions_SetPromotionEffect(command: SetPromotionEffectCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Promotions/SetPromotionEffect";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPromotions_SetPromotionEffect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPromotions_SetPromotionEffect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPromotions_SetPromotionEffect(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    promotions_ListPromotions(): Observable<ListPromotionsQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Promotions/ListPromotions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPromotions_ListPromotions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPromotions_ListPromotions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListPromotionsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListPromotionsQueryResult>;
        }));
    }

    protected processPromotions_ListPromotions(response: HttpResponseBase): Observable<ListPromotionsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListPromotionsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListPromotionsQueryResult>(null as any);
    }

    promotions_GetPromotionsByIds(query: GetPromotionsByIdsQuery): Observable<GetPromotionsByIdsQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Promotions/GetPromotionsByIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPromotions_GetPromotionsByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPromotions_GetPromotionsByIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPromotionsByIdsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPromotionsByIdsQueryResult>;
        }));
    }

    protected processPromotions_GetPromotionsByIds(response: HttpResponseBase): Observable<GetPromotionsByIdsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPromotionsByIdsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPromotionsByIdsQueryResult>(null as any);
    }

    promotions_CreateDraftPromotion(command: CreateDraftPromotionCommand): Observable<CreateDraftPromotionCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Promotions/CreateDraftPromotion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPromotions_CreateDraftPromotion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPromotions_CreateDraftPromotion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateDraftPromotionCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateDraftPromotionCommandResponse>;
        }));
    }

    protected processPromotions_CreateDraftPromotion(response: HttpResponseBase): Observable<CreateDraftPromotionCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateDraftPromotionCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateDraftPromotionCommandResponse>(null as any);
    }

    program_GetProgramStartDateTimesForArrivalDate(query: GetProgramStartDateTimesForArrivalDateQuery): Observable<GetProgramStartDateTimesForArrivalDateQueryResult> {
        let url_ = this.baseUrl + "/Program/GetProgramStartDateTimesForArrivalDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processProgram_GetProgramStartDateTimesForArrivalDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProgram_GetProgramStartDateTimesForArrivalDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProgramStartDateTimesForArrivalDateQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProgramStartDateTimesForArrivalDateQueryResult>;
        }));
    }

    protected processProgram_GetProgramStartDateTimesForArrivalDate(response: HttpResponseBase): Observable<GetProgramStartDateTimesForArrivalDateQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProgramStartDateTimesForArrivalDateQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProgramStartDateTimesForArrivalDateQueryResult>(null as any);
    }

    programs_GetProgramListView(query: GetProgramListViewQuery): Observable<GetProgramListViewQueryResult> {
        let url_ = this.baseUrl + "/Programs/GetProgramListView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPrograms_GetProgramListView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrograms_GetProgramListView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProgramListViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProgramListViewQueryResult>;
        }));
    }

    protected processPrograms_GetProgramListView(response: HttpResponseBase): Observable<GetProgramListViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProgramListViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProgramListViewQueryResult>(null as any);
    }

    programs_GetProgramEditItemLinkView(query: GetProgramEditItemLinkViewQuery): Observable<GetProgramEditItemLinkViewQueryResult> {
        let url_ = this.baseUrl + "/Programs/GetProgramEditItemLinkView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPrograms_GetProgramEditItemLinkView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrograms_GetProgramEditItemLinkView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProgramEditItemLinkViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProgramEditItemLinkViewQueryResult>;
        }));
    }

    protected processPrograms_GetProgramEditItemLinkView(response: HttpResponseBase): Observable<GetProgramEditItemLinkViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProgramEditItemLinkViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProgramEditItemLinkViewQueryResult>(null as any);
    }

    programs_GetProgramBookingPartyConfig(query: GetProgramBookingPartyConfigQuery): Observable<GetProgramBookingPartyConfigQueryResult> {
        let url_ = this.baseUrl + "/Programs/GetProgramBookingPartyConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPrograms_GetProgramBookingPartyConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrograms_GetProgramBookingPartyConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProgramBookingPartyConfigQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProgramBookingPartyConfigQueryResult>;
        }));
    }

    protected processPrograms_GetProgramBookingPartyConfig(response: HttpResponseBase): Observable<GetProgramBookingPartyConfigQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProgramBookingPartyConfigQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProgramBookingPartyConfigQueryResult>(null as any);
    }

    program_GetProgramArrivalDateAvailabilityForMonth(query: GetProgramArrivalDateAvailabilityForMonthQuery): Observable<GetProgramArrivalDateAvailabilityForMonthQueryResult> {
        let url_ = this.baseUrl + "/Program/GetProgramArrivalDateAvailabilityForMonth";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processProgram_GetProgramArrivalDateAvailabilityForMonth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProgram_GetProgramArrivalDateAvailabilityForMonth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProgramArrivalDateAvailabilityForMonthQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProgramArrivalDateAvailabilityForMonthQueryResult>;
        }));
    }

    protected processProgram_GetProgramArrivalDateAvailabilityForMonth(response: HttpResponseBase): Observable<GetProgramArrivalDateAvailabilityForMonthQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProgramArrivalDateAvailabilityForMonthQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProgramArrivalDateAvailabilityForMonthQueryResult>(null as any);
    }

    programSteps_GetProgramStepListView(query: GetProgramStepListViewQuery): Observable<GetProgramStepListViewQueryResult> {
        let url_ = this.baseUrl + "/ProgramSteps/GetProgramStepListView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processProgramSteps_GetProgramStepListView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProgramSteps_GetProgramStepListView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProgramStepListViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProgramStepListViewQueryResult>;
        }));
    }

    protected processProgramSteps_GetProgramStepListView(response: HttpResponseBase): Observable<GetProgramStepListViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProgramStepListViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProgramStepListViewQueryResult>(null as any);
    }

    programSteps_GetProgramStepEditItemLinkView(query: GetProgramStepEditItemLinkViewQuery): Observable<GetProgramStepEditItemLinkViewQueryResult> {
        let url_ = this.baseUrl + "/ProgramSteps/GetProgramStepEditItemLinkView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processProgramSteps_GetProgramStepEditItemLinkView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProgramSteps_GetProgramStepEditItemLinkView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProgramStepEditItemLinkViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProgramStepEditItemLinkViewQueryResult>;
        }));
    }

    protected processProgramSteps_GetProgramStepEditItemLinkView(response: HttpResponseBase): Observable<GetProgramStepEditItemLinkViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProgramStepEditItemLinkViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProgramStepEditItemLinkViewQueryResult>(null as any);
    }

    product_GetProductAddDialogView(query: GetProductAddDialogViewQuery): Observable<GetProductAddDialogViewQueryResult> {
        let url_ = this.baseUrl + "/Product/GetProductAddDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processProduct_GetProductAddDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProduct_GetProductAddDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProductAddDialogViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProductAddDialogViewQueryResult>;
        }));
    }

    protected processProduct_GetProductAddDialogView(response: HttpResponseBase): Observable<GetProductAddDialogViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProductAddDialogViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProductAddDialogViewQueryResult>(null as any);
    }

    product_GetProductEditItemView(query: GetProductEditItemViewQuery): Observable<GetProductEditItemViewQueryResult> {
        let url_ = this.baseUrl + "/Product/GetProductEditItemView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processProduct_GetProductEditItemView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProduct_GetProductEditItemView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProductEditItemViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProductEditItemViewQueryResult>;
        }));
    }

    protected processProduct_GetProductEditItemView(response: HttpResponseBase): Observable<GetProductEditItemViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProductEditItemViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProductEditItemViewQueryResult>(null as any);
    }

    product_GetProductListView(query: GetProductListViewQuery): Observable<GetProductListViewQueryResult> {
        let url_ = this.baseUrl + "/Product/GetProductListView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processProduct_GetProductListView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProduct_GetProductListView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProductListViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProductListViewQueryResult>;
        }));
    }

    protected processProduct_GetProductListView(response: HttpResponseBase): Observable<GetProductListViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProductListViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProductListViewQueryResult>(null as any);
    }

    pricing_SetRateCardAmounts(command: SetRateCardAmountsCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/SetRateCardAmounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_SetRateCardAmounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_SetRateCardAmounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPricing_SetRateCardAmounts(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    pricing_ScheduleLevelTransition(command: ScheduleLevelTransitionCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/ScheduleLevelTransition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_ScheduleLevelTransition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_ScheduleLevelTransition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPricing_ScheduleLevelTransition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    pricing_RemoveLevelTransition(command: RemoveLevelTransitionCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/RemoveLevelTransition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_RemoveLevelTransition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_RemoveLevelTransition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPricing_RemoveLevelTransition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    pricing_MoveLevelTransition(command: MoveLevelTransitionCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/MoveLevelTransition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_MoveLevelTransition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_MoveLevelTransition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPricing_MoveLevelTransition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    pricing_GetActivityRateCardsView(query: GetActivityRateCardsViewQuery): Observable<GetActivityRateCardsViewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/GetActivityRateCardsView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_GetActivityRateCardsView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_GetActivityRateCardsView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetActivityRateCardsViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetActivityRateCardsViewQueryResult>;
        }));
    }

    protected processPricing_GetActivityRateCardsView(response: HttpResponseBase): Observable<GetActivityRateCardsViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetActivityRateCardsViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetActivityRateCardsViewQueryResult>(null as any);
    }

    pricing_CreateActivityRateCardSet(command: CreateActivityRateCardSetCommand): Observable<CreateActivityRateCardSetCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/CreateActivityRateCardSet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_CreateActivityRateCardSet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_CreateActivityRateCardSet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateActivityRateCardSetCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateActivityRateCardSetCommandResponse>;
        }));
    }

    protected processPricing_CreateActivityRateCardSet(response: HttpResponseBase): Observable<CreateActivityRateCardSetCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateActivityRateCardSetCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateActivityRateCardSetCommandResponse>(null as any);
    }

    pricing_CopyDaySchedule(command: CopyDayScheduleCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/CopyDaySchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_CopyDaySchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_CopyDaySchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPricing_CopyDaySchedule(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    pricing_ChangeLevelTransitionTarget(command: ChangeLevelTransitionTargetCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/ChangeLevelTransitionTarget";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_ChangeLevelTransitionTarget(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_ChangeLevelTransitionTarget(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPricing_ChangeLevelTransitionTarget(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    pricing_ChangeDayStartLevel(command: ChangeDayStartLevelCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/ChangeDayStartLevel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_ChangeDayStartLevel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_ChangeDayStartLevel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPricing_ChangeDayStartLevel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    pricing_RestorePriceComponent(command: RestorePriceComponentCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/RestorePriceComponent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_RestorePriceComponent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_RestorePriceComponent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPricing_RestorePriceComponent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    pricing_RemovePriceComponent(command: RemovePriceComponentCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/RemovePriceComponent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_RemovePriceComponent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_RemovePriceComponent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPricing_RemovePriceComponent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    pricing_RedefinePerResourceComponent(command: RedefinePerResourceComponentCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/RedefinePerResourceComponent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_RedefinePerResourceComponent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_RedefinePerResourceComponent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPricing_RedefinePerResourceComponent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    pricing_RedefinePerParticipantComponent(command: RedefinePerParticipantComponentCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/RedefinePerParticipantComponent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_RedefinePerParticipantComponent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_RedefinePerParticipantComponent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPricing_RedefinePerParticipantComponent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    pricing_RedefinePerBookingComponent(command: RedefinePerBookingComponentCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/RedefinePerBookingComponent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_RedefinePerBookingComponent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_RedefinePerBookingComponent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPricing_RedefinePerBookingComponent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    pricing_PublishPriceStructureDraft(command: PublishPriceStructureDraftCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/PublishPriceStructureDraft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_PublishPriceStructureDraft(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_PublishPriceStructureDraft(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPricing_PublishPriceStructureDraft(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    pricing_GetPriceStructureDraftPreparationView(query: GetPriceStructureDraftPreparationViewQuery): Observable<GetPriceStructureDraftPreparationViewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/GetPriceStructureDraftPreparationView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_GetPriceStructureDraftPreparationView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_GetPriceStructureDraftPreparationView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPriceStructureDraftPreparationViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPriceStructureDraftPreparationViewQueryResult>;
        }));
    }

    protected processPricing_GetPriceStructureDraftPreparationView(response: HttpResponseBase): Observable<GetPriceStructureDraftPreparationViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPriceStructureDraftPreparationViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPriceStructureDraftPreparationViewQueryResult>(null as any);
    }

    pricing_GetActivityPriceStructureView(query: GetActivityPriceStructureViewQuery): Observable<GetActivityPriceStructureViewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/GetActivityPriceStructureView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_GetActivityPriceStructureView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_GetActivityPriceStructureView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetActivityPriceStructureViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetActivityPriceStructureViewQueryResult>;
        }));
    }

    protected processPricing_GetActivityPriceStructureView(response: HttpResponseBase): Observable<GetActivityPriceStructureViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetActivityPriceStructureViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetActivityPriceStructureViewQueryResult>(null as any);
    }

    pricing_DiscardPriceStructureDraft(command: DiscardPriceStructureDraftCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/DiscardPriceStructureDraft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_DiscardPriceStructureDraft(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_DiscardPriceStructureDraft(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPricing_DiscardPriceStructureDraft(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    pricing_CreatePriceStructureDraft(command: CreatePriceStructureDraftCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/CreatePriceStructureDraft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_CreatePriceStructureDraft(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_CreatePriceStructureDraft(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPricing_CreatePriceStructureDraft(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    pricing_CreateActivityPriceStructure(command: CreateActivityPriceStructureCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/CreateActivityPriceStructure";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_CreateActivityPriceStructure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_CreateActivityPriceStructure(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPricing_CreateActivityPriceStructure(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    pricing_AddPerResourceComponent(command: AddPerResourceComponentCommand): Observable<AddPerResourceComponentCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/AddPerResourceComponent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_AddPerResourceComponent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_AddPerResourceComponent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddPerResourceComponentCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddPerResourceComponentCommandResponse>;
        }));
    }

    protected processPricing_AddPerResourceComponent(response: HttpResponseBase): Observable<AddPerResourceComponentCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddPerResourceComponentCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddPerResourceComponentCommandResponse>(null as any);
    }

    pricing_AddPerParticipantComponent(command: AddPerParticipantComponentCommand): Observable<AddPerParticipantComponentCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/AddPerParticipantComponent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_AddPerParticipantComponent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_AddPerParticipantComponent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddPerParticipantComponentCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddPerParticipantComponentCommandResponse>;
        }));
    }

    protected processPricing_AddPerParticipantComponent(response: HttpResponseBase): Observable<AddPerParticipantComponentCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddPerParticipantComponentCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddPerParticipantComponentCommandResponse>(null as any);
    }

    pricing_AddPerBookingComponent(command: AddPerBookingComponentCommand): Observable<AddPerBookingComponentCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/AddPerBookingComponent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_AddPerBookingComponent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_AddPerBookingComponent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddPerBookingComponentCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddPerBookingComponentCommandResponse>;
        }));
    }

    protected processPricing_AddPerBookingComponent(response: HttpResponseBase): Observable<AddPerBookingComponentCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddPerBookingComponentCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddPerBookingComponentCommandResponse>(null as any);
    }

    pricing_SetPriceLevelName(command: SetPriceLevelNameCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/SetPriceLevelName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_SetPriceLevelName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_SetPriceLevelName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPricing_SetPriceLevelName(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    pricing_ReorderPriceLevels(command: ReorderPriceLevelsCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/ReorderPriceLevels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_ReorderPriceLevels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_ReorderPriceLevels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPricing_ReorderPriceLevels(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    pricing_ReactivatePriceLevel(command: ReactivatePriceLevelCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/ReactivatePriceLevel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_ReactivatePriceLevel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_ReactivatePriceLevel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPricing_ReactivatePriceLevel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    pricing_GetPriceLevelUsage(query: GetPriceLevelUsageQuery): Observable<GetPriceLevelUsageQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/GetPriceLevelUsage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_GetPriceLevelUsage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_GetPriceLevelUsage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPriceLevelUsageQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPriceLevelUsageQueryResult>;
        }));
    }

    protected processPricing_GetPriceLevelUsage(response: HttpResponseBase): Observable<GetPriceLevelUsageQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPriceLevelUsageQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPriceLevelUsageQueryResult>(null as any);
    }

    pricing_GetLocationPriceLevelsConfig(query: GetLocationPriceLevelsConfigQuery): Observable<GetLocationPriceLevelsConfigQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/GetLocationPriceLevelsConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_GetLocationPriceLevelsConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_GetLocationPriceLevelsConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationPriceLevelsConfigQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationPriceLevelsConfigQueryResult>;
        }));
    }

    protected processPricing_GetLocationPriceLevelsConfig(response: HttpResponseBase): Observable<GetLocationPriceLevelsConfigQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationPriceLevelsConfigQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationPriceLevelsConfigQueryResult>(null as any);
    }

    pricing_GetCanDeactivatePriceLevelView(query: GetCanDeactivatePriceLevelViewQuery): Observable<GetCanDeactivatePriceLevelViewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/GetCanDeactivatePriceLevelView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_GetCanDeactivatePriceLevelView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_GetCanDeactivatePriceLevelView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCanDeactivatePriceLevelViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCanDeactivatePriceLevelViewQueryResult>;
        }));
    }

    protected processPricing_GetCanDeactivatePriceLevelView(response: HttpResponseBase): Observable<GetCanDeactivatePriceLevelViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCanDeactivatePriceLevelViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCanDeactivatePriceLevelViewQueryResult>(null as any);
    }

    pricing_DefinePriceLevel(command: DefinePriceLevelCommand): Observable<DefinePriceLevelCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/DefinePriceLevel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_DefinePriceLevel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_DefinePriceLevel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DefinePriceLevelCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DefinePriceLevelCommandResponse>;
        }));
    }

    protected processPricing_DefinePriceLevel(response: HttpResponseBase): Observable<DefinePriceLevelCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DefinePriceLevelCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DefinePriceLevelCommandResponse>(null as any);
    }

    pricing_DeactivatePriceLevel(command: DeactivatePriceLevelCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/DeactivatePriceLevel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_DeactivatePriceLevel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_DeactivatePriceLevel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPricing_DeactivatePriceLevel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    pricing_CreateLocationPriceLevels(command: CreateLocationPriceLevelsCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/CreateLocationPriceLevels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_CreateLocationPriceLevels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_CreateLocationPriceLevels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPricing_CreateLocationPriceLevels(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    pricing_ChangePriceLevelColor(command: ChangePriceLevelColorCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/ChangePriceLevelColor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_ChangePriceLevelColor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_ChangePriceLevelColor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPricing_ChangePriceLevelColor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    pricing_SetPriceComponentName(command: SetPriceComponentNameCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/SetPriceComponentName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_SetPriceComponentName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_SetPriceComponentName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPricing_SetPriceComponentName(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    pricing_RetirePriceComponent(command: RetirePriceComponentCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/RetirePriceComponent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_RetirePriceComponent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_RetirePriceComponent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPricing_RetirePriceComponent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    pricing_GetLocationPriceComponentsView(query: GetLocationPriceComponentsViewQuery): Observable<GetLocationPriceComponentsViewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/GetLocationPriceComponentsView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_GetLocationPriceComponentsView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_GetLocationPriceComponentsView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationPriceComponentsViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationPriceComponentsViewQueryResult>;
        }));
    }

    protected processPricing_GetLocationPriceComponentsView(response: HttpResponseBase): Observable<GetLocationPriceComponentsViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationPriceComponentsViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationPriceComponentsViewQueryResult>(null as any);
    }

    pricing_CreatePriceComponent(command: CreatePriceComponentCommand): Observable<CreatePriceComponentCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/CreatePriceComponent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_CreatePriceComponent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_CreatePriceComponent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatePriceComponentCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatePriceComponentCommandResponse>;
        }));
    }

    protected processPricing_CreatePriceComponent(response: HttpResponseBase): Observable<CreatePriceComponentCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatePriceComponentCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreatePriceComponentCommandResponse>(null as any);
    }

    pricing_SetLocationDepositRule(command: SetLocationDepositRuleCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/SetLocationDepositRule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_SetLocationDepositRule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_SetLocationDepositRule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPricing_SetLocationDepositRule(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    pricing_SetLocationDepositDueWindow(command: SetLocationDepositDueWindowCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/SetLocationDepositDueWindow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_SetLocationDepositDueWindow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_SetLocationDepositDueWindow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPricing_SetLocationDepositDueWindow(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    pricing_SetLocationDepositChannelApplicability(command: SetLocationDepositChannelApplicabilityCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/SetLocationDepositChannelApplicability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_SetLocationDepositChannelApplicability(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_SetLocationDepositChannelApplicability(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPricing_SetLocationDepositChannelApplicability(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    pricing_SetActivityDepositOverride(command: SetActivityDepositOverrideCommand): Observable<SetActivityDepositOverrideCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/SetActivityDepositOverride";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_SetActivityDepositOverride(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_SetActivityDepositOverride(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SetActivityDepositOverrideCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SetActivityDepositOverrideCommandResponse>;
        }));
    }

    protected processPricing_SetActivityDepositOverride(response: HttpResponseBase): Observable<SetActivityDepositOverrideCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SetActivityDepositOverrideCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SetActivityDepositOverrideCommandResponse>(null as any);
    }

    pricing_RemoveActivityDepositOverride(command: RemoveActivityDepositOverrideCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/RemoveActivityDepositOverride";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_RemoveActivityDepositOverride(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_RemoveActivityDepositOverride(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPricing_RemoveActivityDepositOverride(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    pricing_GetLocationDepositPolicyView(query: GetLocationDepositPolicyViewQuery): Observable<GetLocationDepositPolicyViewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/GetLocationDepositPolicyView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_GetLocationDepositPolicyView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_GetLocationDepositPolicyView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationDepositPolicyViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationDepositPolicyViewQueryResult>;
        }));
    }

    protected processPricing_GetLocationDepositPolicyView(response: HttpResponseBase): Observable<GetLocationDepositPolicyViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationDepositPolicyViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationDepositPolicyViewQueryResult>(null as any);
    }

    pricing_GetActivityDepositPolicyView(query: GetActivityDepositPolicyViewQuery): Observable<GetActivityDepositPolicyViewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/GetActivityDepositPolicyView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_GetActivityDepositPolicyView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_GetActivityDepositPolicyView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetActivityDepositPolicyViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetActivityDepositPolicyViewQueryResult>;
        }));
    }

    protected processPricing_GetActivityDepositPolicyView(response: HttpResponseBase): Observable<GetActivityDepositPolicyViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetActivityDepositPolicyViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetActivityDepositPolicyViewQueryResult>(null as any);
    }

    pricing_CreateLocationDepositPolicy(command: CreateLocationDepositPolicyCommand): Observable<CreateLocationDepositPolicyCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Pricing/CreateLocationDepositPolicy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPricing_CreateLocationDepositPolicy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPricing_CreateLocationDepositPolicy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateLocationDepositPolicyCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateLocationDepositPolicyCommandResponse>;
        }));
    }

    protected processPricing_CreateLocationDepositPolicy(response: HttpResponseBase): Observable<CreateLocationDepositPolicyCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateLocationDepositPolicyCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateLocationDepositPolicyCommandResponse>(null as any);
    }

    pos_SetPosTableSelection(request: SetPosTableSelectionRequestDto): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Pos/SetPosTableSelection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPos_SetPosTableSelection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPos_SetPosTableSelection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPos_SetPosTableSelection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    pos_GetPosTableSelectionSettings(): Observable<PosTableSelectionSettingsView> {
        let url_ = this.baseUrl + "/api/cqrs/Pos/GetPosTableSelectionSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPos_GetPosTableSelectionSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPos_GetPosTableSelectionSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PosTableSelectionSettingsView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PosTableSelectionSettingsView>;
        }));
    }

    protected processPos_GetPosTableSelectionSettings(response: HttpResponseBase): Observable<PosTableSelectionSettingsView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosTableSelectionSettingsView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PosTableSelectionSettingsView>(null as any);
    }

    posArticleConfig_GetPosArticlePickerView(query: GetPosArticlePickerViewQuery): Observable<GetPosArticlePickerViewQueryResult> {
        let url_ = this.baseUrl + "/Pos/PosArticleConfig/GetPosArticlePickerView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPosArticleConfig_GetPosArticlePickerView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosArticleConfig_GetPosArticlePickerView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPosArticlePickerViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPosArticlePickerViewQueryResult>;
        }));
    }

    protected processPosArticleConfig_GetPosArticlePickerView(response: HttpResponseBase): Observable<GetPosArticlePickerViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPosArticlePickerViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPosArticlePickerViewQueryResult>(null as any);
    }

    posArticleConfig_GetPosArticleConfigListPageView(query: GetPosArticleConfigListPageViewQuery): Observable<GetPosArticleConfigListPageViewQueryResult> {
        let url_ = this.baseUrl + "/Pos/PosArticleConfig/GetPosArticleConfigListPageView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPosArticleConfig_GetPosArticleConfigListPageView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosArticleConfig_GetPosArticleConfigListPageView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPosArticleConfigListPageViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPosArticleConfigListPageViewQueryResult>;
        }));
    }

    protected processPosArticleConfig_GetPosArticleConfigListPageView(response: HttpResponseBase): Observable<GetPosArticleConfigListPageViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPosArticleConfigListPageViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPosArticleConfigListPageViewQueryResult>(null as any);
    }

    posArticleConfig_GetPosArticleConfigEditItemPageView(query: GetPosArticleConfigEditItemPageViewQuery): Observable<GetPosArticleConfigEditItemPageViewQueryResult> {
        let url_ = this.baseUrl + "/Pos/PosArticleConfig/GetPosArticleConfigEditItemPageView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPosArticleConfig_GetPosArticleConfigEditItemPageView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosArticleConfig_GetPosArticleConfigEditItemPageView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPosArticleConfigEditItemPageViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPosArticleConfigEditItemPageViewQueryResult>;
        }));
    }

    protected processPosArticleConfig_GetPosArticleConfigEditItemPageView(response: HttpResponseBase): Observable<GetPosArticleConfigEditItemPageViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPosArticleConfigEditItemPageViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPosArticleConfigEditItemPageViewQueryResult>(null as any);
    }

    posArticleConfig_GetPosArticleConfigArticleDetailsDialogView(query: GetPosArticleConfigArticleDetailsDialogViewQuery): Observable<GetPosArticleConfigArticleDetailsDialogViewQueryResult> {
        let url_ = this.baseUrl + "/Pos/PosArticleConfig/GetPosArticleConfigArticleDetailsDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPosArticleConfig_GetPosArticleConfigArticleDetailsDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosArticleConfig_GetPosArticleConfigArticleDetailsDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPosArticleConfigArticleDetailsDialogViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPosArticleConfigArticleDetailsDialogViewQueryResult>;
        }));
    }

    protected processPosArticleConfig_GetPosArticleConfigArticleDetailsDialogView(response: HttpResponseBase): Observable<GetPosArticleConfigArticleDetailsDialogViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPosArticleConfigArticleDetailsDialogViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPosArticleConfigArticleDetailsDialogViewQueryResult>(null as any);
    }

    pos_StartPosArticleBookingSync(command: StartPosArticleBookingSyncCommand): Observable<StartPosArticleBookingSyncCommandResult> {
        let url_ = this.baseUrl + "/api/cqrs/Pos/StartPosArticleBookingSync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPos_StartPosArticleBookingSync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPos_StartPosArticleBookingSync(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StartPosArticleBookingSyncCommandResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StartPosArticleBookingSyncCommandResult>;
        }));
    }

    protected processPos_StartPosArticleBookingSync(response: HttpResponseBase): Observable<StartPosArticleBookingSyncCommandResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StartPosArticleBookingSyncCommandResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StartPosArticleBookingSyncCommandResult>(null as any);
    }

    pos_PreviewPosArticleBookingSync(query: PreviewPosArticleBookingSyncQuery): Observable<PreviewPosArticleBookingSyncQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Pos/PreviewPosArticleBookingSync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPos_PreviewPosArticleBookingSync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPos_PreviewPosArticleBookingSync(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PreviewPosArticleBookingSyncQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PreviewPosArticleBookingSyncQueryResult>;
        }));
    }

    protected processPos_PreviewPosArticleBookingSync(response: HttpResponseBase): Observable<PreviewPosArticleBookingSyncQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PreviewPosArticleBookingSyncQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PreviewPosArticleBookingSyncQueryResult>(null as any);
    }

    pos_GetLatestPosArticleBookingSyncRun(query: GetLatestPosArticleBookingSyncRunQuery): Observable<GetLatestPosArticleBookingSyncRunQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Pos/GetLatestPosArticleBookingSyncRun";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPos_GetLatestPosArticleBookingSyncRun(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPos_GetLatestPosArticleBookingSyncRun(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLatestPosArticleBookingSyncRunQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLatestPosArticleBookingSyncRunQueryResult>;
        }));
    }

    protected processPos_GetLatestPosArticleBookingSyncRun(response: HttpResponseBase): Observable<GetLatestPosArticleBookingSyncRunQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLatestPosArticleBookingSyncRunQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLatestPosArticleBookingSyncRunQueryResult>(null as any);
    }

    posBooking_GetTableAreas(): Observable<GetTableAreasQueryResult> {
        let url_ = this.baseUrl + "/PosBooking/GetTableAreas";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPosBooking_GetTableAreas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosBooking_GetTableAreas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTableAreasQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTableAreasQueryResult>;
        }));
    }

    protected processPosBooking_GetTableAreas(response: HttpResponseBase): Observable<GetTableAreasQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetTableAreasQueryResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTableAreasQueryResult>(null as any);
    }

    posBooking_GetPosBookingEntryDialogView(query: GetPosBookingEntryDialogViewQuery): Observable<GetPosBookingEntryDialogViewQueryResult> {
        let url_ = this.baseUrl + "/PosBooking/GetPosBookingEntryDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPosBooking_GetPosBookingEntryDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosBooking_GetPosBookingEntryDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPosBookingEntryDialogViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPosBookingEntryDialogViewQueryResult>;
        }));
    }

    protected processPosBooking_GetPosBookingEntryDialogView(response: HttpResponseBase): Observable<GetPosBookingEntryDialogViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPosBookingEntryDialogViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPosBookingEntryDialogViewQueryResult>(null as any);
    }

    posBooking_GetFreeTables(query: GetFreeTablesQuery): Observable<GetFreeTablesQueryResult> {
        let url_ = this.baseUrl + "/PosBooking/GetFreeTables";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPosBooking_GetFreeTables(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosBooking_GetFreeTables(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFreeTablesQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFreeTablesQueryResult>;
        }));
    }

    protected processPosBooking_GetFreeTables(response: HttpResponseBase): Observable<GetFreeTablesQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetFreeTablesQueryResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFreeTablesQueryResult>(null as any);
    }

    posBooking_EnterManually(request: PosBookingEnterManuallyRequestDto): Observable<ResultId> {
        let url_ = this.baseUrl + "/PosBooking/EnterManually";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPosBooking_EnterManually(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosBooking_EnterManually(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processPosBooking_EnterManually(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    posBooking_EnterAutomatically(request: PosBookingEnterAutomaticallyRequestDto): Observable<PosBookingEnterAutomaticallyResult> {
        let url_ = this.baseUrl + "/PosBooking/EnterAutomatically";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPosBooking_EnterAutomatically(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosBooking_EnterAutomatically(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PosBookingEnterAutomaticallyResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PosBookingEnterAutomaticallyResult>;
        }));
    }

    protected processPosBooking_EnterAutomatically(response: HttpResponseBase): Observable<PosBookingEnterAutomaticallyResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PosBookingEnterAutomaticallyResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PosBookingEnterAutomaticallyResult>(null as any);
    }

    posBooking_Clear(request: PosBookingClearRequestDto): Observable<ResultId> {
        let url_ = this.baseUrl + "/PosBooking/Clear";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPosBooking_Clear(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosBooking_Clear(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processPosBooking_Clear(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    platformEnvironmentOverrides_SetLocationEnvironmentOverrides(command: SetLocationEnvironmentOverridesCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Platform/EnvironmentOverrides/SetLocationEnvironmentOverrides";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPlatformEnvironmentOverrides_SetLocationEnvironmentOverrides(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPlatformEnvironmentOverrides_SetLocationEnvironmentOverrides(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPlatformEnvironmentOverrides_SetLocationEnvironmentOverrides(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    platformEnvironmentOverrides_GetLocationEnvironmentOverrides(query: GetLocationEnvironmentOverridesQuery): Observable<GetLocationEnvironmentOverridesQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Platform/EnvironmentOverrides/GetLocationEnvironmentOverrides";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPlatformEnvironmentOverrides_GetLocationEnvironmentOverrides(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPlatformEnvironmentOverrides_GetLocationEnvironmentOverrides(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationEnvironmentOverridesQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationEnvironmentOverridesQueryResult>;
        }));
    }

    protected processPlatformEnvironmentOverrides_GetLocationEnvironmentOverrides(response: HttpResponseBase): Observable<GetLocationEnvironmentOverridesQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationEnvironmentOverridesQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationEnvironmentOverridesQueryResult>(null as any);
    }

    platform_GetPlatformDomains(query: GetPlatformDomainsQuery): Observable<GetPlatformDomainsQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Platform/GetPlatformDomains";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPlatform_GetPlatformDomains(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPlatform_GetPlatformDomains(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPlatformDomainsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPlatformDomainsQueryResult>;
        }));
    }

    protected processPlatform_GetPlatformDomains(response: HttpResponseBase): Observable<GetPlatformDomainsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPlatformDomainsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPlatformDomainsQueryResult>(null as any);
    }

    platform_GetPlatformConfigListPageView(query: GetPlatformConfigListPageViewQuery): Observable<GetPlatformConfigListPageViewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Platform/GetPlatformConfigListPageView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPlatform_GetPlatformConfigListPageView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPlatform_GetPlatformConfigListPageView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPlatformConfigListPageViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPlatformConfigListPageViewQueryResult>;
        }));
    }

    protected processPlatform_GetPlatformConfigListPageView(response: HttpResponseBase): Observable<GetPlatformConfigListPageViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPlatformConfigListPageViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPlatformConfigListPageViewQueryResult>(null as any);
    }

    platformLogging_GetListView(query: GetListViewQuery): Observable<GetListViewQueryResult> {
        let url_ = this.baseUrl + "/PlatformLogging/GetListView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPlatformLogging_GetListView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPlatformLogging_GetListView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetListViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetListViewQueryResult>;
        }));
    }

    protected processPlatformLogging_GetListView(response: HttpResponseBase): Observable<GetListViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetListViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetListViewQueryResult>(null as any);
    }

    platformLogging_GetListDataView(query: GetListDataViewQuery): Observable<GetListDataViewQueryResult> {
        let url_ = this.baseUrl + "/PlatformLogging/GetListDataView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPlatformLogging_GetListDataView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPlatformLogging_GetListDataView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetListDataViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetListDataViewQueryResult>;
        }));
    }

    protected processPlatformLogging_GetListDataView(response: HttpResponseBase): Observable<GetListDataViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetListDataViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetListDataViewQueryResult>(null as any);
    }

    platformLogging_GetGroupListView(query: GetGroupListViewQuery): Observable<GetGroupListViewQueryResult> {
        let url_ = this.baseUrl + "/PlatformLogging/GetGroupListView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPlatformLogging_GetGroupListView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPlatformLogging_GetGroupListView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGroupListViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGroupListViewQueryResult>;
        }));
    }

    protected processPlatformLogging_GetGroupListView(response: HttpResponseBase): Observable<GetGroupListViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetGroupListViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGroupListViewQueryResult>(null as any);
    }

    platformLogging_GetGroupListDataView(query: GetGroupListDataViewQuery): Observable<GetGroupListDataViewQueryResult> {
        let url_ = this.baseUrl + "/PlatformLogging/GetGroupListDataView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPlatformLogging_GetGroupListDataView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPlatformLogging_GetGroupListDataView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGroupListDataViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGroupListDataViewQueryResult>;
        }));
    }

    protected processPlatformLogging_GetGroupListDataView(response: HttpResponseBase): Observable<GetGroupListDataViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetGroupListDataViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGroupListDataViewQueryResult>(null as any);
    }

    platformLogging_GetEditItemView(query: GetEditItemViewQuery): Observable<GetEditItemViewQueryResult> {
        let url_ = this.baseUrl + "/PlatformLogging/GetEditItemView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPlatformLogging_GetEditItemView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPlatformLogging_GetEditItemView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEditItemViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEditItemViewQueryResult>;
        }));
    }

    protected processPlatformLogging_GetEditItemView(response: HttpResponseBase): Observable<GetEditItemViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetEditItemViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEditItemViewQueryResult>(null as any);
    }

    payments_GetStuckRefunds(): Observable<GetStuckRefundsQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Payments/Reports/GetStuckRefunds";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPayments_GetStuckRefunds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPayments_GetStuckRefunds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetStuckRefundsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetStuckRefundsQueryResult>;
        }));
    }

    protected processPayments_GetStuckRefunds(response: HttpResponseBase): Observable<GetStuckRefundsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetStuckRefundsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetStuckRefundsQueryResult>(null as any);
    }

    payments_GetRefundReport(query: GetRefundReportQuery): Observable<GetRefundReportQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Payments/Reports/GetRefundReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPayments_GetRefundReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPayments_GetRefundReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRefundReportQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRefundReportQueryResult>;
        }));
    }

    protected processPayments_GetRefundReport(response: HttpResponseBase): Observable<GetRefundReportQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetRefundReportQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRefundReportQueryResult>(null as any);
    }

    payments_GetPaymentVolume(query: GetPaymentVolumeQuery): Observable<GetPaymentVolumeQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Payments/Reports/GetPaymentVolume";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPayments_GetPaymentVolume(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPayments_GetPaymentVolume(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPaymentVolumeQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPaymentVolumeQueryResult>;
        }));
    }

    protected processPayments_GetPaymentVolume(response: HttpResponseBase): Observable<GetPaymentVolumeQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPaymentVolumeQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPaymentVolumeQueryResult>(null as any);
    }

    payments_GetPaymentTransactions(query: GetPaymentTransactionsQuery): Observable<GetPaymentTransactionsQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Payments/Reports/GetPaymentTransactions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPayments_GetPaymentTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPayments_GetPaymentTransactions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPaymentTransactionsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPaymentTransactionsQueryResult>;
        }));
    }

    protected processPayments_GetPaymentTransactions(response: HttpResponseBase): Observable<GetPaymentTransactionsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPaymentTransactionsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPaymentTransactionsQueryResult>(null as any);
    }

    /**
     * @return The generated file.
     */
    payments_ExportRefundsExcel(query: GetRefundReportQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Payments/Reports/ExportRefundsExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPayments_ExportRefundsExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPayments_ExportRefundsExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPayments_ExportRefundsExcel(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    /**
     * @return The generated file.
     */
    payments_ExportPaymentVolumeExcel(query: GetPaymentVolumeQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Payments/Reports/ExportPaymentVolumeExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPayments_ExportPaymentVolumeExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPayments_ExportPaymentVolumeExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPayments_ExportPaymentVolumeExcel(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    /**
     * @return The generated file.
     */
    payments_ExportPaymentTransactionsExcel(query: GetPaymentTransactionsQuery): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Payments/Reports/ExportPaymentTransactionsExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPayments_ExportPaymentTransactionsExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPayments_ExportPaymentTransactionsExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPayments_ExportPaymentTransactionsExcel(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    payments_SetPlatformProviderFeeSchedule(command: SetPlatformProviderFeeScheduleCommand): Observable<ProviderFeeScheduleResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Payments/ProviderFees/SetPlatformProviderFeeSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPayments_SetPlatformProviderFeeSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPayments_SetPlatformProviderFeeSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProviderFeeScheduleResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProviderFeeScheduleResponse>;
        }));
    }

    protected processPayments_SetPlatformProviderFeeSchedule(response: HttpResponseBase): Observable<ProviderFeeScheduleResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProviderFeeScheduleResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProviderFeeScheduleResponse>(null as any);
    }

    payments_SetLocationProviderFeeSchedule(command: SetLocationProviderFeeScheduleCommand): Observable<ProviderFeeScheduleResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Payments/ProviderFees/SetLocationProviderFeeSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPayments_SetLocationProviderFeeSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPayments_SetLocationProviderFeeSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProviderFeeScheduleResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProviderFeeScheduleResponse>;
        }));
    }

    protected processPayments_SetLocationProviderFeeSchedule(response: HttpResponseBase): Observable<ProviderFeeScheduleResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProviderFeeScheduleResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProviderFeeScheduleResponse>(null as any);
    }

    payments_GetPlatformProviderFeeSchedule(query: GetPlatformProviderFeeScheduleQuery): Observable<ProviderFeeScheduleResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Payments/ProviderFees/GetPlatformProviderFeeSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPayments_GetPlatformProviderFeeSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPayments_GetPlatformProviderFeeSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProviderFeeScheduleResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProviderFeeScheduleResponse>;
        }));
    }

    protected processPayments_GetPlatformProviderFeeSchedule(response: HttpResponseBase): Observable<ProviderFeeScheduleResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProviderFeeScheduleResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProviderFeeScheduleResponse>(null as any);
    }

    payments_GetLocationProviderFeeSchedule(query: GetLocationProviderFeeScheduleQuery): Observable<ProviderFeeScheduleResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Payments/ProviderFees/GetLocationProviderFeeSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPayments_GetLocationProviderFeeSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPayments_GetLocationProviderFeeSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProviderFeeScheduleResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProviderFeeScheduleResponse>;
        }));
    }

    protected processPayments_GetLocationProviderFeeSchedule(response: HttpResponseBase): Observable<ProviderFeeScheduleResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProviderFeeScheduleResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProviderFeeScheduleResponse>(null as any);
    }

    payments_SelectProviderConnectionProfile(command: SelectProviderConnectionProfileCommand): Observable<ProviderConnectionDto> {
        let url_ = this.baseUrl + "/api/cqrs/Payments/ProviderConnections/SelectProviderConnectionProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPayments_SelectProviderConnectionProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPayments_SelectProviderConnectionProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProviderConnectionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProviderConnectionDto>;
        }));
    }

    protected processPayments_SelectProviderConnectionProfile(response: HttpResponseBase): Observable<ProviderConnectionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProviderConnectionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProviderConnectionDto>(null as any);
    }

    payments_RenameProviderConnection(command: RenameProviderConnectionCommand): Observable<ProviderConnectionDto> {
        let url_ = this.baseUrl + "/api/cqrs/Payments/ProviderConnections/RenameProviderConnection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPayments_RenameProviderConnection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPayments_RenameProviderConnection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProviderConnectionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProviderConnectionDto>;
        }));
    }

    protected processPayments_RenameProviderConnection(response: HttpResponseBase): Observable<ProviderConnectionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProviderConnectionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProviderConnectionDto>(null as any);
    }

    payments_RefreshProviderConnectionStatus(command: RefreshProviderConnectionStatusCommand): Observable<ListProviderConnectionsResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Payments/ProviderConnections/RefreshProviderConnectionStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPayments_RefreshProviderConnectionStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPayments_RefreshProviderConnectionStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListProviderConnectionsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListProviderConnectionsResponse>;
        }));
    }

    protected processPayments_RefreshProviderConnectionStatus(response: HttpResponseBase): Observable<ListProviderConnectionsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListProviderConnectionsResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListProviderConnectionsResponse>(null as any);
    }

    payments_ListProviderConnections(): Observable<ListProviderConnectionsResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Payments/ProviderConnections/ListProviderConnections";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPayments_ListProviderConnections(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPayments_ListProviderConnections(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListProviderConnectionsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListProviderConnectionsResponse>;
        }));
    }

    protected processPayments_ListProviderConnections(response: HttpResponseBase): Observable<ListProviderConnectionsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListProviderConnectionsResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListProviderConnectionsResponse>(null as any);
    }

    payments_ListProviderConnectionProfiles(query: ListProviderConnectionProfilesQuery): Observable<ListProviderConnectionProfilesResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Payments/ProviderConnections/ListProviderConnectionProfiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPayments_ListProviderConnectionProfiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPayments_ListProviderConnectionProfiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListProviderConnectionProfilesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListProviderConnectionProfilesResponse>;
        }));
    }

    protected processPayments_ListProviderConnectionProfiles(response: HttpResponseBase): Observable<ListProviderConnectionProfilesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListProviderConnectionProfilesResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListProviderConnectionProfilesResponse>(null as any);
    }

    payments_DisconnectProviderConnection(command: DisconnectProviderConnectionCommand): Observable<ProviderConnectionDto> {
        let url_ = this.baseUrl + "/api/cqrs/Payments/ProviderConnections/DisconnectProviderConnection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPayments_DisconnectProviderConnection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPayments_DisconnectProviderConnection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProviderConnectionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProviderConnectionDto>;
        }));
    }

    protected processPayments_DisconnectProviderConnection(response: HttpResponseBase): Observable<ProviderConnectionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProviderConnectionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProviderConnectionDto>(null as any);
    }

    payments_ConnectProviderWithApiKey(command: ConnectProviderWithApiKeyCommand): Observable<ProviderConnectionDto> {
        let url_ = this.baseUrl + "/api/cqrs/Payments/ProviderConnections/ConnectProviderWithApiKey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPayments_ConnectProviderWithApiKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPayments_ConnectProviderWithApiKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProviderConnectionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProviderConnectionDto>;
        }));
    }

    protected processPayments_ConnectProviderWithApiKey(response: HttpResponseBase): Observable<ProviderConnectionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProviderConnectionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProviderConnectionDto>(null as any);
    }

    payments_CompleteProviderOAuth(command: CompleteProviderOAuthCommand): Observable<CompleteProviderOAuthResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Payments/ProviderConnections/CompleteProviderOAuth";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPayments_CompleteProviderOAuth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPayments_CompleteProviderOAuth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CompleteProviderOAuthResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CompleteProviderOAuthResponse>;
        }));
    }

    protected processPayments_CompleteProviderOAuth(response: HttpResponseBase): Observable<CompleteProviderOAuthResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompleteProviderOAuthResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompleteProviderOAuthResponse>(null as any);
    }

    payments_BeginProviderPlatformOnboarding(command: BeginProviderPlatformOnboardingCommand): Observable<BeginProviderPlatformOnboardingResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Payments/ProviderConnections/BeginProviderPlatformOnboarding";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPayments_BeginProviderPlatformOnboarding(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPayments_BeginProviderPlatformOnboarding(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BeginProviderPlatformOnboardingResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BeginProviderPlatformOnboardingResponse>;
        }));
    }

    protected processPayments_BeginProviderPlatformOnboarding(response: HttpResponseBase): Observable<BeginProviderPlatformOnboardingResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BeginProviderPlatformOnboardingResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BeginProviderPlatformOnboardingResponse>(null as any);
    }

    payments_BeginProviderConnection(command: BeginProviderConnectionCommand): Observable<BeginProviderConnectionResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Payments/ProviderConnections/BeginProviderConnection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPayments_BeginProviderConnection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPayments_BeginProviderConnection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BeginProviderConnectionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BeginProviderConnectionResponse>;
        }));
    }

    protected processPayments_BeginProviderConnection(response: HttpResponseBase): Observable<BeginProviderConnectionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BeginProviderConnectionResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BeginProviderConnectionResponse>(null as any);
    }

    payments_AssignProviderConnectionToPaymentSettings(command: AssignProviderConnectionToPaymentSettingsCommand): Observable<AssignProviderConnectionToPaymentSettingsResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Payments/ProviderConnections/AssignProviderConnectionToPaymentSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPayments_AssignProviderConnectionToPaymentSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPayments_AssignProviderConnectionToPaymentSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignProviderConnectionToPaymentSettingsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignProviderConnectionToPaymentSettingsResponse>;
        }));
    }

    protected processPayments_AssignProviderConnectionToPaymentSettings(response: HttpResponseBase): Observable<AssignProviderConnectionToPaymentSettingsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssignProviderConnectionToPaymentSettingsResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssignProviderConnectionToPaymentSettingsResponse>(null as any);
    }

    participantSegmentation_SplitAgeGroup(command: SplitAgeGroupCommand): Observable<SplitAgeGroupCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/ParticipantSegmentation/SplitAgeGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processParticipantSegmentation_SplitAgeGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processParticipantSegmentation_SplitAgeGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SplitAgeGroupCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SplitAgeGroupCommandResponse>;
        }));
    }

    protected processParticipantSegmentation_SplitAgeGroup(response: HttpResponseBase): Observable<SplitAgeGroupCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SplitAgeGroupCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SplitAgeGroupCommandResponse>(null as any);
    }

    participantSegmentation_SetAgeGroupText(command: SetAgeGroupTextCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/ParticipantSegmentation/SetAgeGroupText";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processParticipantSegmentation_SetAgeGroupText(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processParticipantSegmentation_SetAgeGroupText(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processParticipantSegmentation_SetAgeGroupText(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    participantSegmentation_MergeAgeGroups(command: MergeAgeGroupsCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/ParticipantSegmentation/MergeAgeGroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processParticipantSegmentation_MergeAgeGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processParticipantSegmentation_MergeAgeGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processParticipantSegmentation_MergeAgeGroups(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    participantSegmentation_GetLocationAgeGroupsConfig(): Observable<GetLocationAgeGroupsConfigQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/ParticipantSegmentation/GetLocationAgeGroupsConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processParticipantSegmentation_GetLocationAgeGroupsConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processParticipantSegmentation_GetLocationAgeGroupsConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationAgeGroupsConfigQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationAgeGroupsConfigQueryResult>;
        }));
    }

    protected processParticipantSegmentation_GetLocationAgeGroupsConfig(response: HttpResponseBase): Observable<GetLocationAgeGroupsConfigQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationAgeGroupsConfigQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationAgeGroupsConfigQueryResult>(null as any);
    }

    participantSegmentation_CreateLocationAgeGroups(command: CreateLocationAgeGroupsCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/ParticipantSegmentation/CreateLocationAgeGroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processParticipantSegmentation_CreateLocationAgeGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processParticipantSegmentation_CreateLocationAgeGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processParticipantSegmentation_CreateLocationAgeGroups(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    participantSegmentation_ChangeAgeGroupSortOrder(command: ChangeAgeGroupSortOrderCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/ParticipantSegmentation/ChangeAgeGroupSortOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processParticipantSegmentation_ChangeAgeGroupSortOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processParticipantSegmentation_ChangeAgeGroupSortOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processParticipantSegmentation_ChangeAgeGroupSortOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    participantSegmentation_AdjustAgeGroupBoundary(command: AdjustAgeGroupBoundaryCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/ParticipantSegmentation/AdjustAgeGroupBoundary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processParticipantSegmentation_AdjustAgeGroupBoundary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processParticipantSegmentation_AdjustAgeGroupBoundary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processParticipantSegmentation_AdjustAgeGroupBoundary(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_SyncPeriods(): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/SyncPeriods";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_SyncPeriods(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_SyncPeriods(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_SyncPeriods(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_SetPeriodAdjustedOpeningHours(command: SetPeriodAdjustedOpeningHoursCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/SetPeriodAdjustedOpeningHours";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_SetPeriodAdjustedOpeningHours(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_SetPeriodAdjustedOpeningHours(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_SetPeriodAdjustedOpeningHours(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_ResolveLocationOpeningHoursForDate(query: ResolveLocationOpeningHoursForDateQuery): Observable<ResolveLocationOpeningHoursForDateQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/ResolveLocationOpeningHoursForDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_ResolveLocationOpeningHoursForDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_ResolveLocationOpeningHoursForDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResolveLocationOpeningHoursForDateQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResolveLocationOpeningHoursForDateQueryResult>;
        }));
    }

    protected processOperations_ResolveLocationOpeningHoursForDate(response: HttpResponseBase): Observable<ResolveLocationOpeningHoursForDateQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResolveLocationOpeningHoursForDateQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResolveLocationOpeningHoursForDateQueryResult>(null as any);
    }

    operations_ResetAdjustedDayOfWeekToRegular(command: ResetAdjustedDayOfWeekToRegularCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/ResetAdjustedDayOfWeekToRegular";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_ResetAdjustedDayOfWeekToRegular(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_ResetAdjustedDayOfWeekToRegular(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_ResetAdjustedDayOfWeekToRegular(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_ReplaceSpecialOpeningHoursIntervals(command: ReplaceSpecialOpeningHoursIntervalsCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/ReplaceSpecialOpeningHoursIntervals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_ReplaceSpecialOpeningHoursIntervals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_ReplaceSpecialOpeningHoursIntervals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_ReplaceSpecialOpeningHoursIntervals(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_ReplaceRegularDayOfWeekIntervals(command: ReplaceRegularDayOfWeekIntervalsCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/ReplaceRegularDayOfWeekIntervals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_ReplaceRegularDayOfWeekIntervals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_ReplaceRegularDayOfWeekIntervals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_ReplaceRegularDayOfWeekIntervals(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_ReplaceAdjustedDayOfWeekIntervals(command: ReplaceAdjustedDayOfWeekIntervalsCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/ReplaceAdjustedDayOfWeekIntervals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_ReplaceAdjustedDayOfWeekIntervals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_ReplaceAdjustedDayOfWeekIntervals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_ReplaceAdjustedDayOfWeekIntervals(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_RenameSpecialOpeningHours(command: RenameSpecialOpeningHoursCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/RenameSpecialOpeningHours";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_RenameSpecialOpeningHours(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_RenameSpecialOpeningHours(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_RenameSpecialOpeningHours(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_RenameAdjustedOpeningHours(command: RenameAdjustedOpeningHoursCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/RenameAdjustedOpeningHours";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_RenameAdjustedOpeningHours(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_RenameAdjustedOpeningHours(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_RenameAdjustedOpeningHours(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_RemoveSpecialOpeningHours(command: RemoveSpecialOpeningHoursCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/RemoveSpecialOpeningHours";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_RemoveSpecialOpeningHours(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_RemoveSpecialOpeningHours(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_RemoveSpecialOpeningHours(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_RemoveRegularOpeningHoursVersion(command: RemoveRegularOpeningHoursVersionCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/RemoveRegularOpeningHoursVersion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_RemoveRegularOpeningHoursVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_RemoveRegularOpeningHoursVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_RemoveRegularOpeningHoursVersion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_RemoveAdjustedOpeningHours(command: RemoveAdjustedOpeningHoursCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/RemoveAdjustedOpeningHours";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_RemoveAdjustedOpeningHours(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_RemoveAdjustedOpeningHours(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_RemoveAdjustedOpeningHours(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_ImportLocationOpeningHoursFromLegacy(): Observable<ImportLocationOpeningHoursFromLegacyResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/ImportLocationOpeningHoursFromLegacy";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_ImportLocationOpeningHoursFromLegacy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_ImportLocationOpeningHoursFromLegacy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportLocationOpeningHoursFromLegacyResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportLocationOpeningHoursFromLegacyResponse>;
        }));
    }

    protected processOperations_ImportLocationOpeningHoursFromLegacy(response: HttpResponseBase): Observable<ImportLocationOpeningHoursFromLegacyResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportLocationOpeningHoursFromLegacyResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImportLocationOpeningHoursFromLegacyResponse>(null as any);
    }

    operations_GetLocationOpeningHoursConfig(): Observable<GetLocationOpeningHoursConfigQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/GetLocationOpeningHoursConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_GetLocationOpeningHoursConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_GetLocationOpeningHoursConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationOpeningHoursConfigQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationOpeningHoursConfigQueryResult>;
        }));
    }

    protected processOperations_GetLocationOpeningHoursConfig(response: HttpResponseBase): Observable<GetLocationOpeningHoursConfigQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationOpeningHoursConfigQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationOpeningHoursConfigQueryResult>(null as any);
    }

    operations_GetLocationOpeningHoursCalendar(): Observable<GetLocationOpeningHoursCalendarQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/GetLocationOpeningHoursCalendar";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_GetLocationOpeningHoursCalendar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_GetLocationOpeningHoursCalendar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationOpeningHoursCalendarQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationOpeningHoursCalendarQueryResult>;
        }));
    }

    protected processOperations_GetLocationOpeningHoursCalendar(response: HttpResponseBase): Observable<GetLocationOpeningHoursCalendarQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationOpeningHoursCalendarQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationOpeningHoursCalendarQueryResult>(null as any);
    }

    operations_CreateLocationOpeningHours(): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/CreateLocationOpeningHours";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_CreateLocationOpeningHours(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_CreateLocationOpeningHours(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_CreateLocationOpeningHours(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_CopyRegularDayOfWeek(command: CopyRegularDayOfWeekCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/CopyRegularDayOfWeek";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_CopyRegularDayOfWeek(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_CopyRegularDayOfWeek(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_CopyRegularDayOfWeek(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_CopyAdjustedDayOfWeek(command: CopyAdjustedDayOfWeekCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/CopyAdjustedDayOfWeek";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_CopyAdjustedDayOfWeek(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_CopyAdjustedDayOfWeek(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_CopyAdjustedDayOfWeek(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_ClearPeriodAdjustedOpeningHours(command: ClearPeriodAdjustedOpeningHoursCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/ClearPeriodAdjustedOpeningHours";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_ClearPeriodAdjustedOpeningHours(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_ClearPeriodAdjustedOpeningHours(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_ClearPeriodAdjustedOpeningHours(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_AddSpecialOpeningHours(command: AddSpecialOpeningHoursCommand): Observable<AddSpecialOpeningHoursCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/AddSpecialOpeningHours";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_AddSpecialOpeningHours(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_AddSpecialOpeningHours(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddSpecialOpeningHoursCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddSpecialOpeningHoursCommandResponse>;
        }));
    }

    protected processOperations_AddSpecialOpeningHours(response: HttpResponseBase): Observable<AddSpecialOpeningHoursCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddSpecialOpeningHoursCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddSpecialOpeningHoursCommandResponse>(null as any);
    }

    operations_AddRegularOpeningHoursVersion(command: AddRegularOpeningHoursVersionCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/AddRegularOpeningHoursVersion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_AddRegularOpeningHoursVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_AddRegularOpeningHoursVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_AddRegularOpeningHoursVersion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_AddAdjustedOpeningHours(command: AddAdjustedOpeningHoursCommand): Observable<AddAdjustedOpeningHoursCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/AddAdjustedOpeningHours";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_AddAdjustedOpeningHours(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_AddAdjustedOpeningHours(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddAdjustedOpeningHoursCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddAdjustedOpeningHoursCommandResponse>;
        }));
    }

    protected processOperations_AddAdjustedOpeningHours(response: HttpResponseBase): Observable<AddAdjustedOpeningHoursCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddAdjustedOpeningHoursCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddAdjustedOpeningHoursCommandResponse>(null as any);
    }

    operations_SyncOfferingSchedulePeriods(): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/SyncOfferingSchedulePeriods";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_SyncOfferingSchedulePeriods(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_SyncOfferingSchedulePeriods(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_SyncOfferingSchedulePeriods(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_SyncOfferingScheduleAreas(): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/SyncOfferingScheduleAreas";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_SyncOfferingScheduleAreas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_SyncOfferingScheduleAreas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_SyncOfferingScheduleAreas(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_SetSpecialAreaDay(command: SetSpecialAreaDayCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/SetSpecialAreaDay";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_SetSpecialAreaDay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_SetSpecialAreaDay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_SetSpecialAreaDay(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_SetRegularAreaDay(command: SetRegularAreaDayCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/SetRegularAreaDay";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_SetRegularAreaDay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_SetRegularAreaDay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_SetRegularAreaDay(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_SetRegularAreaDays(command: SetRegularAreaDaysCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/SetRegularAreaDays";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_SetRegularAreaDays(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_SetRegularAreaDays(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_SetRegularAreaDays(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_SetPeriodAdjustedSchedule(command: SetPeriodAdjustedScheduleCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/SetPeriodAdjustedSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_SetPeriodAdjustedSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_SetPeriodAdjustedSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_SetPeriodAdjustedSchedule(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_SetAdjustedAreaDay(command: SetAdjustedAreaDayCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/SetAdjustedAreaDay";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_SetAdjustedAreaDay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_SetAdjustedAreaDay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_SetAdjustedAreaDay(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_ResolveLocationOfferingScheduleForDate(query: ResolveLocationOfferingScheduleForDateQuery): Observable<ResolveLocationOfferingScheduleForDateQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/ResolveLocationOfferingScheduleForDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_ResolveLocationOfferingScheduleForDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_ResolveLocationOfferingScheduleForDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResolveLocationOfferingScheduleForDateQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResolveLocationOfferingScheduleForDateQueryResult>;
        }));
    }

    protected processOperations_ResolveLocationOfferingScheduleForDate(response: HttpResponseBase): Observable<ResolveLocationOfferingScheduleForDateQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResolveLocationOfferingScheduleForDateQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResolveLocationOfferingScheduleForDateQueryResult>(null as any);
    }

    operations_RenameSpecialOfferingSchedule(command: RenameSpecialOfferingScheduleCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/RenameSpecialOfferingSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_RenameSpecialOfferingSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_RenameSpecialOfferingSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_RenameSpecialOfferingSchedule(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_RenameAdjustedOfferingSchedule(command: RenameAdjustedOfferingScheduleCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/RenameAdjustedOfferingSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_RenameAdjustedOfferingSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_RenameAdjustedOfferingSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_RenameAdjustedOfferingSchedule(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_RemoveSpecialOfferingSchedule(command: RemoveSpecialOfferingScheduleCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/RemoveSpecialOfferingSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_RemoveSpecialOfferingSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_RemoveSpecialOfferingSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_RemoveSpecialOfferingSchedule(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_RemoveSpecialAreaSchedule(command: RemoveSpecialAreaScheduleCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/RemoveSpecialAreaSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_RemoveSpecialAreaSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_RemoveSpecialAreaSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_RemoveSpecialAreaSchedule(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_RemoveRegularOfferingScheduleVersion(command: RemoveRegularOfferingScheduleVersionCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/RemoveRegularOfferingScheduleVersion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_RemoveRegularOfferingScheduleVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_RemoveRegularOfferingScheduleVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_RemoveRegularOfferingScheduleVersion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_RemoveRegularAreaSchedule(command: RemoveRegularAreaScheduleCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/RemoveRegularAreaSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_RemoveRegularAreaSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_RemoveRegularAreaSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_RemoveRegularAreaSchedule(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_RemoveAdjustedOfferingSchedule(command: RemoveAdjustedOfferingScheduleCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/RemoveAdjustedOfferingSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_RemoveAdjustedOfferingSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_RemoveAdjustedOfferingSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_RemoveAdjustedOfferingSchedule(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_RemoveAdjustedAreaSchedule(command: RemoveAdjustedAreaScheduleCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/RemoveAdjustedAreaSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_RemoveAdjustedAreaSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_RemoveAdjustedAreaSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_RemoveAdjustedAreaSchedule(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_GetLocationOfferingScheduleConfig(): Observable<GetLocationOfferingScheduleConfigQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/GetLocationOfferingScheduleConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_GetLocationOfferingScheduleConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_GetLocationOfferingScheduleConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationOfferingScheduleConfigQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationOfferingScheduleConfigQueryResult>;
        }));
    }

    protected processOperations_GetLocationOfferingScheduleConfig(response: HttpResponseBase): Observable<GetLocationOfferingScheduleConfigQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationOfferingScheduleConfigQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationOfferingScheduleConfigQueryResult>(null as any);
    }

    operations_CreateLocationOfferingSchedule(): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/CreateLocationOfferingSchedule";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_CreateLocationOfferingSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_CreateLocationOfferingSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_CreateLocationOfferingSchedule(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_ClearPeriodAdjustedSchedule(command: ClearPeriodAdjustedScheduleCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/ClearPeriodAdjustedSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_ClearPeriodAdjustedSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_ClearPeriodAdjustedSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_ClearPeriodAdjustedSchedule(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_ClearAdjustedAreaDay(command: ClearAdjustedAreaDayCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/ClearAdjustedAreaDay";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_ClearAdjustedAreaDay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_ClearAdjustedAreaDay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_ClearAdjustedAreaDay(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_AddSpecialOfferingSchedule(command: AddSpecialOfferingScheduleCommand): Observable<AddSpecialOfferingScheduleCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/AddSpecialOfferingSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_AddSpecialOfferingSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_AddSpecialOfferingSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddSpecialOfferingScheduleCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddSpecialOfferingScheduleCommandResponse>;
        }));
    }

    protected processOperations_AddSpecialOfferingSchedule(response: HttpResponseBase): Observable<AddSpecialOfferingScheduleCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddSpecialOfferingScheduleCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddSpecialOfferingScheduleCommandResponse>(null as any);
    }

    operations_AddRegularOfferingScheduleVersion(command: AddRegularOfferingScheduleVersionCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/AddRegularOfferingScheduleVersion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_AddRegularOfferingScheduleVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_AddRegularOfferingScheduleVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_AddRegularOfferingScheduleVersion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_AddAdjustedOfferingSchedule(command: AddAdjustedOfferingScheduleCommand): Observable<AddAdjustedOfferingScheduleCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/AddAdjustedOfferingSchedule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_AddAdjustedOfferingSchedule(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_AddAdjustedOfferingSchedule(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddAdjustedOfferingScheduleCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddAdjustedOfferingScheduleCommandResponse>;
        }));
    }

    protected processOperations_AddAdjustedOfferingSchedule(response: HttpResponseBase): Observable<AddAdjustedOfferingScheduleCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddAdjustedOfferingScheduleCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddAdjustedOfferingScheduleCommandResponse>(null as any);
    }

    operations_SetActivityOfferingPresetStartPolicy(command: SetActivityOfferingPresetStartPolicyCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/SetActivityOfferingPresetStartPolicy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_SetActivityOfferingPresetStartPolicy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_SetActivityOfferingPresetStartPolicy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_SetActivityOfferingPresetStartPolicy(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_SetActivityOfferingPresetDurationPolicy(command: SetActivityOfferingPresetDurationPolicyCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/SetActivityOfferingPresetDurationPolicy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_SetActivityOfferingPresetDurationPolicy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_SetActivityOfferingPresetDurationPolicy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_SetActivityOfferingPresetDurationPolicy(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_RenameActivityOfferingPreset(command: RenameActivityOfferingPresetCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/RenameActivityOfferingPreset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_RenameActivityOfferingPreset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_RenameActivityOfferingPreset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_RenameActivityOfferingPreset(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_RemoveActivityOfferingPreset(command: RemoveActivityOfferingPresetCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/RemoveActivityOfferingPreset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_RemoveActivityOfferingPreset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_RemoveActivityOfferingPreset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_RemoveActivityOfferingPreset(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_GetActivityOfferingPresets(query: GetActivityOfferingPresetsQuery): Observable<GetActivityOfferingPresetsQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/GetActivityOfferingPresets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_GetActivityOfferingPresets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_GetActivityOfferingPresets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetActivityOfferingPresetsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetActivityOfferingPresetsQueryResult>;
        }));
    }

    protected processOperations_GetActivityOfferingPresets(response: HttpResponseBase): Observable<GetActivityOfferingPresetsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetActivityOfferingPresetsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetActivityOfferingPresetsQueryResult>(null as any);
    }

    operations_AddActivityOfferingPreset(command: AddActivityOfferingPresetCommand): Observable<AddActivityOfferingPresetCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/AddActivityOfferingPreset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_AddActivityOfferingPreset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_AddActivityOfferingPreset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddActivityOfferingPresetCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddActivityOfferingPresetCommandResponse>;
        }));
    }

    protected processOperations_AddActivityOfferingPreset(response: HttpResponseBase): Observable<AddActivityOfferingPresetCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddActivityOfferingPresetCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddActivityOfferingPresetCommandResponse>(null as any);
    }

    operations_GetActivityOfferingDurationsInUse(query: GetActivityOfferingDurationsInUseQuery): Observable<GetActivityOfferingDurationsInUseQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/GetActivityOfferingDurationsInUse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_GetActivityOfferingDurationsInUse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_GetActivityOfferingDurationsInUse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetActivityOfferingDurationsInUseQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetActivityOfferingDurationsInUseQueryResult>;
        }));
    }

    protected processOperations_GetActivityOfferingDurationsInUse(response: HttpResponseBase): Observable<GetActivityOfferingDurationsInUseQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetActivityOfferingDurationsInUseQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetActivityOfferingDurationsInUseQueryResult>(null as any);
    }

    operations_ResolveLocationCalendarForDate(query: ResolveLocationCalendarForDateQuery): Observable<ResolveLocationCalendarForDateQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/ResolveLocationCalendarForDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_ResolveLocationCalendarForDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_ResolveLocationCalendarForDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResolveLocationCalendarForDateQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResolveLocationCalendarForDateQueryResult>;
        }));
    }

    protected processOperations_ResolveLocationCalendarForDate(response: HttpResponseBase): Observable<ResolveLocationCalendarForDateQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResolveLocationCalendarForDateQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResolveLocationCalendarForDateQueryResult>(null as any);
    }

    operations_RescheduleCalendarPeriod(command: RescheduleCalendarPeriodCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/RescheduleCalendarPeriod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_RescheduleCalendarPeriod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_RescheduleCalendarPeriod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_RescheduleCalendarPeriod(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_RenameCalendarPeriod(command: RenameCalendarPeriodCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/RenameCalendarPeriod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_RenameCalendarPeriod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_RenameCalendarPeriod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_RenameCalendarPeriod(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_RemoveCalendarPeriod(command: RemoveCalendarPeriodCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/RemoveCalendarPeriod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_RemoveCalendarPeriod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_RemoveCalendarPeriod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_RemoveCalendarPeriod(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_PruneExpiredAnnualCalendars(): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/PruneExpiredAnnualCalendars";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_PruneExpiredAnnualCalendars(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_PruneExpiredAnnualCalendars(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_PruneExpiredAnnualCalendars(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_ImportLocationCalendarFromLegacy(command: ImportLocationCalendarFromLegacyCommand): Observable<ImportLocationCalendarFromLegacyResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/ImportLocationCalendarFromLegacy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_ImportLocationCalendarFromLegacy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_ImportLocationCalendarFromLegacy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImportLocationCalendarFromLegacyResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImportLocationCalendarFromLegacyResponse>;
        }));
    }

    protected processOperations_ImportLocationCalendarFromLegacy(response: HttpResponseBase): Observable<ImportLocationCalendarFromLegacyResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportLocationCalendarFromLegacyResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ImportLocationCalendarFromLegacyResponse>(null as any);
    }

    operations_GetLocationCalendarConfig(): Observable<GetLocationCalendarConfigQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/GetLocationCalendarConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_GetLocationCalendarConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_GetLocationCalendarConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationCalendarConfigQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationCalendarConfigQueryResult>;
        }));
    }

    protected processOperations_GetLocationCalendarConfig(response: HttpResponseBase): Observable<GetLocationCalendarConfigQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationCalendarConfigQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationCalendarConfigQueryResult>(null as any);
    }

    operations_CreateLocationCalendar(command: CreateLocationCalendarCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/CreateLocationCalendar";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_CreateLocationCalendar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_CreateLocationCalendar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_CreateLocationCalendar(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_ChangeAnnualCalendarStartMonth(command: ChangeAnnualCalendarStartMonthCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/ChangeAnnualCalendarStartMonth";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_ChangeAnnualCalendarStartMonth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_ChangeAnnualCalendarStartMonth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_ChangeAnnualCalendarStartMonth(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_CanChangeAnnualCalendarStartMonth(query: CanChangeAnnualCalendarStartMonthQuery): Observable<CanChangeAnnualCalendarStartMonthQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/CanChangeAnnualCalendarStartMonth";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_CanChangeAnnualCalendarStartMonth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_CanChangeAnnualCalendarStartMonth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CanChangeAnnualCalendarStartMonthQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CanChangeAnnualCalendarStartMonthQueryResult>;
        }));
    }

    protected processOperations_CanChangeAnnualCalendarStartMonth(response: HttpResponseBase): Observable<CanChangeAnnualCalendarStartMonthQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CanChangeAnnualCalendarStartMonthQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CanChangeAnnualCalendarStartMonthQueryResult>(null as any);
    }

    operations_AddNextAnnualCalendar(): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/AddNextAnnualCalendar";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_AddNextAnnualCalendar(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_AddNextAnnualCalendar(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_AddNextAnnualCalendar(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_AddCalendarPeriod(command: AddCalendarPeriodCommand): Observable<AddCalendarPeriodCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/AddCalendarPeriod";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_AddCalendarPeriod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_AddCalendarPeriod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddCalendarPeriodCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddCalendarPeriodCommandResponse>;
        }));
    }

    protected processOperations_AddCalendarPeriod(response: HttpResponseBase): Observable<AddCalendarPeriodCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddCalendarPeriodCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddCalendarPeriodCommandResponse>(null as any);
    }

    operations_SetActivityResourcePool(command: SetActivityResourcePoolCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/SetActivityResourcePool";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_SetActivityResourcePool(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_SetActivityResourcePool(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_SetActivityResourcePool(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_SetActivityResourcePoolPolicy(command: SetActivityResourcePoolPolicyCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/SetActivityResourcePoolPolicy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_SetActivityResourcePoolPolicy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_SetActivityResourcePoolPolicy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOperations_SetActivityResourcePoolPolicy(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    operations_GetActivityResourcePool(query: GetActivityResourcePoolQuery): Observable<GetActivityResourcePoolQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/GetActivityResourcePool";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_GetActivityResourcePool(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_GetActivityResourcePool(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetActivityResourcePoolQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetActivityResourcePoolQueryResult>;
        }));
    }

    protected processOperations_GetActivityResourcePool(response: HttpResponseBase): Observable<GetActivityResourcePoolQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetActivityResourcePoolQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetActivityResourcePoolQueryResult>(null as any);
    }

    operations_GetActivityAreaPlacements(): Observable<GetActivityAreaPlacementsQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Operations/GetActivityAreaPlacements";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOperations_GetActivityAreaPlacements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOperations_GetActivityAreaPlacements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetActivityAreaPlacementsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetActivityAreaPlacementsQueryResult>;
        }));
    }

    protected processOperations_GetActivityAreaPlacements(response: HttpResponseBase): Observable<GetActivityAreaPlacementsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetActivityAreaPlacementsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetActivityAreaPlacementsQueryResult>(null as any);
    }

    offers_ProgramGroup_GetProgramGroupListPageView(query: GetProgramGroupListPageViewQuery): Observable<GetProgramGroupListPageViewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Offers/ProgramGroup/GetProgramGroupListPageView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOffers_ProgramGroup_GetProgramGroupListPageView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOffers_ProgramGroup_GetProgramGroupListPageView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProgramGroupListPageViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProgramGroupListPageViewQueryResult>;
        }));
    }

    protected processOffers_ProgramGroup_GetProgramGroupListPageView(response: HttpResponseBase): Observable<GetProgramGroupListPageViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProgramGroupListPageViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProgramGroupListPageViewQueryResult>(null as any);
    }

    offers_ProgramGroup_GetProgramGroupEditItemView(query: GetProgramGroupEditItemViewQuery): Observable<GetProgramGroupEditItemViewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Offers/ProgramGroup/GetProgramGroupEditItemView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOffers_ProgramGroup_GetProgramGroupEditItemView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOffers_ProgramGroup_GetProgramGroupEditItemView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProgramGroupEditItemViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProgramGroupEditItemViewQueryResult>;
        }));
    }

    protected processOffers_ProgramGroup_GetProgramGroupEditItemView(response: HttpResponseBase): Observable<GetProgramGroupEditItemViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProgramGroupEditItemViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProgramGroupEditItemViewQueryResult>(null as any);
    }

    offers_ProgramGroup_GetProgramGroupEditItemProgramsView(query: GetProgramGroupEditItemProgramsViewQuery): Observable<GetProgramGroupEditItemProgramsViewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Offers/ProgramGroup/GetProgramGroupEditItemProgramsView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOffers_ProgramGroup_GetProgramGroupEditItemProgramsView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOffers_ProgramGroup_GetProgramGroupEditItemProgramsView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProgramGroupEditItemProgramsViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProgramGroupEditItemProgramsViewQueryResult>;
        }));
    }

    protected processOffers_ProgramGroup_GetProgramGroupEditItemProgramsView(response: HttpResponseBase): Observable<GetProgramGroupEditItemProgramsViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProgramGroupEditItemProgramsViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProgramGroupEditItemProgramsViewQueryResult>(null as any);
    }

    offers_ProgramGroup_GetProgramGroupAddDialogView(query: GetProgramGroupAddDialogViewQuery): Observable<GetProgramGroupAddDialogViewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Offers/ProgramGroup/GetProgramGroupAddDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processOffers_ProgramGroup_GetProgramGroupAddDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOffers_ProgramGroup_GetProgramGroupAddDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProgramGroupAddDialogViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProgramGroupAddDialogViewQueryResult>;
        }));
    }

    protected processOffers_ProgramGroup_GetProgramGroupAddDialogView(response: HttpResponseBase): Observable<GetProgramGroupAddDialogViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProgramGroupAddDialogViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProgramGroupAddDialogViewQueryResult>(null as any);
    }

    notes_GetNotesDataView(query: GetNotesDataViewQuery): Observable<GetNotesDataViewQueryResult> {
        let url_ = this.baseUrl + "/Notes/GetNotesDataView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processNotes_GetNotesDataView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotes_GetNotesDataView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNotesDataViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNotesDataViewQueryResult>;
        }));
    }

    protected processNotes_GetNotesDataView(response: HttpResponseBase): Observable<GetNotesDataViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetNotesDataViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNotesDataViewQueryResult>(null as any);
    }

    notes_GetNoteListView(query: GetNoteListViewQuery): Observable<GetNoteListViewQueryResult> {
        let url_ = this.baseUrl + "/Notes/GetNoteListView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processNotes_GetNoteListView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotes_GetNoteListView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNoteListViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNoteListViewQueryResult>;
        }));
    }

    protected processNotes_GetNoteListView(response: HttpResponseBase): Observable<GetNoteListViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetNoteListViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNoteListViewQueryResult>(null as any);
    }

    notes_GetNoteListTodayView(query: GetNoteListTodayViewQuery): Observable<GetNoteListTodayViewQueryResult> {
        let url_ = this.baseUrl + "/Notes/GetNoteListTodayView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processNotes_GetNoteListTodayView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotes_GetNoteListTodayView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNoteListTodayViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNoteListTodayViewQueryResult>;
        }));
    }

    protected processNotes_GetNoteListTodayView(response: HttpResponseBase): Observable<GetNoteListTodayViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetNoteListTodayViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNoteListTodayViewQueryResult>(null as any);
    }

    notes_GetNoteListCalendarView(query: GetNoteListCalendarViewQuery): Observable<GetNoteListCalendarViewQueryResult> {
        let url_ = this.baseUrl + "/Notes/GetNoteListCalendarView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processNotes_GetNoteListCalendarView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotes_GetNoteListCalendarView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNoteListCalendarViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNoteListCalendarViewQueryResult>;
        }));
    }

    protected processNotes_GetNoteListCalendarView(response: HttpResponseBase): Observable<GetNoteListCalendarViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetNoteListCalendarViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNoteListCalendarViewQueryResult>(null as any);
    }

    notes_GetNoteListCalendarDataView(query: GetNoteListCalendarDataViewQuery): Observable<GetNoteListCalendarDataViewQueryResult> {
        let url_ = this.baseUrl + "/Notes/GetNoteListCalendarDataView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processNotes_GetNoteListCalendarDataView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotes_GetNoteListCalendarDataView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNoteListCalendarDataViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNoteListCalendarDataViewQueryResult>;
        }));
    }

    protected processNotes_GetNoteListCalendarDataView(response: HttpResponseBase): Observable<GetNoteListCalendarDataViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetNoteListCalendarDataViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNoteListCalendarDataViewQueryResult>(null as any);
    }

    notes_GetNoteItem(query: GetNoteItemQuery): Observable<GetNoteItemQueryResult> {
        let url_ = this.baseUrl + "/Notes/GetNoteItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processNotes_GetNoteItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotes_GetNoteItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNoteItemQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNoteItemQueryResult>;
        }));
    }

    protected processNotes_GetNoteItem(response: HttpResponseBase): Observable<GetNoteItemQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetNoteItemQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNoteItemQueryResult>(null as any);
    }

    notes_GetNoteDetailsDialogView(query: GetNoteDetailsDialogViewQuery): Observable<GetNoteDetailsDialogViewQueryResult> {
        let url_ = this.baseUrl + "/Notes/GetNoteDetailsDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processNotes_GetNoteDetailsDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotes_GetNoteDetailsDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNoteDetailsDialogViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNoteDetailsDialogViewQueryResult>;
        }));
    }

    protected processNotes_GetNoteDetailsDialogView(response: HttpResponseBase): Observable<GetNoteDetailsDialogViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetNoteDetailsDialogViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetNoteDetailsDialogViewQueryResult>(null as any);
    }

    monitoring_RunPosStatusCheck(command: RunPosStatusCheckCommand): Observable<RunPosStatusCheckCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Monitoring/RunPosStatusCheck";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processMonitoring_RunPosStatusCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMonitoring_RunPosStatusCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RunPosStatusCheckCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RunPosStatusCheckCommandResponse>;
        }));
    }

    protected processMonitoring_RunPosStatusCheck(response: HttpResponseBase): Observable<RunPosStatusCheckCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RunPosStatusCheckCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RunPosStatusCheckCommandResponse>(null as any);
    }

    monitoring_GetPosStatusListPageView(query: GetPosStatusListPageViewQuery): Observable<GetPosStatusListPageViewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Monitoring/GetPosStatusListPageView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processMonitoring_GetPosStatusListPageView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMonitoring_GetPosStatusListPageView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPosStatusListPageViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPosStatusListPageViewQueryResult>;
        }));
    }

    protected processMonitoring_GetPosStatusListPageView(response: HttpResponseBase): Observable<GetPosStatusListPageViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPosStatusListPageViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPosStatusListPageViewQueryResult>(null as any);
    }

    locationMarketing_GetLocationSocialSettingsPageView(query: GetLocationSocialSettingsPageViewQuery): Observable<GetLocationSocialSettingsPageViewQueryResult> {
        let url_ = this.baseUrl + "/LocationMarketing/GetLocationSocialSettingsPageView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationMarketing_GetLocationSocialSettingsPageView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationMarketing_GetLocationSocialSettingsPageView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationSocialSettingsPageViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationSocialSettingsPageViewQueryResult>;
        }));
    }

    protected processLocationMarketing_GetLocationSocialSettingsPageView(response: HttpResponseBase): Observable<GetLocationSocialSettingsPageViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationSocialSettingsPageViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationSocialSettingsPageViewQueryResult>(null as any);
    }

    locations_IsLocationIdCodeInUse(query: IsLocationIdCodeInUseQuery): Observable<IsLocationIdCodeInUseQueryResult> {
        let url_ = this.baseUrl + "/Locations/IsLocationIdCodeInUse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocations_IsLocationIdCodeInUse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocations_IsLocationIdCodeInUse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsLocationIdCodeInUseQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsLocationIdCodeInUseQueryResult>;
        }));
    }

    protected processLocations_IsLocationIdCodeInUse(response: HttpResponseBase): Observable<IsLocationIdCodeInUseQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IsLocationIdCodeInUseQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IsLocationIdCodeInUseQueryResult>(null as any);
    }

    locations_GetLocationsOpenDatesForMonth(query: GetLocationOpenDatesForMonthQuery): Observable<GetLocationOpenDatesForMonthQueryResult> {
        let url_ = this.baseUrl + "/Locations/GetLocationsOpenDatesForMonth";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocations_GetLocationsOpenDatesForMonth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocations_GetLocationsOpenDatesForMonth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationOpenDatesForMonthQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationOpenDatesForMonthQueryResult>;
        }));
    }

    protected processLocations_GetLocationsOpenDatesForMonth(response: HttpResponseBase): Observable<GetLocationOpenDatesForMonthQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationOpenDatesForMonthQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationOpenDatesForMonthQueryResult>(null as any);
    }

    locationSnapshots_ResolveLocationSnapshotBooking(query: ResolveLocationSnapshotBookingQuery): Observable<ResolveLocationSnapshotBookingQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/LocationSnapshots/ResolveLocationSnapshotBooking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSnapshots_ResolveLocationSnapshotBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSnapshots_ResolveLocationSnapshotBooking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResolveLocationSnapshotBookingQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResolveLocationSnapshotBookingQueryResult>;
        }));
    }

    protected processLocationSnapshots_ResolveLocationSnapshotBooking(response: HttpResponseBase): Observable<ResolveLocationSnapshotBookingQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResolveLocationSnapshotBookingQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResolveLocationSnapshotBookingQueryResult>(null as any);
    }

    locationSnapshots_RequestLocationSnapshot(command: RequestLocationSnapshotCommand): Observable<RequestLocationSnapshotCommandResult> {
        let url_ = this.baseUrl + "/api/cqrs/LocationSnapshots/RequestLocationSnapshot";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSnapshots_RequestLocationSnapshot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSnapshots_RequestLocationSnapshot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequestLocationSnapshotCommandResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequestLocationSnapshotCommandResult>;
        }));
    }

    protected processLocationSnapshots_RequestLocationSnapshot(response: HttpResponseBase): Observable<RequestLocationSnapshotCommandResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RequestLocationSnapshotCommandResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RequestLocationSnapshotCommandResult>(null as any);
    }

    locationSnapshots_GetLocationSnapshotSourceTenants(): Observable<GetLocationSnapshotSourceTenantsQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/LocationSnapshots/GetLocationSnapshotSourceTenants";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSnapshots_GetLocationSnapshotSourceTenants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSnapshots_GetLocationSnapshotSourceTenants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationSnapshotSourceTenantsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationSnapshotSourceTenantsQueryResult>;
        }));
    }

    protected processLocationSnapshots_GetLocationSnapshotSourceTenants(response: HttpResponseBase): Observable<GetLocationSnapshotSourceTenantsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationSnapshotSourceTenantsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationSnapshotSourceTenantsQueryResult>(null as any);
    }

    locationSnapshots_GetLocationSnapshotSourceLocations(query: GetLocationSnapshotSourceLocationsQuery): Observable<GetLocationSnapshotSourceLocationsQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/LocationSnapshots/GetLocationSnapshotSourceLocations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSnapshots_GetLocationSnapshotSourceLocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSnapshots_GetLocationSnapshotSourceLocations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationSnapshotSourceLocationsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationSnapshotSourceLocationsQueryResult>;
        }));
    }

    protected processLocationSnapshots_GetLocationSnapshotSourceLocations(response: HttpResponseBase): Observable<GetLocationSnapshotSourceLocationsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationSnapshotSourceLocationsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationSnapshotSourceLocationsQueryResult>(null as any);
    }

    locationSnapshots_GetLocationSnapshotRuns(): Observable<GetLocationSnapshotRunsQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/LocationSnapshots/GetLocationSnapshotRuns";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSnapshots_GetLocationSnapshotRuns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSnapshots_GetLocationSnapshotRuns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationSnapshotRunsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationSnapshotRunsQueryResult>;
        }));
    }

    protected processLocationSnapshots_GetLocationSnapshotRuns(response: HttpResponseBase): Observable<GetLocationSnapshotRunsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationSnapshotRunsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationSnapshotRunsQueryResult>(null as any);
    }

    locationSnapshots_DeleteLocationSnapshot(command: DeleteLocationSnapshotCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/LocationSnapshots/DeleteLocationSnapshot";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSnapshots_DeleteLocationSnapshot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSnapshots_DeleteLocationSnapshot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLocationSnapshots_DeleteLocationSnapshot(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    locationSettings_UpdateLocationBookingSettings(command: UpdateLocationBookingSettingsCommand): Observable<void> {
        let url_ = this.baseUrl + "/LocationSettings/UpdateLocationBookingSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettings_UpdateLocationBookingSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettings_UpdateLocationBookingSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLocationSettings_UpdateLocationBookingSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    locationSettings_GetLocationUnitListPageView(query: GetLocationUnitListPageViewQuery): Observable<GetLocationUnitListPageViewQueryResult> {
        let url_ = this.baseUrl + "/LocationSettings/GetLocationUnitListPageView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettings_GetLocationUnitListPageView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettings_GetLocationUnitListPageView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationUnitListPageViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationUnitListPageViewQueryResult>;
        }));
    }

    protected processLocationSettings_GetLocationUnitListPageView(response: HttpResponseBase): Observable<GetLocationUnitListPageViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationUnitListPageViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationUnitListPageViewQueryResult>(null as any);
    }

    locationSettings_GetLocationUnitFormDialogView(query: GetLocationUnitFormDialogViewQuery): Observable<GetLocationUnitFormDialogViewQueryResult> {
        let url_ = this.baseUrl + "/LocationSettings/GetLocationUnitFormDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettings_GetLocationUnitFormDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettings_GetLocationUnitFormDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationUnitFormDialogViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationUnitFormDialogViewQueryResult>;
        }));
    }

    protected processLocationSettings_GetLocationUnitFormDialogView(response: HttpResponseBase): Observable<GetLocationUnitFormDialogViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationUnitFormDialogViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationUnitFormDialogViewQueryResult>(null as any);
    }

    locationSettings_GetLocationSurveyQuestionListPageView(query: GetLocationSurveyQuestionListPageViewQuery): Observable<GetLocationSurveyQuestionListPageViewQueryResult> {
        let url_ = this.baseUrl + "/LocationSettings/GetLocationSurveyQuestionListPageView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettings_GetLocationSurveyQuestionListPageView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettings_GetLocationSurveyQuestionListPageView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationSurveyQuestionListPageViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationSurveyQuestionListPageViewQueryResult>;
        }));
    }

    protected processLocationSettings_GetLocationSurveyQuestionListPageView(response: HttpResponseBase): Observable<GetLocationSurveyQuestionListPageViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationSurveyQuestionListPageViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationSurveyQuestionListPageViewQueryResult>(null as any);
    }

    locationSettings_GetLocationSurveyQuestionItemTabsPageView(query: GetLocationSurveyQuestionItemTabsPageViewQuery): Observable<GetLocationSurveyQuestionItemTabsPageViewQueryResult> {
        let url_ = this.baseUrl + "/LocationSettings/GetLocationSurveyQuestionItemTabsPageView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettings_GetLocationSurveyQuestionItemTabsPageView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettings_GetLocationSurveyQuestionItemTabsPageView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationSurveyQuestionItemTabsPageViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationSurveyQuestionItemTabsPageViewQueryResult>;
        }));
    }

    protected processLocationSettings_GetLocationSurveyQuestionItemTabsPageView(response: HttpResponseBase): Observable<GetLocationSurveyQuestionItemTabsPageViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationSurveyQuestionItemTabsPageViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationSurveyQuestionItemTabsPageViewQueryResult>(null as any);
    }

    locationSettings_GetLocationSurveyQuestionItemGeneralPageView(query: GetLocationSurveyQuestionItemGeneralPageViewQuery): Observable<GetLocationSurveyQuestionItemGeneralPageViewQueryResult> {
        let url_ = this.baseUrl + "/LocationSettings/GetLocationSurveyQuestionItemGeneralPageView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettings_GetLocationSurveyQuestionItemGeneralPageView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettings_GetLocationSurveyQuestionItemGeneralPageView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationSurveyQuestionItemGeneralPageViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationSurveyQuestionItemGeneralPageViewQueryResult>;
        }));
    }

    protected processLocationSettings_GetLocationSurveyQuestionItemGeneralPageView(response: HttpResponseBase): Observable<GetLocationSurveyQuestionItemGeneralPageViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationSurveyQuestionItemGeneralPageViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationSurveyQuestionItemGeneralPageViewQueryResult>(null as any);
    }

    locationSettings_GetLocationSurveyQuestionFormDialogView(query: GetLocationSurveyQuestionFormDialogViewQuery): Observable<GetLocationSurveyQuestionFormDialogViewQueryResult> {
        let url_ = this.baseUrl + "/LocationSettings/GetLocationSurveyQuestionFormDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettings_GetLocationSurveyQuestionFormDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettings_GetLocationSurveyQuestionFormDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationSurveyQuestionFormDialogViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationSurveyQuestionFormDialogViewQueryResult>;
        }));
    }

    protected processLocationSettings_GetLocationSurveyQuestionFormDialogView(response: HttpResponseBase): Observable<GetLocationSurveyQuestionFormDialogViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationSurveyQuestionFormDialogViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationSurveyQuestionFormDialogViewQueryResult>(null as any);
    }

    locationSettings_GetLocationScheduleBoardListView(query: GetLocationScheduleBoardListViewQuery): Observable<GetLocationScheduleBoardListViewQueryResult> {
        let url_ = this.baseUrl + "/LocationSettings/GetLocationScheduleBoardListView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettings_GetLocationScheduleBoardListView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettings_GetLocationScheduleBoardListView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationScheduleBoardListViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationScheduleBoardListViewQueryResult>;
        }));
    }

    protected processLocationSettings_GetLocationScheduleBoardListView(response: HttpResponseBase): Observable<GetLocationScheduleBoardListViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationScheduleBoardListViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationScheduleBoardListViewQueryResult>(null as any);
    }

    locationSettings_GetLocationScheduleBoardEditItemView(query: GetLocationScheduleBoardEditItemViewQuery): Observable<GetLocationScheduleBoardEditItemViewQueryResult> {
        let url_ = this.baseUrl + "/LocationSettings/GetLocationScheduleBoardEditItemView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettings_GetLocationScheduleBoardEditItemView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettings_GetLocationScheduleBoardEditItemView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationScheduleBoardEditItemViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationScheduleBoardEditItemViewQueryResult>;
        }));
    }

    protected processLocationSettings_GetLocationScheduleBoardEditItemView(response: HttpResponseBase): Observable<GetLocationScheduleBoardEditItemViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationScheduleBoardEditItemViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationScheduleBoardEditItemViewQueryResult>(null as any);
    }

    locationSettings_GetLocationScheduleBoardEditItemResourcesView(query: GetLocationScheduleBoardEditItemResourcesViewQuery): Observable<GetLocationScheduleBoardEditItemResourcesViewQueryResult> {
        let url_ = this.baseUrl + "/LocationSettings/GetLocationScheduleBoardEditItemResourcesView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettings_GetLocationScheduleBoardEditItemResourcesView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettings_GetLocationScheduleBoardEditItemResourcesView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationScheduleBoardEditItemResourcesViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationScheduleBoardEditItemResourcesViewQueryResult>;
        }));
    }

    protected processLocationSettings_GetLocationScheduleBoardEditItemResourcesView(response: HttpResponseBase): Observable<GetLocationScheduleBoardEditItemResourcesViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationScheduleBoardEditItemResourcesViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationScheduleBoardEditItemResourcesViewQueryResult>(null as any);
    }

    locationSettings_GetLocationResourceConfigResourceTypesPageView(query: GetLocationResourceConfigResourceTypesPageViewQuery): Observable<GetLocationResourceConfigResourceTypesPageViewQueryResult> {
        let url_ = this.baseUrl + "/LocationSettings/GetLocationResourceConfigResourceTypesPageView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettings_GetLocationResourceConfigResourceTypesPageView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettings_GetLocationResourceConfigResourceTypesPageView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationResourceConfigResourceTypesPageViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationResourceConfigResourceTypesPageViewQueryResult>;
        }));
    }

    protected processLocationSettings_GetLocationResourceConfigResourceTypesPageView(response: HttpResponseBase): Observable<GetLocationResourceConfigResourceTypesPageViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationResourceConfigResourceTypesPageViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationResourceConfigResourceTypesPageViewQueryResult>(null as any);
    }

    locationSettings_GetLocationResourceConfigResourceTypeFormDialogView(query: GetLocationResourceConfigResourceTypeFormDialogViewQuery): Observable<GetLocationResourceConfigResourceTypeFormDialogViewQueryResult> {
        let url_ = this.baseUrl + "/LocationSettings/GetLocationResourceConfigResourceTypeFormDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettings_GetLocationResourceConfigResourceTypeFormDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettings_GetLocationResourceConfigResourceTypeFormDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationResourceConfigResourceTypeFormDialogViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationResourceConfigResourceTypeFormDialogViewQueryResult>;
        }));
    }

    protected processLocationSettings_GetLocationResourceConfigResourceTypeFormDialogView(response: HttpResponseBase): Observable<GetLocationResourceConfigResourceTypeFormDialogViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationResourceConfigResourceTypeFormDialogViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationResourceConfigResourceTypeFormDialogViewQueryResult>(null as any);
    }

    locationSettings_GetLocationResourceConfigResourcesPageView(query: GetLocationResourceConfigResourcesPageViewQuery): Observable<GetLocationResourceConfigResourcesPageViewQueryResult> {
        let url_ = this.baseUrl + "/LocationSettings/GetLocationResourceConfigResourcesPageView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettings_GetLocationResourceConfigResourcesPageView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettings_GetLocationResourceConfigResourcesPageView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationResourceConfigResourcesPageViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationResourceConfigResourcesPageViewQueryResult>;
        }));
    }

    protected processLocationSettings_GetLocationResourceConfigResourcesPageView(response: HttpResponseBase): Observable<GetLocationResourceConfigResourcesPageViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationResourceConfigResourcesPageViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationResourceConfigResourcesPageViewQueryResult>(null as any);
    }

    locationSettings_GetLocationResourceConfigResourceFormDialogView(query: GetLocationResourceConfigResourceFormDialogViewQuery): Observable<GetLocationResourceConfigResourceFormDialogViewQueryResult> {
        let url_ = this.baseUrl + "/LocationSettings/GetLocationResourceConfigResourceFormDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettings_GetLocationResourceConfigResourceFormDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettings_GetLocationResourceConfigResourceFormDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationResourceConfigResourceFormDialogViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationResourceConfigResourceFormDialogViewQueryResult>;
        }));
    }

    protected processLocationSettings_GetLocationResourceConfigResourceFormDialogView(response: HttpResponseBase): Observable<GetLocationResourceConfigResourceFormDialogViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationResourceConfigResourceFormDialogViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationResourceConfigResourceFormDialogViewQueryResult>(null as any);
    }

    locationSettings_GetLocationResourceConfigResourceCategoryPageView(query: GetLocationResourceConfigResourceCategoryPageViewQuery): Observable<GetLocationResourceConfigResourceCategoryPageViewQueryResult> {
        let url_ = this.baseUrl + "/LocationSettings/GetLocationResourceConfigResourceCategoryPageView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettings_GetLocationResourceConfigResourceCategoryPageView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettings_GetLocationResourceConfigResourceCategoryPageView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationResourceConfigResourceCategoryPageViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationResourceConfigResourceCategoryPageViewQueryResult>;
        }));
    }

    protected processLocationSettings_GetLocationResourceConfigResourceCategoryPageView(response: HttpResponseBase): Observable<GetLocationResourceConfigResourceCategoryPageViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationResourceConfigResourceCategoryPageViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationResourceConfigResourceCategoryPageViewQueryResult>(null as any);
    }

    locationSettings_GetLocationResourceConfigResourceCategoryEditDialogView(query: GetLocationResourceConfigResourceCategoryEditDialogViewQuery): Observable<GetLocationResourceConfigResourceCategoryEditDialogViewQueryResult> {
        let url_ = this.baseUrl + "/LocationSettings/GetLocationResourceConfigResourceCategoryEditDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettings_GetLocationResourceConfigResourceCategoryEditDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettings_GetLocationResourceConfigResourceCategoryEditDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationResourceConfigResourceCategoryEditDialogViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationResourceConfigResourceCategoryEditDialogViewQueryResult>;
        }));
    }

    protected processLocationSettings_GetLocationResourceConfigResourceCategoryEditDialogView(response: HttpResponseBase): Observable<GetLocationResourceConfigResourceCategoryEditDialogViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationResourceConfigResourceCategoryEditDialogViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationResourceConfigResourceCategoryEditDialogViewQueryResult>(null as any);
    }

    locationSettings_GetLocationResourceConfigResourceCategoryAddDialogView(query: GetLocationResourceConfigResourceCategoryAddDialogViewQuery): Observable<GetLocationResourceConfigResourceCategoryAddDialogViewQueryResult> {
        let url_ = this.baseUrl + "/LocationSettings/GetLocationResourceConfigResourceCategoryAddDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettings_GetLocationResourceConfigResourceCategoryAddDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettings_GetLocationResourceConfigResourceCategoryAddDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationResourceConfigResourceCategoryAddDialogViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationResourceConfigResourceCategoryAddDialogViewQueryResult>;
        }));
    }

    protected processLocationSettings_GetLocationResourceConfigResourceCategoryAddDialogView(response: HttpResponseBase): Observable<GetLocationResourceConfigResourceCategoryAddDialogViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationResourceConfigResourceCategoryAddDialogViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationResourceConfigResourceCategoryAddDialogViewQueryResult>(null as any);
    }

    locationSettings_GetLocationResourceConfigAreaSectionFormDialogView(query: GetLocationResourceConfigAreaSectionFormDialogViewQuery): Observable<GetLocationResourceConfigAreaSectionFormDialogViewQueryResult> {
        let url_ = this.baseUrl + "/LocationSettings/GetLocationResourceConfigAreaSectionFormDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettings_GetLocationResourceConfigAreaSectionFormDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettings_GetLocationResourceConfigAreaSectionFormDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationResourceConfigAreaSectionFormDialogViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationResourceConfigAreaSectionFormDialogViewQueryResult>;
        }));
    }

    protected processLocationSettings_GetLocationResourceConfigAreaSectionFormDialogView(response: HttpResponseBase): Observable<GetLocationResourceConfigAreaSectionFormDialogViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationResourceConfigAreaSectionFormDialogViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationResourceConfigAreaSectionFormDialogViewQueryResult>(null as any);
    }

    locationSettings_GetLocationResourceConfigAreaFormDialogView(query: GetLocationResourceConfigAreaFormDialogViewQuery): Observable<GetLocationResourceConfigAreaFormDialogViewQueryResult> {
        let url_ = this.baseUrl + "/LocationSettings/GetLocationResourceConfigAreaFormDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettings_GetLocationResourceConfigAreaFormDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettings_GetLocationResourceConfigAreaFormDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationResourceConfigAreaFormDialogViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationResourceConfigAreaFormDialogViewQueryResult>;
        }));
    }

    protected processLocationSettings_GetLocationResourceConfigAreaFormDialogView(response: HttpResponseBase): Observable<GetLocationResourceConfigAreaFormDialogViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationResourceConfigAreaFormDialogViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationResourceConfigAreaFormDialogViewQueryResult>(null as any);
    }

    locationSettings_GetLocationPeriodEditDialogView(query: GetLocationPeriodEditDialogViewQuery): Observable<GetLocationPeriodEditDialogViewQueryResult> {
        let url_ = this.baseUrl + "/LocationSettings/GetLocationPeriodEditDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettings_GetLocationPeriodEditDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettings_GetLocationPeriodEditDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationPeriodEditDialogViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationPeriodEditDialogViewQueryResult>;
        }));
    }

    protected processLocationSettings_GetLocationPeriodEditDialogView(response: HttpResponseBase): Observable<GetLocationPeriodEditDialogViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationPeriodEditDialogViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationPeriodEditDialogViewQueryResult>(null as any);
    }

    locationSettings_GetLocationPeriodConfigOpeningHoursView(query: GetLocationPeriodConfigOpeningHoursViewQuery): Observable<GetLocationPeriodConfigOpeningHoursViewQueryResult> {
        let url_ = this.baseUrl + "/LocationSettings/GetLocationPeriodConfigOpeningHoursView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettings_GetLocationPeriodConfigOpeningHoursView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettings_GetLocationPeriodConfigOpeningHoursView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationPeriodConfigOpeningHoursViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationPeriodConfigOpeningHoursViewQueryResult>;
        }));
    }

    protected processLocationSettings_GetLocationPeriodConfigOpeningHoursView(response: HttpResponseBase): Observable<GetLocationPeriodConfigOpeningHoursViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationPeriodConfigOpeningHoursViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationPeriodConfigOpeningHoursViewQueryResult>(null as any);
    }

    locationSettings_GetLocationPeriodConfigEditItemView(query: GetLocationPeriodConfigEditItemViewQuery): Observable<GetLocationPeriodConfigEditItemViewQueryResult> {
        let url_ = this.baseUrl + "/LocationSettings/GetLocationPeriodConfigEditItemView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettings_GetLocationPeriodConfigEditItemView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettings_GetLocationPeriodConfigEditItemView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationPeriodConfigEditItemViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationPeriodConfigEditItemViewQueryResult>;
        }));
    }

    protected processLocationSettings_GetLocationPeriodConfigEditItemView(response: HttpResponseBase): Observable<GetLocationPeriodConfigEditItemViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationPeriodConfigEditItemViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationPeriodConfigEditItemViewQueryResult>(null as any);
    }

    locationSettings_GetLocationPaymentListPageView(query: GetLocationPaymentListPageViewQuery): Observable<GetLocationPaymentListPageViewQueryResult> {
        let url_ = this.baseUrl + "/LocationSettings/GetLocationPaymentListPageView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettings_GetLocationPaymentListPageView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettings_GetLocationPaymentListPageView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationPaymentListPageViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationPaymentListPageViewQueryResult>;
        }));
    }

    protected processLocationSettings_GetLocationPaymentListPageView(response: HttpResponseBase): Observable<GetLocationPaymentListPageViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationPaymentListPageViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationPaymentListPageViewQueryResult>(null as any);
    }

    locationSettings_GetLocationPaymentFormDialogView(query: GetLocationPaymentFormDialogViewQuery): Observable<GetLocationPaymentFormDialogViewQueryResult> {
        let url_ = this.baseUrl + "/LocationSettings/GetLocationPaymentFormDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettings_GetLocationPaymentFormDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettings_GetLocationPaymentFormDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationPaymentFormDialogViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationPaymentFormDialogViewQueryResult>;
        }));
    }

    protected processLocationSettings_GetLocationPaymentFormDialogView(response: HttpResponseBase): Observable<GetLocationPaymentFormDialogViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationPaymentFormDialogViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationPaymentFormDialogViewQueryResult>(null as any);
    }

    locationSettings_GetLocationNewPaymentFormDialogView(query: GetLocationNewPaymentFormDialogViewQuery): Observable<GetLocationNewPaymentFormDialogViewQueryResult> {
        let url_ = this.baseUrl + "/LocationSettings/GetLocationNewPaymentFormDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettings_GetLocationNewPaymentFormDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettings_GetLocationNewPaymentFormDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationNewPaymentFormDialogViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationNewPaymentFormDialogViewQueryResult>;
        }));
    }

    protected processLocationSettings_GetLocationNewPaymentFormDialogView(response: HttpResponseBase): Observable<GetLocationNewPaymentFormDialogViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationNewPaymentFormDialogViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationNewPaymentFormDialogViewQueryResult>(null as any);
    }

    locationSettings_GetLocationBookingPaymentSettingsEditItemView(query: GetLocationBookingPaymentSettingsEditItemViewQuery): Observable<GetLocationBookingPaymentSettingsEditItemViewQueryResult> {
        let url_ = this.baseUrl + "/LocationSettings/GetLocationBookingPaymentSettingsEditItemView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettings_GetLocationBookingPaymentSettingsEditItemView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettings_GetLocationBookingPaymentSettingsEditItemView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationBookingPaymentSettingsEditItemViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationBookingPaymentSettingsEditItemViewQueryResult>;
        }));
    }

    protected processLocationSettings_GetLocationBookingPaymentSettingsEditItemView(response: HttpResponseBase): Observable<GetLocationBookingPaymentSettingsEditItemViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationBookingPaymentSettingsEditItemViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationBookingPaymentSettingsEditItemViewQueryResult>(null as any);
    }

    locationSettings_GetLocationOverviewListPageView(query: GetLocationOverviewListPageViewQuery): Observable<GetLocationOverviewListPageViewQueryResult> {
        let url_ = this.baseUrl + "/LocationSettings/GetLocationOverviewListPageView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettings_GetLocationOverviewListPageView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettings_GetLocationOverviewListPageView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationOverviewListPageViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationOverviewListPageViewQueryResult>;
        }));
    }

    protected processLocationSettings_GetLocationOverviewListPageView(response: HttpResponseBase): Observable<GetLocationOverviewListPageViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationOverviewListPageViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationOverviewListPageViewQueryResult>(null as any);
    }

    locationSettings_GetLocationOverviewItemTabsPageView(query: GetLocationOverviewItemTabsPageViewQuery): Observable<GetLocationOverviewItemTabsPageViewQueryResult> {
        let url_ = this.baseUrl + "/LocationSettings/GetLocationOverviewItemTabsPageView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettings_GetLocationOverviewItemTabsPageView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettings_GetLocationOverviewItemTabsPageView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationOverviewItemTabsPageViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationOverviewItemTabsPageViewQueryResult>;
        }));
    }

    protected processLocationSettings_GetLocationOverviewItemTabsPageView(response: HttpResponseBase): Observable<GetLocationOverviewItemTabsPageViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationOverviewItemTabsPageViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationOverviewItemTabsPageViewQueryResult>(null as any);
    }

    locationSettings_GetLocationOverviewFormDialogView(query: GetLocationOverviewFormDialogViewQuery): Observable<GetLocationOverviewFormDialogViewQueryResult> {
        let url_ = this.baseUrl + "/LocationSettings/GetLocationOverviewFormDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettings_GetLocationOverviewFormDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettings_GetLocationOverviewFormDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationOverviewFormDialogViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationOverviewFormDialogViewQueryResult>;
        }));
    }

    protected processLocationSettings_GetLocationOverviewFormDialogView(response: HttpResponseBase): Observable<GetLocationOverviewFormDialogViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationOverviewFormDialogViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationOverviewFormDialogViewQueryResult>(null as any);
    }

    locationSettings_GetLocationNoteListListPageView(query: GetLocationNoteListListPageViewQuery): Observable<GetLocationNoteListListPageViewQueryResult> {
        let url_ = this.baseUrl + "/LocationSettings/GetLocationNoteListListPageView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettings_GetLocationNoteListListPageView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettings_GetLocationNoteListListPageView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationNoteListListPageViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationNoteListListPageViewQueryResult>;
        }));
    }

    protected processLocationSettings_GetLocationNoteListListPageView(response: HttpResponseBase): Observable<GetLocationNoteListListPageViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationNoteListListPageViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationNoteListListPageViewQueryResult>(null as any);
    }

    locationSettings_GetLocationNoteListItemTabsPageView(query: GetLocationNoteListItemTabsPageViewQuery): Observable<GetLocationNoteListItemTabsPageViewQueryResult> {
        let url_ = this.baseUrl + "/LocationSettings/GetLocationNoteListItemTabsPageView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettings_GetLocationNoteListItemTabsPageView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettings_GetLocationNoteListItemTabsPageView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationNoteListItemTabsPageViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationNoteListItemTabsPageViewQueryResult>;
        }));
    }

    protected processLocationSettings_GetLocationNoteListItemTabsPageView(response: HttpResponseBase): Observable<GetLocationNoteListItemTabsPageViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationNoteListItemTabsPageViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationNoteListItemTabsPageViewQueryResult>(null as any);
    }

    locationSettings_GetLocationNoteListFormDialogView(query: GetLocationNoteListFormDialogViewQuery): Observable<GetLocationNoteListFormDialogViewQueryResult> {
        let url_ = this.baseUrl + "/LocationSettings/GetLocationNoteListFormDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettings_GetLocationNoteListFormDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettings_GetLocationNoteListFormDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationNoteListFormDialogViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationNoteListFormDialogViewQueryResult>;
        }));
    }

    protected processLocationSettings_GetLocationNoteListFormDialogView(response: HttpResponseBase): Observable<GetLocationNoteListFormDialogViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationNoteListFormDialogViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationNoteListFormDialogViewQueryResult>(null as any);
    }

    locationSettings_GetLocationGeneralSettings(query: GetLocationGeneralSettingsQuery): Observable<GetLocationGeneralSettingsQueryResult> {
        let url_ = this.baseUrl + "/LocationSettings/GetLocationGeneralSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettings_GetLocationGeneralSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettings_GetLocationGeneralSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationGeneralSettingsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationGeneralSettingsQueryResult>;
        }));
    }

    protected processLocationSettings_GetLocationGeneralSettings(response: HttpResponseBase): Observable<GetLocationGeneralSettingsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationGeneralSettingsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationGeneralSettingsQueryResult>(null as any);
    }

    locationSettings_GetLocationBookingSettings(query: GetLocationBookingSettingsQuery): Observable<GetLocationBookingSettingsQueryResult> {
        let url_ = this.baseUrl + "/LocationSettings/GetLocationBookingSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettings_GetLocationBookingSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettings_GetLocationBookingSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationBookingSettingsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationBookingSettingsQueryResult>;
        }));
    }

    protected processLocationSettings_GetLocationBookingSettings(response: HttpResponseBase): Observable<GetLocationBookingSettingsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationBookingSettingsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationBookingSettingsQueryResult>(null as any);
    }

    locationSettings_UpdateLocationBrandColorScheme(command: UpdateLocationBrandColorSchemeCommand): Observable<void> {
        let url_ = this.baseUrl + "/LocationSettings/UpdateLocationBrandColorScheme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettings_UpdateLocationBrandColorScheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettings_UpdateLocationBrandColorScheme(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLocationSettings_UpdateLocationBrandColorScheme(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    locationSettings_GetLocationBrandSettings(query: GetLocationBrandSettingsQuery): Observable<GetLocationBrandSettingsQueryResult> {
        let url_ = this.baseUrl + "/LocationSettings/GetLocationBrandSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettings_GetLocationBrandSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettings_GetLocationBrandSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationBrandSettingsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationBrandSettingsQueryResult>;
        }));
    }

    protected processLocationSettings_GetLocationBrandSettings(response: HttpResponseBase): Observable<GetLocationBrandSettingsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationBrandSettingsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationBrandSettingsQueryResult>(null as any);
    }

    locationSettings_GetLocationAgeGroupListPageView(query: GetLocationAgeGroupListPageViewQuery): Observable<GetLocationAgeGroupListPageViewQueryResult> {
        let url_ = this.baseUrl + "/LocationSettings/GetLocationAgeGroupListPageView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettings_GetLocationAgeGroupListPageView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettings_GetLocationAgeGroupListPageView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationAgeGroupListPageViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationAgeGroupListPageViewQueryResult>;
        }));
    }

    protected processLocationSettings_GetLocationAgeGroupListPageView(response: HttpResponseBase): Observable<GetLocationAgeGroupListPageViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationAgeGroupListPageViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationAgeGroupListPageViewQueryResult>(null as any);
    }

    locationSettings_GetLocationAgeGroupFormDialogView(query: GetLocationAgeGroupFormDialogViewQuery): Observable<GetLocationAgeGroupFormDialogViewQueryResult> {
        let url_ = this.baseUrl + "/LocationSettings/GetLocationAgeGroupFormDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettings_GetLocationAgeGroupFormDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettings_GetLocationAgeGroupFormDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationAgeGroupFormDialogViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationAgeGroupFormDialogViewQueryResult>;
        }));
    }

    protected processLocationSettings_GetLocationAgeGroupFormDialogView(response: HttpResponseBase): Observable<GetLocationAgeGroupFormDialogViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationAgeGroupFormDialogViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationAgeGroupFormDialogViewQueryResult>(null as any);
    }

    locationFeatureFlags_SetLocationFeatureFlags(command: SetLocationFeatureFlagsCommand): Observable<void> {
        let url_ = this.baseUrl + "/LocationFeatureFlags/SetLocationFeatureFlags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationFeatureFlags_SetLocationFeatureFlags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationFeatureFlags_SetLocationFeatureFlags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLocationFeatureFlags_SetLocationFeatureFlags(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    locationFeatureFlags_GetLocationFeatureFlagsFormView(query: GetLocationFeatureFlagsFormViewQuery): Observable<GetLocationFeatureFlagsFormViewQueryResult> {
        let url_ = this.baseUrl + "/LocationFeatureFlags/GetLocationFeatureFlagsFormView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationFeatureFlags_GetLocationFeatureFlagsFormView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationFeatureFlags_GetLocationFeatureFlagsFormView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationFeatureFlagsFormViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationFeatureFlagsFormViewQueryResult>;
        }));
    }

    protected processLocationFeatureFlags_GetLocationFeatureFlagsFormView(response: HttpResponseBase): Observable<GetLocationFeatureFlagsFormViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationFeatureFlagsFormViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationFeatureFlagsFormViewQueryResult>(null as any);
    }

    locationDashboard_GetProgramResultListWidgetData(query: GetProgramResultListWidgetDataQuery): Observable<GetProgramResultListWidgetDataQueryResult> {
        let url_ = this.baseUrl + "/LocationDashboard/GetProgramResultListWidgetData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationDashboard_GetProgramResultListWidgetData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationDashboard_GetProgramResultListWidgetData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProgramResultListWidgetDataQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProgramResultListWidgetDataQueryResult>;
        }));
    }

    protected processLocationDashboard_GetProgramResultListWidgetData(response: HttpResponseBase): Observable<GetProgramResultListWidgetDataQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProgramResultListWidgetDataQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProgramResultListWidgetDataQueryResult>(null as any);
    }

    locationDashboard_GetPeriodSummaryWidgetData(query: GetPeriodSummaryWidgetDataQuery): Observable<GetPeriodSummaryWidgetDataQueryResult> {
        let url_ = this.baseUrl + "/LocationDashboard/GetPeriodSummaryWidgetData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationDashboard_GetPeriodSummaryWidgetData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationDashboard_GetPeriodSummaryWidgetData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPeriodSummaryWidgetDataQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPeriodSummaryWidgetDataQueryResult>;
        }));
    }

    protected processLocationDashboard_GetPeriodSummaryWidgetData(response: HttpResponseBase): Observable<GetPeriodSummaryWidgetDataQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPeriodSummaryWidgetDataQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPeriodSummaryWidgetDataQueryResult>(null as any);
    }

    locationDashboard_GetDayView(query: GetDayViewQuery): Observable<GetDayViewQueryResult> {
        let url_ = this.baseUrl + "/LocationDashboard/GetDayView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationDashboard_GetDayView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationDashboard_GetDayView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDayViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDayViewQueryResult>;
        }));
    }

    protected processLocationDashboard_GetDayView(response: HttpResponseBase): Observable<GetDayViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetDayViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDayViewQueryResult>(null as any);
    }

    locationDashboard_GetBookingCreatedOnWidgetData(query: GetBookingCreatedOnWidgetDataQuery): Observable<GetBookingCreatedOnWidgetDataQueryResult> {
        let url_ = this.baseUrl + "/LocationDashboard/GetBookingCreatedOnWidgetData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationDashboard_GetBookingCreatedOnWidgetData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationDashboard_GetBookingCreatedOnWidgetData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBookingCreatedOnWidgetDataQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBookingCreatedOnWidgetDataQueryResult>;
        }));
    }

    protected processLocationDashboard_GetBookingCreatedOnWidgetData(response: HttpResponseBase): Observable<GetBookingCreatedOnWidgetDataQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetBookingCreatedOnWidgetDataQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBookingCreatedOnWidgetDataQueryResult>(null as any);
    }

    locationDashboard_GetBookingCountOriginWidgetData(query: GetBookingCountOriginWidgetDataQuery): Observable<GetBookingCountOriginWidgetDataQueryResult> {
        let url_ = this.baseUrl + "/LocationDashboard/GetBookingCountOriginWidgetData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationDashboard_GetBookingCountOriginWidgetData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationDashboard_GetBookingCountOriginWidgetData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBookingCountOriginWidgetDataQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBookingCountOriginWidgetDataQueryResult>;
        }));
    }

    protected processLocationDashboard_GetBookingCountOriginWidgetData(response: HttpResponseBase): Observable<GetBookingCountOriginWidgetDataQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetBookingCountOriginWidgetDataQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBookingCountOriginWidgetDataQueryResult>(null as any);
    }

    locationDashboard_GetBookingAmountOriginWidgetData(query: GetBookingAmountOriginWidgetDataQuery): Observable<GetBookingAmountOriginWidgetDataQueryResult> {
        let url_ = this.baseUrl + "/LocationDashboard/GetBookingAmountOriginWidgetData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationDashboard_GetBookingAmountOriginWidgetData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationDashboard_GetBookingAmountOriginWidgetData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBookingAmountOriginWidgetDataQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBookingAmountOriginWidgetDataQueryResult>;
        }));
    }

    protected processLocationDashboard_GetBookingAmountOriginWidgetData(response: HttpResponseBase): Observable<GetBookingAmountOriginWidgetDataQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetBookingAmountOriginWidgetDataQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBookingAmountOriginWidgetDataQueryResult>(null as any);
    }

    locationCore_RefreshCachedCoreLocationData(command: RefreshCachedCoreLocationDataCommand): Observable<void> {
        let url_ = this.baseUrl + "/Location/RefreshCachedCoreLocationData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationCore_RefreshCachedCoreLocationData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationCore_RefreshCachedCoreLocationData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLocationCore_RefreshCachedCoreLocationData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    locationCore_GetLocationRelatedObjectNameData(query: GetLocationRelatedObjectNameDataQuery): Observable<LocationRelatedObjectNameData> {
        let url_ = this.baseUrl + "/Location/GetLocationRelatedObjectNameData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationCore_GetLocationRelatedObjectNameData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationCore_GetLocationRelatedObjectNameData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationRelatedObjectNameData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationRelatedObjectNameData>;
        }));
    }

    protected processLocationCore_GetLocationRelatedObjectNameData(response: HttpResponseBase): Observable<LocationRelatedObjectNameData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LocationRelatedObjectNameData;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocationRelatedObjectNameData>(null as any);
    }

    locationCore_GetLocationCoreData(query: GetLocationCoreDataQuery): Observable<LocationCoreData> {
        let url_ = this.baseUrl + "/Location/GetLocationCoreData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationCore_GetLocationCoreData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationCore_GetLocationCoreData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LocationCoreData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LocationCoreData>;
        }));
    }

    protected processLocationCore_GetLocationCoreData(response: HttpResponseBase): Observable<LocationCoreData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LocationCoreData;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LocationCoreData>(null as any);
    }

    league_GetLeagueListPageView(query: GetLeagueListPageViewQuery): Observable<GetLeagueListPageViewQueryResult> {
        let url_ = this.baseUrl + "/League/GetLeagueListPageView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLeague_GetLeagueListPageView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLeague_GetLeagueListPageView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLeagueListPageViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLeagueListPageViewQueryResult>;
        }));
    }

    protected processLeague_GetLeagueListPageView(response: HttpResponseBase): Observable<GetLeagueListPageViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLeagueListPageViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLeagueListPageViewQueryResult>(null as any);
    }

    i18n_GetPlatformLocales(query: GetPlatformLocalesQuery): Observable<GetPlatformLocalesQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/I18n/GetPlatformLocales";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processI18n_GetPlatformLocales(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processI18n_GetPlatformLocales(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPlatformLocalesQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPlatformLocalesQueryResult>;
        }));
    }

    protected processI18n_GetPlatformLocales(response: HttpResponseBase): Observable<GetPlatformLocalesQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPlatformLocalesQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPlatformLocalesQueryResult>(null as any);
    }

    i18n_DeactivatePlatformLocale(command: DeactivatePlatformLocaleCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/I18n/DeactivatePlatformLocale";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processI18n_DeactivatePlatformLocale(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processI18n_DeactivatePlatformLocale(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processI18n_DeactivatePlatformLocale(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    i18n_AddPlatformLocale(command: AddPlatformLocaleCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/I18n/AddPlatformLocale";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processI18n_AddPlatformLocale(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processI18n_AddPlatformLocale(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processI18n_AddPlatformLocale(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    i18n_ActivatePlatformLocale(command: ActivatePlatformLocaleCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/I18n/ActivatePlatformLocale";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processI18n_ActivatePlatformLocale(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processI18n_ActivatePlatformLocale(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processI18n_ActivatePlatformLocale(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    i18n_SetLocationLocaleFallbackLocale(command: SetLocationLocaleFallbackLocaleCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/I18n/SetLocationLocaleFallbackLocale";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processI18n_SetLocationLocaleFallbackLocale(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processI18n_SetLocationLocaleFallbackLocale(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processI18n_SetLocationLocaleFallbackLocale(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    i18n_SetLocationDefaultLocale(command: SetLocationDefaultLocaleCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/I18n/SetLocationDefaultLocale";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processI18n_SetLocationDefaultLocale(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processI18n_SetLocationDefaultLocale(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processI18n_SetLocationDefaultLocale(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    i18n_RemoveLocationLocale(command: RemoveLocationLocaleCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/I18n/RemoveLocationLocale";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processI18n_RemoveLocationLocale(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processI18n_RemoveLocationLocale(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processI18n_RemoveLocationLocale(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    i18n_MakeLocationLocaleOptional(command: MakeLocationLocaleOptionalCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/I18n/MakeLocationLocaleOptional";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processI18n_MakeLocationLocaleOptional(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processI18n_MakeLocationLocaleOptional(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processI18n_MakeLocationLocaleOptional(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    i18n_MakeLocationLocaleMandatory(command: MakeLocationLocaleMandatoryCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/I18n/MakeLocationLocaleMandatory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processI18n_MakeLocationLocaleMandatory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processI18n_MakeLocationLocaleMandatory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processI18n_MakeLocationLocaleMandatory(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    i18n_GetLocationLocales(query: GetLocationLocalesQuery): Observable<GetLocationLocalesQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/I18n/GetLocationLocales";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processI18n_GetLocationLocales(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processI18n_GetLocationLocales(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationLocalesQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationLocalesQueryResult>;
        }));
    }

    protected processI18n_GetLocationLocales(response: HttpResponseBase): Observable<GetLocationLocalesQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationLocalesQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationLocalesQueryResult>(null as any);
    }

    i18n_GetAvailableLocalesForLocation(query: GetAvailableLocalesForLocationQuery): Observable<GetAvailableLocalesForLocationQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/I18n/GetAvailableLocalesForLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processI18n_GetAvailableLocalesForLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processI18n_GetAvailableLocalesForLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAvailableLocalesForLocationQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAvailableLocalesForLocationQueryResult>;
        }));
    }

    protected processI18n_GetAvailableLocalesForLocation(response: HttpResponseBase): Observable<GetAvailableLocalesForLocationQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetAvailableLocalesForLocationQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAvailableLocalesForLocationQueryResult>(null as any);
    }

    i18n_GetAvailableFallbackLocalesForLocationLocale(query: GetAvailableFallbackLocalesForLocationLocaleQuery): Observable<GetAvailableFallbackLocalesForLocationLocaleQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/I18n/GetAvailableFallbackLocalesForLocationLocale";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processI18n_GetAvailableFallbackLocalesForLocationLocale(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processI18n_GetAvailableFallbackLocalesForLocationLocale(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAvailableFallbackLocalesForLocationLocaleQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAvailableFallbackLocalesForLocationLocaleQueryResult>;
        }));
    }

    protected processI18n_GetAvailableFallbackLocalesForLocationLocale(response: HttpResponseBase): Observable<GetAvailableFallbackLocalesForLocationLocaleQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetAvailableFallbackLocalesForLocationLocaleQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAvailableFallbackLocalesForLocationLocaleQueryResult>(null as any);
    }

    i18n_ClearLocationLocaleFallbackLocale(command: ClearLocationLocaleFallbackLocaleCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/I18n/ClearLocationLocaleFallbackLocale";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processI18n_ClearLocationLocaleFallbackLocale(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processI18n_ClearLocationLocaleFallbackLocale(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processI18n_ClearLocationLocaleFallbackLocale(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    i18n_AddLocationLocale(command: AddLocationLocaleCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/I18n/AddLocationLocale";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processI18n_AddLocationLocale(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processI18n_AddLocationLocale(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processI18n_AddLocationLocale(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    facility_SetResourceTypeText(command: SetResourceTypeTextCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Facility/SetResourceTypeText";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFacility_SetResourceTypeText(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacility_SetResourceTypeText(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFacility_SetResourceTypeText(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    facility_SetResourceTypeOrder(command: SetResourceTypeOrderCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Facility/SetResourceTypeOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFacility_SetResourceTypeOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacility_SetResourceTypeOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFacility_SetResourceTypeOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    facility_RenameResourceType(command: RenameResourceTypeCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Facility/RenameResourceType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFacility_RenameResourceType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacility_RenameResourceType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFacility_RenameResourceType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    facility_RenameResourceTypePreset(command: RenameResourceTypePresetCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Facility/RenameResourceTypePreset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFacility_RenameResourceTypePreset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacility_RenameResourceTypePreset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFacility_RenameResourceTypePreset(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    facility_RemoveResourceTypePreset(command: RemoveResourceTypePresetCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Facility/RemoveResourceTypePreset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFacility_RemoveResourceTypePreset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacility_RemoveResourceTypePreset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFacility_RemoveResourceTypePreset(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    facility_GetResourceTypesConfig(query: GetResourceTypesConfigQuery): Observable<GetResourceTypesConfigQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Facility/GetResourceTypesConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFacility_GetResourceTypesConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacility_GetResourceTypesConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetResourceTypesConfigQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetResourceTypesConfigQueryResult>;
        }));
    }

    protected processFacility_GetResourceTypesConfig(response: HttpResponseBase): Observable<GetResourceTypesConfigQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetResourceTypesConfigQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetResourceTypesConfigQueryResult>(null as any);
    }

    facility_GetResourceTypeConfig(query: GetResourceTypeConfigQuery): Observable<GetResourceTypeConfigQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Facility/GetResourceTypeConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFacility_GetResourceTypeConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacility_GetResourceTypeConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetResourceTypeConfigQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetResourceTypeConfigQueryResult>;
        }));
    }

    protected processFacility_GetResourceTypeConfig(response: HttpResponseBase): Observable<GetResourceTypeConfigQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetResourceTypeConfigQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetResourceTypeConfigQueryResult>(null as any);
    }

    facility_DeleteResourceType(command: DeleteResourceTypeCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Facility/DeleteResourceType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFacility_DeleteResourceType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacility_DeleteResourceType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFacility_DeleteResourceType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    facility_CreateResourceType(command: CreateResourceTypeCommand): Observable<CreateResourceTypeCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Facility/CreateResourceType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFacility_CreateResourceType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacility_CreateResourceType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateResourceTypeCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateResourceTypeCommandResponse>;
        }));
    }

    protected processFacility_CreateResourceType(response: HttpResponseBase): Observable<CreateResourceTypeCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateResourceTypeCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateResourceTypeCommandResponse>(null as any);
    }

    facility_CreateResourceTypeCatalog(command: CreateResourceTypeCatalogCommand): Observable<CreateResourceTypeCatalogCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Facility/CreateResourceTypeCatalog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFacility_CreateResourceTypeCatalog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacility_CreateResourceTypeCatalog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateResourceTypeCatalogCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateResourceTypeCatalogCommandResponse>;
        }));
    }

    protected processFacility_CreateResourceTypeCatalog(response: HttpResponseBase): Observable<CreateResourceTypeCatalogCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateResourceTypeCatalogCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateResourceTypeCatalogCommandResponse>(null as any);
    }

    facility_ChangeResourceTypePresetDisplayDefaults(command: ChangeResourceTypePresetDisplayDefaultsCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Facility/ChangeResourceTypePresetDisplayDefaults";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFacility_ChangeResourceTypePresetDisplayDefaults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacility_ChangeResourceTypePresetDisplayDefaults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFacility_ChangeResourceTypePresetDisplayDefaults(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    facility_ChangeResourceTypePresetDefaultPersonCapacity(command: ChangeResourceTypePresetDefaultPersonCapacityCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Facility/ChangeResourceTypePresetDefaultPersonCapacity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFacility_ChangeResourceTypePresetDefaultPersonCapacity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacility_ChangeResourceTypePresetDefaultPersonCapacity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFacility_ChangeResourceTypePresetDefaultPersonCapacity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    facility_AddResourceTypePreset(command: AddResourceTypePresetCommand): Observable<AddResourceTypePresetCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Facility/AddResourceTypePreset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFacility_AddResourceTypePreset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacility_AddResourceTypePreset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddResourceTypePresetCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddResourceTypePresetCommandResponse>;
        }));
    }

    protected processFacility_AddResourceTypePreset(response: HttpResponseBase): Observable<AddResourceTypePresetCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddResourceTypePresetCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddResourceTypePresetCommandResponse>(null as any);
    }

    facility_SetLocationLayoutResourceDisplay(command: SetLocationLayoutResourceDisplayCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Facility/SetLocationLayoutResourceDisplay";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFacility_SetLocationLayoutResourceDisplay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacility_SetLocationLayoutResourceDisplay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFacility_SetLocationLayoutResourceDisplay(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    facility_ReorderLocationLayoutSection(command: ReorderLocationLayoutSectionCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Facility/ReorderLocationLayoutSection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFacility_ReorderLocationLayoutSection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacility_ReorderLocationLayoutSection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFacility_ReorderLocationLayoutSection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    facility_ReorderLocationLayoutResource(command: ReorderLocationLayoutResourceCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Facility/ReorderLocationLayoutResource";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFacility_ReorderLocationLayoutResource(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacility_ReorderLocationLayoutResource(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFacility_ReorderLocationLayoutResource(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    facility_ReorderLocationLayoutArea(command: ReorderLocationLayoutAreaCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Facility/ReorderLocationLayoutArea";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFacility_ReorderLocationLayoutArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacility_ReorderLocationLayoutArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFacility_ReorderLocationLayoutArea(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    facility_RenameLocationLayoutSection(command: RenameLocationLayoutSectionCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Facility/RenameLocationLayoutSection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFacility_RenameLocationLayoutSection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacility_RenameLocationLayoutSection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFacility_RenameLocationLayoutSection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    facility_RenameLocationLayoutResource(command: RenameLocationLayoutResourceCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Facility/RenameLocationLayoutResource";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFacility_RenameLocationLayoutResource(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacility_RenameLocationLayoutResource(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFacility_RenameLocationLayoutResource(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    facility_RenameLocationLayoutArea(command: RenameLocationLayoutAreaCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Facility/RenameLocationLayoutArea";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFacility_RenameLocationLayoutArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacility_RenameLocationLayoutArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFacility_RenameLocationLayoutArea(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    facility_RemoveLocationLayoutSection(command: RemoveLocationLayoutSectionCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Facility/RemoveLocationLayoutSection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFacility_RemoveLocationLayoutSection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacility_RemoveLocationLayoutSection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFacility_RemoveLocationLayoutSection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    facility_RemoveLocationLayoutResource(command: RemoveLocationLayoutResourceCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Facility/RemoveLocationLayoutResource";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFacility_RemoveLocationLayoutResource(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacility_RemoveLocationLayoutResource(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFacility_RemoveLocationLayoutResource(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    facility_RemoveLocationLayoutArea(command: RemoveLocationLayoutAreaCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Facility/RemoveLocationLayoutArea";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFacility_RemoveLocationLayoutArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacility_RemoveLocationLayoutArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFacility_RemoveLocationLayoutArea(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    facility_MoveLocationLayoutSection(command: MoveLocationLayoutSectionCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Facility/MoveLocationLayoutSection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFacility_MoveLocationLayoutSection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacility_MoveLocationLayoutSection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFacility_MoveLocationLayoutSection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    facility_MoveLocationLayoutResource(command: MoveLocationLayoutResourceCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Facility/MoveLocationLayoutResource";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFacility_MoveLocationLayoutResource(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacility_MoveLocationLayoutResource(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFacility_MoveLocationLayoutResource(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    facility_GetLocationLayoutConfig(query: GetLocationLayoutConfigQuery): Observable<GetLocationLayoutConfigQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Facility/GetLocationLayoutConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFacility_GetLocationLayoutConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacility_GetLocationLayoutConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationLayoutConfigQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationLayoutConfigQueryResult>;
        }));
    }

    protected processFacility_GetLocationLayoutConfig(response: HttpResponseBase): Observable<GetLocationLayoutConfigQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationLayoutConfigQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationLayoutConfigQueryResult>(null as any);
    }

    facility_FormLocationLayoutPairGroup(command: FormLocationLayoutPairGroupCommand): Observable<FormLocationLayoutPairGroupCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Facility/FormLocationLayoutPairGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFacility_FormLocationLayoutPairGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacility_FormLocationLayoutPairGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FormLocationLayoutPairGroupCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FormLocationLayoutPairGroupCommandResponse>;
        }));
    }

    protected processFacility_FormLocationLayoutPairGroup(response: HttpResponseBase): Observable<FormLocationLayoutPairGroupCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FormLocationLayoutPairGroupCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FormLocationLayoutPairGroupCommandResponse>(null as any);
    }

    facility_DissolveLocationLayoutPairGroup(command: DissolveLocationLayoutPairGroupCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Facility/DissolveLocationLayoutPairGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFacility_DissolveLocationLayoutPairGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacility_DissolveLocationLayoutPairGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFacility_DissolveLocationLayoutPairGroup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    facility_DeleteLocationLayout(command: DeleteLocationLayoutCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Facility/DeleteLocationLayout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFacility_DeleteLocationLayout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacility_DeleteLocationLayout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFacility_DeleteLocationLayout(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    facility_CreateLocationLayout(command: CreateLocationLayoutCommand): Observable<CreateLocationLayoutCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Facility/CreateLocationLayout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFacility_CreateLocationLayout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacility_CreateLocationLayout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateLocationLayoutCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateLocationLayoutCommandResponse>;
        }));
    }

    protected processFacility_CreateLocationLayout(response: HttpResponseBase): Observable<CreateLocationLayoutCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateLocationLayoutCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateLocationLayoutCommandResponse>(null as any);
    }

    facility_ChangeLocationLayoutResourcePersonCapacity(command: ChangeLocationLayoutResourcePersonCapacityCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Facility/ChangeLocationLayoutResourcePersonCapacity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFacility_ChangeLocationLayoutResourcePersonCapacity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacility_ChangeLocationLayoutResourcePersonCapacity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFacility_ChangeLocationLayoutResourcePersonCapacity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    facility_AddLocationLayoutSection(command: AddLocationLayoutSectionCommand): Observable<AddLocationLayoutSectionCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Facility/AddLocationLayoutSection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFacility_AddLocationLayoutSection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacility_AddLocationLayoutSection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddLocationLayoutSectionCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddLocationLayoutSectionCommandResponse>;
        }));
    }

    protected processFacility_AddLocationLayoutSection(response: HttpResponseBase): Observable<AddLocationLayoutSectionCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddLocationLayoutSectionCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddLocationLayoutSectionCommandResponse>(null as any);
    }

    facility_AddLocationLayoutResource(command: AddLocationLayoutResourceCommand): Observable<AddLocationLayoutResourceCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Facility/AddLocationLayoutResource";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFacility_AddLocationLayoutResource(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacility_AddLocationLayoutResource(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddLocationLayoutResourceCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddLocationLayoutResourceCommandResponse>;
        }));
    }

    protected processFacility_AddLocationLayoutResource(response: HttpResponseBase): Observable<AddLocationLayoutResourceCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddLocationLayoutResourceCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddLocationLayoutResourceCommandResponse>(null as any);
    }

    facility_AddLocationLayoutResources(command: AddLocationLayoutResourcesCommand): Observable<AddLocationLayoutResourcesCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Facility/AddLocationLayoutResources";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFacility_AddLocationLayoutResources(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacility_AddLocationLayoutResources(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddLocationLayoutResourcesCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddLocationLayoutResourcesCommandResponse>;
        }));
    }

    protected processFacility_AddLocationLayoutResources(response: HttpResponseBase): Observable<AddLocationLayoutResourcesCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddLocationLayoutResourcesCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddLocationLayoutResourcesCommandResponse>(null as any);
    }

    facility_AddLocationLayoutArea(command: AddLocationLayoutAreaCommand): Observable<AddLocationLayoutAreaCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Facility/AddLocationLayoutArea";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFacility_AddLocationLayoutArea(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFacility_AddLocationLayoutArea(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddLocationLayoutAreaCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddLocationLayoutAreaCommandResponse>;
        }));
    }

    protected processFacility_AddLocationLayoutArea(response: HttpResponseBase): Observable<AddLocationLayoutAreaCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddLocationLayoutAreaCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddLocationLayoutAreaCommandResponse>(null as any);
    }

    externalAccess_SetNameForApiKey(command: SetNameForApiKeyCommand): Observable<SetNameForApiKeyCommandResponse> {
        let url_ = this.baseUrl + "/ExternalAccess/SetNameForApiKey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processExternalAccess_SetNameForApiKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalAccess_SetNameForApiKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SetNameForApiKeyCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SetNameForApiKeyCommandResponse>;
        }));
    }

    protected processExternalAccess_SetNameForApiKey(response: HttpResponseBase): Observable<SetNameForApiKeyCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SetNameForApiKeyCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SetNameForApiKeyCommandResponse>(null as any);
    }

    externalAccess_RevokeApiKey(command: RevokeApiKeyCommand): Observable<RevokeApiKeyCommandResponse> {
        let url_ = this.baseUrl + "/ExternalAccess/RevokeApiKey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processExternalAccess_RevokeApiKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalAccess_RevokeApiKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RevokeApiKeyCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RevokeApiKeyCommandResponse>;
        }));
    }

    protected processExternalAccess_RevokeApiKey(response: HttpResponseBase): Observable<RevokeApiKeyCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RevokeApiKeyCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RevokeApiKeyCommandResponse>(null as any);
    }

    externalAccess_GetApiKeysForLocation(): Observable<GetApiKeysForLocationQueryResult> {
        let url_ = this.baseUrl + "/ExternalAccess/GetApiKeysForLocation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processExternalAccess_GetApiKeysForLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalAccess_GetApiKeysForLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetApiKeysForLocationQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetApiKeysForLocationQueryResult>;
        }));
    }

    protected processExternalAccess_GetApiKeysForLocation(response: HttpResponseBase): Observable<GetApiKeysForLocationQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetApiKeysForLocationQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetApiKeysForLocationQueryResult>(null as any);
    }

    externalAccess_CreateApiKey(command: CreateApiKeyCommand): Observable<CreateApiKeyCommandResponse> {
        let url_ = this.baseUrl + "/ExternalAccess/CreateApiKey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processExternalAccess_CreateApiKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalAccess_CreateApiKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateApiKeyCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateApiKeyCommandResponse>;
        }));
    }

    protected processExternalAccess_CreateApiKey(response: HttpResponseBase): Observable<CreateApiKeyCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateApiKeyCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateApiKeyCommandResponse>(null as any);
    }

    emailTemplate_GetEmailTemplateListView(query: GetEmailTemplateListViewQuery): Observable<GetEmailTemplateListViewQueryResult> {
        let url_ = this.baseUrl + "/EmailTemplate/GetEmailTemplateListView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processEmailTemplate_GetEmailTemplateListView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmailTemplate_GetEmailTemplateListView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmailTemplateListViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmailTemplateListViewQueryResult>;
        }));
    }

    protected processEmailTemplate_GetEmailTemplateListView(response: HttpResponseBase): Observable<GetEmailTemplateListViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetEmailTemplateListViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEmailTemplateListViewQueryResult>(null as any);
    }

    emailTemplate_GetEmailTemplateEditItemView(query: GetEmailTemplateEditItemViewQuery): Observable<GetEmailTemplateEditItemViewQueryResult> {
        let url_ = this.baseUrl + "/EmailTemplate/GetEmailTemplateEditItemView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processEmailTemplate_GetEmailTemplateEditItemView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmailTemplate_GetEmailTemplateEditItemView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmailTemplateEditItemViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmailTemplateEditItemViewQueryResult>;
        }));
    }

    protected processEmailTemplate_GetEmailTemplateEditItemView(response: HttpResponseBase): Observable<GetEmailTemplateEditItemViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetEmailTemplateEditItemViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEmailTemplateEditItemViewQueryResult>(null as any);
    }

    emailMessaging_SendCmsSiteCheckOutLink(command: SendCmsSiteCheckOutLinkCommand): Observable<void> {
        let url_ = this.baseUrl + "/EmailMessaging/SendCmsSiteCheckOutLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processEmailMessaging_SendCmsSiteCheckOutLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmailMessaging_SendCmsSiteCheckOutLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEmailMessaging_SendCmsSiteCheckOutLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    emailMessaging_GetEmailSettingsEditItemView(query: GetEmailSettingsEditItemViewQuery): Observable<EmailSettingsEditItemView> {
        let url_ = this.baseUrl + "/EmailMessaging/GetEmailSettingsEditItemView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processEmailMessaging_GetEmailSettingsEditItemView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmailMessaging_GetEmailSettingsEditItemView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailSettingsEditItemView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailSettingsEditItemView>;
        }));
    }

    protected processEmailMessaging_GetEmailSettingsEditItemView(response: HttpResponseBase): Observable<EmailSettingsEditItemView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmailSettingsEditItemView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmailSettingsEditItemView>(null as any);
    }

    emailMessaging_GetEmailSettingsEditItemLocationView(query: GetEmailSettingsEditItemLocationViewQuery): Observable<EmailSettingsEditItemLocationView> {
        let url_ = this.baseUrl + "/EmailMessaging/GetEmailSettingsEditItemLocationView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processEmailMessaging_GetEmailSettingsEditItemLocationView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmailMessaging_GetEmailSettingsEditItemLocationView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailSettingsEditItemLocationView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailSettingsEditItemLocationView>;
        }));
    }

    protected processEmailMessaging_GetEmailSettingsEditItemLocationView(response: HttpResponseBase): Observable<EmailSettingsEditItemLocationView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmailSettingsEditItemLocationView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmailSettingsEditItemLocationView>(null as any);
    }

    emailMessaging_GetEmailSettingsEditItemEventsView(query: GetEmailSettingsEditItemEventsViewQuery): Observable<EmailSettingsEditItemEventsView> {
        let url_ = this.baseUrl + "/EmailMessaging/GetEmailSettingsEditItemEventsView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processEmailMessaging_GetEmailSettingsEditItemEventsView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmailMessaging_GetEmailSettingsEditItemEventsView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailSettingsEditItemEventsView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailSettingsEditItemEventsView>;
        }));
    }

    protected processEmailMessaging_GetEmailSettingsEditItemEventsView(response: HttpResponseBase): Observable<EmailSettingsEditItemEventsView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmailSettingsEditItemEventsView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmailSettingsEditItemEventsView>(null as any);
    }

    customers_GetCustomerListPageView(query: GetCustomerListPageViewQuery): Observable<GetCustomerListPageViewQueryResult> {
        let url_ = this.baseUrl + "/Customers/GetCustomerListPageView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomers_GetCustomerListPageView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomers_GetCustomerListPageView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCustomerListPageViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCustomerListPageViewQueryResult>;
        }));
    }

    protected processCustomers_GetCustomerListPageView(response: HttpResponseBase): Observable<GetCustomerListPageViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCustomerListPageViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCustomerListPageViewQueryResult>(null as any);
    }

    customers_GetCustomerEditItemPageView(query: GetCustomerEditItemPageViewQuery): Observable<GetCustomerEditItemPageViewQueryResult> {
        let url_ = this.baseUrl + "/Customers/GetCustomerEditItemPageView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomers_GetCustomerEditItemPageView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomers_GetCustomerEditItemPageView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCustomerEditItemPageViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCustomerEditItemPageViewQueryResult>;
        }));
    }

    protected processCustomers_GetCustomerEditItemPageView(response: HttpResponseBase): Observable<GetCustomerEditItemPageViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCustomerEditItemPageViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCustomerEditItemPageViewQueryResult>(null as any);
    }

    customers_SearchCustomers(query: SearchCustomersQuery): Observable<SearchCustomersQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Customers/SearchCustomers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomers_SearchCustomers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomers_SearchCustomers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchCustomersQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchCustomersQueryResult>;
        }));
    }

    protected processCustomers_SearchCustomers(response: HttpResponseBase): Observable<SearchCustomersQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchCustomersQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SearchCustomersQueryResult>(null as any);
    }

    customers_GetCustomerInfo(query: GetCustomerInfoQuery): Observable<GetCustomerInfoQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Customers/GetCustomerInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomers_GetCustomerInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomers_GetCustomerInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCustomerInfoQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCustomerInfoQueryResult>;
        }));
    }

    protected processCustomers_GetCustomerInfo(response: HttpResponseBase): Observable<GetCustomerInfoQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCustomerInfoQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCustomerInfoQueryResult>(null as any);
    }

    customers_IsCustomerAccountAuthenticationPhoneNumberInUse(query: IsCustomerAccountAuthenticationPhoneNumberInUseQuery): Observable<IsCustomerAccountAuthenticationPhoneNumberInUseQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Customers/IsCustomerAccountAuthenticationPhoneNumberInUse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomers_IsCustomerAccountAuthenticationPhoneNumberInUse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomers_IsCustomerAccountAuthenticationPhoneNumberInUse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsCustomerAccountAuthenticationPhoneNumberInUseQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsCustomerAccountAuthenticationPhoneNumberInUseQueryResult>;
        }));
    }

    protected processCustomers_IsCustomerAccountAuthenticationPhoneNumberInUse(response: HttpResponseBase): Observable<IsCustomerAccountAuthenticationPhoneNumberInUseQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IsCustomerAccountAuthenticationPhoneNumberInUseQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IsCustomerAccountAuthenticationPhoneNumberInUseQueryResult>(null as any);
    }

    customers_IsCustomerAccountAuthenticationEmailAddressInUse(query: IsCustomerAccountAuthenticationEmailAddressInUseQuery): Observable<IsCustomerAccountAuthenticationEmailAddressInUseQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Customers/IsCustomerAccountAuthenticationEmailAddressInUse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomers_IsCustomerAccountAuthenticationEmailAddressInUse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomers_IsCustomerAccountAuthenticationEmailAddressInUse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsCustomerAccountAuthenticationEmailAddressInUseQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsCustomerAccountAuthenticationEmailAddressInUseQueryResult>;
        }));
    }

    protected processCustomers_IsCustomerAccountAuthenticationEmailAddressInUse(response: HttpResponseBase): Observable<IsCustomerAccountAuthenticationEmailAddressInUseQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IsCustomerAccountAuthenticationEmailAddressInUseQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IsCustomerAccountAuthenticationEmailAddressInUseQueryResult>(null as any);
    }

    customers_GetCustomerAccountInfoById(query: GetCustomerAccountInfoByIdQuery): Observable<GetCustomerAccountInfoByIdQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Customers/GetCustomerAccountInfoById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomers_GetCustomerAccountInfoById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomers_GetCustomerAccountInfoById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCustomerAccountInfoByIdQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCustomerAccountInfoByIdQueryResult>;
        }));
    }

    protected processCustomers_GetCustomerAccountInfoById(response: HttpResponseBase): Observable<GetCustomerAccountInfoByIdQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCustomerAccountInfoByIdQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCustomerAccountInfoByIdQueryResult>(null as any);
    }

    customers_GetCustomerAccountInfoByAuthenticationPhoneNumber(query: GetCustomerAccountInfoByAuthenticationPhoneNumberQuery): Observable<GetCustomerAccountInfoByAuthenticationPhoneNumberQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Customers/GetCustomerAccountInfoByAuthenticationPhoneNumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomers_GetCustomerAccountInfoByAuthenticationPhoneNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomers_GetCustomerAccountInfoByAuthenticationPhoneNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCustomerAccountInfoByAuthenticationPhoneNumberQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCustomerAccountInfoByAuthenticationPhoneNumberQueryResult>;
        }));
    }

    protected processCustomers_GetCustomerAccountInfoByAuthenticationPhoneNumber(response: HttpResponseBase): Observable<GetCustomerAccountInfoByAuthenticationPhoneNumberQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCustomerAccountInfoByAuthenticationPhoneNumberQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCustomerAccountInfoByAuthenticationPhoneNumberQueryResult>(null as any);
    }

    customers_GetCustomerAccountInfoByAuthenticationEmailAddress(query: GetCustomerAccountInfoByAuthenticationEmailAddressQuery): Observable<GetCustomerAccountInfoByAuthenticationEmailAddressQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Customers/GetCustomerAccountInfoByAuthenticationEmailAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomers_GetCustomerAccountInfoByAuthenticationEmailAddress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomers_GetCustomerAccountInfoByAuthenticationEmailAddress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCustomerAccountInfoByAuthenticationEmailAddressQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCustomerAccountInfoByAuthenticationEmailAddressQueryResult>;
        }));
    }

    protected processCustomers_GetCustomerAccountInfoByAuthenticationEmailAddress(response: HttpResponseBase): Observable<GetCustomerAccountInfoByAuthenticationEmailAddressQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCustomerAccountInfoByAuthenticationEmailAddressQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCustomerAccountInfoByAuthenticationEmailAddressQueryResult>(null as any);
    }

    customers_CreateCustomerAccount(command: CreateCustomerAccountCommand): Observable<CreateCustomerAccountCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Customers/CreateCustomerAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomers_CreateCustomerAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomers_CreateCustomerAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateCustomerAccountCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateCustomerAccountCommandResponse>;
        }));
    }

    protected processCustomers_CreateCustomerAccount(response: HttpResponseBase): Observable<CreateCustomerAccountCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateCustomerAccountCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateCustomerAccountCommandResponse>(null as any);
    }

    customerMessaging_SetLocationMessagingSettings(command: SetLocationMessagingSettingsCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/CustomerMessaging/SetLocationMessagingSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomerMessaging_SetLocationMessagingSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerMessaging_SetLocationMessagingSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCustomerMessaging_SetLocationMessagingSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    customerMessaging_SetEmailContentSections(command: SetEmailContentSectionsCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/CustomerMessaging/SetEmailContentSections";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomerMessaging_SetEmailContentSections(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerMessaging_SetEmailContentSections(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCustomerMessaging_SetEmailContentSections(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    customerMessaging_SetCurrentEmailTheme(command: SetCurrentEmailThemeCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/CustomerMessaging/SetCurrentEmailTheme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomerMessaging_SetCurrentEmailTheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerMessaging_SetCurrentEmailTheme(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCustomerMessaging_SetCurrentEmailTheme(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    customerMessaging_SendTestEmail(command: SendTestEmailCommand): Observable<OutboundEmail> {
        let url_ = this.baseUrl + "/api/cqrs/CustomerMessaging/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomerMessaging_SendTestEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerMessaging_SendTestEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutboundEmail>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutboundEmail>;
        }));
    }

    protected processCustomerMessaging_SendTestEmail(response: HttpResponseBase): Observable<OutboundEmail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OutboundEmail;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OutboundEmail>(null as any);
    }

    customerMessaging_ResetEmailContentSection(command: ResetEmailContentSectionCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/CustomerMessaging/ResetEmailContentSection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomerMessaging_ResetEmailContentSection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerMessaging_ResetEmailContentSection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCustomerMessaging_ResetEmailContentSection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    customerMessaging_ResendOutboundEmail(command: ResendOutboundEmailCommand): Observable<OutboundEmail> {
        let url_ = this.baseUrl + "/api/cqrs/CustomerMessaging/ResendOutboundEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomerMessaging_ResendOutboundEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerMessaging_ResendOutboundEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutboundEmail>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutboundEmail>;
        }));
    }

    protected processCustomerMessaging_ResendOutboundEmail(response: HttpResponseBase): Observable<OutboundEmail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OutboundEmail;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OutboundEmail>(null as any);
    }

    customerMessaging_PreviewEmail(command: PreviewEmailCommand): Observable<RenderedEmail> {
        let url_ = this.baseUrl + "/api/cqrs/CustomerMessaging/PreviewEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomerMessaging_PreviewEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerMessaging_PreviewEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RenderedEmail>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RenderedEmail>;
        }));
    }

    protected processCustomerMessaging_PreviewEmail(response: HttpResponseBase): Observable<RenderedEmail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RenderedEmail;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RenderedEmail>(null as any);
    }

    customerMessaging_PreviewEmailForSubject(command: PreviewEmailForSubjectCommand): Observable<PreviewEmailForSubjectQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CustomerMessaging/PreviewEmailForSubject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomerMessaging_PreviewEmailForSubject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerMessaging_PreviewEmailForSubject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PreviewEmailForSubjectQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PreviewEmailForSubjectQueryResult>;
        }));
    }

    protected processCustomerMessaging_PreviewEmailForSubject(response: HttpResponseBase): Observable<PreviewEmailForSubjectQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PreviewEmailForSubjectQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PreviewEmailForSubjectQueryResult>(null as any);
    }

    customerMessaging_PreviewEmailDraft(command: PreviewEmailDraftCommand): Observable<RenderedEmail> {
        let url_ = this.baseUrl + "/api/cqrs/CustomerMessaging/PreviewEmailDraft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomerMessaging_PreviewEmailDraft(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerMessaging_PreviewEmailDraft(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RenderedEmail>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RenderedEmail>;
        }));
    }

    protected processCustomerMessaging_PreviewEmailDraft(response: HttpResponseBase): Observable<RenderedEmail> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RenderedEmail;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RenderedEmail>(null as any);
    }

    customerMessaging_GetRecentOutboundEmails(query: GetRecentOutboundEmailsQuery): Observable<GetRecentOutboundEmailsQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CustomerMessaging/GetRecentOutboundEmails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomerMessaging_GetRecentOutboundEmails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerMessaging_GetRecentOutboundEmails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRecentOutboundEmailsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRecentOutboundEmailsQueryResult>;
        }));
    }

    protected processCustomerMessaging_GetRecentOutboundEmails(response: HttpResponseBase): Observable<GetRecentOutboundEmailsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetRecentOutboundEmailsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRecentOutboundEmailsQueryResult>(null as any);
    }

    customerMessaging_GetOutboundEmailsBySubjectRef(query: GetOutboundEmailsBySubjectRefQuery): Observable<GetOutboundEmailsBySubjectRefQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CustomerMessaging/GetOutboundEmailsBySubjectRef";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomerMessaging_GetOutboundEmailsBySubjectRef(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerMessaging_GetOutboundEmailsBySubjectRef(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOutboundEmailsBySubjectRefQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOutboundEmailsBySubjectRefQueryResult>;
        }));
    }

    protected processCustomerMessaging_GetOutboundEmailsBySubjectRef(response: HttpResponseBase): Observable<GetOutboundEmailsBySubjectRefQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetOutboundEmailsBySubjectRefQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOutboundEmailsBySubjectRefQueryResult>(null as any);
    }

    customerMessaging_GetMessageKinds(): Observable<GetMessageKindsQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CustomerMessaging/GetMessageKinds";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomerMessaging_GetMessageKinds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerMessaging_GetMessageKinds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMessageKindsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMessageKindsQueryResult>;
        }));
    }

    protected processCustomerMessaging_GetMessageKinds(response: HttpResponseBase): Observable<GetMessageKindsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetMessageKindsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMessageKindsQueryResult>(null as any);
    }

    customerMessaging_GetLocationMessagingSettings(): Observable<GetLocationMessagingSettingsQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CustomerMessaging/GetLocationMessagingSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomerMessaging_GetLocationMessagingSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerMessaging_GetLocationMessagingSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLocationMessagingSettingsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLocationMessagingSettingsQueryResult>;
        }));
    }

    protected processCustomerMessaging_GetLocationMessagingSettings(response: HttpResponseBase): Observable<GetLocationMessagingSettingsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLocationMessagingSettingsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLocationMessagingSettingsQueryResult>(null as any);
    }

    customerMessaging_GetEmailContent(query: GetEmailContentQuery): Observable<GetEmailContentQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CustomerMessaging/GetEmailContent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomerMessaging_GetEmailContent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerMessaging_GetEmailContent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmailContentQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmailContentQueryResult>;
        }));
    }

    protected processCustomerMessaging_GetEmailContent(response: HttpResponseBase): Observable<GetEmailContentQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetEmailContentQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEmailContentQueryResult>(null as any);
    }

    customerMessaging_GetCurrentEmailTheme(): Observable<GetCurrentEmailThemeQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CustomerMessaging/GetCurrentEmailTheme";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomerMessaging_GetCurrentEmailTheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerMessaging_GetCurrentEmailTheme(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCurrentEmailThemeQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCurrentEmailThemeQueryResult>;
        }));
    }

    protected processCustomerMessaging_GetCurrentEmailTheme(response: HttpResponseBase): Observable<GetCurrentEmailThemeQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCurrentEmailThemeQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCurrentEmailThemeQueryResult>(null as any);
    }

    customDomains_TestEmailProviderConnection(): Observable<TestEmailProviderConnectionQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CustomDomains/TestEmailProviderConnection";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomDomains_TestEmailProviderConnection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomDomains_TestEmailProviderConnection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TestEmailProviderConnectionQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TestEmailProviderConnectionQueryResult>;
        }));
    }

    protected processCustomDomains_TestEmailProviderConnection(response: HttpResponseBase): Observable<TestEmailProviderConnectionQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TestEmailProviderConnectionQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TestEmailProviderConnectionQueryResult>(null as any);
    }

    customDomains_GetEmailProviderConfiguration(): Observable<GetEmailProviderConfigurationQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CustomDomains/GetEmailProviderConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomDomains_GetEmailProviderConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomDomains_GetEmailProviderConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmailProviderConfigurationQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmailProviderConfigurationQueryResult>;
        }));
    }

    protected processCustomDomains_GetEmailProviderConfiguration(response: HttpResponseBase): Observable<GetEmailProviderConfigurationQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetEmailProviderConfigurationQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEmailProviderConfigurationQueryResult>(null as any);
    }

    customDomains_UnassignCustomDomainHostnameFromLocation(command: UnassignCustomDomainHostnameFromLocationCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/CustomDomains/UnassignCustomDomainHostnameFromLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomDomains_UnassignCustomDomainHostnameFromLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomDomains_UnassignCustomDomainHostnameFromLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCustomDomains_UnassignCustomDomainHostnameFromLocation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    customDomains_RetryCustomDomainProvisioning(command: RetryCustomDomainProvisioningCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/CustomDomains/RetryCustomDomainProvisioning";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomDomains_RetryCustomDomainProvisioning(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomDomains_RetryCustomDomainProvisioning(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCustomDomains_RetryCustomDomainProvisioning(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    customDomains_RequestCustomDomain(command: RequestCustomDomainCommand): Observable<RequestCustomDomainCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/CustomDomains/RequestCustomDomain";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomDomains_RequestCustomDomain(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomDomains_RequestCustomDomain(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequestCustomDomainCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequestCustomDomainCommandResponse>;
        }));
    }

    protected processCustomDomains_RequestCustomDomain(response: HttpResponseBase): Observable<RequestCustomDomainCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RequestCustomDomainCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RequestCustomDomainCommandResponse>(null as any);
    }

    customDomains_RemoveCustomDomainHostname(command: RemoveCustomDomainHostnameCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/CustomDomains/RemoveCustomDomainHostname";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomDomains_RemoveCustomDomainHostname(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomDomains_RemoveCustomDomainHostname(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCustomDomains_RemoveCustomDomainHostname(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    customDomains_RemoveCustomDomainCapability(command: RemoveCustomDomainCapabilityCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/CustomDomains/RemoveCustomDomainCapability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomDomains_RemoveCustomDomainCapability(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomDomains_RemoveCustomDomainCapability(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCustomDomains_RemoveCustomDomainCapability(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    customDomains_GetTenantHostAllowance(): Observable<GetTenantHostAllowanceQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CustomDomains/GetTenantHostAllowance";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomDomains_GetTenantHostAllowance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomDomains_GetTenantHostAllowance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTenantHostAllowanceQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTenantHostAllowanceQueryResult>;
        }));
    }

    protected processCustomDomains_GetTenantHostAllowance(response: HttpResponseBase): Observable<GetTenantHostAllowanceQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetTenantHostAllowanceQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTenantHostAllowanceQueryResult>(null as any);
    }

    customDomains_GetCustomDomains(): Observable<GetCustomDomainsQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CustomDomains/GetCustomDomains";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomDomains_GetCustomDomains(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomDomains_GetCustomDomains(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCustomDomainsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCustomDomainsQueryResult>;
        }));
    }

    protected processCustomDomains_GetCustomDomains(response: HttpResponseBase): Observable<GetCustomDomainsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCustomDomainsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCustomDomainsQueryResult>(null as any);
    }

    customDomains_EvaluateCustomDomainHostname(query: EvaluateCustomDomainHostnameQuery): Observable<EvaluateCustomDomainHostnameQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CustomDomains/EvaluateCustomDomainHostname";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomDomains_EvaluateCustomDomainHostname(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomDomains_EvaluateCustomDomainHostname(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EvaluateCustomDomainHostnameQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EvaluateCustomDomainHostnameQueryResult>;
        }));
    }

    protected processCustomDomains_EvaluateCustomDomainHostname(response: HttpResponseBase): Observable<EvaluateCustomDomainHostnameQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EvaluateCustomDomainHostnameQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EvaluateCustomDomainHostnameQueryResult>(null as any);
    }

    customDomains_CheckCustomDomainCapabilityNow(command: CheckCustomDomainCapabilityNowCommand): Observable<CheckCustomDomainCapabilityNowQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CustomDomains/CheckCustomDomainCapabilityNow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomDomains_CheckCustomDomainCapabilityNow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomDomains_CheckCustomDomainCapabilityNow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckCustomDomainCapabilityNowQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckCustomDomainCapabilityNowQueryResult>;
        }));
    }

    protected processCustomDomains_CheckCustomDomainCapabilityNow(response: HttpResponseBase): Observable<CheckCustomDomainCapabilityNowQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CheckCustomDomainCapabilityNowQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CheckCustomDomainCapabilityNowQueryResult>(null as any);
    }

    customDomains_AssignCustomDomainHostnameToLocation(command: AssignCustomDomainHostnameToLocationCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/CustomDomains/AssignCustomDomainHostnameToLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomDomains_AssignCustomDomainHostnameToLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomDomains_AssignCustomDomainHostnameToLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCustomDomains_AssignCustomDomainHostnameToLocation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    customDomains_ActivateCustomDomainCapability(command: ActivateCustomDomainCapabilityCommand): Observable<ActivateCustomDomainCapabilityCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/CustomDomains/ActivateCustomDomainCapability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomDomains_ActivateCustomDomainCapability(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomDomains_ActivateCustomDomainCapability(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivateCustomDomainCapabilityCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivateCustomDomainCapabilityCommandResponse>;
        }));
    }

    protected processCustomDomains_ActivateCustomDomainCapability(response: HttpResponseBase): Observable<ActivateCustomDomainCapabilityCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ActivateCustomDomainCapabilityCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivateCustomDomainCapabilityCommandResponse>(null as any);
    }

    customDomains_TestDnsProviderConnection(): Observable<TestDnsProviderConnectionQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CustomDomains/TestDnsProviderConnection";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomDomains_TestDnsProviderConnection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomDomains_TestDnsProviderConnection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TestDnsProviderConnectionQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TestDnsProviderConnectionQueryResult>;
        }));
    }

    protected processCustomDomains_TestDnsProviderConnection(response: HttpResponseBase): Observable<TestDnsProviderConnectionQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TestDnsProviderConnectionQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TestDnsProviderConnectionQueryResult>(null as any);
    }

    customDomains_SetDnsProviderOverride(command: SetDnsProviderOverrideCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/CustomDomains/SetDnsProviderOverride";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomDomains_SetDnsProviderOverride(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomDomains_SetDnsProviderOverride(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCustomDomains_SetDnsProviderOverride(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    customDomains_GetDnsProviderConfiguration(): Observable<GetDnsProviderConfigurationQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CustomDomains/GetDnsProviderConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomDomains_GetDnsProviderConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomDomains_GetDnsProviderConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDnsProviderConfigurationQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDnsProviderConfigurationQueryResult>;
        }));
    }

    protected processCustomDomains_GetDnsProviderConfiguration(response: HttpResponseBase): Observable<GetDnsProviderConfigurationQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetDnsProviderConfigurationQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDnsProviderConfigurationQueryResult>(null as any);
    }

    couponCampaign_GetCouponCampaignListView(query: GetCouponCampaignListViewQuery): Observable<GetCouponCampaignListViewQueryResult> {
        let url_ = this.baseUrl + "/CouponCampaign/GetCouponCampaignListView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCouponCampaign_GetCouponCampaignListView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCouponCampaign_GetCouponCampaignListView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCouponCampaignListViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCouponCampaignListViewQueryResult>;
        }));
    }

    protected processCouponCampaign_GetCouponCampaignListView(response: HttpResponseBase): Observable<GetCouponCampaignListViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCouponCampaignListViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCouponCampaignListViewQueryResult>(null as any);
    }

    couponCampaign_GetCouponCampaignEditItemView(query: GetCouponCampaignEditItemViewQuery): Observable<GetCouponCampaignEditItemViewQueryResult> {
        let url_ = this.baseUrl + "/CouponCampaign/GetCouponCampaignEditItemView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCouponCampaign_GetCouponCampaignEditItemView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCouponCampaign_GetCouponCampaignEditItemView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCouponCampaignEditItemViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCouponCampaignEditItemViewQueryResult>;
        }));
    }

    protected processCouponCampaign_GetCouponCampaignEditItemView(response: HttpResponseBase): Observable<GetCouponCampaignEditItemViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCouponCampaignEditItemViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCouponCampaignEditItemViewQueryResult>(null as any);
    }

    couponCampaign_GetCouponCampaignEditItemCodesView(query: GetCouponCampaignEditItemCodesViewQuery): Observable<GetCouponCampaignEditItemCodesViewQueryResult> {
        let url_ = this.baseUrl + "/CouponCampaign/GetCouponCampaignEditItemCodesView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCouponCampaign_GetCouponCampaignEditItemCodesView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCouponCampaign_GetCouponCampaignEditItemCodesView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCouponCampaignEditItemCodesViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCouponCampaignEditItemCodesViewQueryResult>;
        }));
    }

    protected processCouponCampaign_GetCouponCampaignEditItemCodesView(response: HttpResponseBase): Observable<GetCouponCampaignEditItemCodesViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCouponCampaignEditItemCodesViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCouponCampaignEditItemCodesViewQueryResult>(null as any);
    }

    couponCampaign_GetCouponCampaignAddDialogView(query: GetCouponCampaignAddDialogViewQuery): Observable<GetCouponCampaignAddDialogViewQueryResult> {
        let url_ = this.baseUrl + "/CouponCampaign/GetCouponCampaignAddDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCouponCampaign_GetCouponCampaignAddDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCouponCampaign_GetCouponCampaignAddDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCouponCampaignAddDialogViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCouponCampaignAddDialogViewQueryResult>;
        }));
    }

    protected processCouponCampaign_GetCouponCampaignAddDialogView(response: HttpResponseBase): Observable<GetCouponCampaignAddDialogViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCouponCampaignAddDialogViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCouponCampaignAddDialogViewQueryResult>(null as any);
    }

    cmsTemplate_GetListView(query: GetListViewQuery2): Observable<CmsTemplateListView> {
        let url_ = this.baseUrl + "/CmsTemplate/GetListView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsTemplate_GetListView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsTemplate_GetListView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CmsTemplateListView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CmsTemplateListView>;
        }));
    }

    protected processCmsTemplate_GetListView(response: HttpResponseBase): Observable<CmsTemplateListView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CmsTemplateListView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CmsTemplateListView>(null as any);
    }

    cmsTemplate_GetEditItemView(query: GetEditItemViewQuery2): Observable<CmsTemplateEditItemView> {
        let url_ = this.baseUrl + "/CmsTemplate/GetEditItemView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsTemplate_GetEditItemView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsTemplate_GetEditItemView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CmsTemplateEditItemView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CmsTemplateEditItemView>;
        }));
    }

    protected processCmsTemplate_GetEditItemView(response: HttpResponseBase): Observable<CmsTemplateEditItemView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CmsTemplateEditItemView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CmsTemplateEditItemView>(null as any);
    }

    cmsTemplate_GetAddPartdDialogView(query: GetAddPartdDialogViewQuery): Observable<CmsTemplateAddPartDialogView> {
        let url_ = this.baseUrl + "/CmsTemplate/GetAddPartdDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsTemplate_GetAddPartdDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsTemplate_GetAddPartdDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CmsTemplateAddPartDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CmsTemplateAddPartDialogView>;
        }));
    }

    protected processCmsTemplate_GetAddPartdDialogView(response: HttpResponseBase): Observable<CmsTemplateAddPartDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CmsTemplateAddPartDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CmsTemplateAddPartDialogView>(null as any);
    }

    cmsTemplate_GetAddDialogView(query: GetAddDialogViewQuery): Observable<CmsTemplateAddDialogView> {
        let url_ = this.baseUrl + "/CmsTemplate/GetAddDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsTemplate_GetAddDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsTemplate_GetAddDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CmsTemplateAddDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CmsTemplateAddDialogView>;
        }));
    }

    protected processCmsTemplate_GetAddDialogView(response: HttpResponseBase): Observable<CmsTemplateAddDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CmsTemplateAddDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CmsTemplateAddDialogView>(null as any);
    }

    cms_TemplatePart_GetCmsTemplatePartListView(query: GetCmsTemplatePartListViewQuery): Observable<GetCmsTemplatePartListViewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Cms/TemplatePart/GetCmsTemplatePartListView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCms_TemplatePart_GetCmsTemplatePartListView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCms_TemplatePart_GetCmsTemplatePartListView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCmsTemplatePartListViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCmsTemplatePartListViewQueryResult>;
        }));
    }

    protected processCms_TemplatePart_GetCmsTemplatePartListView(response: HttpResponseBase): Observable<GetCmsTemplatePartListViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCmsTemplatePartListViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCmsTemplatePartListViewQueryResult>(null as any);
    }

    cms_TemplatePart_GetCmsTemplatePartEditItemView(query: GetCmsTemplatePartEditItemViewQuery): Observable<GetCmsTemplatePartEditItemViewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Cms/TemplatePart/GetCmsTemplatePartEditItemView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCms_TemplatePart_GetCmsTemplatePartEditItemView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCms_TemplatePart_GetCmsTemplatePartEditItemView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCmsTemplatePartEditItemViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCmsTemplatePartEditItemViewQueryResult>;
        }));
    }

    protected processCms_TemplatePart_GetCmsTemplatePartEditItemView(response: HttpResponseBase): Observable<GetCmsTemplatePartEditItemViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCmsTemplatePartEditItemViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCmsTemplatePartEditItemViewQueryResult>(null as any);
    }

    cms_TemplatePart_GetCmsTemplatePartAddDialogView(query: GetCmsTemplatePartAddDialogViewQuery): Observable<GetCmsTemplatePartAddDialogViewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Cms/TemplatePart/GetCmsTemplatePartAddDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCms_TemplatePart_GetCmsTemplatePartAddDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCms_TemplatePart_GetCmsTemplatePartAddDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCmsTemplatePartAddDialogViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCmsTemplatePartAddDialogViewQueryResult>;
        }));
    }

    protected processCms_TemplatePart_GetCmsTemplatePartAddDialogView(response: HttpResponseBase): Observable<GetCmsTemplatePartAddDialogViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCmsTemplatePartAddDialogViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCmsTemplatePartAddDialogViewQueryResult>(null as any);
    }

    cms_SiteTheme_GetCmsSiteThemeListView(query: GetCmsSiteThemeListViewQuery): Observable<GetCmsSiteThemeListViewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Cms/SiteTheme/GetCmsSiteThemeListView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCms_SiteTheme_GetCmsSiteThemeListView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCms_SiteTheme_GetCmsSiteThemeListView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCmsSiteThemeListViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCmsSiteThemeListViewQueryResult>;
        }));
    }

    protected processCms_SiteTheme_GetCmsSiteThemeListView(response: HttpResponseBase): Observable<GetCmsSiteThemeListViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCmsSiteThemeListViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCmsSiteThemeListViewQueryResult>(null as any);
    }

    cms_SiteTheme_GetCmsSiteThemeEditItemView(query: GetCmsSiteThemeEditItemViewQuery): Observable<GetCmsSiteThemeEditItemViewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Cms/SiteTheme/GetCmsSiteThemeEditItemView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCms_SiteTheme_GetCmsSiteThemeEditItemView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCms_SiteTheme_GetCmsSiteThemeEditItemView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCmsSiteThemeEditItemViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCmsSiteThemeEditItemViewQueryResult>;
        }));
    }

    protected processCms_SiteTheme_GetCmsSiteThemeEditItemView(response: HttpResponseBase): Observable<GetCmsSiteThemeEditItemViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCmsSiteThemeEditItemViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCmsSiteThemeEditItemViewQueryResult>(null as any);
    }

    cms_Sites_UpdateCmsSiteDomain(command: UpdateCmsSiteDomainCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Cms/Sites/UpdateCmsSiteDomain";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCms_Sites_UpdateCmsSiteDomain(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCms_Sites_UpdateCmsSiteDomain(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCms_Sites_UpdateCmsSiteDomain(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    cms_Sites_SetCmsSiteLogo(command: SetCmsSiteLogoCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Cms/Sites/SetCmsSiteLogo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCms_Sites_SetCmsSiteLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCms_Sites_SetCmsSiteLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCms_Sites_SetCmsSiteLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    cms_Sites_SetCmsSiteFavicon(command: SetCmsSiteFaviconCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Cms/Sites/SetCmsSiteFavicon";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCms_Sites_SetCmsSiteFavicon(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCms_Sites_SetCmsSiteFavicon(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCms_Sites_SetCmsSiteFavicon(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    cms_Sites_SetCmsSiteDomainPrefix(command: SetCmsSiteDomainPrefixCommand): Observable<SetCmsSiteDomainPrefixCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Cms/Sites/SetCmsSiteDomainPrefix";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCms_Sites_SetCmsSiteDomainPrefix(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCms_Sites_SetCmsSiteDomainPrefix(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SetCmsSiteDomainPrefixCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SetCmsSiteDomainPrefixCommandResponse>;
        }));
    }

    protected processCms_Sites_SetCmsSiteDomainPrefix(response: HttpResponseBase): Observable<SetCmsSiteDomainPrefixCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SetCmsSiteDomainPrefixCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SetCmsSiteDomainPrefixCommandResponse>(null as any);
    }

    cms_Sites_SetCmsSiteDefaultLocale(command: SetCmsSiteDefaultLocaleCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Cms/Sites/SetCmsSiteDefaultLocale";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCms_Sites_SetCmsSiteDefaultLocale(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCms_Sites_SetCmsSiteDefaultLocale(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCms_Sites_SetCmsSiteDefaultLocale(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    cms_Sites_RemoveCmsSiteDomain(command: RemoveCmsSiteDomainCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Cms/Sites/RemoveCmsSiteDomain";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCms_Sites_RemoveCmsSiteDomain(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCms_Sites_RemoveCmsSiteDomain(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCms_Sites_RemoveCmsSiteDomain(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    cms_GetSeoPagesForHostname(query: GetSeoPagesForHostnameQuery): Observable<GetSeoPagesForHostnameQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Cms/Sites/GetSeoPagesForHostname";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCms_GetSeoPagesForHostname(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCms_GetSeoPagesForHostname(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSeoPagesForHostnameQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSeoPagesForHostnameQueryResult>;
        }));
    }

    protected processCms_GetSeoPagesForHostname(response: HttpResponseBase): Observable<GetSeoPagesForHostnameQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetSeoPagesForHostnameQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSeoPagesForHostnameQueryResult>(null as any);
    }

    cms_Sites_GetCmsSiteListPageView(query: GetCmsSiteListPageViewQuery): Observable<GetCmsSiteListPageViewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Cms/Sites/GetCmsSiteListPageView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCms_Sites_GetCmsSiteListPageView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCms_Sites_GetCmsSiteListPageView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCmsSiteListPageViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCmsSiteListPageViewQueryResult>;
        }));
    }

    protected processCms_Sites_GetCmsSiteListPageView(response: HttpResponseBase): Observable<GetCmsSiteListPageViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCmsSiteListPageViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCmsSiteListPageViewQueryResult>(null as any);
    }

    cms_Sites_GetCmsSiteEditItemView(query: GetCmsSiteEditItemViewQuery): Observable<GetCmsSiteEditItemViewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Cms/Sites/GetCmsSiteEditItemView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCms_Sites_GetCmsSiteEditItemView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCms_Sites_GetCmsSiteEditItemView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCmsSiteEditItemViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCmsSiteEditItemViewQueryResult>;
        }));
    }

    protected processCms_Sites_GetCmsSiteEditItemView(response: HttpResponseBase): Observable<GetCmsSiteEditItemViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCmsSiteEditItemViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCmsSiteEditItemViewQueryResult>(null as any);
    }

    cms_Sites_GetCmsSiteEditItemSelfServiceView(query: GetCmsSiteEditItemSelfServiceViewQuery): Observable<GetCmsSiteEditItemSelfServiceViewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Cms/Sites/GetCmsSiteEditItemSelfServiceView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCms_Sites_GetCmsSiteEditItemSelfServiceView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCms_Sites_GetCmsSiteEditItemSelfServiceView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCmsSiteEditItemSelfServiceViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCmsSiteEditItemSelfServiceViewQueryResult>;
        }));
    }

    protected processCms_Sites_GetCmsSiteEditItemSelfServiceView(response: HttpResponseBase): Observable<GetCmsSiteEditItemSelfServiceViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCmsSiteEditItemSelfServiceViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCmsSiteEditItemSelfServiceViewQueryResult>(null as any);
    }

    cms_Sites_GetCmsSiteEditItemDomainView(query: GetCmsSiteEditItemDomainViewQuery): Observable<GetCmsSiteEditItemDomainViewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Cms/Sites/GetCmsSiteEditItemDomainView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCms_Sites_GetCmsSiteEditItemDomainView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCms_Sites_GetCmsSiteEditItemDomainView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCmsSiteEditItemDomainViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCmsSiteEditItemDomainViewQueryResult>;
        }));
    }

    protected processCms_Sites_GetCmsSiteEditItemDomainView(response: HttpResponseBase): Observable<GetCmsSiteEditItemDomainViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCmsSiteEditItemDomainViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCmsSiteEditItemDomainViewQueryResult>(null as any);
    }

    cms_Sites_GetCmsSiteEditItemAnalyticsView(query: GetCmsSiteEditItemAnalyticsViewQuery): Observable<GetCmsSiteEditItemAnalyticsViewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Cms/Sites/GetCmsSiteEditItemAnalyticsView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCms_Sites_GetCmsSiteEditItemAnalyticsView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCms_Sites_GetCmsSiteEditItemAnalyticsView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCmsSiteEditItemAnalyticsViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCmsSiteEditItemAnalyticsViewQueryResult>;
        }));
    }

    protected processCms_Sites_GetCmsSiteEditItemAnalyticsView(response: HttpResponseBase): Observable<GetCmsSiteEditItemAnalyticsViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCmsSiteEditItemAnalyticsViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCmsSiteEditItemAnalyticsViewQueryResult>(null as any);
    }

    cms_Sites_GetCmsSiteDomainPrefixAvailability(query: GetCmsSiteDomainPrefixAvailabilityQuery): Observable<GetCmsSiteDomainPrefixAvailabilityQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Cms/Sites/GetCmsSiteDomainPrefixAvailability";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCms_Sites_GetCmsSiteDomainPrefixAvailability(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCms_Sites_GetCmsSiteDomainPrefixAvailability(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCmsSiteDomainPrefixAvailabilityQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCmsSiteDomainPrefixAvailabilityQueryResult>;
        }));
    }

    protected processCms_Sites_GetCmsSiteDomainPrefixAvailability(response: HttpResponseBase): Observable<GetCmsSiteDomainPrefixAvailabilityQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCmsSiteDomainPrefixAvailabilityQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCmsSiteDomainPrefixAvailabilityQueryResult>(null as any);
    }

    cms_Sites_ClearCmsSiteLogo(command: ClearCmsSiteLogoCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Cms/Sites/ClearCmsSiteLogo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCms_Sites_ClearCmsSiteLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCms_Sites_ClearCmsSiteLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCms_Sites_ClearCmsSiteLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    cms_Sites_ClearCmsSiteFavicon(command: ClearCmsSiteFaviconCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Cms/Sites/ClearCmsSiteFavicon";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCms_Sites_ClearCmsSiteFavicon(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCms_Sites_ClearCmsSiteFavicon(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCms_Sites_ClearCmsSiteFavicon(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    cms_Sites_AddCmsSiteDomain(command: AddCmsSiteDomainCommand): Observable<AddCmsSiteDomainCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Cms/Sites/AddCmsSiteDomain";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCms_Sites_AddCmsSiteDomain(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCms_Sites_AddCmsSiteDomain(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddCmsSiteDomainCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddCmsSiteDomainCommandResponse>;
        }));
    }

    protected processCms_Sites_AddCmsSiteDomain(response: HttpResponseBase): Observable<AddCmsSiteDomainCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddCmsSiteDomainCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddCmsSiteDomainCommandResponse>(null as any);
    }

    cms_SiteCheckOuts_GetCmsSiteCheckOutListPageView(query: GetCmsSiteCheckOutListPageViewQuery): Observable<GetCmsSiteCheckOutListPageViewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Cms/SiteCheckOuts/GetCmsSiteCheckOutListPageView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCms_SiteCheckOuts_GetCmsSiteCheckOutListPageView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCms_SiteCheckOuts_GetCmsSiteCheckOutListPageView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCmsSiteCheckOutListPageViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCmsSiteCheckOutListPageViewQueryResult>;
        }));
    }

    protected processCms_SiteCheckOuts_GetCmsSiteCheckOutListPageView(response: HttpResponseBase): Observable<GetCmsSiteCheckOutListPageViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCmsSiteCheckOutListPageViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCmsSiteCheckOutListPageViewQueryResult>(null as any);
    }

    cms_SiteCheckOuts_GetCmsSiteCheckOutEditItemView(query: GetCmsSiteCheckOutEditItemViewQuery): Observable<GetCmsSiteCheckOutEditItemViewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Cms/SiteCheckOuts/GetCmsSiteCheckOutEditItemView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCms_SiteCheckOuts_GetCmsSiteCheckOutEditItemView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCms_SiteCheckOuts_GetCmsSiteCheckOutEditItemView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCmsSiteCheckOutEditItemViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCmsSiteCheckOutEditItemViewQueryResult>;
        }));
    }

    protected processCms_SiteCheckOuts_GetCmsSiteCheckOutEditItemView(response: HttpResponseBase): Observable<GetCmsSiteCheckOutEditItemViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCmsSiteCheckOutEditItemViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCmsSiteCheckOutEditItemViewQueryResult>(null as any);
    }

    cms_ContentTypes_GetContentTypePartAddDialogView(query: GetContentTypePartAddDialogViewQuery): Observable<GetContentTypePartAddDialogViewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Cms/ContentTypes/GetContentTypePartAddDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCms_ContentTypes_GetContentTypePartAddDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCms_ContentTypes_GetContentTypePartAddDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetContentTypePartAddDialogViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetContentTypePartAddDialogViewQueryResult>;
        }));
    }

    protected processCms_ContentTypes_GetContentTypePartAddDialogView(response: HttpResponseBase): Observable<GetContentTypePartAddDialogViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetContentTypePartAddDialogViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetContentTypePartAddDialogViewQueryResult>(null as any);
    }

    cms_ContentTypes_GetContentTypeListPageView(query: GetContentTypeListPageViewQuery): Observable<GetContentTypeListPageViewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Cms/ContentTypes/GetContentTypeListPageView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCms_ContentTypes_GetContentTypeListPageView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCms_ContentTypes_GetContentTypeListPageView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetContentTypeListPageViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetContentTypeListPageViewQueryResult>;
        }));
    }

    protected processCms_ContentTypes_GetContentTypeListPageView(response: HttpResponseBase): Observable<GetContentTypeListPageViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetContentTypeListPageViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetContentTypeListPageViewQueryResult>(null as any);
    }

    cms_ContentTypes_GetContentTypeEditItemView(query: GetContentTypeEditItemViewQuery): Observable<GetContentTypeEditItemViewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Cms/ContentTypes/GetContentTypeEditItemView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCms_ContentTypes_GetContentTypeEditItemView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCms_ContentTypes_GetContentTypeEditItemView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetContentTypeEditItemViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetContentTypeEditItemViewQueryResult>;
        }));
    }

    protected processCms_ContentTypes_GetContentTypeEditItemView(response: HttpResponseBase): Observable<GetContentTypeEditItemViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetContentTypeEditItemViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetContentTypeEditItemViewQueryResult>(null as any);
    }

    cms_ContentPart_GetCmsContentPartListView(query: GetCmsContentPartListViewQuery): Observable<GetCmsContentPartListViewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Cms/ContentPart/GetCmsContentPartListView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCms_ContentPart_GetCmsContentPartListView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCms_ContentPart_GetCmsContentPartListView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCmsContentPartListViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCmsContentPartListViewQueryResult>;
        }));
    }

    protected processCms_ContentPart_GetCmsContentPartListView(response: HttpResponseBase): Observable<GetCmsContentPartListViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCmsContentPartListViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCmsContentPartListViewQueryResult>(null as any);
    }

    cms_ContentPart_GetCmsContentPartFieldAddDialogView(query: GetCmsContentPartFieldAddDialogViewQuery): Observable<GetCmsContentPartFieldAddDialogViewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Cms/ContentPart/GetCmsContentPartFieldAddDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCms_ContentPart_GetCmsContentPartFieldAddDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCms_ContentPart_GetCmsContentPartFieldAddDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCmsContentPartFieldAddDialogViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCmsContentPartFieldAddDialogViewQueryResult>;
        }));
    }

    protected processCms_ContentPart_GetCmsContentPartFieldAddDialogView(response: HttpResponseBase): Observable<GetCmsContentPartFieldAddDialogViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCmsContentPartFieldAddDialogViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCmsContentPartFieldAddDialogViewQueryResult>(null as any);
    }

    cms_ContentPart_GetCmsContentPartEditItemView(query: GetCmsContentPartEditItemViewQuery): Observable<GetCmsContentPartEditItemViewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Cms/ContentPart/GetCmsContentPartEditItemView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCms_ContentPart_GetCmsContentPartEditItemView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCms_ContentPart_GetCmsContentPartEditItemView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCmsContentPartEditItemViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCmsContentPartEditItemViewQueryResult>;
        }));
    }

    protected processCms_ContentPart_GetCmsContentPartEditItemView(response: HttpResponseBase): Observable<GetCmsContentPartEditItemViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCmsContentPartEditItemViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCmsContentPartEditItemViewQueryResult>(null as any);
    }

    cms_ContentItem_GetCmsContentItemVersionEditItemView(query: GetCmsContentItemVersionEditItemViewQuery): Observable<CmsContentItemVersionEditItemViewResult> {
        let url_ = this.baseUrl + "/api/cqrs/Cms/ContentItem/GetCmsContentItemVersionEditItemView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCms_ContentItem_GetCmsContentItemVersionEditItemView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCms_ContentItem_GetCmsContentItemVersionEditItemView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CmsContentItemVersionEditItemViewResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CmsContentItemVersionEditItemViewResult>;
        }));
    }

    protected processCms_ContentItem_GetCmsContentItemVersionEditItemView(response: HttpResponseBase): Observable<CmsContentItemVersionEditItemViewResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CmsContentItemVersionEditItemViewResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CmsContentItemVersionEditItemViewResult>(null as any);
    }

    cms_ContentItem_GetCmsContentItemLinkPickerView(query: GetCmsContentItemLinkPickerViewQuery): Observable<GetCmsContentItemLinkPickerViewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Cms/ContentItem/GetCmsContentItemLinkPickerView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCms_ContentItem_GetCmsContentItemLinkPickerView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCms_ContentItem_GetCmsContentItemLinkPickerView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCmsContentItemLinkPickerViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCmsContentItemLinkPickerViewQueryResult>;
        }));
    }

    protected processCms_ContentItem_GetCmsContentItemLinkPickerView(response: HttpResponseBase): Observable<GetCmsContentItemLinkPickerViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCmsContentItemLinkPickerViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCmsContentItemLinkPickerViewQueryResult>(null as any);
    }

    cms_ContentItem_GetCmsContentItemEditItemView(query: GetCmsContentItemEditItemViewQuery): Observable<CmsContentItemEditItemViewResult> {
        let url_ = this.baseUrl + "/api/cqrs/Cms/ContentItem/GetCmsContentItemEditItemView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCms_ContentItem_GetCmsContentItemEditItemView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCms_ContentItem_GetCmsContentItemEditItemView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CmsContentItemEditItemViewResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CmsContentItemEditItemViewResult>;
        }));
    }

    protected processCms_ContentItem_GetCmsContentItemEditItemView(response: HttpResponseBase): Observable<CmsContentItemEditItemViewResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CmsContentItemEditItemViewResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CmsContentItemEditItemViewResult>(null as any);
    }

    cms_ContentItem_GetCmsContentItemAddDialogView(query: GetCmsContentItemAddDialogViewQuery): Observable<GetCmsContentItemAddDialogViewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Cms/ContentItem/GetCmsContentItemAddDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCms_ContentItem_GetCmsContentItemAddDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCms_ContentItem_GetCmsContentItemAddDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCmsContentItemAddDialogViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCmsContentItemAddDialogViewQueryResult>;
        }));
    }

    protected processCms_ContentItem_GetCmsContentItemAddDialogView(response: HttpResponseBase): Observable<GetCmsContentItemAddDialogViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCmsContentItemAddDialogViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCmsContentItemAddDialogViewQueryResult>(null as any);
    }

    cmsV2Settings_TakePublicWebsiteOffline(command: TakePublicWebsiteOfflineCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Settings/TakePublicWebsiteOffline";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Settings_TakePublicWebsiteOffline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Settings_TakePublicWebsiteOffline(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCmsV2Settings_TakePublicWebsiteOffline(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    cmsV2Settings_SetWebsiteName(command: SetWebsiteNameCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Settings/SetWebsiteName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Settings_SetWebsiteName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Settings_SetWebsiteName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCmsV2Settings_SetWebsiteName(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    cmsV2Settings_MakeOfflineWebsiteAvailableToPublic(command: MakeOfflineWebsiteAvailableToPublicCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Settings/MakeOfflineWebsiteAvailableToPublic";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Settings_MakeOfflineWebsiteAvailableToPublic(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Settings_MakeOfflineWebsiteAvailableToPublic(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCmsV2Settings_MakeOfflineWebsiteAvailableToPublic(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    cmsV2Settings_GetWebsites(query: GetWebsitesQuery): Observable<GetWebsitesQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Settings/GetWebsites";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Settings_GetWebsites(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Settings_GetWebsites(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetWebsitesQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetWebsitesQueryResult>;
        }));
    }

    protected processCmsV2Settings_GetWebsites(response: HttpResponseBase): Observable<GetWebsitesQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetWebsitesQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetWebsitesQueryResult>(null as any);
    }

    cmsV2Settings_CreateWebsite(command: CreateWebsiteCommand): Observable<CreateWebsiteCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Settings/CreateWebsite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Settings_CreateWebsite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Settings_CreateWebsite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateWebsiteCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateWebsiteCommandResponse>;
        }));
    }

    protected processCmsV2Settings_CreateWebsite(response: HttpResponseBase): Observable<CreateWebsiteCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateWebsiteCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateWebsiteCommandResponse>(null as any);
    }

    cmsV2Settings_SetWebsiteDomainLocaleAsPrimary(command: SetWebsiteDomainLocaleAsPrimaryCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Settings/SetWebsiteDomainLocaleAsPrimary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Settings_SetWebsiteDomainLocaleAsPrimary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Settings_SetWebsiteDomainLocaleAsPrimary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCmsV2Settings_SetWebsiteDomainLocaleAsPrimary(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    cmsV2Settings_RemoveWebsiteDomainSecondaryLocale(command: RemoveWebsiteDomainSecondaryLocaleCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Settings/RemoveWebsiteDomainSecondaryLocale";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Settings_RemoveWebsiteDomainSecondaryLocale(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Settings_RemoveWebsiteDomainSecondaryLocale(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCmsV2Settings_RemoveWebsiteDomainSecondaryLocale(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    cmsV2Settings_GetWebsitesWithDomainsLocales(query: GetWebsitesWithDomainsLocalesQuery): Observable<GetWebsitesWithDomainsLocalesQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Settings/GetWebsitesWithDomainsLocales";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Settings_GetWebsitesWithDomainsLocales(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Settings_GetWebsitesWithDomainsLocales(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetWebsitesWithDomainsLocalesQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetWebsitesWithDomainsLocalesQueryResult>;
        }));
    }

    protected processCmsV2Settings_GetWebsitesWithDomainsLocales(response: HttpResponseBase): Observable<GetWebsitesWithDomainsLocalesQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetWebsitesWithDomainsLocalesQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetWebsitesWithDomainsLocalesQueryResult>(null as any);
    }

    cmsV2Settings_AddWebsiteDomainSecondaryLocale(command: AddWebsiteDomainSecondaryLocaleCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Settings/AddWebsiteDomainSecondaryLocale";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Settings_AddWebsiteDomainSecondaryLocale(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Settings_AddWebsiteDomainSecondaryLocale(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCmsV2Settings_AddWebsiteDomainSecondaryLocale(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    cmsV2Settings_RemoveWebsiteDomain(command: RemoveWebsiteDomainCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Settings/RemoveWebsiteDomain";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Settings_RemoveWebsiteDomain(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Settings_RemoveWebsiteDomain(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCmsV2Settings_RemoveWebsiteDomain(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    cmsV2Settings_GetWebsitesWithDomains(query: GetWebsitesWithDomainsQuery): Observable<GetWebsitesWithDomainsQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Settings/GetWebsitesWithDomains";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Settings_GetWebsitesWithDomains(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Settings_GetWebsitesWithDomains(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetWebsitesWithDomainsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetWebsitesWithDomainsQueryResult>;
        }));
    }

    protected processCmsV2Settings_GetWebsitesWithDomains(response: HttpResponseBase): Observable<GetWebsitesWithDomainsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetWebsitesWithDomainsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetWebsitesWithDomainsQueryResult>(null as any);
    }

    cmsV2Settings_AddWebsiteDomain(command: AddWebsiteDomainCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Settings/AddWebsiteDomain";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Settings_AddWebsiteDomain(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Settings_AddWebsiteDomain(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCmsV2Settings_AddWebsiteDomain(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    cmsV2Preview_GetWebsiteThemeStylesheetForWebsitePagePreview(query: GetWebsiteThemeStylesheetForWebsitePagePreviewQuery): Observable<GetWebsiteThemeStylesheetForWebsitePagePreviewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Preview/GetWebsiteThemeStylesheetForWebsitePagePreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Preview_GetWebsiteThemeStylesheetForWebsitePagePreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Preview_GetWebsiteThemeStylesheetForWebsitePagePreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetWebsiteThemeStylesheetForWebsitePagePreviewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetWebsiteThemeStylesheetForWebsitePagePreviewQueryResult>;
        }));
    }

    protected processCmsV2Preview_GetWebsiteThemeStylesheetForWebsitePagePreview(response: HttpResponseBase): Observable<GetWebsiteThemeStylesheetForWebsitePagePreviewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetWebsiteThemeStylesheetForWebsitePagePreviewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetWebsiteThemeStylesheetForWebsitePagePreviewQueryResult>(null as any);
    }

    cmsV2Preview_GetWebsiteThemeStylesheetForComponentPreview(query: GetWebsiteThemeStylesheetForComponentPreviewQuery): Observable<GetWebsiteThemeStylesheetForComponentPreviewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Preview/GetWebsiteThemeStylesheetForComponentPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Preview_GetWebsiteThemeStylesheetForComponentPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Preview_GetWebsiteThemeStylesheetForComponentPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetWebsiteThemeStylesheetForComponentPreviewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetWebsiteThemeStylesheetForComponentPreviewQueryResult>;
        }));
    }

    protected processCmsV2Preview_GetWebsiteThemeStylesheetForComponentPreview(response: HttpResponseBase): Observable<GetWebsiteThemeStylesheetForComponentPreviewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetWebsiteThemeStylesheetForComponentPreviewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetWebsiteThemeStylesheetForComponentPreviewQueryResult>(null as any);
    }

    cmsV2Preview_GetPageContentHtmlForWebsitePagePreview(query: GetPageContentHtmlForWebsitePagePreviewQuery): Observable<GetPageContentHtmlForWebsitePagePreviewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Preview/GetPageContentHtmlForWebsitePagePreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Preview_GetPageContentHtmlForWebsitePagePreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Preview_GetPageContentHtmlForWebsitePagePreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPageContentHtmlForWebsitePagePreviewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPageContentHtmlForWebsitePagePreviewQueryResult>;
        }));
    }

    protected processCmsV2Preview_GetPageContentHtmlForWebsitePagePreview(response: HttpResponseBase): Observable<GetPageContentHtmlForWebsitePagePreviewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPageContentHtmlForWebsitePagePreviewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPageContentHtmlForWebsitePagePreviewQueryResult>(null as any);
    }

    cmsV2Preview_GetPageContentCellHtmlForWebsitePagePreview(query: GetPageContentCellHtmlForWebsitePagePreviewQuery): Observable<GetPageContentCellHtmlForWebsitePagePreviewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Preview/GetPageContentCellHtmlForWebsitePagePreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Preview_GetPageContentCellHtmlForWebsitePagePreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Preview_GetPageContentCellHtmlForWebsitePagePreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPageContentCellHtmlForWebsitePagePreviewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPageContentCellHtmlForWebsitePagePreviewQueryResult>;
        }));
    }

    protected processCmsV2Preview_GetPageContentCellHtmlForWebsitePagePreview(response: HttpResponseBase): Observable<GetPageContentCellHtmlForWebsitePagePreviewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPageContentCellHtmlForWebsitePagePreviewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPageContentCellHtmlForWebsitePagePreviewQueryResult>(null as any);
    }

    cmsV2Preview_GetPageContentCellHtmlForComponentPreview(query: GetPageContentCellHtmlForComponentPreviewQuery): Observable<GetPageContentCellHtmlForComponentPreviewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Preview/GetPageContentCellHtmlForComponentPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Preview_GetPageContentCellHtmlForComponentPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Preview_GetPageContentCellHtmlForComponentPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPageContentCellHtmlForComponentPreviewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPageContentCellHtmlForComponentPreviewQueryResult>;
        }));
    }

    protected processCmsV2Preview_GetPageContentCellHtmlForComponentPreview(response: HttpResponseBase): Observable<GetPageContentCellHtmlForComponentPreviewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPageContentCellHtmlForComponentPreviewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPageContentCellHtmlForComponentPreviewQueryResult>(null as any);
    }

    cmsV2Preview_GetComponentStylesheetForComponentPreview(query: GetComponentStylesheetForComponentPreviewQuery): Observable<GetComponentStylesheetForComponentPreviewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Preview/GetComponentStylesheetForComponentPreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Preview_GetComponentStylesheetForComponentPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Preview_GetComponentStylesheetForComponentPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetComponentStylesheetForComponentPreviewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetComponentStylesheetForComponentPreviewQueryResult>;
        }));
    }

    protected processCmsV2Preview_GetComponentStylesheetForComponentPreview(response: HttpResponseBase): Observable<GetComponentStylesheetForComponentPreviewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetComponentStylesheetForComponentPreviewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetComponentStylesheetForComponentPreviewQueryResult>(null as any);
    }

    cmsV2FieldTypes_(query: GetFieldTypeDtosQuery): Observable<GetFieldTypeDtosQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/GetFieldTypeDtos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2FieldTypes_(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2FieldTypes_(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFieldTypeDtosQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFieldTypeDtosQueryResult>;
        }));
    }

    protected processCmsV2FieldTypes_(response: HttpResponseBase): Observable<GetFieldTypeDtosQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetFieldTypeDtosQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFieldTypeDtosQueryResult>(null as any);
    }

    cmsV2Design_SetWebsiteThemeStyleSheet(command: SetWebsiteThemeStylesheetTemplateCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Design/SetWebsiteThemeStyleSheet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Design_SetWebsiteThemeStyleSheet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Design_SetWebsiteThemeStyleSheet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCmsV2Design_SetWebsiteThemeStyleSheet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    cmsV2Design_SetWebsiteThemeName(command: SetWebsiteThemeNameCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Design/SetWebsiteThemeName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Design_SetWebsiteThemeName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Design_SetWebsiteThemeName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCmsV2Design_SetWebsiteThemeName(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    cmsV2Design_GetWebsiteTheme(query: GetWebsiteThemeQuery): Observable<GetWebsiteThemeQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Design/GetWebsiteTheme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Design_GetWebsiteTheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Design_GetWebsiteTheme(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetWebsiteThemeQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetWebsiteThemeQueryResult>;
        }));
    }

    protected processCmsV2Design_GetWebsiteTheme(response: HttpResponseBase): Observable<GetWebsiteThemeQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetWebsiteThemeQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetWebsiteThemeQueryResult>(null as any);
    }

    cmsV2Design_GetWebsitesWithThemes(query: GetWebsitesWithThemesQuery): Observable<GetWebsitesWithThemesQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Design/GetWebsitesWithThemes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Design_GetWebsitesWithThemes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Design_GetWebsitesWithThemes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetWebsitesWithThemesQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetWebsitesWithThemesQueryResult>;
        }));
    }

    protected processCmsV2Design_GetWebsitesWithThemes(response: HttpResponseBase): Observable<GetWebsitesWithThemesQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetWebsitesWithThemesQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetWebsitesWithThemesQueryResult>(null as any);
    }

    cmsV2Design_CreateWebsiteTheme(command: CreateWebsiteThemeCommand): Observable<CreateWebsiteThemeCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Design/CreateWebsiteTheme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Design_CreateWebsiteTheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Design_CreateWebsiteTheme(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateWebsiteThemeCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateWebsiteThemeCommandResponse>;
        }));
    }

    protected processCmsV2Design_CreateWebsiteTheme(response: HttpResponseBase): Observable<CreateWebsiteThemeCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateWebsiteThemeCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateWebsiteThemeCommandResponse>(null as any);
    }

    cmsV2Design_UpdatePublishedPageTemplateContent(command: UpdatePublishedPageTemplateContentCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Design/UpdatePublishedPageTemplateContent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Design_UpdatePublishedPageTemplateContent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Design_UpdatePublishedPageTemplateContent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCmsV2Design_UpdatePublishedPageTemplateContent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    cmsV2Design_SetPageTemplatePrimaryLanguage(command: SetPageTemplatePrimaryLanguageCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Design/SetPageTemplatePrimaryLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Design_SetPageTemplatePrimaryLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Design_SetPageTemplatePrimaryLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCmsV2Design_SetPageTemplatePrimaryLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    cmsV2Design_SetPageTemplateName(command: SetPageTemplateNameCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Design/SetPageTemplateName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Design_SetPageTemplateName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Design_SetPageTemplateName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCmsV2Design_SetPageTemplateName(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    cmsV2Design_RetractPublishedPageTemplate(command: RetractPublishedPageTemplateCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Design/RetractPublishedPageTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Design_RetractPublishedPageTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Design_RetractPublishedPageTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCmsV2Design_RetractPublishedPageTemplate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    cmsV2Design_RemovePageTemplateSecondaryLanguage(command: RemovePageTemplateSecondaryLanguageCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Design/RemovePageTemplateSecondaryLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Design_RemovePageTemplateSecondaryLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Design_RemovePageTemplateSecondaryLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCmsV2Design_RemovePageTemplateSecondaryLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    cmsV2Design_PublishDraftPageTemplate(command: PublishDraftPageTemplateCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Design/PublishDraftPageTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Design_PublishDraftPageTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Design_PublishDraftPageTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCmsV2Design_PublishDraftPageTemplate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    cmsV2Design_GetPageTemplates(query: GetPageTemplatesQuery): Observable<GetPageTemplatesQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Design/GetPageTemplates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Design_GetPageTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Design_GetPageTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPageTemplatesQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPageTemplatesQueryResult>;
        }));
    }

    protected processCmsV2Design_GetPageTemplates(response: HttpResponseBase): Observable<GetPageTemplatesQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPageTemplatesQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPageTemplatesQueryResult>(null as any);
    }

    cmsV2Design_GetPageTemplatesForNewWebsitePage(query: GetPageTemplatesForNewWebsitePageQuery): Observable<GetPageTemplatesForNewWebsitePageQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Design/GetPageTemplatesForNewWebsitePage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Design_GetPageTemplatesForNewWebsitePage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Design_GetPageTemplatesForNewWebsitePage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPageTemplatesForNewWebsitePageQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPageTemplatesForNewWebsitePageQueryResult>;
        }));
    }

    protected processCmsV2Design_GetPageTemplatesForNewWebsitePage(response: HttpResponseBase): Observable<GetPageTemplatesForNewWebsitePageQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPageTemplatesForNewWebsitePageQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPageTemplatesForNewWebsitePageQueryResult>(null as any);
    }

    cmsV2Design_GetPageTemplateName(query: GetPageTemplateNameQuery): Observable<GetPageTemplateNameQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Design/GetPageTemplateName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Design_GetPageTemplateName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Design_GetPageTemplateName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPageTemplateNameQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPageTemplateNameQueryResult>;
        }));
    }

    protected processCmsV2Design_GetPageTemplateName(response: HttpResponseBase): Observable<GetPageTemplateNameQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPageTemplateNameQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPageTemplateNameQueryResult>(null as any);
    }

    cmsV2Design_GetPageTemplateLocalesNotInUse(query: GetPageTemplateLocalesNotInUseQuery): Observable<GetPageTemplateLocalesNotInUseQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Design/GetPageTemplateLocalesNotInUse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Design_GetPageTemplateLocalesNotInUse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Design_GetPageTemplateLocalesNotInUse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPageTemplateLocalesNotInUseQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPageTemplateLocalesNotInUseQueryResult>;
        }));
    }

    protected processCmsV2Design_GetPageTemplateLocalesNotInUse(response: HttpResponseBase): Observable<GetPageTemplateLocalesNotInUseQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPageTemplateLocalesNotInUseQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPageTemplateLocalesNotInUseQueryResult>(null as any);
    }

    cmsV2Design_GetPageTemplateEditorView(query: GetPageTemplateEditorViewQuery): Observable<PageTemplateEditorView> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Design/GetPageTemplateEditorView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Design_GetPageTemplateEditorView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Design_GetPageTemplateEditorView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PageTemplateEditorView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PageTemplateEditorView>;
        }));
    }

    protected processCmsV2Design_GetPageTemplateEditorView(response: HttpResponseBase): Observable<PageTemplateEditorView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PageTemplateEditorView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PageTemplateEditorView>(null as any);
    }

    cmsV2Design_GetPageTemplateContentVersionHistory(query: GetPageTemplateContentVersionHistoryQuery): Observable<GetPageTemplateContentVersionHistoryQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Design/GetPageTemplateContentVersionHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Design_GetPageTemplateContentVersionHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Design_GetPageTemplateContentVersionHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPageTemplateContentVersionHistoryQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPageTemplateContentVersionHistoryQueryResult>;
        }));
    }

    protected processCmsV2Design_GetPageTemplateContentVersionHistory(response: HttpResponseBase): Observable<GetPageTemplateContentVersionHistoryQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPageTemplateContentVersionHistoryQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPageTemplateContentVersionHistoryQueryResult>(null as any);
    }

    cmsV2Design_GetLatestPageTemplateContentVersion(query: GetLatestPageTemplateContentVersionQuery): Observable<GetLatestPageTemplateContentVersionQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Design/GetLatestPageTemplateContentVersion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Design_GetLatestPageTemplateContentVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Design_GetLatestPageTemplateContentVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLatestPageTemplateContentVersionQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLatestPageTemplateContentVersionQueryResult>;
        }));
    }

    protected processCmsV2Design_GetLatestPageTemplateContentVersion(response: HttpResponseBase): Observable<GetLatestPageTemplateContentVersionQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLatestPageTemplateContentVersionQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLatestPageTemplateContentVersionQueryResult>(null as any);
    }

    cmsV2Design_CreatePageTemplate(command: CreatePageTemplateCommand): Observable<CreatePageTemplateCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Design/CreatePageTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Design_CreatePageTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Design_CreatePageTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatePageTemplateCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatePageTemplateCommandResponse>;
        }));
    }

    protected processCmsV2Design_CreatePageTemplate(response: HttpResponseBase): Observable<CreatePageTemplateCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatePageTemplateCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreatePageTemplateCommandResponse>(null as any);
    }

    cmsV2Design_CreatePageTemplateContentVersion(command: CreatePageTemplateContentVersionCommand): Observable<CreatePageTemplateContentVersionCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Design/CreatePageTemplateContentVersion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Design_CreatePageTemplateContentVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Design_CreatePageTemplateContentVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatePageTemplateContentVersionCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatePageTemplateContentVersionCommandResponse>;
        }));
    }

    protected processCmsV2Design_CreatePageTemplateContentVersion(response: HttpResponseBase): Observable<CreatePageTemplateContentVersionCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatePageTemplateContentVersionCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreatePageTemplateContentVersionCommandResponse>(null as any);
    }

    cmsV2Design_AddPageTemplateSecondaryLanguage(command: AddPageTemplateSecondaryLanguageCommand): Observable<AddPageTemplateSecondaryLanguageCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Design/AddPageTemplateSecondaryLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Design_AddPageTemplateSecondaryLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Design_AddPageTemplateSecondaryLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddPageTemplateSecondaryLanguageCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddPageTemplateSecondaryLanguageCommandResponse>;
        }));
    }

    protected processCmsV2Design_AddPageTemplateSecondaryLanguage(response: HttpResponseBase): Observable<AddPageTemplateSecondaryLanguageCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddPageTemplateSecondaryLanguageCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddPageTemplateSecondaryLanguageCommandResponse>(null as any);
    }

    cmsV2Design_UpdatePublishedPageContentComponentSourceCode(command: UpdatePublishedPageContentComponentSourceCodeCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Design/UpdatePublishedPageContentComponentSourceCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Design_UpdatePublishedPageContentComponentSourceCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Design_UpdatePublishedPageContentComponentSourceCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCmsV2Design_UpdatePublishedPageContentComponentSourceCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    cmsV2Design_SetPageContentComponentName(command: SetPageContentComponentNameCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Design/SetPageContentComponentName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Design_SetPageContentComponentName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Design_SetPageContentComponentName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCmsV2Design_SetPageContentComponentName(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    cmsV2Design_PublishDraftPageContentComponent(command: PublishDraftPageContentComponentCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Design/PublishDraftPageContentComponent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Design_PublishDraftPageContentComponent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Design_PublishDraftPageContentComponent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCmsV2Design_PublishDraftPageContentComponent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    cmsV2Design_GetStandardPageContentComponentsForPageContent(query: GetStandardPageContentComponentsForPageContentQuery): Observable<GetStandardPageContentComponentsForPageContentQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Design/GetStandardPageContentComponentsForPageContent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Design_GetStandardPageContentComponentsForPageContent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Design_GetStandardPageContentComponentsForPageContent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetStandardPageContentComponentsForPageContentQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetStandardPageContentComponentsForPageContentQueryResult>;
        }));
    }

    protected processCmsV2Design_GetStandardPageContentComponentsForPageContent(response: HttpResponseBase): Observable<GetStandardPageContentComponentsForPageContentQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetStandardPageContentComponentsForPageContentQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetStandardPageContentComponentsForPageContentQueryResult>(null as any);
    }

    cmsV2Design_GetPageContentComponents(query: GetPageContentComponentsQuery): Observable<GetPageContentComponentsQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Design/GetPageContentComponents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Design_GetPageContentComponents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Design_GetPageContentComponents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPageContentComponentsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPageContentComponentsQueryResult>;
        }));
    }

    protected processCmsV2Design_GetPageContentComponents(response: HttpResponseBase): Observable<GetPageContentComponentsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPageContentComponentsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPageContentComponentsQueryResult>(null as any);
    }

    cmsV2Design_GetPageContentComponentsForPageContent(query: GetPageContentComponentsForPageContentQuery): Observable<GetPageContentComponentsForPageContentQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Design/GetPageContentComponentsForPageContent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Design_GetPageContentComponentsForPageContent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Design_GetPageContentComponentsForPageContent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPageContentComponentsForPageContentQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPageContentComponentsForPageContentQueryResult>;
        }));
    }

    protected processCmsV2Design_GetPageContentComponentsForPageContent(response: HttpResponseBase): Observable<GetPageContentComponentsForPageContentQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPageContentComponentsForPageContentQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPageContentComponentsForPageContentQueryResult>(null as any);
    }

    cmsV2Design_GetPageContentComponentEditorView(query: GetPageContentComponentEditorViewQuery): Observable<PageContentComponentEditorView> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Design/GetPageContentComponentEditorView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Design_GetPageContentComponentEditorView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Design_GetPageContentComponentEditorView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PageContentComponentEditorView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PageContentComponentEditorView>;
        }));
    }

    protected processCmsV2Design_GetPageContentComponentEditorView(response: HttpResponseBase): Observable<PageContentComponentEditorView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PageContentComponentEditorView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PageContentComponentEditorView>(null as any);
    }

    cmsV2Design_GetLatestPageContentComponentSourceCodeVersion(query: GetLatestPageContentComponentSourceCodeVersionQuery): Observable<GetLatestPageContentComponentSourceCodeVersionQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Design/GetLatestPageContentComponentSourceCodeVersion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Design_GetLatestPageContentComponentSourceCodeVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Design_GetLatestPageContentComponentSourceCodeVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLatestPageContentComponentSourceCodeVersionQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLatestPageContentComponentSourceCodeVersionQueryResult>;
        }));
    }

    protected processCmsV2Design_GetLatestPageContentComponentSourceCodeVersion(response: HttpResponseBase): Observable<GetLatestPageContentComponentSourceCodeVersionQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLatestPageContentComponentSourceCodeVersionQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLatestPageContentComponentSourceCodeVersionQueryResult>(null as any);
    }

    cmsV2Design_CreatePageContentComponent(command: CreatePageContentComponentCommand): Observable<CreatePageContentComponentCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Design/CreatePageContentComponent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Design_CreatePageContentComponent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Design_CreatePageContentComponent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatePageContentComponentCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatePageContentComponentCommandResponse>;
        }));
    }

    protected processCmsV2Design_CreatePageContentComponent(response: HttpResponseBase): Observable<CreatePageContentComponentCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatePageContentComponentCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreatePageContentComponentCommandResponse>(null as any);
    }

    cmsV2Design_CreatePageContentComponentSourceCodeVersion(command: CreatePageContentComponentSourceCodeVersionCommand): Observable<CreatePageContentComponentSourceCodeVersionCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Design/CreatePageContentComponentSourceCodeVersion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Design_CreatePageContentComponentSourceCodeVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Design_CreatePageContentComponentSourceCodeVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatePageContentComponentSourceCodeVersionCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatePageContentComponentSourceCodeVersionCommandResponse>;
        }));
    }

    protected processCmsV2Design_CreatePageContentComponentSourceCodeVersion(response: HttpResponseBase): Observable<CreatePageContentComponentSourceCodeVersionCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatePageContentComponentSourceCodeVersionCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreatePageContentComponentSourceCodeVersionCommandResponse>(null as any);
    }

    cmsV2Content_SetWebsitePageTitle(command: SetWebsitePageTitleCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Content/SetWebsitePageTitle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Content_SetWebsitePageTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Content_SetWebsitePageTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCmsV2Content_SetWebsitePageTitle(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    cmsV2Content_SetWebsitePageContentSlug(command: SetWebsitePageContentSlugCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Content/SetWebsitePageContentSlug";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Content_SetWebsitePageContentSlug(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Content_SetWebsitePageContentSlug(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCmsV2Content_SetWebsitePageContentSlug(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    cmsV2Content_RetractPublishedWebsitePage(command: RetractPublishedWebsitePageCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Content/RetractPublishedWebsitePage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Content_RetractPublishedWebsitePage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Content_RetractPublishedWebsitePage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCmsV2Content_RetractPublishedWebsitePage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    cmsV2Content_PublishDraftWebsitePage(command: PublishDraftWebsitePageCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Content/PublishDraftWebsitePage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Content_PublishDraftWebsitePage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Content_PublishDraftWebsitePage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCmsV2Content_PublishDraftWebsitePage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    cmsV2Content_IsWebsitePageContentSlugUnique(query: IsWebsitePageContentSlugUniqueQuery): Observable<IsWebsitePageContentSlugUniqueQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Content/IsWebsitePageContentSlugUnique";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Content_IsWebsitePageContentSlugUnique(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Content_IsWebsitePageContentSlugUnique(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsWebsitePageContentSlugUniqueQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsWebsitePageContentSlugUniqueQueryResult>;
        }));
    }

    protected processCmsV2Content_IsWebsitePageContentSlugUnique(response: HttpResponseBase): Observable<IsWebsitePageContentSlugUniqueQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IsWebsitePageContentSlugUniqueQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IsWebsitePageContentSlugUniqueQueryResult>(null as any);
    }

    cmsV2Content_GetWebsitePage(query: GetWebsitePageQuery): Observable<GetWebsitePageQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Content/GetWebsitePage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Content_GetWebsitePage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Content_GetWebsitePage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetWebsitePageQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetWebsitePageQueryResult>;
        }));
    }

    protected processCmsV2Content_GetWebsitePage(response: HttpResponseBase): Observable<GetWebsitePageQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetWebsitePageQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetWebsitePageQueryResult>(null as any);
    }

    cmsV2Content_GetWebsitePages(query: GetWebsitePagesQuery): Observable<GetWebsitePagesQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Content/GetWebsitePages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Content_GetWebsitePages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Content_GetWebsitePages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetWebsitePagesQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetWebsitePagesQueryResult>;
        }));
    }

    protected processCmsV2Content_GetWebsitePages(response: HttpResponseBase): Observable<GetWebsitePagesQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetWebsitePagesQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetWebsitePagesQueryResult>(null as any);
    }

    cmsV2Content_GetWebsitePageEditorView(query: GetWebsitePageEditorViewQuery): Observable<WebsitePageEditorView> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Content/GetWebsitePageEditorView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Content_GetWebsitePageEditorView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Content_GetWebsitePageEditorView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WebsitePageEditorView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebsitePageEditorView>;
        }));
    }

    protected processCmsV2Content_GetWebsitePageEditorView(response: HttpResponseBase): Observable<WebsitePageEditorView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WebsitePageEditorView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebsitePageEditorView>(null as any);
    }

    cmsV2Content_GetWebsitePageContentVersionHistory(query: GetWebsitePageContentVersionHistoryQuery): Observable<GetWebsitePageContentVersionHistoryQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Content/GetWebsitePageContentVersionHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Content_GetWebsitePageContentVersionHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Content_GetWebsitePageContentVersionHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetWebsitePageContentVersionHistoryQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetWebsitePageContentVersionHistoryQueryResult>;
        }));
    }

    protected processCmsV2Content_GetWebsitePageContentVersionHistory(response: HttpResponseBase): Observable<GetWebsitePageContentVersionHistoryQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetWebsitePageContentVersionHistoryQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetWebsitePageContentVersionHistoryQueryResult>(null as any);
    }

    cmsV2Content_GetLatestWebsitePageContentVersion(query: GetLatestWebsitePageContentVersionQuery): Observable<GetLatestWebsitePageContentVersionQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Content/GetLatestWebsitePageContentVersion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Content_GetLatestWebsitePageContentVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Content_GetLatestWebsitePageContentVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLatestWebsitePageContentVersionQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLatestWebsitePageContentVersionQueryResult>;
        }));
    }

    protected processCmsV2Content_GetLatestWebsitePageContentVersion(response: HttpResponseBase): Observable<GetLatestWebsitePageContentVersionQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetLatestWebsitePageContentVersionQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetLatestWebsitePageContentVersionQueryResult>(null as any);
    }

    cmsV2Content_CreateWebsitePage(command: CreateWebsitePageCommand): Observable<CreateWebsitePageCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Content/CreateWebsitePage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Content_CreateWebsitePage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Content_CreateWebsitePage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateWebsitePageCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateWebsitePageCommandResponse>;
        }));
    }

    protected processCmsV2Content_CreateWebsitePage(response: HttpResponseBase): Observable<CreateWebsitePageCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateWebsitePageCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateWebsitePageCommandResponse>(null as any);
    }

    cmsV2Content_CreateWebsitePageContentVersion(command: CreateWebsitePageContentVersionCommand): Observable<CreateWebsitePageContentVersionCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/CmsV2/Content/CreateWebsitePageContentVersion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsV2Content_CreateWebsitePageContentVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsV2Content_CreateWebsitePageContentVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateWebsitePageContentVersionCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateWebsitePageContentVersionCommandResponse>;
        }));
    }

    protected processCmsV2Content_CreateWebsitePageContentVersion(response: HttpResponseBase): Observable<CreateWebsitePageContentVersionCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateWebsitePageContentVersionCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateWebsitePageContentVersionCommandResponse>(null as any);
    }

    catalogs_SetProgramVariantStepWeekConfig(command: SetProgramVariantStepWeekConfigCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Catalogs/SetProgramVariantStepWeekConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCatalogs_SetProgramVariantStepWeekConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogs_SetProgramVariantStepWeekConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCatalogs_SetProgramVariantStepWeekConfig(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    catalogs_SetProgramVariantStepDayConfig(command: SetProgramVariantStepDayConfigCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Catalogs/SetProgramVariantStepDayConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCatalogs_SetProgramVariantStepDayConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogs_SetProgramVariantStepDayConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCatalogs_SetProgramVariantStepDayConfig(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    catalogs_SetProgramVariantStepDayConfigs(command: SetProgramVariantStepDayConfigsCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Catalogs/SetProgramVariantStepDayConfigs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCatalogs_SetProgramVariantStepDayConfigs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogs_SetProgramVariantStepDayConfigs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCatalogs_SetProgramVariantStepDayConfigs(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    catalogs_SetProgramStepHasDynamicDuration(command: SetProgramStepHasDynamicDurationCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Catalogs/SetProgramStepHasDynamicDuration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCatalogs_SetProgramStepHasDynamicDuration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogs_SetProgramStepHasDynamicDuration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCatalogs_SetProgramStepHasDynamicDuration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    catalogs_SetProgramStepCanChangePosition(command: SetProgramStepCanChangePositionCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Catalogs/SetProgramStepCanChangePosition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCatalogs_SetProgramStepCanChangePosition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogs_SetProgramStepCanChangePosition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCatalogs_SetProgramStepCanChangePosition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    catalogs_SetProgramPeriodOfferingVariant(command: SetProgramPeriodOfferingVariantCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Catalogs/SetProgramPeriodOfferingVariant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCatalogs_SetProgramPeriodOfferingVariant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogs_SetProgramPeriodOfferingVariant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCatalogs_SetProgramPeriodOfferingVariant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    catalogs_SetProgramOfferingVariantName(command: SetProgramOfferingVariantNameCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Catalogs/SetProgramOfferingVariantName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCatalogs_SetProgramOfferingVariantName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogs_SetProgramOfferingVariantName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCatalogs_SetProgramOfferingVariantName(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    catalogs_SetDefaultProgramOfferingVariant(command: SetDefaultProgramOfferingVariantCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Catalogs/SetDefaultProgramOfferingVariant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCatalogs_SetDefaultProgramOfferingVariant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogs_SetDefaultProgramOfferingVariant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCatalogs_SetDefaultProgramOfferingVariant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    catalogs_ReorderProgramSteps(command: ReorderProgramStepsCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Catalogs/ReorderProgramSteps";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCatalogs_ReorderProgramSteps(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogs_ReorderProgramSteps(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCatalogs_ReorderProgramSteps(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    catalogs_RemoveProgramStep(command: RemoveProgramStepCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Catalogs/RemoveProgramStep";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCatalogs_RemoveProgramStep(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogs_RemoveProgramStep(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCatalogs_RemoveProgramStep(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    catalogs_RemoveProgramOfferingVariant(command: RemoveProgramOfferingVariantCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Catalogs/RemoveProgramOfferingVariant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCatalogs_RemoveProgramOfferingVariant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogs_RemoveProgramOfferingVariant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCatalogs_RemoveProgramOfferingVariant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    catalogs_MigrateLocationProgramsToOfferingVariants(command: MigrateLocationProgramsToOfferingVariantsCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Catalogs/MigrateLocationProgramsToOfferingVariants";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCatalogs_MigrateLocationProgramsToOfferingVariants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogs_MigrateLocationProgramsToOfferingVariants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCatalogs_MigrateLocationProgramsToOfferingVariants(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    catalogs_GetProgramById(query: GetProgramByIdQuery): Observable<GetProgramByIdQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Catalogs/GetProgramById";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCatalogs_GetProgramById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogs_GetProgramById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProgramByIdQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProgramByIdQueryResult>;
        }));
    }

    protected processCatalogs_GetProgramById(response: HttpResponseBase): Observable<GetProgramByIdQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProgramByIdQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProgramByIdQueryResult>(null as any);
    }

    catalogs_GetActivePrograms(): Observable<GetActiveProgramsQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Catalogs/GetActivePrograms";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCatalogs_GetActivePrograms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogs_GetActivePrograms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetActiveProgramsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetActiveProgramsQueryResult>;
        }));
    }

    protected processCatalogs_GetActivePrograms(response: HttpResponseBase): Observable<GetActiveProgramsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetActiveProgramsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetActiveProgramsQueryResult>(null as any);
    }

    catalogs_CopyProgramVariantStepDayConfigToOtherDays(command: CopyProgramVariantStepDayConfigToOtherDaysCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Catalogs/CopyProgramVariantStepDayConfigToOtherDays";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCatalogs_CopyProgramVariantStepDayConfigToOtherDays(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogs_CopyProgramVariantStepDayConfigToOtherDays(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCatalogs_CopyProgramVariantStepDayConfigToOtherDays(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    catalogs_AddProgramStep(command: AddProgramStepCommand): Observable<AddProgramStepCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Catalogs/AddProgramStep";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCatalogs_AddProgramStep(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogs_AddProgramStep(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddProgramStepCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddProgramStepCommandResponse>;
        }));
    }

    protected processCatalogs_AddProgramStep(response: HttpResponseBase): Observable<AddProgramStepCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddProgramStepCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddProgramStepCommandResponse>(null as any);
    }

    catalogs_AddProgramOfferingVariant(command: AddProgramOfferingVariantCommand): Observable<AddProgramOfferingVariantCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Catalogs/AddProgramOfferingVariant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCatalogs_AddProgramOfferingVariant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogs_AddProgramOfferingVariant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddProgramOfferingVariantCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddProgramOfferingVariantCommandResponse>;
        }));
    }

    protected processCatalogs_AddProgramOfferingVariant(response: HttpResponseBase): Observable<AddProgramOfferingVariantCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddProgramOfferingVariantCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddProgramOfferingVariantCommandResponse>(null as any);
    }

    catalogs_CreateArticle(command: CreateArticleCommand): Observable<CreateArticleCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Catalogs/CreateArticle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCatalogs_CreateArticle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogs_CreateArticle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateArticleCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateArticleCommandResponse>;
        }));
    }

    protected processCatalogs_CreateArticle(response: HttpResponseBase): Observable<CreateArticleCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateArticleCommandRefusal;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateArticleCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateArticleCommandResponse>(null as any);
    }

    catalogs_SetActivitySuitableAgeGroups(command: SetActivitySuitableAgeGroupsCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Catalogs/SetActivitySuitableAgeGroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCatalogs_SetActivitySuitableAgeGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogs_SetActivitySuitableAgeGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCatalogs_SetActivitySuitableAgeGroups(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    catalogs_SetActivityName(command: SetActivityNameCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Catalogs/SetActivityName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCatalogs_SetActivityName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogs_SetActivityName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCatalogs_SetActivityName(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    catalogs_SetActivityDescription(command: SetActivityDescriptionCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Catalogs/SetActivityDescription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCatalogs_SetActivityDescription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogs_SetActivityDescription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCatalogs_SetActivityDescription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    catalogs_SetActivityCompatibleResourceTypes(command: SetActivityCompatibleResourceTypesCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Catalogs/SetActivityCompatibleResourceTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCatalogs_SetActivityCompatibleResourceTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogs_SetActivityCompatibleResourceTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCatalogs_SetActivityCompatibleResourceTypes(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    catalogs_SetActivityCapacityBasis(command: SetActivityCapacityBasisCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Catalogs/SetActivityCapacityBasis";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCatalogs_SetActivityCapacityBasis(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogs_SetActivityCapacityBasis(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCatalogs_SetActivityCapacityBasis(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    catalogs_RemoveActivityDuration(command: RemoveActivityDurationCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Catalogs/RemoveActivityDuration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCatalogs_RemoveActivityDuration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogs_RemoveActivityDuration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCatalogs_RemoveActivityDuration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    catalogs_GetActivities(query: GetActivitiesQuery): Observable<GetActivitiesQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Catalogs/GetActivities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCatalogs_GetActivities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogs_GetActivities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetActivitiesQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetActivitiesQueryResult>;
        }));
    }

    protected processCatalogs_GetActivities(response: HttpResponseBase): Observable<GetActivitiesQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetActivitiesQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetActivitiesQueryResult>(null as any);
    }

    catalogs_GetActiveActivities(): Observable<GetActiveActivitiesQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Catalogs/GetActiveActivities";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCatalogs_GetActiveActivities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogs_GetActiveActivities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetActiveActivitiesQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetActiveActivitiesQueryResult>;
        }));
    }

    protected processCatalogs_GetActiveActivities(response: HttpResponseBase): Observable<GetActiveActivitiesQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetActiveActivitiesQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetActiveActivitiesQueryResult>(null as any);
    }

    catalogs_CreateActivity(command: CreateActivityCommand): Observable<CreateActivityCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/Catalogs/CreateActivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCatalogs_CreateActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogs_CreateActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateActivityCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateActivityCommandResponse>;
        }));
    }

    protected processCatalogs_CreateActivity(response: HttpResponseBase): Observable<CreateActivityCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateActivityCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateActivityCommandResponse>(null as any);
    }

    catalogs_AddActivityDuration(command: AddActivityDurationCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/Catalogs/AddActivityDuration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCatalogs_AddActivityDuration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCatalogs_AddActivityDuration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCatalogs_AddActivityDuration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    bookings_GetPendingConfirmationEmailBookingsListPageView(query: GetPendingConfirmationEmailBookingsListPageViewQuery): Observable<GetPendingConfirmationEmailBookingsListPageViewQueryResult> {
        let url_ = this.baseUrl + "/Bookings/GetPendingConfirmationEmailBookingsListPageView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookings_GetPendingConfirmationEmailBookingsListPageView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookings_GetPendingConfirmationEmailBookingsListPageView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPendingConfirmationEmailBookingsListPageViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPendingConfirmationEmailBookingsListPageViewQueryResult>;
        }));
    }

    protected processBookings_GetPendingConfirmationEmailBookingsListPageView(response: HttpResponseBase): Observable<GetPendingConfirmationEmailBookingsListPageViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPendingConfirmationEmailBookingsListPageViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPendingConfirmationEmailBookingsListPageViewQueryResult>(null as any);
    }

    bookings_GetPendingApprovalBookingsListPageView(query: GetPendingApprovalBookingsListPageViewQuery): Observable<GetPendingApprovalBookingsListPageViewQueryResult> {
        let url_ = this.baseUrl + "/Bookings/GetPendingApprovalBookingsListPageView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookings_GetPendingApprovalBookingsListPageView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookings_GetPendingApprovalBookingsListPageView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPendingApprovalBookingsListPageViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPendingApprovalBookingsListPageViewQueryResult>;
        }));
    }

    protected processBookings_GetPendingApprovalBookingsListPageView(response: HttpResponseBase): Observable<GetPendingApprovalBookingsListPageViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPendingApprovalBookingsListPageViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPendingApprovalBookingsListPageViewQueryResult>(null as any);
    }

    bookingsV2Payments_RegisterBookingPaymentReceived(command: RegisterBookingPaymentReceivedCommand): Observable<RegisterBookingPaymentReceivedCommandResult> {
        let url_ = this.baseUrl + "/api/cqrs/BookingsV2/Payments/RegisterBookingPaymentReceived";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingsV2Payments_RegisterBookingPaymentReceived(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingsV2Payments_RegisterBookingPaymentReceived(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterBookingPaymentReceivedCommandResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterBookingPaymentReceivedCommandResult>;
        }));
    }

    protected processBookingsV2Payments_RegisterBookingPaymentReceived(response: HttpResponseBase): Observable<RegisterBookingPaymentReceivedCommandResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RegisterBookingPaymentReceivedCommandResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisterBookingPaymentReceivedCommandResult>(null as any);
    }

    bookingsV2Payments_GetBookingPaymentPanelView(query: GetBookingPaymentPanelViewQuery): Observable<GetBookingPaymentPanelViewQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/BookingsV2/Payments/GetBookingPaymentPanelView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingsV2Payments_GetBookingPaymentPanelView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingsV2Payments_GetBookingPaymentPanelView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBookingPaymentPanelViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBookingPaymentPanelViewQueryResult>;
        }));
    }

    protected processBookingsV2Payments_GetBookingPaymentPanelView(response: HttpResponseBase): Observable<GetBookingPaymentPanelViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetBookingPaymentPanelViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBookingPaymentPanelViewQueryResult>(null as any);
    }

    bookingsV2Payments_CreateBookingPaymentLink(command: CreateBookingPaymentLinkCommand): Observable<CreateBookingPaymentLinkCommandResult> {
        let url_ = this.baseUrl + "/api/cqrs/BookingsV2/Payments/CreateBookingPaymentLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingsV2Payments_CreateBookingPaymentLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingsV2Payments_CreateBookingPaymentLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateBookingPaymentLinkCommandResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateBookingPaymentLinkCommandResult>;
        }));
    }

    protected processBookingsV2Payments_CreateBookingPaymentLink(response: HttpResponseBase): Observable<CreateBookingPaymentLinkCommandResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateBookingPaymentLinkCommandResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateBookingPaymentLinkCommandResult>(null as any);
    }

    bookingsV2Catalogs_GetCatalogAvailabilityForDate(query: GetCatalogAvailabilityForDateQuery): Observable<GetCatalogAvailabilityForDateQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/BookingsV2/Catalogs/GetCatalogAvailabilityForDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingsV2Catalogs_GetCatalogAvailabilityForDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingsV2Catalogs_GetCatalogAvailabilityForDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCatalogAvailabilityForDateQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCatalogAvailabilityForDateQueryResult>;
        }));
    }

    protected processBookingsV2Catalogs_GetCatalogAvailabilityForDate(response: HttpResponseBase): Observable<GetCatalogAvailabilityForDateQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetCatalogAvailabilityForDateQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCatalogAvailabilityForDateQueryResult>(null as any);
    }

    bookingsV2Bookings_SubmitDraftBooking(command: SubmitDraftBookingCommand): Observable<SubmitDraftBookingCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/BookingsV2/Bookings/SubmitDraftBooking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingsV2Bookings_SubmitDraftBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingsV2Bookings_SubmitDraftBooking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubmitDraftBookingCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubmitDraftBookingCommandResponse>;
        }));
    }

    protected processBookingsV2Bookings_SubmitDraftBooking(response: HttpResponseBase): Observable<SubmitDraftBookingCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubmitDraftBookingCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 410) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubmitDraftBookingCommandResponse>(null as any);
    }

    bookingsV2Bookings_SetBookingReference(command: SetBookingReferenceCommand): Observable<SetBookingReferenceCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/BookingsV2/Bookings/SetBookingReference";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingsV2Bookings_SetBookingReference(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingsV2Bookings_SetBookingReference(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SetBookingReferenceCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SetBookingReferenceCommandResponse>;
        }));
    }

    protected processBookingsV2Bookings_SetBookingReference(response: HttpResponseBase): Observable<SetBookingReferenceCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SetBookingReferenceCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 410) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SetBookingReferenceCommandResponse>(null as any);
    }

    bookingsV2Bookings_SetBookingQuestionAnswers(command: SetBookingQuestionAnswersCommand): Observable<SetBookingQuestionAnswersCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/BookingsV2/Bookings/SetBookingQuestionAnswers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingsV2Bookings_SetBookingQuestionAnswers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingsV2Bookings_SetBookingQuestionAnswers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SetBookingQuestionAnswersCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SetBookingQuestionAnswersCommandResponse>;
        }));
    }

    protected processBookingsV2Bookings_SetBookingQuestionAnswers(response: HttpResponseBase): Observable<SetBookingQuestionAnswersCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SetBookingQuestionAnswersCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 410) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SetBookingQuestionAnswersCommandResponse>(null as any);
    }

    bookingsV2Bookings_SetBookingIndividualCustomer(command: SetBookingIndividualCustomerCommand): Observable<SetBookingIndividualCustomerCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/BookingsV2/Bookings/SetBookingIndividualCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingsV2Bookings_SetBookingIndividualCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingsV2Bookings_SetBookingIndividualCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SetBookingIndividualCustomerCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SetBookingIndividualCustomerCommandResponse>;
        }));
    }

    protected processBookingsV2Bookings_SetBookingIndividualCustomer(response: HttpResponseBase): Observable<SetBookingIndividualCustomerCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SetBookingIndividualCustomerCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 410) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SetBookingIndividualCustomerCommandResponse>(null as any);
    }

    bookingsV2Bookings_SetBookingCustomerForCustomerAccount(command: SetBookingCustomerForCustomerAccountCommand): Observable<SetBookingCustomerForCustomerAccountCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/BookingsV2/Bookings/SetBookingCustomerForCustomerAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingsV2Bookings_SetBookingCustomerForCustomerAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingsV2Bookings_SetBookingCustomerForCustomerAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SetBookingCustomerForCustomerAccountCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SetBookingCustomerForCustomerAccountCommandResponse>;
        }));
    }

    protected processBookingsV2Bookings_SetBookingCustomerForCustomerAccount(response: HttpResponseBase): Observable<SetBookingCustomerForCustomerAccountCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SetBookingCustomerForCustomerAccountCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 410) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SetBookingCustomerForCustomerAccountCommandResponse>(null as any);
    }

    bookingsV2Bookings_SetBookingCompanyCustomer(command: SetBookingCompanyCustomerCommand): Observable<SetBookingCompanyCustomerCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/BookingsV2/Bookings/SetBookingCompanyCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingsV2Bookings_SetBookingCompanyCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingsV2Bookings_SetBookingCompanyCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SetBookingCompanyCustomerCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SetBookingCompanyCustomerCommandResponse>;
        }));
    }

    protected processBookingsV2Bookings_SetBookingCompanyCustomer(response: HttpResponseBase): Observable<SetBookingCompanyCustomerCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SetBookingCompanyCustomerCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 410) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SetBookingCompanyCustomerCommandResponse>(null as any);
    }

    bookingsV2Bookings_SetBookingCommunicationLocale(command: SetBookingCommunicationLocaleCommand): Observable<SetBookingCommunicationLocaleCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/BookingsV2/Bookings/SetBookingCommunicationLocale";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingsV2Bookings_SetBookingCommunicationLocale(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingsV2Bookings_SetBookingCommunicationLocale(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SetBookingCommunicationLocaleCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SetBookingCommunicationLocaleCommandResponse>;
        }));
    }

    protected processBookingsV2Bookings_SetBookingCommunicationLocale(response: HttpResponseBase): Observable<SetBookingCommunicationLocaleCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SetBookingCommunicationLocaleCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 410) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SetBookingCommunicationLocaleCommandResponse>(null as any);
    }

    bookingsV2Bookings_SetBookingArticleExtras(command: SetBookingArticleExtrasCommand): Observable<SetBookingArticleExtrasCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/BookingsV2/Bookings/SetBookingArticleExtras";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingsV2Bookings_SetBookingArticleExtras(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingsV2Bookings_SetBookingArticleExtras(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SetBookingArticleExtrasCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SetBookingArticleExtrasCommandResponse>;
        }));
    }

    protected processBookingsV2Bookings_SetBookingArticleExtras(response: HttpResponseBase): Observable<SetBookingArticleExtrasCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SetBookingArticleExtrasCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 410) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SetBookingArticleExtrasCommandResponse>(null as any);
    }

    bookingsV2Bookings_SetAsideDraftBooking(command: SetAsideDraftBookingCommand): Observable<SetAsideDraftBookingCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/BookingsV2/Bookings/SetAsideDraftBooking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingsV2Bookings_SetAsideDraftBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingsV2Bookings_SetAsideDraftBooking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SetAsideDraftBookingCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SetAsideDraftBookingCommandResponse>;
        }));
    }

    protected processBookingsV2Bookings_SetAsideDraftBooking(response: HttpResponseBase): Observable<SetAsideDraftBookingCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SetAsideDraftBookingCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 410) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SetAsideDraftBookingCommandResponse>(null as any);
    }

    bookingsV2Bookings_ReverseBookingPromotionCodeRedemption(command: ReverseBookingPromotionCodeRedemptionCommand): Observable<ReverseBookingPromotionCodeRedemptionCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/BookingsV2/Bookings/ReverseBookingPromotionCodeRedemption";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingsV2Bookings_ReverseBookingPromotionCodeRedemption(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingsV2Bookings_ReverseBookingPromotionCodeRedemption(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReverseBookingPromotionCodeRedemptionCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReverseBookingPromotionCodeRedemptionCommandResponse>;
        }));
    }

    protected processBookingsV2Bookings_ReverseBookingPromotionCodeRedemption(response: HttpResponseBase): Observable<ReverseBookingPromotionCodeRedemptionCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReverseBookingPromotionCodeRedemptionCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 410) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReverseBookingPromotionCodeRedemptionCommandResponse>(null as any);
    }

    bookingsV2Bookings_ResumeDraftBooking(command: ResumeDraftBookingCommand): Observable<ResumeDraftBookingCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/BookingsV2/Bookings/ResumeDraftBooking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingsV2Bookings_ResumeDraftBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingsV2Bookings_ResumeDraftBooking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResumeDraftBookingCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResumeDraftBookingCommandResponse>;
        }));
    }

    protected processBookingsV2Bookings_ResumeDraftBooking(response: HttpResponseBase): Observable<ResumeDraftBookingCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResumeDraftBookingCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 410) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResumeDraftBookingCommandResponse>(null as any);
    }

    bookingsV2Bookings_RemoveBookingActivity(command: RemoveBookingActivityCommand): Observable<RemoveBookingActivityCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/BookingsV2/Bookings/RemoveBookingActivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingsV2Bookings_RemoveBookingActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingsV2Bookings_RemoveBookingActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RemoveBookingActivityCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RemoveBookingActivityCommandResponse>;
        }));
    }

    protected processBookingsV2Bookings_RemoveBookingActivity(response: HttpResponseBase): Observable<RemoveBookingActivityCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RemoveBookingActivityCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 410) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RemoveBookingActivityCommandResponse>(null as any);
    }

    bookingsV2Bookings_RedeemBookingPromotionCode(command: RedeemBookingPromotionCodeCommand): Observable<RedeemBookingPromotionCodeCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/BookingsV2/Bookings/RedeemBookingPromotionCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingsV2Bookings_RedeemBookingPromotionCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingsV2Bookings_RedeemBookingPromotionCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RedeemBookingPromotionCodeCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RedeemBookingPromotionCodeCommandResponse>;
        }));
    }

    protected processBookingsV2Bookings_RedeemBookingPromotionCode(response: HttpResponseBase): Observable<RedeemBookingPromotionCodeCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RedeemBookingPromotionCodeCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 410) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RedeemBookingPromotionCodeCommandResponse>(null as any);
    }

    bookingsV2Bookings_ListSubmittedBookingsForDate(query: ListSubmittedBookingsForDateQuery): Observable<ListSubmittedBookingsForDateQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/BookingsV2/Bookings/ListSubmittedBookingsForDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingsV2Bookings_ListSubmittedBookingsForDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingsV2Bookings_ListSubmittedBookingsForDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListSubmittedBookingsForDateQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListSubmittedBookingsForDateQueryResult>;
        }));
    }

    protected processBookingsV2Bookings_ListSubmittedBookingsForDate(response: HttpResponseBase): Observable<ListSubmittedBookingsForDateQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListSubmittedBookingsForDateQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListSubmittedBookingsForDateQueryResult>(null as any);
    }

    bookingsV2_ListRecentConfirmedBookings(query: ListRecentConfirmedBookingsQuery): Observable<ListRecentConfirmedBookingsQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/BookingsV2/ListRecentConfirmedBookings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingsV2_ListRecentConfirmedBookings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingsV2_ListRecentConfirmedBookings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListRecentConfirmedBookingsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListRecentConfirmedBookingsQueryResult>;
        }));
    }

    protected processBookingsV2_ListRecentConfirmedBookings(response: HttpResponseBase): Observable<ListRecentConfirmedBookingsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListRecentConfirmedBookingsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListRecentConfirmedBookingsQueryResult>(null as any);
    }

    bookingsV2Bookings_ListDraftBookings(query: ListDraftBookingsQuery): Observable<ListDraftBookingsQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/BookingsV2/Bookings/ListDraftBookings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingsV2Bookings_ListDraftBookings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingsV2Bookings_ListDraftBookings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListDraftBookingsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListDraftBookingsQueryResult>;
        }));
    }

    protected processBookingsV2Bookings_ListDraftBookings(response: HttpResponseBase): Observable<ListDraftBookingsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListDraftBookingsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListDraftBookingsQueryResult>(null as any);
    }

    bookingsV2Bookings_GetBookingForBookingSession(query: GetBookingForBookingSessionQuery): Observable<GetBookingForBookingSessionQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/BookingsV2/Bookings/GetBookingForBookingSession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingsV2Bookings_GetBookingForBookingSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingsV2Bookings_GetBookingForBookingSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBookingForBookingSessionQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBookingForBookingSessionQueryResult>;
        }));
    }

    protected processBookingsV2Bookings_GetBookingForBookingSession(response: HttpResponseBase): Observable<GetBookingForBookingSessionQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetBookingForBookingSessionQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBookingForBookingSessionQueryResult>(null as any);
    }

    bookingsV2Bookings_DiscardDraftBooking(command: DiscardDraftBookingCommand): Observable<DiscardDraftBookingCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/BookingsV2/Bookings/DiscardDraftBooking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingsV2Bookings_DiscardDraftBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingsV2Bookings_DiscardDraftBooking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiscardDraftBookingCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiscardDraftBookingCommandResponse>;
        }));
    }

    protected processBookingsV2Bookings_DiscardDraftBooking(response: HttpResponseBase): Observable<DiscardDraftBookingCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DiscardDraftBookingCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 410) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DiscardDraftBookingCommandResponse>(null as any);
    }

    bookingsV2Bookings_ConfirmDraftBooking(command: ConfirmDraftBookingCommand): Observable<ConfirmDraftBookingCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/BookingsV2/Bookings/ConfirmDraftBooking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingsV2Bookings_ConfirmDraftBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingsV2Bookings_ConfirmDraftBooking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfirmDraftBookingCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfirmDraftBookingCommandResponse>;
        }));
    }

    protected processBookingsV2Bookings_ConfirmDraftBooking(response: HttpResponseBase): Observable<ConfirmDraftBookingCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ConfirmDraftBookingCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 410) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ConfirmDraftBookingCommandResponse>(null as any);
    }

    bookingsV2Bookings_ClearBookingCustomer(command: ClearBookingCustomerCommand): Observable<ClearBookingCustomerCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/BookingsV2/Bookings/ClearBookingCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingsV2Bookings_ClearBookingCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingsV2Bookings_ClearBookingCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClearBookingCustomerCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClearBookingCustomerCommandResponse>;
        }));
    }

    protected processBookingsV2Bookings_ClearBookingCustomer(response: HttpResponseBase): Observable<ClearBookingCustomerCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClearBookingCustomerCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 410) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClearBookingCustomerCommandResponse>(null as any);
    }

    bookingsV2Bookings_CancelBooking(command: CancelBookingCommand): Observable<CancelBookingCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/BookingsV2/Bookings/CancelBooking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingsV2Bookings_CancelBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingsV2Bookings_CancelBooking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CancelBookingCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CancelBookingCommandResponse>;
        }));
    }

    protected processBookingsV2Bookings_CancelBooking(response: HttpResponseBase): Observable<CancelBookingCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CancelBookingCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CancelBookingCommandResponse>(null as any);
    }

    bookingsV2Bookings_AddBookingActivityFromOption(command: AddBookingActivityFromOptionCommand): Observable<AddBookingActivityFromOptionCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/BookingsV2/Bookings/AddBookingActivityFromOption";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingsV2Bookings_AddBookingActivityFromOption(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingsV2Bookings_AddBookingActivityFromOption(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddBookingActivityFromOptionCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddBookingActivityFromOptionCommandResponse>;
        }));
    }

    protected processBookingsV2Bookings_AddBookingActivityFromOption(response: HttpResponseBase): Observable<AddBookingActivityFromOptionCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddBookingActivityFromOptionCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 410) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddBookingActivityFromOptionCommandResponse>(null as any);
    }

    bookingsV2Bookings_AbortDraftBooking(command: AbortDraftBookingCommand): Observable<AbortDraftBookingCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/BookingsV2/Bookings/AbortDraftBooking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingsV2Bookings_AbortDraftBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingsV2Bookings_AbortDraftBooking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AbortDraftBookingCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AbortDraftBookingCommandResponse>;
        }));
    }

    protected processBookingsV2Bookings_AbortDraftBooking(response: HttpResponseBase): Observable<AbortDraftBookingCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AbortDraftBookingCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 410) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AbortDraftBookingCommandResponse>(null as any);
    }

    bookingsV2Sessions_StartDraftBookingSession(command: StartDraftBookingSessionCommand): Observable<StartDraftBookingSessionCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/BookingsV2/Sessions/StartDraftBookingSession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingsV2Sessions_StartDraftBookingSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingsV2Sessions_StartDraftBookingSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StartDraftBookingSessionCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StartDraftBookingSessionCommandResponse>;
        }));
    }

    protected processBookingsV2Sessions_StartDraftBookingSession(response: HttpResponseBase): Observable<StartDraftBookingSessionCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StartDraftBookingSessionCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StartDraftBookingSessionCommandResponse>(null as any);
    }

    bookingsV2Sessions_ExtendBookingSession(command: ExtendBookingSessionCommand): Observable<ExtendBookingSessionCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/BookingsV2/Sessions/ExtendBookingSession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingsV2Sessions_ExtendBookingSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingsV2Sessions_ExtendBookingSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExtendBookingSessionCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExtendBookingSessionCommandResponse>;
        }));
    }

    protected processBookingsV2Sessions_ExtendBookingSession(response: HttpResponseBase): Observable<ExtendBookingSessionCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExtendBookingSessionCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExtendBookingSessionCommandResponse>(null as any);
    }

    bookingsDev_CreateSampleBooking(command: CreateSampleBookingCommand): Observable<CreateSampleBookingResult> {
        let url_ = this.baseUrl + "/api/cqrs/BookingsDev/CreateSampleBooking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingsDev_CreateSampleBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingsDev_CreateSampleBooking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateSampleBookingResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateSampleBookingResult>;
        }));
    }

    protected processBookingsDev_CreateSampleBooking(response: HttpResponseBase): Observable<CreateSampleBookingResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateSampleBookingResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateSampleBookingResult>(null as any);
    }

    bookingRefundProposals_GetPrepareBookingRefundProposalsPageView(query: GetPrepareBookingRefundProposalsPageViewQuery): Observable<GetPrepareBookingRefundProposalsPageViewQueryResult> {
        let url_ = this.baseUrl + "/BookingRefundProposals/GetPrepareBookingRefundProposalsPageView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingRefundProposals_GetPrepareBookingRefundProposalsPageView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingRefundProposals_GetPrepareBookingRefundProposalsPageView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPrepareBookingRefundProposalsPageViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPrepareBookingRefundProposalsPageViewQueryResult>;
        }));
    }

    protected processBookingRefundProposals_GetPrepareBookingRefundProposalsPageView(response: HttpResponseBase): Observable<GetPrepareBookingRefundProposalsPageViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPrepareBookingRefundProposalsPageViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPrepareBookingRefundProposalsPageViewQueryResult>(null as any);
    }

    bookingRefundProposals_GetBookingRefundProposalPendingApprovalListPageView(query: GetBookingRefundProposalPendingApprovalListPageViewQuery): Observable<GetBookingRefundProposalPendingApprovalListPageViewQueryResult> {
        let url_ = this.baseUrl + "/BookingRefundProposals/GetBookingRefundProposalPendingApprovalListPageView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingRefundProposals_GetBookingRefundProposalPendingApprovalListPageView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingRefundProposals_GetBookingRefundProposalPendingApprovalListPageView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBookingRefundProposalPendingApprovalListPageViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBookingRefundProposalPendingApprovalListPageViewQueryResult>;
        }));
    }

    protected processBookingRefundProposals_GetBookingRefundProposalPendingApprovalListPageView(response: HttpResponseBase): Observable<GetBookingRefundProposalPendingApprovalListPageViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetBookingRefundProposalPendingApprovalListPageViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBookingRefundProposalPendingApprovalListPageViewQueryResult>(null as any);
    }

    bookingRefundProposals_GetBookingRefundProposalInProgressListPageView(query: GetBookingRefundProposalInProgressListPageViewQuery): Observable<GetBookingRefundProposalInProgressListPageViewQueryResult> {
        let url_ = this.baseUrl + "/BookingRefundProposals/GetBookingRefundProposalInProgressListPageView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingRefundProposals_GetBookingRefundProposalInProgressListPageView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingRefundProposals_GetBookingRefundProposalInProgressListPageView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBookingRefundProposalInProgressListPageViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBookingRefundProposalInProgressListPageViewQueryResult>;
        }));
    }

    protected processBookingRefundProposals_GetBookingRefundProposalInProgressListPageView(response: HttpResponseBase): Observable<GetBookingRefundProposalInProgressListPageViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetBookingRefundProposalInProgressListPageViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBookingRefundProposalInProgressListPageViewQueryResult>(null as any);
    }

    bookingRefundProposals_GetBookingRefundProposalHistoryListPageDataView(query: GetBookingRefundProposalHistoryListPageDataViewQuery): Observable<GetBookingRefundProposalHistoryListPageDataViewQueryResult> {
        let url_ = this.baseUrl + "/BookingRefundProposals/GetBookingRefundProposalHistoryListPageDataView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingRefundProposals_GetBookingRefundProposalHistoryListPageDataView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingRefundProposals_GetBookingRefundProposalHistoryListPageDataView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBookingRefundProposalHistoryListPageDataViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBookingRefundProposalHistoryListPageDataViewQueryResult>;
        }));
    }

    protected processBookingRefundProposals_GetBookingRefundProposalHistoryListPageDataView(response: HttpResponseBase): Observable<GetBookingRefundProposalHistoryListPageDataViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetBookingRefundProposalHistoryListPageDataViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBookingRefundProposalHistoryListPageDataViewQueryResult>(null as any);
    }

    bookingNotifications_SetBookingReminderLeadDays(command: SetBookingReminderLeadDaysCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/BookingNotifications/SetBookingReminderLeadDays";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingNotifications_SetBookingReminderLeadDays(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingNotifications_SetBookingReminderLeadDays(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBookingNotifications_SetBookingReminderLeadDays(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    bookingNotifications_SetBookingNotificationKindEnabled(command: SetBookingNotificationKindEnabledCommand): Observable<void> {
        let url_ = this.baseUrl + "/api/cqrs/BookingNotifications/SetBookingNotificationKindEnabled";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingNotifications_SetBookingNotificationKindEnabled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingNotifications_SetBookingNotificationKindEnabled(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBookingNotifications_SetBookingNotificationKindEnabled(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    bookingNotifications_GetBookingNotificationRules(query: GetBookingNotificationRulesQuery): Observable<GetBookingNotificationRulesQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/BookingNotifications/GetBookingNotificationRules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingNotifications_GetBookingNotificationRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingNotifications_GetBookingNotificationRules(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBookingNotificationRulesQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBookingNotificationRulesQueryResult>;
        }));
    }

    protected processBookingNotifications_GetBookingNotificationRules(response: HttpResponseBase): Observable<GetBookingNotificationRulesQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetBookingNotificationRulesQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBookingNotificationRulesQueryResult>(null as any);
    }

    bookingItem_GetPaymentDetailsDialogView(query: GetPaymentDetailsDialogViewQuery): Observable<GetPaymentDetailsDialogViewQueryResult> {
        let url_ = this.baseUrl + "/BookingItem/GetPaymentDetailsDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingItem_GetPaymentDetailsDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingItem_GetPaymentDetailsDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPaymentDetailsDialogViewQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPaymentDetailsDialogViewQueryResult>;
        }));
    }

    protected processBookingItem_GetPaymentDetailsDialogView(response: HttpResponseBase): Observable<GetPaymentDetailsDialogViewQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPaymentDetailsDialogViewQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPaymentDetailsDialogViewQueryResult>(null as any);
    }

    bookingDev_GetSelfServiceOptions(query: BookingDevQuery): Observable<GetSelfServiceOptionsQueryResult> {
        let url_ = this.baseUrl + "/BookingDev/GetSelfServiceOptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingDev_GetSelfServiceOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingDev_GetSelfServiceOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSelfServiceOptionsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSelfServiceOptionsQueryResult>;
        }));
    }

    protected processBookingDev_GetSelfServiceOptions(response: HttpResponseBase): Observable<GetSelfServiceOptionsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetSelfServiceOptionsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSelfServiceOptionsQueryResult>(null as any);
    }

    bookingDev_GetResourceBookings(query: BookingDevQuery): Observable<__GetBookingResourceBookingsQueryResult> {
        let url_ = this.baseUrl + "/BookingDev/GetResourceBookings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingDev_GetResourceBookings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingDev_GetResourceBookings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<__GetBookingResourceBookingsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<__GetBookingResourceBookingsQueryResult>;
        }));
    }

    protected processBookingDev_GetResourceBookings(response: HttpResponseBase): Observable<__GetBookingResourceBookingsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as __GetBookingResourceBookingsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<__GetBookingResourceBookingsQueryResult>(null as any);
    }

    bookingDev_GetRefunds(query: BookingDevQuery): Observable<GetRefundsQueryResult> {
        let url_ = this.baseUrl + "/BookingDev/GetRefunds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingDev_GetRefunds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingDev_GetRefunds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRefundsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRefundsQueryResult>;
        }));
    }

    protected processBookingDev_GetRefunds(response: HttpResponseBase): Observable<GetRefundsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetRefundsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRefundsQueryResult>(null as any);
    }

    bookingDev_GetPayments(query: BookingDevQuery): Observable<GetPaymentsQueryResult> {
        let url_ = this.baseUrl + "/BookingDev/GetPayments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingDev_GetPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingDev_GetPayments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPaymentsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPaymentsQueryResult>;
        }));
    }

    protected processBookingDev_GetPayments(response: HttpResponseBase): Observable<GetPaymentsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPaymentsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPaymentsQueryResult>(null as any);
    }

    bookingDev_GetPaymentLinkOptions(query: BookingDevQuery): Observable<GetPaymentLinkOptionsQueryResult> {
        let url_ = this.baseUrl + "/BookingDev/GetPaymentLinkOptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingDev_GetPaymentLinkOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingDev_GetPaymentLinkOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPaymentLinkOptionsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPaymentLinkOptionsQueryResult>;
        }));
    }

    protected processBookingDev_GetPaymentLinkOptions(response: HttpResponseBase): Observable<GetPaymentLinkOptionsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPaymentLinkOptionsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPaymentLinkOptionsQueryResult>(null as any);
    }

    bookingDev_GetBooking(query: BookingDevQuery): Observable<__BookingData> {
        let url_ = this.baseUrl + "/BookingDev/GetBooking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingDev_GetBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingDev_GetBooking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<__BookingData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<__BookingData>;
        }));
    }

    protected processBookingDev_GetBooking(response: HttpResponseBase): Observable<__BookingData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as __BookingData;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<__BookingData>(null as any);
    }

    bookingDev_GetBookingRefundProposals(query: BookingDevQuery): Observable<__GetBookingRefundProposalsForBookingQueryResult> {
        let url_ = this.baseUrl + "/BookingDev/GetBookingRefundProposals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingDev_GetBookingRefundProposals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingDev_GetBookingRefundProposals(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<__GetBookingRefundProposalsForBookingQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<__GetBookingRefundProposalsForBookingQueryResult>;
        }));
    }

    protected processBookingDev_GetBookingRefundProposals(response: HttpResponseBase): Observable<__GetBookingRefundProposalsForBookingQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as __GetBookingRefundProposalsForBookingQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<__GetBookingRefundProposalsForBookingQueryResult>(null as any);
    }

    bookingDev_GetBookingLedger(query: BookingDevQuery): Observable<__BookingLedgerData> {
        let url_ = this.baseUrl + "/BookingDev/GetBookingLedger";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingDev_GetBookingLedger(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingDev_GetBookingLedger(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<__BookingLedgerData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<__BookingLedgerData>;
        }));
    }

    protected processBookingDev_GetBookingLedger(response: HttpResponseBase): Observable<__BookingLedgerData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as __BookingLedgerData;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<__BookingLedgerData>(null as any);
    }

    bookability_ResolveActivityBookingOptionsForDate(query: ResolveActivityBookingOptionsForDateQuery): Observable<ResolveActivityBookingOptionsForDateQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Bookability/ResolveActivityBookingOptionsForDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookability_ResolveActivityBookingOptionsForDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookability_ResolveActivityBookingOptionsForDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResolveActivityBookingOptionsForDateQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResolveActivityBookingOptionsForDateQueryResult>;
        }));
    }

    protected processBookability_ResolveActivityBookingOptionsForDate(response: HttpResponseBase): Observable<ResolveActivityBookingOptionsForDateQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResolveActivityBookingOptionsForDateQueryResult;
            return _observableOf(result200);
            }));
        } else if (status === 410) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResolveActivityBookingOptionsForDateQueryResult>(null as any);
    }

    bookability_GetOfferedActivityIdsForDate(query: GetOfferedActivityIdsForDateQuery): Observable<GetOfferedActivityIdsForDateQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Bookability/GetOfferedActivityIdsForDate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookability_GetOfferedActivityIdsForDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookability_GetOfferedActivityIdsForDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOfferedActivityIdsForDateQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOfferedActivityIdsForDateQueryResult>;
        }));
    }

    protected processBookability_GetOfferedActivityIdsForDate(response: HttpResponseBase): Observable<GetOfferedActivityIdsForDateQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetOfferedActivityIdsForDateQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetOfferedActivityIdsForDateQueryResult>(null as any);
    }

    bookability_GetBookableArticleExtrasForSession(query: GetBookableArticleExtrasForSessionQuery): Observable<GetBookableArticleExtrasForSessionQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Bookability/GetBookableArticleExtrasForSession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookability_GetBookableArticleExtrasForSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookability_GetBookableArticleExtrasForSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBookableArticleExtrasForSessionQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBookableArticleExtrasForSessionQueryResult>;
        }));
    }

    protected processBookability_GetBookableArticleExtrasForSession(response: HttpResponseBase): Observable<GetBookableArticleExtrasForSessionQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetBookableArticleExtrasForSessionQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBookableArticleExtrasForSessionQueryResult>(null as any);
    }

    bookability_GetActivityBookingOptionDetails(query: GetActivityBookingOptionDetailsQuery): Observable<GetActivityBookingOptionDetailsQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Bookability/GetActivityBookingOptionDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookability_GetActivityBookingOptionDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookability_GetActivityBookingOptionDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetActivityBookingOptionDetailsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetActivityBookingOptionDetailsQueryResult>;
        }));
    }

    protected processBookability_GetActivityBookingOptionDetails(response: HttpResponseBase): Observable<GetActivityBookingOptionDetailsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetActivityBookingOptionDetailsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetActivityBookingOptionDetailsQueryResult>(null as any);
    }

    assortments_GetAssortmentActivities(query: GetAssortmentActivitiesQuery): Observable<GetAssortmentActivitiesQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Assortments/GetAssortmentActivities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processAssortments_GetAssortmentActivities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssortments_GetAssortmentActivities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAssortmentActivitiesQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAssortmentActivitiesQueryResult>;
        }));
    }

    protected processAssortments_GetAssortmentActivities(response: HttpResponseBase): Observable<GetAssortmentActivitiesQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetAssortmentActivitiesQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAssortmentActivitiesQueryResult>(null as any);
    }

    admins_LookupBookingInfo(query: LookupBookingInfoQuery): Observable<LookupBookingInfoQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Admins/LookupBookingInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processAdmins_LookupBookingInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdmins_LookupBookingInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupBookingInfoQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupBookingInfoQueryResult>;
        }));
    }

    protected processAdmins_LookupBookingInfo(response: HttpResponseBase): Observable<LookupBookingInfoQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookupBookingInfoQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LookupBookingInfoQueryResult>(null as any);
    }

    marketing_SetMarketingLocationConfig(command: SetMarketingLocationConfigCommand): Observable<ResultV2Dto> {
        let url_ = this.baseUrl + "/api/cqrs/marketing/SetMarketingLocationConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processMarketing_SetMarketingLocationConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarketing_SetMarketingLocationConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2Dto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2Dto>;
        }));
    }

    protected processMarketing_SetMarketingLocationConfig(response: HttpResponseBase): Observable<ResultV2Dto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2Dto>(null as any);
    }

    marketing_GetMarketingLocationConfigFormData(query: GetMarketingLocationConfigFormDataQuery): Observable<ResultV2DtoOfGetMarketingLocationConfigFormDataQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/marketing/GetMarketingLocationConfigFormData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processMarketing_GetMarketingLocationConfigFormData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarketing_GetMarketingLocationConfigFormData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2DtoOfGetMarketingLocationConfigFormDataQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2DtoOfGetMarketingLocationConfigFormDataQueryResult>;
        }));
    }

    protected processMarketing_GetMarketingLocationConfigFormData(response: HttpResponseBase): Observable<ResultV2DtoOfGetMarketingLocationConfigFormDataQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2DtoOfGetMarketingLocationConfigFormDataQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2DtoOfGetMarketingLocationConfigFormDataQueryResult>(null as any);
    }

    marketing_GetMarketingLocationIntegrations(query: GetMarketingLocationIntegrationsQuery): Observable<ResultV2DtoOfGetMarketingLocationIntegrationsQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/marketing/GetMarketingLocationIntegrations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processMarketing_GetMarketingLocationIntegrations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarketing_GetMarketingLocationIntegrations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2DtoOfGetMarketingLocationIntegrationsQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2DtoOfGetMarketingLocationIntegrationsQueryResult>;
        }));
    }

    protected processMarketing_GetMarketingLocationIntegrations(response: HttpResponseBase): Observable<ResultV2DtoOfGetMarketingLocationIntegrationsQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2DtoOfGetMarketingLocationIntegrationsQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2DtoOfGetMarketingLocationIntegrationsQueryResult>(null as any);
    }

    marketing_GetAvailableMarketingIntegrationsForLocation(query: GetAvailableMarketingIntegrationsForLocationQuery): Observable<ResultV2DtoOfGetAvailableMarketingIntegrationsForLocationQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/marketing/GetAvailableMarketingIntegrationsForLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processMarketing_GetAvailableMarketingIntegrationsForLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarketing_GetAvailableMarketingIntegrationsForLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2DtoOfGetAvailableMarketingIntegrationsForLocationQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2DtoOfGetAvailableMarketingIntegrationsForLocationQueryResult>;
        }));
    }

    protected processMarketing_GetAvailableMarketingIntegrationsForLocation(response: HttpResponseBase): Observable<ResultV2DtoOfGetAvailableMarketingIntegrationsForLocationQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2DtoOfGetAvailableMarketingIntegrationsForLocationQueryResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2DtoOfGetAvailableMarketingIntegrationsForLocationQueryResult>(null as any);
    }

    marketing_AddMarketingLocationIntegration(command: AddMarketingLocationIntegrationCommand): Observable<ResultV2Dto> {
        let url_ = this.baseUrl + "/api/cqrs/marketing/AddMarketingLocationIntegration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processMarketing_AddMarketingLocationIntegration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarketing_AddMarketingLocationIntegration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2Dto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2Dto>;
        }));
    }

    protected processMarketing_AddMarketingLocationIntegration(response: HttpResponseBase): Observable<ResultV2Dto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2Dto>(null as any);
    }

    shell_GetShellView(query: GetShellViewQuery): Observable<ShellView> {
        let url_ = this.baseUrl + "/api/Shell/GetShellView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processShell_GetShellView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShell_GetShellView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShellView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShellView>;
        }));
    }

    protected processShell_GetShellView(response: HttpResponseBase): Observable<ShellView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ShellView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShellView>(null as any);
    }

    shell_GetShellViewLocation(query: GetShellViewLocationQuery): Observable<ShellViewLocation> {
        let url_ = this.baseUrl + "/api/Shell/GetShellViewLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processShell_GetShellViewLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShell_GetShellViewLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShellViewLocation>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShellViewLocation>;
        }));
    }

    protected processShell_GetShellViewLocation(response: HttpResponseBase): Observable<ShellViewLocation> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ShellViewLocation;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShellViewLocation>(null as any);
    }

    scheduleBoard_GetBookingStartStopOverviewDialogView(query: GetBookingStartStopOverviewDialogViewQuery): Observable<BookingStartStopOverviewDialogView> {
        let url_ = this.baseUrl + "/ScheduleBoard/GetBookingStartStopOverviewDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processScheduleBoard_GetBookingStartStopOverviewDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleBoard_GetBookingStartStopOverviewDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BookingStartStopOverviewDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BookingStartStopOverviewDialogView>;
        }));
    }

    protected processScheduleBoard_GetBookingStartStopOverviewDialogView(response: HttpResponseBase): Observable<BookingStartStopOverviewDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BookingStartStopOverviewDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BookingStartStopOverviewDialogView>(null as any);
    }

    scheduleBoard_GetGridBlockItems(query: GetGridBlockItemsQuery): Observable<GetGridBlockItemsResult> {
        let url_ = this.baseUrl + "/ScheduleBoard/GetGridBlockItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processScheduleBoard_GetGridBlockItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleBoard_GetGridBlockItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGridBlockItemsResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGridBlockItemsResult>;
        }));
    }

    protected processScheduleBoard_GetGridBlockItems(response: HttpResponseBase): Observable<GetGridBlockItemsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetGridBlockItemsResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGridBlockItemsResult>(null as any);
    }

    scheduleBoard_GetGridDataView(query: GetGridDataViewQuery): Observable<ScheduleBoardGridDataView> {
        let url_ = this.baseUrl + "/ScheduleBoard/GetGridDataView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processScheduleBoard_GetGridDataView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleBoard_GetGridDataView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleBoardGridDataView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleBoardGridDataView>;
        }));
    }

    protected processScheduleBoard_GetGridDataView(response: HttpResponseBase): Observable<ScheduleBoardGridDataView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScheduleBoardGridDataView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ScheduleBoardGridDataView>(null as any);
    }

    scheduleBoard_GetGridsterItemsForBookingId(query: GetGridsterItemsForBookingIdQuery): Observable<GetGridsterItemsForBookingIdResult> {
        let url_ = this.baseUrl + "/ScheduleBoard/GetGridsterItemsForBookingId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processScheduleBoard_GetGridsterItemsForBookingId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleBoard_GetGridsterItemsForBookingId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGridsterItemsForBookingIdResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGridsterItemsForBookingIdResult>;
        }));
    }

    protected processScheduleBoard_GetGridsterItemsForBookingId(response: HttpResponseBase): Observable<GetGridsterItemsForBookingIdResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetGridsterItemsForBookingIdResult;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetGridsterItemsForBookingIdResult>(null as any);
    }

    scheduleBoard_GetGridView(query: GetGridViewQuery): Observable<ScheduleBoardGridView> {
        let url_ = this.baseUrl + "/ScheduleBoard/GetGridView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processScheduleBoard_GetGridView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleBoard_GetGridView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleBoardGridView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleBoardGridView>;
        }));
    }

    protected processScheduleBoard_GetGridView(response: HttpResponseBase): Observable<ScheduleBoardGridView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScheduleBoardGridView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ScheduleBoardGridView>(null as any);
    }

    scheduleBoard_GetScheduleBoardBlockGridEditDialogView(command: ScheduleBoardBlockGridsterItem): Observable<ScheduleBoardBlockGridEditDialogView> {
        let url_ = this.baseUrl + "/ScheduleBoard/GetScheduleBoardBlockGridEditDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processScheduleBoard_GetScheduleBoardBlockGridEditDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleBoard_GetScheduleBoardBlockGridEditDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduleBoardBlockGridEditDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduleBoardBlockGridEditDialogView>;
        }));
    }

    protected processScheduleBoard_GetScheduleBoardBlockGridEditDialogView(response: HttpResponseBase): Observable<ScheduleBoardBlockGridEditDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScheduleBoardBlockGridEditDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ScheduleBoardBlockGridEditDialogView>(null as any);
    }

    scheduleBoard_SetGridBlockItems(command: ScheduleBoardBlockGridRequest): Observable<Result> {
        let url_ = this.baseUrl + "/ScheduleBoard/SetGridBlockItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processScheduleBoard_SetGridBlockItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleBoard_SetGridBlockItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processScheduleBoard_SetGridBlockItems(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    scheduleBoard_SetGridItemsResourceBookings(command: ScheduleBoardGridItemResourceBookingChangeRequest): Observable<Result> {
        let url_ = this.baseUrl + "/ScheduleBoard/SetGridItemsResourceBookings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processScheduleBoard_SetGridItemsResourceBookings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleBoard_SetGridItemsResourceBookings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processScheduleBoard_SetGridItemsResourceBookings(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    cmsPage_GetAddDialogView(query: GetCmsPageAddDialogViewQuery): Observable<CmsPageAddDialogView> {
        let url_ = this.baseUrl + "/CmsPage/GetAddDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsPage_GetAddDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsPage_GetAddDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CmsPageAddDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CmsPageAddDialogView>;
        }));
    }

    protected processCmsPage_GetAddDialogView(response: HttpResponseBase): Observable<CmsPageAddDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CmsPageAddDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CmsPageAddDialogView>(null as any);
    }

    cmsPage_GetEditItemContentView(query: GetCmsPageEditItemContentViewQuery): Observable<CmsPageEditItemContentView> {
        let url_ = this.baseUrl + "/CmsPage/GetEditItemContentView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsPage_GetEditItemContentView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsPage_GetEditItemContentView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CmsPageEditItemContentView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CmsPageEditItemContentView>;
        }));
    }

    protected processCmsPage_GetEditItemContentView(response: HttpResponseBase): Observable<CmsPageEditItemContentView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CmsPageEditItemContentView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CmsPageEditItemContentView>(null as any);
    }

    cmsPage_GetEditItemView(query: GetCmsPageEditItemViewQuery): Observable<CmsPageEditItemView> {
        let url_ = this.baseUrl + "/CmsPage/GetEditItemView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsPage_GetEditItemView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsPage_GetEditItemView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CmsPageEditItemView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CmsPageEditItemView>;
        }));
    }

    protected processCmsPage_GetEditItemView(response: HttpResponseBase): Observable<CmsPageEditItemView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CmsPageEditItemView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CmsPageEditItemView>(null as any);
    }

    cmsPage_GetListView(query: GetCmsPageListViewQuery): Observable<CmsPageListView> {
        let url_ = this.baseUrl + "/CmsPage/GetListView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsPage_GetListView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsPage_GetListView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CmsPageListView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CmsPageListView>;
        }));
    }

    protected processCmsPage_GetListView(response: HttpResponseBase): Observable<CmsPageListView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CmsPageListView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CmsPageListView>(null as any);
    }

    cmsPage_GetPickerDialogView(query: GetCmsPagePickerDialogViewQuery): Observable<CmsPagePickerDialogView> {
        let url_ = this.baseUrl + "/CmsPage/GetPickerDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsPage_GetPickerDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsPage_GetPickerDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CmsPagePickerDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CmsPagePickerDialogView>;
        }));
    }

    protected processCmsPage_GetPickerDialogView(response: HttpResponseBase): Observable<CmsPagePickerDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CmsPagePickerDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CmsPagePickerDialogView>(null as any);
    }

    webClientSchema_GetCustomSchemaDefinitions(): Observable<CustomSchemaDefinition> {
        let url_ = this.baseUrl + "/api/WebClientSchema/GetCustomSchemaDefinitions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processWebClientSchema_GetCustomSchemaDefinitions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWebClientSchema_GetCustomSchemaDefinitions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomSchemaDefinition>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomSchemaDefinition>;
        }));
    }

    protected processWebClientSchema_GetCustomSchemaDefinitions(response: HttpResponseBase): Observable<CustomSchemaDefinition> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomSchemaDefinition;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomSchemaDefinition>(null as any);
    }

    webClientSchema_WebComponents(): Observable<WebComponentsRegister> {
        let url_ = this.baseUrl + "/api/WebClientSchema/WebComponents";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processWebClientSchema_WebComponents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWebClientSchema_WebComponents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WebComponentsRegister>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WebComponentsRegister>;
        }));
    }

    protected processWebClientSchema_WebComponents(response: HttpResponseBase): Observable<WebComponentsRegister> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WebComponentsRegister;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WebComponentsRegister>(null as any);
    }

    cacheAdmin_Set(cacheKey: string | null, value: string | null): Observable<ResultV2DtoOfString> {
        let url_ = this.baseUrl + "/api/CacheAdmin/Set?";
        if (cacheKey === undefined)
            throw new Error("The parameter 'cacheKey' must be defined.");
        else if(cacheKey !== null)
            url_ += "cacheKey=" + encodeURIComponent("" + cacheKey) + "&";
        if (value === undefined)
            throw new Error("The parameter 'value' must be defined.");
        else if(value !== null)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCacheAdmin_Set(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCacheAdmin_Set(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2DtoOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2DtoOfString>;
        }));
    }

    protected processCacheAdmin_Set(response: HttpResponseBase): Observable<ResultV2DtoOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2DtoOfString;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2DtoOfString>(null as any);
    }

    cacheAdmin_SetWithTags(cacheKey: string | null, value: string | null, tags: string[] | null): Observable<ResultV2DtoOfString> {
        let url_ = this.baseUrl + "/api/CacheAdmin/SetWithTags?";
        if (cacheKey === undefined)
            throw new Error("The parameter 'cacheKey' must be defined.");
        else if(cacheKey !== null)
            url_ += "cacheKey=" + encodeURIComponent("" + cacheKey) + "&";
        if (value === undefined)
            throw new Error("The parameter 'value' must be defined.");
        else if(value !== null)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        if (tags === undefined)
            throw new Error("The parameter 'tags' must be defined.");
        else if(tags !== null)
            tags && tags.forEach(item => { url_ += "tags=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCacheAdmin_SetWithTags(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCacheAdmin_SetWithTags(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2DtoOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2DtoOfString>;
        }));
    }

    protected processCacheAdmin_SetWithTags(response: HttpResponseBase): Observable<ResultV2DtoOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2DtoOfString;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2DtoOfString>(null as any);
    }

    cacheAdmin_Get(cacheKey: string | null): Observable<ResultV2DtoOfString> {
        let url_ = this.baseUrl + "/api/CacheAdmin/Get?";
        if (cacheKey === undefined)
            throw new Error("The parameter 'cacheKey' must be defined.");
        else if(cacheKey !== null)
            url_ += "cacheKey=" + encodeURIComponent("" + cacheKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCacheAdmin_Get(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCacheAdmin_Get(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2DtoOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2DtoOfString>;
        }));
    }

    protected processCacheAdmin_Get(response: HttpResponseBase): Observable<ResultV2DtoOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2DtoOfString;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2DtoOfString>(null as any);
    }

    cacheAdmin_InvalidateKeysByTag(tags: string[] | null): Observable<ResultV2Dto> {
        let url_ = this.baseUrl + "/api/CacheAdmin/InvalidateKeysByTag?";
        if (tags === undefined)
            throw new Error("The parameter 'tags' must be defined.");
        else if(tags !== null)
            tags && tags.forEach(item => { url_ += "tags=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCacheAdmin_InvalidateKeysByTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCacheAdmin_InvalidateKeysByTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2Dto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2Dto>;
        }));
    }

    protected processCacheAdmin_InvalidateKeysByTag(response: HttpResponseBase): Observable<ResultV2Dto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2Dto>(null as any);
    }

    cacheAdmin_FlushDatabase(password?: string | null | undefined): Observable<ResultV2Dto> {
        let url_ = this.baseUrl + "/api/CacheAdmin/FlushDatabase?";
        if (password !== undefined && password !== null)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCacheAdmin_FlushDatabase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCacheAdmin_FlushDatabase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2Dto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2Dto>;
        }));
    }

    protected processCacheAdmin_FlushDatabase(response: HttpResponseBase): Observable<ResultV2Dto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2Dto>(null as any);
    }

    testCQRS_PortalAppTest(helloWorldText: string): Observable<ResultV2DtoOfPortalAppTestQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/TestCQRS/PortalAppTest?";
        if (helloWorldText === undefined || helloWorldText === null)
            throw new Error("The parameter 'helloWorldText' must be defined and cannot be null.");
        else
            url_ += "HelloWorldText=" + encodeURIComponent("" + helloWorldText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processTestCQRS_PortalAppTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestCQRS_PortalAppTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2DtoOfPortalAppTestQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2DtoOfPortalAppTestQueryResult>;
        }));
    }

    protected processTestCQRS_PortalAppTest(response: HttpResponseBase): Observable<ResultV2DtoOfPortalAppTestQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2DtoOfPortalAppTestQueryResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2DtoOfPortalAppTestQueryResult>(null as any);
    }

    testCQRS_BackendTest(helloWorldText: string): Observable<ResultV2DtoOfBackendTestQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/TestCQRS/BackendTest?";
        if (helloWorldText === undefined || helloWorldText === null)
            throw new Error("The parameter 'helloWorldText' must be defined and cannot be null.");
        else
            url_ += "HelloWorldText=" + encodeURIComponent("" + helloWorldText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processTestCQRS_BackendTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestCQRS_BackendTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2DtoOfBackendTestQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2DtoOfBackendTestQueryResult>;
        }));
    }

    protected processTestCQRS_BackendTest(response: HttpResponseBase): Observable<ResultV2DtoOfBackendTestQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2DtoOfBackendTestQueryResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2DtoOfBackendTestQueryResult>(null as any);
    }

    resourceConfigResourceCategories_GetResourceCategories(query: GetResourceCategoriesQuery): Observable<ResultV2DtoOfGetResourceCategoriesQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/ResourceConfigResourceCategories/GetResourceCategories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processResourceConfigResourceCategories_GetResourceCategories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResourceConfigResourceCategories_GetResourceCategories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2DtoOfGetResourceCategoriesQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2DtoOfGetResourceCategoriesQueryResult>;
        }));
    }

    protected processResourceConfigResourceCategories_GetResourceCategories(response: HttpResponseBase): Observable<ResultV2DtoOfGetResourceCategoriesQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2DtoOfGetResourceCategoriesQueryResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2DtoOfGetResourceCategoriesQueryResult>(null as any);
    }

    resourceConfigResourceCategories_GetResourceCategoryFormData(query: GetResourceCategoryFormDataQuery): Observable<ResultV2DtoOfGetResourceCategoryFormDataQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/ResourceConfigResourceCategories/GetResourceCategoryFormData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processResourceConfigResourceCategories_GetResourceCategoryFormData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResourceConfigResourceCategories_GetResourceCategoryFormData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2DtoOfGetResourceCategoryFormDataQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2DtoOfGetResourceCategoryFormDataQueryResult>;
        }));
    }

    protected processResourceConfigResourceCategories_GetResourceCategoryFormData(response: HttpResponseBase): Observable<ResultV2DtoOfGetResourceCategoryFormDataQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2DtoOfGetResourceCategoryFormDataQueryResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2DtoOfGetResourceCategoryFormDataQueryResult>(null as any);
    }

    resourceConfigResourceCategories_GetNewResourceCategoryFormData(query: GetNewResourceCategoryFormDataQuery): Observable<ResultV2DtoOfGetResourceCategoryFormDataQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/ResourceConfigResourceCategories/GetNewResourceCategoryFormData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processResourceConfigResourceCategories_GetNewResourceCategoryFormData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResourceConfigResourceCategories_GetNewResourceCategoryFormData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2DtoOfGetResourceCategoryFormDataQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2DtoOfGetResourceCategoryFormDataQueryResult>;
        }));
    }

    protected processResourceConfigResourceCategories_GetNewResourceCategoryFormData(response: HttpResponseBase): Observable<ResultV2DtoOfGetResourceCategoryFormDataQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2DtoOfGetResourceCategoryFormDataQueryResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2DtoOfGetResourceCategoryFormDataQueryResult>(null as any);
    }

    resourceConfigResourceCategories_AddResourceCategory(command: AddResourceCategoryCommand): Observable<ResultV2Dto> {
        let url_ = this.baseUrl + "/api/cqrs/ResourceConfigResourceCategories/AddResourceCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processResourceConfigResourceCategories_AddResourceCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResourceConfigResourceCategories_AddResourceCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2Dto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2Dto>;
        }));
    }

    protected processResourceConfigResourceCategories_AddResourceCategory(response: HttpResponseBase): Observable<ResultV2Dto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2Dto>(null as any);
    }

    resourceConfigResourceCategories_UpdateResourceCategory(command: UpdateResourceCategoryCommand): Observable<ResultV2Dto> {
        let url_ = this.baseUrl + "/api/cqrs/ResourceConfigResourceCategories/UpdateResourceCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processResourceConfigResourceCategories_UpdateResourceCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResourceConfigResourceCategories_UpdateResourceCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2Dto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2Dto>;
        }));
    }

    protected processResourceConfigResourceCategories_UpdateResourceCategory(response: HttpResponseBase): Observable<ResultV2Dto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2Dto>(null as any);
    }

    resourceConfigResourceCategories_RemoveResourceCategory(command: RemoveResourceCategoryCommand): Observable<ResultV2Dto> {
        let url_ = this.baseUrl + "/api/cqrs/ResourceConfigResourceCategories/RemoveResourceCategory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processResourceConfigResourceCategories_RemoveResourceCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResourceConfigResourceCategories_RemoveResourceCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2Dto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2Dto>;
        }));
    }

    protected processResourceConfigResourceCategories_RemoveResourceCategory(response: HttpResponseBase): Observable<ResultV2Dto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2Dto>(null as any);
    }

    resourceConfigResourceTypes_GetResourceTypes(query: GetResourceTypesQuery): Observable<ResultV2DtoOfGetResourceTypesQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/ResourceConfigResourceTypes/GetResourceTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processResourceConfigResourceTypes_GetResourceTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResourceConfigResourceTypes_GetResourceTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2DtoOfGetResourceTypesQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2DtoOfGetResourceTypesQueryResult>;
        }));
    }

    protected processResourceConfigResourceTypes_GetResourceTypes(response: HttpResponseBase): Observable<ResultV2DtoOfGetResourceTypesQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2DtoOfGetResourceTypesQueryResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2DtoOfGetResourceTypesQueryResult>(null as any);
    }

    resourceConfigResourceTypes_GetResourceTypeFormData(query: GetResourceTypeFormDataQuery): Observable<ResultV2DtoOfGetResourceTypeFormDataQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/ResourceConfigResourceTypes/GetResourceTypeFormData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processResourceConfigResourceTypes_GetResourceTypeFormData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResourceConfigResourceTypes_GetResourceTypeFormData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2DtoOfGetResourceTypeFormDataQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2DtoOfGetResourceTypeFormDataQueryResult>;
        }));
    }

    protected processResourceConfigResourceTypes_GetResourceTypeFormData(response: HttpResponseBase): Observable<ResultV2DtoOfGetResourceTypeFormDataQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2DtoOfGetResourceTypeFormDataQueryResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2DtoOfGetResourceTypeFormDataQueryResult>(null as any);
    }

    resourceConfigResourceTypes_GetNewResourceTypeFormData(query: GetNewResourceTypeFormDataQuery): Observable<ResultV2DtoOfGetResourceTypeFormDataQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/ResourceConfigResourceTypes/GetNewResourceTypeFormData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processResourceConfigResourceTypes_GetNewResourceTypeFormData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResourceConfigResourceTypes_GetNewResourceTypeFormData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2DtoOfGetResourceTypeFormDataQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2DtoOfGetResourceTypeFormDataQueryResult>;
        }));
    }

    protected processResourceConfigResourceTypes_GetNewResourceTypeFormData(response: HttpResponseBase): Observable<ResultV2DtoOfGetResourceTypeFormDataQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2DtoOfGetResourceTypeFormDataQueryResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2DtoOfGetResourceTypeFormDataQueryResult>(null as any);
    }

    resourceConfigResourceTypes_AddResourceType(command: AddResourceTypeCommand): Observable<ResultV2Dto> {
        let url_ = this.baseUrl + "/api/cqrs/ResourceConfigResourceTypes/AddResourceType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processResourceConfigResourceTypes_AddResourceType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResourceConfigResourceTypes_AddResourceType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2Dto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2Dto>;
        }));
    }

    protected processResourceConfigResourceTypes_AddResourceType(response: HttpResponseBase): Observable<ResultV2Dto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2Dto>(null as any);
    }

    resourceConfigResourceTypes_UpdateResourceType(command: UpdateResourceTypeCommand): Observable<ResultV2Dto> {
        let url_ = this.baseUrl + "/api/cqrs/ResourceConfigResourceTypes/UpdateResourceType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processResourceConfigResourceTypes_UpdateResourceType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResourceConfigResourceTypes_UpdateResourceType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2Dto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2Dto>;
        }));
    }

    protected processResourceConfigResourceTypes_UpdateResourceType(response: HttpResponseBase): Observable<ResultV2Dto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2Dto>(null as any);
    }

    resourceConfigResourceTypes_RemoveResourceType(command: RemoveResourceTypeCommand): Observable<ResultV2Dto> {
        let url_ = this.baseUrl + "/api/cqrs/ResourceConfigResourceTypes/RemoveResourceType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processResourceConfigResourceTypes_RemoveResourceType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResourceConfigResourceTypes_RemoveResourceType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2Dto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2Dto>;
        }));
    }

    protected processResourceConfigResourceTypes_RemoveResourceType(response: HttpResponseBase): Observable<ResultV2Dto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2Dto>(null as any);
    }

    periodConfiguration_GetPeriodConfigurationWithPeriodInserted(query: GetPeriodConfigurationWithPeriodInsertedQuery): Observable<ResultV2DtoOfGetPeriodConfigurationWithPeriodInsertedQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/PeriodConfiguration/GetPeriodConfigurationWithPeriodInserted";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPeriodConfiguration_GetPeriodConfigurationWithPeriodInserted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPeriodConfiguration_GetPeriodConfigurationWithPeriodInserted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2DtoOfGetPeriodConfigurationWithPeriodInsertedQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2DtoOfGetPeriodConfigurationWithPeriodInsertedQueryResult>;
        }));
    }

    protected processPeriodConfiguration_GetPeriodConfigurationWithPeriodInserted(response: HttpResponseBase): Observable<ResultV2DtoOfGetPeriodConfigurationWithPeriodInsertedQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2DtoOfGetPeriodConfigurationWithPeriodInsertedQueryResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2DtoOfGetPeriodConfigurationWithPeriodInsertedQueryResult>(null as any);
    }

    periodConfiguration_GetPeriodConfigurationWithPeriodModified(query: GetPeriodConfigurationWithPeriodModifiedQuery): Observable<ResultV2DtoOfGetPeriodConfigurationWithPeriodModifiedQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/PeriodConfiguration/GetPeriodConfigurationWithPeriodModified";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPeriodConfiguration_GetPeriodConfigurationWithPeriodModified(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPeriodConfiguration_GetPeriodConfigurationWithPeriodModified(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2DtoOfGetPeriodConfigurationWithPeriodModifiedQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2DtoOfGetPeriodConfigurationWithPeriodModifiedQueryResult>;
        }));
    }

    protected processPeriodConfiguration_GetPeriodConfigurationWithPeriodModified(response: HttpResponseBase): Observable<ResultV2DtoOfGetPeriodConfigurationWithPeriodModifiedQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2DtoOfGetPeriodConfigurationWithPeriodModifiedQueryResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2DtoOfGetPeriodConfigurationWithPeriodModifiedQueryResult>(null as any);
    }

    periodConfiguration_GetPeriodConfigurationWithPeriodRemovedAndGapFilled(query: GetPeriodConfigurationWithPeriodRemovedAndGapFilledQuery): Observable<ResultV2DtoOfGetPeriodConfigurationWithPeriodRemovedAndGapFilledQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/PeriodConfiguration/GetPeriodConfigurationWithPeriodRemovedAndGapFilled";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPeriodConfiguration_GetPeriodConfigurationWithPeriodRemovedAndGapFilled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPeriodConfiguration_GetPeriodConfigurationWithPeriodRemovedAndGapFilled(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2DtoOfGetPeriodConfigurationWithPeriodRemovedAndGapFilledQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2DtoOfGetPeriodConfigurationWithPeriodRemovedAndGapFilledQueryResult>;
        }));
    }

    protected processPeriodConfiguration_GetPeriodConfigurationWithPeriodRemovedAndGapFilled(response: HttpResponseBase): Observable<ResultV2DtoOfGetPeriodConfigurationWithPeriodRemovedAndGapFilledQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2DtoOfGetPeriodConfigurationWithPeriodRemovedAndGapFilledQueryResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2DtoOfGetPeriodConfigurationWithPeriodRemovedAndGapFilledQueryResult>(null as any);
    }

    paymentSettings_CreateNewPaymentSettings(command: CreateNewPaymentSettingsCommand): Observable<ResultV2DtoOfCreateNewPaymentSettingsCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/PaymentSettings/CreateNewPaymentSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPaymentSettings_CreateNewPaymentSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaymentSettings_CreateNewPaymentSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2DtoOfCreateNewPaymentSettingsCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2DtoOfCreateNewPaymentSettingsCommandResponse>;
        }));
    }

    protected processPaymentSettings_CreateNewPaymentSettings(response: HttpResponseBase): Observable<ResultV2DtoOfCreateNewPaymentSettingsCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2DtoOfCreateNewPaymentSettingsCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2DtoOfCreateNewPaymentSettingsCommandResponse>(null as any);
    }

    paymentSettings_PatchPaymentSettings(command: PatchPaymentSettingsCommand): Observable<ResultV2DtoOfPatchPaymentSettingsCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/PaymentSettings/PatchPaymentSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPaymentSettings_PatchPaymentSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaymentSettings_PatchPaymentSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2DtoOfPatchPaymentSettingsCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2DtoOfPatchPaymentSettingsCommandResponse>;
        }));
    }

    protected processPaymentSettings_PatchPaymentSettings(response: HttpResponseBase): Observable<ResultV2DtoOfPatchPaymentSettingsCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2DtoOfPatchPaymentSettingsCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2DtoOfPatchPaymentSettingsCommandResponse>(null as any);
    }

    paymentServiceProviders_CreateManualPaymentForBooking(command: CreateManualPaymentForBookingCommand): Observable<ResultV2DtoOfCreateManualPaymentForBookingCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/PaymentServiceProviders/CreateManualPaymentForBooking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPaymentServiceProviders_CreateManualPaymentForBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaymentServiceProviders_CreateManualPaymentForBooking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2DtoOfCreateManualPaymentForBookingCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2DtoOfCreateManualPaymentForBookingCommandResponse>;
        }));
    }

    protected processPaymentServiceProviders_CreateManualPaymentForBooking(response: HttpResponseBase): Observable<ResultV2DtoOfCreateManualPaymentForBookingCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2DtoOfCreateManualPaymentForBookingCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2DtoOfCreateManualPaymentForBookingCommandResponse>(null as any);
    }

    paymentServiceProviders_CreateManualRefundForBooking(command: CreateManualRefundForBookingCommand): Observable<ResultV2DtoOfCreateManualRefundForBookingCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/PaymentServiceProviders/CreateManualRefundForBooking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPaymentServiceProviders_CreateManualRefundForBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaymentServiceProviders_CreateManualRefundForBooking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2DtoOfCreateManualRefundForBookingCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2DtoOfCreateManualRefundForBookingCommandResponse>;
        }));
    }

    protected processPaymentServiceProviders_CreateManualRefundForBooking(response: HttpResponseBase): Observable<ResultV2DtoOfCreateManualRefundForBookingCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2DtoOfCreateManualRefundForBookingCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2DtoOfCreateManualRefundForBookingCommandResponse>(null as any);
    }

    program_GetStartDateTimesFilterData(programId: string, year: number, month: number): Observable<ResultV2DtoOfGetProgramStartDateTimesFilterDataQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/Program/GetStartDateTimesFilterData?";
        if (programId === undefined || programId === null)
            throw new Error("The parameter 'programId' must be defined and cannot be null.");
        else
            url_ += "ProgramId=" + encodeURIComponent("" + programId) + "&";
        if (year === undefined || year === null)
            throw new Error("The parameter 'year' must be defined and cannot be null.");
        else
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (month === undefined || month === null)
            throw new Error("The parameter 'month' must be defined and cannot be null.");
        else
            url_ += "Month=" + encodeURIComponent("" + month) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processProgram_GetStartDateTimesFilterData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProgram_GetStartDateTimesFilterData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2DtoOfGetProgramStartDateTimesFilterDataQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2DtoOfGetProgramStartDateTimesFilterDataQueryResult>;
        }));
    }

    protected processProgram_GetStartDateTimesFilterData(response: HttpResponseBase): Observable<ResultV2DtoOfGetProgramStartDateTimesFilterDataQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2DtoOfGetProgramStartDateTimesFilterDataQueryResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2DtoOfGetProgramStartDateTimesFilterDataQueryResult>(null as any);
    }

    file_GetFileUri(fileId: string): Observable<ResultV2DtoOfGetFileUriQueryResult> {
        let url_ = this.baseUrl + "/api/cqrs/File/GetFileUri?";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined and cannot be null.");
        else
            url_ += "FileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFile_GetFileUri(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFile_GetFileUri(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2DtoOfGetFileUriQueryResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2DtoOfGetFileUriQueryResult>;
        }));
    }

    protected processFile_GetFileUri(response: HttpResponseBase): Observable<ResultV2DtoOfGetFileUriQueryResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2DtoOfGetFileUriQueryResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2DtoOfGetFileUriQueryResult>(null as any);
    }

    file_SetFileUploadStatus(command: SetFileUploadStatusCommand): Observable<ResultV2Dto> {
        let url_ = this.baseUrl + "/api/cqrs/File/SetFileUploadStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFile_SetFileUploadStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFile_SetFileUploadStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2Dto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2Dto>;
        }));
    }

    protected processFile_SetFileUploadStatus(response: HttpResponseBase): Observable<ResultV2Dto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2Dto>(null as any);
    }

    file_CreateNewFileForUpload(command: CreateNewFileForUploadCommand): Observable<ResultV2DtoOfCreateNewFileForUploadCommandResponse> {
        let url_ = this.baseUrl + "/api/cqrs/File/CreateNewFileForUpload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFile_CreateNewFileForUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFile_CreateNewFileForUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2DtoOfCreateNewFileForUploadCommandResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2DtoOfCreateNewFileForUploadCommandResponse>;
        }));
    }

    protected processFile_CreateNewFileForUpload(response: HttpResponseBase): Observable<ResultV2DtoOfCreateNewFileForUploadCommandResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2DtoOfCreateNewFileForUploadCommandResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2DtoOfCreateNewFileForUploadCommandResponse>(null as any);
    }

    cmsCaching_ClearCachedCmsPagesDataForLocation(command: ClearCachedCmsPagesDataForLocationCommand): Observable<ResultV2Dto> {
        let url_ = this.baseUrl + "/api/cqrs/CmsCaching/ClearCachedCmsPagesDataForLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsCaching_ClearCachedCmsPagesDataForLocation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsCaching_ClearCachedCmsPagesDataForLocation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2Dto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2Dto>;
        }));
    }

    protected processCmsCaching_ClearCachedCmsPagesDataForLocation(response: HttpResponseBase): Observable<ResultV2Dto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2Dto>(null as any);
    }

    cmsCaching_ClearCachedCmsSiteData(command: ClearCachedCmsSiteDataCommand): Observable<ResultV2Dto> {
        let url_ = this.baseUrl + "/api/cqrs/CmsCaching/ClearCachedCmsSiteData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsCaching_ClearCachedCmsSiteData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsCaching_ClearCachedCmsSiteData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2Dto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2Dto>;
        }));
    }

    protected processCmsCaching_ClearCachedCmsSiteData(response: HttpResponseBase): Observable<ResultV2Dto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2Dto>(null as any);
    }

    bookingItem_Patch(bookingId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/BookingItem/Patch?";
        if (bookingId === undefined)
            throw new Error("The parameter 'bookingId' must be defined.");
        else if(bookingId !== null)
            url_ += "bookingId=" + encodeURIComponent("" + bookingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingItem_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingItem_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processBookingItem_Patch(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    bookingItem_PatchCustomer(bookingId: string | null, customerId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/BookingItem/PatchCustomer?";
        if (bookingId === undefined)
            throw new Error("The parameter 'bookingId' must be defined.");
        else if(bookingId !== null)
            url_ += "bookingId=" + encodeURIComponent("" + bookingId) + "&";
        if (customerId === undefined)
            throw new Error("The parameter 'customerId' must be defined.");
        else if(customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingItem_PatchCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingItem_PatchCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processBookingItem_PatchCustomer(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    bookingItem_ChangeStatus(bookingId: string | null, bookingStatus: BookingStatus): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/BookingItem/ChangeStatus?";
        if (bookingId === undefined)
            throw new Error("The parameter 'bookingId' must be defined.");
        else if(bookingId !== null)
            url_ += "bookingId=" + encodeURIComponent("" + bookingId) + "&";
        if (bookingStatus === undefined || bookingStatus === null)
            throw new Error("The parameter 'bookingStatus' must be defined and cannot be null.");
        else
            url_ += "bookingStatus=" + encodeURIComponent("" + bookingStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingItem_ChangeStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingItem_ChangeStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processBookingItem_ChangeStatus(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    bookingItem_GetLookupDialogView(): Observable<ResultDataOfBookingLookupDialogView> {
        let url_ = this.baseUrl + "/api/tenant/location/BookingItem/GetLookupDialogView";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingItem_GetLookupDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingItem_GetLookupDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfBookingLookupDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfBookingLookupDialogView>;
        }));
    }

    protected processBookingItem_GetLookupDialogView(response: HttpResponseBase): Observable<ResultDataOfBookingLookupDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfBookingLookupDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfBookingLookupDialogView>(null as any);
    }

    bookingItem_RequestBookingLookup(searchQ: string | null): Observable<ResultDataOfListOfBookingLookupResultItem> {
        let url_ = this.baseUrl + "/api/tenant/location/BookingItem/RequestBookingLookup?";
        if (searchQ === undefined)
            throw new Error("The parameter 'searchQ' must be defined.");
        else if(searchQ !== null)
            url_ += "searchQ=" + encodeURIComponent("" + searchQ) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingItem_RequestBookingLookup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingItem_RequestBookingLookup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfListOfBookingLookupResultItem>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfListOfBookingLookupResultItem>;
        }));
    }

    protected processBookingItem_RequestBookingLookup(response: HttpResponseBase): Observable<ResultDataOfListOfBookingLookupResultItem> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfListOfBookingLookupResultItem;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfListOfBookingLookupResultItem>(null as any);
    }

    bookingItem_RequestCustomerLookup(searchQ: string | null): Observable<ResultDataOfListOfBookingCustomerDetails> {
        let url_ = this.baseUrl + "/api/tenant/location/BookingItem/RequestCustomerLookup?";
        if (searchQ === undefined)
            throw new Error("The parameter 'searchQ' must be defined.");
        else if(searchQ !== null)
            url_ += "searchQ=" + encodeURIComponent("" + searchQ) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingItem_RequestCustomerLookup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingItem_RequestCustomerLookup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfListOfBookingCustomerDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfListOfBookingCustomerDetails>;
        }));
    }

    protected processBookingItem_RequestCustomerLookup(response: HttpResponseBase): Observable<ResultDataOfListOfBookingCustomerDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfListOfBookingCustomerDetails;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfListOfBookingCustomerDetails>(null as any);
    }

    bookingItem_GetDetailsDialogView(bookingId: string | null): Observable<ResultDataOfBookingDetailsDialogView> {
        let url_ = this.baseUrl + "/api/tenant/location/BookingItem/GetDetailsDialogView?";
        if (bookingId === undefined)
            throw new Error("The parameter 'bookingId' must be defined.");
        else if(bookingId !== null)
            url_ += "bookingId=" + encodeURIComponent("" + bookingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingItem_GetDetailsDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingItem_GetDetailsDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfBookingDetailsDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfBookingDetailsDialogView>;
        }));
    }

    protected processBookingItem_GetDetailsDialogView(response: HttpResponseBase): Observable<ResultDataOfBookingDetailsDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfBookingDetailsDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfBookingDetailsDialogView>(null as any);
    }

    bookingItem_GetBookingCustomerEditDialogView(bookingId: string | null): Observable<ResultDataOfBookingCustomerEditDialogView> {
        let url_ = this.baseUrl + "/api/tenant/location/BookingItem/GetBookingCustomerEditDialogView?";
        if (bookingId === undefined)
            throw new Error("The parameter 'bookingId' must be defined.");
        else if(bookingId !== null)
            url_ += "bookingId=" + encodeURIComponent("" + bookingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingItem_GetBookingCustomerEditDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingItem_GetBookingCustomerEditDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfBookingCustomerEditDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfBookingCustomerEditDialogView>;
        }));
    }

    protected processBookingItem_GetBookingCustomerEditDialogView(response: HttpResponseBase): Observable<ResultDataOfBookingCustomerEditDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfBookingCustomerEditDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfBookingCustomerEditDialogView>(null as any);
    }

    bookingItem_RequestPaymentLink(paymentLinkRequest: BookingPaymentLinkRequest): Observable<ResultDataOfBookingPaymentLinkResponse> {
        let url_ = this.baseUrl + "/api/tenant/location/BookingItem/RequestPaymentLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(paymentLinkRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingItem_RequestPaymentLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingItem_RequestPaymentLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfBookingPaymentLinkResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfBookingPaymentLinkResponse>;
        }));
    }

    protected processBookingItem_RequestPaymentLink(response: HttpResponseBase): Observable<ResultDataOfBookingPaymentLinkResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfBookingPaymentLinkResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfBookingPaymentLinkResponse>(null as any);
    }

    bookingProcess_Cancel(cancelBookingPortalRequest: CancelBookingPortalRequest): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/BookingProcess/Cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cancelBookingPortalRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingProcess_Cancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingProcess_Cancel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processBookingProcess_Cancel(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    bookingProcess_CreateBooking(createBookingPortalRequest: CreateBookingPortalRequest): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/BookingProcess/CreateBooking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createBookingPortalRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingProcess_CreateBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingProcess_CreateBooking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processBookingProcess_CreateBooking(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    bookingProcess_UpdateBooking(updateBookingPortalRequest: UpdateBookingPortalRequest): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/BookingProcess/UpdateBooking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateBookingPortalRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingProcess_UpdateBooking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingProcess_UpdateBooking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processBookingProcess_UpdateBooking(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    bookingProcess_ValidateCouponCode(couponCode: string | null, bookingInfo: CouponCodeBookingPortalInfo): Observable<ResultDataOfCouponValidationPortalResponse> {
        let url_ = this.baseUrl + "/api/tenant/location/BookingProcess/ValidateCouponCode?";
        if (couponCode === undefined)
            throw new Error("The parameter 'couponCode' must be defined.");
        else if(couponCode !== null)
            url_ += "couponCode=" + encodeURIComponent("" + couponCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bookingInfo);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingProcess_ValidateCouponCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingProcess_ValidateCouponCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfCouponValidationPortalResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfCouponValidationPortalResponse>;
        }));
    }

    protected processBookingProcess_ValidateCouponCode(response: HttpResponseBase): Observable<ResultDataOfCouponValidationPortalResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfCouponValidationPortalResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfCouponValidationPortalResponse>(null as any);
    }

    bookingProcessDialog_GetDebugSettingsFormDialogView(debugSettings?: BookingRequestDialogDebugSettings | undefined): Observable<ResultDataOfRaxFormDialogView> {
        let url_ = this.baseUrl + "/api/tenant/location/BookingProcessDialog/GetDebugSettingsFormDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(debugSettings);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingProcessDialog_GetDebugSettingsFormDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingProcessDialog_GetDebugSettingsFormDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfRaxFormDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfRaxFormDialogView>;
        }));
    }

    protected processBookingProcessDialog_GetDebugSettingsFormDialogView(response: HttpResponseBase): Observable<ResultDataOfRaxFormDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfRaxFormDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfRaxFormDialogView>(null as any);
    }

    bookingProcessDialog_GetRequestDialogView(options: BookingRequestDialogOptions): Observable<ResultDataOfBookingRequestDialogView> {
        let url_ = this.baseUrl + "/api/tenant/location/BookingProcessDialog/GetRequestDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingProcessDialog_GetRequestDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingProcessDialog_GetRequestDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfBookingRequestDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfBookingRequestDialogView>;
        }));
    }

    protected processBookingProcessDialog_GetRequestDialogView(response: HttpResponseBase): Observable<ResultDataOfBookingRequestDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfBookingRequestDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfBookingRequestDialogView>(null as any);
    }

    bookingProcessDialog_GetProgramStepPickerDialogView(fromDate: DateTime, programId: string | null): Observable<ResultDataOfProgramBookingProgramStepPickerDialogView> {
        let url_ = this.baseUrl + "/api/tenant/location/BookingProcessDialog/GetProgramStepPickerDialogView?";
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined and cannot be null.");
        else
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (programId === undefined)
            throw new Error("The parameter 'programId' must be defined.");
        else if(programId !== null)
            url_ += "programId=" + encodeURIComponent("" + programId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingProcessDialog_GetProgramStepPickerDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingProcessDialog_GetProgramStepPickerDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfProgramBookingProgramStepPickerDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfProgramBookingProgramStepPickerDialogView>;
        }));
    }

    protected processBookingProcessDialog_GetProgramStepPickerDialogView(response: HttpResponseBase): Observable<ResultDataOfProgramBookingProgramStepPickerDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfProgramBookingProgramStepPickerDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfProgramBookingProgramStepPickerDialogView>(null as any);
    }

    bookingProcessDialog_GetRequestChangeDialogView(bookingId: string | null): Observable<ResultDataOfBookingRequestChangeDialogView> {
        let url_ = this.baseUrl + "/api/tenant/location/BookingProcessDialog/GetRequestChangeDialogView?";
        if (bookingId === undefined)
            throw new Error("The parameter 'bookingId' must be defined.");
        else if(bookingId !== null)
            url_ += "bookingId=" + encodeURIComponent("" + bookingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingProcessDialog_GetRequestChangeDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingProcessDialog_GetRequestChangeDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfBookingRequestChangeDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfBookingRequestChangeDialogView>;
        }));
    }

    protected processBookingProcessDialog_GetRequestChangeDialogView(response: HttpResponseBase): Observable<ResultDataOfBookingRequestChangeDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfBookingRequestChangeDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfBookingRequestChangeDialogView>(null as any);
    }

    bookingProcessDialog_GetRequestMoveDialogView(bookingId: string | null, moveRequest: ProgramStepMoveRequest): Observable<ResultDataOfBookingRequestChangeDialogView> {
        let url_ = this.baseUrl + "/api/tenant/location/BookingProcessDialog/GetRequestMoveDialogView?";
        if (bookingId === undefined)
            throw new Error("The parameter 'bookingId' must be defined.");
        else if(bookingId !== null)
            url_ += "bookingId=" + encodeURIComponent("" + bookingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(moveRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingProcessDialog_GetRequestMoveDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingProcessDialog_GetRequestMoveDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfBookingRequestChangeDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfBookingRequestChangeDialogView>;
        }));
    }

    protected processBookingProcessDialog_GetRequestMoveDialogView(response: HttpResponseBase): Observable<ResultDataOfBookingRequestChangeDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfBookingRequestChangeDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfBookingRequestChangeDialogView>(null as any);
    }

    bookingProcessDialog_GetProgramAvailabilityInfo(programId: string | null): Observable<ResultDataOfProgramAvailabilityInfo> {
        let url_ = this.baseUrl + "/api/tenant/location/BookingProcessDialog/GetProgramAvailabilityInfo?";
        if (programId === undefined)
            throw new Error("The parameter 'programId' must be defined.");
        else if(programId !== null)
            url_ += "programId=" + encodeURIComponent("" + programId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingProcessDialog_GetProgramAvailabilityInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingProcessDialog_GetProgramAvailabilityInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfProgramAvailabilityInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfProgramAvailabilityInfo>;
        }));
    }

    protected processBookingProcessDialog_GetProgramAvailabilityInfo(response: HttpResponseBase): Observable<ResultDataOfProgramAvailabilityInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfProgramAvailabilityInfo;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfProgramAvailabilityInfo>(null as any);
    }

    bookingProcessDialog_GetProgramBookingOptions(fromDate: DateTime, programId: string | null): Observable<ResultDataOfProgramBookingOptions> {
        let url_ = this.baseUrl + "/api/tenant/location/BookingProcessDialog/GetProgramBookingOptions?";
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined and cannot be null.");
        else
            url_ += "fromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (programId === undefined)
            throw new Error("The parameter 'programId' must be defined.");
        else if(programId !== null)
            url_ += "programId=" + encodeURIComponent("" + programId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingProcessDialog_GetProgramBookingOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingProcessDialog_GetProgramBookingOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfProgramBookingOptions>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfProgramBookingOptions>;
        }));
    }

    protected processBookingProcessDialog_GetProgramBookingOptions(response: HttpResponseBase): Observable<ResultDataOfProgramBookingOptions> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfProgramBookingOptions;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfProgramBookingOptions>(null as any);
    }

    bookingProcessDialog_GetProgramBookingAvailabilityView(programAvailabilityRequest: ProgramAvailabilityRequest): Observable<ResultDataOfProgramBookingAvailabilityView> {
        let url_ = this.baseUrl + "/api/tenant/location/BookingProcessDialog/GetProgramBookingAvailabilityView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(programAvailabilityRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingProcessDialog_GetProgramBookingAvailabilityView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingProcessDialog_GetProgramBookingAvailabilityView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfProgramBookingAvailabilityView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfProgramBookingAvailabilityView>;
        }));
    }

    protected processBookingProcessDialog_GetProgramBookingAvailabilityView(response: HttpResponseBase): Observable<ResultDataOfProgramBookingAvailabilityView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfProgramBookingAvailabilityView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfProgramBookingAvailabilityView>(null as any);
    }

    bookingProposal_Patch(bookingProposalId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/BookingProposal/Patch?";
        if (bookingProposalId === undefined)
            throw new Error("The parameter 'bookingProposalId' must be defined.");
        else if(bookingProposalId !== null)
            url_ += "bookingProposalId=" + encodeURIComponent("" + bookingProposalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingProposal_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingProposal_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processBookingProposal_Patch(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    bookingProposal_PatchObjects(objects: PatchObject[]): Observable<Result> {
        let url_ = this.baseUrl + "/api/tenant/location/BookingProposal/PatchObjects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(objects);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingProposal_PatchObjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingProposal_PatchObjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processBookingProposal_PatchObjects(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    bookingProposal_Delete(bookingProposalId: string | null): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/BookingProposal/Delete?";
        if (bookingProposalId === undefined)
            throw new Error("The parameter 'bookingProposalId' must be defined.");
        else if(bookingProposalId !== null)
            url_ += "bookingProposalId=" + encodeURIComponent("" + bookingProposalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingProposal_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingProposal_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processBookingProposal_Delete(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    bookingProposal_GetListView(): Observable<ResultDataOfBookingProposalListView> {
        let url_ = this.baseUrl + "/api/tenant/location/BookingProposal/GetListView";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingProposal_GetListView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingProposal_GetListView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfBookingProposalListView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfBookingProposalListView>;
        }));
    }

    protected processBookingProposal_GetListView(response: HttpResponseBase): Observable<ResultDataOfBookingProposalListView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfBookingProposalListView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfBookingProposalListView>(null as any);
    }

    bookingProposal_GetListItem(bookingProposalId: string | null): Observable<ResultDataOfBookingProposalListItem> {
        let url_ = this.baseUrl + "/api/tenant/location/BookingProposal/GetListItem?";
        if (bookingProposalId === undefined)
            throw new Error("The parameter 'bookingProposalId' must be defined.");
        else if(bookingProposalId !== null)
            url_ += "bookingProposalId=" + encodeURIComponent("" + bookingProposalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingProposal_GetListItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingProposal_GetListItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfBookingProposalListItem>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfBookingProposalListItem>;
        }));
    }

    protected processBookingProposal_GetListItem(response: HttpResponseBase): Observable<ResultDataOfBookingProposalListItem> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfBookingProposalListItem;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfBookingProposalListItem>(null as any);
    }

    bookingProposal_GetEditItemView(bookingProposalId: string | null): Observable<ResultDataOfBookingProposalEditItemView> {
        let url_ = this.baseUrl + "/api/tenant/location/BookingProposal/GetEditItemView?";
        if (bookingProposalId === undefined)
            throw new Error("The parameter 'bookingProposalId' must be defined.");
        else if(bookingProposalId !== null)
            url_ += "bookingProposalId=" + encodeURIComponent("" + bookingProposalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingProposal_GetEditItemView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingProposal_GetEditItemView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfBookingProposalEditItemView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfBookingProposalEditItemView>;
        }));
    }

    protected processBookingProposal_GetEditItemView(response: HttpResponseBase): Observable<ResultDataOfBookingProposalEditItemView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfBookingProposalEditItemView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfBookingProposalEditItemView>(null as any);
    }

    bookingProposal_GetEditItem(bookingProposalId: string | null): Observable<ResultDataOfBookingProposalEditItem> {
        let url_ = this.baseUrl + "/api/tenant/location/BookingProposal/GetEditItem?";
        if (bookingProposalId === undefined)
            throw new Error("The parameter 'bookingProposalId' must be defined.");
        else if(bookingProposalId !== null)
            url_ += "bookingProposalId=" + encodeURIComponent("" + bookingProposalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingProposal_GetEditItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingProposal_GetEditItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfBookingProposalEditItem>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfBookingProposalEditItem>;
        }));
    }

    protected processBookingProposal_GetEditItem(response: HttpResponseBase): Observable<ResultDataOfBookingProposalEditItem> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfBookingProposalEditItem;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfBookingProposalEditItem>(null as any);
    }

    bookingProposal_ChangeStatus(statusChangeRequest: BookingProposalStatusChangeRequest): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/BookingProposal/ChangeStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(statusChangeRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processBookingProposal_ChangeStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBookingProposal_ChangeStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processBookingProposal_ChangeStatus(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    clients_DownloadAngularClient(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Clients/DownloadAngularClient";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processClients_DownloadAngularClient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClients_DownloadAngularClient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processClients_DownloadAngularClient(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    cmsContentItem_Post(cmsContentItemPost: CmsContentItemPostRequest): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/CmsContentItem/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmsContentItemPost);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsContentItem_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsContentItem_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processCmsContentItem_Post(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    cmsContentItem_Patch(cmsContentItemId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/CmsContentItem/Patch?";
        if (cmsContentItemId === undefined)
            throw new Error("The parameter 'cmsContentItemId' must be defined.");
        else if(cmsContentItemId !== null)
            url_ += "cmsContentItemId=" + encodeURIComponent("" + cmsContentItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsContentItem_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsContentItem_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processCmsContentItem_Patch(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    cmsContentItem_Delete(cmsContentItemId: string | null): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/CmsContentItem/Delete?";
        if (cmsContentItemId === undefined)
            throw new Error("The parameter 'cmsContentItemId' must be defined.");
        else if(cmsContentItemId !== null)
            url_ += "cmsContentItemId=" + encodeURIComponent("" + cmsContentItemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsContentItem_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsContentItem_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processCmsContentItem_Delete(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    cmsContentItem_PatchVersion(cmsContentItemVersionId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/CmsContentItem/PatchVersion?";
        if (cmsContentItemVersionId === undefined)
            throw new Error("The parameter 'cmsContentItemVersionId' must be defined.");
        else if(cmsContentItemVersionId !== null)
            url_ += "cmsContentItemVersionId=" + encodeURIComponent("" + cmsContentItemVersionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsContentItem_PatchVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsContentItem_PatchVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processCmsContentItem_PatchVersion(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    cmsContentPart_Post(cmsContentPart: CmsContentPartPostRequest): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/CmsContentPart/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmsContentPart);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsContentPart_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsContentPart_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processCmsContentPart_Post(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    cmsContentPart_Patch(cmsContentPartId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/CmsContentPart/Patch?";
        if (cmsContentPartId === undefined)
            throw new Error("The parameter 'cmsContentPartId' must be defined.");
        else if(cmsContentPartId !== null)
            url_ += "cmsContentPartId=" + encodeURIComponent("" + cmsContentPartId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsContentPart_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsContentPart_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processCmsContentPart_Patch(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    cmsContentPart_Delete(cmsContentPartId: string | null): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/CmsContentPart/Delete?";
        if (cmsContentPartId === undefined)
            throw new Error("The parameter 'cmsContentPartId' must be defined.");
        else if(cmsContentPartId !== null)
            url_ += "cmsContentPartId=" + encodeURIComponent("" + cmsContentPartId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsContentPart_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsContentPart_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processCmsContentPart_Delete(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    cmsContentPart_GetAddDialogView(): Observable<ResultDataOfCmsContentPartAddDialogView> {
        let url_ = this.baseUrl + "/api/tenant/location/CmsContentPart/GetAddDialogView";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsContentPart_GetAddDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsContentPart_GetAddDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfCmsContentPartAddDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfCmsContentPartAddDialogView>;
        }));
    }

    protected processCmsContentPart_GetAddDialogView(response: HttpResponseBase): Observable<ResultDataOfCmsContentPartAddDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfCmsContentPartAddDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfCmsContentPartAddDialogView>(null as any);
    }

    cmsContentType_Post(cmsContentType: CmsContentTypePostRequest): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/CmsContentType/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmsContentType);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsContentType_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsContentType_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processCmsContentType_Post(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    cmsContentType_Patch(cmsContentTypeId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/CmsContentType/Patch?";
        if (cmsContentTypeId === undefined)
            throw new Error("The parameter 'cmsContentTypeId' must be defined.");
        else if(cmsContentTypeId !== null)
            url_ += "cmsContentTypeId=" + encodeURIComponent("" + cmsContentTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsContentType_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsContentType_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processCmsContentType_Patch(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    cmsContentType_Delete(cmsContentTypeId: string | null): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/CmsContentType/Delete?";
        if (cmsContentTypeId === undefined)
            throw new Error("The parameter 'cmsContentTypeId' must be defined.");
        else if(cmsContentTypeId !== null)
            url_ += "cmsContentTypeId=" + encodeURIComponent("" + cmsContentTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsContentType_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsContentType_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processCmsContentType_Delete(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    cmsContentType_GetAddDialogView(): Observable<ResultDataOfCmsContentTypeAddDialogView> {
        let url_ = this.baseUrl + "/api/tenant/location/CmsContentType/GetAddDialogView";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsContentType_GetAddDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsContentType_GetAddDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfCmsContentTypeAddDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfCmsContentTypeAddDialogView>;
        }));
    }

    protected processCmsContentType_GetAddDialogView(response: HttpResponseBase): Observable<ResultDataOfCmsContentTypeAddDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfCmsContentTypeAddDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfCmsContentTypeAddDialogView>(null as any);
    }

    cms_GetFieldEditDialogView(cmsField?: CmsField | undefined): Observable<ResultDataOfCmsFieldEditDialogView> {
        let url_ = this.baseUrl + "/api/tenant/location/Cms/GetFieldEditDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmsField);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCms_GetFieldEditDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCms_GetFieldEditDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfCmsFieldEditDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfCmsFieldEditDialogView>;
        }));
    }

    protected processCms_GetFieldEditDialogView(response: HttpResponseBase): Observable<ResultDataOfCmsFieldEditDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfCmsFieldEditDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfCmsFieldEditDialogView>(null as any);
    }

    cmsPage_Post(cmsPage: CmsPagePostRequest): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/CmsPage/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmsPage);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsPage_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsPage_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processCmsPage_Post(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    cmsPage_Patch(cmsPageId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/CmsPage/Patch?";
        if (cmsPageId === undefined)
            throw new Error("The parameter 'cmsPageId' must be defined.");
        else if(cmsPageId !== null)
            url_ += "cmsPageId=" + encodeURIComponent("" + cmsPageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsPage_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsPage_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processCmsPage_Patch(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    cmsPage_Delete(cmsPageId: string | null): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/CmsPage/Delete?";
        if (cmsPageId === undefined)
            throw new Error("The parameter 'cmsPageId' must be defined.");
        else if(cmsPageId !== null)
            url_ += "cmsPageId=" + encodeURIComponent("" + cmsPageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsPage_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsPage_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processCmsPage_Delete(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    cmsPage_PatchVersion(cmsPageVersionId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/CmsPage/PatchVersion?";
        if (cmsPageVersionId === undefined)
            throw new Error("The parameter 'cmsPageVersionId' must be defined.");
        else if(cmsPageVersionId !== null)
            url_ += "cmsPageVersionId=" + encodeURIComponent("" + cmsPageVersionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsPage_PatchVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsPage_PatchVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processCmsPage_PatchVersion(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    cmsSiteCheckOut_Post(cmsSiteCheckOut: CmsSiteCheckOutPostRequest): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/CmsSiteCheckOut/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmsSiteCheckOut);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsSiteCheckOut_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsSiteCheckOut_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processCmsSiteCheckOut_Post(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    cmsSiteCheckOut_Patch(cmsSiteCheckOutId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/CmsSiteCheckOut/Patch?";
        if (cmsSiteCheckOutId === undefined)
            throw new Error("The parameter 'cmsSiteCheckOutId' must be defined.");
        else if(cmsSiteCheckOutId !== null)
            url_ += "cmsSiteCheckOutId=" + encodeURIComponent("" + cmsSiteCheckOutId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsSiteCheckOut_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsSiteCheckOut_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processCmsSiteCheckOut_Patch(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    cmsSiteCheckOut_Delete(cmsSiteCheckOutId: string | null): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/CmsSiteCheckOut/Delete?";
        if (cmsSiteCheckOutId === undefined)
            throw new Error("The parameter 'cmsSiteCheckOutId' must be defined.");
        else if(cmsSiteCheckOutId !== null)
            url_ += "cmsSiteCheckOutId=" + encodeURIComponent("" + cmsSiteCheckOutId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsSiteCheckOut_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsSiteCheckOut_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processCmsSiteCheckOut_Delete(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    cmsSiteCheckOut_GetAddDialogView(): Observable<ResultDataOfCmsSiteCheckOutAddDialogView> {
        let url_ = this.baseUrl + "/api/tenant/location/CmsSiteCheckOut/GetAddDialogView";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsSiteCheckOut_GetAddDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsSiteCheckOut_GetAddDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfCmsSiteCheckOutAddDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfCmsSiteCheckOutAddDialogView>;
        }));
    }

    protected processCmsSiteCheckOut_GetAddDialogView(response: HttpResponseBase): Observable<ResultDataOfCmsSiteCheckOutAddDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfCmsSiteCheckOutAddDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfCmsSiteCheckOutAddDialogView>(null as any);
    }

    cmsSite_Post(cmsSite: CmsSitePostRequest): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/CmsSite/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmsSite);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsSite_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsSite_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processCmsSite_Post(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    cmsSite_Patch(cmsSiteId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/CmsSite/Patch?";
        if (cmsSiteId === undefined)
            throw new Error("The parameter 'cmsSiteId' must be defined.");
        else if(cmsSiteId !== null)
            url_ += "cmsSiteId=" + encodeURIComponent("" + cmsSiteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsSite_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsSite_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processCmsSite_Patch(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    cmsSite_Delete(cmsSiteId: string | null): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/CmsSite/Delete?";
        if (cmsSiteId === undefined)
            throw new Error("The parameter 'cmsSiteId' must be defined.");
        else if(cmsSiteId !== null)
            url_ += "cmsSiteId=" + encodeURIComponent("" + cmsSiteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsSite_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsSite_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processCmsSite_Delete(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    cmsSite_GetAddDialogView(): Observable<ResultDataOfCmsSiteAddDialogView> {
        let url_ = this.baseUrl + "/api/tenant/location/CmsSite/GetAddDialogView";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsSite_GetAddDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsSite_GetAddDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfCmsSiteAddDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfCmsSiteAddDialogView>;
        }));
    }

    protected processCmsSite_GetAddDialogView(response: HttpResponseBase): Observable<ResultDataOfCmsSiteAddDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfCmsSiteAddDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfCmsSiteAddDialogView>(null as any);
    }

    cmsSite_GetTheme(): Observable<ResultDataOfString> {
        let url_ = this.baseUrl + "/api/tenant/location/CmsSite/GetTheme";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsSite_GetTheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsSite_GetTheme(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfString>;
        }));
    }

    protected processCmsSite_GetTheme(response: HttpResponseBase): Observable<ResultDataOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfString;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfString>(null as any);
    }

    cmsSite_SetTheme(cmsThemeData: string): Observable<Result> {
        let url_ = this.baseUrl + "/api/tenant/location/CmsSite/SetTheme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmsThemeData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsSite_SetTheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsSite_SetTheme(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processCmsSite_SetTheme(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    cmsSiteTheme_Post(cmsSiteTheme: CmsSiteThemePostRequest): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/CmsSiteTheme/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmsSiteTheme);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsSiteTheme_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsSiteTheme_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processCmsSiteTheme_Post(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    cmsSiteTheme_Patch(cmsSiteThemeId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/CmsSiteTheme/Patch?";
        if (cmsSiteThemeId === undefined)
            throw new Error("The parameter 'cmsSiteThemeId' must be defined.");
        else if(cmsSiteThemeId !== null)
            url_ += "cmsSiteThemeId=" + encodeURIComponent("" + cmsSiteThemeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsSiteTheme_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsSiteTheme_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processCmsSiteTheme_Patch(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    cmsSiteTheme_Delete(cmsSiteThemeId: string | null): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/CmsSiteTheme/Delete?";
        if (cmsSiteThemeId === undefined)
            throw new Error("The parameter 'cmsSiteThemeId' must be defined.");
        else if(cmsSiteThemeId !== null)
            url_ += "cmsSiteThemeId=" + encodeURIComponent("" + cmsSiteThemeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsSiteTheme_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsSiteTheme_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processCmsSiteTheme_Delete(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    cmsSiteTheme_GetAddDialogView(): Observable<ResultDataOfCmsSiteThemeAddDialogView> {
        let url_ = this.baseUrl + "/api/tenant/location/CmsSiteTheme/GetAddDialogView";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsSiteTheme_GetAddDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsSiteTheme_GetAddDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfCmsSiteThemeAddDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfCmsSiteThemeAddDialogView>;
        }));
    }

    protected processCmsSiteTheme_GetAddDialogView(response: HttpResponseBase): Observable<ResultDataOfCmsSiteThemeAddDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfCmsSiteThemeAddDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfCmsSiteThemeAddDialogView>(null as any);
    }

    cmsSiteTheme_GetAddScriptTagSourceDialogView(): Observable<ResultDataOfCmsStyleScriptTagSourceAddDialogView> {
        let url_ = this.baseUrl + "/api/tenant/location/CmsSiteTheme/GetAddScriptTagSourceDialogView";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsSiteTheme_GetAddScriptTagSourceDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsSiteTheme_GetAddScriptTagSourceDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfCmsStyleScriptTagSourceAddDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfCmsStyleScriptTagSourceAddDialogView>;
        }));
    }

    protected processCmsSiteTheme_GetAddScriptTagSourceDialogView(response: HttpResponseBase): Observable<ResultDataOfCmsStyleScriptTagSourceAddDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfCmsStyleScriptTagSourceAddDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfCmsStyleScriptTagSourceAddDialogView>(null as any);
    }

    cmsSiteTheme_GetAddFontDialogView(): Observable<ResultDataOfCmsStyleFontAddDialogView> {
        let url_ = this.baseUrl + "/api/tenant/location/CmsSiteTheme/GetAddFontDialogView";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsSiteTheme_GetAddFontDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsSiteTheme_GetAddFontDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfCmsStyleFontAddDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfCmsStyleFontAddDialogView>;
        }));
    }

    protected processCmsSiteTheme_GetAddFontDialogView(response: HttpResponseBase): Observable<ResultDataOfCmsStyleFontAddDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfCmsStyleFontAddDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfCmsStyleFontAddDialogView>(null as any);
    }

    cmsSiteTheme_GetAddVariableDialogView(): Observable<ResultDataOfCmsStyleVariableAddDialogView> {
        let url_ = this.baseUrl + "/api/tenant/location/CmsSiteTheme/GetAddVariableDialogView";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsSiteTheme_GetAddVariableDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsSiteTheme_GetAddVariableDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfCmsStyleVariableAddDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfCmsStyleVariableAddDialogView>;
        }));
    }

    protected processCmsSiteTheme_GetAddVariableDialogView(response: HttpResponseBase): Observable<ResultDataOfCmsStyleVariableAddDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfCmsStyleVariableAddDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfCmsStyleVariableAddDialogView>(null as any);
    }

    cmsTemplate_Post(cmsTemplate: CmsTemplatePostRequest): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/CmsTemplate/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmsTemplate);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsTemplate_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsTemplate_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processCmsTemplate_Post(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    cmsTemplate_Patch(cmsTemplateId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/CmsTemplate/Patch?";
        if (cmsTemplateId === undefined)
            throw new Error("The parameter 'cmsTemplateId' must be defined.");
        else if(cmsTemplateId !== null)
            url_ += "cmsTemplateId=" + encodeURIComponent("" + cmsTemplateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsTemplate_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsTemplate_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processCmsTemplate_Patch(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    cmsTemplate_Delete(cmsTemplateId: string | null): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/CmsTemplate/Delete?";
        if (cmsTemplateId === undefined)
            throw new Error("The parameter 'cmsTemplateId' must be defined.");
        else if(cmsTemplateId !== null)
            url_ += "cmsTemplateId=" + encodeURIComponent("" + cmsTemplateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsTemplate_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsTemplate_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processCmsTemplate_Delete(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    cmsTemplatePart_Post(cmsTemplatePart: CmsTemplatePartPostRequest): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/CmsTemplatePart/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmsTemplatePart);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsTemplatePart_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsTemplatePart_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processCmsTemplatePart_Post(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    cmsTemplatePart_Patch(cmsTemplatePartId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/CmsTemplatePart/Patch?";
        if (cmsTemplatePartId === undefined)
            throw new Error("The parameter 'cmsTemplatePartId' must be defined.");
        else if(cmsTemplatePartId !== null)
            url_ += "cmsTemplatePartId=" + encodeURIComponent("" + cmsTemplatePartId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsTemplatePart_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsTemplatePart_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processCmsTemplatePart_Patch(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    cmsTemplatePart_Delete(cmsTemplatePartId: string | null): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/CmsTemplatePart/Delete?";
        if (cmsTemplatePartId === undefined)
            throw new Error("The parameter 'cmsTemplatePartId' must be defined.");
        else if(cmsTemplatePartId !== null)
            url_ += "cmsTemplatePartId=" + encodeURIComponent("" + cmsTemplatePartId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCmsTemplatePart_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCmsTemplatePart_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processCmsTemplatePart_Delete(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    couponCampaign_Post(couponCampaign: CouponCampaignPostRequest): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/CouponCampaign/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(couponCampaign);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCouponCampaign_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCouponCampaign_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processCouponCampaign_Post(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    couponCampaign_Patch(couponCampaignId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/CouponCampaign/Patch?";
        if (couponCampaignId === undefined)
            throw new Error("The parameter 'couponCampaignId' must be defined.");
        else if(couponCampaignId !== null)
            url_ += "couponCampaignId=" + encodeURIComponent("" + couponCampaignId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCouponCampaign_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCouponCampaign_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processCouponCampaign_Patch(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    couponCampaign_Delete(couponCampaignId: string | null): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/CouponCampaign/Delete?";
        if (couponCampaignId === undefined)
            throw new Error("The parameter 'couponCampaignId' must be defined.");
        else if(couponCampaignId !== null)
            url_ += "couponCampaignId=" + encodeURIComponent("" + couponCampaignId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCouponCampaign_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCouponCampaign_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processCouponCampaign_Delete(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    customer_Patch(customerId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/Customer/Patch?";
        if (customerId === undefined)
            throw new Error("The parameter 'customerId' must be defined.");
        else if(customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomer_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomer_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processCustomer_Patch(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    customer_PatchObjects(objects: PatchObject[]): Observable<Result> {
        let url_ = this.baseUrl + "/api/tenant/location/Customer/PatchObjects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(objects);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomer_PatchObjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomer_PatchObjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processCustomer_PatchObjects(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    customer_Delete(customerId: string | null): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/Customer/Delete?";
        if (customerId === undefined)
            throw new Error("The parameter 'customerId' must be defined.");
        else if(customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processCustomer_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomer_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processCustomer_Delete(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    dev_GetDemoFormView(objectId: string | null): Observable<ResultDataOfRaxFormPageView> {
        let url_ = this.baseUrl + "/api/Dev/GetDemoFormView?";
        if (objectId === undefined)
            throw new Error("The parameter 'objectId' must be defined.");
        else if(objectId !== null)
            url_ += "objectId=" + encodeURIComponent("" + objectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDev_GetDemoFormView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDev_GetDemoFormView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfRaxFormPageView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfRaxFormPageView>;
        }));
    }

    protected processDev_GetDemoFormView(response: HttpResponseBase): Observable<ResultDataOfRaxFormPageView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfRaxFormPageView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfRaxFormPageView>(null as any);
    }

    dev_GetDemoFormDialogView(): Observable<ResultDataOfRaxFormDialogView> {
        let url_ = this.baseUrl + "/api/Dev/GetDemoFormDialogView";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDev_GetDemoFormDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDev_GetDemoFormDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfRaxFormDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfRaxFormDialogView>;
        }));
    }

    protected processDev_GetDemoFormDialogView(response: HttpResponseBase): Observable<ResultDataOfRaxFormDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfRaxFormDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfRaxFormDialogView>(null as any);
    }

    dev_Patch(demoModelId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/Dev/Patch?";
        if (demoModelId === undefined)
            throw new Error("The parameter 'demoModelId' must be defined.");
        else if(demoModelId !== null)
            url_ += "demoModelId=" + encodeURIComponent("" + demoModelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDev_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDev_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processDev_Patch(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    dev_TimeSpanTest(helloWorldTimeSpan: Duration): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Dev/TimeSpanTest?";
        if (helloWorldTimeSpan === undefined || helloWorldTimeSpan === null)
            throw new Error("The parameter 'helloWorldTimeSpan' must be defined and cannot be null.");
        else
            url_ += "helloWorldTimeSpan=" + encodeURIComponent("" + helloWorldTimeSpan) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDev_TimeSpanTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDev_TimeSpanTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDev_TimeSpanTest(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    dev_TimeSpanTestBody(helloWorldTimeSpan: Duration, worldTimeModel: HelloWorldTimeModel): Observable<HelloWorldTimeModel> {
        let url_ = this.baseUrl + "/api/Dev/TimeSpanTestBody?";
        if (helloWorldTimeSpan === undefined || helloWorldTimeSpan === null)
            throw new Error("The parameter 'helloWorldTimeSpan' must be defined and cannot be null.");
        else
            url_ += "helloWorldTimeSpan=" + encodeURIComponent("" + helloWorldTimeSpan) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(worldTimeModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processDev_TimeSpanTestBody(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDev_TimeSpanTestBody(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HelloWorldTimeModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HelloWorldTimeModel>;
        }));
    }

    protected processDev_TimeSpanTestBody(response: HttpResponseBase): Observable<HelloWorldTimeModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HelloWorldTimeModel;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HelloWorldTimeModel>(null as any);
    }

    emailSettings_PostForBookingSiteId(bookingSiteId: string | null): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/EmailSettings/PostForBookingSiteId?";
        if (bookingSiteId === undefined)
            throw new Error("The parameter 'bookingSiteId' must be defined.");
        else if(bookingSiteId !== null)
            url_ += "bookingSiteId=" + encodeURIComponent("" + bookingSiteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processEmailSettings_PostForBookingSiteId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmailSettings_PostForBookingSiteId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processEmailSettings_PostForBookingSiteId(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    emailSettings_Patch(messageSettingsId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/EmailSettings/Patch?";
        if (messageSettingsId === undefined)
            throw new Error("The parameter 'messageSettingsId' must be defined.");
        else if(messageSettingsId !== null)
            url_ += "messageSettingsId=" + encodeURIComponent("" + messageSettingsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processEmailSettings_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmailSettings_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processEmailSettings_Patch(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    emailTemplate_Post(emailTemplatePost: EmailTemplatePostRequest): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/EmailTemplate/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailTemplatePost);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processEmailTemplate_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmailTemplate_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processEmailTemplate_Post(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    emailTemplate_Patch(emailTemplateId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/EmailTemplate/Patch?";
        if (emailTemplateId === undefined)
            throw new Error("The parameter 'emailTemplateId' must be defined.");
        else if(emailTemplateId !== null)
            url_ += "emailTemplateId=" + encodeURIComponent("" + emailTemplateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processEmailTemplate_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmailTemplate_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processEmailTemplate_Patch(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    emailTemplate_GetAddDialogView(): Observable<ResultDataOfEmailTemplateAddDialogView> {
        let url_ = this.baseUrl + "/api/tenant/location/EmailTemplate/GetAddDialogView";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processEmailTemplate_GetAddDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEmailTemplate_GetAddDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfEmailTemplateAddDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfEmailTemplateAddDialogView>;
        }));
    }

    protected processEmailTemplate_GetAddDialogView(response: HttpResponseBase): Observable<ResultDataOfEmailTemplateAddDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfEmailTemplateAddDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfEmailTemplateAddDialogView>(null as any);
    }

    error_GetGET(): Observable<Result> {
        let url_ = this.baseUrl + "/api/Error/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processError_GetGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processError_GetGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processError_GetGET(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    error_GetPATCH(): Observable<Result> {
        let url_ = this.baseUrl + "/api/Error/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processError_GetPATCH(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processError_GetPATCH(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processError_GetPATCH(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    error_GetPOST(): Observable<Result> {
        let url_ = this.baseUrl + "/api/Error/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processError_GetPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processError_GetPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processError_GetPOST(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    error_GetPUT(): Observable<Result> {
        let url_ = this.baseUrl + "/api/Error/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processError_GetPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processError_GetPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processError_GetPUT(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    error_GetDELETE(): Observable<Result> {
        let url_ = this.baseUrl + "/api/Error/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processError_GetDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processError_GetDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processError_GetDELETE(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    error_GetHEAD(): Observable<Result> {
        let url_ = this.baseUrl + "/api/Error/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("head", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processError_GetHEAD(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processError_GetHEAD(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processError_GetHEAD(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    error_GetOPTIONS(): Observable<Result> {
        let url_ = this.baseUrl + "/api/Error/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("options", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processError_GetOPTIONS(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processError_GetOPTIONS(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processError_GetOPTIONS(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    error_GetV2GET(status400: boolean): Observable<ResultV2DtoOfString> {
        let url_ = this.baseUrl + "/api/Error/GetV2?";
        if (status400 === undefined || status400 === null)
            throw new Error("The parameter 'status400' must be defined and cannot be null.");
        else
            url_ += "status400=" + encodeURIComponent("" + status400) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processError_GetV2GET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processError_GetV2GET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2DtoOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2DtoOfString>;
        }));
    }

    protected processError_GetV2GET(response: HttpResponseBase): Observable<ResultV2DtoOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2DtoOfString;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2DtoOfString>(null as any);
    }

    error_GetV2PATCH(status400: boolean): Observable<ResultV2DtoOfString> {
        let url_ = this.baseUrl + "/api/Error/GetV2?";
        if (status400 === undefined || status400 === null)
            throw new Error("The parameter 'status400' must be defined and cannot be null.");
        else
            url_ += "status400=" + encodeURIComponent("" + status400) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processError_GetV2PATCH(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processError_GetV2PATCH(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2DtoOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2DtoOfString>;
        }));
    }

    protected processError_GetV2PATCH(response: HttpResponseBase): Observable<ResultV2DtoOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2DtoOfString;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2DtoOfString>(null as any);
    }

    error_GetV2POST(status400: boolean): Observable<ResultV2DtoOfString> {
        let url_ = this.baseUrl + "/api/Error/GetV2?";
        if (status400 === undefined || status400 === null)
            throw new Error("The parameter 'status400' must be defined and cannot be null.");
        else
            url_ += "status400=" + encodeURIComponent("" + status400) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processError_GetV2POST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processError_GetV2POST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2DtoOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2DtoOfString>;
        }));
    }

    protected processError_GetV2POST(response: HttpResponseBase): Observable<ResultV2DtoOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2DtoOfString;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2DtoOfString>(null as any);
    }

    error_GetV2PUT(status400: boolean): Observable<ResultV2DtoOfString> {
        let url_ = this.baseUrl + "/api/Error/GetV2?";
        if (status400 === undefined || status400 === null)
            throw new Error("The parameter 'status400' must be defined and cannot be null.");
        else
            url_ += "status400=" + encodeURIComponent("" + status400) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processError_GetV2PUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processError_GetV2PUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2DtoOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2DtoOfString>;
        }));
    }

    protected processError_GetV2PUT(response: HttpResponseBase): Observable<ResultV2DtoOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2DtoOfString;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2DtoOfString>(null as any);
    }

    error_GetV2DELETE(status400: boolean): Observable<ResultV2DtoOfString> {
        let url_ = this.baseUrl + "/api/Error/GetV2?";
        if (status400 === undefined || status400 === null)
            throw new Error("The parameter 'status400' must be defined and cannot be null.");
        else
            url_ += "status400=" + encodeURIComponent("" + status400) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processError_GetV2DELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processError_GetV2DELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2DtoOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2DtoOfString>;
        }));
    }

    protected processError_GetV2DELETE(response: HttpResponseBase): Observable<ResultV2DtoOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2DtoOfString;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2DtoOfString>(null as any);
    }

    error_GetV2HEAD(status400: boolean): Observable<ResultV2DtoOfString> {
        let url_ = this.baseUrl + "/api/Error/GetV2?";
        if (status400 === undefined || status400 === null)
            throw new Error("The parameter 'status400' must be defined and cannot be null.");
        else
            url_ += "status400=" + encodeURIComponent("" + status400) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("head", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processError_GetV2HEAD(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processError_GetV2HEAD(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2DtoOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2DtoOfString>;
        }));
    }

    protected processError_GetV2HEAD(response: HttpResponseBase): Observable<ResultV2DtoOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2DtoOfString;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2DtoOfString>(null as any);
    }

    error_GetV2OPTIONS(status400: boolean): Observable<ResultV2DtoOfString> {
        let url_ = this.baseUrl + "/api/Error/GetV2?";
        if (status400 === undefined || status400 === null)
            throw new Error("The parameter 'status400' must be defined and cannot be null.");
        else
            url_ += "status400=" + encodeURIComponent("" + status400) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("options", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processError_GetV2OPTIONS(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processError_GetV2OPTIONS(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultV2DtoOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultV2DtoOfString>;
        }));
    }

    protected processError_GetV2OPTIONS(response: HttpResponseBase): Observable<ResultV2DtoOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2DtoOfString;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultV2Dto;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultV2DtoOfString>(null as any);
    }

    error_GetDetailsGET(): Observable<Result> {
        let url_ = this.baseUrl + "/api/Error/GetDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processError_GetDetailsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processError_GetDetailsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processError_GetDetailsGET(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    error_GetDetailsPATCH(): Observable<Result> {
        let url_ = this.baseUrl + "/api/Error/GetDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processError_GetDetailsPATCH(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processError_GetDetailsPATCH(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processError_GetDetailsPATCH(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    error_GetDetailsPOST(): Observable<Result> {
        let url_ = this.baseUrl + "/api/Error/GetDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processError_GetDetailsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processError_GetDetailsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processError_GetDetailsPOST(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    error_GetDetailsPUT(): Observable<Result> {
        let url_ = this.baseUrl + "/api/Error/GetDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processError_GetDetailsPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processError_GetDetailsPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processError_GetDetailsPUT(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    error_GetDetailsDELETE(): Observable<Result> {
        let url_ = this.baseUrl + "/api/Error/GetDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processError_GetDetailsDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processError_GetDetailsDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processError_GetDetailsDELETE(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    error_GetDetailsHEAD(): Observable<Result> {
        let url_ = this.baseUrl + "/api/Error/GetDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("head", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processError_GetDetailsHEAD(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processError_GetDetailsHEAD(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processError_GetDetailsHEAD(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    error_GetDetailsOPTIONS(): Observable<Result> {
        let url_ = this.baseUrl + "/api/Error/GetDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("options", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processError_GetDetailsOPTIONS(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processError_GetDetailsOPTIONS(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processError_GetDetailsOPTIONS(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    error_LogError(errorMessage: string): Observable<Result> {
        let url_ = this.baseUrl + "/api/Error/LogError";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(errorMessage);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processError_LogError(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processError_LogError(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processError_LogError(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    error_TriggerGraphError(): Observable<Result> {
        let url_ = this.baseUrl + "/api/Error/TriggerGraphError";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processError_TriggerGraphError(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processError_TriggerGraphError(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processError_TriggerGraphError(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    error_GetExceptionData(): Observable<ExceptionData> {
        let url_ = this.baseUrl + "/api/Error";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processError_GetExceptionData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processError_GetExceptionData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExceptionData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExceptionData>;
        }));
    }

    protected processError_GetExceptionData(response: HttpResponseBase): Observable<ExceptionData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExceptionData;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExceptionData>(null as any);
    }

    feedback_Post(feedback: PortalFeedback): Observable<Result> {
        let url_ = this.baseUrl + "/api/Feedback/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(feedback);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processFeedback_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFeedback_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processFeedback_Post(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    league_Post(league: LeaguePostRequest): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/League/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(league);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLeague_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLeague_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processLeague_Post(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    league_Patch(leagueId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/League/Patch?";
        if (leagueId === undefined)
            throw new Error("The parameter 'leagueId' must be defined.");
        else if(leagueId !== null)
            url_ += "leagueId=" + encodeURIComponent("" + leagueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLeague_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLeague_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processLeague_Patch(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    league_PatchObjects(objects: PatchObject[]): Observable<Result> {
        let url_ = this.baseUrl + "/api/tenant/location/League/PatchObjects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(objects);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLeague_PatchObjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLeague_PatchObjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processLeague_PatchObjects(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    league_Delete(leagueId: string | null): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/League/Delete?";
        if (leagueId === undefined)
            throw new Error("The parameter 'leagueId' must be defined.");
        else if(leagueId !== null)
            url_ += "leagueId=" + encodeURIComponent("" + leagueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLeague_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLeague_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processLeague_Delete(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    league_GetAddDialogView(): Observable<ResultDataOfLeagueAddDialogView> {
        let url_ = this.baseUrl + "/api/tenant/location/League/GetAddDialogView";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLeague_GetAddDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLeague_GetAddDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfLeagueAddDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfLeagueAddDialogView>;
        }));
    }

    protected processLeague_GetAddDialogView(response: HttpResponseBase): Observable<ResultDataOfLeagueAddDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfLeagueAddDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfLeagueAddDialogView>(null as any);
    }

    league_GetSeasonAddDialogView(leagueId: string | null, sourceSeasonId?: string | null | undefined): Observable<ResultDataOfLeagueSeasonAddDialogView> {
        let url_ = this.baseUrl + "/api/tenant/location/League/GetSeasonAddDialogView?";
        if (leagueId === undefined)
            throw new Error("The parameter 'leagueId' must be defined.");
        else if(leagueId !== null)
            url_ += "leagueId=" + encodeURIComponent("" + leagueId) + "&";
        if (sourceSeasonId !== undefined && sourceSeasonId !== null)
            url_ += "sourceSeasonId=" + encodeURIComponent("" + sourceSeasonId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLeague_GetSeasonAddDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLeague_GetSeasonAddDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfLeagueSeasonAddDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfLeagueSeasonAddDialogView>;
        }));
    }

    protected processLeague_GetSeasonAddDialogView(response: HttpResponseBase): Observable<ResultDataOfLeagueSeasonAddDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfLeagueSeasonAddDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfLeagueSeasonAddDialogView>(null as any);
    }

    league_GetEditItemView(leagueId: string | null): Observable<ResultDataOfLeagueEditItemView> {
        let url_ = this.baseUrl + "/api/tenant/location/League/GetEditItemView?";
        if (leagueId === undefined)
            throw new Error("The parameter 'leagueId' must be defined.");
        else if(leagueId !== null)
            url_ += "leagueId=" + encodeURIComponent("" + leagueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLeague_GetEditItemView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLeague_GetEditItemView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfLeagueEditItemView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfLeagueEditItemView>;
        }));
    }

    protected processLeague_GetEditItemView(response: HttpResponseBase): Observable<ResultDataOfLeagueEditItemView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfLeagueEditItemView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfLeagueEditItemView>(null as any);
    }

    league_GetEditItemSeasonView(leagueId: string | null, seasonId: string | null): Observable<ResultDataOfLeagueEditItemSeasonView> {
        let url_ = this.baseUrl + "/api/tenant/location/League/GetEditItemSeasonView?";
        if (leagueId === undefined)
            throw new Error("The parameter 'leagueId' must be defined.");
        else if(leagueId !== null)
            url_ += "leagueId=" + encodeURIComponent("" + leagueId) + "&";
        if (seasonId === undefined)
            throw new Error("The parameter 'seasonId' must be defined.");
        else if(seasonId !== null)
            url_ += "seasonId=" + encodeURIComponent("" + seasonId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLeague_GetEditItemSeasonView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLeague_GetEditItemSeasonView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfLeagueEditItemSeasonView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfLeagueEditItemSeasonView>;
        }));
    }

    protected processLeague_GetEditItemSeasonView(response: HttpResponseBase): Observable<ResultDataOfLeagueEditItemSeasonView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfLeagueEditItemSeasonView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfLeagueEditItemSeasonView>(null as any);
    }

    league_TeamUpdatesRequest(leagueTeamUpdatesRequest: LeagueTeamUpdatesRequest): Observable<Result> {
        let url_ = this.baseUrl + "/api/tenant/location/League/TeamUpdatesRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(leagueTeamUpdatesRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLeague_TeamUpdatesRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLeague_TeamUpdatesRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processLeague_TeamUpdatesRequest(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    leagueMatchDateProcess_CreateMatchDates(createMatchDatesRequest: CreateMatchDatesRequest): Observable<Result> {
        let url_ = this.baseUrl + "/api/tenant/location/LeagueMatchDateProcess/CreateMatchDates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createMatchDatesRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLeagueMatchDateProcess_CreateMatchDates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLeagueMatchDateProcess_CreateMatchDates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processLeagueMatchDateProcess_CreateMatchDates(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    leagueMatchDateProcess_UpdateMatchDateBookingsTeamOrder(orderUpdateRequest: MatchDateBookingsTeamOrderUpdateRequest): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/LeagueMatchDateProcess/UpdateMatchDateBookingsTeamOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orderUpdateRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLeagueMatchDateProcess_UpdateMatchDateBookingsTeamOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLeagueMatchDateProcess_UpdateMatchDateBookingsTeamOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processLeagueMatchDateProcess_UpdateMatchDateBookingsTeamOrder(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    leagueMatchDateProcessDialog_GetRequestDialogView(options: MatchDatesRequestDialogOptions): Observable<ResultDataOfMatchDatesRequestDialogView> {
        let url_ = this.baseUrl + "/api/tenant/location/LeagueMatchDateProcessDialog/GetRequestDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLeagueMatchDateProcessDialog_GetRequestDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLeagueMatchDateProcessDialog_GetRequestDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfMatchDatesRequestDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfMatchDatesRequestDialogView>;
        }));
    }

    protected processLeagueMatchDateProcessDialog_GetRequestDialogView(response: HttpResponseBase): Observable<ResultDataOfMatchDatesRequestDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfMatchDatesRequestDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfMatchDatesRequestDialogView>(null as any);
    }

    leagueMatchDateProcessDialog_GetMatchDateBookingOptions(startTime: Duration, programId: string | null, leagueId: string | null, seasonId: string | null): Observable<ResultDataOfMatchDateBookingOptions> {
        let url_ = this.baseUrl + "/api/tenant/location/LeagueMatchDateProcessDialog/GetMatchDateBookingOptions?";
        if (startTime === undefined || startTime === null)
            throw new Error("The parameter 'startTime' must be defined and cannot be null.");
        else
            url_ += "startTime=" + encodeURIComponent("" + startTime) + "&";
        if (programId === undefined)
            throw new Error("The parameter 'programId' must be defined.");
        else if(programId !== null)
            url_ += "programId=" + encodeURIComponent("" + programId) + "&";
        if (leagueId === undefined)
            throw new Error("The parameter 'leagueId' must be defined.");
        else if(leagueId !== null)
            url_ += "leagueId=" + encodeURIComponent("" + leagueId) + "&";
        if (seasonId === undefined)
            throw new Error("The parameter 'seasonId' must be defined.");
        else if(seasonId !== null)
            url_ += "seasonId=" + encodeURIComponent("" + seasonId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLeagueMatchDateProcessDialog_GetMatchDateBookingOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLeagueMatchDateProcessDialog_GetMatchDateBookingOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfMatchDateBookingOptions>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfMatchDateBookingOptions>;
        }));
    }

    protected processLeagueMatchDateProcessDialog_GetMatchDateBookingOptions(response: HttpResponseBase): Observable<ResultDataOfMatchDateBookingOptions> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfMatchDateBookingOptions;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfMatchDateBookingOptions>(null as any);
    }

    leagueMatchDateProcessDialog_GetMatchDatesAvailabilityView(matchDatesAvailabilityRequest: MatchDatesAvailabilityRequest): Observable<ResultDataOfMatchDatesAvailabilityView> {
        let url_ = this.baseUrl + "/api/tenant/location/LeagueMatchDateProcessDialog/GetMatchDatesAvailabilityView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(matchDatesAvailabilityRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLeagueMatchDateProcessDialog_GetMatchDatesAvailabilityView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLeagueMatchDateProcessDialog_GetMatchDatesAvailabilityView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfMatchDatesAvailabilityView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfMatchDatesAvailabilityView>;
        }));
    }

    protected processLeagueMatchDateProcessDialog_GetMatchDatesAvailabilityView(response: HttpResponseBase): Observable<ResultDataOfMatchDatesAvailabilityView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfMatchDatesAvailabilityView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfMatchDatesAvailabilityView>(null as any);
    }

    locationBookingApproval_SetBookingApproval(bookingApprovalChangeRequest: LocationBookingApprovalChangeRequest): Observable<Result> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationBookingApproval/SetBookingApproval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bookingApprovalChangeRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationBookingApproval_SetBookingApproval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationBookingApproval_SetBookingApproval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processLocationBookingApproval_SetBookingApproval(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    locationBookingConfirmationEmail_SetBookingConfirmationEmail(bookingConfirmationEmailChangeItem: LocationBookingConfirmationEmailChangeItem): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationBookingConfirmationEmail/SetBookingConfirmationEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bookingConfirmationEmailChangeItem);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationBookingConfirmationEmail_SetBookingConfirmationEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationBookingConfirmationEmail_SetBookingConfirmationEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processLocationBookingConfirmationEmail_SetBookingConfirmationEmail(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    locationBookingRefundProposal_GetCreateBookingRefundProposalDialogView(bookingId: string | null): Observable<ResultDataOfCreateBookingRefundProposalDialogView> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationBookingRefundProposal/GetCreateBookingRefundProposalDialogView?";
        if (bookingId === undefined)
            throw new Error("The parameter 'bookingId' must be defined.");
        else if(bookingId !== null)
            url_ += "bookingId=" + encodeURIComponent("" + bookingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationBookingRefundProposal_GetCreateBookingRefundProposalDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationBookingRefundProposal_GetCreateBookingRefundProposalDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfCreateBookingRefundProposalDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfCreateBookingRefundProposalDialogView>;
        }));
    }

    protected processLocationBookingRefundProposal_GetCreateBookingRefundProposalDialogView(response: HttpResponseBase): Observable<ResultDataOfCreateBookingRefundProposalDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfCreateBookingRefundProposalDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfCreateBookingRefundProposalDialogView>(null as any);
    }

    locationBookingRefundProposal_ProcessBookingRefundProposalApprovalDecisionBatch(processRefundApprovalRequest: BookingRefundProposalApprovalDecisionBatchRequest): Observable<Result> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationBookingRefundProposal/ProcessBookingRefundProposalApprovalDecisionBatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(processRefundApprovalRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationBookingRefundProposal_ProcessBookingRefundProposalApprovalDecisionBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationBookingRefundProposal_ProcessBookingRefundProposalApprovalDecisionBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processLocationBookingRefundProposal_ProcessBookingRefundProposalApprovalDecisionBatch(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    locationBookingRefundProposal_GetBookingRefundProposalHistoryListPageView(): Observable<ResultDataOfBookingRefundProposalHistoryListPageView> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationBookingRefundProposal/GetBookingRefundProposalHistoryListPageView";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationBookingRefundProposal_GetBookingRefundProposalHistoryListPageView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationBookingRefundProposal_GetBookingRefundProposalHistoryListPageView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfBookingRefundProposalHistoryListPageView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfBookingRefundProposalHistoryListPageView>;
        }));
    }

    protected processLocationBookingRefundProposal_GetBookingRefundProposalHistoryListPageView(response: HttpResponseBase): Observable<ResultDataOfBookingRefundProposalHistoryListPageView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfBookingRefundProposalHistoryListPageView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfBookingRefundProposalHistoryListPageView>(null as any);
    }

    locationBookingRefundProposal_CreateBookingRefundProposalBatch(createBookingRefundProposalBatchRequest: CreateBookingRefundProposalBatchRequest): Observable<Result> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationBookingRefundProposal/CreateBookingRefundProposalBatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createBookingRefundProposalBatchRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationBookingRefundProposal_CreateBookingRefundProposalBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationBookingRefundProposal_CreateBookingRefundProposalBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processLocationBookingRefundProposal_CreateBookingRefundProposalBatch(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    locationBookingRefundProposal_CreateBookingRefundProposal(createBookingRefundProposal: CreateBookingRefundProposalRequest): Observable<Result> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationBookingRefundProposal/CreateBookingRefundProposal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createBookingRefundProposal);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationBookingRefundProposal_CreateBookingRefundProposal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationBookingRefundProposal_CreateBookingRefundProposal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processLocationBookingRefundProposal_CreateBookingRefundProposal(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    location_Post(location: LocationEditItem): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/Location/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(location);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocation_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocation_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processLocation_Post(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    location_Patch(locationId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/Location/Patch?";
        if (locationId === undefined)
            throw new Error("The parameter 'locationId' must be defined.");
        else if(locationId !== null)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocation_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocation_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processLocation_Patch(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    location_Delete(locationId: string | null): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/Location/Delete?";
        if (locationId === undefined)
            throw new Error("The parameter 'locationId' must be defined.");
        else if(locationId !== null)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocation_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocation_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processLocation_Delete(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    location_GetEditDialogView(locationId?: string | null | undefined): Observable<ResultDataOfLocationEditDialogView> {
        let url_ = this.baseUrl + "/api/tenant/Location/GetEditDialogView?";
        if (locationId !== undefined && locationId !== null)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocation_GetEditDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocation_GetEditDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfLocationEditDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfLocationEditDialogView>;
        }));
    }

    protected processLocation_GetEditDialogView(response: HttpResponseBase): Observable<ResultDataOfLocationEditDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfLocationEditDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfLocationEditDialogView>(null as any);
    }

    locationMarketingSocial_Patch(locationSettingsId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationMarketingSocial/Patch?";
        if (locationSettingsId === undefined)
            throw new Error("The parameter 'locationSettingsId' must be defined.");
        else if(locationSettingsId !== null)
            url_ += "locationSettingsId=" + encodeURIComponent("" + locationSettingsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationMarketingSocial_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationMarketingSocial_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processLocationMarketingSocial_Patch(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    locationSettingsAgeGroup_Post(ageGroup: LocationSettingsAgeGroupFormData): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationSettingsAgeGroup/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ageGroup);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettingsAgeGroup_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettingsAgeGroup_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processLocationSettingsAgeGroup_Post(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    locationSettingsAgeGroup_Patch(ageGroupId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationSettingsAgeGroup/Patch?";
        if (ageGroupId === undefined)
            throw new Error("The parameter 'ageGroupId' must be defined.");
        else if(ageGroupId !== null)
            url_ += "ageGroupId=" + encodeURIComponent("" + ageGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettingsAgeGroup_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettingsAgeGroup_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processLocationSettingsAgeGroup_Patch(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    locationSettingsAgeGroup_PatchObjects(objects: PatchObject[]): Observable<Result> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationSettingsAgeGroup/PatchObjects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(objects);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettingsAgeGroup_PatchObjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettingsAgeGroup_PatchObjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processLocationSettingsAgeGroup_PatchObjects(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    locationSettingsAgeGroup_Delete(ageGroupId: string | null): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationSettingsAgeGroup/Delete?";
        if (ageGroupId === undefined)
            throw new Error("The parameter 'ageGroupId' must be defined.");
        else if(ageGroupId !== null)
            url_ += "ageGroupId=" + encodeURIComponent("" + ageGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettingsAgeGroup_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettingsAgeGroup_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processLocationSettingsAgeGroup_Delete(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    locationSettingsLocation_Patch(locationSettingsId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationSettingsLocation/Patch?";
        if (locationSettingsId === undefined)
            throw new Error("The parameter 'locationSettingsId' must be defined.");
        else if(locationSettingsId !== null)
            url_ += "locationSettingsId=" + encodeURIComponent("" + locationSettingsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettingsLocation_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettingsLocation_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processLocationSettingsLocation_Patch(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    locationSettingsLocation_GetTabsPageView(): Observable<ResultDataOfRaxTabsPageView> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationSettingsLocation/GetTabsPageView";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettingsLocation_GetTabsPageView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettingsLocation_GetTabsPageView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfRaxTabsPageView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfRaxTabsPageView>;
        }));
    }

    protected processLocationSettingsLocation_GetTabsPageView(response: HttpResponseBase): Observable<ResultDataOfRaxTabsPageView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfRaxTabsPageView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfRaxTabsPageView>(null as any);
    }

    locationSettingsMarketing_Patch(posSettingsId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationSettingsMarketing/Patch?";
        if (posSettingsId === undefined)
            throw new Error("The parameter 'posSettingsId' must be defined.");
        else if(posSettingsId !== null)
            url_ += "posSettingsId=" + encodeURIComponent("" + posSettingsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettingsMarketing_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettingsMarketing_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processLocationSettingsMarketing_Patch(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    locationSettingsMarketing_GetMarketingView(): Observable<ResultDataOfLocationSettingsMarketingView> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationSettingsMarketing/GetMarketingView";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettingsMarketing_GetMarketingView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettingsMarketing_GetMarketingView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfLocationSettingsMarketingView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfLocationSettingsMarketingView>;
        }));
    }

    protected processLocationSettingsMarketing_GetMarketingView(response: HttpResponseBase): Observable<ResultDataOfLocationSettingsMarketingView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfLocationSettingsMarketingView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfLocationSettingsMarketingView>(null as any);
    }

    locationSettingsMarketing_GetEmailMarketingView(): Observable<ResultDataOfLocationSettingsMarketingEmailMarketingView> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationSettingsMarketing/GetEmailMarketingView";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettingsMarketing_GetEmailMarketingView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettingsMarketing_GetEmailMarketingView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfLocationSettingsMarketingEmailMarketingView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfLocationSettingsMarketingEmailMarketingView>;
        }));
    }

    protected processLocationSettingsMarketing_GetEmailMarketingView(response: HttpResponseBase): Observable<ResultDataOfLocationSettingsMarketingEmailMarketingView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfLocationSettingsMarketingEmailMarketingView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfLocationSettingsMarketingEmailMarketingView>(null as any);
    }

    locationSettingsNoteList_Post(noteListFormData: LocationSettingsNoteListFormData): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationSettingsNoteList/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(noteListFormData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettingsNoteList_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettingsNoteList_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processLocationSettingsNoteList_Post(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    locationSettingsNoteList_Patch(noteListId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationSettingsNoteList/Patch?";
        if (noteListId === undefined)
            throw new Error("The parameter 'noteListId' must be defined.");
        else if(noteListId !== null)
            url_ += "noteListId=" + encodeURIComponent("" + noteListId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettingsNoteList_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettingsNoteList_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processLocationSettingsNoteList_Patch(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    locationSettingsNoteList_PatchObjects(objects: PatchObject[]): Observable<Result> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationSettingsNoteList/PatchObjects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(objects);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettingsNoteList_PatchObjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettingsNoteList_PatchObjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processLocationSettingsNoteList_PatchObjects(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    locationSettingsNoteList_Delete(noteListId: string | null): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationSettingsNoteList/Delete?";
        if (noteListId === undefined)
            throw new Error("The parameter 'noteListId' must be defined.");
        else if(noteListId !== null)
            url_ += "noteListId=" + encodeURIComponent("" + noteListId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettingsNoteList_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettingsNoteList_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processLocationSettingsNoteList_Delete(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    locationSettingsOverview_Post(overviewFormData: LocationSettingsOverviewFormData): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationSettingsOverview/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(overviewFormData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettingsOverview_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettingsOverview_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processLocationSettingsOverview_Post(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    locationSettingsOverview_Patch(overviewId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationSettingsOverview/Patch?";
        if (overviewId === undefined)
            throw new Error("The parameter 'overviewId' must be defined.");
        else if(overviewId !== null)
            url_ += "overviewId=" + encodeURIComponent("" + overviewId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettingsOverview_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettingsOverview_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processLocationSettingsOverview_Patch(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    locationSettingsOverview_PatchObjects(objects: PatchObject[]): Observable<Result> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationSettingsOverview/PatchObjects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(objects);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettingsOverview_PatchObjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettingsOverview_PatchObjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processLocationSettingsOverview_PatchObjects(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    locationSettingsOverview_Delete(overviewId: string | null): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationSettingsOverview/Delete?";
        if (overviewId === undefined)
            throw new Error("The parameter 'overviewId' must be defined.");
        else if(overviewId !== null)
            url_ += "overviewId=" + encodeURIComponent("" + overviewId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettingsOverview_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettingsOverview_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processLocationSettingsOverview_Delete(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    locationSettingsPayment_GetTabsPageView(): Observable<ResultDataOfRaxTabsPageView> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationSettingsPayment/GetTabsPageView";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettingsPayment_GetTabsPageView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettingsPayment_GetTabsPageView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfRaxTabsPageView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfRaxTabsPageView>;
        }));
    }

    protected processLocationSettingsPayment_GetTabsPageView(response: HttpResponseBase): Observable<ResultDataOfRaxTabsPageView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfRaxTabsPageView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfRaxTabsPageView>(null as any);
    }

    locationSettingsPayment_Patch(locationPaymentSettingsId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationSettingsPayment/Patch?";
        if (locationPaymentSettingsId === undefined)
            throw new Error("The parameter 'locationPaymentSettingsId' must be defined.");
        else if(locationPaymentSettingsId !== null)
            url_ += "locationPaymentSettingsId=" + encodeURIComponent("" + locationPaymentSettingsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettingsPayment_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettingsPayment_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processLocationSettingsPayment_Patch(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    locationSettingsPeriodConfig_Patch(periodConfigId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationSettingsPeriodConfig/Patch?";
        if (periodConfigId === undefined)
            throw new Error("The parameter 'periodConfigId' must be defined.");
        else if(periodConfigId !== null)
            url_ += "periodConfigId=" + encodeURIComponent("" + periodConfigId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettingsPeriodConfig_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettingsPeriodConfig_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processLocationSettingsPeriodConfig_Patch(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    locationSettingsPeriodConfig_PatchOpeningHourConfig(openingHourConfigId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationSettingsPeriodConfig/PatchOpeningHourConfig?";
        if (openingHourConfigId === undefined)
            throw new Error("The parameter 'openingHourConfigId' must be defined.");
        else if(openingHourConfigId !== null)
            url_ += "openingHourConfigId=" + encodeURIComponent("" + openingHourConfigId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettingsPeriodConfig_PatchOpeningHourConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettingsPeriodConfig_PatchOpeningHourConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processLocationSettingsPeriodConfig_PatchOpeningHourConfig(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    locationSettingsPos_Patch(posSettingsId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationSettingsPos/Patch?";
        if (posSettingsId === undefined)
            throw new Error("The parameter 'posSettingsId' must be defined.");
        else if(posSettingsId !== null)
            url_ += "posSettingsId=" + encodeURIComponent("" + posSettingsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettingsPos_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettingsPos_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processLocationSettingsPos_Patch(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    locationSettingsPos_GetEditItemView(): Observable<ResultDataOfLocationSettingsPosEditItemView> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationSettingsPos/GetEditItemView";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettingsPos_GetEditItemView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettingsPos_GetEditItemView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfLocationSettingsPosEditItemView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfLocationSettingsPosEditItemView>;
        }));
    }

    protected processLocationSettingsPos_GetEditItemView(response: HttpResponseBase): Observable<ResultDataOfLocationSettingsPosEditItemView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfLocationSettingsPosEditItemView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfLocationSettingsPosEditItemView>(null as any);
    }

    locationSettingsPos_GetPosSystemConfigPickerDialogView(): Observable<ResultDataOfPosSystemConfigPickerDialogView> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationSettingsPos/GetPosSystemConfigPickerDialogView";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettingsPos_GetPosSystemConfigPickerDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettingsPos_GetPosSystemConfigPickerDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfPosSystemConfigPickerDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfPosSystemConfigPickerDialogView>;
        }));
    }

    protected processLocationSettingsPos_GetPosSystemConfigPickerDialogView(response: HttpResponseBase): Observable<ResultDataOfPosSystemConfigPickerDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfPosSystemConfigPickerDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfPosSystemConfigPickerDialogView>(null as any);
    }

    locationSettingsPos_GetDefaultSystemConfig(posSystemId: string | null, posSystemVersionId: string | null): Observable<ResultDataOfPosSystemConfig> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationSettingsPos/GetDefaultSystemConfig?";
        if (posSystemId === undefined)
            throw new Error("The parameter 'posSystemId' must be defined.");
        else if(posSystemId !== null)
            url_ += "posSystemId=" + encodeURIComponent("" + posSystemId) + "&";
        if (posSystemVersionId === undefined)
            throw new Error("The parameter 'posSystemVersionId' must be defined.");
        else if(posSystemVersionId !== null)
            url_ += "posSystemVersionId=" + encodeURIComponent("" + posSystemVersionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettingsPos_GetDefaultSystemConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettingsPos_GetDefaultSystemConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfPosSystemConfig>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfPosSystemConfig>;
        }));
    }

    protected processLocationSettingsPos_GetDefaultSystemConfig(response: HttpResponseBase): Observable<ResultDataOfPosSystemConfig> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfPosSystemConfig;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfPosSystemConfig>(null as any);
    }

    locationSettingsPos_ValidatePosSystemConfig(validationRequest: PosSystemConfigValidationRequestDto): Observable<Result> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationSettingsPos/ValidatePosSystemConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(validationRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettingsPos_ValidatePosSystemConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettingsPos_ValidatePosSystemConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processLocationSettingsPos_ValidatePosSystemConfig(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    locationSettingsResourceConfig_Patch(resourceConfigId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationSettingsResourceConfig/Patch?";
        if (resourceConfigId === undefined)
            throw new Error("The parameter 'resourceConfigId' must be defined.");
        else if(resourceConfigId !== null)
            url_ += "resourceConfigId=" + encodeURIComponent("" + resourceConfigId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettingsResourceConfig_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettingsResourceConfig_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processLocationSettingsResourceConfig_Patch(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    locationSettingsResourceConfig_GetTabsPageView(): Observable<ResultDataOfRaxTabsPageView> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationSettingsResourceConfig/GetTabsPageView";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettingsResourceConfig_GetTabsPageView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettingsResourceConfig_GetTabsPageView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfRaxTabsPageView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfRaxTabsPageView>;
        }));
    }

    protected processLocationSettingsResourceConfig_GetTabsPageView(response: HttpResponseBase): Observable<ResultDataOfRaxTabsPageView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfRaxTabsPageView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfRaxTabsPageView>(null as any);
    }

    locationSettingsScheduleBoard_Post(scheduleBoard: LocationSettingsScheduleBoardPostRequest): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationSettingsScheduleBoard/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(scheduleBoard);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettingsScheduleBoard_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettingsScheduleBoard_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processLocationSettingsScheduleBoard_Post(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    locationSettingsScheduleBoard_Patch(scheduleBoardId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationSettingsScheduleBoard/Patch?";
        if (scheduleBoardId === undefined)
            throw new Error("The parameter 'scheduleBoardId' must be defined.");
        else if(scheduleBoardId !== null)
            url_ += "scheduleBoardId=" + encodeURIComponent("" + scheduleBoardId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettingsScheduleBoard_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettingsScheduleBoard_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processLocationSettingsScheduleBoard_Patch(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    locationSettingsScheduleBoard_PatchObjects(objects: PatchObject[]): Observable<Result> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationSettingsScheduleBoard/PatchObjects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(objects);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettingsScheduleBoard_PatchObjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettingsScheduleBoard_PatchObjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processLocationSettingsScheduleBoard_PatchObjects(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    locationSettingsScheduleBoard_Delete(scheduleBoardId: string | null): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationSettingsScheduleBoard/Delete?";
        if (scheduleBoardId === undefined)
            throw new Error("The parameter 'scheduleBoardId' must be defined.");
        else if(scheduleBoardId !== null)
            url_ += "scheduleBoardId=" + encodeURIComponent("" + scheduleBoardId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettingsScheduleBoard_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettingsScheduleBoard_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processLocationSettingsScheduleBoard_Delete(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    locationSettingsScheduleBoard_GetItemTabsPageView(scheduleBoardId: string | null): Observable<ResultDataOfRaxTabsPageView> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationSettingsScheduleBoard/GetItemTabsPageView?";
        if (scheduleBoardId === undefined)
            throw new Error("The parameter 'scheduleBoardId' must be defined.");
        else if(scheduleBoardId !== null)
            url_ += "scheduleBoardId=" + encodeURIComponent("" + scheduleBoardId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettingsScheduleBoard_GetItemTabsPageView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettingsScheduleBoard_GetItemTabsPageView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfRaxTabsPageView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfRaxTabsPageView>;
        }));
    }

    protected processLocationSettingsScheduleBoard_GetItemTabsPageView(response: HttpResponseBase): Observable<ResultDataOfRaxTabsPageView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfRaxTabsPageView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfRaxTabsPageView>(null as any);
    }

    locationSettingsScheduleBoard_GetAddDialogView(): Observable<ResultDataOfLocationSettingsScheduleBoardAddDialogView> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationSettingsScheduleBoard/GetAddDialogView";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettingsScheduleBoard_GetAddDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettingsScheduleBoard_GetAddDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfLocationSettingsScheduleBoardAddDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfLocationSettingsScheduleBoardAddDialogView>;
        }));
    }

    protected processLocationSettingsScheduleBoard_GetAddDialogView(response: HttpResponseBase): Observable<ResultDataOfLocationSettingsScheduleBoardAddDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfLocationSettingsScheduleBoardAddDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfLocationSettingsScheduleBoardAddDialogView>(null as any);
    }

    locationSettingsScheduleBoard_GetViewModeOptionEditDialogView(viewModeOption?: ScheduleBoardGridViewModeOptions | undefined): Observable<ResultDataOfLocationSettingsScheduleBoardGridViewModeOptionEditDialogView> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationSettingsScheduleBoard/GetViewModeOptionEditDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModeOption);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettingsScheduleBoard_GetViewModeOptionEditDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettingsScheduleBoard_GetViewModeOptionEditDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfLocationSettingsScheduleBoardGridViewModeOptionEditDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfLocationSettingsScheduleBoardGridViewModeOptionEditDialogView>;
        }));
    }

    protected processLocationSettingsScheduleBoard_GetViewModeOptionEditDialogView(response: HttpResponseBase): Observable<ResultDataOfLocationSettingsScheduleBoardGridViewModeOptionEditDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfLocationSettingsScheduleBoardGridViewModeOptionEditDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfLocationSettingsScheduleBoardGridViewModeOptionEditDialogView>(null as any);
    }

    locationSettingsSurveyQuestion_Post(surveyQuestionFormData: SurveyQuestionFormData): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationSettingsSurveyQuestion/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(surveyQuestionFormData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettingsSurveyQuestion_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettingsSurveyQuestion_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processLocationSettingsSurveyQuestion_Post(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    locationSettingsSurveyQuestion_Patch(surveyQuestionId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationSettingsSurveyQuestion/Patch?";
        if (surveyQuestionId === undefined)
            throw new Error("The parameter 'surveyQuestionId' must be defined.");
        else if(surveyQuestionId !== null)
            url_ += "surveyQuestionId=" + encodeURIComponent("" + surveyQuestionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettingsSurveyQuestion_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettingsSurveyQuestion_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processLocationSettingsSurveyQuestion_Patch(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    locationSettingsSurveyQuestion_Delete(surveyQuestionId: string | null): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationSettingsSurveyQuestion/Delete?";
        if (surveyQuestionId === undefined)
            throw new Error("The parameter 'surveyQuestionId' must be defined.");
        else if(surveyQuestionId !== null)
            url_ += "surveyQuestionId=" + encodeURIComponent("" + surveyQuestionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettingsSurveyQuestion_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettingsSurveyQuestion_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processLocationSettingsSurveyQuestion_Delete(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    locationSettingsUnit_Post(unit: LocationSettingsUnitFormData): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationSettingsUnit/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(unit);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettingsUnit_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettingsUnit_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processLocationSettingsUnit_Post(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    locationSettingsUnit_Patch(unitId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationSettingsUnit/Patch?";
        if (unitId === undefined)
            throw new Error("The parameter 'unitId' must be defined.");
        else if(unitId !== null)
            url_ += "unitId=" + encodeURIComponent("" + unitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettingsUnit_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettingsUnit_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processLocationSettingsUnit_Patch(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    locationSettingsUnit_Delete(unitId: string | null): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/LocationSettingsUnit/Delete?";
        if (unitId === undefined)
            throw new Error("The parameter 'unitId' must be defined.");
        else if(unitId !== null)
            url_ += "unitId=" + encodeURIComponent("" + unitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processLocationSettingsUnit_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLocationSettingsUnit_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processLocationSettingsUnit_Delete(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    note_Post(note: NotePostRequest): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/Note/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(note);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processNote_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNote_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processNote_Post(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    note_Patch(noteId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/Note/Patch?";
        if (noteId === undefined)
            throw new Error("The parameter 'noteId' must be defined.");
        else if(noteId !== null)
            url_ += "noteId=" + encodeURIComponent("" + noteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processNote_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNote_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processNote_Patch(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    note_Delete(noteId: string | null): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/Note/Delete?";
        if (noteId === undefined)
            throw new Error("The parameter 'noteId' must be defined.");
        else if(noteId !== null)
            url_ += "noteId=" + encodeURIComponent("" + noteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processNote_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNote_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processNote_Delete(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    note_GetNoteTaskAddDialogView(dialogOptions: NoteTaskAddDialogOptions): Observable<ResultDataOfNoteAddDialogView> {
        let url_ = this.baseUrl + "/api/tenant/location/Note/GetNoteTaskAddDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dialogOptions);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processNote_GetNoteTaskAddDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNote_GetNoteTaskAddDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfNoteAddDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfNoteAddDialogView>;
        }));
    }

    protected processNote_GetNoteTaskAddDialogView(response: HttpResponseBase): Observable<ResultDataOfNoteAddDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfNoteAddDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfNoteAddDialogView>(null as any);
    }

    note_GetNoteAddDialogView(dialogOptions: NoteAddDialogOptions): Observable<ResultDataOfNoteAddDialogView> {
        let url_ = this.baseUrl + "/api/tenant/location/Note/GetNoteAddDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dialogOptions);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processNote_GetNoteAddDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNote_GetNoteAddDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfNoteAddDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfNoteAddDialogView>;
        }));
    }

    protected processNote_GetNoteAddDialogView(response: HttpResponseBase): Observable<ResultDataOfNoteAddDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfNoteAddDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfNoteAddDialogView>(null as any);
    }

    platformConfig_Post(platformConfig: PlatformConfigPostRequest): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/PlatformConfig/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(platformConfig);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPlatformConfig_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPlatformConfig_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processPlatformConfig_Post(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    platformConfig_Patch(platformConfigId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/PlatformConfig/Patch?";
        if (platformConfigId === undefined)
            throw new Error("The parameter 'platformConfigId' must be defined.");
        else if(platformConfigId !== null)
            url_ += "platformConfigId=" + encodeURIComponent("" + platformConfigId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPlatformConfig_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPlatformConfig_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processPlatformConfig_Patch(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    platformConfig_PatchObjects(objects: PatchObject[]): Observable<Result> {
        let url_ = this.baseUrl + "/api/PlatformConfig/PatchObjects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(objects);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPlatformConfig_PatchObjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPlatformConfig_PatchObjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processPlatformConfig_PatchObjects(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    platformConfig_Delete(platformConfigId: string | null): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/PlatformConfig/Delete?";
        if (platformConfigId === undefined)
            throw new Error("The parameter 'platformConfigId' must be defined.");
        else if(platformConfigId !== null)
            url_ += "platformConfigId=" + encodeURIComponent("" + platformConfigId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPlatformConfig_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPlatformConfig_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processPlatformConfig_Delete(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    platformConfig_SetActive(platformConfigId: string | null): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/PlatformConfig/SetActive?";
        if (platformConfigId === undefined)
            throw new Error("The parameter 'platformConfigId' must be defined.");
        else if(platformConfigId !== null)
            url_ += "platformConfigId=" + encodeURIComponent("" + platformConfigId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPlatformConfig_SetActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPlatformConfig_SetActive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processPlatformConfig_SetActive(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    platformConfig_GetAddDialogView(sourcePlatformConfigId?: string | null | undefined, sourcePlatformName?: string | null | undefined): Observable<ResultDataOfPlatformConfigAddDialogView> {
        let url_ = this.baseUrl + "/api/PlatformConfig/GetAddDialogView?";
        if (sourcePlatformConfigId !== undefined && sourcePlatformConfigId !== null)
            url_ += "sourcePlatformConfigId=" + encodeURIComponent("" + sourcePlatformConfigId) + "&";
        if (sourcePlatformName !== undefined && sourcePlatformName !== null)
            url_ += "sourcePlatformName=" + encodeURIComponent("" + sourcePlatformName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPlatformConfig_GetAddDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPlatformConfig_GetAddDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfPlatformConfigAddDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfPlatformConfigAddDialogView>;
        }));
    }

    protected processPlatformConfig_GetAddDialogView(response: HttpResponseBase): Observable<ResultDataOfPlatformConfigAddDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfPlatformConfigAddDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfPlatformConfigAddDialogView>(null as any);
    }

    platformConfig_GetEditItemView(platformConfigId: string | null): Observable<ResultDataOfPlatformConfigEditItemView> {
        let url_ = this.baseUrl + "/api/PlatformConfig/GetEditItemView?";
        if (platformConfigId === undefined)
            throw new Error("The parameter 'platformConfigId' must be defined.");
        else if(platformConfigId !== null)
            url_ += "platformConfigId=" + encodeURIComponent("" + platformConfigId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPlatformConfig_GetEditItemView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPlatformConfig_GetEditItemView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfPlatformConfigEditItemView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfPlatformConfigEditItemView>;
        }));
    }

    protected processPlatformConfig_GetEditItemView(response: HttpResponseBase): Observable<ResultDataOfPlatformConfigEditItemView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfPlatformConfigEditItemView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfPlatformConfigEditItemView>(null as any);
    }

    platformConfig_GetEditItemPlannerView(platformConfigId: string | null): Observable<ResultDataOfPlatformConfigEditItemPlannerView> {
        let url_ = this.baseUrl + "/api/PlatformConfig/GetEditItemPlannerView?";
        if (platformConfigId === undefined)
            throw new Error("The parameter 'platformConfigId' must be defined.");
        else if(platformConfigId !== null)
            url_ += "platformConfigId=" + encodeURIComponent("" + platformConfigId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPlatformConfig_GetEditItemPlannerView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPlatformConfig_GetEditItemPlannerView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfPlatformConfigEditItemPlannerView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfPlatformConfigEditItemPlannerView>;
        }));
    }

    protected processPlatformConfig_GetEditItemPlannerView(response: HttpResponseBase): Observable<ResultDataOfPlatformConfigEditItemPlannerView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfPlatformConfigEditItemPlannerView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfPlatformConfigEditItemPlannerView>(null as any);
    }

    platformConfig_GetPlannerMenuItemEditDialogView(menuItem?: MainPlannerNavMenuItem | undefined, isMainMenuItem?: boolean | undefined): Observable<ResultDataOfPlatformPlannerMenuItemEditDialogView> {
        let url_ = this.baseUrl + "/api/PlatformConfig/GetPlannerMenuItemEditDialogView?";
        if (isMainMenuItem === null)
            throw new Error("The parameter 'isMainMenuItem' cannot be null.");
        else if (isMainMenuItem !== undefined)
            url_ += "isMainMenuItem=" + encodeURIComponent("" + isMainMenuItem) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(menuItem);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPlatformConfig_GetPlannerMenuItemEditDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPlatformConfig_GetPlannerMenuItemEditDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfPlatformPlannerMenuItemEditDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfPlatformPlannerMenuItemEditDialogView>;
        }));
    }

    protected processPlatformConfig_GetPlannerMenuItemEditDialogView(response: HttpResponseBase): Observable<ResultDataOfPlatformPlannerMenuItemEditDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfPlatformPlannerMenuItemEditDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfPlatformPlannerMenuItemEditDialogView>(null as any);
    }

    platformConfig_GetEditItemFeatureFlagView(platformConfigId: string | null): Observable<ResultDataOfPlatformConfigEditItemFeatureFlagView> {
        let url_ = this.baseUrl + "/api/PlatformConfig/GetEditItemFeatureFlagView?";
        if (platformConfigId === undefined)
            throw new Error("The parameter 'platformConfigId' must be defined.");
        else if(platformConfigId !== null)
            url_ += "platformConfigId=" + encodeURIComponent("" + platformConfigId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPlatformConfig_GetEditItemFeatureFlagView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPlatformConfig_GetEditItemFeatureFlagView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfPlatformConfigEditItemFeatureFlagView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfPlatformConfigEditItemFeatureFlagView>;
        }));
    }

    protected processPlatformConfig_GetEditItemFeatureFlagView(response: HttpResponseBase): Observable<ResultDataOfPlatformConfigEditItemFeatureFlagView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfPlatformConfigEditItemFeatureFlagView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfPlatformConfigEditItemFeatureFlagView>(null as any);
    }

    platformConfig_GetEditItemSecurityView(platformConfigId: string | null): Observable<ResultDataOfPlatformConfigEditItemSecurityView> {
        let url_ = this.baseUrl + "/api/PlatformConfig/GetEditItemSecurityView?";
        if (platformConfigId === undefined)
            throw new Error("The parameter 'platformConfigId' must be defined.");
        else if(platformConfigId !== null)
            url_ += "platformConfigId=" + encodeURIComponent("" + platformConfigId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPlatformConfig_GetEditItemSecurityView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPlatformConfig_GetEditItemSecurityView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfPlatformConfigEditItemSecurityView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfPlatformConfigEditItemSecurityView>;
        }));
    }

    protected processPlatformConfig_GetEditItemSecurityView(response: HttpResponseBase): Observable<ResultDataOfPlatformConfigEditItemSecurityView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfPlatformConfigEditItemSecurityView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfPlatformConfigEditItemSecurityView>(null as any);
    }

    platformConfig_GetSecurityTopicEditDialogView(topic?: PlatformSecurityTopic | undefined): Observable<ResultDataOfPlatformSecurityTopicEditDialogView> {
        let url_ = this.baseUrl + "/api/PlatformConfig/GetSecurityTopicEditDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(topic);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPlatformConfig_GetSecurityTopicEditDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPlatformConfig_GetSecurityTopicEditDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfPlatformSecurityTopicEditDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfPlatformSecurityTopicEditDialogView>;
        }));
    }

    protected processPlatformConfig_GetSecurityTopicEditDialogView(response: HttpResponseBase): Observable<ResultDataOfPlatformSecurityTopicEditDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfPlatformSecurityTopicEditDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfPlatformSecurityTopicEditDialogView>(null as any);
    }

    platformConfig_GetSecurityActionEditDialogView(action?: PlatformSecurityAction | undefined, parentKey?: string | null | undefined): Observable<ResultDataOfPlatformSecurityActionEditDialogView> {
        let url_ = this.baseUrl + "/api/PlatformConfig/GetSecurityActionEditDialogView?";
        if (parentKey !== undefined && parentKey !== null)
            url_ += "parentKey=" + encodeURIComponent("" + parentKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(action);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPlatformConfig_GetSecurityActionEditDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPlatformConfig_GetSecurityActionEditDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfPlatformSecurityActionEditDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfPlatformSecurityActionEditDialogView>;
        }));
    }

    protected processPlatformConfig_GetSecurityActionEditDialogView(response: HttpResponseBase): Observable<ResultDataOfPlatformSecurityActionEditDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfPlatformSecurityActionEditDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfPlatformSecurityActionEditDialogView>(null as any);
    }

    platformConfig_GetSecurityRoleEditDialogView(role?: PlatformSecurityRole | undefined): Observable<ResultDataOfPlatformSecurityRoleEditDialogView> {
        let url_ = this.baseUrl + "/api/PlatformConfig/GetSecurityRoleEditDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(role);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPlatformConfig_GetSecurityRoleEditDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPlatformConfig_GetSecurityRoleEditDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfPlatformSecurityRoleEditDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfPlatformSecurityRoleEditDialogView>;
        }));
    }

    protected processPlatformConfig_GetSecurityRoleEditDialogView(response: HttpResponseBase): Observable<ResultDataOfPlatformSecurityRoleEditDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfPlatformSecurityRoleEditDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfPlatformSecurityRoleEditDialogView>(null as any);
    }

    platformConfig_GetSecurityGroupEditDialogView(group?: PlatformSecurityGroup | undefined): Observable<ResultDataOfPlatformSecurityGroupEditDialogView> {
        let url_ = this.baseUrl + "/api/PlatformConfig/GetSecurityGroupEditDialogView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(group);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPlatformConfig_GetSecurityGroupEditDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPlatformConfig_GetSecurityGroupEditDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfPlatformSecurityGroupEditDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfPlatformSecurityGroupEditDialogView>;
        }));
    }

    protected processPlatformConfig_GetSecurityGroupEditDialogView(response: HttpResponseBase): Observable<ResultDataOfPlatformSecurityGroupEditDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfPlatformSecurityGroupEditDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfPlatformSecurityGroupEditDialogView>(null as any);
    }

    platformDebug_GetLocationInfo(locationId: string | null): Observable<ResultDataOfLocationInfo> {
        let url_ = this.baseUrl + "/api/PlatformDebug/GetLocationInfo?";
        if (locationId === undefined)
            throw new Error("The parameter 'locationId' must be defined.");
        else if(locationId !== null)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPlatformDebug_GetLocationInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPlatformDebug_GetLocationInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfLocationInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfLocationInfo>;
        }));
    }

    protected processPlatformDebug_GetLocationInfo(response: HttpResponseBase): Observable<ResultDataOfLocationInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfLocationInfo;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfLocationInfo>(null as any);
    }

    platformDebug_GetTenantInfo(tenantId: string | null): Observable<ResultDataOfTenantInfo> {
        let url_ = this.baseUrl + "/api/PlatformDebug/GetTenantInfo?";
        if (tenantId === undefined)
            throw new Error("The parameter 'tenantId' must be defined.");
        else if(tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPlatformDebug_GetTenantInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPlatformDebug_GetTenantInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfTenantInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfTenantInfo>;
        }));
    }

    protected processPlatformDebug_GetTenantInfo(response: HttpResponseBase): Observable<ResultDataOfTenantInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfTenantInfo;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfTenantInfo>(null as any);
    }

    posArticleConfig_Sync(): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/PosArticleConfig/Sync";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPosArticleConfig_Sync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosArticleConfig_Sync(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processPosArticleConfig_Sync(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    posArticleConfig_Patch(posArticleConfigId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/PosArticleConfig/Patch?";
        if (posArticleConfigId === undefined)
            throw new Error("The parameter 'posArticleConfigId' must be defined.");
        else if(posArticleConfigId !== null)
            url_ += "posArticleConfigId=" + encodeURIComponent("" + posArticleConfigId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPosArticleConfig_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosArticleConfig_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processPosArticleConfig_Patch(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    posArticleConfig_Delete(posArticleConfigId: string | null): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/PosArticleConfig/Delete?";
        if (posArticleConfigId === undefined)
            throw new Error("The parameter 'posArticleConfigId' must be defined.");
        else if(posArticleConfigId !== null)
            url_ += "posArticleConfigId=" + encodeURIComponent("" + posArticleConfigId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPosArticleConfig_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosArticleConfig_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processPosArticleConfig_Delete(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    posArticleConfig_SetActive(posArticleConfigId: string | null): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/PosArticleConfig/SetActive?";
        if (posArticleConfigId === undefined)
            throw new Error("The parameter 'posArticleConfigId' must be defined.");
        else if(posArticleConfigId !== null)
            url_ += "posArticleConfigId=" + encodeURIComponent("" + posArticleConfigId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processPosArticleConfig_SetActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPosArticleConfig_SetActive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processPosArticleConfig_SetActive(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    product_Post(product: ProductPostRequest): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/Product/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(product);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processProduct_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProduct_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processProduct_Post(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    product_Patch(productId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/Product/Patch?";
        if (productId === undefined)
            throw new Error("The parameter 'productId' must be defined.");
        else if(productId !== null)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processProduct_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProduct_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processProduct_Patch(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    product_PatchObjects(objects: PatchObject[]): Observable<Result> {
        let url_ = this.baseUrl + "/api/tenant/location/Product/PatchObjects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(objects);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processProduct_PatchObjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProduct_PatchObjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processProduct_PatchObjects(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    product_Delete(productId: string | null): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/Product/Delete?";
        if (productId === undefined)
            throw new Error("The parameter 'productId' must be defined.");
        else if(productId !== null)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processProduct_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProduct_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processProduct_Delete(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    program_Post(program: ProgramPostRequest): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/Program/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(program);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processProgram_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProgram_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processProgram_Post(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    program_Patch(programId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/Program/Patch?";
        if (programId === undefined)
            throw new Error("The parameter 'programId' must be defined.");
        else if(programId !== null)
            url_ += "programId=" + encodeURIComponent("" + programId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processProgram_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProgram_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processProgram_Patch(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    program_PatchObjects(objects: PatchObject[]): Observable<Result> {
        let url_ = this.baseUrl + "/api/tenant/location/Program/PatchObjects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(objects);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processProgram_PatchObjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProgram_PatchObjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processProgram_PatchObjects(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    program_Delete(programId: string | null): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/Program/Delete?";
        if (programId === undefined)
            throw new Error("The parameter 'programId' must be defined.");
        else if(programId !== null)
            url_ += "programId=" + encodeURIComponent("" + programId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processProgram_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProgram_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processProgram_Delete(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    program_GetAddDialogView(): Observable<ResultDataOfProgramAddDialogView> {
        let url_ = this.baseUrl + "/api/tenant/location/Program/GetAddDialogView";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processProgram_GetAddDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProgram_GetAddDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfProgramAddDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfProgramAddDialogView>;
        }));
    }

    protected processProgram_GetAddDialogView(response: HttpResponseBase): Observable<ResultDataOfProgramAddDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfProgramAddDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfProgramAddDialogView>(null as any);
    }

    program_GetEditItemView(programId: string | null): Observable<ResultDataOfProgramEditItemView> {
        let url_ = this.baseUrl + "/api/tenant/location/Program/GetEditItemView?";
        if (programId === undefined)
            throw new Error("The parameter 'programId' must be defined.");
        else if(programId !== null)
            url_ += "programId=" + encodeURIComponent("" + programId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processProgram_GetEditItemView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProgram_GetEditItemView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfProgramEditItemView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfProgramEditItemView>;
        }));
    }

    protected processProgram_GetEditItemView(response: HttpResponseBase): Observable<ResultDataOfProgramEditItemView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfProgramEditItemView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfProgramEditItemView>(null as any);
    }

    program_GetEditItemProgramStepsView(programId: string | null): Observable<ResultDataOfProgramEditItemProgramStepsView> {
        let url_ = this.baseUrl + "/api/tenant/location/Program/GetEditItemProgramStepsView?";
        if (programId === undefined)
            throw new Error("The parameter 'programId' must be defined.");
        else if(programId !== null)
            url_ += "programId=" + encodeURIComponent("" + programId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processProgram_GetEditItemProgramStepsView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProgram_GetEditItemProgramStepsView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfProgramEditItemProgramStepsView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfProgramEditItemProgramStepsView>;
        }));
    }

    protected processProgram_GetEditItemProgramStepsView(response: HttpResponseBase): Observable<ResultDataOfProgramEditItemProgramStepsView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfProgramEditItemProgramStepsView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfProgramEditItemProgramStepsView>(null as any);
    }

    programGroup_Post(programGroup: ProgramGroupPostRequest): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/ProgramGroup/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(programGroup);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processProgramGroup_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProgramGroup_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processProgramGroup_Post(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    programGroup_Patch(programGroupId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/ProgramGroup/Patch?";
        if (programGroupId === undefined)
            throw new Error("The parameter 'programGroupId' must be defined.");
        else if(programGroupId !== null)
            url_ += "programGroupId=" + encodeURIComponent("" + programGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processProgramGroup_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProgramGroup_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processProgramGroup_Patch(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    programGroup_PatchObjects(objects: PatchObject[]): Observable<Result> {
        let url_ = this.baseUrl + "/api/tenant/location/ProgramGroup/PatchObjects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(objects);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processProgramGroup_PatchObjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProgramGroup_PatchObjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processProgramGroup_PatchObjects(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    programGroup_Delete(programGroupId: string | null): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/ProgramGroup/Delete?";
        if (programGroupId === undefined)
            throw new Error("The parameter 'programGroupId' must be defined.");
        else if(programGroupId !== null)
            url_ += "programGroupId=" + encodeURIComponent("" + programGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processProgramGroup_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProgramGroup_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processProgramGroup_Delete(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    programStep_Post(programStep: ProgramStepPostRequest): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/ProgramStep/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(programStep);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processProgramStep_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProgramStep_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processProgramStep_Post(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    programStep_Patch(programStepId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/ProgramStep/Patch?";
        if (programStepId === undefined)
            throw new Error("The parameter 'programStepId' must be defined.");
        else if(programStepId !== null)
            url_ += "programStepId=" + encodeURIComponent("" + programStepId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processProgramStep_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProgramStep_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processProgramStep_Patch(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    programStep_PatchObjects(objects: PatchObject[]): Observable<Result> {
        let url_ = this.baseUrl + "/api/tenant/location/ProgramStep/PatchObjects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(objects);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processProgramStep_PatchObjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProgramStep_PatchObjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Result>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Result>;
        }));
    }

    protected processProgramStep_PatchObjects(response: HttpResponseBase): Observable<Result> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Result;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Result>(null as any);
    }

    programStep_Delete(programStepId: string | null): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/ProgramStep/Delete?";
        if (programStepId === undefined)
            throw new Error("The parameter 'programStepId' must be defined.");
        else if(programStepId !== null)
            url_ += "programStepId=" + encodeURIComponent("" + programStepId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processProgramStep_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProgramStep_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processProgramStep_Delete(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    programStep_GetAddDialogView(): Observable<ResultDataOfProgramStepAddDialogView> {
        let url_ = this.baseUrl + "/api/tenant/location/ProgramStep/GetAddDialogView";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processProgramStep_GetAddDialogView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProgramStep_GetAddDialogView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfProgramStepAddDialogView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfProgramStepAddDialogView>;
        }));
    }

    protected processProgramStep_GetAddDialogView(response: HttpResponseBase): Observable<ResultDataOfProgramStepAddDialogView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfProgramStepAddDialogView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfProgramStepAddDialogView>(null as any);
    }

    programStep_GetEditItemView(programStepId: string | null): Observable<ResultDataOfProgramStepEditItemView> {
        let url_ = this.baseUrl + "/api/tenant/location/ProgramStep/GetEditItemView?";
        if (programStepId === undefined)
            throw new Error("The parameter 'programStepId' must be defined.");
        else if(programStepId !== null)
            url_ += "programStepId=" + encodeURIComponent("" + programStepId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processProgramStep_GetEditItemView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProgramStep_GetEditItemView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfProgramStepEditItemView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfProgramStepEditItemView>;
        }));
    }

    protected processProgramStep_GetEditItemView(response: HttpResponseBase): Observable<ResultDataOfProgramStepEditItemView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfProgramStepEditItemView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfProgramStepEditItemView>(null as any);
    }

    programStep_GetEditItemSurveyView(programStepId: string | null): Observable<ResultDataOfProgramStepEditItemSurveyView> {
        let url_ = this.baseUrl + "/api/tenant/location/ProgramStep/GetEditItemSurveyView?";
        if (programStepId === undefined)
            throw new Error("The parameter 'programStepId' must be defined.");
        else if(programStepId !== null)
            url_ += "programStepId=" + encodeURIComponent("" + programStepId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processProgramStep_GetEditItemSurveyView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProgramStep_GetEditItemSurveyView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfProgramStepEditItemSurveyView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfProgramStepEditItemSurveyView>;
        }));
    }

    protected processProgramStep_GetEditItemSurveyView(response: HttpResponseBase): Observable<ResultDataOfProgramStepEditItemSurveyView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfProgramStepEditItemSurveyView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfProgramStepEditItemSurveyView>(null as any);
    }

    programStep_GetEditItemResourceView(programStepId: string | null): Observable<ResultDataOfProgramStepEditItemResourceView> {
        let url_ = this.baseUrl + "/api/tenant/location/ProgramStep/GetEditItemResourceView?";
        if (programStepId === undefined)
            throw new Error("The parameter 'programStepId' must be defined.");
        else if(programStepId !== null)
            url_ += "programStepId=" + encodeURIComponent("" + programStepId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processProgramStep_GetEditItemResourceView(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProgramStep_GetEditItemResourceView(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultDataOfProgramStepEditItemResourceView>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultDataOfProgramStepEditItemResourceView>;
        }));
    }

    protected processProgramStep_GetEditItemResourceView(response: HttpResponseBase): Observable<ResultDataOfProgramStepEditItemResourceView> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultDataOfProgramStepEditItemResourceView;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultDataOfProgramStepEditItemResourceView>(null as any);
    }

    rateCard_Post(relatedObjectType: string | null, relatedObjectId: string | null, rateCard: RateCardEditDialogItem): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/RateCard/Post?";
        if (relatedObjectType === undefined)
            throw new Error("The parameter 'relatedObjectType' must be defined.");
        else if(relatedObjectType !== null)
            url_ += "relatedObjectType=" + encodeURIComponent("" + relatedObjectType) + "&";
        if (relatedObjectId === undefined)
            throw new Error("The parameter 'relatedObjectId' must be defined.");
        else if(relatedObjectId !== null)
            url_ += "relatedObjectId=" + encodeURIComponent("" + relatedObjectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(rateCard);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRateCard_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRateCard_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processRateCard_Post(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    rateCard_Patch(rateCardId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/RateCard/Patch?";
        if (rateCardId === undefined)
            throw new Error("The parameter 'rateCardId' must be defined.");
        else if(rateCardId !== null)
            url_ += "rateCardId=" + encodeURIComponent("" + rateCardId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRateCard_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRateCard_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processRateCard_Patch(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    rateCard_Delete(rateCardId: string | null): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/RateCard/Delete?";
        if (rateCardId === undefined)
            throw new Error("The parameter 'rateCardId' must be defined.");
        else if(rateCardId !== null)
            url_ += "rateCardId=" + encodeURIComponent("" + rateCardId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRateCard_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRateCard_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processRateCard_Delete(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    rateCard_Duplicate(sourceRateCardId: string | null, newRateCardName: string | null): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/RateCard/Duplicate?";
        if (sourceRateCardId === undefined)
            throw new Error("The parameter 'sourceRateCardId' must be defined.");
        else if(sourceRateCardId !== null)
            url_ += "sourceRateCardId=" + encodeURIComponent("" + sourceRateCardId) + "&";
        if (newRateCardName === undefined)
            throw new Error("The parameter 'newRateCardName' must be defined.");
        else if(newRateCardName !== null)
            url_ += "newRateCardName=" + encodeURIComponent("" + newRateCardName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRateCard_Duplicate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRateCard_Duplicate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processRateCard_Duplicate(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    rateCard_SetActive(rateCardId: string | null): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/RateCard/SetActive?";
        if (rateCardId === undefined)
            throw new Error("The parameter 'rateCardId' must be defined.");
        else if(rateCardId !== null)
            url_ += "rateCardId=" + encodeURIComponent("" + rateCardId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("put", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRateCard_SetActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRateCard_SetActive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processRateCard_SetActive(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    rateCardPeriodConfig_Post(relatedObjectType: string | null, relatedObjectId: string | null): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/RateCardPeriodConfig/Post?";
        if (relatedObjectType === undefined)
            throw new Error("The parameter 'relatedObjectType' must be defined.");
        else if(relatedObjectType !== null)
            url_ += "relatedObjectType=" + encodeURIComponent("" + relatedObjectType) + "&";
        if (relatedObjectId === undefined)
            throw new Error("The parameter 'relatedObjectId' must be defined.");
        else if(relatedObjectId !== null)
            url_ += "relatedObjectId=" + encodeURIComponent("" + relatedObjectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRateCardPeriodConfig_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRateCardPeriodConfig_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processRateCardPeriodConfig_Post(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    rateCardPeriodConfig_Patch(rateCardPeriodConfigId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/RateCardPeriodConfig/Patch?";
        if (rateCardPeriodConfigId === undefined)
            throw new Error("The parameter 'rateCardPeriodConfigId' must be defined.");
        else if(rateCardPeriodConfigId !== null)
            url_ += "rateCardPeriodConfigId=" + encodeURIComponent("" + rateCardPeriodConfigId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRateCardPeriodConfig_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRateCardPeriodConfig_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processRateCardPeriodConfig_Patch(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    rateCardPeriodConfig_Delete(rateCardPeriodConfigId: string | null): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/tenant/location/RateCardPeriodConfig/Delete?";
        if (rateCardPeriodConfigId === undefined)
            throw new Error("The parameter 'rateCardPeriodConfigId' must be defined.");
        else if(rateCardPeriodConfigId !== null)
            url_ += "rateCardPeriodConfigId=" + encodeURIComponent("" + rateCardPeriodConfigId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processRateCardPeriodConfig_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRateCardPeriodConfig_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processRateCardPeriodConfig_Delete(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    tenant_Post(tenant: TenantEditItem): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/Tenant/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tenant);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processTenant_Post(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTenant_Post(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processTenant_Post(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    tenant_Patch(tenantId: string | null, operations: PatchOperation[]): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/Tenant/Patch?";
        if (tenantId === undefined)
            throw new Error("The parameter 'tenantId' must be defined.");
        else if(tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(operations);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("patch", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processTenant_Patch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTenant_Patch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processTenant_Patch(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    tenant_Delete(tenantId: string | null): Observable<ResultId> {
        let url_ = this.baseUrl + "/api/Tenant/Delete?";
        if (tenantId === undefined)
            throw new Error("The parameter 'tenantId' must be defined.");
        else if(tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("delete", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processTenant_Delete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTenant_Delete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResultId>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResultId>;
        }));
    }

    protected processTenant_Delete(response: HttpResponseBase): Observable<ResultId> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultId;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResultId>(null as any);
    }

    utils_GetGuid(): Observable<string> {
        let url_ = this.baseUrl + "/api/Utils/GetGuid";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.processUtils_GetGuid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUtils_GetGuid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUtils_GetGuid(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

export interface AddressLookupResult {
    addressFound?: boolean;
    postalCode?: string;
    buildingNumber?: string;
    street?: string;
    city?: string;
}

export interface GetAddressLookupQuery {
    postalCode?: string;
    buildingNumber?: string;
}

export interface GetLocationTranslationCoverageQueryResult {
    locationId?: string;
    defaultLocaleId?: string | undefined;
    locales?: GetLocationTranslationCoverageLocale[];
    fieldCoverages?: GetLocationTranslationCoverageField[];
    localeSummaries?: GetLocationTranslationCoverageLocaleSummary[];
}

export interface GetLocationTranslationCoverageLocale {
    localeId?: string;
    displayName?: string;
    isMandatory?: boolean;
    fallbackLocaleId?: string | undefined;
}

export interface GetLocationTranslationCoverageField {
    fieldRef?: LocalizedTextFieldRef;
    entityLabel?: string;
    kind?: LocalizedTextKind;
    maxLength?: number;
    isMultiline?: boolean;
    isDefault?: boolean;
    conceptLabel?: LocalizedStaticText;
    fieldLabel?: LocalizedStaticText;
    sortOrder?: number;
    isEditedInWorkbench?: boolean;
    valuesByLocaleId?: { [key: string]: LocalizedTextValue; };
    translatedLocaleIds?: string[];
    missingMandatoryLocales?: string[];
    missingOptionalLocales?: string[];
    fallsBackTo?: { [key: string]: string; };
}

export interface LocalizedTextFieldRef {
    context?: string;
    concept?: string;
    field?: string;
    entityKey?: { [key: string]: string; };
}

export enum LocalizedTextKind {
    Static = "Static",
    Pluralized = "Pluralized",
}

export interface LocalizedStaticText {
    values?: { [key: string]: string; };
}

export interface LocalizedTextValue {
    kind: string;
}

export interface StaticTextValue extends LocalizedTextValue {
    text?: string;
}

export interface PluralizedTextValue extends LocalizedTextValue {
    singular?: string;
    plural?: string;
}

export interface GetLocationTranslationCoverageLocaleSummary {
    localeId?: string;
    totalFields?: number;
    translatedFields?: number;
    missingMandatoryFields?: number;
    missingOptionalFields?: number;
}

export interface ApplyTranslationsCommandResult {
    outcomes?: TranslationEditOutcome[];
}

export interface TranslationEditOutcome {
    edit?: TranslationEdit;
    succeeded?: boolean;
    error?: string | undefined;
}

export interface TranslationEdit {
    fieldRef?: LocalizedTextFieldRef;
    localeId?: string;
    newValue?: LocalizedTextValue | undefined;
}

export interface ApplyTranslationsCommand {
    edits?: TranslationEdit[];
}

export interface WhatsAppConnection {
    isConfigured?: boolean;
    status?: WhatsAppConnectionStatus;
    wabaId?: string | undefined;
    phoneNumberId?: string | undefined;
    displayPhoneNumber?: string | undefined;
    verifiedBusinessName?: string | undefined;
    lastErrorStep?: WhatsAppSignupStep | undefined;
    lastError?: string | undefined;
    canRetrySignup?: boolean;
    connectedAt?: DateTime | undefined;
    updatedAt?: DateTime | undefined;
    templates?: WhatsAppTemplate[];
    testPhoneNumber?: string | undefined;
    isDisabledByMeta?: boolean;
    restrictionEndsAt?: DateTime | undefined;
}

export enum WhatsAppConnectionStatus {
    Disconnected = "Disconnected",
    Pending = "Pending",
    Connected = "Connected",
    Error = "Error",
}

export enum WhatsAppSignupStep {
    ExchangeCode = "ExchangeCode",
    SubscribeApp = "SubscribeApp",
    RegisterPhoneNumber = "RegisterPhoneNumber",
    ReadPhoneNumber = "ReadPhoneNumber",
}

export interface WhatsAppTemplate {
    kind?: string;
    kindLabel?: string;
    languageCode?: string;
    status?: WhatsAppTemplateStatus;
    reason?: string | undefined;
    lastError?: string | undefined;
    updatedAt?: DateTime;
}

export enum WhatsAppTemplateStatus {
    NotProvisioned = "NotProvisioned",
    Pending = "Pending",
    Approved = "Approved",
    Rejected = "Rejected",
    Paused = "Paused",
    Disabled = "Disabled",
}

export interface SetWhatsAppTestPhoneNumberCommand {
    phoneCountryCode?: string | undefined;
    phoneNationalNumber?: string | undefined;
}

export interface OutboundTextMessage {
    id?: string;
    channel?: TextChannel;
    kind?: string;
    subjectRef?: string | undefined;
    languageCode?: string;
    recipient?: string | undefined;
    redirectedTo?: string | undefined;
    templateName?: string | undefined;
    status?: OutboundTextMessageStatus;
    reason?: TextMessageReason | undefined;
    detail?: string | undefined;
    providerMessageId?: string | undefined;
    createdAt?: DateTime;
    sentAt?: DateTime | undefined;
    deliveredAt?: DateTime | undefined;
    readAt?: DateTime | undefined;
    attempts?: number;
    isTest?: boolean;
}

export enum TextChannel {
    WhatsApp = "WhatsApp",
}

export enum OutboundTextMessageStatus {
    Pending = "Pending",
    Sent = "Sent",
    Failed = "Failed",
    Skipped = "Skipped",
    Delivered = "Delivered",
    Read = "Read",
}

export enum TextMessageReason {
    UnknownKind = "UnknownKind",
    WhatsAppNotConnected = "WhatsAppNotConnected",
    AccountDisabled = "AccountDisabled",
    AccountRestricted = "AccountRestricted",
    TemplateNotApproved = "TemplateNotApproved",
    NoPhoneNumber = "NoPhoneNumber",
    RedirectNotConfigured = "RedirectNotConfigured",
    RenderError = "RenderError",
    TransportAuthentication = "TransportAuthentication",
    ProviderRejected = "ProviderRejected",
    ProviderUnavailable = "ProviderUnavailable",
    DeliveryFailed = "DeliveryFailed",
}

export interface SendTestTextMessageCommand {
    languageCode?: string | undefined;
    phoneCountryCode?: string | undefined;
    phoneNationalNumber?: string | undefined;
}

export interface RetryWhatsAppSignupCommand {
    pin?: string | undefined;
}

export interface GetWhatsAppSignupConfigQueryResult {
    isConfigured?: boolean;
    appId?: string | undefined;
    configId?: string | undefined;
    graphApiVersion?: string;
    isNonProduction?: boolean;
    deploymentTypeName?: string | undefined;
}

export interface GetRecentOutboundTextMessagesQueryResult {
    messages?: OutboundTextMessage[];
}

export interface GetRecentOutboundTextMessagesQuery {
    limit?: number;
}

export interface CompleteWhatsAppSignupCommand {
    code?: string;
    wabaId?: string;
    phoneNumberId?: string;
    pin?: string | undefined;
}

export interface GetTenantEditDialogViewQueryResult {
    tenantId?: string | undefined;
    dialogTitle?: string | undefined;
    input?: TenantEditDialogFormItem;
    output?: TenantEditDialogFormItem;
}

export interface TenantEditDialogFormItem {
    name?: string | undefined;
    idCode?: string | undefined;
}

export interface GetTenantEditDialogViewQuery {
    tenantId?: string | undefined;
}

export interface CheckTenantIdCodeQueryResult {
    isAvailable?: boolean;
    reason?: string | undefined;
}

export interface CheckTenantIdCodeQuery {
    tenantIdCode?: string;
}

export interface UpdateTenantUserCommandResult {
    updated?: boolean;
    azureUserId?: string;
}

export interface UpdateTenantUserCommand {
    azureUserId?: string;
    aliasPinConfirmationRequired?: boolean;
    aliases?: UpdateTenantUserCommandAlias[];
}

export interface UpdateTenantUserCommandAlias {
    userInfoAliasId?: string;
    email?: string;
    givenName?: string;
    surName?: string;
    idCode?: string;
}

export interface RemoveTenantUserCommandResult {
    removed?: boolean;
    azureUserId?: string | undefined;
}

export interface RemoveTenantUserCommand {
    azureUserId?: string;
}

export interface GetTenantUsersQueryResult {
    users?: GetTenantUsersQueryResultUser[];
}

export interface GetTenantUsersQueryResultUser {
    firstName?: string;
    lastName?: string;
    email?: string;
    mobilePhone?: string;
    azureUserId?: string;
}

export interface GetTenantUserEditItemQueryResult {
    azureUserId?: string;
    email?: string;
    givenName?: string;
    surName?: string;
    aliasPinConfirmationRequired?: boolean;
    aliases?: GetTenantUserEditItemQueryResultAlias[];
}

export interface GetTenantUserEditItemQueryResultAlias {
    userInfoAliasId?: string;
    email?: string;
    givenName?: string;
    surName?: string;
    idCode?: string;
}

export interface GetTenantUserEditItemQuery {
    azureUserId?: string;
}

export interface GetTenantUserAliasAddDialogQueryResult {
    dialogTitle?: string;
    output?: GetTenantUserAliasAddDialogOutput;
}

export interface GetTenantUserAliasAddDialogOutput {
    userInfoAliasId?: string;
    email?: string;
    givenName?: string;
    surName?: string;
    idCode?: string;
}

export interface GetTenantUserAddDialogQueryResult {
    dialogTitle?: string;
    output?: GetTenantUserAddDialogOutput;
}

export interface GetTenantUserAddDialogOutput {
    userEmails?: string[];
    sendEmailInvites?: boolean;
}

export interface AddTenantUsersCommandResult {
    addedUsers?: AddTenantUsersCommandResultUser[];
}

export interface AddTenantUsersCommandResultUser {
    azureUserId?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    inviteStatus?: string | undefined;
}

export interface AddTenantUsersCommand {
    userEmails?: string[];
    sendEmailInvites?: boolean;
}

export interface UpdateSelfServiceSettingsCommand {
    selfServiceSettings?: SelfServiceSettings;
}

export interface SelfServiceSettings {
    modification?: ModificationSelfServiceSettings;
    cancellation?: CancellationSelfServiceSettings;
    modifySurvey?: ModifySurveySelfServiceSettings;
    changeBookingParty?: ChangeBookingPartySelfServiceSettings;
}

export interface ModificationSelfServiceSettings {
    name?: string;
    active?: boolean;
    iconName?: string;
    iconColor?: string;
    forPublicBooking?: boolean;
    forInternalBooking?: boolean;
    maxBookingAmount?: number | undefined;
    leadTimeDuration?: Duration;
    title?: string;
    text?: string;
    paymentRequiredForPublicBooking?: boolean;
    paymentRequiredForInternalBooking?: boolean;
    paymentText?: string;
    paymentConfirmationText?: string;
    refundText?: string;
    refundConfirmationText?: string;
    noPaymentText?: string;
    noPaymentConfirmationText?: string;
}

export interface CancellationSelfServiceSettings {
    name?: string;
    active?: boolean;
    iconName?: string;
    iconColor?: string;
    forPublicBooking?: boolean;
    forInternalBooking?: boolean;
    maxBookingAmount?: number | undefined;
    leadTimeDuration?: Duration;
    title?: string;
    text?: string;
    confirmationTitle?: string;
    confirmationText?: string;
}

export interface ModifySurveySelfServiceSettings {
    name?: string;
    active?: boolean;
    iconName?: string;
    iconColor?: string;
    forPublicBooking?: boolean;
    forInternalBooking?: boolean;
    maxBookingAmount?: number | undefined;
    leadTimeDuration?: Duration;
    title?: string;
    text?: string;
    confirmationTitle?: string;
    confirmationText?: string;
}

export interface ChangeBookingPartySelfServiceSettings {
    name?: string;
    active?: boolean;
    iconName?: string;
    iconColor?: string;
    forPublicBooking?: boolean;
    forInternalBooking?: boolean;
    maxBookingAmount?: number | undefined;
    leadTimeDuration?: Duration;
    title?: string;
    text?: string;
    paymentRequiredForPublicBooking?: boolean;
    paymentRequiredForInternalBooking?: boolean;
    paymentText?: string;
    paymentConfirmationText?: string;
    refundText?: string;
    refundConfirmationText?: string;
    noPaymentText?: string;
    noPaymentConfirmationText?: string;
    reductionRulesActive?: boolean;
    personReductionRules?: PersonReductionRuleSettings[];
    valueReductionRules?: ValueReductionRuleSettings[];
}

export interface PersonReductionRuleSettings {
    id?: string;
    fromTotalPersonCount?: number;
    maxPersonsRemoved?: number;
}

export interface ValueReductionRuleSettings {
    id?: string;
    fromBookingValue?: number;
    maxValueDropAmount?: number | undefined;
    maxValueDropPercentage?: number | undefined;
}

export interface UpdateSelfServiceRuleSettingsCommand {
    ruleSettings?: SelfServiceRuleSettings;
}

export interface SelfServiceRuleSettings {
    cancellation?: SelfServiceCancellationRulesSettings;
    dateChange?: SelfServiceDateChangeRulesSettings;
    bookingParty?: SelfServiceBookingPartyRulesSettings;
    surveyAnswers?: SelfServiceSurveyAnswerRulesSettings;
}

export interface SelfServiceCancellationRulesSettings {
    active?: boolean;
    channels?: SelfServiceChannelAvailabilitySettings;
    leadTimeDuration?: Duration;
    maxBookingValue?: number | undefined;
    refundMethod?: SelfServiceRefundMethodDto;
}

export interface SelfServiceChannelAvailabilitySettings {
    planner?: boolean;
    cmsSite?: boolean;
}

export enum SelfServiceRefundMethodDto {
    Money = "Money",
    Credit = "Credit",
}

export interface SelfServiceDateChangeRulesSettings {
    active?: boolean;
    channels?: SelfServiceChannelAvailabilitySettings;
    leadTimeDuration?: Duration;
    maxBookingValue?: number | undefined;
    moveWindow?: SelfServiceMoveWindowSettings;
    paymentRequired?: SelfServicePaymentRequirementSettings;
    maxChangeCount?: number | undefined;
}

export interface SelfServiceMoveWindowSettings {
    maxDaysForward?: number | undefined;
    maxDaysBackward?: number | undefined;
}

export interface SelfServicePaymentRequirementSettings {
    planner?: boolean;
    cmsSite?: boolean;
}

export interface SelfServiceBookingPartyRulesSettings {
    active?: boolean;
    channels?: SelfServiceChannelAvailabilitySettings;
    leadTimeDuration?: Duration;
    maxBookingValue?: number | undefined;
    paymentRequired?: SelfServicePaymentRequirementSettings;
    reductionRulesActive?: boolean;
    personReductionRules?: PersonReductionRuleSettings[];
    valueReductionRules?: ValueReductionRuleSettings[];
}

export interface SelfServiceSurveyAnswerRulesSettings {
    active?: boolean;
    channels?: SelfServiceChannelAvailabilitySettings;
    leadTimeDuration?: Duration;
}

export interface UpdateProgramSelfServiceOverridesCommand {
    programId?: string;
    overrides?: SelfServiceProgramOverrideSettings;
}

export interface SelfServiceProgramOverrideSettings {
    cancellation?: SelfServiceProgramCancellationOverrideSettings;
    dateChange?: SelfServiceProgramChangeOverrideSettings;
    bookingParty?: SelfServiceProgramBookingPartyOverrideSettings;
    surveyAnswers?: SelfServiceProgramSurveyOverrideSettings;
}

export interface SelfServiceProgramCancellationOverrideSettings {
    configured?: boolean;
    disabled?: boolean;
    channels?: SelfServiceChannelSuppressionSettings;
    leadTimeDuration?: Duration | undefined;
    maxBookingValue?: number | undefined;
    refundMethod?: SelfServiceRefundMethodDto | undefined;
}

export interface SelfServiceChannelSuppressionSettings {
    suppressPlanner?: boolean;
    suppressCmsSite?: boolean;
}

export interface SelfServiceProgramChangeOverrideSettings {
    configured?: boolean;
    disabled?: boolean;
    channels?: SelfServiceChannelSuppressionSettings;
    leadTimeDuration?: Duration | undefined;
    maxBookingValue?: number | undefined;
    moveWindow?: SelfServiceMoveWindowSettings | undefined;
    maxChangeCount?: number | undefined;
}

export interface SelfServiceProgramBookingPartyOverrideSettings {
    configured?: boolean;
    disabled?: boolean;
    channels?: SelfServiceChannelSuppressionSettings;
    leadTimeDuration?: Duration | undefined;
    maxBookingValue?: number | undefined;
    reductionRulesActive?: boolean;
    personReductionRules?: PersonReductionRuleSettings[];
    valueReductionRules?: ValueReductionRuleSettings[];
}

export interface SelfServiceProgramSurveyOverrideSettings {
    configured?: boolean;
    disabled?: boolean;
    channels?: SelfServiceChannelSuppressionSettings;
    leadTimeDuration?: Duration | undefined;
}

export interface MigrateLocationSelfServiceRulesCommand {
}

export interface GetSelfServiceSettingsQueryResult {
    selfServiceSettings?: SelfServiceSettings;
    leadTimeDurationOptions?: SelfServiceLeadTimeDurationOptions;
}

export interface SelfServiceLeadTimeDurationOptions {
    stepDuration?: Duration;
    minDuration?: Duration;
    maxDuration?: Duration;
}

export interface GetSelfServiceSettingsQuery {
}

export interface GetSelfServiceRuleSettingsQueryResult {
    ruleSettings?: SelfServiceRuleSettings;
    timeBoundOptions?: SelfServiceLeadTimeDurationOptions;
}

export interface GetSelfServiceRuleSettingsQuery {
}

export interface GetSelfServiceProgramDeviationsQueryResult {
    venueRuleSettings?: SelfServiceRuleSettings;
    programs?: SelfServiceProgramDeviationRow[];
}

export interface SelfServiceProgramDeviationRow {
    programId?: string;
    name?: string;
    active?: boolean;
    forPublicUse?: boolean;
    allowCustomSteps?: boolean;
    groupName?: string | undefined;
    groupOrderIndex?: number;
    orderIndex?: number;
    cancellation?: SelfServiceDeviation[];
    dateChange?: SelfServiceDeviation[];
    bookingParty?: SelfServiceDeviation[];
    surveyAnswers?: SelfServiceDeviation[];
}

export interface SelfServiceDeviation {
    kind?: SelfServiceDeviationKindDto;
    value?: string | undefined;
}

export enum SelfServiceDeviationKindDto {
    Disabled = "Disabled",
    PlannerClosed = "PlannerClosed",
    CmsSiteClosed = "CmsSiteClosed",
    LeadTime = "LeadTime",
    RefundMethod = "RefundMethod",
    MaxChangeCount = "MaxChangeCount",
    MoveWindow = "MoveWindow",
    ReductionOff = "ReductionOff",
    ReductionLadders = "ReductionLadders",
    MaxBookingValue = "MaxBookingValue",
}

export interface GetSelfServiceProgramDeviationsQuery {
}

export interface GetSelfServiceOverrideSummaryQueryResult {
    cancellation?: SelfServiceOverrideSummary;
    dateChange?: SelfServiceOverrideSummary;
    bookingParty?: SelfServiceOverrideSummary;
    surveyAnswers?: SelfServiceOverrideSummary;
}

export interface SelfServiceOverrideSummary {
    programCount?: number;
    programs?: SelfServiceOverridingProgram[];
}

export interface SelfServiceOverridingProgram {
    programId?: string;
    name?: string;
    disabled?: boolean;
    overridesLeadTime?: boolean;
    suppressesPlanner?: boolean;
    suppressesCmsSite?: boolean;
}

export interface GetSelfServiceOverrideSummaryQuery {
}

export interface GetProgramSelfServiceOverridesQueryResult {
    overrides?: SelfServiceProgramOverrideSettings;
    venueRuleSettings?: SelfServiceRuleSettings;
    timeBoundOptions?: SelfServiceLeadTimeDurationOptions;
}

export interface GetProgramSelfServiceOverridesQuery {
    programId?: string;
}

export interface UpdateSecurityGroupCommandResult {
    updated?: boolean;
    securityGroupId?: string;
}

export interface UpdateSecurityGroupCommand {
    securityGroupId?: string;
    name?: string;
    description?: string;
    roles?: UpdateSecurityGroupCommandRole[];
}

export interface UpdateSecurityGroupCommandRole {
    domainType?: DomainType;
    roleId?: string;
    name?: string;
}

export enum DomainType {
    Platform = "Platform",
    Tenant = "Tenant",
    Location = "Location",
}

export interface RemoveSecurityGroupMemberCommandResult {
    removed?: boolean;
    relatedObjectId?: string;
}

export interface RemoveSecurityGroupMemberCommand {
    securityGroupId?: string;
    relatedObjectId?: string;
}

export interface GetSecurityUserListViewResult {
    users?: GetSecurityUserListViewUser[];
}

export interface GetSecurityUserListViewUser {
    relatedObjectId?: string;
    displayName?: string;
}

export interface GetSecurityUserListViewQuery {
    locationId?: string | undefined;
}

export interface GetSecurityUserEditItemViewResult {
    navItems?: GetSecurityUserEditItemViewNavItem[];
}

export interface GetSecurityUserEditItemViewNavItem {
    name?: string;
    pathTemplate?: string;
}

export interface GetSecurityUserEditItemViewQuery {
    domainType?: DomainType;
    securityGroupId?: string | undefined;
}

export interface GetSecurityNavigationResult {
    domainType?: DomainType;
    tenantId?: string;
    locationId?: string | undefined;
    navItems?: GetSecurityNavigationNavItem[];
}

export interface GetSecurityNavigationNavItem {
    name?: string;
    pathTemplate?: string;
}

export interface GetSecurityNavigationQuery {
    domainType?: DomainType;
    tenantId?: string;
    locationId?: string | undefined;
}

export interface GetSecurityGroupMembersAddDialogViewResult {
    dialogTitle?: string;
    securityGroupId?: string;
    securityObjects?: GetSecurityGroupMembersAddDialogViewSecurityObject[];
}

export interface GetSecurityGroupMembersAddDialogViewSecurityObject {
    relatedObjectId?: string;
    displayName?: string;
    email?: string;
    type?: SecurityGroupMemberType;
    isMember?: boolean;
}

export enum SecurityGroupMemberType {
    SecurityGroup = "SecurityGroup",
    User = "User",
    Device = "Device",
}

export interface GetSecurityGroupMembersAddDialogViewQuery {
    securityGroupId?: string;
}

export interface GetSecurityGroupListViewResult {
    groups?: GetSecurityGroupListViewGroup[];
}

export interface GetSecurityGroupListViewGroup {
    id?: string;
    idCode?: string;
    domainType?: DomainType;
    name?: string;
    description?: string;
    members?: GetSecurityGroupListViewMember[];
}

export interface GetSecurityGroupListViewMember {
    relatedObjectId?: string;
    displayName?: string;
    type?: SecurityGroupMemberType;
}

export interface GetSecurityGroupListViewQuery {
    locationId?: string | undefined;
}

export interface GetSecurityGroupEditItemViewResult {
    groupId?: string;
    groupIdCode?: string;
    groupName?: string;
    domainType?: DomainType;
    name?: string;
    description?: string;
    members?: GetSecurityGroupEditItemViewMember[];
    roles?: GetSecurityGroupEditItemViewRole[];
}

export interface GetSecurityGroupEditItemViewMember {
    relatedObjectId?: string;
    displayName?: string;
    type?: SecurityGroupMemberType;
}

export interface GetSecurityGroupEditItemViewRole {
    roleId?: string;
    name?: string;
    domainType?: DomainType;
}

export interface GetSecurityGroupEditItemViewQuery {
    domainType?: DomainType;
    securityGroupId?: string;
}

export interface GetSecurityGroupEditItemRolesViewResult {
    roles?: GetSecurityGroupEditItemRolesViewRole[];
}

export interface GetSecurityGroupEditItemRolesViewRole {
    roleId?: string;
    name?: string;
    description?: string;
    domainType?: DomainType;
}

export interface GetSecurityGroupEditItemRolesViewQuery {
    domainType?: DomainType;
    securityGroupId?: string | undefined;
}

export interface GetSecurityGroupAddDialogViewResult {
    dialogTitle?: string;
    output?: GetSecurityGroupAddDialogViewOutput;
}

export interface GetSecurityGroupAddDialogViewOutput {
    domainType?: DomainType;
    name?: string;
    description?: string;
}

export interface GetSecurityGroupAddDialogViewQuery {
    domainType?: DomainType;
}

export interface DeleteSecurityGroupCommandResult {
    deleted?: boolean;
    securityGroupId?: string;
}

export interface DeleteSecurityGroupCommand {
    securityGroupId?: string;
}

export interface CreateSecurityGroupCommandResult {
    created?: boolean;
    securityGroupId?: string;
}

export interface CreateSecurityGroupCommand {
    tenantId?: string;
    locationId?: string | undefined;
    domainType?: DomainType;
    name?: string;
    description?: string;
}

export interface AddSecurityGroupMembersCommandResult {
    added?: boolean;
    securityGroupId?: string;
}

export interface AddSecurityGroupMembersCommand {
    securityGroupId?: string;
    members?: AddSecurityGroupMembersCommandMember[];
}

export interface AddSecurityGroupMembersCommandMember {
    relatedObjectId?: string;
    type?: SecurityGroupMemberType;
}

export interface ResultV2Dto {
    state?: ResultState;
    isSuccess?: boolean;
    isFailure?: boolean;
    error?: ErrorV2Dto | undefined;
}

export enum ResultState {
    Faulted = "Faulted",
    Exception = "Exception",
    Invalidated = "Invalidated",
    Succeeded = "Succeeded",
    Created = "Created",
    Updated = "Updated",
    Deleted = "Deleted",
}

export interface ErrorV2Dto {
    code?: string;
    message?: string;
}

export interface GetUpsellQueryResult {
    fromDate?: DateTime;
    toDate?: DateTime;
    summary?: GetUpsellSummary;
    dataItems?: GetUpsellResultItem[];
}

export interface GetUpsellSummary {
    totalUpsellRevenue?: number;
    totalQuantitySold?: number;
    bestSellingProductName?: string | undefined;
    highestAttachRateProductName?: string | undefined;
    highestAttachRate?: number;
}

export interface GetUpsellResultItem {
    programName?: string | undefined;
    productName?: string | undefined;
    isProgramStep?: boolean;
    quantity?: number;
    totalRevenue?: number;
    bookingCount?: number;
    attachRate?: number;
}

export interface GetUpsellQuery {
    period?: QueryPeriod;
}

export interface QueryPeriod {
    fromDate?: FromDate;
    toDate?: ToDate;
}

export interface FromDate {
    year?: number;
    month?: number;
    day?: number;
}

export interface ToDate {
    year?: number;
    month?: number;
    day?: number;
}

export interface GetResourceUtilizationQueryResult {
    fromDate?: DateTime;
    toDate?: DateTime;
    days?: ResourceUtilizationDayResult[];
}

export interface ResourceUtilizationDayResult {
    resourceName?: string | undefined;
    resourceCategoryName?: string | undefined;
    date?: DateTime;
    hours?: ResourceUtilizationHourResult[];
}

export interface ResourceUtilizationHourResult {
    hour?: number;
    openBookedMs?: number;
    openIdleMs?: number;
}

export interface GetResourceUtilizationQuery {
    period?: QueryPeriod;
}

export interface GetProgramRevenueQueryResult {
    fromDate?: DateTime;
    toDate?: DateTime;
    items?: GetProgramRevenueResultItem[];
}

export interface GetProgramRevenueResultItem {
    programName?: string | undefined;
    onlineBookedCount?: number;
    offlineBookedCount?: number;
    onlineProgramRevenue?: number;
    offlineProgramRevenue?: number;
    onlineExtrasRevenue?: number;
    offlineExtrasRevenue?: number;
    visitors?: number;
    ageGroupVisitors?: GetProgramRevenueAgeGroupVisitors[];
    totalBookingValue?: number;
}

export interface GetProgramRevenueAgeGroupVisitors {
    ageGroupId?: string | undefined;
    name?: string | undefined;
    count?: number;
}

export interface GetProgramRevenueQuery {
    period?: QueryPeriod;
    statuses?: BookingStatus[] | undefined;
}

export enum BookingStatus {
    Pending = "Pending",
    PendingApproval = "PendingApproval",
    Proposal = "Proposal",
    CancelledByCustomer = "CancelledByCustomer",
    CancelledBySeller = "CancelledBySeller",
    CancelledBySystem = "CancelledBySystem",
    Declined = "Declined",
    Accepted = "Accepted",
    NoShow = "NoShow",
    CheckedIn = "CheckedIn",
    CheckedOut = "CheckedOut",
}

export interface GetProductSalesQueryResult {
    fromDate?: DateTime;
    toDate?: DateTime;
    items?: GetProductSalesResultItem[];
}

export interface GetProductSalesResultItem {
    productId?: string | undefined;
    productName?: string | undefined;
    productType?: string | undefined;
    unitPrice?: number;
    quantity?: number;
    totalRevenue?: number;
}

export interface GetProductSalesQuery {
    period?: QueryPeriod;
    includeProgramSteps?: boolean | undefined;
}

export interface GetOnlinePaymentsQueryResult {
    fromDate?: DateTime;
    toDate?: DateTime;
    items?: GetOnlinePaymentsResultItem[];
}

export interface GetOnlinePaymentsResultItem {
    bookingId?: string;
    eventDate?: DateTime;
    createdOnDate?: DateTime;
    bookingStatus?: BookingStatus;
    isCompany?: boolean;
    companyName?: string | undefined;
    departmentName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    visitors?: number;
    programName?: string | undefined;
    bookingValue?: number;
    paymentStatus?: PaymentStatus;
    paymentMethod?: string | undefined;
    requestedAmount?: number;
    receivedAmount?: number;
    paidOn?: DateTime | undefined;
    paymentProvider?: string | undefined;
    paymentTransactionId?: string | undefined;
    refundStatus?: RefundStatus | undefined;
    refundRequestedAmount?: number;
    refundedAmount?: number;
    refundedOn?: DateTime | undefined;
    refundProvider?: string | undefined;
    refundTransactionId?: string | undefined;
}

export enum PaymentStatus {
    Pending = "Pending",
    Paid = "Paid",
    Failed = "Failed",
}

export enum RefundStatus {
    None = "None",
    PendingApproval = "Pending Approval",
    Prepared = "Prepared",
    InProgress = "InProgress",
    Authorized = "Authorized",
    Approved = "Approved",
    Declined = "Declined",
    Canceled = "Canceled",
    Succeeded = "Succeeded",
    Failed = "Failed",
}

export interface GetOnlinePaymentsQuery {
    period?: QueryPeriod;
    paymentStatuses?: PaymentStatus[] | undefined;
}

export interface GetLostRevenueQueryResult {
    fromDate?: DateTime;
    toDate?: DateTime;
    summary?: GetLostRevenueSummary;
    dataItems?: GetLostRevenueResultItem[];
}

export interface GetLostRevenueSummary {
    lostRevenueTotal?: number;
    cancellationCount?: number;
    noShowCount?: number;
    openBalanceCount?: number;
    totalBookingsInWindow?: number;
    cancellationRate?: number;
    noShowRate?: number;
}

export interface GetLostRevenueResultItem {
    bookingId?: string;
    eventDate?: DateTime;
    programName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    isCompany?: boolean;
    companyName?: string | undefined;
    visitors?: number;
    bookingValue?: number;
    amountPaid?: number;
    openBalance?: number;
    status?: BookingStatus;
    cancelledOnDate?: DateTime | undefined;
    lossReason?: LossReason;
}

export enum LossReason {
    CancelledByCustomer = "CancelledByCustomer",
    CancelledBySeller = "CancelledBySeller",
    CancelledBySystem = "CancelledBySystem",
    NoShow = "NoShow",
    OpenBalance = "OpenBalance",
}

export interface GetLostRevenueQuery {
    period?: QueryPeriod;
}

export interface GetLocationOverviewBookingsQueryResult {
    fromDate?: DateTime;
    toDate?: DateTime;
    days?: GetLocationOverviewBookingsResultDay[];
}

export interface GetLocationOverviewBookingsResultDay {
    fromDate?: DateTime;
    toDate?: DateTime;
    bookingPartySum?: LocationOverviewParty;
    dataItems?: GetLocationOverviewBookingsResultDataItem[];
}

export interface LocationOverviewParty {
    totalPersonCount?: number;
    ageGroups?: LocationOverviewPartyAgeGroup[];
}

export interface LocationOverviewPartyAgeGroup {
    ageGroupId?: string | undefined;
    fromAge?: number;
    toAge?: number;
    count?: number;
    minCount?: number;
    maxCount?: number;
    orderIndex?: number;
    unitSingular?: string | undefined;
    unitPlural?: string | undefined;
}

export interface GetLocationOverviewBookingsResultDataItem {
    bookingId?: string;
    status?: BookingStatus;
    originType?: BookingOriginType;
    fromDate?: DateTime;
    createdOnDate?: DateTime;
    cancelledOnDate?: DateTime | undefined;
    isCustom?: boolean;
    programName?: string | undefined;
    bookingFinalPrice?: number;
    lockDetails?: LocationOverviewLockDetails;
    posDetails?: LocationOverviewPosDetails;
    customerNameDetails?: LocationOverviewCustomer;
    paymentDetails?: LocationOverviewPaymentInfo;
    bookingParty?: LocationOverviewParty;
    surveyAnswers?: LocationOverviewSurveyAnswer[] | undefined;
    products?: LocationOverviewProduct[] | undefined;
}

export enum BookingOriginType {
    RaxBookingSite = "RaxBookingSite",
    Internal = "Internal",
    League = "League",
}

export interface LocationOverviewLockDetails {
    locked?: boolean;
    lockReason?: string | undefined;
    lockUpdate?: boolean;
    lockCancel?: boolean;
    lockStatusChange?: boolean;
}

export interface LocationOverviewPosDetails {
    inPos?: boolean;
    posReferenceText?: string | undefined;
}

export interface LocationOverviewCustomer {
    firstName?: string | undefined;
    lastName?: string | undefined;
    isCompany?: boolean;
    companyName?: string | undefined;
    departmentName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    fullName?: string;
}

export interface LocationOverviewPaymentInfo {
    requiredGrossAmount?: number;
    remainingGrossAmount?: number;
    remainingRefundableAmount?: number;
    paymentBalance?: number;
    requiredDepositAmount?: number;
    bookingPaymentStatus?: BookingPaymentStatus;
    hasPendingApprovalBookingRefundProposals?: boolean;
}

export enum BookingPaymentStatus {
    None = "None",
    Paid = "Paid",
    PartiallyPaid = "PartiallyPaid",
    Unpaid = "Unpaid",
    Overpaid = "Overpaid",
}

export interface LocationOverviewSurveyAnswer {
    questionLabel?: string | undefined;
    answerType?: string | undefined;
    customRemarks?: string | undefined;
    answerValues?: LocationOverviewSurveyAnswerValue[];
}

export interface LocationOverviewSurveyAnswerValue {
    answerLabel?: string | undefined;
    answerBool?: boolean | undefined;
    answerText?: string | undefined;
    answerNumber?: number | undefined;
}

export interface LocationOverviewProduct {
    productId?: string | undefined;
    name?: string | undefined;
    itemCount?: number;
}

export interface GetLocationOverviewBookingsQuery {
    period?: QueryPeriod2;
    bookingStatuses?: BookingStatus[] | undefined;
    bookingOriginTypes?: BookingOriginType[] | undefined;
}

export interface QueryPeriod2 {
    fromDate?: FromDate2;
    toDate?: ToDate2;
}

export interface FromDate2 {
    year?: number;
    month?: number;
    day?: number;
}

export interface ToDate2 {
    year?: number;
    month?: number;
    day?: number;
}

export interface MolliePriceLineItemsQueryResult {
    fromDate?: DateTime;
    toDate?: DateTime;
    paidPriceLines?: MolliePriceLineResultItem[];
    discountCodes?: MolliePriceLineResultItem[];
    sumTotalAmountPriceLines?: number;
    sumTotalAmountDiscountCode?: number;
    partiallyPaidDays?: MolliePartiallyPaidDay[];
}

export interface MolliePriceLineResultItem {
    relatedObjectType?: string | undefined;
    description?: string | undefined;
    unitName?: string | undefined;
    itemCount?: number;
    itemPrice?: number;
    totalPrice?: number;
    custom?: boolean;
    bookings?: MolliePriceLineBookingInfo[];
}

export interface MolliePriceLineBookingInfo {
    bookingId?: string;
    name?: string | undefined;
    fromDateText?: string | undefined;
}

export interface MolliePartiallyPaidDay {
    fromDate?: DateTime;
    toDate?: DateTime;
    dataItems?: MolliePartiallyPaidBookingResultItem[];
}

export interface MolliePartiallyPaidBookingResultItem {
    bookingId?: string;
    status?: BookingStatus;
    paymentStatus?: BookingPaymentStatus;
    originType?: BookingOriginType;
    fromDate?: DateTime;
    cancelledOnDate?: DateTime | undefined;
    updatedOnDate?: DateTime;
    isCustom?: boolean;
    programName?: string | undefined;
    paymentProviderId?: string | undefined;
    amount?: number;
    finalPrice?: number;
    amountDiff?: number;
    lockDetails?: LocationOverviewLockDetails;
    posDetails?: LocationOverviewPosDetails;
    customerNameDetails?: LocationOverviewCustomer;
}

export interface GetLocationOverviewMolliePriceLineItemsQuery {
    period?: QueryPeriod2;
}

export interface MolliePaymentsQueryResult {
    fromDate?: DateTime;
    toDate?: DateTime;
    sumPaymentBalance?: number;
    sumTotalAmount?: number;
    sumBookingAmountToRefund?: number;
    sumNetPaymentBalance?: number;
    totalAmountBookingNotAccepted?: number;
    days?: MolliePaymentsResultDay[];
}

export interface MolliePaymentsResultDay {
    fromDate?: DateTime;
    toDate?: DateTime;
    sumPaymentBalance?: number;
    sumBookingAmountToRefund?: number;
    sumNetPaymentBalance?: number;
    dataItems?: MolliePaymentsResultDataItem[];
}

export interface MolliePaymentsResultDataItem {
    bookingId?: string;
    status?: BookingStatus;
    originType?: BookingOriginType;
    fromDate?: DateTime;
    cancelledOnDate?: DateTime | undefined;
    updatedOnDate?: DateTime;
    isCustom?: boolean;
    programName?: string | undefined;
    paymentProviderId?: string | undefined;
    paymentProviderTransactionId?: string | undefined;
    paymentTransactionStatus?: PaymentTransactionStatus;
    paymentTransactionBalance?: number;
    bookingPaymentAmountToRefund?: number;
    bookingFinalPrice?: number;
    lockDetails?: LocationOverviewLockDetails;
    posDetails?: LocationOverviewPosDetails;
    customerNameDetails?: LocationOverviewCustomer;
    paymentDetails?: LocationOverviewPaymentInfo;
}

export enum PaymentTransactionStatus {
    None = "None",
    Prepared = "Prepared",
    Started = "Started",
    InProgress = "InProgress",
    Pending = "Pending",
    Reserved = "Reserved",
    Authorized = "Authorized",
    Canceled = "Canceled",
    Succeeded = "Succeeded",
    Failed = "Failed",
    PartiallySucceeded = "PartiallySucceeded",
    Expired = "Expired",
    Refunded = "Refunded",
    PartiallyRefunded = "PartiallyRefunded",
    RefundPending = "RefundPending",
    RefundCancelled = "RefundCancelled",
}

export interface GetLocationOverviewMolliePaymentsQuery {
    period?: QueryPeriod2;
    bookingStatuses?: BookingStatus[] | undefined;
}

export interface MollieFuturePrePaidAmountQueryResult {
    fromDate?: DateTime;
    totalAmountFuturePrePaid?: number;
}

export interface GetLocationOverviewMollieFuturePrePaidAmountQuery {
    fromDate?: FromDate2;
}

export interface MollieCancelledBookingPaymentsQueryResult {
    fromDate?: DateTime;
    toDate?: DateTime;
    sumPaymentBalance?: number;
    sumTotalAmount?: number;
    sumBookingAmountToRefund?: number;
    sumNetPaymentBalance?: number;
    totalAmountBookingNotAccepted?: number;
    days?: MollieCancelledBookingPaymentsResultDay[];
}

export interface MollieCancelledBookingPaymentsResultDay {
    fromDate?: DateTime;
    toDate?: DateTime;
    sumPaymentBalance?: number;
    sumBookingAmountToRefund?: number;
    sumNetPaymentBalance?: number;
    totalAmountBookingNotAccepted?: number;
    dataItems?: MollieCancelledBookingPaymentsResultDataItem[];
}

export interface MollieCancelledBookingPaymentsResultDataItem {
    bookingId?: string;
    status?: BookingStatus;
    originType?: BookingOriginType;
    fromDate?: DateTime;
    cancelledOnDate?: DateTime;
    updatedOnDate?: DateTime;
    isCustom?: boolean;
    programName?: string | undefined;
    paymentProviderId?: string | undefined;
    providerPendingBalanceAmount?: number;
    bookingPaymentAmountToRefund?: number;
    bookingFinalPrice?: number;
    lockDetails?: LocationOverviewLockDetails;
    posDetails?: LocationOverviewPosDetails;
    customerNameDetails?: LocationOverviewCustomer;
    paymentDetails?: LocationOverviewPaymentInfo;
}

export interface GetLocationOverviewMollieCancelledBookingPaymentsQuery {
    period?: QueryPeriod2;
}

export interface GetLocationOverviewDayPlanningView {
    categories?: DayPlanningCategoryView[];
    rows?: DayPlanningRowView[];
}

export interface DayPlanningCategoryView {
    id?: string;
    name?: string;
}

export interface DayPlanningRowView {
    bookingId?: string;
    bookingCode?: string | undefined;
    status?: BookingStatus;
    arrivalDate?: DateTime;
    arrivalTimeLabel?: string;
    receptionAreaName?: string | undefined;
    customerName?: string;
    partySummary?: string;
    personCount?: number;
    mealTimeLabels?: string[];
    mealLocations?: string[];
    mealMenus?: string[];
    price?: number;
    depositPaid?: boolean;
    remarks?: DayPlanningRemarkView[];
    timesByCategoryId?: { [key: string]: string[]; };
    warnings?: DayPlanningRowWarningView[];
}

export interface DayPlanningRemarkView {
    question?: string;
    answer?: string;
}

export enum DayPlanningRowWarningView {
    NoLedger = "NoLedger",
    UnknownResource = "UnknownResource",
}

export interface GetLocationOverviewDayPlanningQuery {
    date?: FromDate2;
    bookingStatuses?: BookingStatus[] | undefined;
}

export interface GetLocationOverviewCustomBookingsQueryResult {
    fromDate?: DateTime;
    toDate?: DateTime;
    days?: GetLocationOverviewCustomBookingsResultDay[];
}

export interface GetLocationOverviewCustomBookingsResultDay {
    fromDate?: DateTime;
    toDate?: DateTime;
    bookingPartySum?: LocationOverviewParty;
    dataItems?: GetLocationOverviewCustomBookingsResultDataItem[];
}

export interface GetLocationOverviewCustomBookingsResultDataItem {
    bookingId?: string;
    status?: BookingStatus;
    originType?: BookingOriginType;
    fromDate?: DateTime;
    isCustom?: boolean;
    programName?: string | undefined;
    programStepName?: string | undefined;
    bookingFinalPrice?: number;
    lockDetails?: LocationOverviewLockDetails;
    posDetails?: LocationOverviewPosDetails;
    customerNameDetails?: LocationOverviewCustomer;
    paymentDetails?: LocationOverviewPaymentInfo;
    bookingParty?: LocationOverviewParty;
    surveyAnswers?: LocationOverviewSurveyAnswer[] | undefined;
    products?: LocationOverviewProduct[] | undefined;
}

export interface GetLocationOverviewCustomBookingsQuery {
    period?: QueryPeriod2;
    bookingStatuses?: BookingStatus[] | undefined;
    bookingOriginTypes?: BookingOriginType[] | undefined;
    bookingPaymentStatuses?: BookingPaymentStatus[] | undefined;
    programStepIds?: string[] | undefined;
    productIds?: string[] | undefined;
}

export interface LocationOverviewCustomBookingListView {
    overviewId?: string;
    overviewName?: string;
    changeBookingStatuses?: EnumOptionItem[];
    bookingStatuses?: EnumOptionItem[];
    bookingOriginTypes?: EnumOptionItem[];
    bookingPaymentStatuses?: EnumOptionItem[];
    columnOptions?: LocationOverviewColumnOptions;
    filterBookingOriginTypes?: ValueItem[];
    filterBookingPaymentStatuses?: ValueItem[];
    filterBookingStatuses?: ValueItem[];
    filterProgramStepIds?: ValueItem[];
    filterProductIds?: ValueItem[];
}

export interface EnumOptionItem {
    label?: string | undefined;
    value?: string | undefined;
    isChecked?: boolean | undefined;
}

export interface LocationOverviewColumnOptions {
    showPayment?: boolean;
    showStatus?: boolean;
    showExtras?: boolean;
    showSurvey?: boolean;
}

export interface BaseKey {
    id?: string | undefined;
}

export interface ValueItem extends BaseKey {
    value?: string | undefined;
}

export interface GetLocationOverviewCustomBookingListViewQuery {
    overviewId?: string;
}

export interface GetDailyBusynessQueryResult {
    categories?: string[];
    days?: DailyBusynessDayResult[];
}

export interface DailyBusynessDayResult {
    date?: DateTime;
    isOpen?: boolean;
    bookingCount?: number;
    visitors?: number;
    categoryVisitors?: DailyBusynessCategoryVisitorsResult[];
    busynessScore?: number | undefined;
}

export interface DailyBusynessCategoryVisitorsResult {
    category?: string;
    visitors?: number;
}

export interface GetDailyBusynessQuery {
    period?: QueryPeriod;
}

export interface GetCustomerLifetimeValueQueryResult {
    summary?: GetCustomerLifetimeValueSummary;
    dataItems?: GetCustomerLifetimeValueResultItem[];
}

export interface GetCustomerLifetimeValueSummary {
    totalCustomers?: number;
    nieuwCount?: number;
    terugkerendCount?: number;
    loyaalCount?: number;
    slapendCount?: number;
    totalRevenue?: number;
    avgRevenuePerCustomer?: number;
}

export interface GetCustomerLifetimeValueResultItem {
    customerId?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    isCompany?: boolean;
    companyName?: string | undefined;
    firstBookingDate?: DateTime;
    lastBookingDate?: DateTime;
    bookingCount?: number;
    totalVisitors?: number;
    totalRevenue?: number;
    avgRevenue?: number;
    favoriteProgram?: string | undefined;
    segment?: string;
}

export interface GetCustomerLifetimeValueQuery {
    reportDate?: DateTime;
}

export interface GetCapacityOverviewQueryResult {
    fromDate?: DateTime;
    toDate?: DateTime;
    days?: CapacityOverviewDayResult[];
    weekdayHourOccupancy?: CapacityOverviewWeekdayHourOccupancyResult[];
}

export interface CapacityOverviewDayResult {
    date?: DateTime;
    bookings?: number;
    visitors?: number;
    openingHours?: number;
    categories?: CapacityOverviewDayCategoryResult[];
}

export interface CapacityOverviewDayCategoryResult {
    categoryName?: string | undefined;
    bookings?: number;
    visitors?: number;
    fillRate?: number;
}

export interface CapacityOverviewWeekdayHourOccupancyResult {
    categoryName?: string | undefined;
    dayOfWeek?: DayOfWeek;
    hour?: number;
    occupancy?: number;
}

export enum DayOfWeek {
    Sunday = "Sunday",
    Monday = "Monday",
    Tuesday = "Tuesday",
    Wednesday = "Wednesday",
    Thursday = "Thursday",
    Friday = "Friday",
    Saturday = "Saturday",
}

export interface GetCapacityOverviewQuery {
    period?: QueryPeriod;
}

export interface GetCancelledBookingsQueryResult {
    fromDate?: DateTime;
    toDate?: DateTime;
    items?: GetCancelledBookingsResultItem[];
}

export interface GetCancelledBookingsResultItem {
    bookingId?: string;
    cancelledOnDate?: DateTime | undefined;
    eventDate?: DateTime;
    companyName?: string | undefined;
    departmentName?: string | undefined;
    isCompany?: boolean;
    lastName?: string | undefined;
    firstName?: string | undefined;
    email?: string | undefined;
    subscribedToEmailMarketing?: boolean;
    visitors?: number;
    programName?: string | undefined;
    bookingValue?: number;
    createdOnDate?: DateTime;
    phoneNumber?: string | undefined;
}

export interface GetCancelledBookingsQuery {
    period?: QueryPeriod;
    statuses?: BookingStatus[] | undefined;
}

export interface GetBookingContactQueryResult {
    fromDate?: DateTime;
    toDate?: DateTime;
    dataItems?: GetBookingContactResultItem[];
}

export interface GetBookingContactResultItem {
    bookingId?: string;
    eventDate?: DateTime;
    programName?: string | undefined;
    visitors?: number;
    bookingValue?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    isCompany?: boolean;
    companyName?: string | undefined;
    departmentName?: string | undefined;
    subscribedToEmailMarketing?: boolean;
    createdOnDate?: DateTime;
    createdBy?: string | undefined;
}

export interface GetBookingContactQuery {
    period?: QueryPeriod;
    bookingStatuses?: BookingStatus[] | undefined;
    bookingOriginTypes?: BookingOriginType[] | undefined;
    isCompany?: boolean | undefined;
}

export interface GetActivityRevenueQueryResult {
    fromDate?: DateTime;
    toDate?: DateTime;
    items?: GetActivityRevenueResultItem[];
}

export interface GetActivityRevenueResultItem {
    activityName?: string | undefined;
    activityType?: string | undefined;
    totalRevenue?: number;
    bookingCount?: number;
    visitors?: number;
    ageGroupVisitors?: GetActivityRevenueAgeGroupVisitors[];
    unitRevenues?: GetActivityRevenueUnitRevenue[];
}

export interface GetActivityRevenueAgeGroupVisitors {
    ageGroupId?: string | undefined;
    name?: string | undefined;
    count?: number;
}

export interface GetActivityRevenueUnitRevenue {
    unitName?: string | undefined;
    revenue?: number;
}

export interface GetActivityRevenueQuery {
    period?: QueryPeriod;
    statuses?: BookingStatus[] | undefined;
}

export interface RateCardPriceLevelDto {
    priceLevelId?: string;
    color?: string;
    name?: string;
    priceRules?: RateCardPriceLevelRuleDto[];
}

export interface RateCardPriceLevelRuleDto {
    title?: string;
    priceRuleDefinitionId?: string;
    price?: number;
    surcharge?: boolean;
    isRebate?: boolean;
    _PosArticle?: RateCardPosArticleDto;
    priceRuleDefinitionData?: RateCardPriceRuleDefinitionDto;
    surchargePriceRuleDefinitionData?: RateCardSurchargePriceRuleDefinitionDto;
}

export interface RateCardPosArticleDto {
    name?: string;
    raxArticleId?: string;
    posArticleId?: string;
    priceInclVat?: number;
    vatPercentage?: number;
    itemJsonData?: string;
}

export interface RateCardPriceRuleDefinitionDto {
    priceRuleDefinitionId?: string;
    title?: string;
    programName?: string;
    programStepName?: string;
    programStepConfigId?: string;
    programStepId?: string;
    rateCardPricingTypeLabel?: string;
    rateCardPricingType?: RateCardPricingType;
    applyPricePerDuration?: boolean;
    applyPricePerDurationInterval?: boolean;
    priceIntervalDuration?: Duration | undefined;
    ageGroupId?: string;
    fromAge?: number;
    toAge?: number;
    ageGroupName?: string;
    priceLineDescription?: string;
    priceLineUnitName?: string;
    applyPricePerPersonCount?: boolean;
    minTotalPersonCount?: number;
    maxTotalPersonCount?: number;
    posArticle?: RateCardPosArticleDto;
    surchargePriceRuleDefinitions?: RateCardSurchargePriceRuleDefinitionDto[];
}

export enum RateCardPricingType {
    PerPersonAgeGroup = "PerPersonAgeGroup",
    PerPerson = "PerPerson",
    PerGroup = "PerGroup",
    PerResource = "PerResource",
    PerItem = "PerItem",
    PerBooking = "PerBooking",
}

export interface RateCardSurchargePriceRuleDefinitionDto {
    isRebate?: boolean;
    priceRuleDefinitionId?: string;
    title?: string;
    programName?: string;
    programStepName?: string;
    programStepConfigId?: string;
    programStepId?: string;
    rateCardPricingTypeLabel?: string;
    rateCardPricingType?: RateCardPricingType;
    applyPricePerDuration?: boolean;
    applyPricePerDurationInterval?: boolean;
    priceIntervalDuration?: Duration | undefined;
    ageGroupId?: string;
    fromAge?: number;
    toAge?: number;
    ageGroupName?: string;
    priceLineDescription?: string;
    priceLineUnitName?: string;
    applyPricePerPersonCount?: boolean;
    minTotalPersonCount?: number;
    maxTotalPersonCount?: number;
    applyToAdditional?: boolean;
    applyBookingParty?: boolean;
    bookingParty?: RateCardBookingPartyDto;
    posArticle?: RateCardPosArticleDto;
}

export interface RateCardBookingPartyDto {
    totalPersonCount?: number;
    minTotalPersonCount?: number;
    maxTotalPersonCount?: number;
    ageGroups?: RateCardBookingPartyAgeGroupDto[];
}

export interface RateCardBookingPartyAgeGroupDto {
    ageGroupId?: string;
    fromAge?: number;
    toAge?: number;
    count?: number;
    unitPlural?: string;
    unitSingular?: string;
    maxCount?: number;
    minCount?: number;
    orderIndex?: number;
}

export interface RequestNewRateCardPriceLevelQuery {
    rateCardId?: string;
}

export interface GetRateCardPriceRuleDefAddDialogViewResult {
    dialogTitle?: string;
    selectedObjectType?: string;
    objectTypes?: PriceRuleObjectTypeOptionDto[];
    ageGroups?: RateCardBookingPartyAgeGroupDto[];
    selectedProgramStep?: PriceRuleProgramStepDto;
    programSteps?: PriceRuleProgramStepDto[];
    programDuration?: Duration;
    priceIntervalDurationOptions?: DurationOptions;
    output?: RateCardSurchargePriceRuleDefinitionDto;
}

export interface PriceRuleObjectTypeOptionDto {
    text?: string;
    value?: string;
}

export interface PriceRuleProgramStepDto {
    capacityType?: ResourceCapacityType;
    name?: string;
    programStepId?: string;
    programStepConfigId?: string;
    ageGroups?: RateCardBookingPartyAgeGroupDto[];
    duration?: Duration;
    unitSingular?: string;
}

export enum ResourceCapacityType {
    None = "None",
    PerItem = "PerItem",
    PerPerson = "PerPerson",
    PerPersonGroup = "PerPersonGroup",
    PerTable = "PerTable",
    PerLane = "PerLane",
    PerVehicle = "PerVehicle",
}

export interface DurationOptions {
    stepDuration?: Duration;
    minDuration?: Duration;
    maxDuration?: Duration;
}

export interface GetRateCardPriceRuleDefAddDialogViewQuery {
    relatedObjectType?: string;
    relatedObjectId?: string;
    isRebate?: boolean;
    parentPriceRule?: RateCardPriceRuleDefinitionDto;
}

export interface GetRateCardPriceLevelEditDialogViewResult {
    dialogTitle?: string;
    rateCardId?: string;
    hasStartingPrice?: boolean;
    priceRuleDefinitions?: RateCardPriceRuleDefinitionDto[];
    input?: RateCardPriceLevelEditDialogItemDto;
    output?: RateCardPriceLevelEditDialogItemDto;
}

export interface RateCardPriceLevelEditDialogItemDto {
    priceLevels?: RateCardPriceLevelDto[];
    defaultPriceLevelId?: string;
    startingPriceConfig?: RateCardStartingPriceConfigDto;
}

export interface RateCardStartingPriceConfigDto {
    priceLevelId?: string;
    bookingParty?: RateCardBookingPartyDto;
    unitDescription?: string;
    description?: string;
    price?: number;
    fromDate?: DateTime;
}

export interface GetRateCardPriceLevelEditDialogViewQuery {
    rateCardId?: string;
}

export interface RateCardEditViewResult {
    relatedObjectType?: string;
    relatedObjectId?: string;
    rateCardId?: string;
    selectedRateCardListItem?: RateCardSelectItemDto;
    rateCardListItems?: RateCardSelectItemDto[];
    input?: RateCardEditItemDto;
    output?: RateCardEditItemDto;
    weekOpeningHours?: RateCardOpeningHourDto[];
    isDirty?: boolean;
}

export interface RateCardSelectItemDto {
    id?: string;
    name?: string;
    createdOnDate?: DateTime;
    active?: boolean;
}

export interface RateCardEditItemDto {
    name?: string;
    customStartTimes?: boolean;
    defaultPriceLevelId?: string;
    posArticlesAssigned?: boolean;
    priceRuleDefinitions?: RateCardPriceRuleDefinitionDto[];
    priceLevels?: RateCardPriceLevelDto[];
    startTimes?: RateCardStartTimeDto[];
    availabilityRules?: RateCardAvailabilityRuleDto[];
    startingPriceConfig?: RateCardStartingPriceConfigDto;
}

export interface RateCardStartTimeDto {
    rateCardStartTimeId?: string;
    fromDayIndex?: number;
    fromTime?: Duration;
}

export interface RateCardAvailabilityRuleDto {
    rateCardAvailabilityRuleId?: string;
    fromTime?: Duration;
    fromDayIndex?: number;
    toTime?: Duration;
    toDayIndex?: number;
    duration?: Duration;
    priceLevelId?: string;
    priceLevelName?: string;
}

export interface RateCardOpeningHourDto {
    active?: boolean;
    orderIndex?: number;
    dayIndex?: number;
    closed?: boolean;
    allDayOpen?: boolean;
    fromTime?: Duration;
    fromDayIndex?: number;
    toTime?: Duration;
    toDayIndex?: number;
    duration?: Duration;
}

export interface GetRateCardEditViewQuery {
    relatedObjectType?: string;
    relatedObjectId?: string;
}

export interface GetRateCardEditViewForRateCardQuery {
    relatedObjectId?: string;
    rateCardId?: string;
}

export interface GetRateCardEditDialogViewResult {
    dialogTitle?: string;
    relatedObjectType?: string;
    relatedObjectId?: string;
    rateCardId?: string;
    intervalDurationOptions?: DurationOptions;
    rateCardRelatedObjects?: RateCardRelatedObjectDto[];
    input?: RateCardEditDialogItemDto;
    output?: RateCardEditDialogItemDto;
}

export interface RateCardRelatedObjectDto {
    id?: string;
    objectType?: string;
    name?: string;
    topics?: RateCardRelatedObjectPriceTopicDto[];
}

export interface RateCardRelatedObjectPriceTopicDto {
    id?: string;
    title?: string;
    priceOptions?: RateCardRelatedObjectPriceOptionDto[];
    topics?: RateCardRelatedObjectPriceTopicDto[];
}

export interface RateCardRelatedObjectPriceOptionDto {
    selected?: boolean;
    id?: string;
    title?: string;
    applyPricePerDuration?: boolean;
    priceIntervalDuration?: Duration | undefined;
    rateCardPricingType?: RateCardPricingType;
    priceRules?: RateCardPriceRuleDefinitionDto[];
}

export interface RateCardEditDialogItemDto {
    name?: string;
    priceRuleDefinitions?: RateCardPriceRuleDefinitionDto[];
}

export interface GetRateCardEditDialogViewQuery {
    relatedObjectType?: string;
    relatedObjectId?: string;
    rateCardId?: string;
}

export interface GetPricingOverviewQueryResult {
    selectedPeriodId?: string | undefined;
    periodConfig?: GetPricingOverviewQueryResultPeriodConfig;
    dataView?: GetPricingOverviewDataQueryResult;
}

export interface GetPricingOverviewQueryResultPeriodConfig {
    id?: string | undefined;
    periods?: GetPricingOverviewQueryResultPeriod[];
}

export interface GetPricingOverviewQueryResultPeriod {
    periodId?: string;
    name?: string;
    fromDate?: DateTime;
    toDate?: DateTime;
    _ExtraDescription?: string | undefined;
    _ExtraHighlight?: boolean;
}

export interface GetPricingOverviewDataQueryResult {
    rateCardItems?: PricingOverviewRateCardItem[];
}

export interface PricingOverviewRateCardItem {
    relatedObjectId?: string;
    active?: boolean;
    relatedObjectName?: string;
    relatedObjectType?: string;
    rateCardId?: string | undefined;
    posArticlesAssigned?: boolean;
    rateCardName?: string | undefined;
    priceLevels?: PricingOverviewPriceLevel[];
}

export interface PricingOverviewPriceLevel {
    priceLevelId?: string;
    name?: string;
    priceRules?: PricingOverviewPriceLevelRule[];
}

export interface PricingOverviewPriceLevelRule {
    priceRuleDefinitionId?: string;
    surcharge?: boolean;
    isRebate?: boolean;
    price?: number;
    priceRuleDefinitionData?: PricingOverviewPriceRuleDefinition | undefined;
    surchargePriceRuleDefinitionData?: PricingOverviewPriceRuleDefinition | undefined;
    _PosArticle?: PricingOverviewPosArticle | undefined;
}

export interface PricingOverviewPriceRuleDefinition {
    programName?: string;
    programStepName?: string;
    programStepId?: string;
    rateCardPricingType?: RateCardPricingType;
    applyPricePerDuration?: boolean;
    applyPricePerDurationInterval?: boolean;
    priceIntervalDuration?: Duration | undefined;
    ageGroupId?: string;
    fromAge?: number;
    toAge?: number;
    ageGroupName?: string;
    priceLineUnitName?: string;
    minTotalPersonCount?: number;
    maxTotalPersonCount?: number;
    isRebate?: boolean;
}

export interface PricingOverviewPosArticle {
    name?: string;
    priceInclVat?: number;
}

export interface GetPricingOverviewQuery {
    periodId?: string | undefined;
}

export interface GetPricingOverviewDataQuery {
    periodId?: string | undefined;
}

export interface CalculateRateCardStartingPriceCommand {
    rateCardId?: string;
    priceLevelId?: string;
    fromDate?: DateTime;
    bookingParty?: RateCardBookingPartyDto;
    priceLevel?: RateCardPriceLevelDto;
}

export interface GetRateCardPeriodConfigEditItemViewQueryResult {
    relatedObjectType?: string;
    relatedObjectId?: string;
    rateCardPeriodConfigId?: string | undefined;
    input?: GetRateCardPeriodConfigEditItemViewEditItem | undefined;
    output?: GetRateCardPeriodConfigEditItemViewEditItem | undefined;
    periodConfig?: GetRateCardPeriodConfigEditItemViewPeriodConfig | undefined;
    rateCards?: GetRateCardPeriodConfigEditItemViewRateCard[];
}

export interface GetRateCardPeriodConfigEditItemViewEditItem {
    periods?: GetRateCardPeriodConfigEditItemViewPeriodAssignment[];
}

export interface GetRateCardPeriodConfigEditItemViewPeriodAssignment {
    rateCardId?: string | undefined;
    rateCardName?: string;
    periodId?: string;
    periodName?: string;
}

export interface GetRateCardPeriodConfigEditItemViewPeriodConfig {
    id?: string;
    periods?: GetRateCardPeriodConfigEditItemViewPeriod[];
}

export interface GetRateCardPeriodConfigEditItemViewPeriod {
    periodId?: string;
    name?: string;
    fromDate?: DateTime;
    toDate?: DateTime;
    _ExtraDescription?: string | undefined;
    _ExtraHighlight?: boolean;
}

export interface GetRateCardPeriodConfigEditItemViewRateCard {
    id?: string | undefined;
    name?: string;
    createdOnDate?: DateTime;
    active?: boolean;
}

export interface GetRateCardPeriodConfigEditItemViewQuery {
    relatedObjectType?: string;
    relatedObjectId?: string;
}

export interface RemoveSelectOptionCommand {
    questionId?: string;
    optionId?: string;
}

export interface RemoveOptionCountOptionCommand {
    questionId?: string;
    optionId?: string;
}

export interface GetQuestionQueryResult {
    id?: string;
    prompt?: LocalizedStaticText;
    answerFormat?: QuestionAnswerFormatDto;
    isRequired?: boolean;
    allowsCustomRemarks?: boolean;
    isInternal?: boolean;
    usedBy?: GetQuestionQueryResultActivity[];
}

export interface QuestionAnswerFormatDto {
    answerKind: string;
}

export interface TextAnswerFormatDto extends QuestionAnswerFormatDto {
    minLength?: number;
    maxLength?: number;
}

export interface CheckAnswerFormatDto extends QuestionAnswerFormatDto {
    checkStatement?: LocalizedStaticText;
    isCheckedByDefault?: boolean;
}

export interface SelectAnswerFormatDto extends QuestionAnswerFormatDto {
    options?: SelectOptionDto[];
    display?: SelectAnswerDisplayDto;
}

export interface SelectOptionDto {
    optionId?: string;
    text?: LocalizedStaticText;
}

export enum SelectAnswerDisplayDto {
    List = "List",
    Dropdown = "Dropdown",
}

export interface OptionCountAnswerFormatDto extends QuestionAnswerFormatDto {
    options?: OptionCountOptionDto[];
    hasParticipantLimit?: boolean;
}

export interface OptionCountOptionDto {
    optionId?: string;
    text?: LocalizedStaticText;
}

export interface GetQuestionQueryResultActivity {
    activityId?: string;
    name?: string;
}

export interface GetQuestionQuery {
    questionId?: string;
}

export interface GetLocationQuestionsQueryResult {
    questions?: GetLocationQuestionsQueryResultQuestion[];
}

export interface GetLocationQuestionsQueryResultQuestion {
    id?: string;
    prompt?: LocalizedStaticText;
    answerFormat?: QuestionAnswerFormatDto;
    isRequired?: boolean;
    allowsCustomRemarks?: boolean;
    isInternal?: boolean;
    assignedActivityCount?: number;
}

export interface DeleteQuestionCommandRefusal {
    assignedToActivities?: DeleteQuestionCommandRefusalActivity[];
}

export interface DeleteQuestionCommandRefusalActivity {
    activityId?: string;
    name?: string;
}

export interface DeleteQuestionCommand {
    questionId?: string;
}

export interface CreateTextQuestionCommandResponse {
    questionId?: string;
}

export interface CreateTextQuestionCommand {
    prompt?: string;
}

export interface CreateSelectQuestionCommandResponse {
    questionId?: string;
}

export interface CreateSelectQuestionCommand {
    prompt?: string;
    optionTexts?: string[];
}

export interface CreateOptionCountQuestionCommandResponse {
    questionId?: string;
}

export interface CreateOptionCountQuestionCommand {
    prompt?: string;
    optionTexts?: string[];
}

export interface CreateCheckQuestionCommandResponse {
    questionId?: string;
}

export interface CreateCheckQuestionCommand {
    prompt?: string;
    checkStatement?: string;
}

export interface ChangeTextAnswerLengthBoundsCommand {
    questionId?: string;
    minLength?: number;
    maxLength?: number;
}

export interface ChangeSelectOptionTextCommand {
    questionId?: string;
    optionId?: string;
    text?: string;
}

export interface ChangeSelectDisplayCommand {
    questionId?: string;
    display?: SelectAnswerDisplayDto;
}

export interface ChangeQuestionSettingsCommand {
    questionId?: string;
    isRequired?: boolean;
    allowsCustomRemarks?: boolean;
    isInternal?: boolean;
}

export interface ChangeQuestionPromptCommand {
    questionId?: string;
    prompt?: string;
}

export interface ChangeOptionCountParticipantLimitCommand {
    questionId?: string;
    hasParticipantLimit?: boolean;
}

export interface ChangeOptionCountOptionTextCommand {
    questionId?: string;
    optionId?: string;
    text?: string;
}

export interface ChangeCheckAnswerCommand {
    questionId?: string;
    checkStatement?: string;
    isCheckedByDefault?: boolean;
}

export interface AddSelectOptionCommandResponse {
    optionId?: string;
}

export interface AddSelectOptionCommand {
    questionId?: string;
    text?: string;
}

export interface AddOptionCountOptionCommandResponse {
    optionId?: string;
}

export interface AddOptionCountOptionCommand {
    questionId?: string;
    text?: string;
}

export interface ReorderActivityQuestionsCommand {
    activityId?: string;
    questionIds?: string[];
}

export interface RemoveActivityQuestionCommand {
    activityId?: string;
    questionId?: string;
}

export interface GetActivityQuestionsQueryResult {
    questions?: GetActivityQuestionsQueryResultQuestion[];
}

export interface GetActivityQuestionsQueryResultQuestion {
    id?: string;
    prompt?: LocalizedStaticText;
    answerFormat?: QuestionAnswerFormatDto;
    isRequired?: boolean;
    allowsCustomRemarks?: boolean;
    isInternal?: boolean;
}

export interface GetActivityQuestionsQuery {
    activityId?: string;
}

export interface AddActivityQuestionCommand {
    activityId?: string;
    questionId?: string;
}

export interface SetPromotionNameCommand {
    promotionId?: string;
    name?: string;
}

export interface SetPromotionEffectCommand {
    promotionId?: string;
    effect?: PromotionEffectRequest;
}

export interface PromotionEffectRequest {
    effectKind: string;
}

export interface PromotionPercentageDiscountEffectRequest extends PromotionEffectRequest {
    discountRate?: number;
    maximumDiscountAmount?: number;
    target?: PromotionEffectTargetRequest;
}

export interface PromotionEffectTargetRequest {
    targetScope: string;
}

export interface PromotionWholeOrderEffectTargetRequest extends PromotionEffectTargetRequest {
}

export interface PromotionActivityEffectTargetRequest extends PromotionEffectTargetRequest {
    activityId?: string;
}

export interface PromotionFixedAmountDiscountEffectRequest extends PromotionEffectRequest {
    discountAmount?: number;
    target?: PromotionEffectTargetRequest;
}

export interface ListPromotionsQueryResult {
    promotions?: ListPromotionsQueryResultPromotion[];
}

export interface ListPromotionsQueryResultPromotion {
    promotionId?: string;
    name?: string;
    activation?: PromotionActivationKindDto;
    state?: PromotionStateDto;
    redemptionWindowHasEnded?: boolean;
    redemptionWindowFromDate?: DateTime;
    redemptionWindowToDate?: DateTime;
    effect?: ListPromotionsQueryResultEffect;
    target?: ListPromotionsQueryResultTarget;
}

export enum PromotionActivationKindDto {
    Code = "Code",
    Automatic = "Automatic",
}

export enum PromotionStateDto {
    Draft = "Draft",
    Active = "Active",
    Disabled = "Disabled",
}

export interface ListPromotionsQueryResultEffect {
    effectKind: string;
}

export interface ListPromotionsQueryResultPercentageDiscountEffect extends ListPromotionsQueryResultEffect {
    discountRate?: number;
    maximumDiscountAmount?: number;
}

export interface ListPromotionsQueryResultFixedAmountDiscountEffect extends ListPromotionsQueryResultEffect {
    discountAmount?: number;
}

export interface ListPromotionsQueryResultTarget {
    scope?: PromotionTargetScopeDto;
    activityId?: string | undefined;
    activityName?: string | undefined;
}

export enum PromotionTargetScopeDto {
    WholeOrder = "WholeOrder",
    Activity = "Activity",
}

export interface GetPromotionsByIdsQueryResult {
    promotions?: PromotionInfoDto[];
}

export interface PromotionInfoDto {
    promotionId?: string;
    name?: string;
    activation?: PromotionActivationKindDto;
    discount?: PromotionDiscountDto;
    target?: PromotionTargetDto;
    conditions?: PromotionConditionDto[];
}

export interface PromotionDiscountDto {
    kind?: PromotionDiscountKindDto;
    discountRate?: number | undefined;
    maximumDiscountAmount?: number | undefined;
    discountAmount?: number | undefined;
}

export enum PromotionDiscountKindDto {
    PercentageDiscount = "PercentageDiscount",
    FixedAmountDiscount = "FixedAmountDiscount",
}

export interface PromotionTargetDto {
    scope?: PromotionTargetScopeDto;
    activityId?: string | undefined;
}

export interface PromotionConditionDto {
    kind?: PromotionConditionKindDto;
    days?: DayOfWeek[] | undefined;
}

export enum PromotionConditionKindDto {
    ItineraryForDayOfWeek = "ItineraryForDayOfWeek",
}

export interface GetPromotionsByIdsQuery {
    promotionIds?: string[];
}

export interface CreateDraftPromotionCommandResponse {
    promotionId?: string;
}

export interface CreateDraftPromotionCommand {
    name?: string;
    activation?: PromotionActivationKindDto;
    effect?: PromotionEffectRequest;
}

export interface ErrorResponse {
    code?: string;
    message?: string;
}

export interface GetProgramStartDateTimesForArrivalDateQueryResult {
    programId?: string;
    arrivalDate?: DateTime;
    startTimeDurationOptions?: DurationOptions | undefined;
    startDateTimes?: GetProgramStartDateTimesForArrivalDateQueryResultStartDateTime[];
}

export interface GetProgramStartDateTimesForArrivalDateQueryResultStartDateTime {
    trackId?: string;
    startDateTime?: DateTime;
    startTime?: Duration;
}

export interface GetProgramStartDateTimesForArrivalDateQuery {
    programId?: string;
    arrivalDate?: DateTime;
}

export interface GetProgramListViewQueryResult {
    programs?: GetProgramListViewQueryResultItem[];
}

export interface GetProgramListViewQueryResultItem {
    id?: string;
    name?: string;
    orderIndex?: number;
    active?: boolean;
    forPublicUse?: boolean;
    allowCustomSteps?: boolean;
    isFavorite?: boolean;
    fromDate?: DateTime | undefined;
    toDate?: DateTime | undefined;
    onlineBookingPriceZeroAllowed?: boolean;
    depositPolicyConfig?: GetProgramListViewQueryResultDepositPolicyConfig;
}

export interface GetProgramListViewQueryResultDepositPolicyConfig {
    planner?: ProgramDepositPolicyKindDto;
    cmsSite?: ProgramDepositPolicyKindDto;
}

export enum ProgramDepositPolicyKindDto {
    NoDepositRequired = "NoDepositRequired",
    FullGrossAmount = "FullGrossAmount",
    PerAgeGroupPerPerson = "PerAgeGroupPerPerson",
    FixedAmountPerUnit = "FixedAmountPerUnit",
    PercentageOfTotal = "PercentageOfTotal",
}

export interface GetProgramListViewQuery {
}

export interface GetProgramEditItemLinkViewQueryResult {
    programId?: string;
    relatedObjects?: GetProgramEditItemLinkViewQueryResultRelatedObject[];
}

export interface GetProgramEditItemLinkViewQueryResultRelatedObject {
    relatedObjectName?: string;
    relatedObjectId?: string;
    relatedObjectType?: string;
    relatedObjectActive?: boolean | undefined;
}

export interface GetProgramEditItemLinkViewQuery {
    programId?: string;
}

export interface GetProgramBookingPartyConfigQueryResult {
    minTotalPersonCount?: number;
    maxTotalPersonCount?: number;
    ageGroups?: GetProgramBookingPartyConfigQueryResultAgeGroup[];
}

export interface GetProgramBookingPartyConfigQueryResultAgeGroup {
    ageGroupId?: string;
}

export interface GetProgramBookingPartyConfigQuery {
    programId?: string;
}

export interface GetProgramArrivalDateAvailabilityForMonthQueryResult {
    programId?: string;
    year?: number;
    month?: number;
    dates?: GetProgramArrivalDateAvailabilityForMonthQueryResultDate[];
}

export interface GetProgramArrivalDateAvailabilityForMonthQueryResultDate {
    date?: DateTime;
    isAvailable?: boolean;
}

export interface GetProgramArrivalDateAvailabilityForMonthQuery {
    programId?: string;
    year?: number;
    month?: number;
}

export interface GetProgramStepListViewQueryResult {
    programSteps?: GetProgramStepListViewQueryResultItem[];
}

export interface GetProgramStepListViewQueryResultItem {
    id?: string;
    name?: string;
    orderIndex?: number;
    active?: boolean;
    allowCustom?: boolean;
    isFavorite?: boolean;
    capacityType?: ResourceCapacityType;
    resourceSelectionMode?: ResourceSelectionMode;
}

export enum ResourceSelectionMode {
    LeftToRightSequential = "LeftToRightSequential",
    RightToLeftSequential = "RightToLeftSequential",
    All = "All",
}

export interface GetProgramStepListViewQuery {
}

export interface GetProgramStepEditItemLinkViewQueryResult {
    programStepId?: string;
    relatedObjects?: GetProgramStepEditItemLinkViewQueryResultRelatedObject[];
}

export interface GetProgramStepEditItemLinkViewQueryResultRelatedObject {
    relatedObjectName?: string;
    relatedObjectId?: string;
    relatedObjectType?: string;
    relatedObjectActive?: boolean | undefined;
}

export interface GetProgramStepEditItemLinkViewQuery {
    programStepId?: string;
}

export interface GetProductAddDialogViewQueryResult {
    dialogTitle?: string;
    output?: ProductViewAddOutput;
    ageGroups?: ProductViewBookingPartyAgeGroup[];
    programSteps?: ProductViewProgramStepSelectListItem[];
    relatedObjects?: ProductViewRelatedObject[];
    units?: ProductViewSelectListItem[];
    leadTimeDurationOptions?: ProductViewDurationOptions;
}

export interface ProductViewAddOutput {
    forPublicUse?: boolean;
    forInternalUse?: boolean;
    unitId?: string;
    orderIndex?: number;
    name?: string;
    description?: string;
    price?: number;
    listPrice?: number;
    posArticle?: ProductViewPosArticle;
    pricingType?: ProductPricingType;
    isProgramStep?: boolean;
    useProgramStepPricing?: boolean;
    programStepId?: string;
    programStepConfig?: ProductViewProgramStepConfig;
    bookingParty?: ProductViewBookingParty;
    relatedObjects?: ProductViewRelatedObject[];
    days?: ProductViewDayOfWeekFilter[];
    leadTimeDuration?: Duration;
}

export interface ProductViewPosArticle {
    name?: string;
    raxArticleId?: string;
    posArticleId?: string;
    priceInclVat?: number;
    vatPercentage?: number;
    itemJsonData?: string;
}

export enum ProductPricingType {
    PerPerson = "PerPerson",
    PerResource = "PerResource",
    PerItem = "PerItem",
}

export interface ProductViewProgramStepConfig {
    programStepConfigId?: string;
    name?: string;
    programStepId?: string;
    orderIndex?: number;
    capacityType?: ResourceCapacityType;
    resourceSelectionMode?: ResourceSelectionMode;
    intervalDuration?: Duration;
    minDuration?: Duration;
    maxDuration?: Duration;
    duration?: Duration;
    startTimeIntervalDuration?: Duration;
    programStepCheckOutOptions?: ProductViewProgramStepCheckOutOptions;
    visible?: boolean;
    locked?: boolean;
    optional?: boolean;
    dynamicDuration?: boolean;
}

export interface ProductViewProgramStepCheckOutOptions {
    allowResourceSelect?: boolean;
    durationOptions?: ProductViewDurationOption[];
}

export interface ProductViewDurationOption {
    orderIndex?: number;
    isDefault?: boolean;
    duration?: Duration;
    weekDays?: ProductViewDayOfWeekFilter[];
}

export interface ProductViewDayOfWeekFilter {
    isActive?: boolean;
    dayIndex?: number;
    dayOfWeek?: DayOfWeek;
}

export interface ProductViewBookingParty {
    totalPersonCount?: number;
    minTotalPersonCount?: number;
    maxTotalPersonCount?: number;
    ageGroups?: ProductViewBookingPartyAgeGroup[];
}

export interface ProductViewBookingPartyAgeGroup {
    _Selected?: boolean;
    ageGroupId?: string;
    fromAge?: number;
    toAge?: number;
    count?: number;
    unitPlural?: string;
    unitSingular?: string;
    maxCount?: number;
    minCount?: number;
    orderIndex?: number;
}

export interface ProductViewRelatedObject {
    relatedObjectName?: string;
    relatedObjectId?: string;
    relatedObjectType?: string;
    relatedObjectActive?: boolean | undefined;
}

export interface ProductViewProgramStepSelectListItem {
    text?: string;
    value?: string;
    objectType?: string;
    data?: ProductViewProgramStepData;
}

export interface ProductViewProgramStepData {
    programStepId?: string;
    startTimeIntervalDuration?: Duration;
    duration?: Duration;
    minDuration?: Duration;
    maxDuration?: Duration;
    durationOptions?: ProductViewDurationOptions;
    programStepCheckOutOptions?: ProductViewProgramStepCheckOutOptions;
    visible?: boolean;
    locked?: boolean;
    optional?: boolean;
    dynamicDuration?: boolean;
    capacityType?: ResourceCapacityType;
    resourceSelectionMode?: ResourceSelectionMode;
}

export interface ProductViewDurationOptions {
    stepDuration?: Duration;
    minDuration?: Duration;
    maxDuration?: Duration;
}

export interface ProductViewSelectListItem {
    text?: string;
    value?: string;
    objectType?: string;
}

export interface GetProductAddDialogViewQuery {
}

export interface GetProductEditItemViewQueryResult {
    productId?: string;
    productName?: string;
    input?: ProductViewEditItem;
    output?: ProductViewEditItem;
    ageGroups?: ProductViewBookingPartyAgeGroup[];
    relatedObjects?: ProductViewRelatedObject[];
    programSteps?: ProductViewProgramStepSelectListItem[];
    units?: ProductViewSelectListItem[];
    leadTimeDurationOptions?: ProductViewDurationOptions;
    navItems?: ProductViewNavItem[];
}

export interface ProductViewEditItem {
    active?: boolean;
    unitId?: string;
    forPublicUse?: boolean;
    forInternalUse?: boolean;
    name?: string;
    description?: string;
    price?: number;
    listPrice?: number;
    pricingType?: ProductPricingType;
    _PriceIsNegative?: boolean;
    posArticle?: ProductViewPosArticle;
    isProgramStep?: boolean;
    useProgramStepPricing?: boolean;
    programStepId?: string;
    programStepConfig?: ProductViewProgramStepConfig;
    bookingParty?: ProductViewBookingParty;
    relatedObjects?: ProductViewRelatedObject[];
    days?: ProductViewDayOfWeekFilter[];
    leadTimeDuration?: Duration;
    programStepAllowAtStartOfProgram?: boolean;
    programStepAllowAtEndOfProgram?: boolean;
    depositPolicyConfig?: ProductViewDepositPolicyConfig;
}

export interface ProductViewDepositPolicyConfig {
    planner?: ProductViewChannelDepositPolicy;
    cmsSite?: ProductViewChannelDepositPolicy;
}

export interface ProductViewChannelDepositPolicy {
    kind?: ArticleDepositPolicyKindDto;
    fixedAmountPerUnitSettings?: ProductViewFixedAmountPerUnit;
    percentageOfTotalSettings?: ProductViewPercentageOfTotal;
}

export enum ArticleDepositPolicyKindDto {
    NoDepositRequired = "NoDepositRequired",
    FullGrossAmount = "FullGrossAmount",
    FixedAmountPerUnit = "FixedAmountPerUnit",
    PercentageOfTotal = "PercentageOfTotal",
}

export interface ProductViewFixedAmountPerUnit {
    amount?: number;
}

export interface ProductViewPercentageOfTotal {
    percentage?: number;
    maximumAmount?: number;
}

export interface ProductViewNavItem {
    name?: string;
    routeDefinition?: ProductViewRouteDefinition;
}

export interface ProductViewRouteDefinition {
    pathTemplate?: string;
    path?: string;
    queryParams?: { [key: string]: string; };
}

export interface GetProductEditItemViewQuery {
    productId?: string;
}

export interface GetProductListViewQueryResult {
    products?: ProductViewListItem[];
}

export interface ProductViewListItem {
    id?: string;
    orderIndex?: number;
    active?: boolean;
    name?: string;
    price?: number;
    listPrice?: number;
    posArticleName?: string;
    isProgramStep?: boolean;
    useProgramStepPricing?: boolean;
    forPublicUse?: boolean;
    forInternalUse?: boolean;
}

export interface GetProductListViewQuery {
}

export interface SetRateCardAmountsCommand {
    rateCardId?: string;
    writes?: RateCardAmountWriteDto[];
}

export interface RateCardAmountWriteDto {
    slotKey?: string;
    priceLevelId?: string;
    amount?: number | undefined;
}

export interface ScheduleLevelTransitionCommand {
    rateCardId?: string;
    day?: DayOfWeek;
    time?: DateTime;
    priceLevelId?: string;
}

export interface RemoveLevelTransitionCommand {
    rateCardId?: string;
    day?: DayOfWeek;
    time?: DateTime;
}

export interface MoveLevelTransitionCommand {
    rateCardId?: string;
    day?: DayOfWeek;
    fromTime?: DateTime;
    toTime?: DateTime;
}

export interface GetActivityRateCardsViewQueryResult {
    setExists?: boolean;
    defaultRateCardId?: string | undefined;
    cards?: RateCardViewDto[];
    components?: RateCardComponentViewDto[];
    priceLevels?: RateCardPriceLevelViewDto[];
    ageGroups?: PriceStructureAgeGroupDto[];
}

export interface RateCardViewDto {
    rateCardId?: string;
    isDefault?: boolean;
    name?: string | undefined;
    daySchedules?: RateCardDayScheduleViewDto[];
    amounts?: RateCardAmountViewDto[];
}

export interface RateCardDayScheduleViewDto {
    day?: DayOfWeek;
    startPriceLevelId?: string | undefined;
    transitions?: RateCardDayTransitionViewDto[];
}

export interface RateCardDayTransitionViewDto {
    time?: DateTime;
    priceLevelId?: string;
}

export interface RateCardAmountViewDto {
    slotKey?: string;
    priceLevelId?: string;
    amount?: number;
}

export interface RateCardComponentViewDto {
    priceComponentId?: string;
    name?: string;
    chargeBasis?: PriceComponentChargeBasisDto;
    timeScope?: PriceComponentTimeScopeDto;
    timeUnit?: Duration | undefined;
    partialUnitPolicy?: PricingPartialUnitPolicyDto | undefined;
    rateForm?: PriceComponentRateFormDto;
    tierBoundaryFroms?: number[] | undefined;
    tierMode?: PricingTierModeDto | undefined;
    differentiateByAgeGroups?: boolean | undefined;
    bracketBasis?: PricingBracketBasisDto | undefined;
    slots?: RateCardSlotViewDto[];
}

export enum PriceComponentChargeBasisDto {
    PerResource = "PerResource",
    PerParticipant = "PerParticipant",
    PerBooking = "PerBooking",
}

export enum PriceComponentTimeScopeDto {
    DurationIndependent = "DurationIndependent",
    PerTimeUnit = "PerTimeUnit",
}

export enum PricingPartialUnitPolicyDto {
    Proportional = "Proportional",
    PerStartedUnit = "PerStartedUnit",
}

export enum PriceComponentRateFormDto {
    Flat = "Flat",
    TieredByCount = "TieredByCount",
    TieredByDuration = "TieredByDuration",
}

export enum PricingTierModeDto {
    Graduated = "Graduated",
    Volume = "Volume",
}

export enum PricingBracketBasisDto {
    TotalParticipants = "TotalParticipants",
    PerAgeGroup = "PerAgeGroup",
}

export interface RateCardSlotViewDto {
    slotKey?: string;
    bracketFrom?: number | undefined;
    ageGroupId?: string | undefined;
}

export interface RateCardPriceLevelViewDto {
    priceLevelId?: string;
    name?: string;
    color?: string;
    sortOrder?: number;
    isActive?: boolean;
}

export interface PriceStructureAgeGroupDto {
    ageGroupId?: string;
    name?: string;
}

export interface GetActivityRateCardsViewQuery {
    activityId?: string;
}

export interface CreateActivityRateCardSetCommandResponse {
    activityRateCardSetId?: string;
    defaultRateCardId?: string;
}

export interface CreateActivityRateCardSetCommand {
    activityId?: string;
}

export interface CopyDayScheduleCommand {
    rateCardId?: string;
    fromDay?: DayOfWeek;
    toDays?: DayOfWeek[];
}

export interface ChangeLevelTransitionTargetCommand {
    rateCardId?: string;
    day?: DayOfWeek;
    time?: DateTime;
    priceLevelId?: string;
}

export interface ChangeDayStartLevelCommand {
    rateCardId?: string;
    day?: DayOfWeek;
    priceLevelId?: string;
}

export interface RestorePriceComponentCommand {
    activityId?: string;
    priceComponentId?: string;
}

export interface RemovePriceComponentCommand {
    activityId?: string;
    priceComponentId?: string;
}

export interface RedefinePerResourceComponentCommand {
    activityId?: string;
    priceComponentId?: string;
    definition?: PriceStructureDefinitionDto;
}

export interface PriceStructureDefinitionDto {
    timeScope?: PriceComponentTimeScopeDto;
    timeUnit?: Duration | undefined;
    partialUnitPolicy?: PricingPartialUnitPolicyDto | undefined;
    rateForm?: PriceComponentRateFormDto;
    tierBoundaryFroms?: number[] | undefined;
    tierMode?: PricingTierModeDto | undefined;
    differentiateByAgeGroups?: boolean | undefined;
    bracketBasis?: PricingBracketBasisDto | undefined;
}

export interface RedefinePerParticipantComponentCommand {
    activityId?: string;
    priceComponentId?: string;
    definition?: PriceStructureDefinitionDto;
}

export interface RedefinePerBookingComponentCommand {
    activityId?: string;
    priceComponentId?: string;
    definition?: PriceStructureDefinitionDto;
}

export interface PublishPriceStructureDraftCommand {
    activityId?: string;
}

export interface GetPriceStructureDraftPreparationViewQueryResult {
    canPublish?: boolean;
    cards?: PreparationCardViewDto[];
}

export interface PreparationCardViewDto {
    rateCardId?: string;
    isDefault?: boolean;
    name?: string | undefined;
    newCellCount?: number;
    filledNewCellCount?: number;
    missingCellCount?: number;
}

export interface GetPriceStructureDraftPreparationViewQuery {
    activityId?: string;
}

export interface GetActivityPriceStructureViewQueryResult {
    structureExists?: boolean;
    hasDraft?: boolean;
    activeComponents?: PriceStructureComponentViewDto[];
    draftComponents?: PriceStructureComponentViewDto[] | undefined;
    ageGroups?: PriceStructureAgeGroupDto[];
}

export interface PriceStructureComponentViewDto {
    priceComponentId?: string;
    name?: string;
    chargeBasis?: PriceComponentChargeBasisDto;
    status?: PriceComponentStatusDto;
    timeScope?: PriceComponentTimeScopeDto;
    timeUnit?: Duration | undefined;
    partialUnitPolicy?: PricingPartialUnitPolicyDto | undefined;
    rateForm?: PriceComponentRateFormDto;
    tierBoundaryFroms?: number[] | undefined;
    tierMode?: PricingTierModeDto | undefined;
    differentiateByAgeGroups?: boolean | undefined;
    bracketBasis?: PricingBracketBasisDto | undefined;
    slots?: PriceStructureSlotViewDto[];
}

export enum PriceComponentStatusDto {
    Active = "Active",
    Retired = "Retired",
}

export interface PriceStructureSlotViewDto {
    slotKey?: string;
    bracketFrom?: number | undefined;
    ageGroupId?: string | undefined;
}

export interface GetActivityPriceStructureViewQuery {
    activityId?: string;
}

export interface DiscardPriceStructureDraftCommand {
    activityId?: string;
}

export interface CreatePriceStructureDraftCommand {
    activityId?: string;
}

export interface CreateActivityPriceStructureCommand {
    activityId?: string;
}

export interface AddPerResourceComponentCommandResponse {
    priceComponentId?: string;
}

export interface AddPerResourceComponentCommand {
    activityId?: string;
    priceComponentId?: string;
    definition?: PriceStructureDefinitionDto;
}

export interface AddPerParticipantComponentCommandResponse {
    priceComponentId?: string;
}

export interface AddPerParticipantComponentCommand {
    activityId?: string;
    priceComponentId?: string;
    definition?: PriceStructureDefinitionDto;
}

export interface AddPerBookingComponentCommandResponse {
    priceComponentId?: string;
}

export interface AddPerBookingComponentCommand {
    activityId?: string;
    priceComponentId?: string;
    definition?: PriceStructureDefinitionDto;
}

export interface SetPriceLevelNameCommand {
    priceLevelId?: string;
    name?: LocalizedStaticText;
}

export interface ReorderPriceLevelsCommand {
    orderedPriceLevelIds?: string[];
}

export interface ReactivatePriceLevelCommand {
    priceLevelId?: string;
}

export interface GetPriceLevelUsageQueryResult {
    priceLevelUsages?: PriceLevelUsageDto[];
}

export interface PriceLevelUsageDto {
    priceLevelId?: string;
    rateCardCount?: number;
}

export interface GetPriceLevelUsageQuery {
}

export interface GetLocationPriceLevelsConfigQueryResult {
    priceLevels?: PriceLevelDto[];
}

export interface PriceLevelDto {
    priceLevelId?: string;
    name?: LocalizedStaticText;
    label?: string;
    color?: string;
    sortOrder?: number;
    isActive?: boolean;
}

export interface GetLocationPriceLevelsConfigQuery {
}

export interface GetCanDeactivatePriceLevelViewQueryResult {
    isReferenced?: boolean;
    affectedRateCards?: AffectedRateCardViewDto[];
}

export interface AffectedRateCardViewDto {
    activityId?: string;
    activityName?: string;
    rateCardId?: string;
    isDefault?: boolean;
    rateCardName?: string | undefined;
}

export interface GetCanDeactivatePriceLevelViewQuery {
    priceLevelId?: string;
}

export interface DefinePriceLevelCommandResponse {
    priceLevelId?: string;
}

export interface DefinePriceLevelCommand {
    name?: LocalizedStaticText;
    color?: string;
}

export interface DeactivatePriceLevelCommand {
    priceLevelId?: string;
}

export interface CreateLocationPriceLevelsCommand {
}

export interface ChangePriceLevelColorCommand {
    priceLevelId?: string;
    color?: string;
}

export interface SetPriceComponentNameCommand {
    priceComponentId?: string;
    name?: LocalizedStaticText;
}

export interface RetirePriceComponentCommand {
    priceComponentId?: string;
}

export interface GetLocationPriceComponentsViewQueryResult {
    priceComponents?: PriceComponentViewDto[];
}

export interface PriceComponentViewDto {
    priceComponentId?: string;
    name?: LocalizedStaticText;
    label?: string;
    chargeBasis?: PriceComponentChargeBasisDto;
    status?: PriceComponentStatusDto;
    retiredAt?: DateTime | undefined;
    referencedByActivityIds?: string[];
}

export interface GetLocationPriceComponentsViewQuery {
}

export interface CreatePriceComponentCommandResponse {
    priceComponentId?: string;
}

export interface CreatePriceComponentCommand {
    name?: LocalizedStaticText;
    chargeBasis?: PriceComponentChargeBasisDto;
}

export interface SetLocationDepositRuleCommand {
    rule?: DepositRuleDto;
}

export interface DepositRuleDto {
    kind?: DepositRuleKindDto;
    amount?: number | undefined;
    percentage?: number | undefined;
    maximumAmount?: number | undefined;
}

export enum DepositRuleKindDto {
    NoDeposit = "NoDeposit",
    FullAmount = "FullAmount",
    PercentageOfTotal = "PercentageOfTotal",
    FixedAmountPerParticipant = "FixedAmountPerParticipant",
    FixedAmountPerActivity = "FixedAmountPerActivity",
}

export interface SetLocationDepositDueWindowCommand {
    channel?: DepositChannelDto;
    dueWithinMinutes?: number;
}

export enum DepositChannelDto {
    Planner = "Planner",
    CmsSite = "CmsSite",
    ConnectApi = "ConnectApi",
}

export interface SetLocationDepositChannelApplicabilityCommand {
    channel?: DepositChannelDto;
    applicability?: DepositChannelApplicabilityDto;
}

export enum DepositChannelApplicabilityDto {
    Applies = "Applies",
    Waived = "Waived",
}

export interface SetActivityDepositOverrideCommandResponse {
    activityDepositPolicyOverrideId?: string;
}

export interface SetActivityDepositOverrideCommand {
    activityId?: string;
    rule?: DepositRuleDto;
}

export interface RemoveActivityDepositOverrideCommand {
    activityId?: string;
}

export interface GetLocationDepositPolicyViewQueryResult {
    locationDepositPolicyId?: string;
    rule?: DepositRuleDto;
    plannerApplicability?: DepositChannelApplicabilityDto;
    cmsSiteApplicability?: DepositChannelApplicabilityDto;
    connectApiApplicability?: DepositChannelApplicabilityDto;
    plannerDueWithinMinutes?: number | undefined;
    cmsSiteDueWithinMinutes?: number | undefined;
    connectApiDueWithinMinutes?: number | undefined;
}

export interface GetLocationDepositPolicyViewQuery {
}

export interface GetActivityDepositPolicyViewQueryResult {
    activityId?: string;
    override?: DepositRuleDto | undefined;
    locationRule?: DepositRuleDto | undefined;
    effectiveRule?: DepositRuleDto;
    plannerApplicability?: DepositChannelApplicabilityDto | undefined;
    cmsSiteApplicability?: DepositChannelApplicabilityDto | undefined;
    connectApiApplicability?: DepositChannelApplicabilityDto | undefined;
}

export interface GetActivityDepositPolicyViewQuery {
    activityId?: string;
}

export interface CreateLocationDepositPolicyCommandResponse {
    locationDepositPolicyId?: string;
}

export interface CreateLocationDepositPolicyCommand {
}

export interface SetPosTableSelectionRequestDto {
    enabled?: boolean;
    hiddenAreaIds?: string[];
    areaOrder?: string[];
}

export interface PosTableSelectionSettingsView {
    supported?: boolean;
    enabled?: boolean;
    hiddenAreaIds?: string[];
    areaOrder?: string[];
    areas?: PosTableSelectionSettingsAreaView[] | undefined;
    areasError?: string | undefined;
}

export interface PosTableSelectionSettingsAreaView {
    areaId?: string;
    name?: string;
    tableCount?: number;
}

export interface GetPosArticlePickerViewQueryResult {
    dialogTitle?: string;
    posArticleConfigId?: string;
    articles?: PosArticleListItem[];
}

export interface PosArticleListItem {
    name?: string;
    priceInclVat?: number;
    vatPercentage?: number;
    raxArticleId?: string;
    posArticleId?: string;
    state?: PosArticleState;
}

export enum PosArticleState {
    New = "New",
    Same = "Same",
    Changed = "Changed",
    Removed = "Removed",
}

export interface GetPosArticlePickerViewQuery {
}

export interface GetPosArticleConfigListPageViewQueryResult {
    posArticleConfigs?: PosArticleConfigListItem[];
}

export interface PosArticleConfigListItem {
    id?: string;
    name?: string;
    active?: boolean;
    createdOnDate?: DateTime;
    updatedOnDate?: DateTime;
}

export interface GetPosArticleConfigListPageViewQuery {
}

export interface GetPosArticleConfigEditItemPageViewQueryResult {
    posArticleConfigId?: string;
    active?: boolean;
    isDirty?: boolean;
    input?: PosArticleConfigEditItem;
    output?: PosArticleConfigEditItem;
    articles?: PosArticleListItem[];
    navItems?: NavItemView[];
}

export interface PosArticleConfigEditItem {
    name?: string;
    description?: string;
}

export interface NavItemView {
    name?: string;
    routeDefinition?: NavItemRouteView;
}

export interface NavItemRouteView {
    path?: string;
}

export interface GetPosArticleConfigEditItemPageViewQuery {
    posArticleConfigId?: string;
}

export interface GetPosArticleConfigArticleDetailsDialogViewQueryResult {
    dialogTitle?: string;
    posArticle?: PosArticleItemDetails;
}

export interface PosArticleItemDetails {
    name?: string;
    priceInclVat?: number;
    vatPercentage?: number;
    raxArticleId?: string;
    posArticleId?: string;
    state?: PosArticleState;
    itemJsonData?: string;
}

export interface GetPosArticleConfigArticleDetailsDialogViewQuery {
    posArticleConfigId?: string;
    raxArticleId?: string;
}

export interface StartPosArticleBookingSyncCommandResult {
    runId?: string;
}

export interface StartPosArticleBookingSyncCommand {
}

export interface PreviewPosArticleBookingSyncQueryResult {
    hasActiveArticleList?: boolean;
    activeArticleListName?: string | undefined;
    activeArticleListUpdatedAt?: DateTime | undefined;
    candidateCount?: number;
    willUpdateCount?: number;
    alreadyCorrectCount?: number;
    incompleteCount?: number;
    lockedCount?: number;
    issues?: PosArticleBookingSyncIssue[];
    issuesTruncated?: boolean;
}

export interface PosArticleBookingSyncIssue {
    bookingId?: string;
    bookingCode?: string;
    fromDate?: DateTime;
    outcome?: PosArticleBookingSyncIssueOutcome;
    reasons?: PosArticleBookingSyncIssueReason[];
}

export enum PosArticleBookingSyncIssueOutcome {
    Incomplete = "Incomplete",
    Locked = "Locked",
    InPos = "InPos",
    StatusChanged = "StatusChanged",
    NotFound = "NotFound",
    Failed = "Failed",
}

export interface PosArticleBookingSyncIssueReason {
    lineDescription?: string;
    reason?: PosArticleBookingSyncReason;
}

export enum PosArticleBookingSyncReason {
    ArticleNotInActiveList = "ArticleNotInActiveList",
    NoArticleOnRule = "NoArticleOnRule",
    RuleNotFound = "RuleNotFound",
    NoArticleOnProduct = "NoArticleOnProduct",
    ProductNotFound = "ProductNotFound",
    ManualLineWithoutArticle = "ManualLineWithoutArticle",
    SaveFailed = "SaveFailed",
}

export interface PreviewPosArticleBookingSyncQuery {
}

export interface GetLatestPosArticleBookingSyncRunQueryResult {
    run?: PosArticleBookingSyncRun | undefined;
}

export interface PosArticleBookingSyncRun {
    runId?: string;
    requestedBy?: string;
    requestedAt?: DateTime;
    startedAt?: DateTime | undefined;
    finishedAt?: DateTime | undefined;
    status?: PosArticleBookingSyncRunStatus;
    errorMessage?: string | undefined;
    heartbeatAt?: DateTime;
    candidateCount?: number;
    processedCount?: number;
    updatedCount?: number;
    alreadyCorrectCount?: number;
    incompleteCount?: number;
    skippedLockedCount?: number;
    skippedInPosCount?: number;
    skippedStatusChangedCount?: number;
    notFoundCount?: number;
    failedCount?: number;
    issuesTruncated?: boolean;
    issues?: PosArticleBookingSyncIssue[];
}

export enum PosArticleBookingSyncRunStatus {
    Queued = "Queued",
    Running = "Running",
    Completed = "Completed",
    Failed = "Failed",
}

export interface GetLatestPosArticleBookingSyncRunQuery {
}

export interface GetTableAreasQueryResult {
    areas?: PosBookingTableAreaView[];
}

export interface PosBookingTableAreaView {
    areaId?: string;
    name?: string;
}

export interface GetPosBookingEntryDialogViewQueryResult {
    dialogTitle?: string;
    isInProgress?: boolean;
    allowManual?: boolean;
    allowAutomatic?: boolean;
    tableSelectionEnabled?: boolean;
    enterManuallyRequest?: PosBookingEnterManuallyRequestDto;
    enterAutomaticallyRequest?: PosBookingEnterAutomaticallyRequestDto;
}

export interface PosBookingEnterManuallyRequestDto {
    bookingId?: string;
    referenceText?: string;
}

export interface PosBookingEnterAutomaticallyRequestDto {
    bookingId?: string;
    posTableId?: string | undefined;
}

export interface GetPosBookingEntryDialogViewQuery {
    bookingId?: string;
}

export interface GetFreeTablesQueryResult {
    tables?: PosBookingFreeTableView[];
}

export interface PosBookingFreeTableView {
    tableId?: string;
    name?: string;
}

export interface GetFreeTablesQuery {
    areaId?: string;
}

export interface Result {
    exceptionData?: ExceptionData | undefined;
    success?: boolean;
    actionType?: ResultActionType;
    isException?: boolean | undefined;
    reason?: string | undefined;
    jobId?: string | undefined;
}

export interface ResultId extends Result {
    id?: string | undefined;
    versionId?: string | undefined;
}

export interface ExceptionData {
    requestBody?: string | undefined;
    message?: string | undefined;
    source?: string | undefined;
    innerException?: string | undefined;
    stack?: string | undefined;
    exceptionType?: string | undefined;
    requestId?: string | undefined;
    requestPath?: string | undefined;
    requestQuery?: string | undefined;
    actionName?: string | undefined;
}

export enum ResultActionType {
    Undefined = "Undefined",
    Create = "Create",
    Update = "Update",
    Delete = "Delete",
    Read = "Read",
}

export interface PosBookingEnterAutomaticallyResult extends ResultId {
    tableOccupied?: boolean;
}

export interface PosBookingClearRequestDto {
    bookingId?: string;
}

export interface SetLocationEnvironmentOverridesCommand {
    reportingProductionTenantId?: string;
    reportingProductionLocationId?: string;
}

export interface GetLocationEnvironmentOverridesQueryResult {
    reportingProductionTenantId?: string;
    reportingProductionLocationId?: string;
    canOverrideIdentity?: boolean;
}

export interface GetLocationEnvironmentOverridesQuery {
}

export interface GetPlatformDomainsQueryResult {
    tenants?: GetPlatformDomainsQueryResultTenant[];
    totalDomainCount?: number;
}

export interface GetPlatformDomainsQueryResultTenant {
    tenantId?: string;
    tenantIdCode?: string;
    tenantName?: string;
    locations?: GetPlatformDomainsQueryResultLocation[];
}

export interface GetPlatformDomainsQueryResultLocation {
    locationId?: string;
    locationIdCode?: string;
    locationName?: string;
    domains?: GetPlatformDomainsQueryResultDomain[];
}

export interface GetPlatformDomainsQueryResultDomain {
    siteId?: string;
    siteName?: string;
    hostname?: string;
    systemRole?: string;
    systemRoleLabel?: string;
}

export interface GetPlatformDomainsQuery {
}

export interface GetPlatformConfigListPageViewQueryResult {
    platformConfigs?: GetPlatformConfigListPageViewQueryResultItem[];
}

export interface GetPlatformConfigListPageViewQueryResultItem {
    id?: string;
    name?: string;
    active?: boolean;
    navItems?: GetPlatformConfigListPageViewQueryResultNavItem[];
}

export interface GetPlatformConfigListPageViewQueryResultNavItem {
    name?: string;
    path?: string;
}

export interface GetPlatformConfigListPageViewQuery {
}

export interface GetListViewQueryResult {
    serviceId?: string;
    serviceName?: string | undefined;
    logId?: string;
    messageTemplate?: string;
}

export interface GetListViewQuery {
    serviceId?: string;
    logId?: string;
}

export interface GetListDataViewQueryResult {
    lineChartData?: LineChartData;
    logs?: GetListDataViewQueryResultLog[];
}

export interface LineChartData {
    title?: string;
    subtitle?: string;
    dataSeries?: LineChartDataSeries;
}

export interface LineChartDataSeries {
    counts?: number[];
    dates?: DateTime[];
}

export interface GetListDataViewQueryResultLog {
    logId?: string;
    logLevel?: RaxLogLevel;
    message?: string;
    fromDateTicks?: number;
    fromDateText?: string;
    fromDateAgoText?: string;
    isOpened?: boolean;
}

export enum RaxLogLevel {
    Trace = "Trace",
    Debug = "Debug",
    Information = "Information",
    Warning = "Warning",
    Error = "Error",
    Critical = "Critical",
    None = "None",
    Fatal = "Fatal",
}

export interface GetListDataViewQuery {
    serviceId?: string;
    logId?: string;
    fromDate?: DateTime;
}

export interface GetGroupListViewQueryResult {
    serviceId?: string;
    serviceName?: string | undefined;
}

export interface GetGroupListViewQuery {
    serviceId?: string;
}

export interface GetGroupListDataViewQueryResult {
    totalLogCount?: number;
    lineChartData?: LineChartData;
    logGroups?: GetGroupListDataViewQueryResultLogGroup[];
}

export interface GetGroupListDataViewQueryResultLogGroup {
    logId?: string;
    messageTemplate?: string;
    logCount?: number;
    logLevel?: RaxLogLevel;
    message?: string;
    fromDateTicks?: number;
    fromDateText?: string;
    fromDateAgoText?: string;
    toDateTicks?: number;
    toDateText?: string;
    toDateAgoText?: string;
}

export interface GetGroupListDataViewQuery {
    serviceId?: string;
    fromDate?: DateTime;
}

export interface GetEditItemViewQueryResult {
    logId?: string;
    logItem?: GetEditItemViewQueryResultLogItem;
}

export interface GetEditItemViewQueryResultLogItem {
    logId?: string;
    logLevel?: RaxLogLevel;
    fromDate?: DateTime;
    fromDateTicks?: number;
    fromDateText?: string;
    fromDateAgoText?: string;
    message?: string;
    messageTemplate?: string;
    propertiesDataJson?: string;
    exceptionDataJson?: string;
}

export interface GetEditItemViewQuery {
    logId?: string;
}

export interface GetStuckRefundsQueryResult {
    rows?: StuckRefundResult[];
}

export interface StuckRefundResult {
    id?: string;
    status?: PaymentMovementStatus;
    requestedAt?: DateTime;
    failedAt?: DateTime | undefined;
    daysInProgress?: number;
    grossAmount?: number;
    providerId?: string | undefined;
    providerTransactionId?: string | undefined;
    bookingId?: string | undefined;
    isBookingV2?: boolean;
    customerName?: string | undefined;
    failureReason?: string | undefined;
}

export enum PaymentMovementStatus {
    Paid = "Paid",
    Pending = "Pending",
    Processing = "Processing",
    Refunded = "Refunded",
    Failed = "Failed",
}

export interface GetRefundReportQueryResult {
    tiles?: RefundReportTilesResult;
    refunds?: PaymentTransactionResult[];
    declinedProposals?: DeclinedRefundProposalResult[];
}

export interface RefundReportTilesResult {
    refundedTotal?: number;
    refundedCount?: number;
    inProgressTotal?: number;
    inProgressCount?: number;
    feeTotal?: number;
    feeUnknownCount?: number;
    declinedCount?: number;
    declinedTotal?: number;
}

export interface PaymentTransactionResult {
    id?: string;
    kind?: PaymentMovementKind;
    status?: PaymentMovementStatus;
    isSettled?: boolean;
    moneyDate?: DateTime;
    movedAt?: DateTime;
    requestedAt?: DateTime | undefined;
    failedAt?: DateTime | undefined;
    grossAmount?: number;
    feeAmount?: number | undefined;
    feeSource?: PaymentFeeSource;
    netAmount?: number | undefined;
    providerId?: string | undefined;
    paymentMethod?: string | undefined;
    providerTransactionId?: string | undefined;
    bookingId?: string | undefined;
    isBookingV2?: boolean;
    customerName?: string | undefined;
    failureReason?: string | undefined;
    refundProposalId?: string | undefined;
    approvedBy?: string | undefined;
    approvedAt?: DateTime | undefined;
}

export enum PaymentMovementKind {
    Payment = "Payment",
    Refund = "Refund",
}

export enum PaymentFeeSource {
    None = "None",
    Estimated = "Estimated",
    Actual = "Actual",
}

export interface DeclinedRefundProposalResult {
    proposalId?: string;
    declinedDate?: DateTime;
    declinedAt?: DateTime;
    bookingId?: string | undefined;
    isBookingV2?: boolean;
    customerName?: string | undefined;
    amount?: number;
    declinedBy?: string | undefined;
    reason?: string | undefined;
}

export interface GetRefundReportQuery {
    period?: QueryPeriod;
}

export interface GetPaymentVolumeQueryResult {
    rows?: PaymentVolumeRowResult[];
    totals?: PaymentVolumeTotalsResult;
    methods?: PaymentVolumeMethodResult[];
}

export interface PaymentVolumeRowResult {
    periodStart?: DateTime;
    paymentCount?: number;
    grossReceived?: number;
    feeTotal?: number;
    feeEstimatedTotal?: number;
    netReceived?: number;
    refundCount?: number;
    refundedAmount?: number;
    refundFeeTotal?: number;
    pendingRefundCount?: number;
    failedRefundCount?: number;
    netAfterRefunds?: number;
}

export interface PaymentVolumeTotalsResult {
    paymentCount?: number;
    grossReceived?: number;
    feeTotal?: number;
    feeEstimatedTotal?: number;
    netReceived?: number;
    refundCount?: number;
    refundedAmount?: number;
    refundFeeTotal?: number;
    pendingRefundCount?: number;
    failedRefundCount?: number;
    netAfterRefunds?: number;
}

export interface PaymentVolumeMethodResult {
    providerId?: string | undefined;
    paymentMethod?: string | undefined;
    paymentCount?: number;
    grossReceived?: number;
    feeTotal?: number;
    feeEstimatedTotal?: number;
    netReceived?: number;
}

export interface GetPaymentVolumeQuery {
    period?: QueryPeriod;
    grain?: PaymentVolumeGrain;
}

export enum PaymentVolumeGrain {
    Day = "Day",
    Month = "Month",
}

export interface GetPaymentTransactionsQueryResult {
    rows?: PaymentTransactionResult[];
    count?: number;
}

export interface GetPaymentTransactionsQuery {
    period?: QueryPeriod;
    kind?: PaymentMovementKind | undefined;
    status?: PaymentMovementStatus | undefined;
    providerId?: string | undefined;
}

export interface ProviderFeeScheduleResponse {
    rows?: ProviderFeeRowDto[];
}

export interface ProviderFeeRowDto {
    paymentServiceProviderId?: string;
    paymentMethod?: string;
    fixed?: number;
    percentage?: number;
    origin?: string;
}

export interface SetPlatformProviderFeeScheduleCommand {
    rows?: ProviderFeeRowDto[];
}

export interface SetLocationProviderFeeScheduleCommand {
    rows?: ProviderFeeRowDto[];
}

export interface GetPlatformProviderFeeScheduleQuery {
}

export interface GetLocationProviderFeeScheduleQuery {
}

export interface ProviderConnectionDto {
    id?: string;
    paymentServiceProviderId?: string;
    providerDisplayName?: string;
    kind?: ProviderConnectionKind;
    status?: ProviderConnectionStatus;
    mode?: ProviderConnectionMode;
    keyHint?: string | undefined;
    externalAccountId?: string | undefined;
    externalAccountName?: string | undefined;
    profileId?: string | undefined;
    displayName?: string | undefined;
    credentialsVerified?: boolean;
    canTakePayments?: boolean;
    needsProfileSelection?: boolean;
    requiresReauthorization?: boolean;
    canReceiveSettlements?: boolean;
    connectedAt?: DateTime | undefined;
    disconnectedAt?: DateTime | undefined;
    statusCheckedAt?: DateTime | undefined;
    statusNote?: string | undefined;
    usedBy?: string[];
}

export enum ProviderConnectionKind {
    LegacyApiKey = "LegacyApiKey",
    ApiKeyAndAccount = "ApiKeyAndAccount",
    OAuth = "OAuth",
    PlatformAccount = "PlatformAccount",
}

export enum ProviderConnectionStatus {
    NotStarted = "NotStarted",
    AwaitingAuthorization = "AwaitingAuthorization",
    NeedsData = "NeedsData",
    InReview = "InReview",
    Active = "Active",
    Suspended = "Suspended",
    Disconnected = "Disconnected",
}

export enum ProviderConnectionMode {
    Unknown = "Unknown",
    Test = "Test",
    Live = "Live",
}

export interface SelectProviderConnectionProfileCommand {
    connectionId?: string;
    profileId?: string;
}

export interface RenameProviderConnectionCommand {
    providerConnectionId?: string;
    displayName?: string | undefined;
}

export interface ListProviderConnectionsResponse {
    connections?: ProviderConnectionDto[];
    providers?: ProviderOptionDto[];
}

export interface ProviderOptionDto {
    paymentServiceProviderId?: string;
    displayName?: string;
    supportedKinds?: ProviderConnectionKind[];
    requiresAccountId?: boolean;
    supportsOAuth?: boolean;
    oAuthConfigured?: boolean;
    supportsPlatformOnboarding?: boolean;
    platformOnboardingConfigured?: boolean;
}

export interface RefreshProviderConnectionStatusCommand {
    connectionId?: string | undefined;
}

export interface ListProviderConnectionProfilesResponse {
    profiles?: ProviderProfileDto[];
}

export interface ProviderProfileDto {
    id?: string;
    name?: string;
    website?: string | undefined;
    status?: string;
}

export interface ListProviderConnectionProfilesQuery {
    connectionId?: string;
}

export interface DisconnectProviderConnectionCommand {
    providerConnectionId?: string;
}

export interface ConnectProviderWithApiKeyCommand {
    paymentServiceProviderId?: string;
    apiKey?: string;
    accountId?: string | undefined;
    replaceConnectionId?: string | undefined;
    revertConnectionId?: string | undefined;
}

export interface CompleteProviderOAuthResponse {
    outcome?: string;
    tenantId?: string | undefined;
    locationId?: string | undefined;
}

export interface CompleteProviderOAuthCommand {
    paymentServiceProviderId?: string;
    state?: string;
    code?: string | undefined;
    error?: string | undefined;
    errorDescription?: string | undefined;
}

export interface BeginProviderPlatformOnboardingResponse {
    connection?: ProviderConnectionDto;
    onboardingUrl?: string;
}

export interface BeginProviderPlatformOnboardingCommand {
    paymentServiceProviderId?: string;
    legalName?: string;
    tradeName?: string | undefined;
    registrationNumber?: string | undefined;
}

export interface BeginProviderConnectionResponse {
    authorizeUrl?: string;
}

export interface BeginProviderConnectionCommand {
    paymentServiceProviderId?: string;
    connectionId?: string | undefined;
    upgradeConnectionId?: string | undefined;
}

export interface AssignProviderConnectionToPaymentSettingsResponse {
    paymentSettingsId?: string;
}

export interface AssignProviderConnectionToPaymentSettingsCommand {
    paymentConfigId?: string;
    providerConnectionId?: string;
}

export interface SplitAgeGroupCommandResponse {
    newAgeGroupId?: string;
}

export interface SplitAgeGroupCommand {
    ageGroupId?: string;
    lowerMaxAge?: number;
    newGroupText?: LocalizedPluralText;
    newGroupPosition?: SplitAgeGroupPosition;
}

export interface LocalizedPluralText {
    values?: { [key: string]: PluralizedText; };
}

export interface PluralizedText {
    singular?: string;
    plural?: string;
}

export enum SplitAgeGroupPosition {
    Lower = "Lower",
    Upper = "Upper",
}

export interface SetAgeGroupTextCommand {
    ageGroupId?: string;
    text?: LocalizedPluralText;
}

export interface MergeAgeGroupsCommand {
    survivorAgeGroupId?: string;
    absorbedAgeGroupId?: string;
    mergedText?: LocalizedPluralText | undefined;
}

export interface GetLocationAgeGroupsConfigQueryResult {
    locationAgeGroups?: GetLocationAgeGroupsConfigLocationAgeGroups | undefined;
}

export interface GetLocationAgeGroupsConfigLocationAgeGroups {
    locationAgeGroupsId?: string;
    sortOrder?: AgeGroupSortOrder;
    ageGroups?: GetLocationAgeGroupsConfigAgeGroup[];
}

export enum AgeGroupSortOrder {
    Ascending = "Ascending",
    Descending = "Descending",
}

export interface GetLocationAgeGroupsConfigAgeGroup {
    ageGroupId?: string;
    text?: LocalizedPluralText;
    minAge?: number;
    maxAge?: number;
    status?: AgeGroupStatus;
    retiredAt?: DateTime | undefined;
}

export enum AgeGroupStatus {
    Active = "Active",
    Retired = "Retired",
}

export interface CreateLocationAgeGroupsCommand {
    sortOrder?: AgeGroupSortOrder;
    ageGroups?: CreateLocationAgeGroupsAgeGroup[];
}

export interface CreateLocationAgeGroupsAgeGroup {
    text?: LocalizedPluralText;
    minAge?: number;
    maxAge?: number;
}

export interface ChangeAgeGroupSortOrderCommand {
    sortOrder?: AgeGroupSortOrder;
}

export interface AdjustAgeGroupBoundaryCommand {
    ageGroupId?: string;
    newMaxAge?: number;
}

export interface SetPeriodAdjustedOpeningHoursCommand {
    calendarPeriodId?: string;
    adjustedOpeningHoursId?: string;
}

export interface ResolveLocationOpeningHoursForDateQueryResult {
    date?: ResolvedDateOpeningHoursDto | undefined;
}

export interface ResolvedDateOpeningHoursDto {
    date?: DateTime;
    period?: ResolvedOpeningHoursPeriodDto | undefined;
    source?: ResolvedOpeningHoursSource;
    isClosed?: boolean;
    intervals?: OpeningHoursIntervalDto[];
    special?: ResolvedOpeningHoursSpecialDto | undefined;
    adjusted?: ResolvedOpeningHoursAdjustedDto | undefined;
    regular?: ResolvedOpeningHoursRegularDto | undefined;
}

export interface ResolvedOpeningHoursPeriodDto {
    calendarPeriodId?: string;
    name?: string;
}

export enum ResolvedOpeningHoursSource {
    Special = "Special",
    Adjusted = "Adjusted",
    Regular = "Regular",
}

export interface OpeningHoursIntervalDto {
    openingTime?: Duration;
    closingTime?: Duration;
}

export interface ResolvedOpeningHoursSpecialDto {
    specialOpeningHoursId?: string;
    name?: string;
}

export interface ResolvedOpeningHoursAdjustedDto {
    adjustedOpeningHoursId?: string;
    name?: string;
    hasExplicitEntry?: boolean;
}

export interface ResolvedOpeningHoursRegularDto {
    regularOpeningHoursVersionId?: string;
}

export interface ResolveLocationOpeningHoursForDateQuery {
    date?: DateTime;
}

export interface ResetAdjustedDayOfWeekToRegularCommand {
    adjustedOpeningHoursId?: string;
    day?: DayOfWeek;
}

export interface ReplaceSpecialOpeningHoursIntervalsCommand {
    date?: DateTime;
    intervals?: OpeningHoursIntervalDto[];
}

export interface ReplaceRegularDayOfWeekIntervalsCommand {
    regularOpeningHoursVersionId?: string;
    day?: DayOfWeek;
    intervals?: OpeningHoursIntervalDto[];
}

export interface ReplaceAdjustedDayOfWeekIntervalsCommand {
    adjustedOpeningHoursId?: string;
    day?: DayOfWeek;
    intervals?: OpeningHoursIntervalDto[];
}

export interface RenameSpecialOpeningHoursCommand {
    date?: DateTime;
    name?: string;
}

export interface RenameAdjustedOpeningHoursCommand {
    adjustedOpeningHoursId?: string;
    name?: string;
}

export interface RemoveSpecialOpeningHoursCommand {
    date?: DateTime;
}

export interface RemoveRegularOpeningHoursVersionCommand {
    regularOpeningHoursVersionId?: string;
}

export interface RemoveAdjustedOpeningHoursCommand {
    adjustedOpeningHoursId?: string;
}

export interface ImportLocationOpeningHoursFromLegacyResponse {
    regularImported?: boolean;
    regularSourceBlockName?: string | undefined;
    importedAdjustedSets?: ImportedAdjustedSetResponse[];
    dedupedBlocks?: DedupedBlockResponse[];
    overflowBlocks?: OverflowBlockResponse[];
    unmatchedToCalendarPeriodBlocks?: UnmatchedBlockResponse[];
}

export interface ImportedAdjustedSetResponse {
    adjustedOpeningHoursName?: string;
    sourceBlockPeriodIds?: string[];
    assignedCalendarPeriodIds?: string[];
}

export interface DedupedBlockResponse {
    periodId?: string;
    periodName?: string | undefined;
    reusedAdjustedOpeningHoursName?: string;
}

export interface OverflowBlockResponse {
    periodId?: string;
    periodName?: string | undefined;
    reason?: string;
}

export interface UnmatchedBlockResponse {
    periodId?: string;
    periodName?: string | undefined;
    reason?: string;
}

export interface GetLocationOpeningHoursConfigQueryResult {
    locationOpeningHours?: GetLocationOpeningHoursConfigLocationOpeningHours | undefined;
}

export interface GetLocationOpeningHoursConfigLocationOpeningHours {
    locationOpeningHoursId?: string;
    regularOpeningHoursVersions?: GetLocationOpeningHoursConfigRegularVersion[];
    adjustedOpeningHours?: GetLocationOpeningHoursConfigAdjustedSet[];
    periodAssignments?: GetLocationOpeningHoursConfigPeriodAssignment[];
    specialOpeningHours?: GetLocationOpeningHoursConfigSpecial[];
}

export interface GetLocationOpeningHoursConfigRegularVersion {
    regularOpeningHoursVersionId?: string;
    effectiveFromDate?: DateTime;
    days?: GetLocationOpeningHoursConfigRegularDay[];
}

export interface GetLocationOpeningHoursConfigRegularDay {
    day?: DayOfWeek;
    intervals?: OpeningHoursIntervalDto[];
}

export interface GetLocationOpeningHoursConfigAdjustedSet {
    adjustedOpeningHoursId?: string;
    name?: string;
    days?: GetLocationOpeningHoursConfigAdjustedDay[];
}

export interface GetLocationOpeningHoursConfigAdjustedDay {
    day?: DayOfWeek;
    hasExplicitEntry?: boolean;
    intervals?: OpeningHoursIntervalDto[];
}

export interface GetLocationOpeningHoursConfigPeriodAssignment {
    calendarPeriodId?: string;
    adjustedOpeningHoursId?: string | undefined;
}

export interface GetLocationOpeningHoursConfigSpecial {
    date?: DateTime;
    specialOpeningHoursId?: string;
    name?: string;
    isClosed?: boolean;
    intervals?: OpeningHoursIntervalDto[];
}

export interface GetLocationOpeningHoursCalendarQueryResult {
    days?: ResolvedDateOpeningHoursDto[];
}

export interface CopyRegularDayOfWeekCommand {
    regularOpeningHoursVersionId?: string;
    sourceDay?: DayOfWeek;
    targetDays?: DayOfWeek[];
}

export interface CopyAdjustedDayOfWeekCommand {
    adjustedOpeningHoursId?: string;
    sourceDay?: DayOfWeek;
    targetDays?: DayOfWeek[];
}

export interface ClearPeriodAdjustedOpeningHoursCommand {
    calendarPeriodId?: string;
}

export interface AddSpecialOpeningHoursCommandResponse {
    specialOpeningHoursId?: string;
}

export interface AddSpecialOpeningHoursCommand {
    date?: DateTime;
    name?: string;
    intervals?: OpeningHoursIntervalDto[] | undefined;
}

export interface AddRegularOpeningHoursVersionCommand {
    effectiveFromDate?: DateTime;
}

export interface AddAdjustedOpeningHoursCommandResponse {
    adjustedOpeningHoursId?: string;
}

export interface AddAdjustedOpeningHoursCommand {
    name?: string;
}

export interface SetSpecialAreaDayCommand {
    date?: DateTime;
    areaId?: string;
    offeringDay?: OfferingDayDto;
}

export interface OfferingDayDto {
    kind?: OfferingDayKind;
    windows?: OfferingWindowDto[];
}

export enum OfferingDayKind {
    NotOffered = "NotOffered",
    Offered = "Offered",
}

export interface OfferingWindowDto {
    fromTime?: Duration;
    untilTime?: Duration;
    activities?: ActivityWindowEntryDto[];
}

export interface ActivityWindowEntryDto {
    activityId?: string;
    startPolicy?: StartPolicyDto;
    durationPolicy?: DurationPolicyDto | undefined;
    activityOfferingPresetId?: string | undefined;
}

export interface StartPolicyDto {
    kind?: StartPolicyKind;
    granularityInMinutes?: number | undefined;
    startTimes?: Duration[] | undefined;
}

export enum StartPolicyKind {
    Continuous = "Continuous",
    FixedTimes = "FixedTimes",
}

export interface DurationPolicyDto {
    eligibleDurationsInMinutes?: number[];
    defaultDurationInMinutes?: number;
}

export interface SetRegularAreaDayCommand {
    regularOfferingScheduleVersionId?: string;
    areaId?: string;
    dayOfWeek?: DayOfWeek;
    offeringDay?: OfferingDayDto;
}

export interface SetRegularAreaDaysCommand {
    regularOfferingScheduleVersionId?: string;
    areaId?: string;
    daysOfWeek?: DayOfWeek[];
    offeringDay?: OfferingDayDto;
}

export interface SetPeriodAdjustedScheduleCommand {
    calendarPeriodId?: string;
    adjustedOfferingScheduleId?: string;
}

export interface SetAdjustedAreaDayCommand {
    adjustedOfferingScheduleId?: string;
    areaId?: string;
    dayOfWeek?: DayOfWeek;
    offeringDay?: OfferingDayDto;
}

export interface ResolveLocationOfferingScheduleForDateQueryResult {
    date?: ResolvedOfferingScheduleDto | undefined;
}

export interface ResolvedOfferingScheduleDto {
    date?: DateTime;
    period?: ResolvedOfferingSchedulePeriodDto | undefined;
    source?: ResolvedOfferingScheduleSource;
    areas?: ResolvedOfferingScheduleAreaDto[];
    special?: ResolvedOfferingScheduleSpecialDto | undefined;
    adjusted?: ResolvedOfferingScheduleAdjustedDto | undefined;
    regular?: ResolvedOfferingScheduleRegularDto | undefined;
}

export interface ResolvedOfferingSchedulePeriodDto {
    calendarPeriodId?: string;
    name?: string;
}

export enum ResolvedOfferingScheduleSource {
    Special = "Special",
    Adjusted = "Adjusted",
    Regular = "Regular",
}

export interface ResolvedOfferingScheduleAreaDto {
    areaId?: string;
    areaSource?: ResolvedAreaScheduleSource;
    windows?: ResolvedOfferingWindowDto[];
    diagnostics?: OfferingScheduleClipDiagnosticDto[];
}

export enum ResolvedAreaScheduleSource {
    Special = "Special",
    AdjustedOverride = "AdjustedOverride",
    Regular = "Regular",
}

export interface ResolvedOfferingWindowDto {
    fromTime?: Duration;
    untilTime?: Duration;
    activities?: ResolvedWindowActivityDto[];
}

export interface ResolvedWindowActivityDto {
    activityId?: string;
    startPolicy?: StartPolicyDto;
    startTimes?: Duration[];
}

export interface OfferingScheduleClipDiagnosticDto {
    kind?: OfferingScheduleClipDiagnosticKind;
    fromTime?: Duration;
    untilTime?: Duration;
    activityId?: string | undefined;
}

export enum OfferingScheduleClipDiagnosticKind {
    WindowClipped = "WindowClipped",
    WindowOutsideOpeningHours = "WindowOutsideOpeningHours",
    OpenButNotOffered = "OpenButNotOffered",
    StartTimesClipped = "StartTimesClipped",
    WindowWithoutActivities = "WindowWithoutActivities",
}

export interface ResolvedOfferingScheduleSpecialDto {
    specialOfferingScheduleId?: string;
    name?: string;
}

export interface ResolvedOfferingScheduleAdjustedDto {
    adjustedOfferingScheduleId?: string;
    name?: string;
}

export interface ResolvedOfferingScheduleRegularDto {
    regularOfferingScheduleVersionId?: string | undefined;
}

export interface ResolveLocationOfferingScheduleForDateQuery {
    date?: DateTime;
}

export interface RenameSpecialOfferingScheduleCommand {
    date?: DateTime;
    name?: string;
}

export interface RenameAdjustedOfferingScheduleCommand {
    adjustedOfferingScheduleId?: string;
    name?: string;
}

export interface RemoveSpecialOfferingScheduleCommand {
    date?: DateTime;
}

export interface RemoveSpecialAreaScheduleCommand {
    date?: DateTime;
    areaId?: string;
}

export interface RemoveRegularOfferingScheduleVersionCommand {
    regularOfferingScheduleVersionId?: string;
}

export interface RemoveRegularAreaScheduleCommand {
    regularOfferingScheduleVersionId?: string;
    areaId?: string;
}

export interface RemoveAdjustedOfferingScheduleCommand {
    adjustedOfferingScheduleId?: string;
}

export interface RemoveAdjustedAreaScheduleCommand {
    adjustedOfferingScheduleId?: string;
    areaId?: string;
}

export interface GetLocationOfferingScheduleConfigQueryResult {
    locationOfferingSchedule?: GetLocationOfferingScheduleConfigLocationOfferingSchedule | undefined;
}

export interface GetLocationOfferingScheduleConfigLocationOfferingSchedule {
    locationOfferingScheduleId?: string;
    regularOfferingScheduleVersions?: GetLocationOfferingScheduleConfigRegularVersion[];
    adjustedOfferingSchedules?: GetLocationOfferingScheduleConfigAdjustedSchedule[];
    periodAssignments?: GetLocationOfferingScheduleConfigPeriodAssignment[];
    specialOfferingSchedules?: GetLocationOfferingScheduleConfigSpecial[];
}

export interface GetLocationOfferingScheduleConfigRegularVersion {
    regularOfferingScheduleVersionId?: string;
    effectiveFromDate?: DateTime;
    areas?: GetLocationOfferingScheduleConfigArea[];
}

export interface GetLocationOfferingScheduleConfigArea {
    areaId?: string;
    days?: GetLocationOfferingScheduleConfigAreaDay[];
}

export interface GetLocationOfferingScheduleConfigAreaDay {
    day?: DayOfWeek;
    offering?: OfferingDayDto;
}

export interface GetLocationOfferingScheduleConfigAdjustedSchedule {
    adjustedOfferingScheduleId?: string;
    name?: string;
    areas?: GetLocationOfferingScheduleConfigArea[];
}

export interface GetLocationOfferingScheduleConfigPeriodAssignment {
    calendarPeriodId?: string;
    adjustedOfferingScheduleId?: string | undefined;
}

export interface GetLocationOfferingScheduleConfigSpecial {
    date?: DateTime;
    specialOfferingScheduleId?: string;
    name?: string;
    areas?: GetLocationOfferingScheduleConfigSpecialArea[];
}

export interface GetLocationOfferingScheduleConfigSpecialArea {
    areaId?: string;
    windows?: OfferingWindowDto[];
}

export interface ClearPeriodAdjustedScheduleCommand {
    calendarPeriodId?: string;
}

export interface ClearAdjustedAreaDayCommand {
    adjustedOfferingScheduleId?: string;
    areaId?: string;
    dayOfWeek?: DayOfWeek;
}

export interface AddSpecialOfferingScheduleCommandResponse {
    specialOfferingScheduleId?: string;
}

export interface AddSpecialOfferingScheduleCommand {
    date?: DateTime;
    name?: string;
}

export interface AddRegularOfferingScheduleVersionCommand {
    effectiveFromDate?: DateTime;
}

export interface AddAdjustedOfferingScheduleCommandResponse {
    adjustedOfferingScheduleId?: string;
}

export interface AddAdjustedOfferingScheduleCommand {
    name?: string;
}

export interface SetActivityOfferingPresetStartPolicyCommand {
    activityId?: string;
    activityOfferingPresetId?: string;
    startPolicy?: StartPolicyDto;
}

export interface SetActivityOfferingPresetDurationPolicyCommand {
    activityId?: string;
    activityOfferingPresetId?: string;
    durationPolicy?: DurationPolicyDto;
}

export interface RenameActivityOfferingPresetCommand {
    activityId?: string;
    activityOfferingPresetId?: string;
    name?: string;
}

export interface RemoveActivityOfferingPresetCommand {
    activityId?: string;
    activityOfferingPresetId?: string;
}

export interface GetActivityOfferingPresetsQueryResult {
    presets?: ActivityOfferingPresetDto[];
}

export interface ActivityOfferingPresetDto {
    activityOfferingPresetId?: string;
    name?: string;
    startPolicy?: StartPolicyDto;
    durationPolicy?: DurationPolicyDto;
}

export interface GetActivityOfferingPresetsQuery {
    activityId?: string;
}

export interface AddActivityOfferingPresetCommandResponse {
    activityOfferingPresetId?: string;
}

export interface AddActivityOfferingPresetCommand {
    activityId?: string;
    name?: string;
    startPolicy?: StartPolicyDto;
    durationPolicy?: DurationPolicyDto;
}

export interface GetActivityOfferingDurationsInUseQueryResult {
    durations?: ActivityOfferingDurationInUseDto[];
}

export interface ActivityOfferingDurationInUseDto {
    durationInMinutes?: number;
    usedByPresets?: boolean;
    usedByOfferingSchedule?: boolean;
}

export interface GetActivityOfferingDurationsInUseQuery {
    activityId?: string;
}

export interface ResolveLocationCalendarForDateQueryResult {
    date?: DateTime;
    period?: ResolveLocationCalendarForDatePeriod | undefined;
}

export interface ResolveLocationCalendarForDatePeriod {
    calendarPeriodId?: string;
    name?: string;
}

export interface ResolveLocationCalendarForDateQuery {
    date?: DateTime;
}

export interface RescheduleCalendarPeriodCommand {
    annualCalendarId?: string;
    calendarPeriodId?: string;
    fromDate?: DateTime;
    toDate?: DateTime;
}

export interface RenameCalendarPeriodCommand {
    annualCalendarId?: string;
    calendarPeriodId?: string;
    name?: string;
}

export interface RemoveCalendarPeriodCommand {
    annualCalendarId?: string;
    calendarPeriodId?: string;
}

export interface ImportLocationCalendarFromLegacyResponse {
    createdNewCalendar?: boolean;
    startMonthUsed?: number;
    importedPeriods?: ImportedCalendarPeriodResponse[];
    droppedPastPeriods?: SkippedLegacyPeriodResponse[];
    overflowPeriods?: SkippedLegacyPeriodResponse[];
    gaps?: CalendarGapResponse[];
}

export interface ImportedCalendarPeriodResponse {
    periodId?: string;
    name?: string | undefined;
    fromDate?: DateTime;
    toDate?: DateTime;
    annualCalendarWindowFromDate?: DateTime;
    wasSplit?: boolean;
    wasClamped?: boolean;
}

export interface SkippedLegacyPeriodResponse {
    periodId?: string;
    name?: string | undefined;
    fromDate?: DateTime;
    toDate?: DateTime;
    hasProgramAssignments?: boolean;
    hasRateCardAssignments?: boolean;
}

export interface CalendarGapResponse {
    fromDate?: DateTime;
    toDate?: DateTime;
}

export interface ImportLocationCalendarFromLegacyCommand {
    startMonth?: number;
}

export interface GetLocationCalendarConfigQueryResult {
    locationCalendar?: GetLocationCalendarConfigLocationCalendar | undefined;
}

export interface GetLocationCalendarConfigLocationCalendar {
    locationCalendarId?: string;
    annualCalendars?: GetLocationCalendarConfigAnnualCalendar[];
}

export interface GetLocationCalendarConfigAnnualCalendar {
    annualCalendarId?: string;
    windowFromDate?: DateTime;
    windowToDate?: DateTime;
    isExpired?: boolean;
    calendarPeriods?: GetLocationCalendarConfigCalendarPeriod[];
}

export interface GetLocationCalendarConfigCalendarPeriod {
    calendarPeriodId?: string;
    name?: string;
    periodFromDate?: DateTime;
    periodToDate?: DateTime;
    origin?: GetLocationCalendarConfigPeriodOrigin;
}

export enum GetLocationCalendarConfigPeriodOrigin {
    Copied = "Copied",
    Edited = "Edited",
    New = "New",
}

export interface CreateLocationCalendarCommand {
    month?: number;
}

export interface ChangeAnnualCalendarStartMonthCommand {
    month?: number;
}

export interface CanChangeAnnualCalendarStartMonthQueryResult {
    canChange?: boolean;
    reason?: string | undefined;
}

export interface CanChangeAnnualCalendarStartMonthQuery {
    month?: number;
}

export interface AddCalendarPeriodCommandResponse {
    calendarPeriodId?: string;
}

export interface AddCalendarPeriodCommand {
    annualCalendarId?: string;
    name?: string;
    fromDate?: DateTime;
    toDate?: DateTime;
}

export interface SetActivityResourcePoolCommand {
    activityId?: string;
    resourceIds?: string[];
}

export interface SetActivityResourcePoolPolicyCommand {
    activityId?: string;
    policy?: ActivityResourcePoolPolicyRequestDto;
}

export interface ActivityResourcePoolPolicyRequestDto {
    policyKind: string;
}

export interface SequencedPoolPolicyRequestDto extends ActivityResourcePoolPolicyRequestDto {
    contiguity?: AllocationPreferenceDto;
}

export enum AllocationPreferenceDto {
    Required = "Required",
    Preferred = "Preferred",
    Ignored = "Ignored",
}

export interface PairedSequencedPoolPolicyRequestDto extends ActivityResourcePoolPolicyRequestDto {
    contiguity?: AllocationPreferenceDto;
    pairAlignment?: AllocationPreferenceDto;
}

export interface CombinablePoolPolicyRequestDto extends ActivityResourcePoolPolicyRequestDto {
    allowCombination?: boolean;
}

export interface GetActivityResourcePoolQueryResult {
    pool?: ActivityResourcePoolDto | undefined;
}

export interface ActivityResourcePoolDto {
    activityId?: string;
    resourceIds?: string[];
    structure?: PoolStructureDto | undefined;
    policy?: ActivityResourcePoolPolicyResponseDto | undefined;
}

export interface PoolStructureDto {
    kind?: PoolStructureKindDto;
    pairGroupSize?: number | undefined;
}

export enum PoolStructureKindDto {
    StandAlone = "StandAlone",
    Sequenced = "Sequenced",
    Combinable = "Combinable",
    SharedHeadcount = "SharedHeadcount",
}

export interface ActivityResourcePoolPolicyResponseDto {
    policyKind: string;
}

export interface SequencedPoolPolicyResponseDto extends ActivityResourcePoolPolicyResponseDto {
    contiguity?: AllocationPreferenceDto;
}

export interface PairedSequencedPoolPolicyResponseDto extends ActivityResourcePoolPolicyResponseDto {
    contiguity?: AllocationPreferenceDto;
    pairAlignment?: AllocationPreferenceDto;
}

export interface CombinablePoolPolicyResponseDto extends ActivityResourcePoolPolicyResponseDto {
    allowCombination?: boolean;
}

export interface GetActivityResourcePoolQuery {
    activityId?: string;
}

export interface GetActivityAreaPlacementsQueryResult {
    activities?: GetActivityAreaPlacementsActivity[];
}

export interface GetActivityAreaPlacementsActivity {
    activityId?: string;
    areaIds?: string[];
}

export interface GetProgramGroupListPageViewQueryResult {
    programGroups?: GetProgramGroupListPageViewQueryResultItem[];
}

export interface GetProgramGroupListPageViewQueryResultItem {
    id?: string;
    name?: string;
    orderIndex?: number;
    active?: boolean;
    forPublicUse?: boolean;
    forInternalUse?: boolean;
}

export interface GetProgramGroupListPageViewQuery {
}

export interface GetProgramGroupEditItemViewQueryResult {
    programGroupId?: string;
    programGroupName?: string;
    active?: boolean;
    name?: string;
    description?: string;
    forPublicUse?: boolean;
    forInternalUse?: boolean;
    programs?: GetProgramGroupEditItemViewQueryResultProgram[];
}

export interface GetProgramGroupEditItemViewQueryResultProgram {
    programId?: string;
    name?: string;
    orderIndex?: number;
}

export interface GetProgramGroupEditItemViewQuery {
    programGroupId?: string;
}

export interface GetProgramGroupEditItemProgramsViewQueryResult {
    programGroupId?: string;
    programGroupName?: string;
    selectedPrograms?: GetProgramGroupEditItemProgramsViewQueryResultProgram[];
    availablePrograms?: GetProgramGroupEditItemProgramsViewQueryResultProgram[];
}

export interface GetProgramGroupEditItemProgramsViewQueryResultProgram {
    programId?: string;
    name?: string;
    orderIndex?: number;
    active?: boolean;
}

export interface GetProgramGroupEditItemProgramsViewQuery {
    programGroupId?: string;
}

export interface GetProgramGroupAddDialogViewQueryResult {
    nextOrderIndex?: number;
}

export interface GetProgramGroupAddDialogViewQuery {
}

export interface GetNotesDataViewQueryResult {
    notes?: NoteListTaskItem[];
}

export interface NoteListTaskItem {
    id?: string;
    title?: string;
    isTask?: boolean;
    hasBodyValue?: boolean;
    hasDateValue?: boolean;
    fromDate?: DateTime;
    dueDate?: DateTime | undefined;
    dueDateExpired?: boolean;
    isCompleted?: boolean;
    completedOnDate?: DateTime | undefined;
    relatedObjects?: NoteRelatedObjectItem[];
}

export interface NoteRelatedObjectItem {
    relatedObjectId?: string;
    relatedObjectName?: string;
    relatedObjectType?: string;
}

export interface GetNotesDataViewQuery {
    relatedObjectId?: string;
    fromDate?: DateTime | undefined;
}

export interface GetNoteListViewQueryResult {
    relatedObject?: NoteListTabsRelatedObject;
    showHeader?: boolean;
    pageTitle?: string;
    pageCloseNavItem?: NoteListTabsNavItem;
    navItems?: NoteListTabsNavItem[];
}

export interface NoteListTabsRelatedObject {
    relatedObjectId?: string;
    relatedObjectName?: string;
    relatedObjectType?: string;
}

export interface NoteListTabsNavItem {
    name?: string;
    routeDefinition?: NoteListTabsRouteDefinition;
}

export interface NoteListTabsRouteDefinition {
    path?: string;
}

export interface GetNoteListViewQuery {
    noteListId?: string;
}

export interface GetNoteListTodayViewQueryResult {
    noteListId?: string;
    fromDate?: DateTime;
    tasks?: NoteListTaskItem[];
    completedTasks?: NoteListTaskItem[];
}

export interface GetNoteListTodayViewQuery {
    noteListId?: string;
}

export interface GetNoteListCalendarViewQueryResult {
    noteListId?: string;
}

export interface GetNoteListCalendarViewQuery {
    noteListId?: string;
}

export interface GetNoteListCalendarDataViewQueryResult {
    fromDate?: DateTime;
    toDate?: DateTime;
    days?: NoteListCalendarDay[];
}

export interface NoteListCalendarDay {
    fromDate?: DateTime;
    toDate?: DateTime;
    tasks?: NoteListTaskItem[];
    completedTasks?: NoteListTaskItem[];
}

export interface GetNoteListCalendarDataViewQuery {
    noteListId?: string;
    fromDate?: DateTime;
    periodType?: PeriodType;
}

export enum PeriodType {
    Day = "Day",
    Workweek = "Workweek",
    Week = "Week",
    Month = "Month",
    Quarter = "Quarter",
    Year = "Year",
}

export interface GetNoteItemQueryResult {
    note?: NoteListTaskItem;
}

export interface GetNoteItemQuery {
    noteId?: string;
    fromDate?: DateTime | undefined;
}

export interface GetNoteDetailsDialogViewQueryResult {
    noteId?: string;
    dialogTitle?: string;
    dueDateExpired?: boolean;
    isDirty?: boolean;
    input?: NoteEditItem;
    output?: NoteEditItem;
}

export interface NoteEditItem {
    relatedObjects?: NoteRelatedObjectItem[];
    isTask?: boolean;
    title?: string;
    body?: string;
    hasBodyValue?: boolean;
    hasDateValue?: boolean;
    fromDate?: DateTime;
    toDate?: DateTime;
    dueDate?: DateTime | undefined;
    isCompleted?: boolean;
    completedOnDate?: DateTime | undefined;
}

export interface GetNoteDetailsDialogViewQuery {
    noteId?: string;
}

export interface RunPosStatusCheckCommandResponse {
    item?: PosStatusListItem;
}

export interface PosStatusListItem {
    tenantId?: string;
    tenantName?: string;
    locationId?: string;
    locationName?: string;
    posSystemId?: string;
    posSystemName?: string;
    status?: PosStatusCheckState;
    lastCheckedOnDate?: DateTime | undefined;
    lastSuccessOnDate?: DateTime | undefined;
    consecutiveFailureCount?: number;
    articleCount?: number | undefined;
    durationMs?: number | undefined;
    errorCode?: string;
    errorMessage?: string;
    recentRuns?: PosStatusRunItem[];
}

export enum PosStatusCheckState {
    NotChecked = "NotChecked",
    Success = "Success",
    Failed = "Failed",
    TimedOut = "TimedOut",
}

export interface PosStatusRunItem {
    checkedOnDate?: DateTime;
    status?: PosStatusCheckState;
    articleCount?: number | undefined;
    durationMs?: number | undefined;
    errorCode?: string;
    errorMessage?: string;
}

export interface RunPosStatusCheckCommand {
    tenantId?: string;
    locationId?: string;
}

export interface GetPosStatusListPageViewQueryResult {
    items?: PosStatusListItem[];
}

export interface GetPosStatusListPageViewQuery {
}

export interface GetLocationSocialSettingsPageViewQueryResult {
    locationSettingsId?: string;
    input?: LocationSocialSettingsEditItem;
    output?: LocationSocialSettingsEditItem;
    socialSettings?: LocationMarketingSocialSettings;
}

export interface LocationSocialSettingsEditItem {
    socialLinks?: LocationSocialLinkEditItem[];
}

export interface LocationSocialLinkEditItem {
    active?: boolean;
    orderIndex?: number;
    logoCustomImageFile?: string;
    companyUrl?: string;
}

export interface LocationMarketingSocialSettings {
    socialLinks?: LocationSocialLink[];
}

export interface LocationSocialLink {
    active?: boolean;
    orderIndex?: number;
    name?: string;
    url?: string;
    logoImageUrl?: string;
    logoCustomImageFile?: string;
    color?: string;
    descriptionPriority?: string;
    description?: string;
    companyUrl?: string;
    custom?: boolean;
}

export interface GetLocationSocialSettingsPageViewQuery {
}

export interface IsLocationIdCodeInUseQueryResult {
    isInUse?: boolean;
}

export interface IsLocationIdCodeInUseQuery {
    tenantId?: string;
    locationIdCode?: string;
}

export interface GetLocationOpenDatesForMonthQueryResult {
    year?: number;
    month?: number;
    dates?: GetLocationOpenDatesForMonthQueryResultDate[];
}

export interface GetLocationOpenDatesForMonthQueryResultDate {
    date?: DateTime;
}

export interface GetLocationOpenDatesForMonthQuery {
    year?: number;
    month?: number;
}

export interface ResolveLocationSnapshotBookingQueryResult {
    sourceTenantId?: string;
    sourceLocationId?: string;
    sourceLocationName?: string;
    businessDate?: DateTime;
    businessDates?: DateTime[];
    bookingCount?: number;
}

export interface ResolveLocationSnapshotBookingQuery {
    sourceLocationId?: string;
    bookingId?: string;
    daysBefore?: number;
    daysAfter?: number;
}

export interface RequestLocationSnapshotCommandResult {
    runId?: string;
}

export interface RequestLocationSnapshotCommand {
    sourceTenantId?: string;
    sourceLocationId?: string;
    bookingId?: string;
    daysBefore?: number;
    daysAfter?: number;
    includeNamedBooking?: boolean;
    label?: string | undefined;
}

export interface GetLocationSnapshotSourceTenantsQueryResult {
    allowedForDeployment?: boolean;
    isAvailable?: boolean;
    unavailableReason?: string | undefined;
    tenants?: LocationSnapshotSourceTenant[];
}

export interface LocationSnapshotSourceTenant {
    tenantId?: string;
    name?: string;
}

export interface GetLocationSnapshotSourceLocationsQueryResult {
    locations?: LocationSnapshotSourceLocation[];
}

export interface LocationSnapshotSourceLocation {
    locationId?: string;
    name?: string;
    idCode?: string | undefined;
}

export interface GetLocationSnapshotSourceLocationsQuery {
    sourceTenantId?: string;
}

export interface GetLocationSnapshotRunsQueryResult {
    runs?: LocationSnapshotRun[];
}

export interface LocationSnapshotRun {
    runId?: string;
    status?: string;
    requestedByName?: string;
    requestedOnDate?: DateTime;
    finishedOnDate?: DateTime | undefined;
    sourceTenantName?: string;
    sourceLocationName?: string;
    bookingId?: string;
    businessDate?: DateTime | undefined;
    includeNamedBooking?: boolean;
    label?: string | undefined;
    ordinal?: number;
    cloneLocationId?: string;
    cloneLocationName?: string;
    copiedDocumentCount?: number;
    failureReason?: string | undefined;
    log?: string[];
}

export interface DeleteLocationSnapshotCommand {
    runId?: string;
}

export interface UpdateLocationBookingSettingsCommand {
    disablePostalCodeLookup?: boolean;
    manualEmailConfirmation?: boolean;
    manualEmailConfirmationMinimumAmount?: number;
    approvalActive?: boolean;
    approvalMinimumAmount?: number;
    plannerBookingWithRequiredDepositActive?: boolean;
    plannerBookingDepositIsRequiredByDefault?: boolean;
    plannerBookingRequiredDepositAmountPercentageOfFinalPrice?: number;
    plannerPendingBookingExpiresAfterTime?: Duration;
}

export interface GetLocationUnitListPageViewQueryResult {
    units?: GetLocationUnitListPageViewQueryResultItem[];
}

export interface GetLocationUnitListPageViewQueryResultItem {
    id?: string;
    singular?: string;
    plural?: string;
}

export interface GetLocationUnitListPageViewQuery {
}

export interface GetLocationUnitFormDialogViewQueryResult {
    formDialogView?: UnitFormDialogView;
}

export interface UnitFormDialogView {
    objectId?: string;
    objectTypeName?: string;
    output?: LocationSettingsUnitFormData;
    input?: LocationSettingsUnitFormData;
    formConfig?: RaxFormConfig;
    dialogTitle?: string;
    actionType?: UnitFormDialogActionType;
    dialogPosition?: UnitFormDialogPosition;
}

export interface LocationSettingsUnitFormData {
    singular?: string;
    plural?: string;
}

export interface RaxFormConfig {
    fieldConfigs?: RaxFormFieldConfig[];
}

export interface RaxFormFieldConfig {
    id?: string;
    key?: string;
    type?: RaxFormFieldType;
    focus?: boolean | undefined;
    flexSpan?: number | undefined;
    flexSize?: number | undefined;
    flexSizeType?: FlexSizeType | undefined;
    fieldProperties?: RaxFormFieldProps;
    modelOptions?: RaxFormFieldModelOptions;
    validators?: RaxFormFieldValidator[];
    validationMessages?: RaxFormFieldValidationMessage[];
    expressions?: RaxFormFieldExpression[];
    isContainer?: boolean | undefined;
    containerType?: RaxFormContainerType | undefined;
    fieldConfigs?: RaxFormFieldConfig[];
}

export enum RaxFormFieldType {
    Text = "Text",
    TextArea = "TextArea",
    Number = "Number",
    Checkbox = "Checkbox",
    ColorPicker = "ColorPicker",
    Multicheckbox = "Multicheckbox",
    Datepicker = "Datepicker",
    Toggle = "Toggle",
    IconButtonToggle = "IconButtonToggle",
    IconPicker = "IconPicker",
    Slider = "Slider",
    DurationSelect = "DurationSelect",
    Select = "Select",
    Radio = "Radio",
    Html = "Html",
}

export enum FlexSizeType {
    Percentage = "Percentage",
    Pixel = "Pixel",
}

export interface RaxFormFieldProps {
    valueType?: string;
    disabled?: boolean | undefined;
    hidden?: boolean | undefined;
    required?: boolean | undefined;
    readOnly?: boolean | undefined;
    label?: string;
    placeholder?: string;
    description?: string;
    min?: number | undefined;
    max?: number | undefined;
    minLength?: number | undefined;
    maxLength?: number | undefined;
    rows?: number | undefined;
    cols?: number | undefined;
    indeterminate?: boolean | undefined;
    labelPosition?: RaxFormFieldLabelPosition | undefined;
    minDate?: DateTime | undefined;
    maxDate?: DateTime | undefined;
    valueText?: string;
    thumbLabel?: boolean | undefined;
    tickInterval?: number | undefined;
    isVertical?: boolean | undefined;
    allowMultiple?: boolean | undefined;
    selectAllOption?: boolean | undefined;
    selectAllLabel?: string;
    selectOptions?: RaxFormFieldSelectOption[];
    radioOptions?: RaxFormFieldIconSelectOption[];
    disableOptionCentering?: boolean | undefined;
    typeAheadInterval?: number | undefined;
    pattern?: string;
    durationSelect?: RaxFormFieldDurationSelectOptions;
    colorPicker?: RaxFormFieldColorPickerOptions;
    iconButtonToggle?: RaxFormFieldIconButtonToggleOptions;
    htmlField?: RaxFormHtmlFieldOptions;
}

export enum RaxFormFieldLabelPosition {
    After = "After",
    Before = "Before",
}

export interface RaxFormFieldSelectOption {
    value?: any;
    label?: string;
    disabled?: boolean | undefined;
    data?: any;
}

export interface RaxFormFieldIconSelectOption extends RaxFormFieldSelectOption {
    iconName?: string;
}

export interface RaxFormFieldDurationSelectOptions {
    timeOfDay?: boolean | undefined;
    durationOptions?: DurationOptions;
}

export interface RaxFormFieldColorPickerOptions {
    outputFormat?: RaxFormFieldColorPickerOutputFormat;
    position?: RaxFormFieldColorPickerPosition;
    presetColors?: string[];
    allowTransparency?: boolean | undefined;
}

export enum RaxFormFieldColorPickerOutputFormat {
    Auto = "Auto",
    Hex = "Hex",
    Rgba = "Rgba",
    Hsla = "Hsla",
}

export enum RaxFormFieldColorPickerPosition {
    Auto = "Auto",
    Top = "Top",
    Right = "Right",
    Bottom = "Bottom",
    Left = "Left",
    TopLeft = "TopLeft",
    TopRight = "TopRight",
    BottomLeft = "BottomLeft",
    BottomRight = "BottomRight",
}

export interface RaxFormFieldIconButtonToggleOptions {
    activeIconName?: string;
    inactiveIconName?: string;
}

export interface RaxFormHtmlFieldOptions {
    template?: string;
    isDynamic?: boolean;
}

export interface RaxFormFieldModelOptions {
    debounceMS?: number | undefined;
    updateOn?: RaxFormFieldModelOptionsUpdateOnType | undefined;
}

export enum RaxFormFieldModelOptionsUpdateOnType {
    Change = "Change",
    Blur = "Blur",
    Submit = "Submit",
}

export interface RaxFormFieldValidator {
    validatorType?: RaxFormFieldValidatorType;
    name?: string;
    allowEqual?: boolean | undefined;
    crossFieldKey?: string;
    crossFieldSync?: boolean | undefined;
}

export enum RaxFormFieldValidatorType {
    Custom = "Custom",
    Iban = "Iban",
    Email = "Email",
    MinCrossField = "MinCrossField",
    MaxCrossField = "MaxCrossField",
    HttpsUrl = "HttpsUrl",
}

export interface RaxFormFieldValidationMessage {
    validatorName?: string;
    message?: string;
}

export interface RaxFormFieldExpression {
    expressionType?: RaxFormFieldExpressionType;
    fieldExpression?: string;
    crossFieldKey?: string;
    crossFieldSync?: boolean | undefined;
    ifEmpty?: boolean | undefined;
    selectOptionKey?: string;
    copyModifierType?: RaxFormFieldExpressionCopyModifierType | undefined;
}

export enum RaxFormFieldExpressionType {
    Hide = "Hide",
    Copy = "Copy",
}

export enum RaxFormFieldExpressionCopyModifierType {
    None = "None",
    ReplaceSpecialCharacters = "ReplaceSpecialCharacters",
}

export enum RaxFormContainerType {
    Row = "Row",
    Column = "Column",
}

export enum UnitFormDialogActionType {
    Patch = "Patch",
    Post = "Post",
}

export enum UnitFormDialogPosition {
    Center = "Center",
    Left = "Left",
    Top = "Top",
    Right = "Right",
    Bottom = "Bottom",
}

export interface GetLocationUnitFormDialogViewQuery {
    unitId?: string;
}

export interface GetLocationSurveyQuestionListPageViewQueryResult {
    surveyQuestions?: GetLocationSurveyQuestionListPageViewQueryResultItem[];
}

export interface GetLocationSurveyQuestionListPageViewQueryResultItem {
    id?: string;
    text?: string;
    label?: string;
    answerType?: string;
    forPublicUse?: boolean;
    forInternalUse?: boolean;
}

export interface GetLocationSurveyQuestionListPageViewQuery {
}

export interface GetLocationSurveyQuestionItemTabsPageViewQueryResult {
    pageTitle?: string;
    pageCloseNavItem?: GetLocationSurveyQuestionItemTabsPageViewNavItem;
    navItems?: GetLocationSurveyQuestionItemTabsPageViewNavItem[];
}

export interface GetLocationSurveyQuestionItemTabsPageViewNavItem {
    name?: string;
    pathTemplate?: string;
}

export interface GetLocationSurveyQuestionItemTabsPageViewQuery {
    surveyQuestionId?: string;
}

export interface GetLocationSurveyQuestionItemGeneralPageViewQueryResult {
    pageView?: SurveyQuestionItemGeneralPageView;
}

export interface SurveyQuestionItemGeneralPageView {
    objectId?: string;
    objectTypeName?: string;
    output?: LocationSettingsSurveyQuestionFormData;
    input?: LocationSettingsSurveyQuestionFormData;
    formConfig?: RaxFormConfig;
}

export interface LocationSettingsSurveyQuestionFormData {
    text?: string;
    label?: string;
    description?: string;
    forPublicUse?: boolean;
    forInternalUse?: boolean;
    required?: boolean;
    answerType?: string;
    answerTypeJson?: string;
    allowCustomRemarks?: boolean;
}

export interface GetLocationSurveyQuestionItemGeneralPageViewQuery {
    surveyQuestionId?: string;
}

export interface GetLocationSurveyQuestionFormDialogViewQueryResult {
    formDialogView?: SurveyQuestionFormDialogView;
}

export interface SurveyQuestionFormDialogView {
    objectId?: string;
    objectTypeName?: string;
    output?: LocationSettingsSurveyQuestionFormData;
    input?: LocationSettingsSurveyQuestionFormData;
    formConfig?: RaxFormConfig;
    dialogTitle?: string;
    actionType?: SurveyQuestionFormDialogActionType;
    dialogPosition?: SurveyQuestionFormDialogPosition;
}

export enum SurveyQuestionFormDialogActionType {
    Patch = "Patch",
    Post = "Post",
}

export enum SurveyQuestionFormDialogPosition {
    Center = "Center",
    Left = "Left",
    Top = "Top",
    Right = "Right",
    Bottom = "Bottom",
}

export interface GetLocationSurveyQuestionFormDialogViewQuery {
}

export interface GetLocationScheduleBoardListViewQueryResult {
    scheduleBoards?: GetLocationScheduleBoardListViewQueryResultItem[];
}

export interface GetLocationScheduleBoardListViewQueryResultItem {
    id?: string;
    orderIndex?: number;
    name?: string;
    capacityType?: ResourceCapacityType;
    capacityTypeLabel?: string;
    navItemColor?: string;
    navItemIcon?: string;
}

export interface GetLocationScheduleBoardListViewQuery {
}

export interface GetLocationScheduleBoardEditItemViewQueryResult {
    scheduleBoardId?: string;
    scheduleBoardName?: string;
    input?: ScheduleBoardEditItem;
    output?: ScheduleBoardEditItem;
    startOfDayOptions?: DurationOptions;
    dayDurationOptions?: DurationOptions;
    intervalDurationOptions?: DurationOptions;
    programGroups?: ScheduleBoardEditProgramGroupOption[];
    navItems?: ScheduleBoardEditNavItem[];
}

export interface ScheduleBoardEditItem {
    name?: string;
    description?: string;
    capacityType?: ResourceCapacityType;
    idCode?: string;
    navItemColor?: string;
    navItemIcon?: string;
    gridItemCodeTemplate?: string;
    dayStartTime?: Duration;
    dayDuration?: Duration;
    intervalDuration?: Duration;
    gridConfig?: ScheduleBoardEditGridConfig;
    gridTemplate?: ScheduleBoardEditGridTemplate;
    perPersonMinColumnCount?: number | undefined;
    perPersonMaxColumnCount?: number | undefined;
    defaultProgramGroupId?: string;
    defaultProgramId?: string;
}

export interface ScheduleBoardEditGridConfig {
    highlightColumnRowForActiveScheduleBoardItem?: boolean;
    viewModeOptions?: ScheduleBoardEditGridViewModeOption[];
}

export interface ScheduleBoardEditGridViewModeOption {
    viewId?: string;
    title?: string;
    fixedColWidth?: number;
    fixedRowHeight?: number;
    useTitleShort?: boolean;
    showIcons?: boolean;
    showFromTime?: boolean;
    showToTime?: boolean;
    showTitle?: boolean;
    showPersonCount?: boolean;
    showPrice?: boolean;
    showPosReference?: boolean;
    showGridItemCode?: boolean;
}

export interface ScheduleBoardEditGridTemplate {
    areaColumnHeaders?: ScheduleBoardEditAreaColumnHeader[];
    timeRowHeaders?: ScheduleBoardEditTimeRowHeader[];
    gridRowCount?: number;
    gridColumnCount?: number;
}

export interface ScheduleBoardEditAreaColumnHeader {
    orderIndex?: number;
    areaId?: string;
    title?: string;
    color?: string;
    bgColor?: string;
    resourceColumnHeaders?: ScheduleBoardEditResourceColumnHeader[];
}

export interface ScheduleBoardEditResourceColumnHeader {
    orderIndex?: number;
    gridX?: number;
    resourceId?: string;
    title?: string;
    titleShort?: string;
    color?: string;
    bgColor?: string;
    emptyCellColor?: string;
}

export interface ScheduleBoardEditTimeRowHeader {
    gridY?: number;
    offsetTime?: Duration;
    offsetDays?: number;
}

export interface ScheduleBoardEditProgramGroupOption {
    text?: string;
    value?: string;
    childItems?: ScheduleBoardEditProgramOption[];
}

export interface ScheduleBoardEditProgramOption {
    text?: string;
    value?: string;
}

export interface ScheduleBoardEditNavItem {
    name?: string;
    routeDefinition?: ScheduleBoardEditNavItemRouteDefinition;
}

export interface ScheduleBoardEditNavItemRouteDefinition {
    pathTemplate?: string;
    path?: string;
}

export interface GetLocationScheduleBoardEditItemViewQuery {
    scheduleBoardId?: string;
}

export interface GetLocationScheduleBoardEditItemResourcesViewQueryResult {
    scheduleBoardId?: string;
    treeNodes?: ScheduleBoardResourcesAreaTreeNode[];
}

export interface ScheduleBoardResourcesAreaTreeNode {
    orderIndex?: number;
    id?: string;
    title?: string;
    type?: string;
    selected?: boolean | undefined;
    data?: ScheduleBoardResourcesAreaFormData;
    children?: ScheduleBoardResourcesAreaSectionTreeNode[];
}

export interface ScheduleBoardResourcesAreaFormData {
    areaId?: string;
    orderIndex?: number;
    name?: string;
    bgColor?: string;
    color?: string;
    emptyCellBgColor?: string;
}

export interface ScheduleBoardResourcesAreaSectionTreeNode {
    orderIndex?: number;
    id?: string;
    title?: string;
    type?: string;
    selected?: boolean | undefined;
    children?: ScheduleBoardResourcesResourceTreeNode[];
}

export interface ScheduleBoardResourcesResourceTreeNode {
    orderIndex?: number;
    id?: string;
    title?: string;
    type?: string;
    selected?: boolean | undefined;
    data?: ScheduleBoardResourcesResourceFormData;
}

export interface ScheduleBoardResourcesResourceFormData {
    resourceId?: string;
    name?: string;
    nameShort?: string;
    orderIndex?: number;
    resourceTypeId?: string;
    resourceTypeName?: string;
    capacityType?: ResourceCapacityType;
    personCapacityMin?: number | undefined;
    personCapacityMax?: number | undefined;
    personCapacityStartMax?: number | undefined;
    groupCapacityMin?: number | undefined;
    groupCapacityMax?: number | undefined;
    groupCapacityStartMax?: number | undefined;
    startIntervalDuration?: Duration | undefined;
    bookStartIntervalDurationTimeOnly?: boolean;
}

export interface GetLocationScheduleBoardEditItemResourcesViewQuery {
    scheduleBoardId?: string;
}

export interface GetLocationResourceConfigResourceTypesPageViewQueryResult {
    resourceConfigId?: string;
    resourceTypes?: LocationResourceConfigResourceTypeFormData[];
}

export interface LocationResourceConfigResourceTypeFormData {
    resourceTypeId?: string;
    name?: string;
    displayName?: string;
    displayNameShort?: string;
    capacityType?: ResourceCapacityType | undefined;
    personCapacityMin?: number | undefined;
    personCapacityMax?: number | undefined;
    _PersonCapacityStartMax?: boolean;
    _GroupCapacity?: boolean;
    _StartInterval?: boolean;
    personCapacityStartMax?: number | undefined;
    groupCapacityMin?: number | undefined;
    groupCapacityMax?: number | undefined;
    groupCapacityStartMax?: number | undefined;
    startIntervalDuration?: Duration | undefined;
    bookStartIntervalDurationTimeOnly?: boolean;
}

export interface GetLocationResourceConfigResourceTypesPageViewQuery {
}

export interface GetLocationResourceConfigResourceTypeFormDialogViewQueryResult {
    formDialogView?: LocationResourceConfigFormDialogViewOfLocationResourceConfigResourceTypeFormData;
}

export interface LocationResourceConfigFormDialogViewOfLocationResourceConfigResourceTypeFormData {
    objectId?: string;
    objectTypeName?: string;
    output?: LocationResourceConfigResourceTypeFormData | undefined;
    input?: LocationResourceConfigResourceTypeFormData | undefined;
    formConfig?: RaxFormConfig;
    dialogTitle?: string;
    actionType?: LocationResourceConfigFormDialogActionType;
    dialogPosition?: LocationResourceConfigFormDialogPosition;
}

export enum LocationResourceConfigFormDialogActionType {
    Return = "Return",
    Post = "Post",
    Patch = "Patch",
}

export enum LocationResourceConfigFormDialogPosition {
    Center = "Center",
    Left = "Left",
    Top = "Top",
    Right = "Right",
    Bottom = "Bottom",
}

export interface GetLocationResourceConfigResourceTypeFormDialogViewQuery {
    resourceType?: LocationResourceConfigResourceTypeFormData;
}

export interface GetLocationResourceConfigResourcesPageViewQueryResult {
    resourceConfigId?: string;
    areas?: LocationResourceConfigAreaFormData[];
    treeNodes?: LocationResourceConfigAreaTreeNode[];
}

export interface LocationResourceConfigAreaFormData {
    areaId?: string;
    orderIndex?: number;
    name?: string;
    bgColor?: string;
    color?: string;
    emptyCellBgColor?: string;
    sections?: LocationResourceConfigAreaSectionFormData[];
}

export interface LocationResourceConfigAreaSectionFormData {
    areaSectionId?: string;
    name?: string;
    orderIndex?: number;
    resources?: LocationResourceConfigResourceFormData[];
}

export interface LocationResourceConfigResourceTypeData {
    name?: string;
    nameShort?: string;
    resourceTypeId?: string;
    resourceTypeName?: string;
    capacityType?: ResourceCapacityType | undefined;
    personCapacityMin?: number | undefined;
    personCapacityMax?: number | undefined;
    _PersonCapacityStartMax?: boolean;
    _GroupCapacity?: boolean;
    _StartInterval?: boolean;
    personCapacityStartMax?: number | undefined;
    groupCapacityMin?: number | undefined;
    groupCapacityMax?: number | undefined;
    groupCapacityStartMax?: number | undefined;
    startIntervalDuration?: Duration | undefined;
    bookStartIntervalDurationTimeOnly?: boolean;
}

export interface LocationResourceConfigResourceFormData extends LocationResourceConfigResourceTypeData {
    resourceId?: string;
    _ResourceCount?: number;
    orderIndex?: number;
}

export interface LocationResourceConfigAreaTreeNode {
    id?: string;
    orderIndex?: number;
    title?: string;
    type?: string;
    data?: LocationResourceConfigAreaFormData;
    children?: LocationResourceConfigAreaSectionTreeNode[];
}

export interface LocationResourceConfigAreaSectionTreeNode {
    id?: string;
    orderIndex?: number;
    title?: string;
    type?: string;
    data?: LocationResourceConfigAreaSectionFormData;
    children?: LocationResourceConfigResourceTreeNode[];
}

export interface LocationResourceConfigResourceTreeNode {
    id?: string;
    orderIndex?: number;
    title?: string;
    type?: string;
    data?: LocationResourceConfigResourceFormData;
}

export interface GetLocationResourceConfigResourcesPageViewQuery {
}

export interface GetLocationResourceConfigResourceFormDialogViewQueryResult {
    formDialogView?: LocationResourceConfigFormDialogViewOfLocationResourceConfigResourceFormData;
}

export interface LocationResourceConfigFormDialogViewOfLocationResourceConfigResourceFormData {
    objectId?: string;
    objectTypeName?: string;
    output?: LocationResourceConfigResourceFormData | undefined;
    input?: LocationResourceConfigResourceFormData | undefined;
    formConfig?: RaxFormConfig;
    dialogTitle?: string;
    actionType?: LocationResourceConfigFormDialogActionType;
    dialogPosition?: LocationResourceConfigFormDialogPosition;
}

export interface GetLocationResourceConfigResourceFormDialogViewQuery {
    cloneResource?: boolean;
    resource?: LocationResourceConfigResourceFormData;
}

export interface GetLocationResourceConfigResourceCategoryPageViewQueryResult {
    resourceConfigId?: string;
    resourceCategories?: LocationResourceConfigResourceCategoryListItem[];
}

export interface LocationResourceConfigResourceCategoryListItem {
    id?: string;
    resourceCategoryId?: string;
    name?: string;
}

export interface GetLocationResourceConfigResourceCategoryPageViewQuery {
}

export interface GetLocationResourceConfigResourceCategoryEditDialogViewQueryResult {
    input?: LocationResourceConfigResourceCategoryEditItem;
    output?: LocationResourceConfigResourceCategoryEditItem;
}

export interface LocationResourceConfigResourceCategoryEditItem {
    resourceCategoryId?: string;
    name?: string;
}

export interface GetLocationResourceConfigResourceCategoryEditDialogViewQuery {
    resourceCategoryId?: string;
}

export interface GetLocationResourceConfigResourceCategoryAddDialogViewQueryResult {
    input?: LocationResourceConfigResourceCategoryEditItem;
    output?: LocationResourceConfigResourceCategoryEditItem;
}

export interface GetLocationResourceConfigResourceCategoryAddDialogViewQuery {
}

export interface GetLocationResourceConfigAreaSectionFormDialogViewQueryResult {
    formDialogView?: LocationResourceConfigFormDialogViewOfLocationResourceConfigAreaSectionFormData;
}

export interface LocationResourceConfigFormDialogViewOfLocationResourceConfigAreaSectionFormData {
    objectId?: string;
    objectTypeName?: string;
    output?: LocationResourceConfigAreaSectionFormData | undefined;
    input?: LocationResourceConfigAreaSectionFormData | undefined;
    formConfig?: RaxFormConfig;
    dialogTitle?: string;
    actionType?: LocationResourceConfigFormDialogActionType;
    dialogPosition?: LocationResourceConfigFormDialogPosition;
}

export interface GetLocationResourceConfigAreaSectionFormDialogViewQuery {
    areaSection?: LocationResourceConfigAreaSectionFormData;
}

export interface GetLocationResourceConfigAreaFormDialogViewQueryResult {
    formDialogView?: LocationResourceConfigFormDialogViewOfLocationResourceConfigAreaFormData;
}

export interface LocationResourceConfigFormDialogViewOfLocationResourceConfigAreaFormData {
    objectId?: string;
    objectTypeName?: string;
    output?: LocationResourceConfigAreaFormData | undefined;
    input?: LocationResourceConfigAreaFormData | undefined;
    formConfig?: RaxFormConfig;
    dialogTitle?: string;
    actionType?: LocationResourceConfigFormDialogActionType;
    dialogPosition?: LocationResourceConfigFormDialogPosition;
}

export interface GetLocationResourceConfigAreaFormDialogViewQuery {
    area?: LocationResourceConfigAreaFormData;
}

export interface GetLocationPeriodEditDialogViewQueryResult {
    view?: LocationSettingsPeriodEditDialogView;
}

export interface LocationSettingsPeriodEditDialogView {
    dialogTitle?: string;
    output?: PeriodEditDialogFormData;
}

export interface PeriodEditDialogFormData {
    periodId?: string;
    name?: string;
    fromDate?: DateTime;
    toDate?: DateTime;
}

export interface GetLocationPeriodEditDialogViewQuery {
    periodId?: string;
}

export interface GetLocationPeriodConfigOpeningHoursViewQueryResult {
    periodId?: string;
    openingHoursConfigId?: string;
    input?: OpeningHourConfigEditItem;
    output?: OpeningHourConfigEditItem;
    periodOpeningHours?: WeekOpeningHours;
}

export interface OpeningHourConfigEditItem {
    weekOpeningHours?: WeekOpeningHours[];
}

export interface WeekOpeningHours {
    weekOpeningHoursId?: string;
    periodId?: string;
    periodName?: string;
    periodFromDate?: DateTime;
    periodToDate?: DateTime;
    closed?: boolean;
    openingHours?: OpeningHour[];
}

export interface OpeningHour {
    active?: boolean;
    orderIndex?: number;
    dayIndex?: number;
    closed?: boolean;
    allDayOpen?: boolean;
    fromTime?: Duration;
    fromDayIndex?: number;
    toTime?: Duration;
    toDayIndex?: number;
    duration?: Duration;
}

export interface GetLocationPeriodConfigOpeningHoursViewQuery {
    periodId?: string;
}

export interface GetLocationPeriodConfigEditItemViewQueryResult {
    periodConfigId?: string;
    input?: LocationSettingsPeriodConfigEditItem;
    output?: LocationSettingsPeriodConfigEditItem;
}

export interface LocationSettingsPeriodConfigEditItem {
    periods?: LocationSettingsPeriodEditItem[];
}

export interface LocationSettingsPeriodEditItem {
    periodId?: string;
    name?: string;
    fromDate?: DateTime;
    toDate?: DateTime;
}

export interface GetLocationPeriodConfigEditItemViewQuery {
}

export interface GetLocationPaymentListPageViewQueryResult {
    paymentSettings?: GetLocationPaymentListPageViewQueryResultItem[];
}

export interface GetLocationPaymentListPageViewQueryResultItem {
    id?: string;
    name?: string;
    paymentProviderId?: string;
}

export interface GetLocationPaymentListPageViewQuery {
}

export interface GetLocationPaymentFormDialogViewQueryResult {
    paymentProviderId?: string;
    paymentLinkDurationOptions?: DurationOptions;
    formData?: LocationSettingsPaymentFormData;
}

export interface LocationSettingsPaymentFormData {
    name?: string;
    allowManualPaymentEntry?: boolean;
    paymentLinkDuration?: Duration;
    paymentTransactionDescription?: string;
    refundTransactionDescription?: string;
    providerConnectionId?: string | undefined;
}

export interface GetLocationPaymentFormDialogViewQuery {
    paymentSettingsId?: string;
}

export interface GetLocationNewPaymentFormDialogViewQueryResult {
    dialogTitle?: string;
    paymentProviderId?: string;
    formData?: NewLocationSettingsPaymentFormData;
}

export interface NewLocationSettingsPaymentFormData {
    name?: string;
}

export interface GetLocationNewPaymentFormDialogViewQuery {
}

export interface GetLocationBookingPaymentSettingsEditItemViewQueryResult {
    locationSettingsId?: string;
    input?: LocationSettingsBookingPaymentSettingsEditItem;
    output?: LocationSettingsBookingPaymentSettingsEditItem;
    ageGroups?: LocationSettingsBookingPaymentAgeGroup[];
}

export interface LocationSettingsBookingPaymentSettingsEditItem {
    partialDepositRequirementScale?: PartialDepositRequirementScale;
    requiredDepositAmountPerPersonAgeGroupSettings?: RequiredDepositAmountPerPersonAgeGroupSettings;
}

export interface PartialDepositRequirementScale {
    steps?: PartialDepositRequirementScaleStep[];
}

export interface PartialDepositRequirementScaleStep {
    bookingFromAmount?: number;
    depositAmount?: number;
}

export interface RequiredDepositAmountPerPersonAgeGroupSettings {
    priceLevels?: RequiredDepositAmountPerPersonAgeGroupSettingsPriceLevel[];
}

export interface RequiredDepositAmountPerPersonAgeGroupSettingsPriceLevel {
    priceLevelId?: string;
    name?: string;
    ageGroupPerPersonPrices?: RequiredDepositAmountPerPersonAgeGroupSettingsPriceLevelPrice[];
}

export interface RequiredDepositAmountPerPersonAgeGroupSettingsPriceLevelPrice {
    ageGroupId?: string;
    _AgeGroupName?: string;
    price?: number;
}

export interface LocationSettingsBookingPaymentAgeGroup {
    ageGroupId?: string;
    orderIndex?: number;
    fromAge?: number;
    toAge?: number;
    unitSingular?: string;
    unitPlural?: string;
}

export interface GetLocationBookingPaymentSettingsEditItemViewQuery {
}

export interface GetLocationOverviewListPageViewQueryResult {
    overviews?: GetLocationOverviewListPageViewQueryResultItem[];
}

export interface GetLocationOverviewListPageViewQueryResultItem {
    id?: string;
    orderIndex?: number;
    name?: string;
    navItemColor?: string;
    navItemIcon?: string;
}

export interface GetLocationOverviewListPageViewQuery {
}

export interface GetLocationOverviewItemTabsPageViewQueryResult {
    pageTitle?: string;
    pageCloseNavItem?: OverviewTabsNavItem;
    navItems?: OverviewTabsNavItem[];
}

export interface OverviewTabsNavItem {
    name?: string;
    routeDefinition?: OverviewTabsRouteDefinition;
}

export interface OverviewTabsRouteDefinition {
    pathTemplate?: string;
}

export interface GetLocationOverviewItemTabsPageViewQuery {
    overviewId?: string;
}

export interface GetLocationOverviewFormDialogViewQueryResult {
    formDialogView?: OverviewFormDialogView;
}

export interface OverviewFormDialogView {
    objectId?: string;
    objectTypeName?: string;
    output?: LocationSettingsOverviewFormData;
    input?: LocationSettingsOverviewFormData;
    formConfig?: RaxFormConfig;
    dialogTitle?: string;
    actionType?: OverviewFormDialogActionType;
    dialogPosition?: OverviewFormDialogPosition;
    products?: OverviewSelectOption[];
    programSteps?: OverviewSelectOption[];
    bookingStatuses?: EnumOptionItem[];
    bookingOriginTypes?: EnumOptionItem[];
    bookingPaymentStatuses?: EnumOptionItem[];
}

export interface LocationSettingsOverviewFormData {
    orderIndex?: number;
    name?: string;
    description?: string;
    navItemColor?: string;
    navItemIcon?: string;
    programStepIds?: ValueItem[];
    productIds?: ValueItem[];
    bookingStatuses?: ValueItem[];
    bookingPaymentStatuses?: ValueItem[];
    bookingOriginTypes?: ValueItem[];
    columnOptions?: LocationOverviewColumnOptions;
}

export enum OverviewFormDialogActionType {
    Patch = "Patch",
    Post = "Post",
}

export enum OverviewFormDialogPosition {
    Center = "Center",
    Left = "Left",
    Top = "Top",
    Right = "Right",
    Bottom = "Bottom",
}

export interface OverviewSelectOption {
    text?: string;
    value?: string;
}

export interface GetLocationOverviewFormDialogViewQuery {
    overviewId?: string;
}

export interface GetLocationNoteListListPageViewQueryResult {
    noteLists?: GetLocationNoteListListPageViewQueryResultItem[];
}

export interface GetLocationNoteListListPageViewQueryResultItem {
    id?: string;
    orderIndex?: number;
    name?: string;
    idCode?: string;
    navItemColor?: string;
    navItemIcon?: string;
}

export interface GetLocationNoteListListPageViewQuery {
}

export interface GetLocationNoteListItemTabsPageViewQueryResult {
    id?: string;
    name?: string;
    pageTitle?: string;
}

export interface GetLocationNoteListItemTabsPageViewQuery {
    noteListId?: string;
}

export interface GetLocationNoteListFormDialogViewQueryResult {
    formDialogView?: NoteListFormDialogView;
}

export interface NoteListFormDialogView {
    objectId?: string;
    objectTypeName?: string;
    output?: LocationSettingsNoteListFormData;
    input?: LocationSettingsNoteListFormData;
    formConfig?: RaxFormConfig;
    dialogTitle?: string;
    actionType?: NoteListFormDialogActionType;
    dialogPosition?: NoteListFormDialogPosition;
}

export interface LocationSettingsNoteListFormData {
    orderIndex?: number;
    name?: string;
    description?: string;
    navItemColor?: string;
    navItemIcon?: string;
}

export enum NoteListFormDialogActionType {
    Patch = "Patch",
    Post = "Post",
}

export enum NoteListFormDialogPosition {
    Center = "Center",
    Left = "Left",
    Top = "Top",
    Right = "Right",
    Bottom = "Bottom",
}

export interface GetLocationNoteListFormDialogViewQuery {
    noteListId?: string;
}

export interface GetLocationGeneralSettingsQueryResult {
    id?: string;
    name?: string;
    legalName?: string;
    phoneNumber?: string;
    website?: string;
    contactEmail?: string;
    outgoingEmail?: string;
    street?: string;
    buildingNumber?: string;
    buildingNumberSuffix?: string;
    postalCode?: string;
    city?: string;
    bankAccountNumber?: string;
    vatNumber?: string;
    cocNumber?: string;
    termsAndConditionsUrl?: string;
}

export interface GetLocationGeneralSettingsQuery {
}

export interface GetLocationBookingSettingsQueryResult {
    disablePostalCodeLookup?: boolean;
    manualEmailConfirmation?: boolean;
    manualEmailConfirmationMinimumAmount?: number;
    approvalActive?: boolean;
    approvalMinimumAmount?: number;
    plannerBookingWithRequiredDepositActive?: boolean;
    plannerBookingDepositIsRequiredByDefault?: boolean;
    plannerBookingRequiredDepositAmountPercentageOfFinalPrice?: number;
    plannerPendingBookingExpiresAfterTime?: Duration;
}

export interface GetLocationBookingSettingsQuery {
}

export interface UpdateLocationBrandColorSchemeCommand {
    dark?: UpdateLocationBrandColorSchemeCommandColor;
    light?: UpdateLocationBrandColorSchemeCommandColor;
    accent?: UpdateLocationBrandColorSchemeCommandColor;
    background?: UpdateLocationBrandColorSchemeCommandColor;
    unEvenPrimary?: UpdateLocationBrandColorSchemeCommandColor;
    unEvenSecondary?: UpdateLocationBrandColorSchemeCommandColor;
    evenPrimary?: UpdateLocationBrandColorSchemeCommandColor;
    evenSecondary?: UpdateLocationBrandColorSchemeCommandColor;
}

export interface UpdateLocationBrandColorSchemeCommandColor {
    rgba?: string;
}

export interface GetLocationBrandSettingsQueryResult {
    brandSettingsColorScheme?: GetLocationBrandSettingsQueryResultColorScheme;
}

export interface GetLocationBrandSettingsQueryResultColorScheme {
    dark?: GetLocationBrandSettingsQueryResultColor;
    light?: GetLocationBrandSettingsQueryResultColor;
    accent?: GetLocationBrandSettingsQueryResultColor;
    background?: GetLocationBrandSettingsQueryResultColor;
    unEvenPrimary?: GetLocationBrandSettingsQueryResultColor;
    unEvenSecondary?: GetLocationBrandSettingsQueryResultColor;
    evenPrimary?: GetLocationBrandSettingsQueryResultColor;
    evenSecondary?: GetLocationBrandSettingsQueryResultColor;
}

export interface GetLocationBrandSettingsQueryResultColor {
    red?: number;
    green?: number;
    blue?: number;
    alpha?: number;
    rgba?: string;
    hex8?: string;
}

export interface GetLocationBrandSettingsQuery {
}

export interface GetLocationAgeGroupListPageViewQueryResult {
    ageGroups?: GetLocationAgeGroupListPageViewQueryResultItem[];
}

export interface GetLocationAgeGroupListPageViewQueryResultItem {
    id?: string;
    orderIndex?: number;
    name?: string;
    fromAge?: number;
    toAge?: number;
    unitSingular?: string;
    unitPlural?: string;
}

export interface GetLocationAgeGroupListPageViewQuery {
}

export interface GetLocationAgeGroupFormDialogViewQueryResult {
    formDialogView?: AgeGroupFormDialogView;
}

export interface AgeGroupFormDialogView {
    objectId?: string;
    objectTypeName?: string;
    output?: LocationSettingsAgeGroupFormData;
    input?: LocationSettingsAgeGroupFormData;
    formConfig?: RaxFormConfig;
    dialogTitle?: string;
    actionType?: AgeGroupFormDialogActionType;
    dialogPosition?: AgeGroupFormDialogPosition;
}

export interface LocationSettingsAgeGroupFormData {
    name?: string;
    fromAge?: number;
    toAge?: number;
    description?: string;
    unitId?: string;
}

export enum AgeGroupFormDialogActionType {
    Patch = "Patch",
    Post = "Post",
}

export enum AgeGroupFormDialogPosition {
    Center = "Center",
    Left = "Left",
    Top = "Top",
    Right = "Right",
    Bottom = "Bottom",
}

export interface GetLocationAgeGroupFormDialogViewQuery {
    ageGroupId?: string;
}

export interface SetLocationFeatureFlagsCommand {
    featureFlags?: SetLocationFeatureFlagsCommandFeatureFlag[];
}

export interface SetLocationFeatureFlagsCommandFeatureFlag {
    key?: string;
    isEnabled?: boolean;
}

export interface GetLocationFeatureFlagsFormViewQueryResult {
    formData?: LocationFeatureFlagsFormData;
    view?: LocationFeatureFlagsFormView;
}

export interface LocationFeatureFlagsFormData {
    featureFlags?: LocationFeatureFlagsFormDataFeatureFlag[];
}

export interface LocationFeatureFlagsFormDataFeatureFlag {
    key?: string;
    isEnabled?: boolean;
}

export interface LocationFeatureFlagsFormView {
    topics?: LocationFeatureFlagsFormViewTopic[];
}

export interface LocationFeatureFlagsFormViewTopic {
    name?: string;
    featureFlags?: LocationFeatureFlagsFormViewFeatureFlag[];
}

export interface LocationFeatureFlagsFormViewFeatureFlag {
    formControlIndex?: number;
    name?: string;
    key?: string;
    isPreview?: boolean;
    isDev?: boolean;
    availableForCmsSiteWebClient?: boolean;
}

export interface GetLocationFeatureFlagsFormViewQuery {
}

export interface GetProgramResultListWidgetDataQueryResult {
    programs?: GetProgramResultListWidgetDataQueryResultProgram[];
}

export interface GetProgramResultListWidgetDataQueryResultProgram {
    programName?: string;
    programId?: string;
    count?: number;
    bookingAmount?: number;
    extrasAmount?: number;
    totalAmount?: number;
}

export interface GetProgramResultListWidgetDataQuery {
    fromDate?: DateTime;
}

export interface GetPeriodSummaryWidgetDataQueryResult {
    reservationCount?: number;
    personCount?: number;
    bookingAmount?: number;
}

export interface GetPeriodSummaryWidgetDataQuery {
    fromDate?: DateTime;
}

export interface GetDayViewQueryResult {
    dashboardItems?: DashboardGridsterItem[];
}

export interface DashboardGridsterItem {
    id?: string;
    itemType?: string;
    x?: number;
    y?: number;
    cols?: number;
    rows?: number;
    dragEnabled?: boolean;
    resizeEnabled?: boolean;
}

export interface GetDayViewQuery {
}

export interface GetBookingCreatedOnWidgetDataQueryResult {
    series?: GetBookingCreatedOnWidgetDataQueryResultSeries[];
}

export interface GetBookingCreatedOnWidgetDataQueryResultSeries {
    name?: string;
    seriesData?: GetBookingCreatedOnWidgetDataQueryResultSeriesItem[];
}

export interface GetBookingCreatedOnWidgetDataQueryResultSeriesItem {
    count?: number;
    finalPriceAmount?: number;
    date?: DateTime;
}

export interface GetBookingCreatedOnWidgetDataQuery {
    fromDate?: DateTime;
}

export interface GetBookingCountOriginWidgetDataQueryResult {
    plannerCount?: number;
    bookingSiteCount?: number;
}

export interface GetBookingCountOriginWidgetDataQuery {
    fromDate?: DateTime;
}

export interface GetBookingAmountOriginWidgetDataQueryResult {
    plannerAmount?: number;
    bookingSiteAmount?: number;
}

export interface GetBookingAmountOriginWidgetDataQuery {
    fromDate?: DateTime;
}

export interface RefreshCachedCoreLocationDataCommand {
}

export interface LocationRelatedObjectNameData {
    units?: LocationUnitNameData[];
    ageGroups?: LocationAgeGroupNameData[];
    programSteps?: LocationProgramStepNameData[];
    programs?: LocationProgramNameData[];
    products?: LocationProductNameData[];
    programGroups?: LocationProgramGroupNameData[];
    areas?: LocationAreaNameData[];
    areaSections?: LocationAreaSectionNameData[];
    resources?: LocationResourceNameData[];
}

export interface LocationUnitNameData {
    id?: string;
    plural?: string;
    singular?: string;
}

export interface LocationAgeGroupNameData {
    id?: string;
    plural?: string;
    singular?: string;
}

export interface LocationProgramStepNameData {
    id?: string;
    name?: string;
    resourcePlural?: string;
    resourceSingular?: string;
}

export interface LocationProgramNameData {
    id?: string;
    name?: string;
}

export interface LocationProductNameData {
    id?: string;
    name?: string;
}

export interface LocationProgramGroupNameData {
    id?: string;
    name?: string;
}

export interface LocationAreaNameData {
    id?: string;
    name?: string;
}

export interface LocationAreaSectionNameData {
    id?: string;
    name?: string;
}

export interface LocationResourceNameData {
    id?: string;
    name?: string;
    shortName?: string;
}

export interface GetLocationRelatedObjectNameDataQuery {
}

export interface LocationCoreData {
    contact?: LocationCoreDataContactInfo;
    bookingSettings?: LocationCoreDataBookingSettings;
    marketingConfig?: LocationCoreDataMarketingConfig;
    ageGroups?: LocationCoreDataAgeGroup[];
    programGroups?: LocationCoreDataProgramGroup[];
    programs?: LocationCoreDataProgram[];
    programSteps?: LocationCoreDataProgramStep[];
    cmsSites?: LocationCoreDataCmsSite[];
    resourceConfig?: LocationCoreDataResourceConfig;
}

export interface LocationCoreDataContactInfo {
    locationName?: string;
    locationLegalName?: string;
    addressLine1?: string;
    addressLine2?: string;
    contactEmail?: string;
    phoneNumber?: string;
}

export interface LocationCoreDataBookingSettings {
    disablePostalCodeLookup?: boolean;
    manualEmailConfirmationMinimumAmount?: number;
    manualEmailConfirmation?: boolean;
    approvalActive?: boolean;
    approvalMinimumAmount?: number;
    plannerBookingWithRequiredDepositActive?: boolean;
    plannerBookingDepositIsRequiredByDefault?: boolean;
    plannerBookingRequiredDepositAmountPercentageOfFinalPrice?: number;
    plannerPendingBookingExpiresAfterTime?: Duration;
}

export interface LocationCoreDataMarketingConfig {
    customerSignup?: LocationCoreDataMarketingConfigCustomerSignup | undefined;
}

export interface LocationCoreDataMarketingConfigCustomerSignup {
    isApprovedByDefault?: boolean;
    requestSignUpText?: string;
}

export interface LocationCoreDataAgeGroup {
    ageGroupId?: string;
    fromAge?: number;
    toAge?: number;
}

export interface LocationCoreDataProgramGroup {
    programGroupId?: string;
    forPublicUse?: boolean;
    forInternalUse?: boolean;
    programs?: LocationCoreDataProgramGroupProgram[];
}

export interface LocationCoreDataProgramGroupProgram {
    programId?: string;
    forPublicUse?: boolean;
}

export interface LocationCoreDataProgram {
    programId?: string;
    participantConfig?: LocationCoreDataProgramParticipantConfig;
    programDuration?: Duration;
    programSteps?: LocationCoreDataProgramProgramStep[];
    isFavorite?: boolean;
}

export interface LocationCoreDataProgramParticipantConfig {
    applicableAgeGroupIds?: string[];
    minParticipantCountRequirement?: number;
    maxParticipantCountRequirement?: number;
}

export interface LocationCoreDataProgramProgramStep {
    programStepId?: string;
    duration?: Duration;
}

export interface LocationCoreDataProgramStep {
    programStepId?: string;
    participantConfig?: LocationCoreDataProgramStepParticipantConfig;
    allowedCapacityInputModes?: string[];
    allowsManualResourceSelection?: boolean;
    durationConfig?: LocationCoreDataProgramStepDurationConfig;
    isFavorite?: boolean;
}

export interface LocationCoreDataProgramStepParticipantConfig {
    applicableAgeGroupIds?: string[];
    minParticipantCountRequirement?: number;
    maxParticipantCountRequirement?: number;
}

export interface LocationCoreDataProgramStepDurationConfig {
    allowSelection?: boolean;
    options?: LocationCoreDataProgramStepDurationOption[];
}

export interface LocationCoreDataProgramStepDurationOption {
    duration?: Duration;
    isDefault?: boolean;
}

export interface LocationCoreDataCmsSite {
    siteId?: string;
    name?: string;
    primaryDomain?: string | undefined;
}

export interface LocationCoreDataResourceConfig {
    areas?: LocationCoreDataArea[];
}

export interface LocationCoreDataArea {
    areaId?: string;
    sections?: LocationCoreDataAreaSection[];
}

export interface LocationCoreDataAreaSection {
    areaSectionId?: string;
    resources?: LocationCoreDataResource[];
}

export interface LocationCoreDataResource {
    resourceId?: string;
}

export interface GetLocationCoreDataQuery {
}

export interface GetLeagueListPageViewQueryResult {
    items?: GetLeagueListPageViewQueryResultItem[];
}

export interface GetLeagueListPageViewQueryResultItem {
    id?: string;
    name?: string;
    active?: boolean;
    orderIndex?: number;
}

export interface GetLeagueListPageViewQuery {
}

export interface GetPlatformLocalesQueryResult {
    locales?: GetPlatformLocalesQueryResultLocale[];
}

export interface GetPlatformLocalesQueryResultLocale {
    localeId?: string;
    displayName?: string;
    isActive?: boolean;
}

export interface GetPlatformLocalesQuery {
}

export interface DeactivatePlatformLocaleCommand {
    localeId?: string;
}

export interface AddPlatformLocaleCommand {
    localeId?: string;
    displayName?: string;
}

export interface ActivatePlatformLocaleCommand {
    localeId?: string;
}

export interface SetLocationLocaleFallbackLocaleCommand {
    localeId?: string;
    fallbackLocaleId?: string;
}

export interface SetLocationDefaultLocaleCommand {
    defaultLocaleId?: string;
}

export interface RemoveLocationLocaleCommand {
    localeId?: string;
}

export interface MakeLocationLocaleOptionalCommand {
    localeId?: string;
}

export interface MakeLocationLocaleMandatoryCommand {
    localeId?: string;
}

export interface GetLocationLocalesQueryResult {
    locales?: GetLocationLocalesQueryResultLocale[];
}

export interface GetLocationLocalesQueryResultLocale {
    localeId?: string;
    displayName?: string;
    isDefault?: boolean;
    isMandatory?: boolean;
    fallbackLocale?: GetLocationLocalesQueryResultLocaleFallbackLocale | undefined;
    isInUseAsFallbackLocale?: boolean;
}

export interface GetLocationLocalesQueryResultLocaleFallbackLocale {
    localeId?: string;
    displayName?: string;
}

export interface GetLocationLocalesQuery {
}

export interface GetAvailableLocalesForLocationQueryResult {
    locales?: GetAvailableLocalesForLocationQueryResultLocale[];
}

export interface GetAvailableLocalesForLocationQueryResultLocale {
    localeId?: string;
    displayName?: string;
}

export interface GetAvailableLocalesForLocationQuery {
}

export interface GetAvailableFallbackLocalesForLocationLocaleQueryResult {
    locales?: GetAvailableFallbackLocalesForLocationLocaleQueryResultLocale[];
}

export interface GetAvailableFallbackLocalesForLocationLocaleQueryResultLocale {
    localeId?: string;
    displayName?: string;
}

export interface GetAvailableFallbackLocalesForLocationLocaleQuery {
    localeId?: string;
}

export interface ClearLocationLocaleFallbackLocaleCommand {
    localeId?: string;
}

export interface AddLocationLocaleCommand {
    localeId?: string;
}

export interface SetResourceTypeTextCommand {
    resourceTypeId?: string;
    text?: LocalizedPluralText | undefined;
}

export interface SetResourceTypeOrderCommand {
    resourceTypeIds?: string[];
}

export interface RenameResourceTypeCommand {
    resourceTypeId?: string;
    name?: string;
}

export interface RenameResourceTypePresetCommand {
    resourceTypeId?: string;
    resourceTypePresetId?: string;
    name?: string;
}

export interface RemoveResourceTypePresetCommand {
    resourceTypeId?: string;
    resourceTypePresetId?: string;
}

export interface GetResourceTypesConfigQueryResult {
    resourceTypes?: GetResourceTypesResourceType[];
    catalogExists?: boolean;
}

export interface GetResourceTypesResourceType {
    resourceTypeId?: string;
    name?: string;
    text?: LocalizedPluralText | undefined;
    consumption?: ResourceConsumptionResponse;
    presetCount?: number;
}

export interface ResourceConsumptionResponse {
    consumptionKind: string;
}

export interface ExclusiveUnitConsumptionResponse extends ResourceConsumptionResponse {
    structure?: UnitStructureResponse;
}

export interface UnitStructureResponse {
    structureKind: string;
}

export interface StandAloneUnitStructureResponse extends UnitStructureResponse {
}

export interface SequencedUnitStructureResponse extends UnitStructureResponse {
    pairing?: PairingResponse | undefined;
}

export interface PairingResponse {
    groupSize?: number;
}

export interface CombinableUnitStructureResponse extends UnitStructureResponse {
}

export interface SharedHeadcountConsumptionResponse extends ResourceConsumptionResponse {
}

export interface GetResourceTypesConfigQuery {
}

export interface GetResourceTypeConfigQueryResult {
    resourceType?: GetResourceTypeConfigResourceType | undefined;
}

export interface GetResourceTypeConfigResourceType {
    resourceTypeId?: string;
    name?: string;
    text?: LocalizedPluralText | undefined;
    consumption?: ResourceConsumptionResponse;
    presets?: GetResourceTypeConfigPreset[];
}

export interface GetResourceTypeConfigPreset {
    resourceTypePresetId?: string;
    name?: string;
    defaultDisplayName?: string;
    defaultDisplayCode?: string;
    defaultPersonCapacity?: number;
}

export interface GetResourceTypeConfigQuery {
    resourceTypeId?: string;
}

export interface DeleteResourceTypeCommand {
    resourceTypeId?: string;
}

export interface CreateResourceTypeCommandResponse {
    resourceTypeId?: string;
}

export interface CreateResourceTypeCommand {
    name?: string;
    consumption?: ResourceConsumptionRequest;
    text?: LocalizedPluralText | undefined;
}

export interface ResourceConsumptionRequest {
    consumptionKind: string;
}

export interface ExclusiveUnitConsumptionRequest extends ResourceConsumptionRequest {
    structure?: UnitStructureRequest;
}

export interface UnitStructureRequest {
    structureKind: string;
}

export interface StandAloneUnitStructureRequest extends UnitStructureRequest {
}

export interface SequencedUnitStructureRequest extends UnitStructureRequest {
    pairing?: PairingRequest | undefined;
}

export interface PairingRequest {
    groupSize?: number;
}

export interface CombinableUnitStructureRequest extends UnitStructureRequest {
}

export interface SharedHeadcountConsumptionRequest extends ResourceConsumptionRequest {
}

export interface CreateResourceTypeCatalogCommandResponse {
    resourceTypeCatalogId?: string;
}

export interface CreateResourceTypeCatalogCommand {
}

export interface ChangeResourceTypePresetDisplayDefaultsCommand {
    resourceTypeId?: string;
    resourceTypePresetId?: string;
    defaultDisplayName?: string;
    defaultDisplayCode?: string;
}

export interface ChangeResourceTypePresetDefaultPersonCapacityCommand {
    resourceTypeId?: string;
    resourceTypePresetId?: string;
    defaultPersonCapacity?: number;
}

export interface AddResourceTypePresetCommandResponse {
    resourceTypePresetId?: string;
}

export interface AddResourceTypePresetCommand {
    resourceTypeId?: string;
    name?: string;
    defaultDisplayName?: string;
    defaultDisplayCode?: string;
    defaultPersonCapacity?: number;
}

export interface SetLocationLayoutResourceDisplayCommand {
    resourceId?: string;
    displayName?: string;
    displayCode?: string;
}

export interface ReorderLocationLayoutSectionCommand {
    areaSectionId?: string;
    newIndex?: number;
}

export interface ReorderLocationLayoutResourceCommand {
    resourceId?: string;
    newIndex?: number;
}

export interface ReorderLocationLayoutAreaCommand {
    areaId?: string;
    newIndex?: number;
}

export interface RenameLocationLayoutSectionCommand {
    areaSectionId?: string;
    name?: string;
}

export interface RenameLocationLayoutResourceCommand {
    resourceId?: string;
    name?: string;
}

export interface RenameLocationLayoutAreaCommand {
    areaId?: string;
    name?: string;
}

export interface RemoveLocationLayoutSectionCommand {
    areaSectionId?: string;
}

export interface RemoveLocationLayoutResourceCommand {
    resourceId?: string;
}

export interface RemoveLocationLayoutAreaCommand {
    areaId?: string;
}

export interface MoveLocationLayoutSectionCommand {
    areaSectionId?: string;
    targetAreaId?: string;
    newIndex?: number;
}

export interface MoveLocationLayoutResourceCommand {
    resourceId?: string;
    targetAreaSectionId?: string;
    newIndex?: number;
}

export interface GetLocationLayoutConfigQueryResult {
    locationLayout?: GetLocationLayoutConfigLocationLayout | undefined;
}

export interface GetLocationLayoutConfigLocationLayout {
    locationLayoutId?: string;
    areas?: GetLocationLayoutConfigArea[];
}

export interface GetLocationLayoutConfigArea {
    areaId?: string;
    name?: string;
    sections?: GetLocationLayoutConfigAreaSection[];
}

export interface GetLocationLayoutConfigAreaSection {
    areaSectionId?: string;
    name?: string;
    resources?: GetLocationLayoutConfigResource[];
}

export interface GetLocationLayoutConfigResource {
    resourceId?: string;
    name?: string;
    displayName?: string;
    displayCode?: string;
    resourceTypeId?: string;
    personCapacity?: number;
    sequenceNumber?: number;
    pairGroupId?: string | undefined;
    positionInGroup?: number | undefined;
}

export interface GetLocationLayoutConfigQuery {
}

export interface FormLocationLayoutPairGroupCommandResponse {
    pairGroupId?: string;
}

export interface FormLocationLayoutPairGroupCommand {
    resourceTypeId?: string;
    resourceIds?: string[];
}

export interface DissolveLocationLayoutPairGroupCommand {
    pairGroupId?: string;
}

export interface DeleteLocationLayoutCommand {
}

export interface CreateLocationLayoutCommandResponse {
    locationLayoutId?: string;
}

export interface CreateLocationLayoutCommand {
}

export interface ChangeLocationLayoutResourcePersonCapacityCommand {
    resourceId?: string;
    personCapacity?: number;
}

export interface AddLocationLayoutSectionCommandResponse {
    areaSectionId?: string;
}

export interface AddLocationLayoutSectionCommand {
    areaId?: string;
    name?: string;
}

export interface AddLocationLayoutResourceCommandResponse {
    resourceId?: string;
}

export interface AddLocationLayoutResourceCommand {
    areaSectionId?: string;
    name?: string;
    displayName?: string;
    displayCode?: string;
    resourceTypeId?: string;
    resourceTypePresetId?: string;
}

export interface AddLocationLayoutResourcesCommandResponse {
    resourceIds?: string[];
}

export interface AddLocationLayoutResourcesCommand {
    areaSectionId?: string;
    resourceTypeId?: string;
    resourceTypePresetId?: string;
    namePrefix?: string;
    displayNamePrefix?: string;
    displayCodePrefix?: string;
    count?: number;
    startNumber?: number;
}

export interface AddLocationLayoutAreaCommandResponse {
    areaId?: string;
}

export interface AddLocationLayoutAreaCommand {
    name?: string;
}

export interface SetNameForApiKeyCommandResponse {
    isSuccess?: boolean;
    failureCode?: string | undefined;
}

export interface SetNameForApiKeyCommand {
    keyId?: string;
    name?: string;
}

export interface RevokeApiKeyCommandResponse {
    isSuccess?: boolean;
    failureCode?: string | undefined;
}

export interface RevokeApiKeyCommand {
    keyId?: string;
}

export interface GetApiKeysForLocationQueryResult {
    items?: GetApiKeysForLocationQueryResultItem[];
}

export interface GetApiKeysForLocationQueryResultItem {
    keyId?: string;
    name?: string;
    status?: string;
    revokedAtDateTime?: DateTime | undefined;
}

export interface CreateApiKeyCommandResponse {
    keyId?: string;
    secret?: string;
    name?: string;
}

export interface CreateApiKeyCommand {
    name?: string;
}

export interface GetEmailTemplateListViewQueryResult {
    emailTemplates?: GetEmailTemplateListViewQueryResultItem[];
}

export interface GetEmailTemplateListViewQueryResultItem {
    id?: string;
    name?: string;
    relatedObjectType?: string;
}

export interface GetEmailTemplateListViewQuery {
}

export interface GetEmailTemplateEditItemViewQueryResult {
    emailTemplateName?: string;
    emailTemplateId?: string;
    relatedObjectType?: string;
    isDirty?: boolean;
    input?: EmailTemplateEditItemModel;
    output?: EmailTemplateEditItemModel;
    navItems?: EmailTemplateEditItemNavItem[];
}

export interface EmailTemplateEditItemModel {
    name?: string;
    emailTemplate?: string;
}

export interface EmailTemplateEditItemNavItem {
    name?: string;
    routeDefinition?: EmailTemplateEditItemNavItemRouteDefinition;
}

export interface EmailTemplateEditItemNavItemRouteDefinition {
    path?: string;
}

export interface GetEmailTemplateEditItemViewQuery {
    emailTemplateId?: string;
}

export interface SendCmsSiteCheckOutLinkCommand {
    cmsSiteId?: string;
    programId?: string;
    arrivalDate?: DateTime;
    emailToAddress?: string;
}

export interface EmailSettingsEditItemView {
    locationMessageSettingsId?: string;
    bookingSiteId?: string;
    allowForBookingsite?: boolean;
    isForBookingSite?: boolean;
    outgoingEmailAddress?: string;
    input?: EmailSettingsEditItem;
    output?: EmailSettingsEditItem;
    navItems?: EmailSettingsNavItem[];
    isDirty?: boolean;
}

export interface EmailSettingsEditItem {
    emailSettings?: EmailSettingsData;
    emailServerSettings?: EmailServerSettingsData;
}

export interface EmailSettingsData {
    emailEventConfigs?: EmailEventConfigData[];
    emailServerSettingsData?: EmailServerSettingsData;
}

export interface EmailEventConfigData {
    eventType?: string;
    relatedObjectType?: string;
    emailCommandId?: string;
    active?: boolean;
    label?: string;
    emailSubject?: string;
    templateId?: string;
    templateName?: string;
    ccEmailAddress?: string;
    bccEmailAddress?: string;
    emailAttachments?: EmailAttachmentData[];
    emailSendSchedule?: EmailSendSchedule;
}

export interface EmailAttachmentData {
    fileId?: string;
    fileName?: string;
}

export interface EmailSendSchedule {
    emailSendScheduleId?: string;
    emailSendIntervals?: EmailSendInterval[];
}

export interface EmailSendInterval {
    emailSendIntervalId?: string;
    active?: boolean;
    intervalDuration?: Duration;
    sendAtTime?: Duration;
}

export interface EmailServerSettingsData {
    outgoingEmailAddress?: string;
    emailServerType?: string;
    emailServerToken?: string;
}

export interface EmailSettingsNavItem {
    name?: string;
    routeDefinition?: EmailSettingsNavRouteDefinition;
}

export interface EmailSettingsNavRouteDefinition {
    path?: string;
}

export interface GetEmailSettingsEditItemViewQuery {
    bookingSiteId?: string;
}

export interface EmailSettingsEditItemLocationView {
    locationMessageSettingsId?: string;
    locationSettings?: LocationMessageLocationSettings;
}

export interface LocationMessageLocationSettings {
    id?: string;
    name?: string;
    legalName?: string;
    cocNumber?: string;
    branchNumber?: string;
    phoneNumber?: string;
    website?: string;
    contactEmail?: string;
    street?: string;
    buildingNumber?: string;
    buildingNumberSuffix?: string;
    postalCode?: string;
    city?: string;
}

export interface GetEmailSettingsEditItemLocationViewQuery {
    bookingSiteId?: string;
}

export interface EmailSettingsEditItemEventsView {
    emailTemplates?: EmailSettingsEventTemplateItem[];
    isDirty?: boolean;
}

export interface EmailSettingsEventTemplateItem {
    text?: string;
    objectType?: string;
    value?: string;
}

export interface GetEmailSettingsEditItemEventsViewQuery {
}

export interface GetCustomerListPageViewQueryResult {
    customers?: GetCustomerListPageViewQueryResultItem[];
}

export interface GetCustomerListPageViewQueryResultItem {
    id?: string;
    customerId?: string;
    isCompany?: boolean;
    companyName?: string;
    departmentName?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    phoneNumber?: string;
}

export interface GetCustomerListPageViewQuery {
}

export interface GetCustomerEditItemPageViewQueryResult {
    customerId?: string;
    input?: CustomerEditItemData;
    output?: CustomerEditItemData;
    navItems?: NavItemView[];
    isDirty?: boolean;
}

export interface CustomerEditItemData {
    isCompany?: boolean;
    companyName?: string;
    departmentName?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    phoneNumber?: string;
}

export interface GetCustomerEditItemPageViewQuery {
    customerId?: string;
}

export interface SearchCustomersQueryResult {
    items?: SearchCustomersQueryResultItem[];
}

export interface SearchCustomersQueryResultItem {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    contactPhoneNumber?: SearchCustomersQueryResultInternationalPhoneNumber | undefined;
    isCompany?: boolean;
    companyName?: string | undefined;
    departmentName?: string | undefined;
    countryCode?: string;
    street?: string | undefined;
    buildingNumber?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
}

export interface SearchCustomersQueryResultInternationalPhoneNumber {
    e164?: string;
    countryCode?: string;
    nationalNumber?: string;
}

export interface SearchCustomersQuery {
    searchString?: string;
    partialMatch?: boolean;
}

export interface GetCustomerInfoQueryResult {
    customerAccountId?: string;
    customerId?: string;
    lastName?: string;
    contactEmailAddress?: string;
    contactPhoneNumber?: GetCustomerInfoQueryResultInternationalPhoneNumber | undefined;
}

export interface GetCustomerInfoQueryResultInternationalPhoneNumber {
    e164?: string;
    countryCode?: string;
    nationalNumber?: string;
}

export interface GetCustomerInfoQuery {
    customerAccountId?: string;
    customerId?: string;
}

export interface IsCustomerAccountAuthenticationPhoneNumberInUseQueryResult {
    phoneNumberIsAssignedToAccount?: boolean;
}

export interface IsCustomerAccountAuthenticationPhoneNumberInUseQuery {
    countryCode?: string;
    nationalNumber?: string;
}

export interface IsCustomerAccountAuthenticationEmailAddressInUseQueryResult {
    emailIsAssignedToAccount?: boolean;
}

export interface IsCustomerAccountAuthenticationEmailAddressInUseQuery {
    emailAddress?: string;
}

export interface GetCustomerAccountInfoByIdQueryResult {
    customerAccount?: CustomerAccountInfo;
}

export interface CustomerAccountInfo {
    customerAccountId?: string;
    displayName?: string;
    defaultCustomer?: CustomerAccountInfoCustomer;
    otherCustomers?: CustomerAccountInfoCustomer[];
    authenticationEmailAddress?: string;
    authenticationPhoneNumber?: CustomerAccountInfoInternationalPhoneNumber | undefined;
}

export interface CustomerAccountInfoCustomer {
    customerId?: string;
    lastName?: string;
    contactPhoneNumber?: CustomerAccountInfoInternationalPhoneNumber | undefined;
    contactEmailAddress?: string | undefined;
}

export interface CustomerAccountInfoInternationalPhoneNumber {
    e164?: string;
    countryCode?: string;
    nationalNumber?: string;
}

export interface GetCustomerAccountInfoByIdQuery {
    customerAccountId?: string;
}

export interface GetCustomerAccountInfoByAuthenticationPhoneNumberQueryResult {
    customerAccount?: CustomerAccountInfo;
}

export interface GetCustomerAccountInfoByAuthenticationPhoneNumberQuery {
    countryCode?: string;
    nationalNumber?: string;
}

export interface GetCustomerAccountInfoByAuthenticationEmailAddressQueryResult {
    customerAccount?: CustomerAccountInfo;
}

export interface GetCustomerAccountInfoByAuthenticationEmailAddressQuery {
    authenticationEmailAddress?: string;
}

export interface CreateCustomerAccountCommandResponse {
    customerAccountId?: string;
    customerId?: string;
}

export interface CreateCustomerAccountCommand {
    customerLastName?: string;
    authenticationEmailAddress?: string | undefined;
    authenticationPhoneNumber?: CreateCustomerAccountCommandInternationalPhoneNumber | undefined;
}

export interface CreateCustomerAccountCommandInternationalPhoneNumber {
    countryCode?: string;
    nationalNumber?: string;
}

export interface SetLocationMessagingSettingsCommand {
    senderName?: string;
    replyToEmailAddress?: string;
    transportCredentialRef?: string;
    isEnabled?: boolean;
    testRecipient?: string;
}

export interface SetEmailContentSectionsCommand {
    kind?: string;
    sections?: EmailContentSectionCommand[];
}

export interface EmailContentSectionCommand {
    name?: string;
    text?: LocalizedStaticText;
}

export interface SetCurrentEmailThemeCommand {
    logoUrl?: string | undefined;
    accentColor?: string;
    footerText?: LocalizedStaticText | undefined;
}

export interface OutboundEmail {
    id?: string;
    tenantId?: string;
    locationId?: string;
    kind?: string;
    subjectRef?: string;
    recipient?: string | undefined;
    redirectedTo?: string | undefined;
    localeId?: string | undefined;
    status?: OutboundEmailStatus;
    reason?: OutboundEmailReason | undefined;
    detail?: string | undefined;
    providerMessageId?: string | undefined;
    renderedSubject?: string | undefined;
    createdAt?: DateTime;
    sentAt?: DateTime | undefined;
    attempts?: number;
    isTest?: boolean;
}

export enum OutboundEmailStatus {
    Pending = "Pending",
    Sent = "Sent",
    Failed = "Failed",
    Skipped = "Skipped",
}

export enum OutboundEmailReason {
    KindDisabled = "KindDisabled",
    NoContactEmail = "NoContactEmail",
    CustomerOptedOut = "CustomerOptedOut",
    NoContent = "NoContent",
    RedirectNotConfigured = "RedirectNotConfigured",
    MessagingDisabled = "MessagingDisabled",
    NotApplicable = "NotApplicable",
    RenderError = "RenderError",
    UnknownKind = "UnknownKind",
    TransportAuthentication = "TransportAuthentication",
    ProviderRejected = "ProviderRejected",
    ProviderUnavailable = "ProviderUnavailable",
}

export interface SendTestEmailCommand {
    kind?: string;
    localeId?: string;
    to?: string;
    subjectRef?: string | undefined;
}

export interface ResetEmailContentSectionCommand {
    kind?: string;
    name?: string;
}

export interface ResendOutboundEmailCommand {
    outboundEmailId?: string;
}

export interface RenderedEmail {
    subject?: string;
    htmlBody?: string;
    textBody?: string;
}

export interface PreviewEmailCommand {
    kind?: string;
    localeId?: string;
}

export interface PreviewEmailForSubjectQueryResult {
    outcome?: PreviewEmailForSubjectOutcome;
    rendered?: RenderedEmail | undefined;
}

export enum PreviewEmailForSubjectOutcome {
    Rendered = "Rendered",
    SubjectUnavailable = "SubjectUnavailable",
}

export interface PreviewEmailForSubjectCommand {
    kind?: string;
    localeId?: string;
    subjectRef?: string;
}

export interface PreviewEmailDraftCommand {
    kind?: string;
    localeId?: string | undefined;
    sections?: DraftSection[];
}

export interface DraftSection {
    name?: string;
    text?: string;
}

export interface GetRecentOutboundEmailsQueryResult {
    emails?: OutboundEmail[];
}

export interface GetRecentOutboundEmailsQuery {
    limit?: number;
}

export interface GetOutboundEmailsBySubjectRefQueryResult {
    emails?: OutboundEmail[];
}

export interface GetOutboundEmailsBySubjectRefQuery {
    subjectRef?: string;
}

export interface GetMessageKindsQueryResult {
    kinds?: MessageKindSummary[];
}

export interface MessageKindSummary {
    kind?: string;
    ownerContext?: string;
    label?: LocalizedStaticText;
    sections?: MessageKindSectionSummary[];
    placeholders?: MessageKindPlaceholderSummary[];
    blocks?: MessageKindBlockSummary[];
    collections?: MessageKindCollectionSummary[];
}

export interface MessageKindSectionSummary {
    name?: string;
    format?: SectionFormat;
    maxLength?: number;
    isRequired?: boolean;
}

export enum SectionFormat {
    PlainText = "PlainText",
    RichHtml = "RichHtml",
}

export interface MessageKindPlaceholderSummary {
    token?: string;
    kind?: PlaceholderKind;
    label?: LocalizedStaticText;
    example?: string;
}

export enum PlaceholderKind {
    Text = "Text",
    Money = "Money",
    Instant = "Instant",
    LocalizedText = "LocalizedText",
}

export interface MessageKindBlockSummary {
    name?: string;
    label?: LocalizedStaticText;
    description?: LocalizedStaticText;
    isRequired?: boolean;
}

export interface MessageKindCollectionSummary {
    name?: string;
    label?: LocalizedStaticText;
    itemPlaceholders?: MessageKindPlaceholderSummary[];
}

export interface GetLocationMessagingSettingsQueryResult {
    isConfigured?: boolean;
    senderName?: string | undefined;
    replyToEmailAddress?: string | undefined;
    transportCredentialRef?: string | undefined;
    testRecipient?: string | undefined;
    isEnabled?: boolean;
    isNonProduction?: boolean;
    deploymentTypeName?: string;
}

export interface GetEmailContentQueryResult {
    kind?: string;
    sections?: EmailContentSectionResult[];
}

export interface EmailContentSectionResult {
    name?: string;
    text?: LocalizedStaticText;
    isDefault?: boolean;
}

export interface GetEmailContentQuery {
    kind?: string;
}

export interface GetCurrentEmailThemeQueryResult {
    hasTheme?: boolean;
    logoUrl?: string | undefined;
    accentColor?: string | undefined;
    footerText?: LocalizedStaticText | undefined;
}

export interface TestEmailProviderConnectionQueryResult {
    isConfigured?: boolean;
    hasSecretValue?: boolean;
    providerReached?: boolean;
    registeredDomainCount?: number | undefined;
    problem?: string | undefined;
}

export interface GetEmailProviderConfigurationQueryResult {
    kind?: string;
    accountTokenSecretName?: string;
    accountTokenKeyVaultSecretName?: string;
    hasAccountTokenValue?: boolean;
    isComplete?: boolean;
}

export interface UnassignCustomDomainHostnameFromLocationCommand {
    hostname?: string;
}

export interface RetryCustomDomainProvisioningCommand {
    hostname?: string;
    capability?: CapabilityKind;
}

export enum CapabilityKind {
    WebHosting = "WebHosting",
    EmailSending = "EmailSending",
}

export interface RequestCustomDomainCommandResponse {
    customDomainId?: string;
    domain?: string;
    capabilities?: RequestedCapabilityResult[];
}

export interface RequestedCapabilityResult {
    hostname?: string;
    capability?: CapabilityKind;
    state?: string;
}

export interface RequestCustomDomainCommand {
    domain?: string;
    requestEmailSending?: boolean;
    requestWebHosting?: boolean;
    emailHostname?: string | undefined;
    websiteHostname?: string | undefined;
    createdFromLocationId?: string | undefined;
    ownedName?: string | undefined;
}

export interface RemoveCustomDomainHostnameCommand {
    hostname?: string;
}

export interface RemoveCustomDomainCapabilityCommand {
    hostname?: string;
    capability?: CapabilityKind;
}

export interface GetTenantHostAllowanceQueryResult {
    maxHosts?: number;
    usedHosts?: number;
}

export interface GetCustomDomainsQueryResult {
    domains?: GetCustomDomainsDomain[];
}

export interface GetCustomDomainsDomain {
    customDomainId?: string;
    ownedName?: string;
    registrableName?: string;
    hostnames?: GetCustomDomainsHostname[];
}

export interface GetCustomDomainsHostname {
    hostname?: string;
    isApex?: boolean;
    addedUtc?: DateTime;
    createdFromLocationId?: string | undefined;
    assignedLocationIds?: string[];
    capabilities?: GetCustomDomainsCapability[];
}

export interface GetCustomDomainsCapability {
    kind?: CapabilityKind;
    state?: string;
    isUsable?: boolean;
    stateChangedUtc?: DateTime;
    activatedUtc?: DateTime | undefined;
    suspendedReason?: string | undefined;
    attemptCount?: number;
    nextCheckUtc?: DateTime | undefined;
    records?: GetCustomDomainsRecord[];
}

export interface GetCustomDomainsRecord {
    host?: string;
    recordType?: string;
    expectedValue?: string;
    isConfirmed?: boolean;
}

export interface EvaluateCustomDomainHostnameQueryResult {
    isUsable?: boolean;
    reason?: DomainIneligibilityReason | undefined;
    customDomainId?: string | undefined;
    proposedOwnedName?: string | undefined;
}

export enum DomainIneligibilityReason {
    NotRegistered = "NotRegistered",
    SetupInProgress = "SetupInProgress",
    SetupFailed = "SetupFailed",
    Deactivated = "Deactivated",
}

export interface EvaluateCustomDomainHostnameQuery {
    hostname?: string;
    capability?: CapabilityKind;
}

export interface CheckCustomDomainCapabilityNowQueryResult {
    state?: string;
    setupReason?: CustomDomainSetupReason;
    lastCheckedAt?: DateTime | undefined;
    lastRefreshAt?: DateTime | undefined;
    nextCheckAt?: DateTime | undefined;
    stalledSinceAt?: DateTime | undefined;
}

export enum CustomDomainSetupReason {
    None = "None",
    WaitingForProvider = "WaitingForProvider",
    CustomerSetupMissing = "CustomerSetupMissing",
    CustomerSetupPointsElsewhere = "CustomerSetupPointsElsewhere",
    CheckInconclusive = "CheckInconclusive",
    ProviderRetryRequested = "ProviderRetryRequested",
    RefreshLimitReached = "RefreshLimitReached",
    RegistrationRemovedByProvider = "RegistrationRemovedByProvider",
}

export interface CheckCustomDomainCapabilityNowCommand {
    hostname?: string;
    capability?: CapabilityKind;
}

export interface AssignCustomDomainHostnameToLocationCommand {
    hostname?: string;
}

export interface ActivateCustomDomainCapabilityCommandResponse {
    state?: string;
    nextCheckUtc?: DateTime | undefined;
}

export interface ActivateCustomDomainCapabilityCommand {
    hostname?: string;
    capability?: CapabilityKind;
}

export interface TestDnsProviderConnectionQueryResult {
    isConfigured?: boolean;
    hasSecretValue?: boolean;
    problem?: string | undefined;
}

export interface SetDnsProviderOverrideCommand {
    zoneId?: string | undefined;
    cnameTarget?: string | undefined;
}

export interface GetDnsProviderConfigurationQueryResult {
    kind?: string;
    apiTokenSecretName?: string;
    apiTokenKeyVaultSecretName?: string;
    hasApiTokenValue?: boolean;
    isComplete?: boolean;
    zoneId?: GetDnsProviderConfigurationField;
    cnameTarget?: GetDnsProviderConfigurationField;
}

export interface GetDnsProviderConfigurationField {
    configurationKey?: string;
    keyVaultSecretName?: string;
    keyVaultValue?: string | undefined;
    overrideValue?: string | undefined;
    effectiveValue?: string | undefined;
    isOverridden?: boolean;
}

export interface GetCouponCampaignListViewQueryResult {
    couponCampaigns?: GetCouponCampaignListViewQueryResultItem[];
}

export interface GetCouponCampaignListViewQueryResultItem {
    id?: string;
    active?: boolean;
    name?: string;
    couponRewardType?: CouponRewardType;
    couponRewardAmount?: number | undefined;
    couponRewardPercentage?: number | undefined;
    maxUsedCount?: number;
    minBookingAmount?: number | undefined;
    validForEntryFromDate?: DateTime | undefined;
    validForEntryToDate?: DateTime | undefined;
    validForBookingFromDate?: DateTime | undefined;
    validForBookingToDate?: DateTime | undefined;
    validForBookingFromTime?: Duration | undefined;
    validForBookingToTime?: Duration | undefined;
    couponCount?: number;
}

export enum CouponRewardType {
    Percentage = "Percentage",
    Amount = "Amount",
}

export interface GetCouponCampaignListViewQuery {
}

export interface GetCouponCampaignEditItemViewQueryResult {
    couponCampaignId?: string;
    couponCampaignName?: string;
    isDirty?: boolean;
    output?: CouponCampaignEditItem;
    input?: CouponCampaignEditItem;
    couponCampaign?: CouponCampaignInfo;
    relatedObjects?: CouponCampaignSelectListItem[];
    navItems?: CouponCampaignNavItem[];
}

export interface CouponCampaignEditItem {
    active?: boolean;
    name?: string;
    description?: string;
    validForEntryFromDate?: DateTime | undefined;
    validForEntryToDate?: DateTime | undefined;
    validForBookingFromDate?: DateTime | undefined;
    validForBookingToDate?: DateTime | undefined;
    validForBookingFromTime?: Duration | undefined;
    validForBookingToTime?: Duration | undefined;
    relatedObjects?: CouponCampaignRelatedObjectItem[];
    days?: CouponCampaignDayItem[];
}

export interface CouponCampaignRelatedObjectItem {
    relatedObjectName?: string;
    relatedObjectId?: string;
    relatedObjectType?: string;
    relatedObjectActive?: boolean | undefined;
}

export interface CouponCampaignDayItem {
    isActive?: boolean;
    dayIndex?: number;
    dayOfWeek?: DayOfWeek;
}

export interface CouponCampaignInfo {
    couponRewardType?: CouponRewardType;
    couponRewardAmount?: number | undefined;
    couponCount?: number;
}

export interface CouponCampaignSelectListItem {
    text?: string;
    objectType?: string;
    value?: string;
}

export interface CouponCampaignNavItem {
    name?: string;
    routeDefinition?: CouponCampaignRouteDefinition;
}

export interface CouponCampaignRouteDefinition {
    path?: string;
}

export interface GetCouponCampaignEditItemViewQuery {
    couponCampaignId?: string;
}

export interface GetCouponCampaignEditItemCodesViewQueryResult {
    couponCampaignId?: string;
    couponCampaignName?: string;
    couponCodes?: GetCouponCampaignEditItemCodesViewQueryResultCode[];
}

export interface GetCouponCampaignEditItemCodesViewQueryResultCode {
    id?: string;
    active?: boolean;
    used?: boolean;
    usedCount?: number;
    code?: string;
    rewardType?: CouponRewardType;
    rewardAmount?: number | undefined;
    rewardPercentage?: number | undefined;
    maxUsedCount?: number;
    minBookingAmount?: number | undefined;
    days?: CouponCampaignDayItem[];
}

export interface GetCouponCampaignEditItemCodesViewQuery {
    couponCampaignId?: string;
}

export interface GetCouponCampaignAddDialogViewQueryResult {
    dialogTitle?: string;
    couponRewardTypes?: EnumOptionItem[];
    relatedObjects?: CouponCampaignSelectListItem[];
    output?: CouponCampaignAddDialogOutput;
}

export interface CouponCampaignAddDialogOutput {
    name?: string;
    couponRewardType?: CouponRewardType;
    validForEntryFromDate?: DateTime | undefined;
    validForEntryToDate?: DateTime | undefined;
    validForBookingFromDate?: DateTime | undefined;
    validForBookingToDate?: DateTime | undefined;
    validForBookingFromTime?: Duration | undefined;
    validForBookingToTime?: Duration | undefined;
    relatedObjects?: CouponCampaignRelatedObjectItem[];
    autoGenerateCodes?: boolean;
    couponCodePrefix?: string;
    couponCount?: number;
    couponCodeLength?: number;
    couponRewardAmount?: number | undefined;
    couponRewardPercentage?: number | undefined;
    maxUsedCount?: number;
    minBookingAmount?: number | undefined;
    days?: CouponCampaignDayItem[];
    description?: string;
}

export interface GetCouponCampaignAddDialogViewQuery {
}

export interface CmsTemplateListView {
    templates?: CmsTemplateListItem[];
}

export interface CmsTemplateListItem {
    id?: string;
    name?: string;
    label?: string;
    contentTypeName?: string;
}

export interface GetListViewQuery2 {
}

export interface CmsTemplateEditItemView {
    cmsTemplateId?: string;
    cmsTemplateName?: string;
    cmsContentTypeId?: string;
    cmsContentTypeName?: string;
    input?: CmsTemplateEditItem;
    output?: CmsTemplateEditItem;
    navItems?: CmsTemplateNavItem[];
    isDirty?: boolean;
}

export interface CmsTemplateEditItem {
    name?: string;
    label?: string;
    description?: string;
    templateParts?: CmsTemplateTemplatePart[];
}

export interface CmsTemplateTemplatePart {
    orderIndex?: number;
    templatePartId?: string;
    templatePartName?: string;
    templatePartLabel?: string;
}

export interface CmsTemplateNavItem {
    name?: string;
    routeDefinition?: CmsTemplateRouteDefinition;
}

export interface CmsTemplateRouteDefinition {
    pathTemplate?: string;
    path?: string;
    queryParams?: { [key: string]: string; };
}

export interface GetEditItemViewQuery2 {
    cmsTemplateId?: string;
}

export interface CmsTemplateAddPartDialogView {
    dialogTitle?: string;
    templateParts?: CmsTemplateTemplatePart[];
}

export interface GetAddPartdDialogViewQuery {
}

export interface CmsTemplateAddDialogView {
    dialogTitle?: string;
    contentTypes?: CmsTemplateContentTypeOption[];
}

export interface CmsTemplateContentTypeOption {
    value?: string;
    text?: string;
}

export interface GetAddDialogViewQuery {
}

export interface GetCmsTemplatePartListViewQueryResult {
    templateParts?: CmsTemplatePartListItem[];
}

export interface CmsTemplatePartListItem {
    id?: string;
    name?: string;
    label?: string;
}

export interface GetCmsTemplatePartListViewQuery {
}

export interface GetCmsTemplatePartEditItemViewQueryResult {
    cmsTemplatePartId?: string;
    cmsTemplatePartName?: string;
    isDirty?: boolean;
    input?: CmsTemplatePartEditItem;
    output?: CmsTemplatePartEditItem;
    navItems?: CmsTemplatePartEditItemNavItem[];
}

export interface CmsTemplatePartEditItem {
    name?: string;
    description?: string;
    label?: string;
    fields?: CmsTemplatePartEditItemField[];
    contentFields?: CmsTemplatePartEditItemContentField[];
}

export interface CmsTemplatePartEditItemField {
    fieldId?: string;
    label?: string;
    name?: string;
    description?: string;
    value?: string;
    fieldType?: string;
    fieldTypeSettingsJson?: string;
}

export interface CmsTemplatePartEditItemContentField {
    fieldId?: string;
    name?: string;
    contentPartId?: string;
    contentPartLabel?: string;
    multiple?: boolean;
    maxItems?: number;
    linkToPage?: boolean;
}

export interface CmsTemplatePartEditItemNavItem {
    name?: string;
    routeDefinition?: CmsTemplatePartEditItemNavItemRouteDefinition;
}

export interface CmsTemplatePartEditItemNavItemRouteDefinition {
    path?: string;
}

export interface GetCmsTemplatePartEditItemViewQuery {
    templatePartId?: string;
}

export interface GetCmsTemplatePartAddDialogViewQueryResult {
    dialogTitle?: string;
    output?: CmsTemplatePartAddDialogOutput;
}

export interface CmsTemplatePartAddDialogOutput {
    name?: string;
    description?: string;
    label?: string;
}

export interface GetCmsTemplatePartAddDialogViewQuery {
}

export interface GetCmsSiteThemeListViewQueryResult {
    siteThemes?: GetCmsSiteThemeListViewQueryResultItem[];
}

export interface GetCmsSiteThemeListViewQueryResultItem {
    id?: string;
    name?: string;
}

export interface GetCmsSiteThemeListViewQuery {
}

export interface GetCmsSiteThemeEditItemViewQueryResult {
    cmsSiteThemeId?: string;
    cmsSiteThemeName?: string;
    output?: GetCmsSiteThemeEditItemViewQueryResultEditItem;
    navItems?: GetCmsSiteThemeEditItemViewQueryResultNavItem[];
}

export interface GetCmsSiteThemeEditItemViewQueryResultEditItem {
    name?: string;
    description?: string;
    styleSheet?: string;
    fonts?: GetCmsSiteThemeEditItemViewQueryResultFont[];
    variables?: GetCmsSiteThemeEditItemViewQueryResultVariable[];
    scriptTagSources?: GetCmsSiteThemeEditItemViewQueryResultScriptTagSource[];
}

export interface GetCmsSiteThemeEditItemViewQueryResultFont {
    url?: string;
    fontFamily?: string;
}

export interface GetCmsSiteThemeEditItemViewQueryResultVariable {
    key?: string;
    value?: string;
}

export interface GetCmsSiteThemeEditItemViewQueryResultScriptTagSource {
    name?: string;
    src?: string;
}

export interface GetCmsSiteThemeEditItemViewQueryResultNavItem {
    name?: string;
    path?: string;
}

export interface GetCmsSiteThemeEditItemViewQuery {
    siteThemeId?: string;
}

export interface UpdateCmsSiteDomainCommand {
    siteId?: string;
    domainId?: string;
    hostname?: string;
}

export interface SetCmsSiteLogoCommand {
    siteId?: string;
    fileId?: string;
}

export interface SetCmsSiteFaviconCommand {
    siteId?: string;
    fileId?: string;
}

export interface SetCmsSiteDomainPrefixCommandResponse {
    prefix?: string;
    hostnames?: string[];
}

export interface SetCmsSiteDomainPrefixCommand {
    siteId?: string;
    prefix?: string;
}

export interface SetCmsSiteDefaultLocaleCommand {
    siteId?: string;
    defaultLocale?: string;
}

export interface RemoveCmsSiteDomainCommand {
    siteId?: string;
    domainId?: string;
}

export interface GetSeoPagesForHostnameQueryResult {
    pages?: SeoPageDto[];
}

export interface SeoPageDto {
    path?: string;
    updatedOn?: DateTime;
}

export interface GetSeoPagesForHostnameQuery {
    hostname?: string;
}

export interface GetCmsSiteListPageViewQueryResult {
    sites?: CmsSiteListItem[];
}

export interface CmsSiteListItem {
    id?: string;
    name?: string;
    siteTitle?: string;
}

export interface GetCmsSiteListPageViewQuery {
}

export interface GetCmsSiteEditItemViewQueryResult {
    cmsSiteId?: string;
    isDirty?: boolean;
    input?: CmsSiteEditItem;
    output?: CmsSiteEditItem;
    rootPageLink?: CmsSitePageRef;
    contactPageLink?: CmsSitePageRef;
    siteThemes?: CmsSiteThemeSelectItem[];
    siteCheckOuts?: CmsSiteCheckOutSelectItem[];
    paymentSettings?: CmsSitePaymentSettingsSelectItem[];
    navItems?: CmsSiteNavItem[];
}

export interface CmsSiteEditItem {
    name?: string;
    siteTitle?: string;
    siteThemeId?: string;
    paymentSettingsId?: string;
    defaultBookingCheckOutId?: string;
    defaultBookingProposalCheckOutId?: string;
    rootPageId?: string;
    rootPageContentItemId?: string;
    contactPageId?: string;
    contactPageContentItemId?: string;
    description?: string;
    footerOpeningHoursDescriptionText?: string;
    isMultilingual?: boolean;
    defaultLocale?: string;
    siteLogoImageFile?: string;
    siteFaviconImageFile?: string;
    mainMenuLinks?: CmsSiteMenuLink[];
}

export interface CmsSiteMenuLink {
    orderIndex?: number;
    linkTitle?: string;
    relatedObjectId?: string;
    relatedObjectType?: string;
    relatedObjectName?: string;
    contentItemId?: string;
    pageId?: string;
    pageLabel?: string;
    pageName?: string;
}

export interface CmsSitePageRef {
    pageName?: string;
    pageId?: string;
    pageLabel?: string;
    contentItemLabel?: string;
    contentItemName?: string;
    contentItemId?: string;
    relatedObjectType?: string;
    relatedObjectId?: string;
    relatedObjectName?: string;
}

export interface CmsSiteThemeSelectItem {
    id?: string;
    name?: string;
}

export interface CmsSiteCheckOutSelectItem {
    id?: string;
    name?: string;
}

export interface CmsSitePaymentSettingsSelectItem {
    id?: string;
    name?: string;
}

export interface CmsSiteNavItem {
    name?: string;
    routeDefinition?: CmsSiteNavItemRouteDefinition;
}

export interface CmsSiteNavItemRouteDefinition {
    path?: string;
}

export interface GetCmsSiteEditItemViewQuery {
    siteId?: string;
}

export interface GetCmsSiteEditItemSelfServiceViewQueryResult {
    cmsSiteId?: string;
    isDirty?: boolean;
    input?: CmsSiteSelfServiceSettings;
    output?: CmsSiteSelfServiceSettings;
    selfServiceSettings?: CmsSiteSelfServiceSettings;
    leadTimeDurationOptions?: CmsSiteLeadTimeDurationOptions;
}

export interface CmsSiteSelfServiceSettings {
    modification?: CmsSiteModificationSelfServiceSettings;
    cancellation?: CmsSiteCancellationSelfServiceSettings;
    modifySurvey?: CmsSiteModifySurveySelfServiceSettings;
}

export interface CmsSiteModificationSelfServiceSettings {
    name?: string;
    active?: boolean;
    iconName?: string;
    iconColor?: string;
    forPublicBooking?: boolean;
    forInternalBooking?: boolean;
    maxBookingAmount?: number | undefined;
    leadTimeDuration?: Duration;
    title?: string;
    text?: string;
    paymentRequiredForPublicBooking?: boolean;
    paymentRequiredForInternalBooking?: boolean;
    paymentText?: string;
    paymentConfirmationText?: string;
    refundText?: string;
    refundConfirmationText?: string;
    noPaymentText?: string;
    noPaymentConfirmationText?: string;
}

export interface CmsSiteCancellationSelfServiceSettings {
    name?: string;
    active?: boolean;
    iconName?: string;
    iconColor?: string;
    forPublicBooking?: boolean;
    forInternalBooking?: boolean;
    maxBookingAmount?: number | undefined;
    leadTimeDuration?: Duration;
    title?: string;
    text?: string;
    confirmationTitle?: string;
    confirmationText?: string;
}

export interface CmsSiteModifySurveySelfServiceSettings {
    name?: string;
    active?: boolean;
    iconName?: string;
    iconColor?: string;
    forPublicBooking?: boolean;
    forInternalBooking?: boolean;
    maxBookingAmount?: number | undefined;
    leadTimeDuration?: Duration;
    title?: string;
    text?: string;
    confirmationTitle?: string;
    confirmationText?: string;
}

export interface CmsSiteLeadTimeDurationOptions {
    stepDuration?: Duration;
    minDuration?: Duration;
    maxDuration?: Duration;
}

export interface GetCmsSiteEditItemSelfServiceViewQuery {
    siteId?: string;
}

export interface GetCmsSiteEditItemDomainViewQueryResult {
    siteId?: string;
    systemDomainPrefix?: string;
    systemDomains?: CmsSystemSiteDomain[];
    domains?: CmsSiteDomain[];
}

export interface CmsSystemSiteDomain {
    id?: string;
    hostname?: string;
    role?: string;
}

export interface CmsSiteDomain {
    id?: string;
    hostname?: string;
    isSystem?: boolean;
}

export interface GetCmsSiteEditItemDomainViewQuery {
    siteId?: string;
}

export interface GetCmsSiteEditItemAnalyticsViewQueryResult {
    cmsSiteId?: string;
    isDirty?: boolean;
    input?: CmsSiteAnalyticsSettings;
    output?: CmsSiteAnalyticsSettings;
    analyticsSettings?: CmsSiteAnalyticsSettings;
}

export interface CmsSiteAnalyticsSettings {
    facebook?: CmsSiteFacebookAnalyticsSettings;
    google?: CmsSiteGoogleAnalyticsSettings;
    googleTagManager?: CmsSiteGoogleTagManagerSettings;
    consent?: CmsSiteConsentSettings;
    consentBannerV2?: CmsSiteConsentBannerV2Settings;
}

export interface CmsSiteFacebookAnalyticsSettings {
    name?: string;
    active?: boolean;
    logoImageUrl?: string;
    siteVerificationMetaTag?: string;
    siteVerified?: boolean;
    pixelId?: string;
    conversationToken?: string;
    facebookBusinessUrl?: string;
}

export interface CmsSiteGoogleAnalyticsSettings {
    name?: string;
    active?: boolean;
    logoImageUrl?: string;
    propertyId?: string;
    resourceId?: string;
    siteVerificationMetaTag?: string;
    siteVerified?: boolean;
    analyticsMeasurementId?: string;
    analyticsUrl?: string;
    searchUrl?: string;
}

export interface CmsSiteGoogleTagManagerSettings {
    name?: string;
    active?: boolean;
    logoImageUrl?: string;
    siteVerificationMetaTag?: string;
    siteVerified?: boolean;
    resourceId?: string;
    tagManagerId?: string;
    tagManagerAuth?: string;
    tagManagerPreview?: string;
    tagManagerResourcePath?: string;
    tagManagerUrl?: string;
    searchUrl?: string;
}

export interface CmsSiteConsentSettings {
    name?: string;
    active?: boolean;
    logoImageUrl?: string;
    position?: string;
    consentType?: string;
    content?: CmsSiteConsentContent;
    palette?: CmsSiteConsentPalette;
}

export interface CmsSiteConsentContent {
    messageText?: string;
    headerText?: string;
    linkText?: string;
    allowText?: string;
    dismissText?: string;
    denyText?: string;
    policyText?: string;
    policyLinkUrl?: string;
}

export interface CmsSiteConsentPalette {
    button?: CmsSiteConsentPaletteColor;
    highlight?: CmsSiteConsentPaletteColor;
    popup?: CmsSiteConsentPaletteColor;
}

export interface CmsSiteConsentPaletteColor {
    backgroundColor?: string;
    borderColor?: string;
    textColor?: string;
    linkColor?: string;
}

export interface CmsSiteConsentBannerV2Settings {
    name?: string;
    active?: boolean;
    logoImageUrl?: string;
    position?: string;
    modalPopUp?: CmsSiteConsentBannerV2ModalPopUp;
    preferencesPopUp?: CmsSiteConsentBannerV2PreferencesPopUp;
    stylingSettings?: CmsSiteConsentBannerV2StylingSettings;
}

export interface CmsSiteConsentBannerV2ModalPopUp {
    titleText?: string;
    descriptionText?: string;
    linkText?: string;
    acceptAllButtonText?: string;
    rejectAllButtonText?: string;
    individualButtonText?: string;
}

export interface CmsSiteConsentBannerV2PreferencesPopUp {
    titleText?: string;
    headerText?: string;
    enableNecessaryToggle?: boolean;
    necessaryTitleText?: string;
    necessaryBodyText?: string;
    enableAnalyticsToggle?: boolean;
    analyticsTitleText?: string;
    analyticsBodyText?: string;
    enablePerformanceToggle?: boolean;
    performanceTitleText?: string;
    performanceBodyText?: string;
    acceptAllButtonText?: string;
    rejectAllButtonText?: string;
    currentSelectionButtonText?: string;
}

export interface CmsSiteConsentBannerV2StylingSettings {
    formPalette?: CmsSiteConsentBannerV2FormPalette;
    primaryButtonPalette?: CmsSiteConsentBannerV2ButtonPalette;
    secondaryButtonPalette?: CmsSiteConsentBannerV2ButtonPalette;
}

export interface CmsSiteConsentBannerV2FormPalette {
    backgroundColor?: string;
    titlesTextColor?: string;
    bodyTextColor?: string;
}

export interface CmsSiteConsentBannerV2ButtonPalette {
    backgroundColor?: string;
    backgroundHoverColor?: string;
    textColor?: string;
    hoverColor?: string;
}

export interface GetCmsSiteEditItemAnalyticsViewQuery {
    siteId?: string;
}

export interface GetCmsSiteDomainPrefixAvailabilityQueryResult {
    isAvailable?: boolean;
    prefix?: string;
    hostnames?: string[];
    unavailableReasonCode?: string | undefined;
    suggestions?: string[];
}

export interface GetCmsSiteDomainPrefixAvailabilityQuery {
    siteId?: string;
    prefix?: string;
}

export interface ClearCmsSiteLogoCommand {
    siteId?: string;
}

export interface ClearCmsSiteFaviconCommand {
    siteId?: string;
}

export interface AddCmsSiteDomainCommandResponse {
    domainId?: string;
}

export interface AddCmsSiteDomainCommand {
    siteId?: string;
    hostname?: string;
}

export interface GetCmsSiteCheckOutListPageViewQueryResult {
    siteCheckOuts?: CmsSiteCheckOutListItem[];
}

export interface CmsSiteCheckOutListItem {
    id?: string;
    name?: string;
}

export interface GetCmsSiteCheckOutListPageViewQuery {
}

export interface GetCmsSiteCheckOutEditItemViewQueryResult {
    cmsSiteCheckOutId?: string;
    cmsSiteCheckOutName?: string;
    isDirty?: boolean;
    input?: CmsSiteCheckOutEditItem;
    output?: CmsSiteCheckOutEditItem;
    timeSlotLeadTimeDurationOptions?: DurationOptions;
    navItems?: CmsSiteCheckOutNavItem[];
}

export interface CmsSiteCheckOutEditItem {
    name?: string;
    description?: string;
    stepWhen?: CmsSiteCheckOutStepWhen;
    stepProgram?: CmsSiteCheckOutStepProgram;
    stepCustomer?: CmsSiteCheckOutStepCustomer;
    stepSurvey?: CmsSiteCheckOutStepSurvey;
    stepConfirm?: CmsSiteCheckOutStepConfirm;
    stepPayment?: CmsSiteCheckOutStepPayment;
    stepPaymentResult?: CmsSiteCheckOutStepPaymentResult;
    stepPaymentSuccess?: CmsSiteCheckOutStepPaymentSuccess;
    stepPaymentFailed?: CmsSiteCheckOutStepPaymentFailed;
}

export interface CmsSiteCheckOutStepWhen {
    name?: string;
    titleText?: string;
    subTitleText?: string;
    descriptionText?: string;
    noAvailableTimeSlotsSubTitleText?: string;
    noAvailableTimeSlotsDescriptionText?: string;
    minOnlineScore?: number;
    showTimeSlotPrice?: boolean;
    showNoAvailableTimeSlots?: boolean;
    timeSlotLeadTimeDuration?: Duration;
}

export interface CmsSiteCheckOutStepProgram {
    name?: string;
    titleText?: string;
    subTitleText?: string;
    descriptionText?: string;
    programAttentionText?: string;
    programAlternateAttentionText?: string;
}

export interface CmsSiteCheckOutStepCustomer {
    name?: string;
    titleText?: string;
    subTitleText?: string;
    descriptionText?: string;
}

export interface CmsSiteCheckOutStepSurvey {
    name?: string;
    titleText?: string;
    subTitleText?: string;
    descriptionText?: string;
}

export interface CmsSiteCheckOutStepConfirm {
    name?: string;
    titleText?: string;
    subTitleText?: string;
    descriptionText?: string;
}

export interface CmsSiteCheckOutStepPayment {
    name?: string;
    titleText?: string;
    subTitleText?: string;
    descriptionText?: string;
}

export interface CmsSiteCheckOutStepPaymentResult {
    name?: string;
    titleText?: string;
    subTitleText?: string;
    descriptionText?: string;
}

export interface CmsSiteCheckOutStepPaymentSuccess {
    name?: string;
    titleText?: string;
    subTitleText?: string;
    descriptionText?: string;
    showWhatsappShareButton?: boolean;
    whatsappShareMessageTemplate?: string;
}

export interface CmsSiteCheckOutStepPaymentFailed {
    name?: string;
    titleText?: string;
    subTitleText?: string;
    descriptionText?: string;
}

export interface CmsSiteCheckOutNavItem {
    name?: string;
    routeDefinition?: CmsSiteCheckOutNavItemRouteDefinition;
}

export interface CmsSiteCheckOutNavItemRouteDefinition {
    path?: string;
}

export interface GetCmsSiteCheckOutEditItemViewQuery {
    cmsSiteCheckOutId?: string;
}

export interface GetContentTypePartAddDialogViewQueryResult {
    dialogTitle?: string;
    output?: ContentTypePart;
    contentParts?: ContentTypePart[];
}

export interface ContentTypePart {
    id?: string;
    orderIndex?: number;
    contentPartId?: string;
    partName?: string;
}

export interface GetContentTypePartAddDialogViewQuery {
    contentTypeId?: string;
}

export interface GetContentTypeListPageViewQueryResult {
    contentTypes?: CmsContentTypeListItem[];
}

export interface CmsContentTypeListItem {
    id?: string;
    name?: string;
    label?: string;
    relatedObjectType?: string;
}

export interface GetContentTypeListPageViewQuery {
}

export interface GetContentTypeEditItemViewQueryResult {
    cmsContentTypeId?: string;
    cmsContentTypeName?: string;
    relatedObjectType?: string;
    isDirty?: boolean;
    input?: CmsContentTypeEditItem;
    output?: CmsContentTypeEditItem;
    navItems?: CmsContentTypeEditItemNavItem[];
}

export interface CmsContentTypeEditItem {
    name?: string;
    description?: string;
    label?: string;
    contentTypeParts?: ContentTypePart[];
}

export interface CmsContentTypeEditItemNavItem {
    name?: string;
    routeDefinition?: CmsContentTypeEditItemNavItemRouteDefinition;
}

export interface CmsContentTypeEditItemNavItemRouteDefinition {
    path?: string;
}

export interface GetContentTypeEditItemViewQuery {
    contentTypeId?: string;
}

export interface GetCmsContentPartListViewQueryResult {
    contentParts?: CmsContentPartListItem[];
}

export interface CmsContentPartListItem {
    id?: string;
    name?: string;
    label?: string;
}

export interface GetCmsContentPartListViewQuery {
}

export interface GetCmsContentPartFieldAddDialogViewQueryResult {
    dialogTitle?: string;
    output?: CmsContentPartFieldDialogItem;
    contentParts?: CmsContentPartFieldDialogItem[];
}

export interface CmsContentPartFieldDialogItem {
    name?: string;
    fieldId?: string;
    contentPartId?: string;
    contentPartLabel?: string;
    multiple?: boolean;
    maxItems?: number;
    linkToPage?: boolean;
}

export interface GetCmsContentPartFieldAddDialogViewQuery {
}

export interface GetCmsContentPartEditItemViewQueryResult {
    cmsContentPartId?: string;
    cmsContentPartName?: string;
    isDirty?: boolean;
    input?: CmsContentPartEditItem;
    output?: CmsContentPartEditItem;
    navItems?: CmsContentPartEditItemNavItem[];
}

export interface CmsContentPartEditItem {
    name?: string;
    label?: string;
    description?: string;
    fields?: CmsContentPartEditItemField[];
}

export interface CmsContentPartEditItemField {
    fieldId?: string;
    label?: string;
    name?: string;
    description?: string;
    value?: string;
    fieldType?: string;
    fieldTypeSettingsJson?: string;
}

export interface CmsContentPartEditItemNavItem {
    name?: string;
    routeDefinition?: CmsContentPartEditItemNavItemRouteDefinition;
}

export interface CmsContentPartEditItemNavItemRouteDefinition {
    path?: string;
}

export interface GetCmsContentPartEditItemViewQuery {
    contentPartId?: string;
}

export interface CmsContentItemVersionEditItemViewResult {
    cmsContentItemVersionId?: string;
    isDirty?: boolean;
    input?: CmsContentItemVersionEditItemViewResultEditItem;
    output?: CmsContentItemVersionEditItemViewResultEditItem;
}

export interface CmsContentItemVersionEditItemViewResultEditItem {
    fieldValues?: CmsContentItemVersionEditItemViewResultFieldValue[];
    pages?: CmsContentItemVersionEditItemViewResultPage[];
}

export interface CmsContentItemVersionEditItemViewResultFieldValue {
    fieldId?: string;
    fieldLabel?: string;
    fieldType?: string;
    partId?: string;
    partLabel?: string;
    value?: string;
}

export interface CmsContentItemVersionEditItemViewResultPage {
    pageId?: string;
    pageName?: string;
    pageLabel?: string;
    metaPageTitle?: string;
    metaPageDescription?: string;
    doNotIndex?: boolean;
    fieldValues?: CmsContentItemVersionEditItemViewResultFieldValue[];
}

export interface GetCmsContentItemVersionEditItemViewQuery {
    contentItemVersionId?: string;
}

export interface GetCmsContentItemLinkPickerViewQueryResult {
    multiple?: boolean;
    maxItems?: number;
    linkToPage?: boolean;
    availableItems?: ContentItemKanbanItem[];
    selectedItems?: ContentItemKanbanItem[];
}

export interface ContentItemKanbanItem {
    contentItemId?: string;
    relatedObjectName?: string;
    relatedObjectId?: string;
    relatedObjectType?: string;
    pageId?: string | undefined;
    pageLabel?: string | undefined;
    pageName?: string | undefined;
    pages?: ContentItemLinkPage[];
}

export interface ContentItemLinkPage {
    pageId?: string;
    pageLabel?: string;
    pageName?: string;
}

export interface GetCmsContentItemLinkPickerViewQuery {
    contentPartId?: string;
    multiple?: boolean;
    maxItems?: number;
    linkToPage?: boolean;
    cmsContentItemLinks?: CmsContentItemLinkInput[];
}

export interface CmsContentItemLinkInput {
    contentItemId?: string;
    relatedObjectId?: string;
    relatedObjectType?: string;
    relatedObjectName?: string;
    pageId?: string | undefined;
    pageLabel?: string | undefined;
    pageName?: string | undefined;
}

export interface CmsContentItemEditItemViewResult {
    relatedObjectId?: string;
    relatedObjectType?: string;
    cmsContentItemId?: string | undefined;
    cmsSiteCss?: string | undefined;
    contentType?: CmsContentItemEditItemViewResultContentType | undefined;
    pageTemplates?: CmsContentItemEditItemViewResultPageTemplate[];
    pages?: CmsContentItemEditItemViewResultPageReference[];
    input?: CmsContentItemEditItemViewResultEditItem | undefined;
    output?: CmsContentItemEditItemViewResultEditItem | undefined;
    versionViewData?: CmsContentItemVersionEditItemViewResult | undefined;
}

export interface CmsContentItemEditItemViewResultContentType {
    id?: string;
    name?: string;
    label?: string;
    contentTypeParts?: CmsContentItemEditItemViewResultContentTypePart[];
}

export interface CmsContentItemEditItemViewResultContentTypePart {
    partId?: string;
    orderIndex?: number;
    partName?: string;
    label?: string;
    fields?: CmsContentItemEditItemViewResultField[];
}

export interface CmsContentItemEditItemViewResultField {
    fieldId?: string;
    label?: string;
    name?: string;
    description?: string;
    value?: string | undefined;
    fieldType?: string;
    fieldTypeSettingsJson?: string;
}

export interface CmsContentItemEditItemViewResultPageTemplate {
    id?: string;
    name?: string;
    label?: string;
    templateParts?: CmsContentItemEditItemViewResultTemplatePart[];
}

export interface CmsContentItemEditItemViewResultTemplatePart {
    trackingId?: string;
    offset?: number;
    partId?: string;
    orderIndex?: number;
    partName?: string;
    label?: string;
    fields?: CmsContentItemEditItemViewResultField[];
    contentFields?: any[];
}

export interface CmsContentItemEditItemViewResultPageReference {
    pageId?: string;
    pageName?: string;
    pageLabel?: string;
}

export interface CmsContentItemEditItemViewResultEditItem {
    label?: string | undefined;
}

export interface GetCmsContentItemEditItemViewQuery {
    relatedObjectType?: string;
    relatedObjectId?: string;
}

export interface GetCmsContentItemAddDialogViewQueryResult {
    relatedObjectName?: string;
    relatedObjectId?: string;
    relatedObjectType?: string;
    contentTypes?: GetCmsContentItemAddDialogViewContentType[];
}

export interface GetCmsContentItemAddDialogViewContentType {
    id?: string;
    name?: string;
    relatedObjectType?: string;
}

export interface GetCmsContentItemAddDialogViewQuery {
    relatedObjectType?: string;
    relatedObjectId?: string;
}

export interface TakePublicWebsiteOfflineCommand {
    websiteId?: string;
}

export interface SetWebsiteNameCommand {
    websiteId?: string;
    websiteName?: string;
}

export interface MakeOfflineWebsiteAvailableToPublicCommand {
    websiteId?: string;
}

export interface GetWebsitesQueryResult {
    websites?: GetWebsitesQueryResultWebsiteDto[];
}

export interface GetWebsitesQueryResultWebsiteDto {
    websiteId?: string;
    websiteName?: string;
    availabilityStatus?: WebsiteAvailabilityStatusDto;
}

export enum WebsiteAvailabilityStatusDto {
    Offline = "Offline",
    Private = "Private",
    Public = "Public",
}

export interface GetWebsitesQuery {
}

export interface CreateWebsiteCommandResponse {
    websiteId?: string;
}

export interface CreateWebsiteCommand {
    websiteName?: string;
}

export interface SetWebsiteDomainLocaleAsPrimaryCommand {
    websiteId?: string;
    websiteDomainId?: string;
    secondaryLocaleId?: string;
}

export interface RemoveWebsiteDomainSecondaryLocaleCommand {
    websiteId?: string;
    websiteDomainId?: string;
    secondaryLocaleId?: string;
}

export interface GetWebsitesWithDomainsLocalesQueryResult {
    websites?: GetWebsitesWithDomainsLocalesQueryResultWebsite[];
}

export interface GetWebsitesWithDomainsLocalesQueryResultWebsite {
    websiteId?: string;
    websiteName?: string;
    domains?: GetWebsitesWithDomainsLocalesQueryResultWebsiteDomain[];
}

export interface GetWebsitesWithDomainsLocalesQueryResultWebsiteDomain {
    websiteDomainId?: string;
    hostname?: string;
    locales?: GetWebsitesWithDomainsLocalesQueryResultWebsiteDomainLocale[];
}

export interface GetWebsitesWithDomainsLocalesQueryResultWebsiteDomainLocale {
    localeId?: string;
    isPrimary?: boolean;
}

export interface GetWebsitesWithDomainsLocalesQuery {
}

export interface AddWebsiteDomainSecondaryLocaleCommand {
    websiteId?: string;
    websiteDomainId?: string;
    secondaryLocaleId?: string;
}

export interface RemoveWebsiteDomainCommand {
    websiteId?: string;
    websiteDomainId?: string;
}

export interface GetWebsitesWithDomainsQueryResult {
    websites?: GetWebsitesWithDomainsQueryResultWebsite[];
}

export interface GetWebsitesWithDomainsQueryResultWebsite {
    websiteId?: string;
    websiteName?: string;
    domains?: GetWebsitesWithDomainsQueryResultWebsiteDomain[];
}

export interface GetWebsitesWithDomainsQueryResultWebsiteDomain {
    websiteDomainId?: string;
    hostname?: string;
}

export interface GetWebsitesWithDomainsQuery {
}

export interface AddWebsiteDomainCommand {
    websiteId?: string;
    hostname?: string;
}

export interface GetWebsiteThemeStylesheetForWebsitePagePreviewQueryResult {
    websiteThemeStylesheet?: string;
}

export interface GetWebsiteThemeStylesheetForWebsitePagePreviewQuery {
    websiteId?: string;
    websiteThemeId?: string;
}

export interface GetWebsiteThemeStylesheetForComponentPreviewQueryResult {
    websiteThemeStylesheet?: string;
}

export interface GetWebsiteThemeStylesheetForComponentPreviewQuery {
    websiteId?: string;
    websiteThemeId?: string;
}

export interface GetPageContentHtmlForWebsitePagePreviewQueryResult {
    headerHtmlNode?: string;
    mainHtmlNode?: string;
    footerHtmlNode?: string;
}

export interface GetPageContentHtmlForWebsitePagePreviewQuery {
    websiteId?: string;
    websiteThemeId?: string;
    pageContent?: PageContentDto;
}

export interface PageContentDto {
    headerArea?: PageContentAreaDto;
    mainArea?: PageContentAreaDto;
    footerArea?: PageContentAreaDto;
}

export interface PageContentAreaDto {
    sections?: PageContentSectionDto[];
}

export interface PageContentSectionDto {
    rows?: PageContentRowDto[];
}

export interface PageContentRowDto {
    columns?: PageContentColumnDto[];
}

export interface PageContentColumnDto {
    gridSpan?: number;
    cells?: PageContentCellDto[];
}

export interface PageContentCellDto {
    componentContent?: PageContentComponentContentDto;
}

export interface PageContentComponentContentDto {
    isStandardComponent?: boolean;
    componentId?: string;
    fieldValues?: FieldValueDto[];
    listFieldGroupValues?: ListFieldGroupValueDto[];
    relatedObjectFieldGroupValues?: RelatedObjectFieldGroupValueDto[];
}

export interface FieldValueDto {
    fieldKey?: string;
    fieldTypeKey?: string;
    fieldTypeValueJsonData?: string;
}

export interface ListFieldGroupValueDto {
    listFieldGroupKey?: string;
    items?: ListFieldGroupItemValueDto[];
}

export interface ListFieldGroupItemValueDto {
    itemLabel?: string;
    fieldValues?: FieldValueDto[];
}

export interface RelatedObjectFieldGroupValueDto {
    relatedObjectFieldGroupKey?: string;
    relatedObjectLinks?: RelatedObjectFieldLinkValueDto[];
}

export interface RelatedObjectFieldLinkValueDto {
    relatedObjectType?: string;
    relatedObjectId?: string;
    linkFieldValue?: LinkFieldValueDto;
}

export interface LinkFieldValueDto {
    linkRelationType?: LinkFieldRelationTypeDto;
    websitePageLink?: LinkFieldValueWebsitePageLinkDto | undefined;
    externalLink?: LinkFieldValueExternalLinkDto | undefined;
    fieldTypeKey?: string;
}

export enum LinkFieldRelationTypeDto {
    None = "None",
    WebsitePage = "WebsitePage",
    External = "External",
}

export interface LinkFieldValueWebsitePageLinkDto {
    websitePageId?: string;
    openInTab?: boolean;
}

export interface LinkFieldValueExternalLinkDto {
    href?: string;
    openInTab?: boolean;
}

export interface GetPageContentCellHtmlForWebsitePagePreviewQueryResult {
    cellHtmlNode?: string;
}

export interface GetPageContentCellHtmlForWebsitePagePreviewQuery {
    websiteId?: string;
    websiteThemeId?: string;
    cell?: PageContentCellDto;
    cellPosition?: PageContentCellPositionDto;
}

export interface PageContentCellPositionDto {
    area?: PageContentAreaTypeDto;
    sectionIndex?: number;
    rowIndex?: number;
    columnIndex?: number;
    cellIndex?: number;
}

export enum PageContentAreaTypeDto {
    Header = "Header",
    Main = "Main",
    Footer = "Footer",
}

export interface GetPageContentCellHtmlForComponentPreviewQueryResult {
    cellHtmlNode?: string;
}

export interface GetPageContentCellHtmlForComponentPreviewQuery {
    websiteId?: string;
    websiteThemeId?: string;
    pageContentComponentId?: string;
    htmlTemplate?: string;
    cell?: PageContentCellDto;
    cellPosition?: PageContentCellPositionDto;
}

export interface GetComponentStylesheetForComponentPreviewQueryResult {
    componentStylesheet?: string;
}

export interface GetComponentStylesheetForComponentPreviewQuery {
    websiteId?: string;
    websiteThemeId?: string;
    pageContentComponentId?: string;
    stylesheetTemplate?: string;
}

export interface GetFieldTypeDtosQueryResult {
    simpleTextfieldValue?: SimpleTextFieldValueDto;
    simpleTextFieldConfig?: SimpleTextFieldConfigDto;
    selectFieldConfig?: SelectFieldConfigDto;
    selectFieldValue?: SelectFieldValueDto;
    booleanFieldValue?: BooleanFieldValueDto;
    booleanFieldConfig?: BooleanFieldConfigDto;
    linkFieldValue?: LinkFieldValueDto;
    linkFieldConfig?: LinkFieldConfigDto;
}

export interface SimpleTextFieldValueDto {
    value?: string | undefined;
    fieldTypeKey?: string;
}

export interface SimpleTextFieldConfigDto {
    fieldTypeKey?: string;
}

export interface SelectFieldConfigDto {
    options?: SelectFieldConfigOptionDto[];
    allowNullValue?: boolean;
    fieldTypeKey?: string;
}

export interface SelectFieldConfigOptionDto {
    text?: string;
    value?: string;
}

export interface SelectFieldValueDto {
    value?: string | undefined;
    fieldTypeKey?: string;
}

export interface BooleanFieldValueDto {
    isTrue?: boolean;
    fieldTypeKey?: string;
}

export interface BooleanFieldConfigDto {
    fieldTypeKey?: string;
}

export interface LinkFieldConfigDto {
    supportedRelationTypes?: LinkFieldRelationTypeDto[];
    fieldTypeKey?: string;
}

export interface GetFieldTypeDtosQuery {
}

export interface SetWebsiteThemeStylesheetTemplateCommand {
    websiteThemeId?: string;
    stylesheetTemplate?: string;
}

export interface SetWebsiteThemeNameCommand {
    websiteThemeId?: string;
    websiteThemeName?: string;
}

export interface GetWebsiteThemeQueryResult {
    websiteThemeName?: string;
    fieldCollection?: WebsiteThemeFieldCollectionDto;
    fieldValueCollection?: WebsiteThemeFieldValueCollectionDto;
    stylesheetTemplate?: string;
}

export interface WebsiteThemeFieldCollectionDto {
    fieldGroups?: FieldGroupDto[] | undefined;
    styleFieldGroups?: StyleFieldGroupDto[] | undefined;
    listFieldGroups?: ListFieldGroupDto[] | undefined;
}

export interface FieldGroupDto {
    fieldGroupName?: string;
    fields?: FieldDto[];
}

export interface FieldDto {
    fieldKey?: string;
    isRequired?: boolean;
    fieldName?: string;
    fieldTypeKey?: string;
    fieldTypeConfigJsonData?: string;
    fieldTypeDefaultValueJsonData?: string;
}

export interface StyleFieldGroupDto {
    styleFieldGroupName?: string;
    fields?: FieldDto[];
}

export interface ListFieldGroupDto {
    listFieldGroupKey?: string;
    listFieldGroupName?: string;
    fields?: FieldDto[];
    defaultItems?: ListFieldGroupItemValueDto[];
}

export interface WebsiteThemeFieldValueCollectionDto {
    fieldValues?: FieldValueDto[];
    listFieldGroupValues?: ListFieldGroupValueDto[];
}

export interface GetWebsiteThemeQuery {
    websiteThemeId?: string;
}

export interface GetWebsitesWithThemesQueryResult {
    websites?: GetWebsitesWithThemesQueryResultWebsite[];
}

export interface GetWebsitesWithThemesQueryResultWebsite {
    websiteId?: string;
    websiteName?: string;
    websiteThemes?: GetWebsitesWithThemesQueryResultWebsiteTheme[];
}

export interface GetWebsitesWithThemesQueryResultWebsiteTheme {
    websiteThemeId?: string;
    websiteThemeName?: string;
}

export interface GetWebsitesWithThemesQuery {
}

export interface CreateWebsiteThemeCommandResponse {
    websiteThemeId?: string;
}

export interface CreateWebsiteThemeCommand {
    websiteId?: string;
}

export interface UpdatePublishedPageTemplateContentCommand {
    pageTemplateId?: string;
    pageTemplateContentVersionId?: string;
}

export interface SetPageTemplatePrimaryLanguageCommand {
    pageTemplateLanguageGroupId?: string;
    pageTemplateId?: string;
}

export interface SetPageTemplateNameCommand {
    pageTemplateId?: string;
    pageTemplateName?: string;
}

export interface RetractPublishedPageTemplateCommand {
    pageTemplateId?: string;
}

export interface RemovePageTemplateSecondaryLanguageCommand {
    pageTemplateLanguageGroupId?: string;
    pageTemplateId?: string;
}

export interface PublishDraftPageTemplateCommand {
    pageTemplateId?: string;
    pageTemplateContentVersionId?: string;
}

export interface GetPageTemplatesQueryResult {
    pageTemplates?: GetPageTemplatesQueryResultPageTemplate[];
}

export interface GetPageTemplatesQueryResultPageTemplate {
    pageTemplateLanguageGroupId?: string;
    websiteId?: string;
    websiteName?: string;
    websiteThemeId?: string;
    websiteThemeName?: string;
    primaryLanguagePageTemplate?: GetPageTemplatesQueryResultPageTemplateForLanguage;
    secondaryLanguagesPageTemplates?: GetPageTemplatesQueryResultPageTemplateForLanguage[];
}

export interface GetPageTemplatesQueryResultPageTemplateForLanguage {
    pageTemplateId?: string;
    localeId?: string;
    pageTemplateName?: string;
    pageTemplateNameIsEmpty?: boolean;
    publishStatus?: PageTemplatePublishStatusDto;
}

export enum PageTemplatePublishStatusDto {
    Draft = "Draft",
    Published = "Published",
}

export interface GetPageTemplatesQuery {
}

export interface GetPageTemplatesForNewWebsitePageQueryResult {
    pageTemplates?: GetPageTemplatesForNewWebsitePageQueryResultPageTemplate[];
}

export interface GetPageTemplatesForNewWebsitePageQueryResultPageTemplate {
    pageTemplateId?: string;
    pageTemplateName?: string;
    websiteThemeId?: string;
    websiteThemeName?: string;
}

export interface GetPageTemplatesForNewWebsitePageQuery {
    websiteId?: string;
}

export interface GetPageTemplateNameQueryResult {
    pageTemplateName?: string;
}

export interface GetPageTemplateNameQuery {
    pageTemplateId?: string;
}

export interface GetPageTemplateLocalesNotInUseQueryResult {
    localeIds?: string[];
}

export interface GetPageTemplateLocalesNotInUseQuery {
    pageTemplateLanguageGroupId?: string;
}

export interface PageTemplateEditorView {
    pageTemplateName?: string;
    publishStatus?: PageTemplatePublishStatusDto;
    websiteId?: string;
    websiteName?: string;
    websiteThemeId?: string;
    websiteThemeName?: string;
}

export interface GetPageTemplateEditorViewQuery {
    pageTemplateId?: string;
}

export interface GetPageTemplateContentVersionHistoryQueryResult {
    contentVersions?: GetPageTemplateContentVersionHistoryQueryResultContentVersion[];
}

export interface GetPageTemplateContentVersionHistoryQueryResultContentVersion {
    pageTemplateContentVersionId?: string;
    isPublishedVersion?: boolean;
    createdOnDateTime?: DateTime;
}

export interface GetPageTemplateContentVersionHistoryQuery {
    pageTemplateId?: string;
}

export interface GetLatestPageTemplateContentVersionQueryResult {
    pageTemplateContentVersionId?: string;
    isPublished?: boolean;
    createdOnDateTime?: DateTime;
    pageContent?: PageContentDto;
}

export interface GetLatestPageTemplateContentVersionQuery {
    pageTemplateId?: string;
}

export interface CreatePageTemplateCommandResponse {
    pageTemplateLanguageGroupId?: string;
    pageTemplateId?: string;
}

export interface CreatePageTemplateCommand {
    websiteThemeId?: string;
}

export interface CreatePageTemplateContentVersionCommandResponse {
    pageTemplateContentVersionId?: string;
}

export interface CreatePageTemplateContentVersionCommand {
    pageTemplateId?: string;
    pageContent?: PageContentDto;
}

export interface AddPageTemplateSecondaryLanguageCommandResponse {
    pageTemplateId?: string;
}

export interface AddPageTemplateSecondaryLanguageCommand {
    pageTemplateLanguageGroupId?: string;
    localeId?: string;
}

export interface UpdatePublishedPageContentComponentSourceCodeCommand {
    pageContentComponentId?: string;
    pageContentComponentSourceCodeVersionId?: string;
}

export interface SetPageContentComponentNameCommand {
    pageContentComponentId?: string;
    pageContentComponentName?: string;
}

export interface PublishDraftPageContentComponentCommand {
    pageContentComponentId?: string;
    pageContentComponentSourceCodeVersionId?: string;
}

export interface GetStandardPageContentComponentsForPageContentQueryResult {
    standardPageContentComponents?: GetStandardPageContentComponentsForPageContentQueryStandardPageComponent[];
}

export interface GetStandardPageContentComponentsForPageContentQueryStandardPageComponent {
    standardPageContentComponentId?: string;
    pageContentFieldCollection?: PageContentFieldCollectionDto;
    defaultPageContentFieldValueCollection?: PageContentFieldValueCollectionDto;
}

export interface PageContentFieldCollectionDto {
    fieldGroups?: FieldGroupDto[];
    styleFieldGroups?: StyleFieldGroupDto[];
    listFieldGroups?: ListFieldGroupDto[];
    relatedObjectFieldGroups?: RelatedObjectFieldGroupDto[];
}

export interface RelatedObjectFieldGroupDto {
    relatedObjectFieldGroupKey?: string;
    relatedObjectFieldGroupName?: string;
    relatedObjectFieldLinkConfig?: RelatedObjectFieldLinkConfigDto;
    fields?: FieldDto[];
}

export interface RelatedObjectFieldLinkConfigDto {
    relatedObjectTypes?: string[];
    supportedLinkTypes?: LinkFieldRelationTypeDto[];
}

export interface PageContentFieldValueCollectionDto {
    fieldValues?: FieldValueDto[];
    listFieldGroupValues?: ListFieldGroupValueDto[];
    relatedObjectFieldGroupValues?: RelatedObjectFieldGroupValueDto[];
}

export interface GetStandardPageContentComponentsForPageContentQuery {
}

export interface GetPageContentComponentsQueryResult {
    pageContentComponents?: GetPageContentComponentsQueryResultPageContentComponent[];
}

export interface GetPageContentComponentsQueryResultPageContentComponent {
    pageContentComponentId?: string;
    pageContentComponentName?: string;
    pageContentComponentNameIsEmpty?: boolean;
    publishStatus?: PageContentComponentPublishStatusDto;
    websiteId?: string;
    websiteName?: string;
    websiteThemeId?: string;
    websiteThemeName?: string;
}

export enum PageContentComponentPublishStatusDto {
    Draft = "Draft",
    Published = "Published",
}

export interface GetPageContentComponentsQuery {
}

export interface GetPageContentComponentsForPageContentQueryResult {
    pageContentComponents?: GetPageContentComponentsForPageContentQueryPageComponent[];
}

export interface GetPageContentComponentsForPageContentQueryPageComponent {
    pageContentComponentId?: string;
    pageContentComponentName?: string;
    pageContentFieldCollection?: PageContentFieldCollectionDto;
    defaultPageContentFieldValueCollection?: PageContentFieldValueCollectionDto;
}

export interface GetPageContentComponentsForPageContentQuery {
    websiteThemeId?: string;
}

export interface PageContentComponentEditorView {
    pageContentComponentName?: string;
    publishStatus?: PageContentComponentPublishStatusDto;
    websiteId?: string;
    websiteName?: string;
    websiteThemeId?: string;
    websiteThemeName?: string;
}

export interface GetPageContentComponentEditorViewQuery {
    pageContentComponentId?: string;
}

export interface GetLatestPageContentComponentSourceCodeVersionQueryResult {
    pageContentComponentSourceCodeVersionId?: string;
    isPublished?: boolean;
    createdOnDateTime?: DateTime;
    sourceCode?: PageContentComponentSourceCodeDto;
}

export interface PageContentComponentSourceCodeDto {
    htmlTemplate?: string;
    stylesheetTemplate?: string;
    javaScript?: string;
    fieldCollection?: PageContentFieldCollectionDto;
}

export interface GetLatestPageContentComponentSourceCodeVersionQuery {
    pageContentComponentId?: string;
}

export interface CreatePageContentComponentCommandResponse {
    pageContentComponentId?: string;
}

export interface CreatePageContentComponentCommand {
    websiteThemeId?: string;
}

export interface CreatePageContentComponentSourceCodeVersionCommandResponse {
    pageContentComponentSourceCodeVersionId?: string;
}

export interface CreatePageContentComponentSourceCodeVersionCommand {
    pageContentComponentId?: string;
    sourceCode?: PageContentComponentSourceCodeDto;
}

export interface SetWebsitePageTitleCommand {
    websitePageId?: string;
    websitePageTitle?: string;
}

export interface SetWebsitePageContentSlugCommand {
    websitePageId?: string;
    websiteContentSlug?: string;
}

export interface RetractPublishedWebsitePageCommand {
    websitePageId?: string;
}

export interface PublishDraftWebsitePageCommand {
    websitePageId?: string;
    websitePageContentVersionId?: string;
}

export interface IsWebsitePageContentSlugUniqueQueryResult {
    contentSlugIsUnique?: boolean;
}

export interface IsWebsitePageContentSlugUniqueQuery {
    websiteId?: string;
    websiteContentSlug?: string;
}

export interface GetWebsitePageQueryResult {
    websiteId?: string;
    websiteName?: string;
    websitePageTitle?: string;
    websiteContentSlug?: string;
    publishStatus?: WebsitePagePublishStatusDto;
}

export enum WebsitePagePublishStatusDto {
    Draft = "Draft",
    Published = "Published",
}

export interface GetWebsitePageQuery {
    websitePageId?: string;
}

export interface GetWebsitePagesQueryResult {
    websitePages?: GetWebsitePagesQueryResultWebsitePage[];
}

export interface GetWebsitePagesQueryResultWebsitePage {
    websitePageLanguageGroupId?: string;
    websiteId?: string;
    websiteName?: string;
    primaryLanguageWebsitePage?: GetWebsitePagesQueryResultWebsitePageForLanguage;
    secondaryLanguagesWebsitePages?: GetWebsitePagesQueryResultWebsitePageForLanguage[];
}

export interface GetWebsitePagesQueryResultWebsitePageForLanguage {
    websitePageId?: string;
    localeId?: string;
    websitePageTitle?: string;
    websiteContentSlug?: string;
    publishStatus?: WebsitePagePublishStatusDto;
}

export interface GetWebsitePagesQuery {
}

export interface WebsitePageEditorView {
    websitePageTitle?: string;
    websiteContentSlug?: string;
    publishStatus?: WebsitePagePublishStatusDto;
}

export interface GetWebsitePageEditorViewQuery {
    websitePageId?: string;
}

export interface GetWebsitePageContentVersionHistoryQueryResult {
    contentVersions?: GetWebsitePageContentVersionHistoryQueryResultContentVersion[];
}

export interface GetWebsitePageContentVersionHistoryQueryResultContentVersion {
    websitePageContentVersionId?: string;
    isPublishedVersion?: boolean;
    createdOnDateTime?: DateTime;
}

export interface GetWebsitePageContentVersionHistoryQuery {
    websitePageId?: string;
}

export interface GetLatestWebsitePageContentVersionQueryResult {
    websitePageContentVersionId?: string;
    isPublished?: boolean;
    createdOnDateTime?: DateTime;
    pageContent?: PageContentDto;
}

export interface GetLatestWebsitePageContentVersionQuery {
    websitePageId?: string;
}

export interface CreateWebsitePageCommandResponse {
    websitePageLanguageGroupId?: string;
    websitePageId?: string;
}

export interface CreateWebsitePageCommand {
    pageTemplateId?: string;
}

export interface CreateWebsitePageContentVersionCommandResponse {
    websitePageContentVersionId?: string;
}

export interface CreateWebsitePageContentVersionCommand {
    websitePageId?: string;
    pageContent?: PageContentDto;
}

export interface SetProgramVariantStepWeekConfigCommand {
    programId?: string;
    offeringVariantId?: string;
    programStepId?: string;
    weekConfig?: SetProgramVariantStepWeekConfigCommandConfig;
}

export interface SetProgramVariantStepWeekConfigCommandConfig {
    mode: string;
}

export interface FixedWeekConfigRequest extends SetProgramVariantStepWeekConfigCommandConfig {
    capacity?: SetProgramVariantStepDayConfigCommandCapacityOffering;
}

export interface SetProgramVariantStepDayConfigCommandCapacityOffering {
    durations?: SetProgramVariantStepDayConfigCommandDurationOptions;
    capacityKind: string;
}

export interface SetProgramVariantStepDayConfigCommandDurationOptions {
    durations?: Duration[];
    defaultDuration?: Duration;
}

export interface NoCapacityOfferingRequest extends SetProgramVariantStepDayConfigCommandCapacityOffering {
}

export interface PerPersonOfferingRequest extends SetProgramVariantStepDayConfigCommandCapacityOffering {
}

export interface PerTableOfferingRequest extends SetProgramVariantStepDayConfigCommandCapacityOffering {
}

export interface PerLaneOfferingRequest extends SetProgramVariantStepDayConfigCommandCapacityOffering {
    laneCountIsCustomerSelectable?: boolean;
}

export interface DynamicWeekConfigRequest extends SetProgramVariantStepWeekConfigCommandConfig {
    intervalDuration?: Duration;
    minDuration?: Duration;
    maxDuration?: Duration;
}

export interface SetProgramVariantStepDayConfigCommand {
    programId?: string;
    offeringVariantId?: string;
    programStepId?: string;
    dayConfig?: SetProgramVariantStepDayConfigCommandDayConfig;
}

export interface SetProgramVariantStepDayConfigCommandDayConfig {
    dayOfWeek?: DayOfWeek;
    mode: string;
}

export interface FixedDayConfigRequest extends SetProgramVariantStepDayConfigCommandDayConfig {
    capacity?: SetProgramVariantStepDayConfigCommandCapacityOffering;
}

export interface DynamicDayConfigRequest extends SetProgramVariantStepDayConfigCommandDayConfig {
    intervalDuration?: Duration;
    minDuration?: Duration;
    maxDuration?: Duration;
}

export interface SetProgramVariantStepDayConfigsCommand {
    programId?: string;
    offeringVariantId?: string;
    programStepId?: string;
    dayConfigs?: SetProgramVariantStepDayConfigCommandDayConfig[];
}

export interface SetProgramStepHasDynamicDurationCommand {
    programId?: string;
    programStepId?: string;
    hasDynamicDuration?: boolean;
}

export interface SetProgramStepCanChangePositionCommand {
    programId?: string;
    programStepId?: string;
    canChangePosition?: boolean;
}

export interface SetProgramPeriodOfferingVariantCommand {
    programId?: string;
    periodId?: string;
    offeringVariantId?: string;
}

export interface SetProgramOfferingVariantNameCommand {
    programId?: string;
    offeringVariantId?: string;
    name?: string;
}

export interface SetDefaultProgramOfferingVariantCommand {
    programId?: string;
    offeringVariantId?: string;
}

export interface ReorderProgramStepsCommand {
    programId?: string;
    orderedProgramStepIds?: string[];
}

export interface RemoveProgramStepCommand {
    programId?: string;
    programStepId?: string;
}

export interface RemoveProgramOfferingVariantCommand {
    programId?: string;
    offeringVariantId?: string;
}

export interface MigrateLocationProgramsToOfferingVariantsCommand {
}

export interface GetProgramByIdQueryResult {
    programId?: string;
    programSteps?: GetProgramByIdProgramStep[];
    defaultOfferingVariant?: GetProgramByIdOfferingVariant;
    offeringVariants?: GetProgramByIdOfferingVariant[];
    periodAssignments?: GetProgramByIdPeriodAssignment[];
}

export interface GetProgramByIdProgramStep {
    programStepId?: string;
    activityId?: string;
    capacityKind?: GetProgramByIdActivityCapacityKind;
    canChangePosition?: boolean;
    hasDynamicDuration?: boolean;
    durationRange?: GetProgramByIdDurationRange;
}

export enum GetProgramByIdActivityCapacityKind {
    None = "None",
    PerLane = "PerLane",
    PerTable = "PerTable",
    PerPerson = "PerPerson",
}

export interface GetProgramByIdDurationRange {
    minDuration?: Duration;
    maxDuration?: Duration;
    stepDuration?: Duration;
}

export interface GetProgramByIdOfferingVariant {
    offeringVariantId?: string;
    name?: string;
    steps?: GetProgramByIdOfferingVariantStep[];
}

export interface GetProgramByIdOfferingVariantStep {
    offeringVariantStepId?: string;
    programStepId?: string;
    dayConfigs?: GetProgramByIdDayConfig[];
    isUniformAcrossWeek?: boolean;
}

export interface GetProgramByIdDayConfig {
    dayOfWeek?: DayOfWeek;
    mode: string;
}

export interface GetProgramByIdFixedDayConfig extends GetProgramByIdDayConfig {
    capacity?: GetProgramByIdCapacityOffering;
}

export interface GetProgramByIdCapacityOffering {
    durations?: GetProgramByIdDurationOptions;
    capacityKind: string;
}

export interface GetProgramByIdDurationOptions {
    durations?: Duration[];
    defaultDuration?: Duration;
}

export interface GetProgramByIdNoCapacityOffering extends GetProgramByIdCapacityOffering {
}

export interface GetProgramByIdPerPersonOffering extends GetProgramByIdCapacityOffering {
}

export interface GetProgramByIdPerTableOffering extends GetProgramByIdCapacityOffering {
}

export interface GetProgramByIdPerLaneOffering extends GetProgramByIdCapacityOffering {
    laneCountIsCustomerSelectable?: boolean;
}

export interface GetProgramByIdDynamicDayConfig extends GetProgramByIdDayConfig {
    intervalDuration?: Duration;
    minDuration?: Duration;
    maxDuration?: Duration;
}

export interface GetProgramByIdPeriodAssignment {
    periodId?: string;
    offeringVariantId?: string | undefined;
}

export interface GetProgramByIdQuery {
    programId?: string;
}

export interface GetActiveProgramsQueryResult {
    programs?: GetActiveProgramsProgram[];
}

export interface GetActiveProgramsProgram {
    programId?: string;
    name?: string;
    programSteps?: GetActiveProgramsProgramStep[];
}

export interface GetActiveProgramsProgramStep {
    activityId?: string;
    name?: string;
}

export interface CopyProgramVariantStepDayConfigToOtherDaysCommand {
    programId?: string;
    offeringVariantId?: string;
    programStepId?: string;
    sourceDay?: DayOfWeek;
}

export interface AddProgramStepCommandResponse {
    programStepId?: string;
}

export interface AddProgramStepCommand {
    programId?: string;
    activityId?: string;
}

export interface AddProgramOfferingVariantCommandResponse {
    offeringVariantId?: string;
}

export interface AddProgramOfferingVariantCommand {
    programId?: string;
    name?: string;
}

export interface CreateArticleCommandRefusal {
    duplicateName?: string;
}

export interface CreateArticleCommandResponse {
    articleId?: string;
}

export interface CreateArticleCommand {
    name?: string;
}

export interface SetActivitySuitableAgeGroupsCommand {
    activityId?: string;
    ageGroupIds?: string[];
}

export interface SetActivityNameCommand {
    activityId?: string;
    name?: LocalizedStaticText;
}

export interface SetActivityDescriptionCommand {
    activityId?: string;
    description?: LocalizedStaticText | undefined;
}

export interface SetActivityCompatibleResourceTypesCommand {
    activityId?: string;
    resourceTypeIds?: string[];
}

export interface SetActivityCapacityBasisCommand {
    activityId?: string;
    resourceBasis?: ResourceCapacityBasisRequestDto | undefined;
    participantBasis?: ParticipantCapacityBasisRequestDto | undefined;
}

export interface ResourceCapacityBasisRequestDto {
    participantsEntry?: ParticipantsEntryDto;
}

export enum ParticipantsEntryDto {
    Optional = "Optional",
    Required = "Required",
}

export interface ParticipantCapacityBasisRequestDto {
    countDetermination?: ActivityResourceCountDeterminationRequestDto;
}

export interface ActivityResourceCountDeterminationRequestDto {
    countDetermination: string;
}

export interface DerivedResourceCountRequestDto extends ActivityResourceCountDeterminationRequestDto {
}

export interface GuestExtendableResourceCountRequestDto extends ActivityResourceCountDeterminationRequestDto {
    maxAdditional?: number | undefined;
}

export interface RemoveActivityDurationCommand {
    activityId?: string;
    durationInMinutes?: number;
}

export interface GetActivitiesQueryResult {
    activities?: GetActivitiesActivityDto[];
}

export interface GetActivitiesActivityDto {
    activityId?: string;
    name?: LocalizedStaticText;
    description?: LocalizedStaticText | undefined;
    durationsInMinutes?: number[];
    compatibleResourceTypeIds?: string[];
    capacityBasis?: ActivityCapacityBasisDto | undefined;
    suitableAgeGroupIds?: string[];
}

export interface ActivityCapacityBasisDto {
    resourceBasis?: ResourceCapacityBasisDto | undefined;
    participantBasis?: ParticipantCapacityBasisDto | undefined;
}

export interface ResourceCapacityBasisDto {
    participantsEntry?: ParticipantsEntryDto;
}

export interface ParticipantCapacityBasisDto {
    countDetermination?: ActivityResourceCountDeterminationResponseDto;
}

export interface ActivityResourceCountDeterminationResponseDto {
    countDetermination: string;
}

export interface DerivedResourceCountResponseDto extends ActivityResourceCountDeterminationResponseDto {
}

export interface GuestExtendableResourceCountResponseDto extends ActivityResourceCountDeterminationResponseDto {
    maxAdditional?: number | undefined;
}

export interface GetActivitiesQuery {
}

export interface GetActiveActivitiesQueryResult {
    activities?: GetActiveActivitiesActivity[];
}

export interface GetActiveActivitiesActivity {
    activityId?: string;
    name?: string;
}

export interface CreateActivityCommandResponse {
    activityId?: string;
}

export interface CreateActivityCommand {
    name?: string;
}

export interface AddActivityDurationCommand {
    activityId?: string;
    durationInMinutes?: number;
}

export interface GetPendingConfirmationEmailBookingsListPageViewQueryResult {
    manualEmailConfirmation?: boolean;
    bookings?: PendingBookingListItem[];
}

export interface PendingBookingListItem {
    id?: string;
    isApproved?: boolean | undefined;
    confirmationHandling?: ProcessHandlingType;
    createdOnDate?: DateTime;
    cancelledOnDate?: DateTime | undefined;
    fromDate?: DateTime;
    lockReason?: string;
    allowStatusChange?: boolean;
    status?: BookingStatus;
    originType?: BookingOriginType;
    bookingFinalPrice?: number;
    isCustom?: boolean;
    programName?: string;
    paymentDetails?: PendingBookingPaymentDetails;
    customerNameDetails?: PendingBookingCustomerNameDetails;
    bookingParty?: PendingBookingPartyView;
    surveyAnswers?: PendingBookingSurveyAnswerView[];
    products?: PendingBookingProductView[];
}

export enum ProcessHandlingType {
    None = "None",
    Automatic = "Automatic",
    Manual = "Manual",
}

export interface PendingBookingPaymentDetails {
    requiredGrossAmount?: number;
    remainingGrossAmount?: number;
    remainingRefundableAmount?: number;
    paymentBalance?: number;
    requiredDepositAmount?: number;
    bookingPaymentStatus?: BookingPaymentStatus;
    hasPendingApprovalBookingRefundProposals?: boolean;
}

export interface PendingBookingCustomerNameDetails {
    _FullName?: string;
    firstName?: string;
    lastName?: string;
    isCompany?: boolean;
    companyName?: string;
    departmentName?: string;
    email?: string;
    phoneNumber?: string;
}

export interface PendingBookingPartyView {
    totalPersonCount?: number;
    minTotalPersonCount?: number;
    maxTotalPersonCount?: number;
    ageGroups?: PendingBookingAgeGroupView[];
}

export interface PendingBookingAgeGroupView {
    ageGroupId?: string;
    orderIndex?: number;
    fromAge?: number;
    toAge?: number;
    count?: number;
    minCount?: number;
    maxCount?: number;
    unitSingular?: string;
    unitPlural?: string;
}

export interface PendingBookingSurveyAnswerView {
    questionLabel?: string;
    customRemarks?: string;
    answerType?: string;
    answerValues?: PendingBookingSurveyAnswerValueView[];
}

export interface PendingBookingSurveyAnswerValueView {
    answerLabel?: string;
    answerBool?: boolean | undefined;
    answerText?: string;
    answerNumber?: number | undefined;
}

export interface PendingBookingProductView {
    productId?: string;
    name?: string;
    itemCount?: number;
    price?: number | undefined;
    totalPrice?: number | undefined;
}

export interface GetPendingConfirmationEmailBookingsListPageViewQuery {
}

export interface GetPendingApprovalBookingsListPageViewQueryResult {
    manualEmailConfirmation?: boolean;
    isDirty?: boolean;
    bookings?: PendingBookingListItem[];
}

export interface GetPendingApprovalBookingsListPageViewQuery {
}

export interface RegisterBookingPaymentReceivedCommandResult {
    bookerPaymentId?: string;
}

export interface RegisterBookingPaymentReceivedCommand {
    bookingId?: string;
    amountToReceive?: number;
}

export interface GetBookingPaymentPanelViewQueryResult {
    header?: BookingPaymentPanelHeaderDto;
    deposit?: BookingPaymentPanelDepositDto;
    totals?: BookingPaymentPanelTotalsDto;
    moneyTransactions?: BookingPaymentPanelMoneyTransactionDto[];
    paymentLinkOptions?: BookingPaymentPanelPaymentLinkOptionsDto;
    allowManualPaymentEntry?: boolean;
}

export interface BookingPaymentPanelHeaderDto {
    bookingId?: string;
    reference?: string;
    referenceIsDerivedFromCustomer?: boolean;
    customer?: BookingCustomerDisplayDto | undefined;
    status?: BookingPaymentPanelBookingStatus;
    firstActivityStartAt?: DateTime | undefined;
}

export interface BookingCustomerDisplayDto {
    displayName?: string;
    kind?: BookingCustomerKind;
    departmentName?: string | undefined;
}

export enum BookingCustomerKind {
    Individual = "Individual",
    Company = "Company",
}

export enum BookingPaymentPanelBookingStatus {
    Draft = "Draft",
    Confirmed = "Confirmed",
    AwaitingDeposit = "AwaitingDeposit",
    Cancelled = "Cancelled",
    Aborted = "Aborted",
}

export interface BookingPaymentPanelDepositDto {
    requiredDepositAmount?: number;
    coveredDepositAmount?: number;
    outstandingDepositAmount?: number;
    depositIsPaid?: boolean;
    depositDueByDateTime?: DateTime | undefined;
}

export interface BookingPaymentPanelTotalsDto {
    requiredGrossAmount?: number;
    receivedGrossAmount?: number;
    outstandingGrossAmount?: number;
}

export interface BookingPaymentPanelMoneyTransactionDto {
    amount?: number;
    description?: string | undefined;
    paidVia?: string;
    createdAtDateTime?: DateTime;
    isPayment?: boolean;
}

export interface BookingPaymentPanelPaymentLinkOptionsDto {
    paymentSettings?: BookingPaymentPanelPaymentSettingsOptionDto[];
    redirectUrlTemplate?: string;
}

export interface BookingPaymentPanelPaymentSettingsOptionDto {
    id?: string;
    name?: string;
}

export interface GetBookingPaymentPanelViewQuery {
    bookingId?: string;
}

export interface CreateBookingPaymentLinkCommandResult {
    paymentLinkUrl?: string;
    bookerPaymentId?: string;
    paymentLinkExpiresAtDateTime?: DateTime;
}

export interface CreateBookingPaymentLinkCommand {
    bookingId?: string;
    paymentSettingsId?: string;
    amountToReceive?: number;
    redirectBaseUrl?: string;
}

export interface GetCatalogAvailabilityForDateQueryResult {
    date?: DateTime;
    availableItems?: GetCatalogAvailabilityForDateQueryResultItem[];
}

export interface GetCatalogAvailabilityForDateQueryResultItem {
    relatedObjectId?: string;
}

export interface GetCatalogAvailabilityForDateQuery {
    date?: DateTime;
}

export interface SubmitDraftBookingCommandResponse {
    isSuccess?: boolean;
    failureCode?: string | undefined;
}

export interface SubmitDraftBookingCommand {
    bookingSessionId?: string;
}

export interface SetBookingReferenceCommandResponse {
    isSuccess?: boolean;
    failureCode?: string | undefined;
    reference?: string | undefined;
}

export interface SetBookingReferenceCommand {
    bookingSessionId?: string;
    reference?: string;
}

export interface SetBookingQuestionAnswersCommandResponse {
    isSuccess?: boolean;
    failureCode?: string | undefined;
}

export interface SetBookingQuestionAnswersCommand {
    bookingSessionId?: string;
    answers?: SetBookingQuestionAnswersCommandAnswer[];
}

export interface SetBookingQuestionAnswersCommandAnswer {
    questionId?: string;
    answerValue?: BookingQuestionnaireAnswerValueRequest;
    customRemarksText?: string | undefined;
}

export interface BookingQuestionnaireAnswerValueRequest {
    answerKind: string;
}

export interface BookingQuestionnaireTextAnswerValueRequest extends BookingQuestionnaireAnswerValueRequest {
    text?: string | undefined;
}

export interface BookingQuestionnaireCheckAnswerValueRequest extends BookingQuestionnaireAnswerValueRequest {
    isChecked?: boolean;
}

export interface BookingQuestionnaireSelectAnswerValueRequest extends BookingQuestionnaireAnswerValueRequest {
    optionId?: string | undefined;
}

export interface BookingQuestionnaireOptionCountAnswerValueRequest extends BookingQuestionnaireAnswerValueRequest {
    counts?: BookingQuestionnaireOptionCountEntryRequest[];
}

export interface BookingQuestionnaireOptionCountEntryRequest {
    optionId?: string;
    count?: number;
}

export interface SetBookingIndividualCustomerCommandResponse {
    isSuccess?: boolean;
    failureCode?: string | undefined;
    bookingReference?: string | undefined;
}

export interface SetBookingIndividualCustomerCommand {
    bookingSessionId?: string;
    firstName?: string | undefined;
    lastName?: string;
    contactEmailAddress?: string | undefined;
    contactPhoneNumber?: InternationalPhoneNumberDto | undefined;
    linkedCustomer?: CustomerReferenceDto | undefined;
    address?: BookingCustomerAddressDto | undefined;
    communicationLocaleId?: string | undefined;
    emailNotificationsEnabled?: boolean;
}

export interface InternationalPhoneNumberDto {
    countryCode?: string;
    nationalNumber?: string;
}

export interface CustomerReferenceDto {
    customerAccountId?: string;
    customerId?: string;
}

export interface BookingCustomerAddressDto {
    countryCode?: string;
    city?: string;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    regionCode?: string | undefined;
    postalCode?: string | undefined;
    street?: string | undefined;
    buildingNumber?: string | undefined;
    buildingNumberSuffix?: string | undefined;
}

export interface SetBookingCustomerForCustomerAccountCommandResponse {
    isSuccess?: boolean;
    failureCode?: string | undefined;
    bookingReference?: string | undefined;
    customerInfo?: SetBookingCustomerForCustomerAccountCommandResponseCustomerInfo | undefined;
}

export interface SetBookingCustomerForCustomerAccountCommandResponseCustomerInfo {
    firstName?: string | undefined;
    lastName?: string;
    contactEmailAddress?: string | undefined;
    contactPhoneNumber?: SetBookingCustomerForCustomerAccountCommandResponseInternationalPhoneNumber | undefined;
    linkedCustomer?: SetBookingCustomerForCustomerAccountCommandResponseLinkedCustomerInfo;
    companyDetails?: SetBookingCustomerForCustomerAccountCommandResponseCompanyDetails | undefined;
}

export interface SetBookingCustomerForCustomerAccountCommandResponseInternationalPhoneNumber {
    e164?: string;
    countryCode?: string;
    nationalNumber?: string;
}

export interface SetBookingCustomerForCustomerAccountCommandResponseLinkedCustomerInfo {
    customerAccountId?: string;
    customerId?: string;
}

export interface SetBookingCustomerForCustomerAccountCommandResponseCompanyDetails {
    companyName?: string;
    departmentName?: string | undefined;
}

export interface SetBookingCustomerForCustomerAccountCommand {
    bookingSessionId?: string;
    customerAccountId?: string;
    customerId?: string;
    communicationLocaleId?: string | undefined;
    emailNotificationsEnabled?: boolean;
}

export interface SetBookingCompanyCustomerCommandResponse {
    isSuccess?: boolean;
    failureCode?: string | undefined;
    bookingReference?: string | undefined;
}

export interface SetBookingCompanyCustomerCommand {
    bookingSessionId?: string;
    companyName?: string;
    departmentName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string;
    contactEmailAddress?: string | undefined;
    contactPhoneNumber?: InternationalPhoneNumberDto | undefined;
    linkedCustomer?: CustomerReferenceDto | undefined;
    address?: BookingCustomerAddressDto | undefined;
    communicationLocaleId?: string | undefined;
    emailNotificationsEnabled?: boolean;
}

export interface SetBookingCommunicationLocaleCommandResponse {
    isSuccess?: boolean;
    failureCode?: string | undefined;
    communicationLocaleId?: string;
}

export interface SetBookingCommunicationLocaleCommand {
    bookingSessionId?: string;
    communicationLocaleId?: string;
}

export interface SetBookingArticleExtrasCommandResponse {
    isSuccess?: boolean;
    failureCode?: string | undefined;
}

export interface SetBookingArticleExtrasCommand {
    bookingSessionId?: string;
    items?: SetBookingArticleExtraItem[];
}

export interface SetBookingArticleExtraItem {
    articleId?: string;
    quantity?: number;
}

export interface SetAsideDraftBookingCommandResponse {
    isSuccess?: boolean;
}

export interface SetAsideDraftBookingCommand {
    bookingSessionId?: string;
}

export interface ReverseBookingPromotionCodeRedemptionCommandResponse {
    isSuccess?: boolean;
    failureCode?: string | undefined;
}

export interface ReverseBookingPromotionCodeRedemptionCommand {
    bookingSessionId?: string;
    promotionId?: string;
}

export interface ResumeDraftBookingCommandResponse {
    sessionType?: string;
    bookingSessionId?: string;
    expiresAt?: DateTime;
}

export interface ResumeDraftBookingCommand {
    bookingId?: string;
}

export interface RemoveBookingActivityCommandResponse {
    isSuccess?: boolean;
    failureCode?: string | undefined;
}

export interface RemoveBookingActivityCommand {
    bookingSessionId?: string;
    bookingActivityId?: string;
}

export interface RedeemBookingPromotionCodeCommandResponse {
    isSuccess?: boolean;
    failureCode?: string | undefined;
    code?: string | undefined;
}

export interface RedeemBookingPromotionCodeCommand {
    bookingSessionId?: string;
    code?: string;
}

export interface ListSubmittedBookingsForDateQueryResult {
    items?: SubmittedBookingListItemDto[];
}

export interface SubmittedBookingListItemDto {
    bookingId?: string;
    reference?: string;
    referenceIsDerivedFromCustomer?: boolean;
    customer?: BookingCustomerDisplayDto | undefined;
    channel?: SubmittedBookingChannelKind;
    firstActivityStartAt?: DateTime | undefined;
    totalPersonCount?: number | undefined;
    participants?: BookingListParticipantDto[];
    activityCount?: number;
    activities?: BookingListActivityDto[];
    submittedAt?: DateTime;
    status?: SubmittedBookingStatus;
    abortReason?: SubmittedBookingAbortReason | undefined;
}

export enum SubmittedBookingChannelKind {
    Planner = "Planner",
    CmsSite = "CmsSite",
    ConnectApi = "ConnectApi",
}

export interface BookingListParticipantDto {
    ageGroupId?: string;
    count?: number;
    name?: string | undefined;
}

export interface BookingListActivityDto {
    activityId?: string;
    name?: string | undefined;
    isDeleted?: boolean;
}

export enum SubmittedBookingStatus {
    Confirmed = "Confirmed",
    AwaitingDeposit = "AwaitingDeposit",
    Cancelled = "Cancelled",
    Aborted = "Aborted",
}

export enum SubmittedBookingAbortReason {
    DraftDiscarded = "DraftDiscarded",
    DepositExpired = "DepositExpired",
}

export interface ListSubmittedBookingsForDateQuery {
    date?: DateTime;
}

export interface ListRecentConfirmedBookingsQueryResult {
    bookings?: RecentConfirmedBookingDto[];
}

export interface RecentConfirmedBookingDto {
    bookingId?: string;
    reference?: string;
    customer?: BookingCustomerDisplayDto | undefined;
    firstActivityStartAt?: DateTime | undefined;
    createdOnDate?: DateTime;
}

export interface ListRecentConfirmedBookingsQuery {
    limit?: number;
}

export interface ListDraftBookingsQueryResult {
    items?: DraftBookingListItemDto[];
}

export interface DraftBookingListItemDto {
    bookingId?: string;
    reference?: string;
    customer?: BookingCustomerDisplayDto | undefined;
    firstActivityStartAt?: DateTime | undefined;
    totalPersonCount?: number | undefined;
    participants?: BookingListParticipantDto[];
    activityCount?: number;
    activities?: BookingListActivityDto[];
    isEmpty?: boolean;
    createdAt?: DateTime;
    createdBy?: string | undefined;
    updatedAt?: DateTime;
    setAsideAt?: DateTime | undefined;
    hasActiveSession?: boolean;
}

export interface ListDraftBookingsQuery {
}

export interface GetBookingForBookingSessionQueryResult {
    booking?: GetBookingForBookingSessionQueryResultBooking | undefined;
}

export interface GetBookingForBookingSessionQueryResultBooking {
    bookingId?: string;
    status?: string;
    reference?: string | undefined;
    customer?: GetBookingForBookingSessionQueryResultCustomer | undefined;
    itinerary?: GetBookingForBookingSessionQueryResultItinerary | undefined;
    quote?: GetBookingForBookingSessionQueryResultQuote | undefined;
    activities?: GetBookingForBookingSessionQueryResultActivity[];
    promotions?: GetBookingForBookingSessionQueryResultPromotion[];
    questionnaire?: GetBookingForBookingSessionQueryResultQuestionnaire | undefined;
    extras?: GetBookingForBookingSessionQueryResultExtra[];
    paymentTerms?: GetBookingForBookingSessionQueryResultPaymentTerms;
    communicationLocaleId?: string;
    emailNotificationsEnabled?: boolean;
    submission?: GetBookingForBookingSessionQueryResultSubmission | undefined;
}

export interface GetBookingForBookingSessionQueryResultCustomer {
    firstName?: string | undefined;
    lastName?: string;
    contactEmailAddress?: string | undefined;
    contactPhoneNumber?: GetBookingForBookingSessionQueryResultInternationalPhoneNumber | undefined;
    linkedCustomerAccountId?: string | undefined;
    linkedCustomerId?: string | undefined;
    address?: GetBookingForBookingSessionQueryResultAddress | undefined;
    companyDetails?: GetBookingForBookingSessionQueryResultCompanyDetails | undefined;
}

export interface GetBookingForBookingSessionQueryResultInternationalPhoneNumber {
    countryCode?: string;
    nationalNumber?: string;
}

export interface GetBookingForBookingSessionQueryResultAddress {
    countryCode?: string;
    addressLine1?: string;
    city?: string;
    addressLine2?: string | undefined;
    regionCode?: string | undefined;
    postalCode?: string | undefined;
    street?: string | undefined;
    buildingNumber?: string | undefined;
    buildingNumberSuffix?: string | undefined;
}

export interface GetBookingForBookingSessionQueryResultCompanyDetails {
    companyName?: string;
    departmentName?: string | undefined;
}

export interface GetBookingForBookingSessionQueryResultItinerary {
    itineraryId?: string;
    itineraryPeriod?: GetBookingForBookingSessionQueryResultPeriod | undefined;
    itineraryParticipants?: GetBookingForBookingSessionQueryResultParticipantGroup;
    steps?: GetBookingForBookingSessionQueryResultItineraryStep[];
    activitySegments?: GetBookingForBookingSessionQueryResultActivitySegment[];
}

export interface GetBookingForBookingSessionQueryResultPeriod {
    fromDateTime?: DateTime;
    toDateTime?: DateTime;
}

export interface GetBookingForBookingSessionQueryResultParticipantGroup {
    totalPersonCount?: number;
    ageGroups?: GetBookingForBookingSessionQueryResultParticipantCountPerAgeGroup[];
}

export interface GetBookingForBookingSessionQueryResultParticipantCountPerAgeGroup {
    ageGroupId?: string;
    participantCount?: number;
}

export interface GetBookingForBookingSessionQueryResultItineraryStep {
    stepId?: string;
    activityId?: string;
    occupancyPeriod?: GetBookingForBookingSessionQueryResultPeriod;
    activityDuration?: Duration;
    activityParticipants?: GetBookingForBookingSessionQueryResultParticipantGroup;
    resources?: GetBookingForBookingSessionQueryResultStepResource[];
    segments?: GetBookingForBookingSessionQueryResultStepSegmentInfo[];
}

export interface GetBookingForBookingSessionQueryResultStepResource {
    resourceId?: string;
    participantGroups?: GetBookingForBookingSessionQueryResultParticipantGroup[];
}

export interface GetBookingForBookingSessionQueryResultStepSegmentInfo {
    segmentId?: string;
    segmentStepId?: string;
    segmentKind?: ItinerarySegmentKindDto;
}

export enum ItinerarySegmentKindDto {
    Activity = "Activity",
    Program = "Program",
}

export interface GetBookingForBookingSessionQueryResultActivitySegment {
    segmentId?: string;
    activityId?: string;
    occupancyPeriod?: GetBookingForBookingSessionQueryResultPeriod;
    activityDuration?: Duration;
    activityParticipants?: GetBookingForBookingSessionQueryResultParticipantGroup;
    step?: GetBookingForBookingSessionQueryResultActivitySegmentStep;
}

export interface GetBookingForBookingSessionQueryResultActivitySegmentStep {
    segmentStepId?: string;
    activityId?: string;
    occupancyPeriod?: GetBookingForBookingSessionQueryResultPeriod;
    activityDuration?: Duration;
    activityParticipants?: GetBookingForBookingSessionQueryResultParticipantGroup;
    resources?: GetBookingForBookingSessionQueryResultSegmentStepResourceAllocation[];
}

export interface GetBookingForBookingSessionQueryResultSegmentStepResourceAllocation {
    resourceBookingId?: string;
    resourceId?: string;
    participantGroups?: GetBookingForBookingSessionQueryResultParticipantGroup[];
}

export interface GetBookingForBookingSessionQueryResultQuote {
    quoteId?: string;
    subtotalBeforeAdjustments?: number;
    total?: number;
    totalDiscountAmount?: number;
    lines?: GetBookingForBookingSessionQueryResultQuoteLine[];
    appliedAdjustments?: GetBookingForBookingSessionQueryResultBookingQuoteAdjustment[];
    status?: BookingQuoteStatusDto;
    revisionNumber?: number;
    precedingQuoteId?: string | undefined;
    committedAt?: DateTime | undefined;
}

export interface GetBookingForBookingSessionQueryResultQuoteLine {
    quoteLineId?: string;
    referenceId?: string;
    origin?: GetBookingForBookingSessionQueryResultQuoteLineOrigin;
    displayName?: string;
    occupancyFromDateTime?: DateTime;
    occupancyToDateTime?: DateTime;
    duration?: Duration;
    participants?: GetBookingForBookingSessionQueryResultQuoteLineParticipant[];
    resourceCount?: number;
    breakdown?: GetBookingForBookingSessionQueryResultQuoteLinePriceBreakdown;
    price?: number;
    quantity?: number;
    subtotalBeforeAdjustments?: number;
    total?: number;
    calculatedDepositAmount?: number;
    descriptionOverride?: string | undefined;
    appliedAdjustments?: GetBookingForBookingSessionQueryResultBookingQuoteLineAdjustment[];
}

export interface GetBookingForBookingSessionQueryResultQuoteLineOrigin {
    activityId?: string;
}

export interface GetBookingForBookingSessionQueryResultQuoteLineParticipant {
    ageGroupId?: string;
    capturedAgeGroupName?: string;
    count?: number;
}

export interface GetBookingForBookingSessionQueryResultQuoteLinePriceBreakdown {
    total?: number;
    lines?: GetBookingForBookingSessionQueryResultQuoteLinePriceBreakdownLine[];
}

export interface GetBookingForBookingSessionQueryResultQuoteLinePriceBreakdownLine {
    specificationId?: string;
    priceComponentId?: string;
    priceComponentName?: string;
    priceLevelId?: string;
    priceLevelName?: string;
    bracketFrom?: number | undefined;
    ageGroupId?: string | undefined;
    capturedAgeGroupName?: string | undefined;
    unitAmount?: number;
    quantity?: number;
    timeUnit?: Duration | undefined;
    amount?: number;
    segmentFromDateTime?: DateTime | undefined;
    segmentToDateTime?: DateTime | undefined;
}

export interface GetBookingForBookingSessionQueryResultBookingQuoteLineAdjustment {
    referenceId?: string;
    sourceKind?: QuoteAdjustmentSourceKindDto;
    direction?: QuoteAdjustmentDirectionDto;
    kind?: QuoteAdjustmentKindDto;
    percentage?: number | undefined;
    fixedAmount?: number | undefined;
    reason?: string;
    subtotalBefore?: number;
    amount?: number;
    subtotalAfter?: number;
}

export enum QuoteAdjustmentSourceKindDto {
    Promotion = "Promotion",
}

export enum QuoteAdjustmentDirectionDto {
    Discount = "Discount",
    Surcharge = "Surcharge",
}

export enum QuoteAdjustmentKindDto {
    Percentage = "Percentage",
    FixedAmount = "FixedAmount",
}

export interface GetBookingForBookingSessionQueryResultBookingQuoteAdjustment {
    referenceId?: string;
    sourceKind?: QuoteAdjustmentSourceKindDto;
    direction?: QuoteAdjustmentDirectionDto;
    kind?: QuoteAdjustmentKindDto;
    percentage?: number | undefined;
    fixedAmount?: number | undefined;
    reason?: string;
    subtotalBefore?: number;
    amount?: number;
    subtotalAfter?: number;
}

export enum BookingQuoteStatusDto {
    Draft = "Draft",
    Committed = "Committed",
    Superseded = "Superseded",
    Discarded = "Discarded",
}

export interface GetBookingForBookingSessionQueryResultActivity {
    bookingActivityId?: string;
    activityId?: string;
    itinerarySegmentId?: string;
}

export interface GetBookingForBookingSessionQueryResultPromotion {
    promotionId?: string;
    promotionName?: string;
    activation?: BookingPromotionActivationDto;
    codeRedemption?: GetBookingForBookingSessionQueryResultPromotionCodeRedemption | undefined;
    discountAmount?: number;
}

export enum BookingPromotionActivationDto {
    Code = "Code",
    Automatic = "Automatic",
}

export interface GetBookingForBookingSessionQueryResultPromotionCodeRedemption {
    code?: string;
}

export interface GetBookingForBookingSessionQueryResultQuestionnaire {
    questionnaireId?: string;
    isEmpty?: boolean;
    isValid?: boolean;
    questions?: GetBookingForBookingSessionQueryResultQuestion[];
}

export interface GetBookingForBookingSessionQueryResultQuestion {
    questionId?: string;
    prompt?: string;
    isRequired?: boolean;
    isAnswered?: boolean;
    isValid?: boolean;
    isInternal?: boolean;
    allowCustomRemarks?: boolean;
    customRemarksText?: string | undefined;
    answerFormat?: BookingQuestionnaireAnswerFormatDto;
    answerValue?: BookingQuestionnaireAnswerValueDto;
}

export interface BookingQuestionnaireAnswerFormatDto {
    answerKind: string;
}

export interface BookingQuestionnaireTextAnswerFormatDto extends BookingQuestionnaireAnswerFormatDto {
    minLength?: number;
    maxLength?: number;
}

export interface BookingQuestionnaireCheckAnswerFormatDto extends BookingQuestionnaireAnswerFormatDto {
    checkStatement?: string;
}

export interface BookingQuestionnaireSelectAnswerFormatDto extends BookingQuestionnaireAnswerFormatDto {
    options?: BookingQuestionnaireSelectOptionDto[];
    display?: SelectAnswerDisplayDto;
}

export interface BookingQuestionnaireSelectOptionDto {
    optionId?: string;
    text?: string;
}

export interface BookingQuestionnaireOptionCountAnswerFormatDto extends BookingQuestionnaireAnswerFormatDto {
    options?: BookingQuestionnaireOptionCountOptionDto[];
    participantLimit?: number | undefined;
}

export interface BookingQuestionnaireOptionCountOptionDto {
    optionId?: string;
    text?: string;
}

export interface BookingQuestionnaireAnswerValueDto {
    answerKind: string;
}

export interface BookingQuestionnaireTextAnswerValueDto extends BookingQuestionnaireAnswerValueDto {
    text?: string;
}

export interface BookingQuestionnaireCheckAnswerValueDto extends BookingQuestionnaireAnswerValueDto {
    isChecked?: boolean;
}

export interface BookingQuestionnaireSelectAnswerValueDto extends BookingQuestionnaireAnswerValueDto {
    chosenOption?: BookingQuestionnaireSelectOptionDto | undefined;
}

export interface BookingQuestionnaireOptionCountAnswerValueDto extends BookingQuestionnaireAnswerValueDto {
    counts?: BookingQuestionnaireCountedOptionDto[];
}

export interface BookingQuestionnaireCountedOptionDto {
    optionId?: string;
    text?: string;
    count?: number;
}

export interface GetBookingForBookingSessionQueryResultExtra {
    articleId?: string;
    quantity?: number;
}

export interface GetBookingForBookingSessionQueryResultPaymentTerms {
    requiredDepositAmount?: number;
    isDepositRequired?: boolean;
    depositDueWithinMinutes?: number | undefined;
}

export interface GetBookingForBookingSessionQueryResultSubmission {
    readyForSubmission?: boolean;
    itineraryReady?: boolean;
    questionnaireReady?: boolean;
    referenceReady?: boolean;
}

export interface GetBookingForBookingSessionQuery {
    bookingSessionId?: string;
}

export interface DiscardDraftBookingCommandResponse {
    isSuccess?: boolean;
}

export interface DiscardDraftBookingCommand {
    bookingId?: string;
}

export interface ConfirmDraftBookingCommandResponse {
    isSuccess?: boolean;
    failureCode?: string | undefined;
}

export interface ConfirmDraftBookingCommand {
    bookingSessionId?: string;
}

export interface ClearBookingCustomerCommandResponse {
    isSuccess?: boolean;
    failureCode?: string | undefined;
}

export interface ClearBookingCustomerCommand {
    bookingSessionId?: string;
}

export interface CancelBookingCommandResponse {
    isSuccess?: boolean;
    failureCode?: string | undefined;
    status?: SubmittedBookingStatus;
}

export interface CancelBookingCommand {
    bookingId?: string;
    initiator?: CancelBookingInitiator;
    note?: string | undefined;
}

export enum CancelBookingInitiator {
    Customer = "Customer",
    Location = "Location",
}

export interface AddBookingActivityFromOptionCommandResponse {
    isSuccess?: boolean;
    failureCode?: string | undefined;
}

export interface AddBookingActivityFromOptionCommand {
    bookingSessionId?: string;
    bookingOptionId?: string;
}

export interface AbortDraftBookingCommandResponse {
    isSuccess?: boolean;
    failureCode?: string | undefined;
}

export interface AbortDraftBookingCommand {
    bookingSessionId?: string;
}

export interface StartDraftBookingSessionCommandResponse {
    sessionType?: string;
    bookingSessionId?: string;
    expiresAt?: DateTime;
}

export interface StartDraftBookingSessionCommand {
    communicationLocaleId?: string | undefined;
}

export interface ExtendBookingSessionCommandResponse {
    expiresAt?: DateTime | undefined;
}

export interface ExtendBookingSessionCommand {
    bookingSessionId?: string;
}

export interface CreateSampleBookingResult {
    success?: boolean;
    bookingId?: string | undefined;
    status?: string | undefined;
    eventDate?: DateTime;
    visitors?: number;
    grossAmount?: number;
    programName?: string | undefined;
    message?: string | undefined;
}

export interface CreateSampleBookingCommand {
    eventDate?: DateTime | undefined;
    visitors?: number | undefined;
    grossAmount?: number | undefined;
}

export interface GetPrepareBookingRefundProposalsPageViewQueryResult {
    bookingsThatRequireRefund?: BookingWhereRefundIsRequired[];
    isDirty?: boolean;
}

export interface BookingWhereRefundIsRequired {
    id?: string;
    processViaPaymentProvider?: boolean | undefined;
    allowViaPaymentProvider?: boolean;
    updatedOnDate?: DateTime;
    updatedBy?: string;
    fromDate?: DateTime;
    bookingId?: string;
    customerNameDetails?: RefundBookingCustomerNameDetails;
    status?: BookingStatus;
    originType?: BookingOriginType;
    bookingFinalPrice?: number;
    paymentDetails?: RefundBookingPaymentGeneralInfo;
    isCustom?: boolean;
    programName?: string;
    bookingParty?: RefundBookingParty;
    surveyAnswers?: RefundSurveyAnswer[];
    products?: RefundBookingProductDetails[];
}

export interface RefundBookingCustomerNameDetails {
    firstName?: string;
    lastName?: string;
    isCompany?: boolean;
    companyName?: string;
    departmentName?: string;
    email?: string;
    phoneNumber?: string;
    _FullName?: string;
}

export interface RefundBookingPaymentGeneralInfo {
    requiredGrossAmount?: number;
    remainingGrossAmount?: number;
    remainingRefundableAmount?: number;
    paymentBalance?: number;
    requiredDepositAmount?: number;
    bookingPaymentStatus?: BookingPaymentStatus;
    hasPendingApprovalBookingRefundProposals?: boolean;
}

export interface RefundBookingParty {
    totalPersonCount?: number;
    minTotalPersonCount?: number;
    maxTotalPersonCount?: number;
    ageGroups?: RefundBookingPartyAgeGroup[];
}

export interface RefundBookingPartyAgeGroup {
    ageGroupId?: string;
    fromAge?: number;
    toAge?: number;
    count?: number;
    unitPlural?: string;
    unitSingular?: string;
    maxCount?: number;
    minCount?: number;
    orderIndex?: number;
}

export interface RefundSurveyAnswer {
    questionLabel?: string;
    questionId?: string;
    answerType?: string;
    customRemarks?: string;
    answerValues?: RefundSurveyAnswerValue[];
}

export interface RefundSurveyAnswerValue {
    answerLabel?: string;
    answerBool?: boolean | undefined;
    answerText?: string;
    answerNumber?: number | undefined;
}

export interface RefundBookingProductDetails {
    productId?: string;
    name?: string;
    itemCount?: number;
    price?: number | undefined;
    totalPrice?: number | undefined;
}

export interface GetPrepareBookingRefundProposalsPageViewQuery {
}

export interface GetBookingRefundProposalPendingApprovalListPageViewQueryResult {
    bookingRefundProposals?: BookingRefundProposalPendingApprovalItem[];
    isDirty?: boolean;
}

export interface BookingRefundProposalPendingApprovalItem {
    id?: string;
    isApproved?: boolean | undefined;
    warningText?: string;
    approvalCreatedOnDate?: DateTime | undefined;
    approvalCreatedBy?: string;
    bookingFromDate?: DateTime;
    bookingId?: string;
    customerNameDetails?: RefundBookingCustomerNameDetails;
    refundStatus?: RefundStatus;
    bookingStatus?: BookingStatus;
    bookingOriginType?: BookingOriginType;
    isCustom?: boolean;
    programName?: string;
    bookingParty?: RefundBookingParty;
    surveyAnswers?: RefundSurveyAnswer[];
    products?: RefundBookingProductDetails[];
    bookingFinalPrice?: number;
    paymentDetailsAfterRefund?: RefundBookingPaymentGeneralInfo;
    currentPendingBalanceAmount?: number;
    totalRefundAmount?: number;
    balanceAfterRefundAmount?: number;
    viaPaymentProvider?: boolean;
}

export interface GetBookingRefundProposalPendingApprovalListPageViewQuery {
}

export interface GetBookingRefundProposalInProgressListPageViewQueryResult {
    bookingRefundProposals?: BookingRefundProposalInProgressItem[];
}

export interface BookingRefundProposalInProgressItem {
    id?: string;
    isApproved?: boolean | undefined;
    warningText?: string;
    approvalCreatedOnDate?: DateTime | undefined;
    approvalCreatedBy?: string;
    approvedBy?: string;
    approvedOnDate?: DateTime | undefined;
    bookingFromDate?: DateTime;
    bookingId?: string;
    customerNameDetails?: RefundBookingCustomerNameDetails;
    refundStatus?: RefundStatus;
    bookingStatus?: BookingStatus;
    bookingOriginType?: BookingOriginType;
    isCustom?: boolean;
    programName?: string;
    bookingParty?: RefundBookingParty;
    surveyAnswers?: RefundSurveyAnswer[];
    products?: RefundBookingProductDetails[];
    bookingFinalPrice?: number;
    paymentDetailsAfterRefund?: RefundBookingPaymentGeneralInfo;
    currentPendingBalanceAmount?: number;
    totalRefundAmount?: number;
    balanceAfterRefundAmount?: number;
    viaPaymentProvider?: boolean;
}

export interface GetBookingRefundProposalInProgressListPageViewQuery {
}

export interface GetBookingRefundProposalHistoryListPageDataViewQueryResult {
    fromDate?: DateTime;
    toDate?: DateTime;
    refunds?: BookingRefundProposalHistoryListPageDataItem[];
}

export interface BookingRefundProposalHistoryListPageDataItem {
    id?: string;
    isApproved?: boolean | undefined;
    warningText?: string;
    approvalCreatedOnDate?: DateTime | undefined;
    approvalCreatedBy?: string;
    approvedBy?: string;
    approvedOnDate?: DateTime | undefined;
    processedOnDate?: DateTime | undefined;
    bookingFromDate?: DateTime;
    bookingId?: string;
    customerNameDetails?: RefundBookingCustomerNameDetails;
    refundStatus?: RefundStatus;
    bookingStatus?: BookingStatus;
    bookingOriginType?: BookingOriginType;
    isCustom?: boolean;
    programName?: string;
    bookingParty?: RefundBookingParty;
    surveyAnswers?: RefundSurveyAnswer[];
    products?: RefundBookingProductDetails[];
    bookingFinalPrice?: number;
    paymentDetailsAfterRefund?: RefundBookingPaymentGeneralInfo;
    startPendingBalanceAmount?: number;
    totalRefundAmount?: number;
    balanceAfterRefundAmount?: number;
    viaPaymentProvider?: boolean;
}

export interface GetBookingRefundProposalHistoryListPageDataViewQuery {
    fromDate?: DateTime;
}

export interface SetBookingReminderLeadDaysCommand {
    days?: number;
}

export interface SetBookingNotificationKindEnabledCommand {
    kind?: string;
    isEnabled?: boolean;
}

export interface GetBookingNotificationRulesQueryResult {
    rules?: BookingNotificationRuleDto[];
    reminderLeadDays?: number;
}

export interface BookingNotificationRuleDto {
    kind?: string;
    label?: LocalizedStaticText;
    isEnabled?: boolean;
}

export interface GetBookingNotificationRulesQuery {
}

export interface GetPaymentDetailsDialogViewQueryResult {
    dialogTitle?: string;
    tenantId?: string;
    locationId?: string;
    locationName?: string;
    bookingId?: string;
    bookingCode?: string;
    bookingFromDate?: DateTime;
    programName?: string;
    bookingStatus?: BookingStatus;
    bookingOriginType?: BookingOriginType;
    bookingFinalPrice?: number;
    allowRefund?: boolean;
    allowManualPaymentEntry?: boolean;
    allowPaymentTransaction?: boolean;
    paymentDetails?: GetPaymentDetailsDialogViewPaymentDetails;
    posDetails?: GetPaymentDetailsDialogViewPosDetails;
    moneyTransactions?: GetPaymentDetailsDialogViewMoneyTransaction[];
    pendingMoneyTransactions?: GetPaymentDetailsDialogViewMoneyTransaction[];
    refundProposals?: GetPaymentDetailsDialogViewRefundProposal[];
}

export interface GetPaymentDetailsDialogViewPaymentDetails {
    requiredGrossAmount?: number;
    remainingGrossAmount?: number;
    remainingRefundableAmount?: number;
    paymentBalance?: number;
    requiredDepositAmount?: number;
    bookingPaymentStatus?: BookingPaymentStatus;
    hasPendingApprovalBookingRefundProposals?: boolean;
}

export interface GetPaymentDetailsDialogViewPosDetails {
    inPos?: boolean;
    referenceText?: string | undefined;
}

export interface GetPaymentDetailsDialogViewMoneyTransaction {
    id?: string;
    transactionAmount?: number;
    balanceAmount?: number;
    description?: string | undefined;
    paymentServiceProviderId?: string | undefined;
    paymentServiceProviderPaymentId?: string | undefined;
    paymentServiceProviderRefundId?: string | undefined;
    createdOnDateTime?: DateTime;
}

export interface GetPaymentDetailsDialogViewRefundProposal {
    id?: string;
    viaPaymentProvider?: boolean;
    status?: BookingRefundProposalStatus;
    createdOnDateTime?: DateTime;
    createdBy?: string | undefined;
    approvedOnDateTime?: DateTime | undefined;
    approvalDecisionBy?: string | undefined;
    totalRefundAmount?: number;
    succeededAtDateTime?: DateTime | undefined;
    failedAtDateTime?: DateTime | undefined;
    failureReason?: string | undefined;
    isApproved?: boolean;
}

export enum BookingRefundProposalStatus {
    PendingApproval = "PendingApproval",
    InProgress = "InProgress",
    Succeeded = "Succeeded",
    Failed = "Failed",
}

export interface GetPaymentDetailsDialogViewQuery {
    bookingId?: string;
}

export interface GetSelfServiceOptionsQueryResult {
    cmsSites?: BookingDebugDialogSiteOptions[];
    modifyUrlTemplate?: string;
    cancelUrlTemplate?: string;
    surveyUrlTemplate?: string;
    dashboardUrlTemplate?: string;
}

export interface BookingDebugDialogSiteOptions {
    siteId?: string;
    name?: string;
    paymentSettingsId?: string;
    hostNames?: string[];
}

export interface BookingDevQuery {
    bookingId?: string;
}

export interface __GetBookingResourceBookingsQueryResult {
    resourceBookings?: __GetBookingResourceBookingsQueryResultItem[] | undefined;
}

export interface __GetBookingResourceBookingsQueryResultItem {
    autoSelect?: boolean;
    blockedForOriginType?: __BookingOriginType | undefined;
    bookingId?: string | undefined;
    color?: string | undefined;
    createdBy?: string | undefined;
    createdByAzureId?: string | undefined;
    createdByRaxId?: string | undefined;
    createdOnDate?: DateTime;
    deleted?: boolean;
    deletedByAzureId?: string | undefined;
    deletedBy?: string | undefined;
    deletedByRaxId?: string | undefined;
    deletedOnDate?: DateTime | undefined;
    description?: string | undefined;
    duration?: Duration;
    id?: string | undefined;
    fromDate?: DateTime;
    locationId?: string | undefined;
    name?: string | undefined;
    personCount?: number;
    partitionKey?: string | undefined;
    programStepConfigId?: string | undefined;
    programStepId?: string | undefined;
    raxVersion?: string | undefined;
    resourceBookingTypeId?: string | undefined;
    resourceId?: string | undefined;
    status?: __ResourceBookingStatus;
    tenantId?: string | undefined;
    toDate?: DateTime;
    updateCorrelationId?: string | undefined;
    updatedBy?: string | undefined;
    updatedByAzureId?: string | undefined;
    updatedByRaxId?: string | undefined;
    updatedOnDate?: DateTime;
}

export enum __BookingOriginType {
    RaxBookingSite = "RaxBookingSite",
    Internal = "Internal",
    League = "League",
}

export enum __ResourceBookingStatus {
    Temporary = "Temporary",
    Cancelled = "Cancelled",
    Booked = "Booked",
    Blocked = "Blocked",
}

export interface GetRefundsQueryResult {
    refunds?: __RefundV2Data[];
}

export interface __BaseKey {
    id?: string | undefined;
}

export interface __BaseData extends __BaseKey {
    createdBy?: string | undefined;
    createdByRaxId?: string | undefined;
    createdByAzureId?: string | undefined;
    createdOnDate?: DateTime;
    deleted?: boolean;
    deletedBy?: string | undefined;
    deletedByRaxId?: string | undefined;
    deletedByAzureId?: string | undefined;
    deletedOnDate?: DateTime | undefined;
    updatedBy?: string | undefined;
    updatedOnDate?: DateTime;
    updatedByRaxId?: string | undefined;
    updatedByAzureId?: string | undefined;
    raxVersion?: string | undefined;
    updateCorrelationId?: string | undefined;
}

export interface __BaseCosmosData extends __BaseData {
    partitionKey?: string | undefined;
}

export interface __RefundV2Data extends __BaseCosmosData {
    bookingId?: string | undefined;
    refundStatus?: __RefundV2Status;
    requestedRefundAmount?: number;
    description?: string | undefined;
    localeName?: string | undefined;
    paymentConfigId?: string | undefined;
    paymentServiceProviderId?: string | undefined;
    paymentServiceProviderRefundId?: string | undefined;
    paymentId?: string | undefined;
    paymentServiceProviderPaymentId?: string | undefined;
    bookingRefundProposalId?: string | undefined;
    failedAtDateTime?: DateTime | undefined;
    refundedAtDateTime?: DateTime | undefined;
    processingStartedAtDateTime?: DateTime | undefined;
    failureReason?: string | undefined;
    metaData?: __RefundV2MetaData | undefined;
    locationId?: string | undefined;
    tenantId?: string | undefined;
}

export enum __RefundV2Status {
    Pending = "Pending",
    Processing = "Processing",
    Refunded = "Refunded",
    Failed = "Failed",
}

export interface __RefundV2MetaData extends __BaseKey {
    refundedAmount?: number;
}

export interface GetPaymentsQueryResult {
    payments?: __PaymentData[];
}

export interface __PaymentData extends __BaseCosmosData {
    bookingId?: string | undefined;
    requestedAmount?: number;
    description?: string | undefined;
    localeName?: string | undefined;
    paymentStatus?: __PaymentStatus;
    paymentMethod?: string | undefined;
    failureReason?: string | undefined;
    failedAtDateTime?: DateTime | undefined;
    paidAtDateTime?: DateTime | undefined;
    paymentLink?: __PaymentLinkData | undefined;
    paymentConfigId?: string | undefined;
    paymentServiceProviderId?: string | undefined;
    paymentServiceProviderPaymentId?: string | undefined;
    paymentRefunds?: __PaymentRefundData[] | undefined;
    metaData?: __PaymentMetaData | undefined;
    locationId?: string | undefined;
    tenantId?: string | undefined;
}

export enum __PaymentStatus {
    Pending = "Pending",
    Paid = "Paid",
    Failed = "Failed",
}

export interface __PaymentLinkData extends __BaseKey {
    paymentUrl?: string | undefined;
    redirectUrl?: string | undefined;
    paymentSuccessRedirectUrl?: string | undefined;
    expiresAtDateTime?: DateTime;
}

export interface __PaymentRefundData extends __BaseKey {
    refundId?: string | undefined;
    refundStatus?: __RefundStatus;
    amountRequested?: number;
    amountRefunded?: number;
}

export enum __RefundStatus {
    None = "None",
    PendingApproval = "Pending Approval",
    Prepared = "Prepared",
    InProgress = "InProgress",
    Authorized = "Authorized",
    Approved = "Approved",
    Declined = "Declined",
    Canceled = "Canceled",
    Succeeded = "Succeeded",
    Failed = "Failed",
}

export interface __PaymentMetaData extends __BaseKey {
    receivedAmount?: number;
    refundedAmount?: number;
    balanceAmount?: number;
}

export interface GetPaymentLinkOptionsQueryResult {
    cmsSites?: BookingDebugDialogSiteOptions[];
    paymentSettings?: BookingDebugDialogPaymentSettingsOption[];
    initialAmount?: number;
    redirectUrlTemplate?: string;
}

export interface BookingDebugDialogPaymentSettingsOption {
    name?: string;
    providerId?: string;
    paymentSettingsId?: string;
    paymentDescription?: string;
}

export interface __BaseCosmosNameData extends __BaseCosmosData {
    name?: string | undefined;
    description?: string | undefined;
}

export interface __BookingData extends __BaseCosmosNameData {
    bookingProposalId?: string | undefined;
    bookingSiteId?: string | undefined;
    cancelledOnDate?: DateTime | undefined;
    cancelledOnEpochTicks?: number | undefined;
    paymentDetails?: __BookingPaymentDetails | undefined;
    timers?: __BookingTimers | undefined;
    lockDetails?: __BookingLockDetails | undefined;
    posDetails?: __BookingPosDetails | undefined;
    messageDetails?: __BookingMessageDetails | undefined;
    pendingBookingExpiresAtDateTime?: DateTime | undefined;
    migratedToVersion?: string | undefined;
    fromEpochTicks?: number;
    tenantId?: string | undefined;
    locationId?: string | undefined;
    bookingCode?: string | undefined;
    bookingCustomer?: __BookingCustomer | undefined;
    bookingOriginType?: __BookingOriginType;
    bookingParty?: __BookingParty | undefined;
    bookingProducts?: __BookingProduct[] | undefined;
    bookingProgramSteps?: __BookingProgramStep[] | undefined;
    customerId?: string | undefined;
    fromDate?: DateTime;
    isCustom?: boolean;
    priceDetails?: __BookingPriceDetails | undefined;
    programDuration?: Duration;
    programId?: string | undefined;
    status?: __BookingStatus;
    surveyAnswers?: __BookingSurveyAnswer[] | undefined;
    leagueDetails?: __BookingLeagueDetails | undefined;
    originalTotalPersonCount?: number | undefined;
    originalBookingValue?: number | undefined;
}

export interface __BookingPaymentDetails extends __BaseKey {
    requiredGrossAmount?: number;
    requiredDepositAmount?: number;
}

export interface __BookingTimers extends __BaseKey {
    reminderEmailTimerInfo?: __TimerInfo | undefined;
    completedEmailTimerInfo?: __TimerInfo | undefined;
}

export interface __TimerInfo extends __BaseKey {
    tokenId?: string | undefined;
    firesOnDate?: DateTime | undefined;
}

export interface __BookingLockDetails extends __BaseKey {
    lockUpdate?: boolean;
    lockCancel?: boolean;
    lockStatusChange?: boolean;
    expiresOnDate?: DateTime | undefined;
    sagaLockCorrelationId?: string | undefined;
    lockReason?: string | undefined;
    locked?: boolean;
    lockedOnDate?: DateTime | undefined;
}

export interface __BookingPosDetails {
    updatedBy?: string | undefined;
    updatedOnDate?: DateTime;
    inPos?: boolean;
    posEntry?: __PosEntryType;
    posReferenceText?: string | undefined;
    posReferenceId?: string | undefined;
    validForAutomaticPosEntry?: boolean;
}

export enum __PosEntryType {
    None = "None",
    Manual = "Manual",
    Automatic = "Automatic",
}

export interface __BookingMessageDetails extends __BaseKey {
    created?: __BookingMessageEventDetails | undefined;
    updated?: __BookingMessageEventDetails | undefined;
    cancelled?: __BookingMessageEventDetails | undefined;
}

export interface __BookingMessageEventDetails extends __BaseKey {
    processHandling?: __ProcessHandlingType;
    completed?: boolean;
    completedBy?: string | undefined;
    completedOnDate?: DateTime | undefined;
}

export enum __ProcessHandlingType {
    None = "None",
    Automatic = "Automatic",
    Manual = "Manual",
}

export interface __BookingCustomer extends __BaseKey {
    legalName?: string | undefined;
    isCompany?: boolean;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    postalCode?: string | undefined;
    buildingNumber?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    customerId?: string | undefined;
    companyName?: string | undefined;
    cocNumber?: string | undefined;
    departmentName?: string | undefined;
    branchNumber?: string | undefined;
    vatNumber?: string | undefined;
    bankAccountNumber?: string | undefined;
    billingEmail?: string | undefined;
    isDirty?: boolean;
    addToCustomerSearchIndex?: boolean;
    emailMarketingSubscriptionIsActive?: boolean;
}

export interface __BookingParty extends __BaseKey {
    totalPersonCount?: number;
    minTotalPersonCount?: number;
    maxTotalPersonCount?: number;
    ageGroups?: __BookingPartyAgeGroup[] | undefined;
}

export interface __BookingPartyAgeGroup extends __BaseKey {
    orderIndex?: number;
    fromAge?: number;
    toAge?: number;
    ageGroupId?: string | undefined;
    count?: number;
    minCount?: number;
    maxCount?: number;
    unitPlural?: string | undefined;
    unitSingular?: string | undefined;
}

export interface __BookingProduct extends __BaseKey {
    name?: string | undefined;
    includedItemCount?: number;
    itemCount?: number;
    productId?: string | undefined;
    price?: number;
    listPrice?: number;
    totalPrice?: number;
    isProgramStep?: boolean;
    programStepId?: string | undefined;
}

export interface __BookingProgramStep extends __BaseKey {
    hasDynamicDuration?: boolean;
    resourceSelectionMode?: __ResourceSelectionMode;
    isCustom?: boolean;
    orderIndex?: number;
    capacityType?: __ResourceCapacityType;
    name?: string | undefined;
    duration?: Duration;
    addedDuration?: Duration | undefined;
    fromDate?: DateTime;
    programStepId?: string | undefined;
    bookingStepId?: string | undefined;
    programStepConfigId?: string | undefined;
    isProduct?: boolean;
    productId?: string | undefined;
    resourcesAutoSelect?: boolean;
    itemCountNeeded?: number;
    resources?: __BookingProgramStepResource[] | undefined;
    bookingParty?: __BookingParty | undefined;
}

export enum __ResourceSelectionMode {
    LeftToRightSequential = "LeftToRightSequential",
    RightToLeftSequential = "RightToLeftSequential",
    All = "All",
}

export enum __ResourceCapacityType {
    None = "None",
    PerItem = "PerItem",
    PerPerson = "PerPerson",
    PerPersonGroup = "PerPersonGroup",
    PerTable = "PerTable",
    PerLane = "PerLane",
    PerVehicle = "PerVehicle",
}

export interface __BookingProgramStepResource extends __BaseKey {
    name?: string | undefined;
    resourceId?: string | undefined;
    resourceBookingId?: string | undefined;
}

export interface __BookingPriceDetails {
    bookingPrice?: __BookingPrice | undefined;
    enginePrice?: __EnginePrice | undefined;
}

export interface __BookingPrice extends __BaseKey {
    priceLineItems?: __BookingPriceLineItem[] | undefined;
    discountCodeItems?: __BookingPriceLineItem[] | undefined;
    downPaymentRequired?: boolean;
    downPaymentPrice?: number;
    totalPrice?: number;
    finalPrice?: number;
    custom?: boolean;
}

export interface __BookingPriceLineItem extends __BaseKey {
    relatedObjectId?: string | undefined;
    relatedObjectType?: string | undefined;
    description?: string | undefined;
    unitName?: string | undefined;
    itemCount?: number;
    itemPrice?: number;
    itemPriceDescription?: string | undefined;
    totalPrice?: number;
    custom?: boolean;
    calculatedByEngine?: boolean;
    enginePriceResultItemId?: string | undefined;
    posArticle?: __PricePosArticle | undefined;
}

export interface __PricePosArticle extends __BaseKey {
    name?: string | undefined;
    raxArticleId?: string | undefined;
}

export interface __EnginePrice {
    resultItems?: __EnginePriceResultItem[] | undefined;
    totalPrice?: number;
    id?: string | undefined;
}

export interface __EnginePriceResultItem {
    id?: string | undefined;
    calculatedByEngine?: boolean;
    rateCardId?: string | undefined;
    programId?: string | undefined;
    programStepConfigId?: string | undefined;
    programStepId?: string | undefined;
    priceRuleDefinitionId?: string | undefined;
    productId?: string | undefined;
    title?: string | undefined;
    itemCount?: number;
    itemPrice?: number;
    itemPriceDescription?: string | undefined;
    totalPrice?: number;
    duration?: Duration | undefined;
    applyPricePerDuration?: boolean;
    priceIntervalDuration?: Duration | undefined;
    pricingType?: __RateCardPricingType;
    fromDate?: DateTime;
    priceLineDescription?: string | undefined;
    priceLineUnitName?: string | undefined;
    applyPricePerPersonCount?: boolean;
    minTotalPersonCount?: number;
    maxTotalPersonCount?: number;
    posArticle?: __PricePosArticle | undefined;
}

export enum __RateCardPricingType {
    PerPersonAgeGroup = "PerPersonAgeGroup",
    PerPerson = "PerPerson",
    PerGroup = "PerGroup",
    PerResource = "PerResource",
    PerItem = "PerItem",
    PerBooking = "PerBooking",
}

export enum __BookingStatus {
    Pending = "Pending",
    PendingApproval = "PendingApproval",
    Proposal = "Proposal",
    CancelledByCustomer = "CancelledByCustomer",
    CancelledBySeller = "CancelledBySeller",
    CancelledBySystem = "CancelledBySystem",
    Declined = "Declined",
    Accepted = "Accepted",
    NoShow = "NoShow",
    CheckedIn = "CheckedIn",
    CheckedOut = "CheckedOut",
}

export interface __BookingSurveyAnswer extends __BaseKey {
    answerType?: string | undefined;
    answerValues?: __BookingSurveyAnswerValue[] | undefined;
    customRemarks?: string | undefined;
    questionId?: string | undefined;
    questionLabel?: string | undefined;
}

export interface __BookingSurveyAnswerValue extends __BaseKey {
    answerBool?: boolean | undefined;
    answerLabel?: string | undefined;
    answerNumber?: number | undefined;
    answerText?: string | undefined;
}

export interface __BookingLeagueDetails extends __BaseKey {
    leagueId?: string | undefined;
    leagueName?: string | undefined;
    leagueSeasonId?: string | undefined;
    leagueSeasonName?: string | undefined;
    leagueMatchDateId?: string | undefined;
    leagueMatchDateName?: string | undefined;
    leagueTeamId?: string | undefined;
    leagueTeamName?: string | undefined;
    leagueTeamOrderIndex?: number;
}

export interface __GetBookingRefundProposalsForBookingQueryResult {
    bookingRefundProposals?: __GetBookingRefundProposalsForBookingQueryResultItem[] | undefined;
}

export interface __GetBookingRefundProposalsForBookingQueryResultItem {
    approvalDecisionBy?: string | undefined;
    approvalDecisionByAzureId?: string | undefined;
    approvalDecisionByRaxId?: string | undefined;
    approvedAtDateTime?: DateTime | undefined;
    bookingId?: string | undefined;
    bookingRefundProposalStatus?: __BookingRefundProposalStatus;
    createdBy?: string | undefined;
    createdByAzureId?: string | undefined;
    createdByRaxId?: string | undefined;
    createdOnDate?: DateTime;
    deleted?: boolean;
    deletedBy?: string | undefined;
    deletedByAzureId?: string | undefined;
    deletedByRaxId?: string | undefined;
    deletedOnDate?: DateTime | undefined;
    failedAtDateTime?: DateTime | undefined;
    failureReason?: string | undefined;
    id?: string | undefined;
    isApproved?: boolean;
    locationId?: string | undefined;
    metaData?: __GetBookingRefundProposalsForBookingQueryResultMetaData | undefined;
    partitionKey?: string | undefined;
    paymentServiceRefunds?: __GetBookingRefundProposalsForBookingQueryResultPaymentServiceRefund[] | undefined;
    raxVersion?: string | undefined;
    succeededAtDateTime?: DateTime | undefined;
    tenantId?: string | undefined;
    updateCorrelationId?: string | undefined;
    updatedBy?: string | undefined;
    updatedByAzureId?: string | undefined;
    updatedByRaxId?: string | undefined;
    updatedOnDate?: DateTime;
}

export enum __BookingRefundProposalStatus {
    PendingApproval = "PendingApproval",
    InProgress = "InProgress",
    Succeeded = "Succeeded",
    Failed = "Failed",
}

export interface __GetBookingRefundProposalsForBookingQueryResultMetaData {
    bookingRemainingRefundableAmountStamp?: number;
    bookingRequiredGrossAmountStamp?: number;
    totalRefundAmount?: number;
    id?: string | undefined;
}

export interface __GetBookingRefundProposalsForBookingQueryResultPaymentServiceRefund {
    amountToRefund?: number;
    paymentServiceProviderId?: string | undefined;
    id?: string | undefined;
}

export interface __BookingLedgerData extends __BaseCosmosData {
    requiredGrossAmount?: number;
    requiredDepositAmount?: number;
    isBookingV2?: boolean;
    moneyTransactions?: __BookingMoneyTransactionData[] | undefined;
    pendingMoneyTransactions?: __BookingPendingMoneyTransactionData[] | undefined;
    pendingApprovalBookingRefundProposals?: __BookingLedgerPendingApprovalBookingRefundProposalDetailsData[] | undefined;
    metaData?: __BookingLedgerMetaData | undefined;
    locationId?: string | undefined;
    tenantId?: string | undefined;
}

export interface __BookingMoneyTransactionData extends __BaseKey {
    moneyAmount?: number;
    description?: string | undefined;
    paymentServiceProviderId?: string | undefined;
    paymentId?: string | undefined;
    moneyAmountReceived?: number;
    refundId?: string | undefined;
    moneyAmountRefunded?: number;
    createdOnDateTime?: DateTime;
}

export interface __BookingPendingMoneyTransactionData extends __BaseKey {
    moneyAmount?: number;
    description?: string | undefined;
    paymentServiceProviderId?: string | undefined;
    paymentId?: string | undefined;
    moneyAmountToBeReceived?: number;
    refundId?: string | undefined;
    moneyAmountToBeRefunded?: number;
    createdOnDateTime?: DateTime;
}

export interface __BookingLedgerPendingApprovalBookingRefundProposalDetailsData extends __BaseKey {
    bookingRefundProposalId?: string | undefined;
    totalProposedRefundAmount?: number;
}

export interface __BookingLedgerMetaData extends __BaseKey {
    isUnpaid?: boolean;
    requiredDepositAmountIsPaid?: boolean;
    requiredDepositAmountIsPaidAfterPendingTransactions?: boolean;
    requiredGrossAmountIsPartiallyPaid?: boolean;
    requiredGrossAmountIsPartiallyPaidAfterPendingTransactions?: boolean;
    requiredGrossAmountIsPaid?: boolean;
    requiredGrossAmountIsPaidAfterPendingTransactions?: boolean;
    requiredGrossAmountIsOverpaid?: boolean;
    requiredGrossAmountIsOverpaidAfterPendingTransactions?: boolean;
    refundIsRequired?: boolean;
    outstandingBalanceAmountIsSettled?: boolean;
    pendingOutstandingBalanceAmountIsSettled?: boolean;
    remainingRefundableAmount?: number;
    remainingAmountOfRequiredGrossAmount?: number;
    overpaidAmountOfRequiredGrossAmount?: number;
    remainingAmountOfRequiredDepositAmount?: number;
    balanceAmount?: number;
    pendingBalanceAmount?: number;
    outstandingBalanceAmount?: number;
    pendingOutstandingBalanceAmount?: number;
    totalPendingAmount?: number;
    paymentServiceProviderIds?: string | undefined;
    hasPendingApprovalBookingRefundProposals?: boolean;
    paymentServiceProviders?: __BookingLedgerPaymentServiceProviderInfoMetaData[] | undefined;
}

export interface __BookingLedgerPaymentServiceProviderInfoMetaData extends __BaseKey {
    paymentServiceProviderId?: string | undefined;
    totalReceivedAmount?: number;
    totalRefundedAmount?: number;
    balanceAmount?: number;
    totalToBeReceivedAmount?: number;
    totalToBeRefundedAmount?: number;
    pendingBalanceAmount?: number;
    remainingRefundableAmount?: number;
}

export interface ResolveActivityBookingOptionsForDateQueryResult {
    bookingOptions?: ResolveActivityBookingOptionsForDateQueryResultBookingOption[];
}

export interface ResolveActivityBookingOptionsForDateQueryResultBookingOption {
    bookingOptionId?: string;
    startDateTime?: DateTime;
    endDateTime?: DateTime;
    occupancyEndDateTime?: DateTime;
    offeredUntilDateTime?: DateTime;
    duration?: Duration;
    isDefaultDuration?: boolean;
    isAvailable?: boolean;
    score?: number;
    totalPrice?: number | undefined;
    overlappingItinerarySegmentStepIds?: string[];
}

export interface ResolveActivityBookingOptionsForDateQuery {
    activityId?: string;
    arrivalDate?: DateTime;
    capacityInput?: ActivityCapacityInput;
    duration?: Duration | undefined;
    bookingSessionId?: string | undefined;
}

export interface ActivityCapacityInput {
    kind: string;
}

export interface ParticipantsActivityCapacityInput extends ActivityCapacityInput {
    participantsPerAgeGroup?: ParticipantCountPerAgeGroup[];
}

export interface ParticipantCountPerAgeGroup {
    ageGroupId?: string;
    participantCount?: number;
}

export interface ResourcesActivityCapacityInput extends ActivityCapacityInput {
    resourceCount?: number;
    participantsPerAgeGroup?: ParticipantCountPerAgeGroup[];
}

export interface GetOfferedActivityIdsForDateQueryResult {
    activityIds?: string[];
}

export interface GetOfferedActivityIdsForDateQuery {
    date?: DateTime;
}

export interface GetBookableArticleExtrasForSessionQueryResult {
    articleExtras?: GetBookableArticleExtrasForSessionQueryResultArticleExtra[];
}

export interface GetBookableArticleExtrasForSessionQueryResultArticleExtra {
    articleId?: string;
    name?: string;
    description?: string;
    itemPrice?: number;
}

export interface GetBookableArticleExtrasForSessionQuery {
    bookingSessionId?: string;
}

export interface GetActivityBookingOptionDetailsQueryResult {
    bookingOptionId?: string;
    activityId?: string;
    arrivalDate?: DateTime;
    startDateTime?: DateTime;
    endDateTime?: DateTime;
    occupancyEndDateTime?: DateTime;
    duration?: Duration;
    isAvailable?: boolean;
    score?: number;
    scoreFactors?: GetActivityBookingOptionDetailsQueryResultScoreFactor[];
    resources?: GetActivityBookingOptionDetailsQueryResultResourceAllocation[];
    priceIndication?: GetActivityBookingOptionDetailsQueryResultPriceIndication | undefined;
}

export interface GetActivityBookingOptionDetailsQueryResultScoreFactor {
    kind?: GetActivityBookingOptionDetailsQueryResultScoreFactorKind;
    count?: number;
}

export enum GetActivityBookingOptionDetailsQueryResultScoreFactorKind {
    AreaCrossing = "AreaCrossing",
    SectionCrossing = "SectionCrossing",
    Gap = "Gap",
    SplitLanePair = "SplitLanePair",
    Unavailable = "Unavailable",
    EmptySeat = "EmptySeat",
    MultipleTables = "MultipleTables",
    FreeSpot = "FreeSpot",
    FreeGroupSpot = "FreeGroupSpot",
    NoCapacity = "NoCapacity",
}

export interface GetActivityBookingOptionDetailsQueryResultResourceAllocation {
    resourceId?: string;
    areaId?: string;
    sectionId?: string;
    participants?: GetActivityBookingOptionDetailsQueryResultParticipantCount[];
}

export interface GetActivityBookingOptionDetailsQueryResultParticipantCount {
    ageGroupId?: string;
    participantCount?: number;
}

export interface GetActivityBookingOptionDetailsQueryResultPriceIndication {
    totalPrice?: number;
    lines?: GetActivityBookingOptionDetailsQueryResultPriceIndicationLine[];
}

export interface GetActivityBookingOptionDetailsQueryResultPriceIndicationLine {
    price?: number;
    quantity?: number;
    totalPrice?: number;
}

export interface GetActivityBookingOptionDetailsQuery {
    bookingOptionId?: string;
    activityId?: string;
    arrivalDate?: DateTime;
    capacityInput?: ActivityCapacityInput;
    start?: DateTime;
    duration?: Duration;
}

export interface GetAssortmentActivitiesQueryResult {
    activities?: GetAssortmentActivitiesActivityDto[];
}

export interface GetAssortmentActivitiesActivityDto {
    activityId?: string;
    name?: string;
    suitableAgeGroupIds?: string[];
    compatibleResourceTypeIds?: string[];
    resourceBasis?: AssortmentActivityResourceBasisDto | undefined;
    participantBasis?: AssortmentActivityParticipantBasisDto | undefined;
}

export interface AssortmentActivityResourceBasisDto {
    maxResourceCount?: number;
    participantsEntry?: ParticipantsEntryDto;
}

export interface AssortmentActivityParticipantBasisDto {
    countDetermination?: ActivityResourceCountDeterminationResponseDto;
}

export interface GetAssortmentActivitiesQuery {
}

export interface LookupBookingInfoQueryResult {
    booking?: LookupBookingInfoQueryResultBooking | undefined;
}

export interface LookupBookingInfoQueryResultBooking {
    bookingId?: string;
    tenantId?: string | undefined;
    tenantName?: string | undefined;
    tenantIdCode?: string | undefined;
    locationId?: string | undefined;
    locationName?: string | undefined;
    locationIdCode?: string | undefined;
    fromDate?: DateTime;
    bookingName?: string | undefined;
    customerName?: string | undefined;
}

export interface LookupBookingInfoQuery {
    bookingId?: string;
}

export interface SetMarketingLocationConfigCommand {
    formData?: MarketingLocationConfigFormData;
}

export interface MarketingLocationConfigFormData {
    customerSignUp?: MarketingLocationConfigFormDataCustomerSignUpDto;
}

export interface MarketingLocationConfigFormDataCustomerSignUpDto {
    isActive?: boolean;
    isApprovedByDefault?: boolean;
    requestSignUpText?: string;
}

export interface ResultV2DtoOfGetMarketingLocationConfigFormDataQueryResult extends ResultV2Dto {
    value?: GetMarketingLocationConfigFormDataQueryResult | undefined;
}

export interface GetMarketingLocationConfigFormDataQueryResult {
    formData?: MarketingLocationConfigFormData;
}

export interface GetMarketingLocationConfigFormDataQuery {
}

export interface ResultV2DtoOfGetMarketingLocationIntegrationsQueryResult extends ResultV2Dto {
    value?: GetMarketingLocationIntegrationsQueryResult | undefined;
}

export interface GetMarketingLocationIntegrationsQueryResult {
    integrations?: GetMarketingLocationIntegrationsQueryResultIntegrationDto[];
}

export interface GetMarketingLocationIntegrationsQueryResultIntegrationDto {
    marketingLocationIntegrationId?: string;
    marketingIntegrationId?: string;
    displayName?: string;
    isActive?: boolean;
}

export interface GetMarketingLocationIntegrationsQuery {
}

export interface ResultV2DtoOfGetAvailableMarketingIntegrationsForLocationQueryResult extends ResultV2Dto {
    value?: GetAvailableMarketingIntegrationsForLocationQueryResult | undefined;
}

export interface GetAvailableMarketingIntegrationsForLocationQueryResult {
    integrations?: GetAvailableMarketingIntegrationsForLocationQueryResultIntegrationDto[];
}

export interface GetAvailableMarketingIntegrationsForLocationQueryResultIntegrationDto {
    marketingIntegrationId?: string;
    displayName?: string;
}

export interface GetAvailableMarketingIntegrationsForLocationQuery {
}

export interface AddMarketingLocationIntegrationCommand {
    marketingIntegrationId?: string;
    displayName?: string;
}

export interface ShellView {
    debugMode?: boolean | undefined;
    devMode?: boolean | undefined;
    userAccount?: ShellViewUserAccount | undefined;
    featureFlags?: ShellViewFeatureFlags | undefined;
    scheduleBoards?: ShellViewScheduleBoards | undefined;
    multiTenant?: ShellViewMultiTenant | undefined;
    navConfig?: ShellViewNavConfig | undefined;
}

export interface ShellViewUserAccount {
    sysAdmin?: boolean;
    impersonation?: boolean;
    id?: string | undefined;
    displayName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    routeDefinition?: RouteDefinition | undefined;
    aliasPinConfirmationRequired?: boolean;
    aliases?: ShellUserAlias[] | undefined;
}

export interface RouteDefinition {
    path?: string | undefined;
}

export interface ShellUserAlias {
    id?: string | undefined;
    displayName?: string | undefined;
    email?: string | undefined;
    idCode?: string | undefined;
}

export interface ShellViewFeatureFlags {
    locations?: ShellViewFeatureFlagsLocation[] | undefined;
}

export interface ShellViewFeatureFlagsLocation {
    tenantIdCode?: string | undefined;
    tenantId?: string | undefined;
    locationIdCode?: string | undefined;
    locationId?: string | undefined;
    featureFlagKeys?: string[] | undefined;
}

export interface ShellViewScheduleBoards {
    locations?: ShellViewScheduleBoardsLocation[] | undefined;
}

export interface ShellViewScheduleBoardsLocation {
    tenantIdCode?: string | undefined;
    tenantId?: string | undefined;
    locationIdCode?: string | undefined;
    locationId?: string | undefined;
    boards?: ShellViewScheduleBoardsLocationBoard[] | undefined;
}

export interface ShellViewScheduleBoardsLocationBoard {
    scheduleBoardIdCode?: string | undefined;
    scheduleBoardId?: string | undefined;
}

export interface ShellViewMultiTenant {
    tenants?: ShellViewMultiTenantTenant[] | undefined;
    locations?: ShellViewMultiTenantLocation[] | undefined;
}

export interface ShellViewMultiTenantTenant {
    tenantIdCode?: string | undefined;
    tenantId?: string | undefined;
    tenantName?: string | undefined;
}

export interface ShellViewMultiTenantLocation {
    tenantIdCode?: string | undefined;
    tenantId?: string | undefined;
    tenantName?: string | undefined;
    locationIdCode?: string | undefined;
    locationId?: string | undefined;
    locationName?: string | undefined;
}

export interface ShellViewNavConfig {
    platform?: ShellViewNavConfigPlatform | undefined;
    tenants?: ShellViewNavConfigTenant[] | undefined;
    locations?: ShellViewNavConfigLocation[] | undefined;
}

export interface ShellViewNavConfigPlatform {
    platformNavItems?: ShellViewNavConfigNavItem[] | undefined;
}

export interface ShellViewNavConfigNavItem {
    path?: string | undefined;
    name?: string | undefined;
    icon?: string | undefined;
    subNavItems?: ShellViewNavConfigSubNavItem[] | undefined;
}

export interface ShellViewNavConfigSubNavItem {
    path?: string | undefined;
    name?: string | undefined;
    icon?: string | undefined;
}

export interface ShellViewNavConfigTenant {
    tenantIdCode?: string | undefined;
    tenantId?: string | undefined;
    tenantSettingsNavItem?: ShellViewNavConfigNavItem | undefined;
}

export interface ShellViewNavConfigLocation {
    tenantIdCode?: string | undefined;
    tenantId?: string | undefined;
    locationIdCode?: string | undefined;
    locationId?: string | undefined;
    locationSettingsNavItem?: ShellViewNavConfigNavItem | undefined;
    locationNavItems?: ShellViewNavConfigNavItemExtended[] | undefined;
}

export interface ShellViewNavConfigNavItemExtended {
    path?: string | undefined;
    name?: string | undefined;
    icon?: string | undefined;
    iconColor?: string | undefined;
    imgUrl?: string | undefined;
    subNavItems?: ShellViewNavConfigSubNavItemExtended[] | undefined;
}

export interface ShellViewNavConfigSubNavItemExtended {
    path?: string | undefined;
    name?: string | undefined;
    icon?: string | undefined;
    iconColor?: string | undefined;
}

export interface GetShellViewQuery {
    forMobile?: boolean;
}

export interface ShellViewLocation {
    id?: string | undefined;
    idCode?: string | undefined;
    name?: string | undefined;
    menuItems?: NavMenuItem[] | undefined;
    settingsMenuItem?: NavMenuItem | undefined;
    idCodes?: IdCodeId[] | undefined;
}

export interface NavItem {
    name?: string | undefined;
    routeDefinition?: RouteDefinition | undefined;
}

export interface NavMenuItem extends NavItem {
    orderIndex?: number;
    iconColor?: string | undefined;
    icon?: string | undefined;
    iconImg?: string | undefined;
    subMenuItems?: NavMenuItem[] | undefined;
    forNonAdminUser?: boolean;
}

export interface IdCodeId {
    idCode?: string | undefined;
    id?: string | undefined;
}

export interface GetShellViewLocationQuery {
    tenantId?: string | undefined;
    locationId?: string | undefined;
    forMobile?: boolean;
}

export interface BaseView {
    correlationId?: string | undefined;
    isDirty?: boolean;
}

export interface BaseDialogView extends BaseView {
    dialogTitle?: string | undefined;
}

export interface BookingStartStopOverviewDialogView extends BaseDialogView {
    fromDate?: DateTime;
    stopItems?: BookingStartStopOverviewItem[] | undefined;
    startItems?: BookingStartStopOverviewItem[] | undefined;
}

export interface BookingStartStopOverviewItem {
    bookingId?: string | undefined;
    orderIndex?: number;
    title?: string | undefined;
    resourceDescription?: string | undefined;
}

export interface GetBookingStartStopOverviewDialogViewQuery {
    scheduleBoardId?: string | undefined;
    capacityType?: ResourceCapacityType;
    fromDate?: DateTime;
    gridY?: number;
    intervalDuration?: Duration;
}

export interface GetGridBlockItemsResult {
    items?: ScheduleBoardBlockGridsterItem[] | undefined;
}

export interface GridsterItemPosition {
    x?: number;
    y?: number;
    cols?: number;
    rows?: number;
}

export interface GridsterItem extends GridsterItemPosition {
    id?: string | undefined;
    itemType?: string | undefined;
    dragEnabled?: boolean;
    resizeEnabled?: boolean;
}

export interface LayeredGridsterItem extends GridsterItem {
    layerIndex?: number | undefined;
}

export interface ScheduleBoardBlockGridsterItem extends LayeredGridsterItem {
    data?: ScheduleBoardBlockGridsterItemData | undefined;
}

export interface GridItemData {
    parentId?: string | undefined;
    linkedResourceBookings?: GridItemResourceBooking[] | undefined;
    title?: string | undefined;
    filterOut?: boolean;
    bgColor?: string | undefined;
    color?: string | undefined;
    selected?: boolean;
}

export interface ScheduleBoardBlockGridsterItemData extends GridItemData {
    personCount?: number;
    fromDate?: DateTime;
    toDate?: DateTime;
}

export interface GridItemResourceBooking {
    id?: string | undefined;
    resourceId?: string | undefined;
}

export interface GetGridBlockItemsQuery {
    scheduleBoardId?: string | undefined;
    capacityType?: ResourceCapacityType;
    fromDate?: DateTime;
    toDate?: DateTime;
}

export interface ScheduleBoardGridDataView extends BaseView {
    gridItems?: ScheduleBoardBookingGridsterItem[] | undefined;
    gridBlockItems?: ScheduleBoardBlockGridsterItem[] | undefined;
    openingHours?: ScheduleBoardOpeningHour[] | undefined;
}

export interface ScheduleBoardBookingGridsterItem extends LayeredGridsterItem {
    data?: ScheduleBoardBookingGridItemData | undefined;
}

export interface ScheduleBoardBookingGridItemData extends GridItemData {
    bookingId?: string | undefined;
    code?: string | undefined;
    customerId?: string | undefined;
    isCompany?: boolean;
    companyName?: string | undefined;
    departmentName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    programName?: string | undefined;
    programStepConfigId?: string | undefined;
    programStepId?: string | undefined;
    fromDate?: DateTime;
    toDate?: DateTime;
    couponCodes?: SelectListItem[] | undefined;
    bookingStatus?: BookingStatus;
    resourceBookingStatus?: ResourceBookingStatus;
    programBookingParty?: BookingParty | undefined;
    bookingParty?: BookingParty | undefined;
    isCustom?: boolean;
    hasMultipleProgramSteps?: boolean;
    programSteps?: GridBookingProgramStepDetails[] | undefined;
    products?: BookingProductDetails[] | undefined;
    hasNotes?: boolean;
    hasExtras?: boolean;
    surveyAnswers?: SurveyAnswer[] | undefined;
    originType?: BookingOriginType;
    leagueDetails?: BookingLeagueDetails | undefined;
    lockDetails?: BookingLockDetails | undefined;
    paymentDetails?: BookingPaymentGeneralInfo | undefined;
    bookingNotFound?: boolean;
    posDetails?: BookingPosDetails | undefined;
}

export interface SelectListItem {
    text?: string | undefined;
    objectType?: string | undefined;
    value?: string | undefined;
}

export enum ResourceBookingStatus {
    Temporary = "Temporary",
    Cancelled = "Cancelled",
    Booked = "Booked",
    Blocked = "Blocked",
}

export interface BookingParty {
    totalPersonCount?: number;
    minTotalPersonCount?: number;
    maxTotalPersonCount?: number;
    ageGroups?: BookingPartyAgeGroup[] | undefined;
}

export interface BookingPartyAgeGroup {
    _Selected?: boolean;
    ageGroupId?: string | undefined;
    fromAge?: number;
    toAge?: number;
    count?: number;
    unitPlural?: string | undefined;
    unitSingular?: string | undefined;
    maxCount?: number;
    minCount?: number;
    orderIndex?: number;
}

export interface GridBookingProgramStepDetails {
    currentStep?: boolean;
    fromDate?: DateTime;
    name?: string | undefined;
    isCustom?: boolean;
}

export interface BookingProductDetails {
    productId?: string | undefined;
    name?: string | undefined;
    itemCount?: number;
    price?: number | undefined;
    totalPrice?: number | undefined;
}

export interface SurveyAnswer {
    questionLabel?: string | undefined;
    questionId?: string | undefined;
    answerType?: string | undefined;
    answerValues?: SurveyAnswerValue[] | undefined;
    customRemarks?: string | undefined;
}

export interface SurveyAnswerValue {
    answerLabel?: string | undefined;
    answerBool?: boolean | undefined;
    answerText?: string | undefined;
    answerNumber?: number | undefined;
}

export interface BookingLeagueDetails {
    leagueId?: string | undefined;
    leagueName?: string | undefined;
    leagueSeasonId?: string | undefined;
    leagueSeasonName?: string | undefined;
    leagueMatchDateId?: string | undefined;
    leagueMatchDateName?: string | undefined;
    leagueTeamId?: string | undefined;
    leagueTeamName?: string | undefined;
    leagueTeamOrderIndex?: number;
}

export interface BookingLockDetails {
    locked?: boolean;
    lockReason?: string | undefined;
    lockUpdate?: boolean;
    lockCancel?: boolean;
    lockStatusChange?: boolean;
}

export interface BookingPaymentGeneralInfo {
    requiredGrossAmount?: number;
    remainingGrossAmount?: number;
    remainingRefundableAmount?: number;
    paymentBalance?: number;
    requiredDepositAmount?: number;
    bookingPaymentStatus?: BookingPaymentStatus;
    hasPendingApprovalBookingRefundProposals?: boolean;
}

export interface BookingPosDetails {
    inPos?: boolean;
    referenceText?: string | undefined;
}

export interface OpeningHour2 {
    active?: boolean;
    orderIndex?: number;
    dayIndex?: number;
    closed?: boolean;
    allDayOpen?: boolean;
    fromTime?: Duration;
    fromDayIndex?: number;
    toTime?: Duration;
    toDayIndex?: number;
    duration?: Duration;
}

export interface ScheduleBoardOpeningHour extends OpeningHour2 {
    id?: string | undefined;
}

export interface GetGridDataViewQuery {
    scheduleBoardId?: string | undefined;
    capacityType?: ResourceCapacityType;
    fromDate?: DateTime;
    toDate?: DateTime;
}

export interface GetGridsterItemsForBookingIdResult {
    items?: ScheduleBoardBookingGridsterItem[] | undefined;
}

export interface GetGridsterItemsForBookingIdQuery {
    scheduleBoardId?: string | undefined;
    capacityType?: ResourceCapacityType;
    fromDate?: DateTime;
    toDate?: DateTime;
    bookingId?: string | undefined;
}

export interface ScheduleBoardGridView extends BaseView {
    scheduleBoardId?: string | undefined;
    scheduleBoardName?: string | undefined;
    scheduleBoard?: ScheduleBoardItem | undefined;
    gridDataView?: ScheduleBoardGridDataView | undefined;
    rearrangeGridItems?: GridsterItem[] | undefined;
    rearrangeBlockGridItems?: LayeredGridsterItem[] | undefined;
    gridItemRearrangeActive?: boolean;
    gridBlockActive?: boolean;
    noteDataView?: ResultDataOfNotesDataView | undefined;
    bookingStatuses?: EnumOptionItem[] | undefined;
}

export interface LocationSettingsScheduleBoardEditItem {
    name?: string | undefined;
    description?: string | undefined;
    capacityType?: ResourceCapacityType;
    idCode?: string | undefined;
    navItemColor?: string | undefined;
    navItemIcon?: string | undefined;
    gridItemCodeTemplate?: string | undefined;
    dayStartTime?: Duration;
    dayDuration?: Duration;
    intervalDuration?: Duration;
    gridConfig?: ScheduleBoardGridConfig | undefined;
    gridTemplate?: ScheduleBoardGridTemplate | undefined;
    perPersonMinColumnCount?: number | undefined;
    perPersonMaxColumnCount?: number | undefined;
    defaultProgramGroupId?: string | undefined;
    defaultProgramId?: string | undefined;
}

export interface ScheduleBoardItem extends LocationSettingsScheduleBoardEditItem {
    gridColumnMaxCount?: number | undefined;
}

export interface ScheduleBoardGridConfig {
    highlightColumnRowForActiveScheduleBoardItem?: boolean;
    viewModeOptions?: ScheduleBoardGridViewModeOptions[] | undefined;
}

export interface ScheduleBoardGridViewModeOptions {
    viewId?: string | undefined;
    title?: string | undefined;
    fixedColWidth?: number;
    fixedRowHeight?: number;
    useTitleShort?: boolean;
    showIcons?: boolean;
    showFromTime?: boolean;
    showToTime?: boolean;
    showTitle?: boolean;
    showPersonCount?: boolean;
    showPrice?: boolean;
    showPosReference?: boolean;
    showGridItemCode?: boolean;
}

export interface ScheduleBoardGridTemplate {
    areaColumnHeaders?: ScheduleBoardAreaColumnHeader[] | undefined;
    timeRowHeaders?: ScheduleBoardTimeRowHeader[] | undefined;
    gridRowCount?: number;
    gridColumnCount?: number;
}

export interface ScheduleBoardAreaColumnHeader {
    orderIndex?: number;
    areaId?: string | undefined;
    title?: string | undefined;
    color?: string | undefined;
    bgColor?: string | undefined;
    highlight?: boolean;
    cssStyle?: string | undefined;
    resourceColumnHeaders?: ScheduleBoardResourceColumnHeader[] | undefined;
}

export interface ScheduleBoardResourceColumnHeader {
    orderIndex?: number;
    gridX?: number;
    resourceId?: string | undefined;
    title?: string | undefined;
    titleShort?: string | undefined;
    color?: string | undefined;
    bgColor?: string | undefined;
    emptyCellColor?: string | undefined;
    cssStyle?: string | undefined;
    highlight?: boolean;
}

export interface ScheduleBoardTimeRowHeader {
    gridY?: number;
    offsetTime?: Duration;
    offsetDays?: number;
    cssStyle?: string | undefined;
    title?: string | undefined;
    now?: boolean;
    openingHourOpen?: boolean;
    rowItemCount?: number;
    rowDetailCount?: number;
    isFullHour?: boolean;
    highlight?: boolean;
}

export interface ResultDataOfNotesDataView extends Result {
    data?: NotesDataView | undefined;
}

export interface NotesDataView extends BaseView {
    notes?: NoteDataItem[] | undefined;
}

export interface BaseListItem {
    id?: string | undefined;
}

export interface NoteDataItem extends BaseListItem {
    relatedObjects?: RelatedObjectItem[] | undefined;
    isTask?: boolean;
    title?: string | undefined;
    hasBodyValue?: boolean;
    hasDateValue?: boolean;
    fromDate?: DateTime;
    dueDate?: DateTime | undefined;
    dueDateExpired?: boolean;
    isCompleted?: boolean;
    completedOnDate?: DateTime | undefined;
}

export interface RelatedObjectItem {
    relatedObjectName?: string | undefined;
    relatedObjectId?: string | undefined;
    relatedObjectType?: string | undefined;
    relatedObjectActive?: boolean | undefined;
}

export interface GetGridViewQuery {
    scheduleBoardId?: string | undefined;
}

export interface ScheduleBoardBlockGridEditDialogView extends BaseDialogView {
    output?: ScheduleBoardBlockGridsterItem | undefined;
}

export interface ScheduleBoardBlockGridRequest {
    scheduleBoardId?: string | undefined;
    fromDate?: DateTime;
    toDate?: DateTime;
    gridBlockItems?: ScheduleBoardBlockGridsterItem[] | undefined;
}

export interface ScheduleBoardGridItemResourceBookingChangeRequest extends ScheduleBoardBlockGridRequest {
    changeDetails?: ScheduleBoardGridItemResourceBookingChangeDetails[] | undefined;
}

export interface ScheduleBoardGridItemResourceBookingChangeDetails {
    bookingId?: string | undefined;
    gridItemId?: string | undefined;
    newResourceBookings?: GridItemResourceBooking[] | undefined;
}

export interface CmsPageAddDialogView extends BaseDialogView {
    output?: CmsPagePostRequest | undefined;
    templates?: CmsPageTemplateItem[] | undefined;
}

export interface CmsPagePostRequest {
    name?: string | undefined;
    description?: string | undefined;
    label?: string | undefined;
    templateId?: string | undefined;
    contentTypeId?: string | undefined;
    contentTypeName?: string | undefined;
}

export interface CmsPageTemplateItem {
    templateId?: string | undefined;
    templateName?: string | undefined;
    templateLabel?: string | undefined;
    contentTypeId?: string | undefined;
    contentTypeName?: string | undefined;
}

export interface GetCmsPageAddDialogViewQuery {
}

export interface CmsPageEditItemContentView extends BaseView {
    cmsPageId?: string | undefined;
    cmsPageVersionId?: string | undefined;
    cmsPageVersionName?: string | undefined;
    template?: CmsPageTemplate | undefined;
    cmsSiteCss?: string | undefined;
    input?: CmsPageVersionEditItem | undefined;
    output?: CmsPageVersionEditItem | undefined;
}

export interface CmsPageTemplate {
    id?: string | undefined;
    name?: string | undefined;
    label?: string | undefined;
    templateParts?: CmsPageTemplatePart[] | undefined;
}

export interface CmsPageTemplatePart {
    trackingId?: string | undefined;
    offset?: number;
    partId?: string | undefined;
    orderIndex?: number;
    partName?: string | undefined;
    label?: string | undefined;
    fields?: CmsField[] | undefined;
    contentFields?: CmsContentItemField[] | undefined;
}

export interface CmsField {
    fieldId?: string | undefined;
    label?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    value?: string | undefined;
    fieldType?: string | undefined;
    fieldTypeSettingsJson?: string | undefined;
}

export interface CmsContentItemField {
    fieldId?: string | undefined;
    name?: string | undefined;
    contentPartId?: string | undefined;
    contentPartLabel?: string | undefined;
    multiple?: boolean;
    maxItems?: number;
    linkToPage?: boolean;
    contentItemLinks?: CmsContentItemLink[] | undefined;
}

export interface CmsContentItemLink {
    orderIndex?: number;
    linkTitle?: string | undefined;
    relatedObjectId?: string | undefined;
    relatedObjectType?: string | undefined;
    relatedObjectName?: string | undefined;
    contentItemId?: string | undefined;
    pageId?: string | undefined;
    pageName?: string | undefined;
    pageLabel?: string | undefined;
}

export interface CmsPageVersionEditItem {
    name?: string | undefined;
    fieldValues?: CmsFieldValue[] | undefined;
    contentFieldValues?: CmsContentItemFieldValue[] | undefined;
    metaPageTitle?: string | undefined;
    metaPageDescription?: string | undefined;
    metaPageDoNotIndexSearchEngines?: boolean;
}

export interface CmsFieldValue {
    fieldId?: string | undefined;
    fieldLabel?: string | undefined;
    fieldType?: string | undefined;
    partId?: string | undefined;
    partLabel?: string | undefined;
    value?: string | undefined;
}

export interface CmsContentItemFieldValue {
    contentItemFieldId?: string | undefined;
    contentItemFieldLabel?: string | undefined;
    contentItemFieldType?: string | undefined;
    templatePartId?: string | undefined;
    templatePartLabel?: string | undefined;
    contentPartId?: string | undefined;
    contentPartLabel?: string | undefined;
    contentItemLinks?: CmsContentItemLink[] | undefined;
}

export interface GetCmsPageEditItemContentViewQuery {
    cmsPageId?: string | undefined;
}

export interface CmsPageEditItemView extends BaseView {
    cmsPageId?: string | undefined;
    cmsPageName?: string | undefined;
    cmsTemplateName?: string | undefined;
    cmsContentTypeName?: string | undefined;
    input?: CmsPageEditItem | undefined;
    output?: CmsPageEditItem | undefined;
    navItems?: NavItem[] | undefined;
}

export interface CmsPageEditItem {
    name?: string | undefined;
    label?: string | undefined;
    description?: string | undefined;
    templateId?: string | undefined;
}

export interface GetCmsPageEditItemViewQuery {
    cmsPageId?: string | undefined;
}

export interface CmsPageListView extends BaseView {
    pages?: CmsPageListItem[] | undefined;
    contentTypePages?: CmsPageListItem[] | undefined;
}

export interface CmsPageListItem extends BaseListItem {
    name?: string | undefined;
    label?: string | undefined;
    templateName?: string | undefined;
    templateId?: string | undefined;
    contentTypeName?: string | undefined;
    relatedObjects?: CmsRelatedObjectItem[] | undefined;
}

export interface CmsRelatedObjectItem {
    relatedObjectName?: string | undefined;
    relatedObjectId?: string | undefined;
    relatedObjectType?: string | undefined;
}

export interface GetCmsPageListViewQuery {
}

export interface CmsPagePickerDialogView extends BaseDialogView {
    pages?: CmsPageLink[] | undefined;
}

export interface CmsPageLink {
    pageName?: string | undefined;
    pageId?: string | undefined;
    pageLabel?: string | undefined;
    contentItemLabel?: string | undefined;
    contentItemName?: string | undefined;
    contentItemId?: string | undefined;
    relatedObjectType?: string | undefined;
    relatedObjectId?: string | undefined;
    relatedObjectName?: string | undefined;
}

export interface GetCmsPagePickerDialogViewQuery {
}

export interface CustomSchemaDefinition {
    locationLiveUpdateMessage?: LocationLiveUpdateMessage | undefined;
    bookingChangedLocationLiveUpdateMessagePayload?: BookingChangedLocationLiveUpdateMessagePayload | undefined;
    noteChangedLocationLiveUpdateMessagePayload?: NoteChangedLocationLiveUpdateMessagePayload | undefined;
    bookedResourcesChangedLocationLiveUpdateMessagePayload?: BookedResourcesChangedLocationLiveUpdateMessagePayload | undefined;
    blockedResourcesChangedLocationLiveUpdateMessagePayload?: BlockedResourcesChangedLocationLiveUpdateMessagePayload | undefined;
    broadCastBookingChangedEvent?: BroadCastBookingChangedEvent | undefined;
    broadCastNoteChangedEvent?: BroadCastNoteChangedEvent | undefined;
    broadCastResourceBookingBlockedEvent?: BroadCastResourceBookingBlockedEvent | undefined;
    broadCastResourceBookingsChangedEvent?: BroadCastResourceBookingsChangedEvent | undefined;
    videoFileFieldType?: VideoFileFieldType | undefined;
    imageFileFieldType?: ImageFileFieldType | undefined;
    fileFieldType?: FileFieldType | undefined;
    textAreaFieldType?: TextAreaFieldType | undefined;
    textFieldType?: TextFieldType | undefined;
    numberFieldType?: NumberFieldType | undefined;
    boolFieldType?: BoolFieldType | undefined;
    colorFieldType?: ColorFieldType | undefined;
    dateFieldType?: DateFieldType | undefined;
    chipsFieldType?: ChipsFieldType | undefined;
    optionFieldType?: OptionFieldType | undefined;
    checkAnswerType?: CheckAnswerType | undefined;
    trueFalseAnswerType?: TrueFalseAnswerType | undefined;
    optionCountAnswerType?: OptionCountAnswerType | undefined;
    selectAnswerType?: SelectAnswerType | undefined;
    textAnswerType?: TextAnswerType | undefined;
    textAreaAnswerType?: TextAreaAnswerType | undefined;
    orderIndexChange?: OrderIndexChange | undefined;
    baseTreeNestedNode?: BaseTreeNestedNode | undefined;
    relatedObjectTypeDef?: RelatedObjectType;
}

export interface LocationLiveUpdateMessage {
    correlationId?: string | undefined;
    tenantId?: string;
    locationId?: string;
    locationMessageType?: string;
    payloadJsonData?: string | undefined;
}

export interface BookingChangedLocationLiveUpdateMessagePayload {
    bookingId?: string;
    bookingProposalId?: string;
    fromDate?: DateTime;
    toDate?: DateTime;
    createdOnDate?: DateTime;
    cancelledOnDate?: DateTime | undefined;
    actionType?: ResultActionType;
}

export interface NoteChangedLocationLiveUpdateMessagePayload {
    noteId?: string;
    relatedObjects?: RelatedObjectItem2[];
    fromDate?: DateTime;
    toDate?: DateTime;
}

export interface RelatedObjectItem2 extends BaseKey {
    relatedObjectName?: string | undefined;
    relatedObjectId?: string | undefined;
    relatedObjectType?: string | undefined;
    relatedObjectActive?: boolean | undefined;
}

export interface BookedResourcesChangedLocationLiveUpdateMessagePayload {
    fromDate?: DateTime;
    toDate?: DateTime;
    raxResourceIds?: string[];
}

export interface BlockedResourcesChangedLocationLiveUpdateMessagePayload {
    fromDate?: DateTime;
    toDate?: DateTime;
    raxResourceIds?: string[];
}

export interface BroadCastBookingChangedEvent {
    tenantId?: string | undefined;
    locationId?: string | undefined;
    correlationId?: string | undefined;
    bookingId?: string | undefined;
    bookingProposalId?: string | undefined;
    fromDate?: DateTime;
    toDate?: DateTime;
    createdOnDate?: DateTime;
    cancelledOnDate?: DateTime | undefined;
    actionType?: ResultActionType;
}

export interface BroadCastNoteChangedEvent {
    noteId?: string | undefined;
    locationId?: string | undefined;
    tenantId?: string | undefined;
    relatedObjects?: RelatedObjectItem2[] | undefined;
    fromDate?: DateTime;
    toDate?: DateTime;
}

export interface BroadCastResourceBookingBlockedEvent {
    tenantId?: string | undefined;
    locationId?: string | undefined;
    fromDate?: DateTime;
    toDate?: DateTime;
    raxResourceIds?: string[] | undefined;
}

export interface BroadCastResourceBookingsChangedEvent {
    tenantId?: string | undefined;
    locationId?: string | undefined;
    fromDate?: DateTime;
    toDate?: DateTime;
    raxResourceIds?: string[] | undefined;
}

export interface BaseDataJson {
}

export interface VideoFileFieldType extends BaseDataJson {
    allowedFileExtensions?: string | undefined;
    maxFileSize?: number;
    pixelHeight?: number;
    pixelWidth?: number;
}

export interface ImageFileFieldType extends BaseDataJson {
    allowedFileExtensions?: string | undefined;
    maxFileSize?: number;
    pixelHeight?: number;
    pixelWidth?: number;
}

export interface FileFieldType extends BaseDataJson {
    allowedFileExtensions?: string | undefined;
    maxFileSize?: number;
}

export interface TextAreaFieldType extends BaseDataJson {
    rows?: number;
    cols?: number;
    maxLength?: number;
    minLength?: number;
}

export interface TextFieldType extends BaseDataJson {
    maxLength?: number;
    minLength?: number;
}

export interface NumberFieldType extends BaseDataJson {
    max?: number;
    min?: number;
    step?: number;
}

export interface BoolFieldType extends BaseDataJson {
}

export interface ColorFieldType extends BaseDataJson {
}

export interface DateFieldType extends BaseDataJson {
}

export interface ChipsFieldType extends BaseDataJson {
    listDelimiter?: string | undefined;
}

export interface OptionFieldType extends BaseDataJson {
    options?: OptionFieldTypeOption[] | undefined;
    controlType?: string | undefined;
}

export interface OptionFieldTypeOption {
    name?: string | undefined;
    value?: string | undefined;
}

export interface CheckAnswerType extends BaseDataJson {
    label?: string | undefined;
}

export interface TrueFalseAnswerType extends BaseDataJson {
    trueLabel?: string | undefined;
    falseLabel?: string | undefined;
}

export interface OptionCountAnswerType extends BaseDataJson {
    countAnswerOptions?: CountAnswerOption[] | undefined;
}

export interface CountAnswerOption {
    label?: string | undefined;
    text?: string | undefined;
    count?: number;
}

export interface SelectAnswerType extends BaseDataJson {
    showAsDropdown?: boolean;
    allowMultiple?: boolean;
    answerOptions?: SelectAnswerOption[] | undefined;
}

export interface SelectAnswerOption {
    label?: string | undefined;
    text?: string | undefined;
}

export interface TextAnswerType extends BaseDataJson {
    maxLength?: number;
    minLength?: number;
}

export interface TextAreaAnswerType extends BaseDataJson {
    maxLength?: number;
    minLength?: number;
    rows?: number;
    cols?: number;
}

export interface OrderIndexChange {
    relatedObjectId?: string | undefined;
    relatedObjectType?: string | undefined;
    orderIndex?: number;
    newOrderIndex?: number;
}

export interface TreeNode {
    orderIndex?: number;
    id?: string | undefined;
    title?: string | undefined;
    type?: string | undefined;
    selected?: boolean | undefined;
}

export interface BaseTreeNestedNode extends TreeNode {
    data?: any | undefined;
    children?: BaseTreeNestedNode[] | undefined;
}

export enum RelatedObjectType {
    Tenant = "Tenant",
    Location = "Location",
    User = "User",
    Program = "Program",
    ProgramStep = "ProgramStep",
    ProgramGroup = "ProgramGroup",
    Product = "Product",
    RateCard = "RateCard",
    ScheduleBoard = "ScheduleBoard",
    Booking = "Booking",
    BookingProposal = "BookingProposal",
    NoteList = "NoteList",
    CouponCode = "CouponCode",
    League = "League",
    LeagueSeason = "LeagueSeason",
    Site = "Site",
}

export interface WebComponentsRegister {
    tabNavBar?: TabNavBarWebComponentDto;
}

export interface TabNavBarWebComponentDto {
    tabs?: TabNavBarWebComponentTabDto[];
}

export interface TabNavBarWebComponentTabDto {
    title?: string;
    routerLinkPath?: string;
}

export interface ResultV2DtoOfString extends ResultV2Dto {
    value?: string | undefined;
}

export interface ResultV2DtoOfPortalAppTestQueryResult extends ResultV2Dto {
    value?: PortalAppTestQueryResult | undefined;
}

export interface PortalAppTestQueryResult {
    tenantId?: string | undefined;
    locationId?: string | undefined;
    helloWorldResponseText?: string;
}

export interface ResultV2DtoOfBackendTestQueryResult extends ResultV2Dto {
    value?: BackendTestQueryResult | undefined;
}

export interface BackendTestQueryResult {
    tenantId?: string | undefined;
    locationId?: string | undefined;
    helloWorldResponseText?: string;
}

export interface ResultV2DtoOfGetResourceCategoriesQueryResult extends ResultV2Dto {
    value?: GetResourceCategoriesQueryResult | undefined;
}

export interface GetResourceCategoriesQueryResult {
    resourceCategories?: GetResourceCategoriesQueryResultCategoryDto[];
}

export interface GetResourceCategoriesQueryResultCategoryDto {
    resourceCategoryId?: string;
    name?: string;
}

export interface GetResourceCategoriesQuery {
}

export interface ResultV2DtoOfGetResourceCategoryFormDataQueryResult extends ResultV2Dto {
    value?: GetResourceCategoryFormDataQueryResult | undefined;
}

export interface GetResourceCategoryFormDataQueryResult {
    resourceCategoryId?: string;
    formData?: ResourceCategoryFormData;
}

export interface ResourceCategoryFormData {
    name?: string;
}

export interface GetResourceCategoryFormDataQuery {
    resourceCategoryId?: string;
}

export interface GetNewResourceCategoryFormDataQuery {
}

export interface AddResourceCategoryCommand {
    formData?: ResourceCategoryFormData;
}

export interface UpdateResourceCategoryCommand {
    resourceCategoryId?: string;
    formData?: ResourceCategoryFormData;
}

export interface RemoveResourceCategoryCommand {
    resourceCategoryId?: string;
}

export interface ResultV2DtoOfGetResourceTypesQueryResult extends ResultV2Dto {
    value?: GetResourceTypesQueryResult | undefined;
}

export interface GetResourceTypesQueryResult {
    resourceTypes?: GetResourceTypesQueryResultResourceTypeDto[];
}

export interface GetResourceTypesQueryResultResourceTypeDto {
    resourceTypeId?: string;
    resourceCapacityType?: ResourceCapacityType;
    name?: string;
    resourceDisplayName?: string;
    resourceDisplayNameShort?: string;
    resourceCategoryId?: string | undefined;
    resourceCategoryName?: string | undefined;
    resourcePersonCapacity?: GetResourceTypesQueryResultResourcePersonCapacityDto | undefined;
    resourcePersonStartCapacity?: GetResourceTypesQueryResultResourcePersonStartCapacityDto | undefined;
    resourcePerPersonStartIntervalConfig?: GetResourceTypesQueryResultResourcePerPersonStartIntervalConfigDto | undefined;
    resourcePersonGroupCapacity?: GetResourceTypesQueryResultResourcePersonGroupCapacityDto | undefined;
}

export interface GetResourceTypesQueryResultResourcePersonCapacityDto {
    minPersonCountAllowed?: number;
    maxPersonCountAllowed?: number;
}

export interface GetResourceTypesQueryResultResourcePersonStartCapacityDto {
    maxPersonCountAllowedToStartAtTheSameTime?: number;
}

export interface GetResourceTypesQueryResultResourcePerPersonStartIntervalConfigDto {
    startTimeIntervalDuration?: Duration;
    onlyBookStartTimeStartIntervalDuration?: boolean;
}

export interface GetResourceTypesQueryResultResourcePersonGroupCapacityDto {
    minPersonCountAllowedPerGroup?: number;
    maxPersonCountAllowedPerGroup?: number;
    maxGroupCountAllowedToStartAtTheSameTime?: number;
}

export interface GetResourceTypesQuery {
}

export interface ResultV2DtoOfGetResourceTypeFormDataQueryResult extends ResultV2Dto {
    value?: GetResourceTypeFormDataQueryResult | undefined;
}

export interface GetResourceTypeFormDataQueryResult {
    resourceTypeId?: string | undefined;
    formData?: ResourceTypeFormData;
    view?: ResourceTypeFormView;
}

export interface ResourceTypeFormData {
    resourceCapacityType?: ResourceCapacityType;
    name?: string;
    resourceDisplayName?: string;
    resourceDisplayNameShort?: string;
    resourceCategoryId?: string | undefined;
    resourcePersonCapacity?: ResourceTypeFormDataResourcePersonCapacityDto | undefined;
    resourcePersonStartCapacity?: ResourceTypeFormDataResourcePersonStartCapacityDto | undefined;
    resourcePerPersonStartIntervalConfig?: ResourceTypeFormDataResourcePerPersonStartIntervalConfigDto | undefined;
    resourcePersonGroupCapacity?: ResourceTypeFormDataResourcePersonGroupCapacityDto | undefined;
}

export interface ResourceTypeFormDataResourcePersonCapacityDto {
    minPersonCountAllowed?: number;
    maxPersonCountAllowed?: number;
}

export interface ResourceTypeFormDataResourcePersonStartCapacityDto {
    maxPersonCountAllowedToStartAtTheSameTime?: number;
}

export interface ResourceTypeFormDataResourcePerPersonStartIntervalConfigDto {
    startTimeIntervalDuration?: Duration;
    onlyBookStartTimeStartIntervalDuration?: boolean;
}

export interface ResourceTypeFormDataResourcePersonGroupCapacityDto {
    minPersonCountAllowedPerGroup?: number;
    maxPersonCountAllowedPerGroup?: number;
    maxGroupCountAllowedToStartAtTheSameTime?: number;
}

export interface ResourceTypeFormView {
    resourceCategories?: ResourceTypeFormViewResourceCategoryDto[];
    startTimeIntervalDurationOptions?: DurationOptions;
}

export interface ResourceTypeFormViewResourceCategoryDto {
    resourceCategoryId?: string;
    name?: string;
}

export interface GetResourceTypeFormDataQuery {
    resourceTypeId?: string;
}

export interface GetNewResourceTypeFormDataQuery {
}

export interface AddResourceTypeCommand {
    formData?: ResourceTypeFormData;
}

export interface UpdateResourceTypeCommand {
    resourceTypeId?: string;
    formData?: ResourceTypeFormData;
}

export interface RemoveResourceTypeCommand {
    resourceTypeId?: string;
}

export interface ResultV2DtoOfGetPeriodConfigurationWithPeriodInsertedQueryResult extends ResultV2Dto {
    value?: GetPeriodConfigurationWithPeriodInsertedQueryResult | undefined;
}

export interface GetPeriodConfigurationWithPeriodInsertedQueryResult {
    periodConfiguration?: PeriodConfigurationDto;
}

export interface PeriodConfigurationDto {
    periodConfigurationId?: string;
    periods?: PeriodConfigurationPeriodDto[];
}

export interface PeriodConfigurationPeriodDto {
    periodId?: string;
    name?: string;
    fromDateTime?: DateTime;
    toDateTime?: DateTime;
}

export interface GetPeriodConfigurationWithPeriodInsertedQuery {
    periodConfiguration?: PeriodConfigurationDto;
    periodToInsert?: PeriodConfigurationPeriodDto;
}

export interface ResultV2DtoOfGetPeriodConfigurationWithPeriodModifiedQueryResult extends ResultV2Dto {
    value?: GetPeriodConfigurationWithPeriodModifiedQueryResult | undefined;
}

export interface GetPeriodConfigurationWithPeriodModifiedQueryResult {
    periodConfiguration?: PeriodConfigurationDto;
}

export interface GetPeriodConfigurationWithPeriodModifiedQuery {
    periodConfiguration?: PeriodConfigurationDto;
    modifiedPeriod?: PeriodConfigurationPeriodDto;
}

export interface ResultV2DtoOfGetPeriodConfigurationWithPeriodRemovedAndGapFilledQueryResult extends ResultV2Dto {
    value?: GetPeriodConfigurationWithPeriodRemovedAndGapFilledQueryResult | undefined;
}

export interface GetPeriodConfigurationWithPeriodRemovedAndGapFilledQueryResult {
    periodConfiguration?: PeriodConfigurationDto;
}

export interface GetPeriodConfigurationWithPeriodRemovedAndGapFilledQuery {
    periodConfiguration?: PeriodConfigurationDto;
    periodIdToRemove?: string;
}

export interface ResultV2DtoOfCreateNewPaymentSettingsCommandResponse extends ResultV2Dto {
    value?: CreateNewPaymentSettingsCommandResponse | undefined;
}

export interface CreateNewPaymentSettingsCommandResponse {
    paymentSettingsId?: string;
}

export interface CreateNewPaymentSettingsCommand {
    formData?: NewLocationSettingsPaymentFormData;
}

export interface ResultV2DtoOfPatchPaymentSettingsCommandResponse extends ResultV2Dto {
    value?: PatchPaymentSettingsCommandResponse | undefined;
}

export interface PatchPaymentSettingsCommandResponse {
    paymentSettingsId?: string;
}

export interface PatchPaymentSettingsCommand {
    paymentSettingsId?: string;
    formData?: LocationSettingsPaymentFormData;
}

export interface ResultV2DtoOfCreateManualPaymentForBookingCommandResponse extends ResultV2Dto {
    value?: CreateManualPaymentForBookingCommandResponse | undefined;
}

export interface CreateManualPaymentForBookingCommandResponse {
    bookerPaymentId?: string;
}

export interface CreateManualPaymentForBookingCommand {
    bookingId?: string;
    amountToReceive?: number;
}

export interface ResultV2DtoOfCreateManualRefundForBookingCommandResponse extends ResultV2Dto {
    value?: CreateManualRefundForBookingCommandResponse | undefined;
}

export interface CreateManualRefundForBookingCommandResponse {
    bookerRefundId?: string;
}

export interface CreateManualRefundForBookingCommand {
    bookingId?: string;
    amountToRefund?: number;
}

export interface ResultV2DtoOfGetProgramStartDateTimesFilterDataQueryResult extends ResultV2Dto {
    value?: GetProgramStartDateTimesFilterDataQueryResult | undefined;
}

export interface GetProgramStartDateTimesFilterDataQueryResult {
    programId?: string;
    year?: number;
    month?: number;
    startTimeDurationOptions?: DurationOptions | undefined;
    dates?: ProgramStartDateTimeFilterDateDto[];
}

export interface ProgramStartDateTimeFilterDateDto {
    id?: string;
    date?: DateTime;
    hasStartDateTimes?: boolean;
    startDateTimes?: ProgramStartDateTimeFilterStartDateTimeDto[] | undefined;
}

export interface ProgramStartDateTimeFilterStartDateTimeDto {
    id?: string;
    startDateTime?: DateTime;
    startTime?: Duration;
}

export interface ResultV2DtoOfGetFileUriQueryResult extends ResultV2Dto {
    value?: GetFileUriQueryResult | undefined;
}

export interface GetFileUriQueryResult {
    fileUri?: string;
}

export interface SetFileUploadStatusCommand {
    fileId?: string;
    uploadStatus?: string;
}

export interface ResultV2DtoOfCreateNewFileForUploadCommandResponse extends ResultV2Dto {
    value?: CreateNewFileForUploadCommandResponse | undefined;
}

export interface CreateNewFileForUploadCommandResponse {
    fileId?: string;
    fileUploadUri?: string;
}

export interface CreateNewFileForUploadCommand {
    filename?: string;
    fileType?: string;
    fileSize?: number;
}

export interface ClearCachedCmsPagesDataForLocationCommand {
    tenantId?: string;
    locationId?: string;
}

export interface ClearCachedCmsSiteDataCommand {
    tenantId?: string;
    locationId?: string;
    siteId?: string;
}

export interface PatchOperation {
    op?: string | undefined;
    path?: string | undefined;
    from?: string | undefined;
    value?: any | undefined;
}

export interface ResultDataOfBookingLookupDialogView extends Result {
    data?: BookingLookupDialogView | undefined;
}

export interface BookingLookupDialogView extends BaseDialogView {
    tenantId?: string | undefined;
    locationId?: string | undefined;
    locationName?: string | undefined;
    searchQ?: string | undefined;
    lookupResults?: BookingLookupResultItem[] | undefined;
}

export interface BookingLookupResultItem {
    bookingId?: string | undefined;
    bookingCode?: string | undefined;
    fromDate?: DateTime;
    programName?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export interface ResultDataOfListOfBookingLookupResultItem extends Result {
    data?: BookingLookupResultItem[] | undefined;
}

export interface ResultDataOfListOfBookingCustomerDetails extends Result {
    data?: BookingCustomerDetails[] | undefined;
}

export interface BookingCustomerNameDetails {
    _FullName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isCompany?: boolean;
    companyName?: string | undefined;
    departmentName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface BookingCustomerDetails extends BookingCustomerNameDetails {
    customerId?: string | undefined;
    postalCode?: string | undefined;
    buildingNumber?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    cocNumber?: string | undefined;
    branchNumber?: string | undefined;
    vatNumber?: string | undefined;
    bankAccountNumber?: string | undefined;
    billingEmail?: string | undefined;
    emailMarketingSubscriptionIsActive?: boolean;
}

export interface ResultDataOfBookingDetailsDialogView extends Result {
    data?: BookingDetailsDialogView | undefined;
}

export interface BookingDetailsDialogView extends BaseDialogView {
    tenantId?: string | undefined;
    locationId?: string | undefined;
    locationAddress?: LocationAddress | undefined;
    booking?: BookingDetailsData | undefined;
    noteDataView?: ResultDataOfNotesDataView | undefined;
    changeBookingStatuses?: EnumOptionItem[] | undefined;
    allowProgramCancel?: boolean;
    allowStatusChange?: boolean;
    allowBookingChange?: boolean;
    allowEditBookingCustomer?: boolean;
    createdBy?: string | undefined;
    createdOnDate?: DateTime;
    updatedBy?: string | undefined;
    updatedOnDate?: DateTime;
}

export interface LocationAddress {
    name?: string | undefined;
    street?: string | undefined;
    buildingNumber?: string | undefined;
    buildingNumberSuffix?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
}

export interface BookingDetailsData {
    bookingId?: string | undefined;
    bookingCode?: string | undefined;
    bookingProposalId?: string | undefined;
    status?: BookingStatus;
    originType?: BookingOriginType;
    pendingBookingExpiresAtDateTime?: DateTime | undefined;
    program?: BookingDetailsProgram | undefined;
    customer?: BookingCustomerDetails | undefined;
    priceDetails?: BookingPriceDetails | undefined;
    surveyAnswers?: SurveyAnswer[] | undefined;
    products?: BookingProductDetails[] | undefined;
    paymentInfo?: BookingPaymentGeneralInfo | undefined;
    leagueDetails?: BookingLeagueDetails | undefined;
    lockDetails?: BookingLockDetails | undefined;
    posDetails?: BookingPosDetails | undefined;
}

export interface BookingDetailsProgram {
    programId?: string | undefined;
    programName?: string | undefined;
    fromDate?: DateTime;
    preProgramDuration?: Duration;
    toDate?: DateTime;
    bookingParty?: BookingParty | undefined;
    isCustom?: boolean;
    programSteps?: BookingDetailsProgramStep[] | undefined;
}

export interface BookingDetailsProgramStep {
    programStepConfigId?: string | undefined;
    programStepId?: string | undefined;
    orderIndex?: number;
    name?: string | undefined;
    duration?: Duration;
    addedDuration?: Duration | undefined;
    fromDate?: DateTime;
    isCustom?: boolean;
    bookingPartyCustom?: boolean;
    bookingParty?: BookingParty | undefined;
}

export interface BookingPriceDetails {
    booking?: BookingPrice | undefined;
    engine?: EnginePrice | undefined;
}

export interface BookingPrice {
    custom?: boolean;
    totalPrice?: number;
    finalPrice?: number;
    priceLineItems?: BookingPriceLineItem[] | undefined;
    discountCodeItems?: BookingPriceLineItem[] | undefined;
}

export interface BookingPriceLineItem {
    relatedObjectId?: string | undefined;
    relatedObjectType?: string | undefined;
    description?: string | undefined;
    unitName?: string | undefined;
    itemPrice?: number;
    itemPriceDescription?: string | undefined;
    itemCount?: number;
    totalPrice?: number;
    custom?: boolean;
    calculatedByEngine?: boolean;
    enginePriceResultItemId?: string | undefined;
    posArticle?: PricePosArticle | undefined;
}

export interface PricePosArticle {
    name?: string | undefined;
    raxArticleId?: string | undefined;
}

export interface EnginePrice {
    resultItems?: EnginePriceResultItem[] | undefined;
    totalPrice?: number;
    calculatedByEngine?: boolean;
}

export interface EnginePriceResultItem {
    id?: string | undefined;
    rateCardId?: string | undefined;
    priceRuleDefinitionId?: string | undefined;
    programId?: string | undefined;
    programStepConfigId?: string | undefined;
    programStepId?: string | undefined;
    productId?: string | undefined;
    title?: string | undefined;
    itemCount?: number;
    itemPrice?: number;
    itemPriceDescription?: string | undefined;
    totalPrice?: number;
    duration?: Duration | undefined;
    applyPricePerDuration?: boolean;
    priceIntervalDuration?: Duration | undefined;
    pricingType?: RateCardPricingType;
    calculatedByEngine?: boolean;
    fromDate?: DateTime;
    applyPricePerPersonCount?: boolean;
    minTotalPersonCount?: number;
    maxTotalPersonCount?: number;
    priceLineDescription?: string | undefined;
    priceLineUnitName?: string | undefined;
    posArticle?: PricePosArticle | undefined;
}

export interface ResultDataOfBookingCustomerEditDialogView extends Result {
    data?: BookingCustomerEditDialogView | undefined;
}

export interface BookingCustomerEditDialogView extends BaseDialogView {
    tenantId?: string | undefined;
    locationId?: string | undefined;
    customerId?: string | undefined;
    bookingId?: string | undefined;
    disablePostalCodeLookup?: boolean;
    input?: BookingCustomerDetails | undefined;
    output?: BookingCustomerDetails | undefined;
}

export interface ResultDataOfBookingPaymentLinkResponse extends Result {
    data?: BookingPaymentLinkResponse | undefined;
}

export interface BookingPaymentLinkResponse {
    paymentLinkUrl?: string | undefined;
    providerPaymentLinkId?: string | undefined;
    raxPaymentId?: string | undefined;
    bookingId?: string | undefined;
    paymentTransactionStatus?: PaymentTransactionStatus;
}

export interface BookingPaymentLinkRequest {
    bookingId?: string | undefined;
    amount?: number;
    description?: string | undefined;
    redirectBaseUrl?: string | undefined;
    siteId?: string | undefined;
    paymentSettingsId?: string | undefined;
}

export interface CancelBookingPortalRequest {
    correlationId?: string;
    bookingProposalId?: string | undefined;
    bookingId?: string | undefined;
    sendEmail?: boolean;
}

export interface BaseBookingPortalRequest {
    correlationId?: string;
    fromDate?: DateTime;
    toDate?: DateTime;
    programId?: string | undefined;
    bookingParty?: BookingParty | undefined;
    programName?: string | undefined;
    isCustom?: boolean;
    programSteps?: ProgramStepBookingRequest[] | undefined;
    products?: ProductBookingRequest[] | undefined;
    customer?: BookingCustomerDetails | undefined;
    customerIsDirty?: boolean;
    emailMarketingCustomerSignUpIsApproved?: boolean;
    price?: BookingPriceDetails | undefined;
    sendEmail?: boolean;
    confirmationHandling?: ProcessHandlingType;
    approvalRequired?: boolean;
    isDepositRequired?: boolean;
    requiredDepositAmount?: number;
    pendingBookingExpiresAfterTime?: Duration | undefined;
    surveyAnswers?: SurveyAnswer[] | undefined;
    couponCode?: string | undefined;
    bookingNotes?: NotePostRequest[] | undefined;
}

export interface CreateBookingPortalRequest extends BaseBookingPortalRequest {
    isProposal?: boolean;
    proposalExpiresAtDate?: DateTime;
    proposalName?: string | undefined;
    proposalRedirectUrl?: string | undefined;
}

export interface ProgramStepBookingRequest {
    isCustom?: boolean;
    name?: string | undefined;
    programStepId?: string | undefined;
    programStepConfigId?: string | undefined;
    isProduct?: boolean;
    productId?: string | undefined;
    fromDate?: DateTime;
    startTime?: Duration;
    bookingParty?: BookingParty | undefined;
    capacityType?: ResourceCapacityType;
    resourceSelectionMode?: ResourceSelectionMode;
    duration?: Duration;
    addedDuration?: Duration | undefined;
    resourcesAutoSelect?: boolean;
    resourceCountNeeded?: number;
    resources?: ProgramStepBookingRequestResource[] | undefined;
}

export interface ProgramStepBookingRequestResource {
    resourceId?: string | undefined;
}

export interface ProductBookingRequest {
    productId?: string | undefined;
    name?: string | undefined;
    itemCount?: number;
    price?: number;
    listPrice?: number;
    totalPrice?: number;
    isProgramStep?: boolean;
    programStepId?: string | undefined;
}

export interface NotePostRequest {
    relatedObjects?: RelatedObjectItem[] | undefined;
    title?: string | undefined;
    body?: string | undefined;
    hasDateValue?: boolean;
    hasBodyValue?: boolean;
    fromDate?: DateTime;
    toDate?: DateTime;
    isTask?: boolean;
    dueDate?: DateTime | undefined;
}

export interface UpdateBookingPortalRequest extends BaseBookingPortalRequest {
    bookingId?: string | undefined;
    currentStatus?: BookingStatus;
}

export interface ResultDataOfCouponValidationPortalResponse extends Result {
    data?: CouponValidationPortalResponse | undefined;
}

export interface CouponValidationPortalResponse {
    couponId?: string | undefined;
    code?: string | undefined;
    isValid?: boolean;
    status?: CouponStatus;
    rewardType?: CouponRewardType;
    rewardAmount?: number | undefined;
    minBookingAmount?: number | undefined;
    rewardPercentage?: number | undefined;
}

export enum CouponStatus {
    Valid = "Valid",
    Invalid = "Invalid",
    NotAvailable = "NotAvailable",
    NotValidForEntry = "NotValidForEntry",
    NotValidForBookingFromDate = "NotValidForBookingFromDate",
    NotValidForBookingFromTime = "NotValidForBookingFromTime",
    NotValidForBookingDayOfWeek = "NotValidForBookingDayOfWeek",
    NotValidForBookingRelatedObjects = "NotValidForBookingRelatedObjects",
    NotValidForMinBookingAmount = "NotValidForMinBookingAmount",
}

export interface CouponCodeBookingPortalInfo {
    isBookingUpdate?: boolean;
    bookingId?: string | undefined;
    fromDate?: DateTime;
    bookingAmount?: number;
    relatedObjects?: RelatedObjectItem[] | undefined;
}

export interface ResultDataOfRaxFormDialogView extends Result {
    data?: RaxFormDialogView | undefined;
}

export interface RaxFormPageView extends BaseView {
    formConfig?: RaxFormConfig | undefined;
    objectId?: string | undefined;
    objectTypeName?: string | undefined;
    input?: any | undefined;
    output?: any | undefined;
}

export interface RaxFormDialogView extends RaxFormPageView {
    dialogTitle?: string | undefined;
    actionType?: RaxFormDialogActionType;
    dialogPosition?: RaxFormDialogPosition | undefined;
    raxFormDialogSize?: RaxFormDialogSize;
    allowCloseOnEsc?: boolean;
}

export enum RaxFormDialogActionType {
    Patch = "Patch",
    Post = "Post",
    Return = "Return",
}

export enum RaxFormDialogPosition {
    Center = "Center",
    Left = "Left",
    Top = "Top",
    Right = "Right",
    Bottom = "Bottom",
}

export enum RaxFormDialogSize {
    Small = "Small",
    Large = "Large",
    FullScreen = "FullScreen",
}

export interface BookingRequestDialogDebugSettings {
    debugModeActive?: boolean;
    forceProgramAvailabilityCheck?: boolean;
    singleAvailabilityCheckFromDate?: boolean;
    enableNewPriceCalculator?: boolean;
}

export interface ResultDataOfBookingRequestDialogView extends Result {
    data?: BookingRequestDialogView | undefined;
}

export interface BaseStepperDialogView extends BaseDialogView {
    stepperActiveIndex?: number;
    stepperMaxIndex?: number;
    stepperActiveStepId?: string | undefined;
}

export interface BookingRequestDialogView extends BaseStepperDialogView {
    tenantId?: string | undefined;
    locationId?: string | undefined;
    locationAddress?: LocationAddress | undefined;
    debugSettings?: BookingRequestDialogDebugSettings | undefined;
    programStep?: BookingRequestDialogProgramStep | undefined;
    customerStep?: BookingRequestDialogCustomerStep | undefined;
    pricingStep?: BookingRequestDialogPricingStep | undefined;
    surveyStep?: BookingRequestDialogSurveyStep | undefined;
    finalizeStep?: BookingRequestDialogFinalizeStep | undefined;
}

export interface BaseStepperView {
    id?: string | undefined;
    tabTitle?: string | undefined;
    valid?: boolean;
    disabled?: boolean;
    isDirty?: boolean | undefined;
}

export interface BookingRequestDialogProgramStep extends BaseStepperView {
    panelGroup?: PanelGroup | undefined;
    selectedProgramIsDirty?: boolean;
    fromDate?: DateTime;
    startTime?: Duration;
    preProgramDuration?: Duration;
    fromDateDayIndex?: number;
    dateFilterActive?: boolean;
    programGroups?: NestedSelectListItemOfSelectListItem[] | undefined;
    selectedProgramGroup?: NestedSelectListItemOfSelectListItem | undefined;
    selectedProgramGroupIds?: string[] | undefined;
    selectedProgram?: SelectListItem | undefined;
    programStartDateTimesFilterDataQueryResult?: GetProgramStartDateTimesFilterDataQueryResult | undefined;
    programStartDateTimeFilterDate?: ProgramStartDateTimeFilterDateDto | undefined;
    selectedProgramIds?: string[] | undefined;
    skipProgramSelect?: boolean;
    programOptions?: ProgramBookingOptions | undefined;
    selectedProgramOptionsIsDirty?: boolean;
    programBookingAvailability?: ProgramBookingAvailabilityView | undefined;
    selectedProgramBookingAvailabilityOption?: ProgramBookingAvailabilityOption | undefined;
    programBookingAvailabilityLocked?: boolean;
}

export interface PanelGroup {
    panelActiveIndex?: number;
    panels?: Panel[] | undefined;
}

export interface Panel {
    title?: string | undefined;
    disabled?: boolean;
    valid?: boolean;
}

export interface NestedSelectListItemOfSelectListItem extends SelectListItem {
    childItems?: SelectListItem[] | undefined;
}

export interface ProgramBookingOptionsBase {
    startTime?: Duration;
    duration?: Duration;
    programId?: string | undefined;
    programName?: string | undefined;
    programSteps?: ProgramBookingProgramStepOptions[] | undefined;
}

export interface ProgramBookingOptions extends ProgramBookingOptionsBase {
    fromDate?: DateTime;
    allowCustomSteps?: boolean;
    addCustomStepsEnabled?: boolean;
    bookingParty?: BookingParty | undefined;
    productProgramSteps?: ProgramBookingProductOptions[] | undefined;
    products?: ProgramBookingProductOptions[] | undefined;
    surveyQuestions?: SurveyQuestion[] | undefined;
}

export interface ProgramBookingProduct {
    productId?: string | undefined;
    name?: string | undefined;
    unitSingular?: string | undefined;
    unitPlural?: string | undefined;
    description?: string | undefined;
    itemCount?: number;
    price?: number;
    listPrice?: number;
    totalPrice?: number;
    posArticle?: PricePosArticle | undefined;
    pricingType?: ProductPricingType;
    isProgramStep?: boolean;
    programStepOptions?: ProgramBookingProgramStepOptions | undefined;
}

export interface ProgramBookingProductOptions extends ProgramBookingProduct {
    active?: boolean;
    bookingPartyEnabled?: boolean;
    bookingParty?: BookingParty | undefined;
}

export interface ProgramBookingProgramStepOptions {
    id?: string | undefined;
    isCustom?: boolean;
    allowDynamicDuration?: boolean;
    hasDynamicDuration?: boolean;
    programStepConfigId?: string | undefined;
    programStepId?: string | undefined;
    programStepName?: string | undefined;
    isProduct?: boolean;
    productId?: string | undefined;
    unitId?: string | undefined;
    unitPlural?: string | undefined;
    unitSingular?: string | undefined;
    fromDate?: DateTime;
    startTime?: Duration;
    itemCountNeeded?: number;
    itemCountOptions?: number[] | undefined;
    itemCountMax?: number;
    itemCountMin?: number;
    duration?: Duration;
    minDuration?: Duration | undefined;
    maxDuration?: Duration | undefined;
    durationOptions?: DurationOptions | undefined;
    addedDuration?: Duration | undefined;
    startIntervalDuration?: Duration;
    capacityType?: ResourceCapacityType;
    resourceSelectionMode?: ResourceSelectionMode;
    resources?: ProgramBookingProgramStepResourceOption[] | undefined;
    bookingPartyMatch?: boolean;
    bookingPartyCustom?: boolean;
    bookingParty?: BookingParty | undefined;
    surveyQuestionIds?: string[] | undefined;
    resourceCapacityConfig?: ProgramBookingProgramStepResourceCapacityConfig | undefined;
}

export interface ProgramBookingProgramStepResourceOption {
    resourceId?: string | undefined;
}

export interface ProgramBookingProgramStepResourceCapacityConfig {
    resourceCount?: number;
    resourcePersonCapacityMin?: number | undefined;
    resourcePersonCapacityMax?: number | undefined;
    resourcePersonCapacityStartMax?: number | undefined;
    personCapacityMin?: number | undefined;
    personCapacityMax?: number | undefined;
    personCapacityStartMax?: number | undefined;
    resourceGroupCapacityMin?: number | undefined;
    resourceGroupCapacityMax?: number | undefined;
    resourceGroupCapacityStartMax?: number | undefined;
    groupCapacityMin?: number | undefined;
    groupCapacityMax?: number | undefined;
    groupCapacityStartMax?: number | undefined;
    resourceStartIntervalDuration?: Duration | undefined;
    resourceBookStartIntervalDurationTimeOnly?: boolean;
}

export interface SurveyQuestion {
    questionId?: string | undefined;
    text?: string | undefined;
    label?: string | undefined;
    description?: string | undefined;
    forPublicUse?: boolean;
    forInternalUse?: boolean;
    required?: boolean;
    answerType?: string | undefined;
    answerTypeJson?: string | undefined;
    answer?: SurveyAnswer | undefined;
    allowCustomRemarks?: boolean;
}

export interface ProgramBookingAvailabilityView extends BaseView {
    selectedProgramAvailabilityOptionId?: string | undefined;
    programAvailabilityOptions?: ProgramBookingAvailabilityOption[] | undefined;
}

export interface ProgramBookingAvailabilityOption {
    isCustom?: boolean;
    isMatch?: boolean;
    isAvailable?: boolean;
    isStartTimeAvailable?: boolean;
    hasPriceWarning?: boolean;
    id?: string | undefined;
    programName?: string | undefined;
    programId?: string | undefined;
    fromDate?: DateTime;
    toDate?: DateTime;
    price?: BookingPriceDetails | undefined;
    score?: number;
    scoreDescription?: string | undefined;
    aggregateScore?: number;
    products?: ProgramBookingProduct[] | undefined;
    programStepAvailabilityOptions?: BookingProgramStepAvailabilityOption[] | undefined;
}

export interface BookingProgramStepAvailabilityOption {
    isAvailable?: boolean;
    isCustom?: boolean;
    hasDynamicDuration?: boolean;
    skip?: boolean;
    programStepConfigId?: string | undefined;
    programStepId?: string | undefined;
    programStepName?: string | undefined;
    isProduct?: boolean;
    productId?: string | undefined;
    unitId?: string | undefined;
    unitSingular?: string | undefined;
    unitPlural?: string | undefined;
    capacityType?: ResourceCapacityType;
    resourceSelectionMode?: ResourceSelectionMode;
    fromDate?: DateTime;
    duration?: Duration;
    addedDuration?: Duration | undefined;
    totalDuration?: Duration;
    selectedResourceOption?: BookingProgramStepResourceAvailabilityOption | undefined;
    resourceOptions?: BookingProgramStepResourceAvailabilityOption[] | undefined;
    score?: number;
    scoreDescription?: string | undefined;
}

export interface BookingProgramStepResourceAvailabilityOption {
    id?: string | undefined;
    title?: string | undefined;
    autoSelect?: boolean;
    resources?: BookingProgramStepResource[] | undefined;
    score?: number;
    scoreDescription?: string | undefined;
    areaDescription?: string | undefined;
}

export interface BookingProgramStepResource {
    resourceId?: string | undefined;
    resourceName?: string | undefined;
    resourceNameShort?: string | undefined;
}

export interface BookingRequestDialogCustomerStep extends BaseStepperView {
    customer?: BookingCustomerDetails | undefined;
    disablePostalCodeLookup?: boolean;
    emailMarketingCustomerSignUpIsApproved?: boolean;
    emailMarketingCustomerSignUpIsEnabled?: boolean;
    emailMarketingCustomerRequestSignUpText?: string | undefined;
}

export interface BookingRequestDialogPricingStep extends BaseStepperView {
    priceDetails?: BookingPriceDetails | undefined;
    couponValidationResponse?: CouponValidationPortalResponse | undefined;
    couponCode?: string | undefined;
}

export interface BookingRequestDialogSurveyStep extends BaseStepperView {
    surveyQuestions?: SurveyQuestion[] | undefined;
}

export interface BookingRequestDialogFinalizeStep extends BaseStepperView {
    isProposal?: boolean;
    proposalName?: string | undefined;
    proposalExpiresAtDate?: DateTime;
    proposalRedirectUrl?: string | undefined;
    proposalRedirectUrls?: SelectListItem[] | undefined;
    bookingNotes?: NotePostRequest[] | undefined;
    confirmationHandling?: ProcessHandlingType;
    approvalActive?: boolean;
    approvalMinimumAmount?: number;
    manualEmailConfirmation?: boolean;
    manualEmailConfirmationMinimumAmount?: number;
    isDepositFeatureActive?: boolean;
    isDepositRequired?: boolean;
    requiredDepositAmount?: number;
    defaultDepositRequiredPercentageOfBookingFinalPrice?: number;
    plannerPendingBookingExpiresAfterTime?: Duration;
}

export interface BookingRequestDialogOptions {
    fromDate?: DateTime | undefined;
    scheduleBoardId?: string | undefined;
    isProposal?: boolean;
}

export interface ResultDataOfProgramBookingProgramStepPickerDialogView extends Result {
    data?: ProgramBookingProgramStepPickerDialogView | undefined;
}

export interface ProgramBookingProgramStepPickerDialogView extends BaseDialogView {
    programSteps?: ProgramBookingProgramStepPickerItem[] | undefined;
}

export interface ProgramBookingProgramStepPickerItem {
    programStepId?: string | undefined;
    programStepName?: string | undefined;
    programStep?: ProgramBookingProgramStepOptions | undefined;
    surveyQuestions?: SurveyQuestion[] | undefined;
}

export interface ResultDataOfBookingRequestChangeDialogView extends Result {
    data?: BookingRequestChangeDialogView | undefined;
}

export interface BookingRequestChangeDialogView extends BookingRequestDialogView {
    allowQuickSave?: boolean;
    booking?: BookingDetailsData | undefined;
}

export interface ProgramStepMoveRequest {
    bookingId?: string | undefined;
    programStepId?: string | undefined;
    programStepConfigId?: string | undefined;
    duration?: Duration;
    fromDate?: DateTime;
    name?: string | undefined;
    resources?: ProgramStepMoveResource[] | undefined;
}

export interface ProgramStepMoveResource {
    resourceId?: string | undefined;
}

export interface ResultDataOfProgramAvailabilityInfo extends Result {
    data?: ProgramAvailabilityInfo | undefined;
}

export interface ProgramAvailabilityInfo {
    programId?: string | undefined;
    programName?: string | undefined;
    fromDate?: DateTime | undefined;
    toDate?: DateTime | undefined;
    days?: ProgramDayAvailabilityInfo[] | undefined;
    startTimeOptions?: DurationOptions | undefined;
    startTimeIntervalDuration?: Duration;
}

export interface ProgramDayAvailabilityInfo {
    dayIndex?: number;
    available?: boolean;
    customStartTimes?: boolean;
    startTimes?: ProgramDayStartTimeAvailabilityInfo[] | undefined;
}

export interface ProgramDayStartTimeAvailabilityInfo {
    id?: string | undefined;
    fromTime?: Duration;
}

export interface ResultDataOfProgramBookingOptions extends Result {
    data?: ProgramBookingOptions | undefined;
}

export interface ResultDataOfProgramBookingAvailabilityView extends Result {
    data?: ProgramBookingAvailabilityView | undefined;
}

export interface ProgramAvailabilityRequest {
    debugSettings?: BookingRequestDialogDebugSettings | undefined;
    isCustom?: boolean;
    fromDate?: DateTime;
    programName?: string | undefined;
    programId?: string | undefined;
    bookingId?: string | undefined;
    bookingParty?: BookingParty | undefined;
    programSteps?: ProgramAvailabilityPortalRequestProgramStep[] | undefined;
    products?: ProgramBookingProduct[] | undefined;
}

export interface ProgramAvailabilityPortalRequestProgramStep {
    isCustom?: boolean;
    hasDynamicDuration?: boolean;
    programStepName?: string | undefined;
    programStepConfigId?: string | undefined;
    programStepId?: string | undefined;
    isProduct?: boolean;
    productId?: string | undefined;
    unitId?: string | undefined;
    unitSingular?: string | undefined;
    unitPlural?: string | undefined;
    bookingParty?: BookingParty | undefined;
    fromDate?: DateTime;
    startTime?: Duration;
    itemCountNeeded?: number;
    minItemCountNeeded?: number;
    duration?: Duration;
    minDuration?: Duration | undefined;
    maxDuration?: Duration | undefined;
    addedDuration?: Duration | undefined;
    capacityType?: ResourceCapacityType;
    resourceSelectionMode?: ResourceSelectionMode;
    resources?: ProgramStepAvailabilityPortalRequestResource[] | undefined;
}

export interface ProgramStepAvailabilityPortalRequestResource {
    resourceId?: string | undefined;
}

export interface PatchObject {
    relatedObjectId?: string | undefined;
    relatedObjectType?: string | undefined;
    operations?: PatchOperation[] | undefined;
}

export interface ResultDataOfBookingProposalListView extends Result {
    data?: BookingProposalListView | undefined;
}

export interface BookingProposalListView extends BaseView {
    bookingProposals?: BookingProposalListItem[] | undefined;
}

export interface BookingProposalListItem extends BaseListItem {
    bookingProposalId?: string | undefined;
    bookingId?: string | undefined;
    name?: string | undefined;
    status?: BookingProposalStatus;
    expiresAtDate?: DateTime;
    expiresAtDateAgoText?: string | undefined;
    bookingFromDate?: DateTime;
    bookingProgramName?: string | undefined;
    customerIsCompany?: boolean;
    customerFirstName?: string | undefined;
    customerLastName?: string | undefined;
    customerEmail?: string | undefined;
    customerPhoneNumber?: string | undefined;
    customerDepartmentName?: string | undefined;
    customerCompanyName?: string | undefined;
    finalPrice?: number;
}

export enum BookingProposalStatus {
    Init = "Init",
    Pending = "Pending",
    CancelledByCustomer = "CancelledByCustomer",
    CancelledBySeller = "CancelledBySeller",
    CancelledBySystem = "CancelledBySystem",
    Declined = "Declined",
    Accepted = "Accepted",
    Expired = "Expired",
}

export interface ResultDataOfBookingProposalListItem extends Result {
    data?: BookingProposalListItem | undefined;
}

export interface ResultDataOfBookingProposalEditItemView extends Result {
    data?: BookingProposalEditItemView | undefined;
}

export interface BookingProposalEditItemView extends BaseView {
    bookingProposalId?: string | undefined;
    bookingProposalName?: string | undefined;
    input?: BookingProposalEditItem | undefined;
    output?: BookingProposalEditItem | undefined;
    expiresAtDateAgoText?: string | undefined;
    allowStatusChange?: boolean;
    allowBookingChange?: boolean;
    booking?: BookingDetailsData | undefined;
    locationAddress?: LocationAddress | undefined;
    statusChangeRequest?: BookingProposalStatusChangeRequest | undefined;
    noteDataView?: ResultDataOfNotesDataView | undefined;
    navItems?: NavItem[] | undefined;
}

export interface BookingProposalEditItem {
    name?: string | undefined;
    expiresAtDate?: DateTime;
    status?: BookingProposalStatus;
    redirectUrl?: string | undefined;
}

export interface BookingProposalStatusChangeRequest {
    bookingProposalId?: string | undefined;
    bookingId?: string | undefined;
    bookingProposalStatus?: BookingProposalStatus;
    noteText?: string | undefined;
}

export interface ResultDataOfBookingProposalEditItem extends Result {
    data?: BookingProposalEditItem | undefined;
}

export interface CmsContentItemPostRequest {
    label?: string | undefined;
    relatedObjectName?: string | undefined;
    relatedObjectType?: string | undefined;
    relatedObjectId?: string | undefined;
    contentTypeId?: string | undefined;
}

export interface CmsContentPartPostRequest {
    label?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
}

export interface ResultDataOfCmsContentPartAddDialogView extends Result {
    data?: CmsContentPartAddDialogView | undefined;
}

export interface CmsContentPartAddDialogView extends BaseDialogView {
    output?: CmsContentPartPostRequest | undefined;
}

export interface CmsContentTypePostRequest {
    name?: string | undefined;
    description?: string | undefined;
    label?: string | undefined;
    relatedObjectType?: string | undefined;
}

export interface ResultDataOfCmsContentTypeAddDialogView extends Result {
    data?: CmsContentTypeAddDialogView | undefined;
}

export interface CmsContentTypeAddDialogView extends BaseDialogView {
    output?: CmsContentTypePostRequest | undefined;
    objectTypes?: SelectListItem[] | undefined;
}

export interface ResultDataOfCmsFieldEditDialogView extends Result {
    data?: CmsFieldEditDialogView | undefined;
}

export interface CmsFieldEditDialogView extends BaseDialogView {
    output?: CmsField | undefined;
    fieldTypes?: CmsField[] | undefined;
    isEdit?: boolean;
}

export interface CmsSiteCheckOutPostRequest {
    name?: string | undefined;
    description?: string | undefined;
}

export interface ResultDataOfCmsSiteCheckOutAddDialogView extends Result {
    data?: CmsSiteCheckOutAddDialogView | undefined;
}

export interface CmsSiteCheckOutAddDialogView extends BaseDialogView {
    output?: CmsSiteCheckOutPostRequest | undefined;
}

export interface CmsSitePostRequest {
    name?: string | undefined;
    description?: string | undefined;
    isMultilingual?: boolean;
}

export interface ResultDataOfCmsSiteAddDialogView extends Result {
    data?: CmsSiteAddDialogView | undefined;
}

export interface CmsSiteAddDialogView extends BaseDialogView {
    output?: CmsSitePostRequest | undefined;
}

export interface ResultDataOfString extends Result {
    data?: string | undefined;
}

export interface CmsSiteThemePostRequest {
    name?: string | undefined;
    description?: string | undefined;
}

export interface ResultDataOfCmsSiteThemeAddDialogView extends Result {
    data?: CmsSiteThemeAddDialogView | undefined;
}

export interface CmsSiteThemeAddDialogView extends BaseDialogView {
    output?: CmsSiteThemePostRequest | undefined;
}

export interface ResultDataOfCmsStyleScriptTagSourceAddDialogView extends Result {
    data?: CmsStyleScriptTagSourceAddDialogView | undefined;
}

export interface CmsStyleScriptTagSourceAddDialogView extends BaseDialogView {
    output?: CmsStyleScriptTagSrc | undefined;
}

export interface CmsStyleScriptTagSrc {
    src?: string | undefined;
    name?: string | undefined;
}

export interface ResultDataOfCmsStyleFontAddDialogView extends Result {
    data?: CmsStyleFontAddDialogView | undefined;
}

export interface CmsStyleFontAddDialogView extends BaseDialogView {
    output?: CmsStyleFont | undefined;
}

export interface CmsStyleFont {
    url?: string | undefined;
    fontFamily?: string | undefined;
}

export interface ResultDataOfCmsStyleVariableAddDialogView extends Result {
    data?: CmsStyleVariableAddDialogView | undefined;
}

export interface CmsStyleVariableAddDialogView extends BaseDialogView {
    output?: CmsStyleVariable | undefined;
}

export interface CmsStyleVariable {
    key?: string | undefined;
    value?: string | undefined;
}

export interface CmsTemplatePostRequest {
    name?: string | undefined;
    label?: string | undefined;
    description?: string | undefined;
    contentTypeId?: string | undefined;
    contentTypeName?: string | undefined;
}

export interface CmsTemplatePartPostRequest {
    name?: string | undefined;
    description?: string | undefined;
    label?: string | undefined;
}

export interface CouponCampaignPostRequest {
    name?: string | undefined;
    couponRewardType?: CouponRewardType;
    validForEntryFromDate?: DateTime | undefined;
    validForEntryToDate?: DateTime | undefined;
    validForBookingFromDate?: DateTime | undefined;
    validForBookingToDate?: DateTime | undefined;
    validForBookingFromTime?: Duration | undefined;
    validForBookingToTime?: Duration | undefined;
    relatedObjects?: RelatedObjectItem[] | undefined;
    autoGenerateCodes?: boolean;
    couponCodePrefix?: string | undefined;
    couponCount?: number;
    couponCodeLength?: number;
    couponRewardAmount?: number | undefined;
    couponRewardPercentage?: number | undefined;
    maxUsedCount?: number;
    minBookingAmount?: number | undefined;
    days?: DayOfWeekFilter[] | undefined;
    description?: string | undefined;
}

export interface DayOfWeekFilter {
    isActive?: boolean;
    dayIndex?: number;
    dayOfWeek?: DayOfWeek;
}

export interface ResultDataOfRaxFormPageView extends Result {
    data?: RaxFormPageView | undefined;
}

export interface HelloWorldTimeModel {
    helloWorldTime?: Duration;
}

export interface EmailTemplatePostRequest {
    name?: string | undefined;
    description?: string | undefined;
    relatedObjectType?: string | undefined;
}

export interface ResultDataOfEmailTemplateAddDialogView extends Result {
    data?: EmailTemplateAddDialogView | undefined;
}

export interface EmailTemplateAddDialogView extends BaseDialogView {
    output?: EmailTemplatePostRequest | undefined;
    relatedObjectTypes?: SelectListItem[] | undefined;
}

export interface PortalFeedback {
    userName?: string | undefined;
    description?: string | undefined;
    screenshotData?: string | undefined;
    currentUrl?: string | undefined;
    softwareVersion?: string | undefined;
    softwareReleaseDate?: string | undefined;
    softwareCommitId?: string | undefined;
    browserUserAgent?: string | undefined;
    browserPlatform?: string | undefined;
    browserLanguage?: string | undefined;
}

export interface LeaguePostRequest {
    name?: string | undefined;
    description?: string | undefined;
}

export interface ResultDataOfLeagueAddDialogView extends Result {
    data?: LeagueAddDialogView | undefined;
}

export interface LeagueAddDialogView extends BaseDialogView {
    output?: LeaguePostRequest | undefined;
}

export interface ResultDataOfLeagueSeasonAddDialogView extends Result {
    data?: LeagueSeasonAddDialogView | undefined;
}

export interface LeagueSeasonAddDialogView extends BaseDialogView {
    output?: LeagueSeason | undefined;
    teamCount?: number;
}

export interface LeagueSeason {
    leagueSeasonId?: string | undefined;
    name?: string | undefined;
    active?: boolean;
    orderIndex?: number;
    matchDates?: LeagueMatchDate[] | undefined;
    teams?: LeagueTeam[] | undefined;
}

export interface LeagueMatchDate {
    leagueMatchDateId?: string | undefined;
    name?: string | undefined;
    fromDate?: DateTime;
    bookings?: LeagueMatchDateBooking[] | undefined;
}

export interface LeagueMatchDateBooking {
    leagueMatchDateBookingId?: string | undefined;
    name?: string | undefined;
    bookingId?: string | undefined;
    leagueTeamId?: string | undefined;
    leagueTeamName?: string | undefined;
    leagueTeamOrderIndex?: number;
}

export interface LeagueTeam {
    active?: boolean;
    leagueTeamId?: string | undefined;
    orderIndex?: number;
    name?: string | undefined;
}

export interface ResultDataOfLeagueEditItemView extends Result {
    data?: LeagueEditItemView | undefined;
}

export interface LeagueEditItemView extends BaseView {
    leagueId?: string | undefined;
    leagueName?: string | undefined;
    input?: LeagueEditItem | undefined;
    output?: LeagueEditItem | undefined;
    noteDataView?: ResultDataOfNotesDataView | undefined;
    navItems?: NavItem[] | undefined;
}

export interface LeagueEditItem {
    name?: string | undefined;
    description?: string | undefined;
    active?: boolean;
    seasons?: LeagueSeason[] | undefined;
}

export interface ResultDataOfLeagueEditItemSeasonView extends Result {
    data?: LeagueEditItemSeasonView | undefined;
}

export interface LeagueEditItemSeasonView extends BaseView {
    navItems?: NavItem[] | undefined;
}

export interface LeagueTeamUpdatesRequest {
    leagueId?: string | undefined;
    leagueSeasonId?: string | undefined;
    teamUpdates?: TeamUpdate[] | undefined;
}

export interface TeamUpdate {
    leagueTeamId?: string | undefined;
    leagueTeamName?: string | undefined;
    leagueTeamOrderIndex?: number;
}

export interface BaseMatchDatesRequest {
    correlationId?: string;
    fromDates?: DateTime[] | undefined;
    programId?: string | undefined;
    bookingParty?: BookingParty | undefined;
    programName?: string | undefined;
    isCustom?: boolean;
    programSteps?: MatchDateProgramStepBookingRequest[] | undefined;
}

export interface CreateMatchDatesRequest extends BaseMatchDatesRequest {
    leagueId?: string | undefined;
    seasonId?: string | undefined;
}

export interface MatchDateProgramStepBookingRequest {
    isCustom?: boolean;
    name?: string | undefined;
    programStepId?: string | undefined;
    programStepConfigId?: string | undefined;
    fromDate?: DateTime;
    startTime?: Duration;
    bookingParty?: BookingParty | undefined;
    capacityType?: ResourceCapacityType;
    resourceSelectionMode?: ResourceSelectionMode;
    duration?: Duration;
    addedDuration?: Duration | undefined;
    resourcesAutoSelect?: boolean;
    resourceCountNeeded?: number;
    resources?: MatchDateProgramStepBookingRequestResource[] | undefined;
}

export interface MatchDateProgramStepBookingRequestResource {
    resourceId?: string | undefined;
    resourceName?: string | undefined;
    leagueTeamId?: string | undefined;
    leagueTeamName?: string | undefined;
}

export interface MatchDateBookingsTeamOrderUpdateRequest {
    leagueId?: string | undefined;
    seasonId?: string | undefined;
    bookingsTeamOrderUpdates?: BookingsTeamOrderUpdate[] | undefined;
}

export interface BookingsTeamOrderUpdate {
    leagueMatchDateId?: string | undefined;
    leagueMatchDateBookingId?: string | undefined;
    bookingId?: string | undefined;
    leagueTeamId?: string | undefined;
    leagueTeamName?: string | undefined;
    leagueTeamOrderIndex?: number;
}

export interface ResultDataOfMatchDatesRequestDialogView extends Result {
    data?: MatchDatesRequestDialogView | undefined;
}

export interface MatchDatesRequestDialogView extends BaseStepperDialogView {
    tenantId?: string | undefined;
    locationId?: string | undefined;
    leagueName?: string | undefined;
    leagueId?: string | undefined;
    seasonName?: string | undefined;
    seasonId?: string | undefined;
    locationAddress?: LocationAddress | undefined;
    programStep?: MatchDatesRequestDialogProgramStep | undefined;
    finalizeStep?: MatchDatesRequestDialogFinalizeStep | undefined;
}

export interface MatchDatesRequestDialogProgramStep extends BaseStepperView {
    panelGroup?: PanelGroup | undefined;
    selectedProgramIsDirty?: boolean;
    dateFilterActive?: boolean;
    fromDates?: DateTime[] | undefined;
    startTime?: Duration;
    startTimeOptions?: DurationOptions | undefined;
    programGroups?: NestedSelectListItemOfSelectListItem[] | undefined;
    selectedProgramGroup?: NestedSelectListItemOfSelectListItem | undefined;
    selectedProgramGroupIds?: string[] | undefined;
    selectedProgram?: SelectListItem | undefined;
    selectedProgramIds?: string[] | undefined;
    matchDateOptions?: MatchDateBookingOptions | undefined;
    selectedMatchDateOptionsIsDirty?: boolean;
    matchDatesAvailability?: MatchDatesAvailabilityView | undefined;
    matchDatesAvailabilityLocked?: boolean;
}

export interface MatchDateBookingOptionsBase {
    startTime?: Duration;
    duration?: Duration;
    programId?: string | undefined;
    programName?: string | undefined;
    programSteps?: MatchDateBookingProgramStepOptions[] | undefined;
}

export interface MatchDateBookingOptions extends MatchDateBookingOptionsBase {
    allowCustomSteps?: boolean;
    addCustomStepsEnabled?: boolean;
    bookingParty?: BookingParty | undefined;
}

export interface MatchDateBookingProgramStepOptions {
    isCustom?: boolean;
    programStepConfigId?: string | undefined;
    programStepId?: string | undefined;
    programStepName?: string | undefined;
    unitId?: string | undefined;
    unitPlural?: string | undefined;
    unitSingular?: string | undefined;
    startTime?: Duration;
    itemCountNeeded?: number;
    itemCountOptions?: number[] | undefined;
    itemCountMax?: number;
    itemCountMin?: number;
    duration?: Duration;
    durationOptions?: DurationOptions | undefined;
    addedDuration?: Duration | undefined;
    startIntervalDuration?: Duration;
    capacityType?: ResourceCapacityType;
    resourceSelectionMode?: ResourceSelectionMode;
    resources?: MatchDateBookingProgramStepResourceOption[] | undefined;
    bookingPartyMatch?: boolean;
    bookingPartyCustom?: boolean;
    bookingParty?: BookingParty | undefined;
    resourceCapacityConfig?: MatchDateBookingProgramStepResourceCapacityConfig | undefined;
}

export interface MatchDateBookingProgramStepResourceOption {
    resourceId?: string | undefined;
}

export interface MatchDateBookingProgramStepResourceCapacityConfig {
    resourceCount?: number;
    resourcePersonCapacityMin?: number | undefined;
    resourcePersonCapacityMax?: number | undefined;
    resourcePersonCapacityStartMax?: number | undefined;
    personCapacityMin?: number | undefined;
    personCapacityMax?: number | undefined;
    personCapacityStartMax?: number | undefined;
    resourceGroupCapacityMin?: number | undefined;
    resourceGroupCapacityMax?: number | undefined;
    resourceGroupCapacityStartMax?: number | undefined;
    groupCapacityMin?: number | undefined;
    groupCapacityMax?: number | undefined;
    groupCapacityStartMax?: number | undefined;
    resourceStartIntervalDuration?: Duration | undefined;
    resourceBookStartIntervalDurationTimeOnly?: boolean;
}

export interface MatchDatesAvailabilityView extends BaseView {
    matchDatesAvailable?: boolean;
    matchDateAvailabilityOptions?: MatchDateAvailabilityOption[] | undefined;
}

export interface MatchDateAvailabilityOption {
    isCustom?: boolean;
    isAvailable?: boolean;
    isStartTimeAvailable?: boolean;
    calculatedByEngine?: boolean;
    id?: string | undefined;
    programName?: string | undefined;
    programId?: string | undefined;
    fromDate?: DateTime;
    toDate?: DateTime;
    price?: BookingPriceDetails | undefined;
    score?: number;
    scoreDescription?: string | undefined;
    aggregateScore?: number;
    matchDateProgramStepAvailabilityOptions?: MatchDateProgramStepAvailabilityOption[] | undefined;
}

export interface MatchDateProgramStepAvailabilityOption {
    isCustom?: boolean;
    programStepConfigId?: string | undefined;
    programStepId?: string | undefined;
    programStepName?: string | undefined;
    unitId?: string | undefined;
    unitSingular?: string | undefined;
    unitPlural?: string | undefined;
    capacityType?: ResourceCapacityType;
    resourceSelectionMode?: ResourceSelectionMode;
    fromDate?: DateTime;
    duration?: Duration;
    selectedResourceOptionId?: string | undefined;
    resourceOptions?: MatchDateProgramStepResourceAvailabilityOption[] | undefined;
    score?: number;
    scoreDescription?: string | undefined;
}

export interface MatchDateProgramStepResourceAvailabilityOption {
    id?: string | undefined;
    title?: string | undefined;
    autoSelect?: boolean;
    resources?: MatchDateBookingProgramStepResource[] | undefined;
    score?: number;
    scoreDescription?: string | undefined;
    areaDescription?: string | undefined;
}

export interface MatchDateBookingProgramStepResource {
    resourceId?: string | undefined;
    resourceName?: string | undefined;
    leagueTeamId?: string | undefined;
    leagueTeamName?: string | undefined;
}

export interface MatchDatesRequestDialogFinalizeStep extends BaseStepperView {
}

export interface MatchDatesRequestDialogOptions {
    leagueId?: string | undefined;
    seasonId?: string | undefined;
}

export interface ResultDataOfMatchDateBookingOptions extends Result {
    data?: MatchDateBookingOptions | undefined;
}

export interface ResultDataOfMatchDatesAvailabilityView extends Result {
    data?: MatchDatesAvailabilityView | undefined;
}

export interface MatchDatesAvailabilityRequest {
    leagueId?: string | undefined;
    seasonId?: string | undefined;
    isCustom?: boolean;
    fromDates?: DateTime[] | undefined;
    startTime?: Duration;
    programName?: string | undefined;
    programId?: string | undefined;
    bookingId?: string | undefined;
    bookingParty?: BookingParty | undefined;
    programSteps?: MatchDateAvailabilityRequestProgramStep[] | undefined;
}

export interface MatchDateAvailabilityRequestProgramStep {
    isCustom?: boolean;
    programStepName?: string | undefined;
    programStepConfigId?: string | undefined;
    programStepId?: string | undefined;
    unitId?: string | undefined;
    unitSingular?: string | undefined;
    unitPlural?: string | undefined;
    bookingParty?: BookingParty | undefined;
    startTime?: Duration;
    itemCountNeeded?: number;
    minItemCountNeeded?: number;
    duration?: Duration;
    addedDuration?: Duration | undefined;
    capacityType?: ResourceCapacityType;
    resourceSelectionMode?: ResourceSelectionMode;
    resources?: MatchDateProgramStepAvailabilityRequestResource[] | undefined;
}

export interface MatchDateProgramStepAvailabilityRequestResource {
    resourceId?: string | undefined;
}

export interface LocationBookingApprovalChangeRequest {
    bookings?: LocationBookingApprovalChangeItem[] | undefined;
}

export interface LocationBookingApprovalChangeItem {
    bookingId?: string | undefined;
    approved?: boolean;
    confirmationHandling?: ProcessHandlingType;
}

export interface LocationBookingConfirmationEmailChangeItem {
    bookingId?: string | undefined;
    confirmationHandling?: ProcessHandlingType;
}

export interface ResultDataOfCreateBookingRefundProposalDialogView extends Result {
    data?: CreateBookingRefundProposalDialogView | undefined;
}

export interface CreateBookingRefundProposalDialogView extends BaseDialogView {
    allowRefund?: boolean;
    tenantId?: string | undefined;
    locationId?: string | undefined;
    bookingId?: string | undefined;
    fromDate?: DateTime;
    customerNameDetails?: BookingCustomerNameDetails | undefined;
    bookingStatus?: BookingStatus;
    bookingFinalPrice?: number;
    paymentDetails?: BookingPaymentGeneralInfo | undefined;
    allowRefundViaPaymentProvider?: boolean;
    processViaPaymentProvider?: boolean | undefined;
}

export interface BookingRefundProposalApprovalDecisionBatchRequest {
    batch?: BookingRefundProposalApprovalDecisionRequest[] | undefined;
}

export interface BookingRefundProposalApprovalDecisionRequest {
    refundId?: string | undefined;
    approved?: boolean;
}

export interface ResultDataOfBookingRefundProposalHistoryListPageView extends Result {
    data?: BookingRefundProposalHistoryListPageView | undefined;
}

export interface BookingRefundProposalHistoryListPageView extends BaseView {
}

export interface CreateBookingRefundProposalBatchRequest {
    requests?: CreateBookingRefundProposalRequest[] | undefined;
}

export interface CreateBookingRefundProposalRequest {
    bookingId?: string | undefined;
    processViaPaymentProvider?: boolean;
}

export interface LocationEditItem {
    idCode?: string | undefined;
    name?: string | undefined;
}

export interface ResultDataOfLocationEditDialogView extends Result {
    data?: LocationEditDialogView | undefined;
}

export interface LocationEditDialogView extends BaseDialogView {
    tenantId?: string | undefined;
    tenantIdCode?: string | undefined;
    locationId?: string | undefined;
    input?: LocationEditItem | undefined;
    output?: LocationEditItem | undefined;
}

export interface ResultDataOfRaxTabsPageView extends Result {
    data?: RaxTabsPageView | undefined;
}

export interface RaxTabsPageView {
    relatedObject?: RelatedObjectItem | undefined;
    showHeader?: boolean;
    pageTitle?: string | undefined;
    pageCloseNavItem?: NavItem | undefined;
    navItems?: NavItem[] | undefined;
}

export interface ResultDataOfLocationSettingsMarketingView extends Result {
    data?: LocationSettingsMarketingView | undefined;
}

export interface LocationSettingsMarketingView extends BaseView {
    navItems?: NavItem[] | undefined;
}

export interface ResultDataOfLocationSettingsMarketingEmailMarketingView extends Result {
    data?: LocationSettingsMarketingEmailMarketingView | undefined;
}

export interface LocationSettingsMarketingEmailMarketingView extends BaseView {
    input?: LocationSettingsMarketingEmailMarketingSettingsEditItem | undefined;
    output?: LocationSettingsMarketingEmailMarketingSettingsEditItem | undefined;
}

export interface LocationSettingsMarketingEmailMarketingSettingsEditItem {
    requestPermissionForEmailMarketing?: boolean;
}

export interface ResultDataOfLocationSettingsPosEditItemView extends Result {
    data?: LocationSettingsPosEditItemView | undefined;
}

export interface LocationSettingsPosEditItemView extends BaseView {
    posSettingsId?: string | undefined;
    input?: PosSettingsEditItem | undefined;
    output?: PosSettingsEditItem | undefined;
    navItems?: NavItem[] | undefined;
}

export interface PosSettingsEditItem {
    active?: boolean;
    systemConfig?: PosSystemConfig | undefined;
}

export interface PosSystemConfig {
    posSystemId?: string | undefined;
    name?: string | undefined;
    logoUrl?: string | undefined;
    version?: string | undefined;
    versionId?: string | undefined;
    configJsonData?: string | undefined;
    configIsValid?: boolean;
    referenceUnitPlural?: string | undefined;
    referenceUnitSingular?: string | undefined;
}

export interface ResultDataOfPosSystemConfigPickerDialogView extends Result {
    data?: PosSystemConfigPickerDialogView | undefined;
}

export interface PosSystemConfigPickerDialogView extends BaseDialogView {
    posSystems?: PosSystemListItem[] | undefined;
}

export interface PosSystemListItem {
    posSystemId?: string | undefined;
    posSystemName?: string | undefined;
    versionId?: string | undefined;
    versionName?: string | undefined;
    logoUrl?: string | undefined;
}

export interface ResultDataOfPosSystemConfig extends Result {
    data?: PosSystemConfig | undefined;
}

export interface PosSystemConfigValidationRequestDto {
    posSystemId?: string | undefined;
    versionId?: string | undefined;
    configJsonData?: string | undefined;
    referenceUnitPlural?: string | undefined;
    referenceUnitSingular?: string | undefined;
}

export interface LocationSettingsScheduleBoardPostRequest {
    orderIndex?: number;
    idCode?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    capacityType?: ResourceCapacityType | undefined;
    navItemColor?: string | undefined;
    navItemIcon?: string | undefined;
    dayStartTime?: Duration;
    dayDuration?: Duration;
    intervalDuration?: Duration;
}

export interface ResultDataOfLocationSettingsScheduleBoardAddDialogView extends Result {
    data?: LocationSettingsScheduleBoardAddDialogView | undefined;
}

export interface LocationSettingsScheduleBoardAddDialogView extends BaseDialogView {
    capacityTypes?: EnumOptionItem[] | undefined;
    capacityTypesCheck?: EnumOptionItem[] | undefined;
    startOfDayOptions?: DurationOptions | undefined;
    dayDurationOptions?: DurationOptions | undefined;
    intervalDurationOptions?: DurationOptions | undefined;
    output?: LocationSettingsScheduleBoardPostRequest | undefined;
}

export interface ResultDataOfLocationSettingsScheduleBoardGridViewModeOptionEditDialogView extends Result {
    data?: LocationSettingsScheduleBoardGridViewModeOptionEditDialogView | undefined;
}

export interface LocationSettingsScheduleBoardGridViewModeOptionEditDialogView extends BaseDialogView {
    output?: ScheduleBoardGridViewModeOptions | undefined;
}

export interface SurveyQuestionFormData {
    text?: string | undefined;
    label?: string | undefined;
    description?: string | undefined;
    forPublicUse?: boolean;
    forInternalUse?: boolean;
    required?: boolean;
    answerType?: string | undefined;
    answerTypeJson?: string | undefined;
    allowCustomRemarks?: boolean;
}

export interface ResultDataOfNoteAddDialogView extends Result {
    data?: NoteAddDialogView | undefined;
}

export interface NoteAddDialogView extends BaseDialogView {
    output?: NotePostRequest | undefined;
}

export interface NoteTaskAddDialogOptions {
    fromDate?: DateTime | undefined;
    relatedObjects?: RelatedObjectItem[] | undefined;
}

export interface NoteAddDialogOptions {
    fromDate?: DateTime | undefined;
    relatedObjects?: RelatedObjectItem[] | undefined;
}

export interface PlatformConfigPostRequest {
    sourcePlatformConfigId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
}

export interface ResultDataOfPlatformConfigAddDialogView extends Result {
    data?: PlatformConfigAddDialogView | undefined;
}

export interface PlatformConfigAddDialogView extends BaseDialogView {
    sourcePlatformConfigName?: string | undefined;
    output?: PlatformConfigPostRequest | undefined;
}

export interface ResultDataOfPlatformConfigEditItemView extends Result {
    data?: PlatformConfigEditItemView | undefined;
}

export interface PlatformConfigEditItemView extends BaseView {
    platformConfigId?: string | undefined;
    active?: boolean;
    input?: PlatformConfigEditItem | undefined;
    output?: PlatformConfigEditItem | undefined;
    navItems?: NavItem[] | undefined;
}

export interface PlatformConfigEditItem {
    name?: string | undefined;
    securityConfig?: PlatformSecurityConfig | undefined;
    plannerConfig?: PlatformPlannerConfig | undefined;
    featureFlagConfig?: PlatformFeatureFlagConfig | undefined;
}

export interface PlatformSecurityConfig {
    topics?: PlatformSecurityTopic[] | undefined;
    roles?: PlatformSecurityRole[] | undefined;
    groups?: PlatformSecurityGroup[] | undefined;
}

export interface PlatformSecurityTopic {
    topicId?: string | undefined;
    active?: boolean;
    name?: string | undefined;
    orderIndex?: number;
    key?: string | undefined;
    domainType?: DomainType;
    actions?: PlatformSecurityAction[] | undefined;
}

export interface PlatformSecurityAction {
    actionId?: string | undefined;
    active?: boolean;
    name?: string | undefined;
    key?: string | undefined;
    value?: string | undefined;
    orderIndex?: number;
}

export interface PlatformSecurityRole {
    domainType?: DomainType;
    active?: boolean;
    roleId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    orderIndex?: number;
    navPermissions?: SecurityPermission[] | undefined;
    actionPermissions?: SecurityPermission[] | undefined;
}

export interface SecurityPermission {
    permissionId?: string | undefined;
    name?: string | undefined;
    key?: string | undefined;
    value?: string | undefined;
    status?: SecurityPermissionStatus;
}

export enum SecurityPermissionStatus {
    NotSet = "NotSet",
    Allow = "Allow",
    Deny = "Deny",
}

export interface PlatformSecurityGroup {
    active?: boolean;
    name?: string | undefined;
    description?: string | undefined;
    securityGroupId?: string | undefined;
    idCode?: string | undefined;
    domainType?: DomainType;
    roles?: PlatformSecurityGroupRole[] | undefined;
}

export interface PlatformSecurityGroupRole {
    active?: boolean;
    domainType?: DomainType;
    roleId?: string | undefined;
    name?: string | undefined;
}

export interface PlatformPlannerConfig {
    navConfig?: PlannerNavConfig | undefined;
}

export interface PlannerNavConfig {
    menus?: PlannerMenu[] | undefined;
}

export interface PlannerMenu {
    menuId?: string | undefined;
    name?: string | undefined;
    domainType?: DomainType;
    isSettingsMenu?: boolean;
    menuItems?: MainPlannerNavMenuItem[] | undefined;
}

export interface PlannerNavMenuItem {
    menuItemId?: string | undefined;
    forDesktop?: boolean;
    forMobile?: boolean;
    active?: boolean;
    relatedObjectType?: string | undefined;
    name?: string | undefined;
    orderIndex?: number;
    iconColor?: string | undefined;
    icon?: string | undefined;
    iconImg?: string | undefined;
    routeDefinition?: PlannerNavRouteDefinition | undefined;
}

export interface MainPlannerNavMenuItem extends PlannerNavMenuItem {
    subMenuItems?: SubPlannerNavMenuItem[] | undefined;
}

export interface SubPlannerNavMenuItem extends PlannerNavMenuItem {
}

export interface PlannerNavRouteDefinition {
    path?: string | undefined;
    routeId?: string | undefined;
    params?: PlannerNavRouteDefinitionParam[] | undefined;
}

export interface PlannerNavRouteDefinitionParam {
    key?: string | undefined;
    value?: string | undefined;
}

export interface PlatformFeatureFlagConfig {
    topics?: PlatformFeatureFlagTopic[] | undefined;
}

export interface PlatformFeatureFlagTopic {
    featureFlagTopicId?: string | undefined;
    domainType?: DomainType;
    orderIndex?: number;
    active?: boolean;
    name?: string | undefined;
    key?: string | undefined;
    featureFlags?: PlatformFeatureFlag[] | undefined;
}

export interface PlatformFeatureFlag {
    featureFlagId?: string | undefined;
    active?: boolean;
    name?: string | undefined;
    key?: string | undefined;
    orderIndex?: number;
    isPreview?: boolean;
    isDev?: boolean;
    availableForCmsSiteWebClient?: boolean;
}

export interface ResultDataOfPlatformConfigEditItemPlannerView extends Result {
    data?: PlatformConfigEditItemPlannerView | undefined;
}

export interface PlatformConfigEditItemPlannerView extends BaseView {
    navItems?: NavItem[] | undefined;
}

export interface ResultDataOfPlatformPlannerMenuItemEditDialogView extends Result {
    data?: PlatformPlannerMenuItemEditDialogView | undefined;
}

export interface PlatformPlannerMenuItemEditDialogView extends BaseDialogView {
    isMainMenuItem?: boolean;
    output?: MainPlannerNavMenuItem | undefined;
    relatedObjectTypes?: string[] | undefined;
    paramOptions?: string[] | undefined;
}

export interface ResultDataOfPlatformConfigEditItemFeatureFlagView extends Result {
    data?: PlatformConfigEditItemFeatureFlagView | undefined;
}

export interface PlatformConfigEditItemFeatureFlagView extends BaseView {
    navItems?: NavItem[] | undefined;
}

export interface ResultDataOfPlatformConfigEditItemSecurityView extends Result {
    data?: PlatformConfigEditItemSecurityView | undefined;
}

export interface PlatformConfigEditItemSecurityView extends BaseView {
    navItems?: NavItem[] | undefined;
}

export interface ResultDataOfPlatformSecurityTopicEditDialogView extends Result {
    data?: PlatformSecurityTopicEditDialogView | undefined;
}

export interface PlatformSecurityTopicEditDialogView extends BaseDialogView {
    output?: PlatformSecurityTopic | undefined;
}

export interface ResultDataOfPlatformSecurityActionEditDialogView extends Result {
    data?: PlatformSecurityActionEditDialogView | undefined;
}

export interface PlatformSecurityActionEditDialogView extends BaseDialogView {
    output?: PlatformSecurityAction | undefined;
}

export interface ResultDataOfPlatformSecurityRoleEditDialogView extends Result {
    data?: PlatformSecurityRoleEditDialogView | undefined;
}

export interface PlatformSecurityRoleEditDialogView extends BaseDialogView {
    output?: PlatformSecurityRole | undefined;
}

export interface ResultDataOfPlatformSecurityGroupEditDialogView extends Result {
    data?: PlatformSecurityGroupEditDialogView | undefined;
}

export interface PlatformSecurityGroupEditDialogView extends BaseDialogView {
    output?: PlatformSecurityGroup | undefined;
}

export interface ResultDataOfLocationInfo extends Result {
    data?: LocationInfo | undefined;
}

export interface TenantInfo {
    tenantId?: string | undefined;
    tenantName?: string | undefined;
    tenantIdCode?: string | undefined;
}

export interface LocationInfo extends TenantInfo {
    locationId?: string | undefined;
    locationName?: string | undefined;
    locationIdCode?: string | undefined;
}

export interface ResultDataOfTenantInfo extends Result {
    data?: TenantInfo | undefined;
}

export interface ProductPostRequest {
    forPublicUse?: boolean;
    forInternalUse?: boolean;
    unitId?: string | undefined;
    orderIndex?: number;
    name?: string | undefined;
    description?: string | undefined;
    price?: number;
    listPrice?: number;
    posArticle?: RelatedObjectPosArticle | undefined;
    pricingType?: ProductPricingType;
    isProgramStep?: boolean;
    useProgramStepPricing?: boolean;
    programStepId?: string | undefined;
    programStepConfig?: ProgramStepConfig | undefined;
    bookingParty?: BookingParty | undefined;
    relatedObjects?: RelatedObjectItem[] | undefined;
    days?: DayOfWeekFilter[] | undefined;
    leadTimeDuration?: Duration;
}

export interface RelatedObjectPosArticle {
    name?: string | undefined;
    raxArticleId?: string | undefined;
    posArticleId?: string | undefined;
    priceInclVat?: number;
    vatPercentage?: number;
    itemJsonData?: string | undefined;
}

export interface ProgramStepConfig {
    programStepConfigId?: string | undefined;
    name?: string | undefined;
    programStepId?: string | undefined;
    orderIndex?: number;
    capacityType?: ResourceCapacityType;
    resourceSelectionMode?: ResourceSelectionMode;
    intervalDuration?: Duration;
    minDuration?: Duration;
    maxDuration?: Duration;
    duration?: Duration;
    startTimeIntervalDuration?: Duration;
    programStepCheckOutOptions?: ProgramStepCheckOutOptions | undefined;
    visible?: boolean;
    locked?: boolean;
    optional?: boolean;
    dynamicDuration?: boolean;
}

export interface ProgramStepCheckOutOptions {
    durationOptions?: DurationOption[] | undefined;
    allowResourceSelect?: boolean;
}

export interface DurationOption {
    orderIndex?: number;
    isDefault?: boolean;
    duration?: Duration;
    weekDays?: DayOfWeekFilter[] | undefined;
}

export interface ProgramPostRequest {
    name?: string | undefined;
    description?: string | undefined;
    orderIndex?: number;
    active?: boolean;
    allowCustomSteps?: boolean;
    bgColor?: string | undefined;
    color?: string | undefined;
    bookingParty?: BookingParty | undefined;
    leadTimeDuration?: Duration;
}

export interface ResultDataOfProgramAddDialogView extends Result {
    data?: ProgramAddDialogView | undefined;
}

export interface ProgramAddDialogView extends BaseDialogView {
    output?: ProgramPostRequest | undefined;
    previewGridBgColor?: string | undefined;
    previewGridColor?: string | undefined;
    previewGridEmptySpaceColor?: string | undefined;
    ageGroups?: BookingPartyAgeGroup[] | undefined;
    leadTimeDurationOptions?: DurationOptions | undefined;
}

export interface ResultDataOfProgramEditItemView extends Result {
    data?: ProgramEditItemView | undefined;
}

export interface ProgramEditItemView extends BaseView {
    programId?: string | undefined;
    programName?: string | undefined;
    output?: ProgramEditItem | undefined;
    input?: ProgramEditItem | undefined;
    ageGroups?: BookingPartyAgeGroup[] | undefined;
    depositAmountPerPersonAgeGroupPriceLevels?: DepositAmountPerPersonAgeGroupPriceLevel[] | undefined;
    leadTimeDurationOptions?: DurationOptions | undefined;
    previewGridBgColor?: string | undefined;
    previewGridColor?: string | undefined;
    previewGridEmptySpaceColor?: string | undefined;
}

export interface ProgramEditItem {
    active?: boolean;
    forPublicUse?: boolean;
    allowCustomSteps?: boolean;
    isFavorite?: boolean;
    name?: string | undefined;
    description?: string | undefined;
    bookingParty?: BookingParty | undefined;
    fromDate?: DateTime | undefined;
    toDate?: DateTime | undefined;
    leadTimeDuration?: Duration;
    bgColor?: string | undefined;
    color?: string | undefined;
    onlineBookingPriceZeroAllowed?: boolean;
    programDuration?: Duration;
    programSteps?: ProgramStepConfig[] | undefined;
    emailContentPart?: MainEmailContentPart | undefined;
    depositPolicyConfig?: ProgramDepositPolicyConfig | undefined;
}

export interface EmailContentPart {
    additionalHtmlContentTemplate?: string | undefined;
    attachmentFile?: string | undefined;
}

export interface MainEmailContentPart extends EmailContentPart {
    mainHtmlContentTemplate?: string | undefined;
}

export interface ProgramDepositPolicyConfig {
    planner?: ProgramChannelDepositPolicy | undefined;
    cmsSite?: ProgramChannelDepositPolicy | undefined;
}

export interface ProgramChannelDepositPolicy {
    kind?: ProgramDepositPolicyKindDto;
    perAgeGroupPerPersonSettings?: ProgramChannelDepositPolicyPerAgeGroupPerPersonSettings | undefined;
    fixedAmountPerUnitSettings?: ProgramChannelDepositPolicyFixedAmountPerUnitSettings | undefined;
    percentageOfTotalSettings?: ProgramChannelDepositPolicyPercentageOfTotalSettings | undefined;
}

export interface ProgramChannelDepositPolicyPerAgeGroupPerPersonSettings {
    depositPerAgeGroupPerPersonSettingsPriceLevelId?: string | undefined;
}

export interface ProgramChannelDepositPolicyFixedAmountPerUnitSettings {
    amount?: number;
}

export interface ProgramChannelDepositPolicyPercentageOfTotalSettings {
    percentage?: number;
    maximumAmount?: number;
}

export interface DepositAmountPerPersonAgeGroupPriceLevel {
    priceLevelId?: string | undefined;
    priceLevelName?: string | undefined;
}

export interface ResultDataOfProgramEditItemProgramStepsView extends Result {
    data?: ProgramEditItemProgramStepsView | undefined;
}

export interface ProgramEditItemProgramStepsView extends BaseView {
    programId?: string | undefined;
    kanbanBoard?: KanbanBoardOfProgramStepKanbanItem | undefined;
}

export interface KanbanBoardOfProgramStepKanbanItem {
    id?: string | undefined;
    title?: string | undefined;
    columns?: KanbanColumnOfProgramStepKanbanItem[] | undefined;
}

export interface KanbanColumnOfProgramStepKanbanItem {
    title?: string | undefined;
    orderIndex?: number;
    id?: string | undefined;
    state?: string | undefined;
    items?: ProgramStepKanbanItem[] | undefined;
}

export interface KanbanItem {
    active?: boolean;
    orderIndex?: number;
    filterOut?: boolean;
    id?: string | undefined;
    title?: string | undefined;
    state?: string | undefined;
}

export interface ProgramStepKanbanItem extends KanbanItem {
    data?: ProgramStepKanbanItemData | undefined;
}

export interface ProgramStepKanbanItemData {
    programStepId?: string | undefined;
    startTimeIntervalDuration?: Duration;
    duration?: Duration;
    minDuration?: Duration;
    maxDuration?: Duration;
    durationOptions?: DurationOptions | undefined;
    programStepCheckOutOptions?: ProgramStepCheckOutOptions | undefined;
    visible?: boolean;
    locked?: boolean;
    optional?: boolean;
    dynamicDuration?: boolean;
    capacityType?: ResourceCapacityType;
    resourceSelectionMode?: ResourceSelectionMode;
}

export interface ProgramGroupPostRequest {
    name?: string | undefined;
    description?: string | undefined;
    orderIndex?: number;
    active?: boolean;
    forPublicUse?: boolean;
    forInternalUse?: boolean;
}

export interface ProgramStepPostRequest {
    allowCustom?: boolean;
    orderIndex?: number;
    name?: string | undefined;
    unitId?: string | undefined;
    description?: string | undefined;
    capacityType?: ResourceCapacityType;
    resourceSelectionMode?: ResourceSelectionMode;
    startTimeIntervalDuration?: Duration;
    intervalDuration?: Duration;
    minDuration?: Duration;
    maxDuration?: Duration;
    defaultDuration?: Duration;
    bookingParty?: BookingParty | undefined;
}

export interface ResultDataOfProgramStepAddDialogView extends Result {
    data?: ProgramStepAddDialogView | undefined;
}

export interface ProgramStepAddDialogView extends BaseDialogView {
    output?: ProgramStepPostRequest | undefined;
    intervalDurationOptions?: DurationOptions | undefined;
    maxDuration?: Duration;
    ageGroups?: BookingPartyAgeGroup[] | undefined;
    units?: SelectListItem[] | undefined;
}

export interface ResultDataOfProgramStepEditItemView extends Result {
    data?: ProgramStepEditItemView | undefined;
}

export interface ProgramStepEditItemView extends BaseView {
    programStepId?: string | undefined;
    programStepName?: string | undefined;
    capacityType?: ResourceCapacityType;
    capacityTypeLabel?: string | undefined;
    input?: ProgramStepEditItem | undefined;
    output?: ProgramStepEditItem | undefined;
    startIntervalDurationOptions?: DurationOptions | undefined;
    intervalDurationOptions?: DurationOptions | undefined;
    maxDuration?: Duration;
    ageGroups?: BookingPartyAgeGroup[] | undefined;
    units?: SelectListItem[] | undefined;
    depositAmountPerPersonAgeGroupPriceLevels?: DepositAmountPerPersonAgeGroupPriceLevel[] | undefined;
    navItems?: NavItem[] | undefined;
}

export interface ProgramStepEditItem {
    allowCustom?: boolean;
    isFavorite?: boolean;
    isMeal?: boolean;
    name?: string | undefined;
    description?: string | undefined;
    unitId?: string | undefined;
    bookingParty?: BookingParty | undefined;
    resourceSelectionMode?: ResourceSelectionMode;
    startTimeIntervalDuration?: Duration;
    intervalDuration?: Duration;
    minDuration?: Duration;
    maxDuration?: Duration;
    defaultDuration?: Duration;
    resources?: ProgramStepResource[] | undefined;
    surveyQuestions?: ProgramStepSurveyQuestion[] | undefined;
    emailContentPart?: EmailContentPart | undefined;
    depositPolicyConfig?: ProgramStepDepositPolicyConfig | undefined;
}

export interface ProgramStepResource {
    name?: string | undefined;
    resourceId?: string | undefined;
}

export interface ProgramStepSurveyQuestion {
    surveyQuestionId?: string | undefined;
}

export interface ProgramStepDepositPolicyConfig {
    planner?: ProgramStepChannelDepositPolicy | undefined;
    cmsSite?: ProgramStepChannelDepositPolicy | undefined;
}

export interface ProgramStepChannelDepositPolicy {
    kind?: ActivityDepositPolicyKindDto;
    perAgeGroupPerPersonSettings?: ProgramStepChannelDepositPolicyPerAgeGroupPerPersonSettings | undefined;
    fixedAmountPerUnitSettings?: ProgramStepChannelDepositPolicyFixedAmountPerUnitSettings | undefined;
    percentageOfTotalSettings?: ProgramStepChannelDepositPolicyPercentageOfTotalSettings | undefined;
}

export enum ActivityDepositPolicyKindDto {
    NoDepositRequired = "NoDepositRequired",
    FullGrossAmount = "FullGrossAmount",
    PerAgeGroupPerPerson = "PerAgeGroupPerPerson",
    FixedAmountPerUnit = "FixedAmountPerUnit",
    PercentageOfTotal = "PercentageOfTotal",
}

export interface ProgramStepChannelDepositPolicyPerAgeGroupPerPersonSettings {
    depositPerAgeGroupPerPersonSettingsPriceLevelId?: string | undefined;
}

export interface ProgramStepChannelDepositPolicyFixedAmountPerUnitSettings {
    amount?: number;
}

export interface ProgramStepChannelDepositPolicyPercentageOfTotalSettings {
    percentage?: number;
    maximumAmount?: number;
}

export interface ResultDataOfProgramStepEditItemSurveyView extends Result {
    data?: ProgramStepEditItemSurveyView | undefined;
}

export interface ProgramStepEditItemSurveyView extends BaseView {
    programStepId?: string | undefined;
    surveyQuestions?: SurveyQuestionSelectListItem[] | undefined;
}

export interface SurveyQuestionSelectListItem extends SelectListItem {
    forPublicUse?: boolean;
    forInternalUse?: boolean;
}

export interface ResultDataOfProgramStepEditItemResourceView extends Result {
    data?: ProgramStepEditItemResourceView | undefined;
}

export interface ProgramStepEditItemResourceView extends BaseView {
    programStepId?: string | undefined;
    programStepName?: string | undefined;
    treeNodes?: AreaTreeNode[] | undefined;
}

export interface TreeNestedNodeOfAreaSectionTreeNode extends TreeNode {
    children?: AreaSectionTreeNode[] | undefined;
}

export interface AreaTreeNode extends TreeNestedNodeOfAreaSectionTreeNode {
    data?: AreaFormData | undefined;
}

export interface AreaFormData {
    areaId?: string | undefined;
    orderIndex?: number;
    name?: string | undefined;
    bgColor?: string | undefined;
    color?: string | undefined;
    emptyCellBgColor?: string | undefined;
    sections?: AreaSectionFormData[] | undefined;
}

export interface AreaSectionFormData {
    areaSectionId?: string | undefined;
    name?: string | undefined;
    orderIndex?: number;
    resources?: ResourceFormData[] | undefined;
}

export interface ResourceFormData {
    resourceId?: string | undefined;
    orderIndex?: number;
    name?: string | undefined;
    nameShort?: string | undefined;
    resourceTypeId?: string | undefined;
    resourceTypeName?: string | undefined;
    capacityType?: ResourceCapacityType | undefined;
    personCapacityMin?: number | undefined;
    personCapacityMax?: number | undefined;
    personCapacityStartMax?: number | undefined;
    groupCapacityMin?: number | undefined;
    groupCapacityMax?: number | undefined;
    groupCapacityStartMax?: number | undefined;
    startIntervalDuration?: Duration | undefined;
    bookStartIntervalDurationTimeOnly?: boolean;
}

export interface TreeNestedNodeOfResourceTreeNode extends TreeNode {
    children?: ResourceTreeNode[] | undefined;
}

export interface AreaSectionTreeNode extends TreeNestedNodeOfResourceTreeNode {
    data?: AreaSectionFormData | undefined;
}

export interface TreeNestedNodeOfTreeNode extends TreeNode {
    children?: TreeNode[] | undefined;
}

export interface ResourceTreeNode extends TreeNestedNodeOfTreeNode {
    data?: ResourceFormData | undefined;
}

export interface RateCardEditDialogItem {
    name?: string | undefined;
    priceRuleDefinitions?: RateCardPriceRuleDefinition[] | undefined;
}

export interface RateCardPriceRuleDefinition {
    priceRuleDefinitionId?: string | undefined;
    title?: string | undefined;
    programName?: string | undefined;
    programStepName?: string | undefined;
    programStepConfigId?: string | undefined;
    programStepId?: string | undefined;
    rateCardPricingTypeLabel?: string | undefined;
    rateCardPricingType?: RateCardPricingType;
    applyPricePerDuration?: boolean;
    applyPricePerDurationInterval?: boolean;
    priceIntervalDuration?: Duration | undefined;
    ageGroupId?: string | undefined;
    fromAge?: number;
    toAge?: number;
    ageGroupName?: string | undefined;
    priceLineDescription?: string | undefined;
    priceLineUnitName?: string | undefined;
    applyPricePerPersonCount?: boolean;
    minTotalPersonCount?: number;
    maxTotalPersonCount?: number;
    posArticle?: RelatedObjectPosArticle | undefined;
    surchargePriceRuleDefinitions?: RateCardSurchargePriceRuleDefinition[] | undefined;
}

export interface RateCardSurchargePriceRuleDefinition {
    isRebate?: boolean;
    priceRuleDefinitionId?: string | undefined;
    title?: string | undefined;
    programName?: string | undefined;
    programStepName?: string | undefined;
    programStepConfigId?: string | undefined;
    programStepId?: string | undefined;
    rateCardPricingTypeLabel?: string | undefined;
    rateCardPricingType?: RateCardPricingType;
    applyPricePerDuration?: boolean;
    applyPricePerDurationInterval?: boolean;
    priceIntervalDuration?: Duration | undefined;
    ageGroupId?: string | undefined;
    fromAge?: number;
    toAge?: number;
    ageGroupName?: string | undefined;
    priceLineDescription?: string | undefined;
    priceLineUnitName?: string | undefined;
    applyPricePerPersonCount?: boolean;
    minTotalPersonCount?: number;
    maxTotalPersonCount?: number;
    applyToAdditional?: boolean;
    applyBookingParty?: boolean;
    bookingParty?: BookingParty | undefined;
    posArticle?: RelatedObjectPosArticle | undefined;
}

export interface TenantEditItem {
    name?: string | undefined;
    idCode?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}

}